import {
  InfiniteData,
  UseInfiniteQueryOptions,
  UseMutationOptions,
  UseQueryOptions,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseQueryOptions,
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery,
} from "@tanstack/react-query"

import { adminFetcher } from "./fetcher"

export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** Date (isoformat) */
  Date: { input: string; output: string }
  /** Date with time and offset (isoformat) */
  DateTime: { input: string; output: string }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: any; output: any }
  Upload: { input: any; output: any }
  /** Represents NULL values */
  Void: { input: any; output: any }
}

export type AiModel = {
  __typename?: "AIModel"
  name: Scalars["String"]["output"]
  provider: AiProvider
  tokenLimit: Scalars["Int"]["output"]
}

export enum AiProvider {
  Anthropic = "ANTHROPIC",
  Openai = "OPENAI",
}

export type AddRate = {
  __typename?: "AddRate"
  op: OpType
  rate: CustomRate
}

export type AddRateInput = {
  chargeClass: ChargeClass
  chargePeriod: ChargePeriod
  chargeType: ChargeType
  name?: InputMaybe<Scalars["String"]["input"]>
  price: Scalars["Float"]["input"]
  rateUnit: RateUnit
  transactionType?: InputMaybe<TransactionType>
}

export type AddRateSubRateOverrideProperty = AddRate | OverrideProperty | SubRate

export type AddScenarioResponse = Error | ScenarioRef

export type AdminBidsTable = {
  __typename?: "AdminBidsTable"
  rows: Array<AdminBidsTableRow>
  view: AdminBidsTableView
}

export type AdminBidsTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type AdminBidsTableViewArgs = {
  filterBy?: InputMaybe<AdminBidsTableFilter>
  sortBy?: InputMaybe<Array<AdminBidsTableSort>>
}

export enum AdminBidsTableAttr {
  AssetManager = "ASSET_MANAGER",
  BiddingClosedAt = "BIDDING_CLOSED_AT",
  BiddingOpenAt = "BIDDING_OPEN_AT",
  BidPackageName = "BID_PACKAGE_NAME",
  BidPackagePid = "BID_PACKAGE_PID",
  BuildingOwnerExtraPaymentsUsd = "BUILDING_OWNER_EXTRA_PAYMENTS_USD",
  BuildingOwnerName = "BUILDING_OWNER_NAME",
  BuildingOwnerNoiLifetimeUsd = "BUILDING_OWNER_NOI_LIFETIME_USD",
  BuildingOwnerPid = "BUILDING_OWNER_PID",
  BundlePid = "BUNDLE_PID",
  City = "CITY",
  CreatedAt = "CREATED_AT",
  CsEstimatedAwardDate = "CS_ESTIMATED_AWARD_DATE",
  EstimatedCod = "ESTIMATED_COD",
  EstimatedNtp = "ESTIMATED_NTP",
  ExtraPaymentsNotes = "EXTRA_PAYMENTS_NOTES",
  FinancierName = "FINANCIER_NAME",
  FinancierPid = "FINANCIER_PID",
  FinproductType = "FINPRODUCT_TYPE",
  IncentivesNotes = "INCENTIVES_NOTES",
  InterconnectionCostNonUtilityUsd = "INTERCONNECTION_COST_NON_UTILITY_USD",
  InterconnectionCostUsdPerWatt = "INTERCONNECTION_COST_USD_PER_WATT",
  InterconnectionCostUtilityMaxUsd = "INTERCONNECTION_COST_UTILITY_MAX_USD",
  InterconnectionCostUtilityMinUsd = "INTERCONNECTION_COST_UTILITY_MIN_USD",
  InterconnectionNotes = "INTERCONNECTION_NOTES",
  IsAwarded = "IS_AWARDED",
  IsCustom = "IS_CUSTOM",
  ItcPercentageAssumption = "ITC_PERCENTAGE_ASSUMPTION",
  Name = "NAME",
  OtherNotes = "OTHER_NOTES",
  PackageRowClosedAt = "PACKAGE_ROW_CLOSED_AT",
  PackageRowCloseCustomReason = "PACKAGE_ROW_CLOSE_CUSTOM_REASON",
  PackageRowCloseReason = "PACKAGE_ROW_CLOSE_REASON",
  PackageRowIsClosed = "PACKAGE_ROW_IS_CLOSED",
  PackageRowStatus = "PACKAGE_ROW_STATUS",
  PvSizeKwAc = "PV_SIZE_KW_AC",
  PvSizeKwDc = "PV_SIZE_KW_DC",
  PvTypes = "PV_TYPES",
  RecOwner = "REC_OWNER",
  RoofRentEscalator = "ROOF_RENT_ESCALATOR",
  RoofRentY1Usd = "ROOF_RENT_Y1_USD",
  SiteName = "SITE_NAME",
  SitePid = "SITE_PID",
  State = "STATE",
  StreetAddress = "STREET_ADDRESS",
  TermYears = "TERM_YEARS",
  UtilityId = "UTILITY_ID",
  UtilityName = "UTILITY_NAME",
  UtilityShortName = "UTILITY_SHORT_NAME",
  ZipCode = "ZIP_CODE",
}

export type AdminBidsTableFilter = {
  bidPackageName?: InputMaybe<StringPred>
  bidPackagePid?: InputMaybe<StringPred>
  biddingClosedAt?: InputMaybe<DatePred>
  biddingOpenAt?: InputMaybe<DatePred>
  buildingOwnerName?: InputMaybe<StringPred>
  buildingOwnerNoiLifetimeUsd?: InputMaybe<FloatPred>
  bundlePid?: InputMaybe<StringPred>
  city?: InputMaybe<StringPred>
  createdAt?: InputMaybe<DatePred>
  csEstimatedAwardDate?: InputMaybe<DatePred>
  estimatedCod?: InputMaybe<DatePred>
  estimatedNtp?: InputMaybe<DatePred>
  financierName?: InputMaybe<StringPred>
  financierPid?: InputMaybe<StringPred>
  finproductType?: InputMaybe<FinProductTypePred>
  id?: InputMaybe<StringPred>
  interconnectionCostNonUtilityUsd?: InputMaybe<FloatPred>
  interconnectionCostUsdPerWatt?: InputMaybe<FloatPred>
  interconnectionCostUtilityMaxUsd?: InputMaybe<FloatPred>
  interconnectionCostUtilityMinUsd?: InputMaybe<FloatPred>
  isAwarded?: InputMaybe<BoolPred>
  isCustom?: InputMaybe<BoolPred>
  itcPercentageAssumption?: InputMaybe<FloatPred>
  name?: InputMaybe<StringPred>
  packageRowClosedAt?: InputMaybe<DatePred>
  packageRowIsClosed?: InputMaybe<BoolPred>
  packageRowStatus?: InputMaybe<PackageRowStatusPred>
  pvSizeKwAc?: InputMaybe<FloatPred>
  pvSizeKwDc?: InputMaybe<FloatPred>
  roofRentEscalator?: InputMaybe<FloatPred>
  roofRentY1Usd?: InputMaybe<FloatPred>
  sitePid?: InputMaybe<StringPred>
  state?: InputMaybe<UsStateMultiPred>
  termYears?: InputMaybe<FloatPred>
  utilityName?: InputMaybe<StringPred>
  utilityShortName?: InputMaybe<StringPred>
}

export type AdminBidsTableRow = {
  __typename?: "AdminBidsTableRow"
  assetManager?: Maybe<Scalars["String"]["output"]>
  bidPackageName: Scalars["String"]["output"]
  bidPackagePid: Scalars["String"]["output"]
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  buildingOwnerExtraPaymentsUsd?: Maybe<Array<Scalars["Float"]["output"]>>
  buildingOwnerName: Scalars["String"]["output"]
  buildingOwnerNoiLifetimeUsd?: Maybe<Scalars["Float"]["output"]>
  buildingOwnerPid: Scalars["String"]["output"]
  bundlePid: Scalars["String"]["output"]
  city: Scalars["String"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  csEstimatedAwardDate?: Maybe<Scalars["DateTime"]["output"]>
  estimatedCod: Scalars["Date"]["output"]
  estimatedNtp: Scalars["Date"]["output"]
  extraPaymentsNotes?: Maybe<Scalars["String"]["output"]>
  financierName: Scalars["String"]["output"]
  financierPid: Scalars["String"]["output"]
  finproductType: FinProductType
  id: Scalars["Int"]["output"]
  incentivesNotes?: Maybe<Scalars["String"]["output"]>
  interconnectionCostNonUtilityUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMaxUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMinUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionNotes?: Maybe<Scalars["String"]["output"]>
  isAwarded: Scalars["Boolean"]["output"]
  isCustom: Scalars["Boolean"]["output"]
  itcPercentageAssumption: Scalars["Float"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  otherNotes?: Maybe<Scalars["String"]["output"]>
  packageRowCloseCustomReason?: Maybe<Scalars["String"]["output"]>
  packageRowCloseReason?: Maybe<PackageRowCloseReason>
  packageRowClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  packageRowIsClosed: Scalars["Boolean"]["output"]
  packageRowStatus?: Maybe<PackageRowStatus>
  pvSizeKwAc?: Maybe<Scalars["Float"]["output"]>
  pvSizeKwDc?: Maybe<Scalars["Float"]["output"]>
  pvTypes: Array<PvType>
  recOwner: RecOwner
  roofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  roofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  siteName?: Maybe<Scalars["String"]["output"]>
  sitePid: Scalars["String"]["output"]
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  termYears?: Maybe<Scalars["Int"]["output"]>
  utilityId?: Maybe<Scalars["Int"]["output"]>
  utilityName?: Maybe<Scalars["String"]["output"]>
  utilityShortName?: Maybe<Scalars["String"]["output"]>
  zipCode: Scalars["String"]["output"]
}

export type AdminBidsTableSort = {
  attr: AdminBidsTableAttr
  order: SortOrder
}

export type AdminBidsTableStats = {
  __typename?: "AdminBidsTableStats"
  buildingOwnerNames: Array<Scalars["String"]["output"]>
  financierNames: Array<Scalars["String"]["output"]>
}

export type AdminBidsTableView = {
  __typename?: "AdminBidsTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
  stats: AdminBidsTableStats
}

export type AdminBundleTable = {
  __typename?: "AdminBundleTable"
  rows: Array<AdminBundleTableRow>
  view: AdminBundleTableView
}

export type AdminBundleTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type AdminBundleTableViewArgs = {
  filterBy?: InputMaybe<AdminBundleTableFilter>
  sortBy?: InputMaybe<Array<AdminBundleTableSort>>
}

export enum AdminBundleTableAttr {
  BiddingClosedAt = "BIDDING_CLOSED_AT",
  BiddingOpenAt = "BIDDING_OPEN_AT",
  BidReviewMeetingDate = "BID_REVIEW_MEETING_DATE",
  BundleName = "BUNDLE_NAME",
  CodDate = "COD_DATE",
  ContractSignedDate = "CONTRACT_SIGNED_DATE",
  CreatedAt = "CREATED_AT",
  CustomReason = "CUSTOM_REASON",
  FinancierName = "FINANCIER_NAME",
  FinancierPid = "FINANCIER_PID",
  FinproductType = "FINPRODUCT_TYPE",
  LeDevFee = "LE_DEV_FEE",
  NtpDate = "NTP_DATE",
  PortfolioName = "PORTFOLIO_NAME",
  PortfolioPid = "PORTFOLIO_PID",
  PreBidMeetingDate = "PRE_BID_MEETING_DATE",
  PvKw = "PV_KW",
  Reason = "REASON",
  ReceiverName = "RECEIVER_NAME",
  ReceiverPid = "RECEIVER_PID",
  SiteName = "SITE_NAME",
  SitePid = "SITE_PID",
  State = "STATE",
}

export type AdminBundleTableFilter = {
  bundleName?: InputMaybe<StringPred>
  customReason?: InputMaybe<StringPred>
  financierName?: InputMaybe<StringPred>
  finproductType?: InputMaybe<FinProductTypePred>
  id?: InputMaybe<IntPred>
  leDevFee?: InputMaybe<FloatPred>
  portfolioName?: InputMaybe<StringPred>
  pvKw?: InputMaybe<FloatPred>
  reason?: InputMaybe<CloseReasonPred>
  receiverName?: InputMaybe<StringPred>
  state?: InputMaybe<BundleStatePred>
}

export type AdminBundleTableRow = {
  __typename?: "AdminBundleTableRow"
  bidReviewMeetingDate?: Maybe<Scalars["Date"]["output"]>
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  bundleName: Scalars["String"]["output"]
  codDate?: Maybe<Scalars["Date"]["output"]>
  contractSignedDate?: Maybe<Scalars["Date"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  customReason?: Maybe<Scalars["String"]["output"]>
  financierName: Scalars["String"]["output"]
  financierPid: Scalars["String"]["output"]
  finproductType: FinProductType
  id: Scalars["Int"]["output"]
  leDevFee?: Maybe<Scalars["Float"]["output"]>
  ntpDate?: Maybe<Scalars["Date"]["output"]>
  portfolioName: Scalars["String"]["output"]
  portfolioPid: Scalars["String"]["output"]
  preBidMeetingDate?: Maybe<Scalars["Date"]["output"]>
  pvKw?: Maybe<Scalars["Float"]["output"]>
  reason?: Maybe<CloseReason>
  receiverName: Scalars["String"]["output"]
  receiverPid: Scalars["String"]["output"]
  siteName?: Maybe<Scalars["String"]["output"]>
  sitePid: Scalars["String"]["output"]
  state?: Maybe<BundleState>
}

export type AdminBundleTableSort = {
  attr: AdminBundleTableAttr
  order: SortOrder
}

export type AdminBundleTableView = {
  __typename?: "AdminBundleTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
}

export type AdminChangelog = {
  __typename?: "AdminChangelog"
  changedBy?: Maybe<UserRef>
  columnName?: Maybe<Scalars["String"]["output"]>
  columnType?: Maybe<ChangelogType>
  dateCreated: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  isNew: Scalars["Boolean"]["output"]
  newVal?: Maybe<Scalars["JSON"]["output"]>
  objectId?: Maybe<Scalars["Int"]["output"]>
  oldVal?: Maybe<Scalars["JSON"]["output"]>
  source?: Maybe<ChangeSourceType>
  sourceId?: Maybe<Scalars["String"]["output"]>
  tableName: Scalars["String"]["output"]
  transactionId: Scalars["String"]["output"]
}

export type AdminFinProduct = {
  __typename?: "AdminFinProduct"
  activeOverrides: Array<FinmodelInputOverride>
  createdAt: Scalars["DateTime"]["output"]
  csPrices?: Maybe<Array<CsPrice>>
  disabledAt?: Maybe<Scalars["DateTime"]["output"]>
  financier: OrgRef
  finmodelInputOverrides: Array<FinmodelInputOverride>
  id: Scalars["Int"]["output"]
  includeStorage: Scalars["Boolean"]["output"]
  name: Scalars["String"]["output"]
  srecToInvestor: Scalars["Boolean"]["output"]
  status?: Maybe<FinProductStatus>
  targetOrg?: Maybe<Org>
  targetSite?: Maybe<SiteRef>
  type: FinProductType
}

export type AdminFinRel = {
  __typename?: "AdminFinRel"
  createdAt: Scalars["DateTime"]["output"]
  disabledAt?: Maybe<Scalars["DateTime"]["output"]>
  finproduct: AdminFinProduct
  id: Scalars["Int"]["output"]
  recvr: Org
}

export type AdminHelioscopeMutations = {
  __typename?: "AdminHelioscopeMutations"
  updateHelioscopeAssumptions: Helioscope
}

export type AdminHelioscopeMutationsUpdateHelioscopeAssumptionsArgs = {
  assumptions: HelioscopeAssumptionsInput
  helioscopePid: Scalars["String"]["input"]
}

export type AdminInvitation = {
  __typename?: "AdminInvitation"
  createdBy: UserRef
  dateCreated: Scalars["DateTime"]["output"]
  expiresAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  isClaimed: Scalars["Boolean"]["output"]
  isExpired: Scalars["Boolean"]["output"]
  org: Org
  pid: Scalars["String"]["output"]
  portfolio?: Maybe<PortfolioRef>
  targetUser: UserRef
}

export type AdminMarketplaceTable = {
  __typename?: "AdminMarketplaceTable"
  rows: Array<AdminMarketplaceTableRow>
  view: AdminMarketplaceTableView
}

export type AdminMarketplaceTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type AdminMarketplaceTableViewArgs = {
  filterBy?: InputMaybe<AdminMarketplaceTableFilter>
  sortBy?: InputMaybe<Array<AdminMarketplaceTableSort>>
}

export enum AdminMarketplaceTableAttr {
  AssetManager = "ASSET_MANAGER",
  AwardedTo = "AWARDED_TO",
  AwardedToDeveloperActual = "AWARDED_TO_DEVELOPER_ACTUAL",
  AwardedToDeveloperDate = "AWARDED_TO_DEVELOPER_DATE",
  AwardedToDeveloperEstimated = "AWARDED_TO_DEVELOPER_ESTIMATED",
  BiddingClosedActual = "BIDDING_CLOSED_ACTUAL",
  BiddingClosedAt = "BIDDING_CLOSED_AT",
  BiddingClosedDate = "BIDDING_CLOSED_DATE",
  BiddingClosedEstimated = "BIDDING_CLOSED_ESTIMATED",
  BiddingOpenedActual = "BIDDING_OPENED_ACTUAL",
  BiddingOpenedDate = "BIDDING_OPENED_DATE",
  BiddingOpenedEstimated = "BIDDING_OPENED_ESTIMATED",
  BiddingOpenAt = "BIDDING_OPEN_AT",
  BidsPresentedActual = "BIDS_PRESENTED_ACTUAL",
  BidsPresentedDate = "BIDS_PRESENTED_DATE",
  BidsPresentedEstimated = "BIDS_PRESENTED_ESTIMATED",
  BidCount = "BID_COUNT",
  BidPackageName = "BID_PACKAGE_NAME",
  BidPackagePid = "BID_PACKAGE_PID",
  BidReviewMeetingDate = "BID_REVIEW_MEETING_DATE",
  BuildingClass = "BUILDING_CLASS",
  BuildingFootprintCount = "BUILDING_FOOTPRINT_COUNT",
  BuildingFootprintSqft = "BUILDING_FOOTPRINT_SQFT",
  BuildingLegalName = "BUILDING_LEGAL_NAME",
  BuildingType = "BUILDING_TYPE",
  CbsaName = "CBSA_NAME",
  City = "CITY",
  CodActual = "COD_ACTUAL",
  CodDate = "COD_DATE",
  CodEstimated = "COD_ESTIMATED",
  ConstructionEmail = "CONSTRUCTION_EMAIL",
  CounselApproval = "COUNSEL_APPROVAL",
  County = "COUNTY",
  CsEstimatedAwardDate = "CS_ESTIMATED_AWARD_DATE",
  CsProgramApprovedActual = "CS_PROGRAM_APPROVED_ACTUAL",
  CsProgramApprovedDate = "CS_PROGRAM_APPROVED_DATE",
  CsProgramApprovedEstimated = "CS_PROGRAM_APPROVED_ESTIMATED",
  CsProgramSubmittedActual = "CS_PROGRAM_SUBMITTED_ACTUAL",
  CsProgramSubmittedDate = "CS_PROGRAM_SUBMITTED_DATE",
  CsProgramSubmittedEstimated = "CS_PROGRAM_SUBMITTED_ESTIMATED",
  EstimatedCod = "ESTIMATED_COD",
  EstimatedNtp = "ESTIMATED_NTP",
  ExternalLeaseApprovers = "EXTERNAL_LEASE_APPROVERS",
  FinproductType = "FINPRODUCT_TYPE",
  HubspotRecordId = "HUBSPOT_RECORD_ID",
  IsAwarded = "IS_AWARDED",
  IsFannieMaeLender = "IS_FANNIE_MAE_LENDER",
  IsFmGlobalInsurer = "IS_FM_GLOBAL_INSURER",
  IxApprovedActual = "IX_APPROVED_ACTUAL",
  IxApprovedDate = "IX_APPROVED_DATE",
  IxApprovedEstimated = "IX_APPROVED_ESTIMATED",
  IxSubmittedActual = "IX_SUBMITTED_ACTUAL",
  IxSubmittedDate = "IX_SUBMITTED_DATE",
  IxSubmittedEstimated = "IX_SUBMITTED_ESTIMATED",
  Latitude = "LATITUDE",
  LeaseApprovers = "LEASE_APPROVERS",
  LeaseLegalOwnerName = "LEASE_LEGAL_OWNER_NAME",
  LeasePropertyLegalDescription = "LEASE_PROPERTY_LEGAL_DESCRIPTION",
  LeaseSignatory = "LEASE_SIGNATORY",
  LeaseSignedActual = "LEASE_SIGNED_ACTUAL",
  LeaseSignedDate = "LEASE_SIGNED_DATE",
  LeaseSignedEstimated = "LEASE_SIGNED_ESTIMATED",
  Longitude = "LONGITUDE",
  LumenFeeUsdPerWatt = "LUMEN_FEE_USD_PER_WATT",
  LumenRevenue = "LUMEN_REVENUE",
  Name = "NAME",
  NeedsTenantApproval = "NEEDS_TENANT_APPROVAL",
  NoiLifetimeUsd = "NOI_LIFETIME_USD",
  NtpActual = "NTP_ACTUAL",
  NtpDate = "NTP_DATE",
  NtpEstimated = "NTP_ESTIMATED",
  NumStories = "NUM_STORIES",
  NumUnitsTotal = "NUM_UNITS_TOTAL",
  OpsOwnerEmail = "OPS_OWNER_EMAIL",
  OpsOwnerPid = "OPS_OWNER_PID",
  OrgName = "ORG_NAME",
  OrgSlug = "ORG_SLUG",
  PackageRowClosedAt = "PACKAGE_ROW_CLOSED_AT",
  PackageRowCloseCustomReason = "PACKAGE_ROW_CLOSE_CUSTOM_REASON",
  PackageRowCloseReason = "PACKAGE_ROW_CLOSE_REASON",
  PackageRowIsClosed = "PACKAGE_ROW_IS_CLOSED",
  PackageRowStatus = "PACKAGE_ROW_STATUS",
  Pid = "PID",
  PortfolioName = "PORTFOLIO_NAME",
  PreBidMeetingActual = "PRE_BID_MEETING_ACTUAL",
  PreBidMeetingDate = "PRE_BID_MEETING_DATE",
  PreBidMeetingEstimated = "PRE_BID_MEETING_ESTIMATED",
  PropertyFundName = "PROPERTY_FUND_NAME",
  PropertyInsurer = "PROPERTY_INSURER",
  PropertyLenders = "PROPERTY_LENDERS",
  PropertySiteVisitContacts = "PROPERTY_SITE_VISIT_CONTACTS",
  PvSizeKwDc = "PV_SIZE_KW_DC",
  RofoSigned = "ROFO_SIGNED",
  RofoSignedActual = "ROFO_SIGNED_ACTUAL",
  RofoSignedDate = "ROFO_SIGNED_DATE",
  RofoSignedEstimated = "ROFO_SIGNED_ESTIMATED",
  RoofCondition = "ROOF_CONDITION",
  RoofRentEscalator = "ROOF_RENT_ESCALATOR",
  RoofRentY1Usd = "ROOF_RENT_Y1_USD",
  RoofReplacedYr = "ROOF_REPLACED_YR",
  RoofRightsHolder = "ROOF_RIGHTS_HOLDER",
  RoofSqft = "ROOF_SQFT",
  SalesOwnerEmail = "SALES_OWNER_EMAIL",
  SalesOwnerPid = "SALES_OWNER_PID",
  SalePlannedYear = "SALE_PLANNED_YEAR",
  SalePlans = "SALE_PLANS",
  SignatureBlocks = "SIGNATURE_BLOCKS",
  SitePid = "SITE_PID",
  Sqft = "SQFT",
  State = "STATE",
  StreetAddress = "STREET_ADDRESS",
  UsableRoofSqft = "USABLE_ROOF_SQFT",
  UtilityShortName = "UTILITY_SHORT_NAME",
  YearBuilt = "YEAR_BUILT",
  ZipCode = "ZIP_CODE",
}

export type AdminMarketplaceTableFilter = {
  assetManager?: InputMaybe<StringPred>
  awardedTo?: InputMaybe<StringPred>
  awardedToDeveloperActual?: InputMaybe<DatePred>
  awardedToDeveloperDate?: InputMaybe<DatePred>
  awardedToDeveloperEstimated?: InputMaybe<DatePred>
  bidCount?: InputMaybe<IntPred>
  bidPackageName?: InputMaybe<StringPred>
  bidPackagePid?: InputMaybe<StringPred>
  bidReviewMeetingDate?: InputMaybe<DatePred>
  biddingClosedActual?: InputMaybe<DatePred>
  biddingClosedAt?: InputMaybe<DatePred>
  biddingClosedDate?: InputMaybe<DatePred>
  biddingClosedEstimated?: InputMaybe<DatePred>
  biddingOpenAt?: InputMaybe<DatePred>
  biddingOpenedActual?: InputMaybe<DatePred>
  biddingOpenedDate?: InputMaybe<DatePred>
  biddingOpenedEstimated?: InputMaybe<DatePred>
  bidsPresentedActual?: InputMaybe<DatePred>
  bidsPresentedDate?: InputMaybe<DatePred>
  bidsPresentedEstimated?: InputMaybe<DatePred>
  buildingClass?: InputMaybe<StringPred>
  buildingFootprintCount?: InputMaybe<IntPred>
  buildingFootprintSqft?: InputMaybe<FloatPred>
  buildingLegalName?: InputMaybe<StringPred>
  buildingType?: InputMaybe<BuildingTypePred>
  cbsaName?: InputMaybe<StringPred>
  city?: InputMaybe<StringPred>
  codActual?: InputMaybe<DatePred>
  codDate?: InputMaybe<DatePred>
  codEstimated?: InputMaybe<DatePred>
  constructionEmail?: InputMaybe<StringPred>
  counselApproval?: InputMaybe<CounselApprovalPred>
  county?: InputMaybe<StringPred>
  csEstimatedAwardDate?: InputMaybe<DatePred>
  csProgramApprovedActual?: InputMaybe<DatePred>
  csProgramApprovedDate?: InputMaybe<DatePred>
  csProgramApprovedEstimated?: InputMaybe<DatePred>
  csProgramSubmittedActual?: InputMaybe<DatePred>
  csProgramSubmittedDate?: InputMaybe<DatePred>
  csProgramSubmittedEstimated?: InputMaybe<DatePred>
  estimatedCod?: InputMaybe<DatePred>
  estimatedNtp?: InputMaybe<DatePred>
  finproductType?: InputMaybe<FinProductTypePred>
  id?: InputMaybe<StringPred>
  isAwarded?: InputMaybe<BoolPred>
  isFannieMaeLender?: InputMaybe<BoolPred>
  isFmGlobalInsurer?: InputMaybe<BoolPred>
  ixApprovedActual?: InputMaybe<DatePred>
  ixApprovedDate?: InputMaybe<DatePred>
  ixApprovedEstimated?: InputMaybe<DatePred>
  ixSubmittedActual?: InputMaybe<DatePred>
  ixSubmittedDate?: InputMaybe<DatePred>
  ixSubmittedEstimated?: InputMaybe<DatePred>
  latitude?: InputMaybe<FloatPred>
  leaseLegalOwnerName?: InputMaybe<StringPred>
  leasePropertyLegalDescription?: InputMaybe<StringPred>
  leaseSignatory?: InputMaybe<StringPred>
  leaseSignedActual?: InputMaybe<DatePred>
  leaseSignedDate?: InputMaybe<DatePred>
  leaseSignedEstimated?: InputMaybe<DatePred>
  longitude?: InputMaybe<FloatPred>
  lumenFeeUsdPerWatt?: InputMaybe<FloatPred>
  lumenRevenue?: InputMaybe<FloatPred>
  name?: InputMaybe<StringPred>
  needsTenantApproval?: InputMaybe<BoolPred>
  noiLifetimeUsd?: InputMaybe<FloatPred>
  ntpActual?: InputMaybe<DatePred>
  ntpDate?: InputMaybe<DatePred>
  ntpEstimated?: InputMaybe<DatePred>
  numStories?: InputMaybe<IntPred>
  numUnitsTotal?: InputMaybe<IntPred>
  opsOwnerEmail?: InputMaybe<StringPred>
  orgName?: InputMaybe<StringPred>
  orgSlug?: InputMaybe<StringPred>
  packageRowClosedAt?: InputMaybe<DatePred>
  packageRowIsClosed?: InputMaybe<BoolPred>
  packageRowStatus?: InputMaybe<PackageRowStatusPred>
  pid?: InputMaybe<StringPred>
  portfolioName?: InputMaybe<StringPred>
  preBidMeetingActual?: InputMaybe<DatePred>
  preBidMeetingDate?: InputMaybe<DatePred>
  preBidMeetingEstimated?: InputMaybe<DatePred>
  propertyFundName?: InputMaybe<StringPred>
  propertyInsurer?: InputMaybe<StringPred>
  propertyLenders?: InputMaybe<StringPred>
  pvSizeKwDc?: InputMaybe<FloatPred>
  rofoSigned?: InputMaybe<DatePred>
  rofoSignedActual?: InputMaybe<DatePred>
  rofoSignedDate?: InputMaybe<DatePred>
  rofoSignedEstimated?: InputMaybe<DatePred>
  roofRentEscalator?: InputMaybe<FloatPred>
  roofRentY1Usd?: InputMaybe<FloatPred>
  roofReplacedYr?: InputMaybe<FloatPred>
  roofRightsHolder?: InputMaybe<RoofRightsHolderPred>
  roofSqft?: InputMaybe<FloatPred>
  salePlannedYear?: InputMaybe<FloatPred>
  salePlans?: InputMaybe<StringPred>
  salesOwnerEmail?: InputMaybe<StringPred>
  search?: InputMaybe<SearchPred>
  sitePid?: InputMaybe<StringPred>
  sqft?: InputMaybe<FloatPred>
  state?: InputMaybe<UsStateMultiPred>
  streetAddress?: InputMaybe<StringPred>
  usableRoofSqft?: InputMaybe<FloatPred>
  utilityShortName?: InputMaybe<StringPred>
  yearBuilt?: InputMaybe<IntPred>
}

export type AdminMarketplaceTableRow = {
  __typename?: "AdminMarketplaceTableRow"
  assetManager?: Maybe<Scalars["String"]["output"]>
  awardedTo?: Maybe<Scalars["String"]["output"]>
  awardedToDeveloperActual?: Maybe<Scalars["Date"]["output"]>
  awardedToDeveloperDate?: Maybe<Scalars["Date"]["output"]>
  awardedToDeveloperEstimated?: Maybe<Scalars["Date"]["output"]>
  bidCount: Scalars["Int"]["output"]
  bidPackageName: Scalars["String"]["output"]
  bidPackagePid: Scalars["String"]["output"]
  bidReviewMeetingDate?: Maybe<Scalars["Date"]["output"]>
  biddingClosedActual?: Maybe<Scalars["Date"]["output"]>
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingClosedDate?: Maybe<Scalars["Date"]["output"]>
  biddingClosedEstimated?: Maybe<Scalars["Date"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenedActual?: Maybe<Scalars["Date"]["output"]>
  biddingOpenedDate?: Maybe<Scalars["Date"]["output"]>
  biddingOpenedEstimated?: Maybe<Scalars["Date"]["output"]>
  bidsPresentedActual?: Maybe<Scalars["Date"]["output"]>
  bidsPresentedDate?: Maybe<Scalars["Date"]["output"]>
  bidsPresentedEstimated?: Maybe<Scalars["Date"]["output"]>
  buildingClass?: Maybe<Scalars["String"]["output"]>
  buildingFootprintCount?: Maybe<Scalars["Int"]["output"]>
  buildingFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  buildingLegalName?: Maybe<Scalars["String"]["output"]>
  buildingType?: Maybe<BuildingType>
  cbsaName?: Maybe<Scalars["String"]["output"]>
  city: Scalars["String"]["output"]
  codActual?: Maybe<Scalars["Date"]["output"]>
  codDate?: Maybe<Scalars["Date"]["output"]>
  codEstimated?: Maybe<Scalars["Date"]["output"]>
  constructionEmail?: Maybe<Scalars["String"]["output"]>
  counselApproval?: Maybe<CounselApproval>
  county: Scalars["String"]["output"]
  csEstimatedAwardDate?: Maybe<Scalars["DateTime"]["output"]>
  csProgramApprovedActual?: Maybe<Scalars["Date"]["output"]>
  csProgramApprovedDate?: Maybe<Scalars["Date"]["output"]>
  csProgramApprovedEstimated?: Maybe<Scalars["Date"]["output"]>
  csProgramSubmittedActual?: Maybe<Scalars["Date"]["output"]>
  csProgramSubmittedDate?: Maybe<Scalars["Date"]["output"]>
  csProgramSubmittedEstimated?: Maybe<Scalars["Date"]["output"]>
  estimatedCod?: Maybe<Scalars["Date"]["output"]>
  estimatedNtp?: Maybe<Scalars["Date"]["output"]>
  externalLeaseApprovers?: Maybe<Array<Scalars["String"]["output"]>>
  finproductType: FinProductType
  hubspotRecordId?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  isAwarded: Scalars["Boolean"]["output"]
  isFannieMaeLender?: Maybe<Scalars["Boolean"]["output"]>
  isFmGlobalInsurer?: Maybe<Scalars["Boolean"]["output"]>
  ixApprovedActual?: Maybe<Scalars["Date"]["output"]>
  ixApprovedDate?: Maybe<Scalars["Date"]["output"]>
  ixApprovedEstimated?: Maybe<Scalars["Date"]["output"]>
  ixSubmittedActual?: Maybe<Scalars["Date"]["output"]>
  ixSubmittedDate?: Maybe<Scalars["Date"]["output"]>
  ixSubmittedEstimated?: Maybe<Scalars["Date"]["output"]>
  latitude: Scalars["Float"]["output"]
  leaseApprovers?: Maybe<Array<Scalars["String"]["output"]>>
  leaseLegalOwnerName?: Maybe<Scalars["String"]["output"]>
  leasePropertyLegalDescription?: Maybe<Scalars["String"]["output"]>
  leaseSignatory?: Maybe<Scalars["String"]["output"]>
  leaseSignedActual?: Maybe<Scalars["Date"]["output"]>
  leaseSignedDate?: Maybe<Scalars["Date"]["output"]>
  leaseSignedEstimated?: Maybe<Scalars["Date"]["output"]>
  longitude: Scalars["Float"]["output"]
  lumenFeeUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  lumenRevenue?: Maybe<Scalars["Float"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  needsTenantApproval?: Maybe<Scalars["Boolean"]["output"]>
  noiLifetimeUsd?: Maybe<Scalars["Float"]["output"]>
  ntpActual?: Maybe<Scalars["Date"]["output"]>
  ntpDate?: Maybe<Scalars["Date"]["output"]>
  ntpEstimated?: Maybe<Scalars["Date"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
  opsOwnerEmail?: Maybe<Scalars["String"]["output"]>
  opsOwnerPid?: Maybe<Scalars["String"]["output"]>
  orgName: Scalars["String"]["output"]
  orgSlug: Scalars["String"]["output"]
  packageRowCloseCustomReason?: Maybe<Scalars["String"]["output"]>
  packageRowCloseReason?: Maybe<PackageRowCloseReason>
  packageRowClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  packageRowIsClosed: Scalars["Boolean"]["output"]
  packageRowStatus?: Maybe<PackageRowStatus>
  pid: Scalars["String"]["output"]
  portfolioName: Scalars["String"]["output"]
  preBidMeetingActual?: Maybe<Scalars["Date"]["output"]>
  preBidMeetingDate?: Maybe<Scalars["Date"]["output"]>
  preBidMeetingEstimated?: Maybe<Scalars["Date"]["output"]>
  propertyFundName?: Maybe<Scalars["String"]["output"]>
  propertyInsurer?: Maybe<Scalars["String"]["output"]>
  propertyLenders?: Maybe<Scalars["String"]["output"]>
  propertySiteVisitContacts?: Maybe<Array<Scalars["String"]["output"]>>
  pvSizeKwDc?: Maybe<Scalars["Float"]["output"]>
  rofoSigned?: Maybe<Scalars["Date"]["output"]>
  rofoSignedActual?: Maybe<Scalars["Date"]["output"]>
  rofoSignedDate?: Maybe<Scalars["Date"]["output"]>
  rofoSignedEstimated?: Maybe<Scalars["Date"]["output"]>
  roofCondition?: Maybe<Scalars["String"]["output"]>
  roofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  roofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  roofReplacedYr?: Maybe<Scalars["Int"]["output"]>
  roofRightsHolder?: Maybe<RoofRightsHolder>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  salePlannedYear?: Maybe<Scalars["Int"]["output"]>
  salePlans?: Maybe<Scalars["String"]["output"]>
  salesOwnerEmail?: Maybe<Scalars["String"]["output"]>
  salesOwnerPid?: Maybe<Scalars["String"]["output"]>
  signatureBlocks?: Maybe<Array<Scalars["String"]["output"]>>
  sitePid: Scalars["String"]["output"]
  sqft?: Maybe<Scalars["Float"]["output"]>
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  usableRoofSqft?: Maybe<Scalars["Float"]["output"]>
  utilityShortName?: Maybe<Scalars["String"]["output"]>
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  zipCode: Scalars["String"]["output"]
}

export type AdminMarketplaceTableSort = {
  attr: AdminMarketplaceTableAttr
  order: SortOrder
}

export type AdminMarketplaceTableStats = {
  __typename?: "AdminMarketplaceTableStats"
  assetManagers: Array<Scalars["String"]["output"]>
  bidPackageNames: Array<Scalars["String"]["output"]>
  buildingOwners: Array<Scalars["String"]["output"]>
  financiers: Array<Scalars["String"]["output"]>
  opsOwners: Array<Scalars["String"]["output"]>
  portfolios: Array<Scalars["String"]["output"]>
  salesOwners: Array<Scalars["String"]["output"]>
  siteStates: Array<Scalars["String"]["output"]>
}

export type AdminMarketplaceTableView = {
  __typename?: "AdminMarketplaceTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
  stats: AdminMarketplaceTableStats
}

export type AdminNote = {
  __typename?: "AdminNote"
  createdAt: Scalars["DateTime"]["output"]
  createdBy: UserRef
  hiddenFromCustomers: Scalars["Boolean"]["output"]
  id: Scalars["Int"]["output"]
  pid: Scalars["String"]["output"]
  text: Scalars["String"]["output"]
  trashedAt?: Maybe<Scalars["DateTime"]["output"]>
  trashedBy?: Maybe<UserRef>
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>
  updatedBy?: Maybe<UserRef>
}

export type AdminNoteMutations = {
  __typename?: "AdminNoteMutations"
  edit: AdminNote
  new: AdminNote
  trash: AdminNote
}

export type AdminNoteMutationsEditArgs = {
  hiddenFromCustomers: Scalars["Boolean"]["input"]
  notePid: Scalars["String"]["input"]
  text: Scalars["String"]["input"]
}

export type AdminNoteMutationsNewArgs = {
  hiddenFromCustomers: Scalars["Boolean"]["input"]
  sitePid: Scalars["String"]["input"]
  text: Scalars["String"]["input"]
}

export type AdminNoteMutationsTrashArgs = {
  notePid: Scalars["String"]["input"]
}

export type AdminOpenInvite = {
  __typename?: "AdminOpenInvite"
  createdAt: Scalars["DateTime"]["output"]
  createdBy: UserRef
  expiresAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  isExpired: Scalars["Boolean"]["output"]
  pid: Scalars["String"]["output"]
  portfolio: PortfolioRef
  url: Scalars["String"]["output"]
}

export type AdminOpenInviteMutations = {
  __typename?: "AdminOpenInviteMutations"
  new: AdminOpenInvite
  setExpiresAt: AdminOpenInvite
}

export type AdminOpenInviteMutationsNewArgs = {
  portfolioPid: Scalars["String"]["input"]
}

export type AdminOpenInviteMutationsSetExpiresAtArgs = {
  expiresAt: Scalars["DateTime"]["input"]
  id: Scalars["Int"]["input"]
}

export type AdminOrg = {
  __typename?: "AdminOrg"
  InvestorProfile?: Maybe<InvestorProfile>
  allowedEmailDomains?: Maybe<Array<Scalars["String"]["output"]>>
  createdAt: Scalars["DateTime"]["output"]
  createdBy?: Maybe<UserRef>
  description?: Maybe<Scalars["String"]["output"]>
  financing: Array<AdminFinRel>
  finmodelDepsUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>
  finproducts: Array<AdminFinProduct>
  id: Scalars["Int"]["output"]
  irrFlavor: IrrType
  labels: Array<SiteLabel>
  logoUrl: Scalars["String"]["output"]
  logomarkUrl?: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  overrides: Array<FinmodelInputOverride>
  pid: Scalars["String"]["output"]
  portfolios: Array<PortfolioRef>
  rawSlug: Scalars["String"]["output"]
  resultTable: ResultTable
  slug: Scalars["String"]["output"]
  slugNum: Scalars["Int"]["output"]
  users: Array<AdminUser>
}

export type AdminOrgMutations = {
  __typename?: "AdminOrgMutations"
  finrelToggle: AdminFinRel
  setAllowedEmailDomains: AdminOrg
  setLogo: AdminOrg
  setLogomark: AdminOrg
  setName: AdminOrg
  setSlug: AdminOrg
}

export type AdminOrgMutationsFinrelToggleArgs = {
  enable: Scalars["Boolean"]["input"]
  finproductId: Scalars["Int"]["input"]
  orgPid: Scalars["String"]["input"]
}

export type AdminOrgMutationsSetAllowedEmailDomainsArgs = {
  allowedEmailDomains?: InputMaybe<Array<Scalars["String"]["input"]>>
  pid: Scalars["String"]["input"]
}

export type AdminOrgMutationsSetLogoArgs = {
  pid: Scalars["String"]["input"]
  upload: Scalars["Upload"]["input"]
}

export type AdminOrgMutationsSetLogomarkArgs = {
  pid: Scalars["String"]["input"]
  upload: Scalars["Upload"]["input"]
}

export type AdminOrgMutationsSetNameArgs = {
  name: Scalars["String"]["input"]
  pid: Scalars["String"]["input"]
}

export type AdminOrgMutationsSetSlugArgs = {
  pid: Scalars["String"]["input"]
  slug: Scalars["String"]["input"]
}

export type AdminPortfolio = {
  __typename?: "AdminPortfolio"
  logoUrl?: Maybe<Scalars["String"]["output"]>
  minKw?: Maybe<Scalars["Float"]["output"]>
  minKwSetBy?: Maybe<Scalars["String"]["output"]>
  minKwSetDate?: Maybe<Scalars["DateTime"]["output"]>
  name: Scalars["String"]["output"]
  numSites: Scalars["Int"]["output"]
  org: AdminOrg
  overrides: Array<FinmodelInputOverride>
  pid: Scalars["String"]["output"]
  siteRefs: Array<SiteRef>
  /** @deprecated Too slow to use */
  sites: Array<Maybe<Site>>
  title: Scalars["String"]["output"]
  users: Array<AdminUser>
  view: AdminPortfolioView
  views: Array<ViewType>
}

export type AdminPortfolioSitesArgs = {
  sitePids: Array<Scalars["String"]["input"]>
}

export type AdminPortfolioView = {
  __typename?: "AdminPortfolioView"
  sitePids: Array<Scalars["String"]["output"]>
}

export type AdminScenario = {
  __typename?: "AdminScenario"
  activeEtbReport?: Maybe<EtbReport>
  allowMulticonnect: Scalars["Boolean"]["output"]
  configs: Array<ScenarioConfig>
  createdBy?: Maybe<UserRef>
  dateCreated: Scalars["DateTime"]["output"]
  etbs: Array<EtbReport>
  helioscope?: Maybe<Helioscope>
  hiddenFromCustomers: Scalars["Boolean"]["output"]
  id: Scalars["Int"]["output"]
  includeStorage: Scalars["Boolean"]["output"]
  isMultifamily: Scalars["Boolean"]["output"]
  isPrimary: Scalars["Boolean"]["output"]
  isRecommended: Scalars["Boolean"]["output"]
  loadCategory: LoadCategory
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  solarLocation: SolarLocation
}

export type AdminSiteLabelMutations = {
  __typename?: "AdminSiteLabelMutations"
  applyLabelToSite?: Maybe<Error>
  changeSiteLabelColor: ChangeSiteLabelColorResponse
  createAndApplySiteLabel: CreateAndApplySiteLabelResponse
  deleteLabel?: Maybe<Error>
  removeLabel?: Maybe<Scalars["Void"]["output"]>
  renameLabel: RenameSiteLabelResponse
}

export type AdminSiteLabelMutationsApplyLabelToSiteArgs = {
  input: ApplyLabelToSiteInput
}

export type AdminSiteLabelMutationsChangeSiteLabelColorArgs = {
  input: ChangeSiteLabelColorInput
}

export type AdminSiteLabelMutationsCreateAndApplySiteLabelArgs = {
  input: CreateAndApplySiteLabelInput
}

export type AdminSiteLabelMutationsDeleteLabelArgs = {
  input: DeleteLabelInput
}

export type AdminSiteLabelMutationsRemoveLabelArgs = {
  input: RemoveLabelInput
}

export type AdminSiteLabelMutationsRenameLabelArgs = {
  input: RenameLabelInput
}

export type AdminSitesTable = {
  __typename?: "AdminSitesTable"
  rows: Array<AdminSitesTableRow>
  view: AdminSitesTableView
}

export type AdminSitesTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type AdminSitesTableViewArgs = {
  filterBy?: InputMaybe<AdminSitesTableFilter>
  sortBy?: InputMaybe<Array<AdminSitesTableSort>>
}

export enum AdminSitesTableAttr {
  BuildingFootprintSqft = "BUILDING_FOOTPRINT_SQFT",
  BuildingType = "BUILDING_TYPE",
  CarportMaxPvKw = "CARPORT_MAX_PV_KW",
  City = "CITY",
  CreatedAt = "CREATED_AT",
  CustomerId = "CUSTOMER_ID",
  Latitude = "LATITUDE",
  Longitude = "LONGITUDE",
  Metering = "METERING",
  Name = "NAME",
  OrgName = "ORG_NAME",
  OrgPid = "ORG_PID",
  OrgSlug = "ORG_SLUG",
  ParcelFootprintSqft = "PARCEL_FOOTPRINT_SQFT",
  PortfolioName = "PORTFOLIO_NAME",
  PortfolioPid = "PORTFOLIO_PID",
  RoofMaxPvKw = "ROOF_MAX_PV_KW",
  RoofSqft = "ROOF_SQFT",
  SitePid = "SITE_PID",
  Sqft = "SQFT",
  State = "STATE",
  Status = "STATUS",
  StatusCustomReason = "STATUS_CUSTOM_REASON",
  StatusReason = "STATUS_REASON",
  StreetAddress = "STREET_ADDRESS",
  UtilityId = "UTILITY_ID",
  UtilityName = "UTILITY_NAME",
  UtilityShortName = "UTILITY_SHORT_NAME",
  YearBuilt = "YEAR_BUILT",
  ZipCode = "ZIP_CODE",
}

export type AdminSitesTableFilter = {
  buildingFootprintSqft?: InputMaybe<FloatPred>
  buildingType?: InputMaybe<BuildingTypePred>
  carportMaxPvKw?: InputMaybe<FloatPred>
  city?: InputMaybe<StringPred>
  createdAt?: InputMaybe<DatePred>
  metering?: InputMaybe<MeteringPred>
  orgName?: InputMaybe<StringPred>
  orgSlug?: InputMaybe<StringPred>
  parcelFootprintSqft?: InputMaybe<FloatPred>
  portfolioName?: InputMaybe<StringPred>
  portfolioPid?: InputMaybe<StringPred>
  roofMaxPvKw?: InputMaybe<FloatPred>
  roofSqft?: InputMaybe<FloatPred>
  sitePid?: InputMaybe<StringPred>
  sqft?: InputMaybe<FloatPred>
  state?: InputMaybe<UsStateMultiPred>
  status?: InputMaybe<SiteStatusPred>
  utilityName?: InputMaybe<StringPred>
  utilityShortName?: InputMaybe<StringPred>
  yearBuilt?: InputMaybe<FloatPred>
}

export type AdminSitesTableRow = {
  __typename?: "AdminSitesTableRow"
  buildingFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  buildingType?: Maybe<BuildingType>
  carportMaxPvKw?: Maybe<Scalars["Float"]["output"]>
  city: Scalars["String"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  customerId?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  latitude: Scalars["Float"]["output"]
  longitude: Scalars["Float"]["output"]
  metering?: Maybe<Metering>
  name?: Maybe<Scalars["String"]["output"]>
  orgName: Scalars["String"]["output"]
  orgPid: Scalars["String"]["output"]
  orgSlug: Scalars["String"]["output"]
  parcelFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  portfolioName: Scalars["String"]["output"]
  portfolioPid: Scalars["String"]["output"]
  roofMaxPvKw: Scalars["Float"]["output"]
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  sitePid: Scalars["String"]["output"]
  sqft?: Maybe<Scalars["Float"]["output"]>
  state: Scalars["String"]["output"]
  status: SiteStatus
  statusCustomReason?: Maybe<Scalars["String"]["output"]>
  statusReason?: Maybe<StatusReason>
  streetAddress: Scalars["String"]["output"]
  utilityId?: Maybe<Scalars["Int"]["output"]>
  utilityName?: Maybe<Scalars["String"]["output"]>
  utilityShortName?: Maybe<Scalars["String"]["output"]>
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  zipCode: Scalars["String"]["output"]
}

export type AdminSitesTableSort = {
  attr: AdminSitesTableAttr
  order: SortOrder
}

export type AdminSitesTableStats = {
  __typename?: "AdminSitesTableStats"
  cities: Array<Scalars["String"]["output"]>
  orgNames: Array<Scalars["String"]["output"]>
  portfolios: Array<Scalars["String"]["output"]>
  utilityNames: Array<Scalars["String"]["output"]>
}

export type AdminSitesTableView = {
  __typename?: "AdminSitesTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
  stats: AdminSitesTableStats
}

export type AdminTariffQuery = {
  __typename?: "AdminTariffQuery"
  searchGenabilityByUtilityName: Array<Utility>
  tariff?: Maybe<Tariff>
  utilities: Array<Utility>
  utility?: Maybe<Utility>
}

export type AdminTariffQuerySearchGenabilityByUtilityNameArgs = {
  name: Scalars["String"]["input"]
}

export type AdminTariffQueryTariffArgs = {
  id: Scalars["Int"]["input"]
}

export type AdminTariffQueryUtilitiesArgs = {
  zipCode?: InputMaybe<Scalars["String"]["input"]>
}

export type AdminTariffQueryUtilityArgs = {
  id: Scalars["Int"]["input"]
}

export type AdminUser = {
  __typename?: "AdminUser"
  affiliation?: Maybe<Scalars["String"]["output"]>
  avatarUrl?: Maybe<Scalars["String"]["output"]>
  dateCreated: Scalars["DateTime"]["output"]
  email: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  isAdmin: Scalars["Boolean"]["output"]
  isEnabled: Scalars["Boolean"]["output"]
  lastSeenAt?: Maybe<Scalars["DateTime"]["output"]>
  licenseAgreements: Array<LicenseAgreement>
  meetingSchedulingUrl?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  org?: Maybe<Org>
  pageViews: Array<AdminUserPageView>
  pid: Scalars["String"]["output"]
  portfoliosWithRole: Array<PortfolioRef>
  unclaimedInvitations: Array<AdminInvitation>
}

export type AdminUserError = AdminUser | Error

export type AdminUserMutations = {
  __typename?: "AdminUserMutations"
  addToPortfolio: AdminUser
  giveMeAMagicLink: MagicLink
  inviteToPortfolio?: Maybe<Scalars["Void"]["output"]>
  new: NewUserResponse
  removeFromPortfolio: AdminUser
  removeOrgMembership: AdminUser
  setAvatar: AdminUser
  setIsEnabled: AdminUser
  setMeetingSchedulingUrl: AdminUserError
  setName: AdminUser
  updateOrgMembership: AdminUser
}

export type AdminUserMutationsAddToPortfolioArgs = {
  portfolioPid: Scalars["String"]["input"]
  sendEmail: Scalars["Boolean"]["input"]
  userId: Scalars["Int"]["input"]
}

export type AdminUserMutationsGiveMeAMagicLinkArgs = {
  email: Scalars["String"]["input"]
}

export type AdminUserMutationsInviteToPortfolioArgs = {
  email: Scalars["String"]["input"]
  orgPid: Scalars["String"]["input"]
  portfolioPid: Scalars["String"]["input"]
}

export type AdminUserMutationsNewArgs = {
  email: Scalars["String"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  orgPid: Scalars["String"]["input"]
  portfolioPids: Array<Scalars["String"]["input"]>
  sendInvite: Scalars["Boolean"]["input"]
}

export type AdminUserMutationsRemoveFromPortfolioArgs = {
  portfolioPid: Scalars["String"]["input"]
  userId: Scalars["Int"]["input"]
}

export type AdminUserMutationsRemoveOrgMembershipArgs = {
  userId: Scalars["Int"]["input"]
}

export type AdminUserMutationsSetAvatarArgs = {
  upload: Scalars["Upload"]["input"]
  userId: Scalars["Int"]["input"]
}

export type AdminUserMutationsSetIsEnabledArgs = {
  isEnabled: Scalars["Boolean"]["input"]
  userId: Scalars["Int"]["input"]
}

export type AdminUserMutationsSetMeetingSchedulingUrlArgs = {
  url: Scalars["String"]["input"]
  userId: Scalars["Int"]["input"]
}

export type AdminUserMutationsSetNameArgs = {
  id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
}

export type AdminUserMutationsUpdateOrgMembershipArgs = {
  orgPid: Scalars["String"]["input"]
  userId: Scalars["Int"]["input"]
}

export type AdminUserPageView = {
  __typename?: "AdminUserPageView"
  createdAt: Scalars["DateTime"]["output"]
  pathname: Scalars["String"]["output"]
}

export type AllMilestonesInput = {
  awardedToDeveloper?: InputMaybe<ProjectMilestoneInput>
  biddingClosed?: InputMaybe<ProjectMilestoneInput>
  biddingOpened?: InputMaybe<ProjectMilestoneInput>
  bidsPresented?: InputMaybe<ProjectMilestoneInput>
  cod?: InputMaybe<ProjectMilestoneInput>
  csProgramApproved?: InputMaybe<ProjectMilestoneInput>
  csProgramSubmitted?: InputMaybe<ProjectMilestoneInput>
  ixApproved?: InputMaybe<ProjectMilestoneInput>
  ixSubmitted?: InputMaybe<ProjectMilestoneInput>
  leaseSigned?: InputMaybe<ProjectMilestoneInput>
  ntp?: InputMaybe<ProjectMilestoneInput>
  preBidMeeting?: InputMaybe<ProjectMilestoneInput>
  rofoSigned?: InputMaybe<ProjectMilestoneInput>
}

export type Allocation = {
  label: Scalars["String"]["input"]
  pct: Scalars["Float"]["input"]
}

export type ApplyLabelToSiteInput = {
  labelPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type AttachFileResponse = DuplicatesAttachment | Error | Site

export type Attachment = {
  __typename?: "Attachment"
  contentType: Scalars["String"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  createdBy: UserRef
  csvPeek?: Maybe<Array<Array<Scalars["String"]["output"]>>>
  downloadHref: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  isEtb?: Maybe<Scalars["Boolean"]["output"]>
  isRoofImageCandidate: Scalars["Boolean"]["output"]
  isTrashable: Scalars["Boolean"]["output"]
  name: Scalars["String"]["output"]
  size: Scalars["Int"]["output"]
  trashedAt?: Maybe<Scalars["DateTime"]["output"]>
}

export type AuthUser = {
  __typename?: "AuthUser"
  email?: Maybe<Scalars["String"]["output"]>
  hasGoogleAccessToken: Scalars["Boolean"]["output"]
  isAdmin: Scalars["Boolean"]["output"]
  isAuthenticated: Scalars["Boolean"]["output"]
  meetingSchedulingUrl?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  org?: Maybe<Org>
  orgs: Array<Org>
  pid?: Maybe<Scalars["String"]["output"]>
}

export type AwardedProjectTable = {
  __typename?: "AwardedProjectTable"
  rows: Array<AwardedProjectTableRow>
  view: AwardedProjectTableView
}

export type AwardedProjectTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type AwardedProjectTableViewArgs = {
  filterBy?: InputMaybe<AwardedProjectTableFilter>
  sortBy?: InputMaybe<Array<AwardedProjectTableSort>>
}

export enum AwardedProjectTableAttr {
  AwardedToDeveloperActual = "AWARDED_TO_DEVELOPER_ACTUAL",
  AwardedToDeveloperDate = "AWARDED_TO_DEVELOPER_DATE",
  AwardedToDeveloperEstimated = "AWARDED_TO_DEVELOPER_ESTIMATED",
  BiddingClosedActual = "BIDDING_CLOSED_ACTUAL",
  BiddingClosedDate = "BIDDING_CLOSED_DATE",
  BiddingClosedEstimated = "BIDDING_CLOSED_ESTIMATED",
  BiddingOpenedActual = "BIDDING_OPENED_ACTUAL",
  BiddingOpenedDate = "BIDDING_OPENED_DATE",
  BiddingOpenedEstimated = "BIDDING_OPENED_ESTIMATED",
  BidsPresentedActual = "BIDS_PRESENTED_ACTUAL",
  BidsPresentedDate = "BIDS_PRESENTED_DATE",
  BidsPresentedEstimated = "BIDS_PRESENTED_ESTIMATED",
  BidPackagePid = "BID_PACKAGE_PID",
  BundlePid = "BUNDLE_PID",
  City = "CITY",
  CodActual = "COD_ACTUAL",
  CodDate = "COD_DATE",
  CodEstimated = "COD_ESTIMATED",
  CsEstimatedAwardDate = "CS_ESTIMATED_AWARD_DATE",
  CsProgramApprovedActual = "CS_PROGRAM_APPROVED_ACTUAL",
  CsProgramApprovedDate = "CS_PROGRAM_APPROVED_DATE",
  CsProgramApprovedEstimated = "CS_PROGRAM_APPROVED_ESTIMATED",
  CsProgramSubmittedActual = "CS_PROGRAM_SUBMITTED_ACTUAL",
  CsProgramSubmittedDate = "CS_PROGRAM_SUBMITTED_DATE",
  CsProgramSubmittedEstimated = "CS_PROGRAM_SUBMITTED_ESTIMATED",
  EstimatedCod = "ESTIMATED_COD",
  EstimatedNtp = "ESTIMATED_NTP",
  IxApprovedActual = "IX_APPROVED_ACTUAL",
  IxApprovedDate = "IX_APPROVED_DATE",
  IxApprovedEstimated = "IX_APPROVED_ESTIMATED",
  IxSubmittedActual = "IX_SUBMITTED_ACTUAL",
  IxSubmittedDate = "IX_SUBMITTED_DATE",
  IxSubmittedEstimated = "IX_SUBMITTED_ESTIMATED",
  LeaseSignedActual = "LEASE_SIGNED_ACTUAL",
  LeaseSignedDate = "LEASE_SIGNED_DATE",
  LeaseSignedEstimated = "LEASE_SIGNED_ESTIMATED",
  LumenRevenue = "LUMEN_REVENUE",
  Name = "NAME",
  NtpActual = "NTP_ACTUAL",
  NtpDate = "NTP_DATE",
  NtpEstimated = "NTP_ESTIMATED",
  OrgName = "ORG_NAME",
  PackageRowClosedAt = "PACKAGE_ROW_CLOSED_AT",
  PackageRowCloseCustomReason = "PACKAGE_ROW_CLOSE_CUSTOM_REASON",
  PackageRowCloseReason = "PACKAGE_ROW_CLOSE_REASON",
  PackageRowIsClosed = "PACKAGE_ROW_IS_CLOSED",
  PackageRowStatus = "PACKAGE_ROW_STATUS",
  PreBidMeetingActual = "PRE_BID_MEETING_ACTUAL",
  PreBidMeetingDate = "PRE_BID_MEETING_DATE",
  PreBidMeetingEstimated = "PRE_BID_MEETING_ESTIMATED",
  PvSizeKwAc = "PV_SIZE_KW_AC",
  PvSizeKwDc = "PV_SIZE_KW_DC",
  PvTypes = "PV_TYPES",
  RofoSignedActual = "ROFO_SIGNED_ACTUAL",
  RofoSignedDate = "ROFO_SIGNED_DATE",
  RofoSignedEstimated = "ROFO_SIGNED_ESTIMATED",
  SitePid = "SITE_PID",
  State = "STATE",
  StreetAddress = "STREET_ADDRESS",
  ZipCode = "ZIP_CODE",
}

export type AwardedProjectTableFilter = {
  awardedToDeveloperActual?: InputMaybe<DatePred>
  awardedToDeveloperDate?: InputMaybe<DatePred>
  awardedToDeveloperEstimated?: InputMaybe<DatePred>
  bidPackagePid?: InputMaybe<StringPred>
  biddingClosedActual?: InputMaybe<DatePred>
  biddingClosedDate?: InputMaybe<DatePred>
  biddingClosedEstimated?: InputMaybe<DatePred>
  biddingOpenedActual?: InputMaybe<DatePred>
  biddingOpenedDate?: InputMaybe<DatePred>
  biddingOpenedEstimated?: InputMaybe<DatePred>
  bidsPresentedActual?: InputMaybe<DatePred>
  bidsPresentedDate?: InputMaybe<DatePred>
  bidsPresentedEstimated?: InputMaybe<DatePred>
  bundlePid?: InputMaybe<StringPred>
  city?: InputMaybe<StringPred>
  codActual?: InputMaybe<DatePred>
  codDate?: InputMaybe<DatePred>
  codEstimated?: InputMaybe<DatePred>
  csEstimatedAwardDate?: InputMaybe<DatePred>
  csProgramApprovedActual?: InputMaybe<DatePred>
  csProgramApprovedDate?: InputMaybe<DatePred>
  csProgramApprovedEstimated?: InputMaybe<DatePred>
  csProgramSubmittedActual?: InputMaybe<DatePred>
  csProgramSubmittedDate?: InputMaybe<DatePred>
  csProgramSubmittedEstimated?: InputMaybe<DatePred>
  estimatedCod?: InputMaybe<DatePred>
  estimatedNtp?: InputMaybe<DatePred>
  id?: InputMaybe<StringPred>
  ixApprovedActual?: InputMaybe<DatePred>
  ixApprovedDate?: InputMaybe<DatePred>
  ixApprovedEstimated?: InputMaybe<DatePred>
  ixSubmittedActual?: InputMaybe<DatePred>
  ixSubmittedDate?: InputMaybe<DatePred>
  ixSubmittedEstimated?: InputMaybe<DatePred>
  leaseSignedActual?: InputMaybe<DatePred>
  leaseSignedDate?: InputMaybe<DatePred>
  leaseSignedEstimated?: InputMaybe<DatePred>
  lumenRevenue?: InputMaybe<FloatPred>
  name?: InputMaybe<StringPred>
  ntpActual?: InputMaybe<DatePred>
  ntpDate?: InputMaybe<DatePred>
  ntpEstimated?: InputMaybe<DatePred>
  orgName?: InputMaybe<StringPred>
  packageRowClosedAt?: InputMaybe<DatePred>
  packageRowIsClosed?: InputMaybe<BoolPred>
  packageRowStatus?: InputMaybe<PackageRowStatusPred>
  preBidMeetingActual?: InputMaybe<DatePred>
  preBidMeetingDate?: InputMaybe<DatePred>
  preBidMeetingEstimated?: InputMaybe<DatePred>
  pvSizeKwAc?: InputMaybe<FloatPred>
  pvSizeKwDc?: InputMaybe<FloatPred>
  rofoSignedActual?: InputMaybe<DatePred>
  rofoSignedDate?: InputMaybe<DatePred>
  rofoSignedEstimated?: InputMaybe<DatePred>
  search?: InputMaybe<SearchPred>
  sitePid?: InputMaybe<StringPred>
  state?: InputMaybe<UsStateMultiPred>
  streetAddress?: InputMaybe<StringPred>
}

export type AwardedProjectTableRow = {
  __typename?: "AwardedProjectTableRow"
  awardedToDeveloperActual?: Maybe<Scalars["Date"]["output"]>
  awardedToDeveloperDate?: Maybe<Scalars["Date"]["output"]>
  awardedToDeveloperEstimated?: Maybe<Scalars["Date"]["output"]>
  bidPackagePid: Scalars["String"]["output"]
  biddingClosedActual?: Maybe<Scalars["Date"]["output"]>
  biddingClosedDate?: Maybe<Scalars["Date"]["output"]>
  biddingClosedEstimated?: Maybe<Scalars["Date"]["output"]>
  biddingOpenedActual?: Maybe<Scalars["Date"]["output"]>
  biddingOpenedDate?: Maybe<Scalars["Date"]["output"]>
  biddingOpenedEstimated?: Maybe<Scalars["Date"]["output"]>
  bidsPresentedActual?: Maybe<Scalars["Date"]["output"]>
  bidsPresentedDate?: Maybe<Scalars["Date"]["output"]>
  bidsPresentedEstimated?: Maybe<Scalars["Date"]["output"]>
  bundlePid: Scalars["String"]["output"]
  city: Scalars["String"]["output"]
  codActual?: Maybe<Scalars["Date"]["output"]>
  codDate?: Maybe<Scalars["Date"]["output"]>
  codEstimated?: Maybe<Scalars["Date"]["output"]>
  csEstimatedAwardDate?: Maybe<Scalars["DateTime"]["output"]>
  csProgramApprovedActual?: Maybe<Scalars["Date"]["output"]>
  csProgramApprovedDate?: Maybe<Scalars["Date"]["output"]>
  csProgramApprovedEstimated?: Maybe<Scalars["Date"]["output"]>
  csProgramSubmittedActual?: Maybe<Scalars["Date"]["output"]>
  csProgramSubmittedDate?: Maybe<Scalars["Date"]["output"]>
  csProgramSubmittedEstimated?: Maybe<Scalars["Date"]["output"]>
  estimatedCod: Scalars["Date"]["output"]
  estimatedNtp: Scalars["Date"]["output"]
  id: Scalars["Int"]["output"]
  ixApprovedActual?: Maybe<Scalars["Date"]["output"]>
  ixApprovedDate?: Maybe<Scalars["Date"]["output"]>
  ixApprovedEstimated?: Maybe<Scalars["Date"]["output"]>
  ixSubmittedActual?: Maybe<Scalars["Date"]["output"]>
  ixSubmittedDate?: Maybe<Scalars["Date"]["output"]>
  ixSubmittedEstimated?: Maybe<Scalars["Date"]["output"]>
  leaseSignedActual?: Maybe<Scalars["Date"]["output"]>
  leaseSignedDate?: Maybe<Scalars["Date"]["output"]>
  leaseSignedEstimated?: Maybe<Scalars["Date"]["output"]>
  lumenRevenue?: Maybe<Scalars["Float"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  ntpActual?: Maybe<Scalars["Date"]["output"]>
  ntpDate?: Maybe<Scalars["Date"]["output"]>
  ntpEstimated?: Maybe<Scalars["Date"]["output"]>
  orgName: Scalars["String"]["output"]
  packageRowCloseCustomReason?: Maybe<Scalars["String"]["output"]>
  packageRowCloseReason?: Maybe<PackageRowCloseReason>
  packageRowClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  packageRowIsClosed: Scalars["Boolean"]["output"]
  packageRowStatus?: Maybe<PackageRowStatus>
  preBidMeetingActual?: Maybe<Scalars["Date"]["output"]>
  preBidMeetingDate?: Maybe<Scalars["Date"]["output"]>
  preBidMeetingEstimated?: Maybe<Scalars["Date"]["output"]>
  pvSizeKwAc?: Maybe<Scalars["Float"]["output"]>
  pvSizeKwDc?: Maybe<Scalars["Float"]["output"]>
  pvTypes: Array<PvType>
  rofoSignedActual?: Maybe<Scalars["Date"]["output"]>
  rofoSignedDate?: Maybe<Scalars["Date"]["output"]>
  rofoSignedEstimated?: Maybe<Scalars["Date"]["output"]>
  sitePid: Scalars["String"]["output"]
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  zipCode: Scalars["String"]["output"]
}

export type AwardedProjectTableSort = {
  attr: AwardedProjectTableAttr
  order: SortOrder
}

export type AwardedProjectTableStats = {
  __typename?: "AwardedProjectTableStats"
  buildingOwners: Array<Scalars["String"]["output"]>
}

export type AwardedProjectTableView = {
  __typename?: "AwardedProjectTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
  stats: AwardedProjectTableStats
}

export type BmConfig = {
  __typename?: "BMConfig"
  annualCostUsd?: Maybe<Scalars["Float"]["output"]>
  annualCostUsdProvider?: Maybe<Provider>
  annualKwh?: Maybe<Scalars["Float"]["output"]>
  annualKwhProvider?: Maybe<Provider>
  annualMaxKw?: Maybe<Scalars["Float"]["output"]>
  annualMaxKwProvider?: Maybe<Provider>
  bauMeter?: Maybe<BauMeter>
  bauTariff?: Maybe<Tariff>
  bauTariffFailure?: Maybe<GuessTariffFailure>
  bauTariffProvider?: Maybe<Provider>
  children: Array<BmConfig>
  createdAt: Scalars["DateTime"]["output"]
  doeReferenceType: BuildingType
  id: Scalars["Int"]["output"]
  intervals: Array<BillingIntervals>
  loadCategory: LoadCategory
  meter: BillingMeter
  meterPid: Scalars["String"]["output"]
  months: Array<BillingMonth>
  opCount: Scalars["Int"]["output"]
  parent?: Maybe<BmConfig>
  pid: Scalars["String"]["output"]
  postBatteryTariff?: Maybe<Tariff>
  postBatteryTariffProvider?: Maybe<Provider>
  postSolarTariff?: Maybe<Tariff>
  postSolarTariffProvider?: Maybe<Provider>
  supplyUtility?: Maybe<ThirdPartySupplier>
  supplyUtilityProvider?: Maybe<Provider>
  utility?: Maybe<Utility>
  utilityProvider?: Maybe<Provider>
}

export type BattAssumptions = {
  __typename?: "BattAssumptions"
  battChemName: Scalars["String"]["output"]
}

export type BatteryConfig = {
  __typename?: "BatteryConfig"
  charge: CleanIntervals
  chargeStrategy: ChargeStrategy
  createdAt: Scalars["DateTime"]["output"]
  discharge: CleanIntervals
  dischargeStrategy: DischargeStrategy
  equipmentCost?: Maybe<Scalars["Float"]["output"]>
  id: Scalars["Int"]["output"]
  laborCost?: Maybe<Scalars["Float"]["output"]>
  meter: PostBatteryMeter
  sizeKw: Scalars["Float"]["output"]
  sizeKwh: Scalars["Float"]["output"]
  vendor: BatteryVendor
}

export type BatteryProduct = {
  __typename?: "BatteryProduct"
  equipmentCost?: Maybe<Scalars["Float"]["output"]>
  laborCost?: Maybe<Scalars["Float"]["output"]>
  sizeKw: Scalars["Float"]["output"]
  sizeKwh: Scalars["Float"]["output"]
  vendor?: Maybe<BatteryVendor>
}

export type BatterySpec = {
  __typename?: "BatterySpec"
  charge: CleanIntervals
  createdAt: Scalars["DateTime"]["output"]
  discharge: CleanIntervals
  document?: Maybe<Document>
  etbMeterName: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  meter: BillingMeter
  notes?: Maybe<Scalars["String"]["output"]>
  sizeKwDc: Scalars["Float"]["output"]
  sizeKwh: Scalars["Float"]["output"]
  soc: CleanIntervals
  system: System
}

export type BatterySpecLite = {
  __typename?: "BatterySpecLite"
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  notes: Scalars["String"]["output"]
  sizeKwDc: Scalars["Float"]["output"]
  sizeKwh: Scalars["Float"]["output"]
  systemLite: SystemLite
}

export type BatterySystem = {
  __typename?: "BatterySystem"
  assumptions: BattAssumptions
  sizeKw: Scalars["Float"]["output"]
  sizeKwh: Scalars["Float"]["output"]
  vendor: BatteryVendor
}

export type BatterySystem2 = {
  __typename?: "BatterySystem2"
  notes?: Maybe<Scalars["String"]["output"]>
  sizeKwDc: Scalars["Float"]["output"]
  sizeKwh: Scalars["Float"]["output"]
}

export enum BatteryVendor {
  Byd = "BYD",
  Socomec = "SOCOMEC",
  SolArk = "SOL_ARK",
  Tesla = "TESLA",
}

export type BauMeter = {
  __typename?: "BauMeter"
  archivedAt?: Maybe<Scalars["DateTime"]["output"]>
  archivedBy?: Maybe<UserRef>
  archivedReason?: Maybe<Scalars["String"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  createdBy?: Maybe<UserRef>
  documentBillingMonths: Array<DocumentBillingMonth>
  formattedBill: FormattedBills
  formattedPostBill: FormattedBills
  hasTruth: Scalars["Boolean"]["output"]
  id: Scalars["Int"]["output"]
  importsKwh: Scalars["Float"]["output"]
  intervals: Zoned
  label: Scalars["String"]["output"]
  loadCategory: LoadCategory
  loadOrigin: LoadOrigin
  meterSource: MeterSource
  /** @deprecated use document_billing_months */
  nameThatTariff: Array<ResultForTariff>
  nameThatTariffDetail?: Maybe<NameThatTariffDetail>
  pid: Scalars["String"]["output"]
  possibleTariffs: Array<Tariff>
  postBatteryTariff?: Maybe<Tariff>
  postBatteryTariffSetBy?: Maybe<UserRef>
  postSolarTariff?: Maybe<Tariff>
  postSolarTariffSetBy?: Maybe<UserRef>
  postTariff: Tariff
  rollup: Array<DailyRollup>
  tariff: Tariff
  tariffSetBy?: Maybe<UserRef>
  tariffUsdPerKwh: Scalars["Float"]["output"]
  tariffsUnderHumanControl: Scalars["Boolean"]["output"]
  testCustomTariff: FormattedBills
  totalCost: Scalars["Float"]["output"]
  underHumanControl: Scalars["Boolean"]["output"]
  userVisibleLabel: Scalars["String"]["output"]
  utility: Utility
}

export type BauMeterNameThatTariffDetailArgs = {
  documentBillingMonthId: Scalars["Int"]["input"]
  tariffId: Scalars["Int"]["input"]
}

export type BauMeterPossibleTariffsArgs = {
  includeCustom?: Scalars["Boolean"]["input"]
  preferred?: Scalars["Boolean"]["input"]
}

export type BauMeterTestCustomTariffArgs = {
  cfg: Scalars["String"]["input"]
  utilityId: Scalars["Int"]["input"]
}

export type BestCommunitySolarSite = {
  __typename?: "BestCommunitySolarSite"
  city?: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  noiCsMax?: Maybe<Scalars["Float"]["output"]>
  pid: Scalars["String"]["output"]
  state?: Maybe<Scalars["String"]["output"]>
  streetAddress?: Maybe<Scalars["String"]["output"]>
  zipCode?: Maybe<Scalars["String"]["output"]>
}

export type BidAwardedPred = {
  value?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type BidPackage = {
  __typename?: "BidPackage"
  bidReview?: Maybe<BidReview>
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  documents: Array<Document>
  financiers: Array<OrgRef>
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  row?: Maybe<BidPackageRow>
  state: BundleState
  totalRows: Scalars["Int"]["output"]
  type: FinProductType
}

export type BidPackageRowArgs = {
  pid: Scalars["String"]["input"]
}

export type BidPackageRow = {
  __typename?: "BidPackageRow"
  closeCustomReason?: Maybe<Scalars["String"]["output"]>
  closeReason?: Maybe<PackageRowCloseReason>
  closedAt?: Maybe<Scalars["DateTime"]["output"]>
  marketplaceStatus?: Maybe<MarketplaceStatus>
  site?: Maybe<RevampSite>
  status?: Maybe<PackageRowStatus>
}

export type BidPackageSitesTable = {
  __typename?: "BidPackageSitesTable"
  rows: Array<BidPackageSitesTableRow>
  view: BidPackageSitesTableView
}

export type BidPackageSitesTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type BidPackageSitesTableViewArgs = {
  filterBy?: InputMaybe<BidPackageSitesTableFilter>
  sortBy?: InputMaybe<Array<BidPackageSitesTableSort>>
}

export enum BidPackageSitesTableAttr {
  AssetManager = "ASSET_MANAGER",
  AwardedBidPvSizeKwAc = "AWARDED_BID_PV_SIZE_KW_AC",
  AwardedBidPvSizeKwDc = "AWARDED_BID_PV_SIZE_KW_DC",
  AwardedBidPvTypes = "AWARDED_BID_PV_TYPES",
  AwardedDeveloper = "AWARDED_DEVELOPER",
  BiddingClosedAt = "BIDDING_CLOSED_AT",
  BiddingOpenAt = "BIDDING_OPEN_AT",
  BidCount = "BID_COUNT",
  BidPackageName = "BID_PACKAGE_NAME",
  BidPackagePid = "BID_PACKAGE_PID",
  BuildingClass = "BUILDING_CLASS",
  BuildingFootprintCount = "BUILDING_FOOTPRINT_COUNT",
  BuildingFootprintSqft = "BUILDING_FOOTPRINT_SQFT",
  BuildingLegalName = "BUILDING_LEGAL_NAME",
  BuildingType = "BUILDING_TYPE",
  CbsaName = "CBSA_NAME",
  City = "CITY",
  ConstructionEmail = "CONSTRUCTION_EMAIL",
  CounselApproval = "COUNSEL_APPROVAL",
  County = "COUNTY",
  CsEstimatedAwardDate = "CS_ESTIMATED_AWARD_DATE",
  CsNoiAvg = "CS_NOI_AVG",
  CsNoiLifetimeUsd = "CS_NOI_LIFETIME_USD",
  CsNoiMax = "CS_NOI_MAX",
  CsNoiMin = "CS_NOI_MIN",
  CsNpv = "CS_NPV",
  CsRoofRentEscalator = "CS_ROOF_RENT_ESCALATOR",
  CsRoofRentY1Usd = "CS_ROOF_RENT_Y1_USD",
  EstimatedCod = "ESTIMATED_COD",
  EstimatedNtp = "ESTIMATED_NTP",
  ExternalLeaseApprovers = "EXTERNAL_LEASE_APPROVERS",
  FinancierCount = "FINANCIER_COUNT",
  FinancingType = "FINANCING_TYPE",
  IsFannieMaeLender = "IS_FANNIE_MAE_LENDER",
  IsFmGlobalInsurer = "IS_FM_GLOBAL_INSURER",
  Latitude = "LATITUDE",
  LeaseApprovers = "LEASE_APPROVERS",
  LeaseLegalOwnerName = "LEASE_LEGAL_OWNER_NAME",
  LeasePropertyLegalDescription = "LEASE_PROPERTY_LEGAL_DESCRIPTION",
  LeaseSignatory = "LEASE_SIGNATORY",
  Longitude = "LONGITUDE",
  Name = "NAME",
  NeedsTenantApproval = "NEEDS_TENANT_APPROVAL",
  NoiLifetimeUsd = "NOI_LIFETIME_USD",
  NumStories = "NUM_STORIES",
  NumUnitsTotal = "NUM_UNITS_TOTAL",
  PackageRowClosedAt = "PACKAGE_ROW_CLOSED_AT",
  PackageRowCloseCustomReason = "PACKAGE_ROW_CLOSE_CUSTOM_REASON",
  PackageRowCloseReason = "PACKAGE_ROW_CLOSE_REASON",
  PackageRowIsClosed = "PACKAGE_ROW_IS_CLOSED",
  PackageRowStatus = "PACKAGE_ROW_STATUS",
  Pid = "PID",
  PpaNoiAvg = "PPA_NOI_AVG",
  PpaNoiLifetimeUsd = "PPA_NOI_LIFETIME_USD",
  PpaNoiMax = "PPA_NOI_MAX",
  PpaNoiMin = "PPA_NOI_MIN",
  PpaRoofRentEscalator = "PPA_ROOF_RENT_ESCALATOR",
  PpaRoofRentY1Usd = "PPA_ROOF_RENT_Y1_USD",
  PropertyFundName = "PROPERTY_FUND_NAME",
  PropertyInsurer = "PROPERTY_INSURER",
  PropertyLenders = "PROPERTY_LENDERS",
  PropertySiteVisitContacts = "PROPERTY_SITE_VISIT_CONTACTS",
  RoofCondition = "ROOF_CONDITION",
  RoofRentEscalator = "ROOF_RENT_ESCALATOR",
  RoofRentY1Usd = "ROOF_RENT_Y1_USD",
  RoofReplacedYr = "ROOF_REPLACED_YR",
  RoofRightsHolder = "ROOF_RIGHTS_HOLDER",
  RoofSqft = "ROOF_SQFT",
  SalePlannedYear = "SALE_PLANNED_YEAR",
  SalePlans = "SALE_PLANS",
  SignatureBlocks = "SIGNATURE_BLOCKS",
  SiteLabels = "SITE_LABELS",
  SitePid = "SITE_PID",
  Sqft = "SQFT",
  State = "STATE",
  StreetAddress = "STREET_ADDRESS",
  UsableRoofSqft = "USABLE_ROOF_SQFT",
  YearBuilt = "YEAR_BUILT",
  ZipCode = "ZIP_CODE",
}

export type BidPackageSitesTableFilter = {
  assetManager?: InputMaybe<StringPred>
  awardedBidPvSizeKwAc?: InputMaybe<FloatPred>
  awardedBidPvSizeKwDc?: InputMaybe<FloatPred>
  awardedDeveloper?: InputMaybe<StringPred>
  bidPackageName?: InputMaybe<StringPred>
  bidPackagePid?: InputMaybe<StringPred>
  buildingClass?: InputMaybe<StringPred>
  buildingFootprintCount?: InputMaybe<IntPred>
  buildingFootprintSqft?: InputMaybe<FloatPred>
  buildingLegalName?: InputMaybe<StringPred>
  buildingType?: InputMaybe<BuildingTypePred>
  cbsaName?: InputMaybe<StringPred>
  city?: InputMaybe<StringPred>
  constructionEmail?: InputMaybe<StringPred>
  counselApproval?: InputMaybe<CounselApprovalPred>
  county?: InputMaybe<StringPred>
  csEstimatedAwardDate?: InputMaybe<DatePred>
  csNoiLifetimeUsd?: InputMaybe<FloatPred>
  csNpv?: InputMaybe<FloatPred>
  csRoofRentEscalator?: InputMaybe<FloatPred>
  csRoofRentY1Usd?: InputMaybe<FloatPred>
  estimatedCod?: InputMaybe<DatePred>
  estimatedNtp?: InputMaybe<DatePred>
  financingType?: InputMaybe<FinProductTypePred>
  id?: InputMaybe<StringPred>
  isFannieMaeLender?: InputMaybe<BoolPred>
  isFmGlobalInsurer?: InputMaybe<BoolPred>
  latitude?: InputMaybe<FloatPred>
  leaseLegalOwnerName?: InputMaybe<StringPred>
  leasePropertyLegalDescription?: InputMaybe<StringPred>
  leaseSignatory?: InputMaybe<StringPred>
  longitude?: InputMaybe<FloatPred>
  name?: InputMaybe<StringPred>
  needsTenantApproval?: InputMaybe<BoolPred>
  noiLifetimeUsd?: InputMaybe<FloatPred>
  numStories?: InputMaybe<IntPred>
  numUnitsTotal?: InputMaybe<IntPred>
  packageRowIsClosed?: InputMaybe<BoolPred>
  packageRowStatus?: InputMaybe<PackageRowStatusPred>
  pid?: InputMaybe<StringPred>
  ppaNoiLifetimeUsd?: InputMaybe<FloatPred>
  ppaRoofRentEscalator?: InputMaybe<FloatPred>
  ppaRoofRentY1Usd?: InputMaybe<FloatPred>
  propertyFundName?: InputMaybe<StringPred>
  propertyInsurer?: InputMaybe<StringPred>
  propertyLenders?: InputMaybe<StringPred>
  roofRentEscalator?: InputMaybe<FloatPred>
  roofRentY1Usd?: InputMaybe<FloatPred>
  roofReplacedYr?: InputMaybe<FloatPred>
  roofRightsHolder?: InputMaybe<RoofRightsHolderPred>
  roofSqft?: InputMaybe<FloatPred>
  salePlannedYear?: InputMaybe<FloatPred>
  salePlans?: InputMaybe<StringPred>
  siteLabels?: InputMaybe<SiteLabelNamesPred>
  sitePid?: InputMaybe<StringPred>
  sqft?: InputMaybe<FloatPred>
  state?: InputMaybe<UsStateMultiPred>
  streetAddress?: InputMaybe<StringPred>
  usableRoofSqft?: InputMaybe<FloatPred>
  yearBuilt?: InputMaybe<IntPred>
}

export type BidPackageSitesTableRow = {
  __typename?: "BidPackageSitesTableRow"
  assetManager?: Maybe<Scalars["String"]["output"]>
  awardedBidPvSizeKwAc?: Maybe<Scalars["Float"]["output"]>
  awardedBidPvSizeKwDc?: Maybe<Scalars["Float"]["output"]>
  awardedBidPvTypes?: Maybe<Array<PvType>>
  awardedDeveloper?: Maybe<Scalars["String"]["output"]>
  bidCount?: Maybe<Scalars["Float"]["output"]>
  bidPackageName: Scalars["String"]["output"]
  bidPackagePid: Scalars["String"]["output"]
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  buildingClass?: Maybe<Scalars["String"]["output"]>
  buildingFootprintCount?: Maybe<Scalars["Int"]["output"]>
  buildingFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  buildingLegalName?: Maybe<Scalars["String"]["output"]>
  buildingType?: Maybe<BuildingType>
  cbsaName?: Maybe<Scalars["String"]["output"]>
  city: Scalars["String"]["output"]
  constructionEmail?: Maybe<Scalars["String"]["output"]>
  counselApproval?: Maybe<CounselApproval>
  county: Scalars["String"]["output"]
  csEstimatedAwardDate?: Maybe<Scalars["DateTime"]["output"]>
  csNoiAvg?: Maybe<Scalars["Float"]["output"]>
  csNoiLifetimeUsd?: Maybe<Scalars["Float"]["output"]>
  csNoiMax?: Maybe<Scalars["Float"]["output"]>
  csNoiMin?: Maybe<Scalars["Float"]["output"]>
  csNpv?: Maybe<Scalars["Float"]["output"]>
  csRoofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  csRoofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  estimatedCod?: Maybe<Scalars["Date"]["output"]>
  estimatedNtp?: Maybe<Scalars["Date"]["output"]>
  externalLeaseApprovers?: Maybe<Array<Scalars["String"]["output"]>>
  financierCount?: Maybe<Scalars["Float"]["output"]>
  financingType: FinProductType
  id: Scalars["Int"]["output"]
  isFannieMaeLender?: Maybe<Scalars["Boolean"]["output"]>
  isFmGlobalInsurer?: Maybe<Scalars["Boolean"]["output"]>
  latitude: Scalars["Float"]["output"]
  leaseApprovers?: Maybe<Array<Scalars["String"]["output"]>>
  leaseLegalOwnerName?: Maybe<Scalars["String"]["output"]>
  leasePropertyLegalDescription?: Maybe<Scalars["String"]["output"]>
  leaseSignatory?: Maybe<Scalars["String"]["output"]>
  longitude: Scalars["Float"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  needsTenantApproval?: Maybe<Scalars["Boolean"]["output"]>
  noiLifetimeUsd?: Maybe<Scalars["Float"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
  packageRowCloseCustomReason?: Maybe<Scalars["String"]["output"]>
  packageRowCloseReason?: Maybe<PackageRowCloseReason>
  packageRowClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  packageRowIsClosed: Scalars["Boolean"]["output"]
  packageRowStatus?: Maybe<PackageRowStatus>
  pid: Scalars["String"]["output"]
  ppaNoiAvg?: Maybe<Scalars["Float"]["output"]>
  ppaNoiLifetimeUsd?: Maybe<Scalars["Float"]["output"]>
  ppaNoiMax?: Maybe<Scalars["Float"]["output"]>
  ppaNoiMin?: Maybe<Scalars["Float"]["output"]>
  ppaRoofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  ppaRoofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  propertyFundName?: Maybe<Scalars["String"]["output"]>
  propertyInsurer?: Maybe<Scalars["String"]["output"]>
  propertyLenders?: Maybe<Scalars["String"]["output"]>
  propertySiteVisitContacts?: Maybe<Array<Scalars["String"]["output"]>>
  roofCondition?: Maybe<Scalars["String"]["output"]>
  roofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  roofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  roofReplacedYr?: Maybe<Scalars["Int"]["output"]>
  roofRightsHolder?: Maybe<RoofRightsHolder>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  salePlannedYear?: Maybe<Scalars["Int"]["output"]>
  salePlans?: Maybe<Scalars["String"]["output"]>
  signatureBlocks?: Maybe<Array<Scalars["String"]["output"]>>
  siteLabels: Array<SiteLabel>
  sitePid: Scalars["String"]["output"]
  sqft?: Maybe<Scalars["Float"]["output"]>
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  targetUtility?: Maybe<Utility>
  usableRoofSqft?: Maybe<Scalars["Float"]["output"]>
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  zipCode: Scalars["String"]["output"]
}

export type BidPackageSitesTableSort = {
  attr: BidPackageSitesTableAttr
  order: SortOrder
}

export type BidPackageSitesTableStats = {
  __typename?: "BidPackageSitesTableStats"
  awardedFinanciers: Array<Scalars["String"]["output"]>
}

export type BidPackageSitesTableView = {
  __typename?: "BidPackageSitesTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
  stats: BidPackageSitesTableStats
}

export type BidReview = {
  __typename?: "BidReview"
  recommendedBidPids: Array<Scalars["String"]["output"]>
  reports: Array<BidReviewReportStats>
}

export type BidReviewReportStats = {
  __typename?: "BidReviewReportStats"
  avgRoofRentY1Usd: Scalars["Float"]["output"]
  bidders: Scalars["Int"]["output"]
  isCustom: Scalars["Boolean"]["output"]
  properties: Scalars["Int"]["output"]
  report: PackageBidReport
  uniqueBids: Scalars["Int"]["output"]
}

export type BidSpec = {
  __typename?: "BidSpec"
  cs?: Maybe<CsBidSpec>
  optOut?: Maybe<InvestorBidSpecOptOut>
  ppa?: Maybe<PpaBidSpec>
}

export type BidSpecsTable = {
  __typename?: "BidSpecsTable"
  rows: Array<BidSpecsTableRow>
  view: BidSpecsTableView
}

export type BidSpecsTableRowsArgs = {
  keys: Array<Scalars["String"]["input"]>
}

export type BidSpecsTableViewArgs = {
  filterBy?: InputMaybe<BidSpecsTableFilter>
  sortBy?: InputMaybe<Array<BidSpecsTableSort>>
}

export enum BidSpecsTableAttr {
  AssetManager = "ASSET_MANAGER",
  BiddingClosedAt = "BIDDING_CLOSED_AT",
  BiddingOpenAt = "BIDDING_OPEN_AT",
  BidName = "BID_NAME",
  BidPackageName = "BID_PACKAGE_NAME",
  BidPackagePid = "BID_PACKAGE_PID",
  BuildingClass = "BUILDING_CLASS",
  BuildingFootprintCount = "BUILDING_FOOTPRINT_COUNT",
  BuildingFootprintSqft = "BUILDING_FOOTPRINT_SQFT",
  BuildingLegalName = "BUILDING_LEGAL_NAME",
  BuildingType = "BUILDING_TYPE",
  CbsaName = "CBSA_NAME",
  City = "CITY",
  ConstructionEmail = "CONSTRUCTION_EMAIL",
  CounselApproval = "COUNSEL_APPROVAL",
  County = "COUNTY",
  CsRoofRentEscalator = "CS_ROOF_RENT_ESCALATOR",
  CsRoofRentY1Usd = "CS_ROOF_RENT_Y1_USD",
  CsTermYears = "CS_TERM_YEARS",
  ExternalLeaseApprovers = "EXTERNAL_LEASE_APPROVERS",
  FinancingType = "FINANCING_TYPE",
  InterconnectionCostUsdPerWatt = "INTERCONNECTION_COST_USD_PER_WATT",
  IsFannieMaeLender = "IS_FANNIE_MAE_LENDER",
  IsFmGlobalInsurer = "IS_FM_GLOBAL_INSURER",
  ItcPercentageAssumption = "ITC_PERCENTAGE_ASSUMPTION",
  Latitude = "LATITUDE",
  LeaseApprovers = "LEASE_APPROVERS",
  LeaseLegalOwnerName = "LEASE_LEGAL_OWNER_NAME",
  LeasePropertyLegalDescription = "LEASE_PROPERTY_LEGAL_DESCRIPTION",
  LeaseSignatory = "LEASE_SIGNATORY",
  Longitude = "LONGITUDE",
  Name = "NAME",
  NeedsTenantApproval = "NEEDS_TENANT_APPROVAL",
  NumStories = "NUM_STORIES",
  NumUnitsTotal = "NUM_UNITS_TOTAL",
  PackageRowClosedAt = "PACKAGE_ROW_CLOSED_AT",
  PackageRowCloseCustomReason = "PACKAGE_ROW_CLOSE_CUSTOM_REASON",
  PackageRowCloseReason = "PACKAGE_ROW_CLOSE_REASON",
  PackageRowIsClosed = "PACKAGE_ROW_IS_CLOSED",
  PackageRowStatus = "PACKAGE_ROW_STATUS",
  PpaPriceEscalator = "PPA_PRICE_ESCALATOR",
  PpaPriceY1Usd = "PPA_PRICE_Y1_USD",
  PpaRoofRentEscalator = "PPA_ROOF_RENT_ESCALATOR",
  PpaRoofRentY1Usd = "PPA_ROOF_RENT_Y1_USD",
  PpaTermYears = "PPA_TERM_YEARS",
  PropertyFundName = "PROPERTY_FUND_NAME",
  PropertyInsurer = "PROPERTY_INSURER",
  PropertyLenders = "PROPERTY_LENDERS",
  PropertySiteVisitContacts = "PROPERTY_SITE_VISIT_CONTACTS",
  RecOwner = "REC_OWNER",
  RoofCondition = "ROOF_CONDITION",
  RoofReplacedYr = "ROOF_REPLACED_YR",
  RoofRightsHolder = "ROOF_RIGHTS_HOLDER",
  RoofSqft = "ROOF_SQFT",
  SalePlannedYear = "SALE_PLANNED_YEAR",
  SalePlans = "SALE_PLANS",
  SignatureBlocks = "SIGNATURE_BLOCKS",
  SiteLabels = "SITE_LABELS",
  SitePid = "SITE_PID",
  Sqft = "SQFT",
  State = "STATE",
  StreetAddress = "STREET_ADDRESS",
  Type = "TYPE",
  UsableRoofSqft = "USABLE_ROOF_SQFT",
  YearBuilt = "YEAR_BUILT",
  ZipCode = "ZIP_CODE",
}

export type BidSpecsTableFilter = {
  assetManager?: InputMaybe<StringPred>
  bidName?: InputMaybe<StringPred>
  bidPackageName?: InputMaybe<StringPred>
  bidPackagePid?: InputMaybe<StringPred>
  buildingClass?: InputMaybe<StringPred>
  buildingFootprintCount?: InputMaybe<IntPred>
  buildingFootprintSqft?: InputMaybe<FloatPred>
  buildingLegalName?: InputMaybe<StringPred>
  buildingType?: InputMaybe<BuildingTypePred>
  cbsaName?: InputMaybe<StringPred>
  city?: InputMaybe<StringPred>
  constructionEmail?: InputMaybe<StringPred>
  counselApproval?: InputMaybe<CounselApprovalPred>
  county?: InputMaybe<StringPred>
  csRoofRentEscalator?: InputMaybe<FloatPred>
  csRoofRentY1Usd?: InputMaybe<FloatPred>
  csTermYears?: InputMaybe<FloatPred>
  financingType?: InputMaybe<FinProductTypePred>
  interconnectionCostUsdPerWatt?: InputMaybe<FloatPred>
  isFannieMaeLender?: InputMaybe<BoolPred>
  isFmGlobalInsurer?: InputMaybe<BoolPred>
  itcPercentageAssumption?: InputMaybe<FloatPred>
  latitude?: InputMaybe<FloatPred>
  leaseLegalOwnerName?: InputMaybe<StringPred>
  leasePropertyLegalDescription?: InputMaybe<StringPred>
  leaseSignatory?: InputMaybe<StringPred>
  longitude?: InputMaybe<FloatPred>
  name?: InputMaybe<StringPred>
  needsTenantApproval?: InputMaybe<BoolPred>
  numStories?: InputMaybe<IntPred>
  numUnitsTotal?: InputMaybe<IntPred>
  packageRowIsClosed?: InputMaybe<BoolPred>
  packageRowStatus?: InputMaybe<PackageRowStatusPred>
  pid?: InputMaybe<StringPred>
  ppaPriceEscalator?: InputMaybe<FloatPred>
  ppaPriceY1Usd?: InputMaybe<FloatPred>
  ppaRoofRentEscalator?: InputMaybe<FloatPred>
  ppaRoofRentY1Usd?: InputMaybe<FloatPred>
  ppaTermYears?: InputMaybe<FloatPred>
  propertyFundName?: InputMaybe<StringPred>
  propertyInsurer?: InputMaybe<StringPred>
  propertyLenders?: InputMaybe<StringPred>
  recOwner?: InputMaybe<RecOwnerPred>
  roofReplacedYr?: InputMaybe<FloatPred>
  roofRightsHolder?: InputMaybe<RoofRightsHolderPred>
  roofSqft?: InputMaybe<FloatPred>
  salePlannedYear?: InputMaybe<FloatPred>
  salePlans?: InputMaybe<StringPred>
  siteLabels?: InputMaybe<SiteLabelNamesPred>
  sitePid?: InputMaybe<StringPred>
  sqft?: InputMaybe<FloatPred>
  state?: InputMaybe<UsStateMultiPred>
  streetAddress?: InputMaybe<StringPred>
  type?: InputMaybe<FinProductTypePred>
  usableRoofSqft?: InputMaybe<FloatPred>
  yearBuilt?: InputMaybe<IntPred>
}

export type BidSpecsTableRow = {
  __typename?: "BidSpecsTableRow"
  assetManager?: Maybe<Scalars["String"]["output"]>
  bidName?: Maybe<Scalars["String"]["output"]>
  bidPackageName: Scalars["String"]["output"]
  bidPackagePid: Scalars["String"]["output"]
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  buildingClass?: Maybe<Scalars["String"]["output"]>
  buildingFootprintCount?: Maybe<Scalars["Int"]["output"]>
  buildingFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  buildingLegalName?: Maybe<Scalars["String"]["output"]>
  buildingType?: Maybe<BuildingType>
  cbsaName?: Maybe<Scalars["String"]["output"]>
  city: Scalars["String"]["output"]
  constructionEmail?: Maybe<Scalars["String"]["output"]>
  counselApproval?: Maybe<CounselApproval>
  county: Scalars["String"]["output"]
  csRoofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  csRoofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  csSystem?: Maybe<SystemLite>
  csTermYears?: Maybe<Scalars["Int"]["output"]>
  externalLeaseApprovers?: Maybe<Array<Scalars["String"]["output"]>>
  financingType: FinProductType
  interconnectionCostUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  isFannieMaeLender?: Maybe<Scalars["Boolean"]["output"]>
  isFmGlobalInsurer?: Maybe<Scalars["Boolean"]["output"]>
  itcPercentageAssumption?: Maybe<Scalars["Float"]["output"]>
  latitude: Scalars["Float"]["output"]
  leaseApprovers?: Maybe<Array<Scalars["String"]["output"]>>
  leaseLegalOwnerName?: Maybe<Scalars["String"]["output"]>
  leasePropertyLegalDescription?: Maybe<Scalars["String"]["output"]>
  leaseSignatory?: Maybe<Scalars["String"]["output"]>
  longitude: Scalars["Float"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  needsTenantApproval?: Maybe<Scalars["Boolean"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
  packageRowCloseCustomReason?: Maybe<Scalars["String"]["output"]>
  packageRowCloseReason?: Maybe<PackageRowCloseReason>
  packageRowClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  packageRowIsClosed: Scalars["Boolean"]["output"]
  packageRowStatus?: Maybe<PackageRowStatus>
  pid: Scalars["String"]["output"]
  ppaPriceEscalator?: Maybe<Scalars["Float"]["output"]>
  ppaPriceY1Usd?: Maybe<Scalars["Float"]["output"]>
  ppaRoofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  ppaRoofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  ppaSystem?: Maybe<System>
  ppaTermYears?: Maybe<Scalars["Int"]["output"]>
  propertyFundName?: Maybe<Scalars["String"]["output"]>
  propertyInsurer?: Maybe<Scalars["String"]["output"]>
  propertyLenders?: Maybe<Scalars["String"]["output"]>
  propertySiteVisitContacts?: Maybe<Array<Scalars["String"]["output"]>>
  recOwner?: Maybe<RecOwner>
  roofCondition?: Maybe<Scalars["String"]["output"]>
  roofReplacedYr?: Maybe<Scalars["Int"]["output"]>
  roofRightsHolder?: Maybe<RoofRightsHolder>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  salePlannedYear?: Maybe<Scalars["Int"]["output"]>
  salePlans?: Maybe<Scalars["String"]["output"]>
  signatureBlocks?: Maybe<Array<Scalars["String"]["output"]>>
  siteLabels: Array<SiteLabel>
  sitePid: Scalars["String"]["output"]
  sqft?: Maybe<Scalars["Float"]["output"]>
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  targetUtility?: Maybe<Utility>
  type: FinProductType
  usableRoofSqft?: Maybe<Scalars["Float"]["output"]>
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  zipCode: Scalars["String"]["output"]
}

export type BidSpecsTableSort = {
  attr: BidSpecsTableAttr
  order: SortOrder
}

export type BidSpecsTableView = {
  __typename?: "BidSpecsTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["String"]["output"]>
}

export type BillGroup = {
  __typename?: "BillGroup"
  group: Scalars["String"]["output"]
  items: Array<GroupedLineItem>
}

export type BillMonth = {
  __typename?: "BillMonth"
  end?: Maybe<Scalars["DateTime"]["output"]>
  lineItems: Array<LineItemCharge>
  peakKw?: Maybe<Scalars["Float"]["output"]>
  start: Scalars["DateTime"]["output"]
  totalCostUsd: Scalars["Float"]["output"]
  totalKwh: Scalars["Float"]["output"]
}

export type BillSection = {
  __typename?: "BillSection"
  costs: Array<Maybe<CostItemTaxItem>>
  name: Scalars["String"]["output"]
  rates: Array<DecodedRate>
}

export type BillSuggestion = {
  __typename?: "BillSuggestion"
  cleanSuggestion: Bill_
  conversation: Conversation
  createdAt: Scalars["DateTime"]["output"]
  document: Document
  id: Scalars["Int"]["output"]
  suggestion: Bill_
}

export enum BillType {
  Combined = "COMBINED",
  Delivery = "DELIVERY",
  Supply = "SUPPLY",
}

export type Bill_ = {
  __typename?: "Bill_"
  billingAccountNumber?: Maybe<Scalars["String"]["output"]>
  billingAddress?: Maybe<Scalars["String"]["output"]>
  billingPeriodEnd: Scalars["String"]["output"]
  billingPeriodStart: Scalars["String"]["output"]
  customerName?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  meters: Array<Meter_>
  serviceIdentifier?: Maybe<Scalars["String"]["output"]>
  utilityId?: Maybe<Scalars["Int"]["output"]>
  utilityName: Scalars["String"]["output"]
}

export type BillingIntervalView = {
  __typename?: "BillingIntervalView"
  createdBy?: Maybe<UserRef>
  document: Document
  end?: Maybe<Scalars["Date"]["output"]>
  id: Scalars["Int"]["output"]
  numbers?: Maybe<Array<Scalars["Float"]["output"]>>
  start?: Maybe<Scalars["Date"]["output"]>
  timeZone: Scalars["String"]["output"]
  timestamps?: Maybe<Array<Scalars["DateTime"]["output"]>>
  units: Units
}

export type BillingIntervals = {
  __typename?: "BillingIntervals"
  configs: Array<BmConfig>
  createdAt: Scalars["DateTime"]["output"]
  createdBy?: Maybe<UserRef>
  document: Document
  errorClass?: Maybe<Scalars["String"]["output"]>
  errorMessage?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  numbersColumn: Scalars["Int"]["output"]
  timeZone: Scalars["String"]["output"]
  timestampColumn: Scalars["Int"]["output"]
  trashedAt?: Maybe<Scalars["DateTime"]["output"]>
  trashedBy?: Maybe<UserRef>
  units: Units
}

export type BillingMeter = {
  __typename?: "BillingMeter"
  archivedAt?: Maybe<Scalars["DateTime"]["output"]>
  archivedBy?: Maybe<UserRef>
  archivedReason?: Maybe<Scalars["String"]["output"]>
  bauMeterPid?: Maybe<Scalars["String"]["output"]>
  config: BmConfig
  configs: Array<BmConfig>
  createdAt: Scalars["DateTime"]["output"]
  createdBy?: Maybe<UserRef>
  disabledAt?: Maybe<Scalars["DateTime"]["output"]>
  disabledBy?: Maybe<UserRef>
  disabledReason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  label: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  site: SiteRef
  supplyUtilityMeterId?: Maybe<Scalars["String"]["output"]>
  utilityMeterId?: Maybe<Scalars["String"]["output"]>
  view: BillingMeterView
}

export type BillingMeterView = {
  __typename?: "BillingMeterView"
  calc2: ProjectedE2Error
  doeReferenceType: BuildingType
  fullYear8760?: Maybe<Zoned8760>
  intervals: Array<BillingIntervalView>
  isArchived: Scalars["Boolean"]["output"]
  isDisabled: Scalars["Boolean"]["output"]
  loadCategory: LoadCategory
  months: Array<BillingMonthView>
  name: Scalars["String"]["output"]
  numBills: Scalars["Int"]["output"]
  numIntervals: Scalars["Int"]["output"]
  peakAnnualKw?: Maybe<FancyFloat>
  supplyUtilityMeterId?: Maybe<Scalars["String"]["output"]>
  tariff?: Maybe<Tariff>
  tenantDetails?: Maybe<TenantDetails>
  totalAnnualKwh?: Maybe<FancyFloat>
  utility?: Maybe<UtilityRef>
  utilityMeterId?: Maybe<Scalars["String"]["output"]>
  weekdayRollup?: Maybe<Array<Scalars["Float"]["output"]>>
  weekendRollup?: Maybe<Array<Scalars["Float"]["output"]>>
  weeklyRollup?: Maybe<Array<Scalars["Float"]["output"]>>
}

export type BillingMonth = {
  __typename?: "BillingMonth"
  configs: Array<BmConfig>
  createdAt: Scalars["DateTime"]["output"]
  deliveryProvider?: Maybe<Provider>
  end: Scalars["Date"]["output"]
  id: Scalars["Int"]["output"]
  peakKw?: Maybe<Scalars["Float"]["output"]>
  provider?: Maybe<Provider>
  start: Scalars["Date"]["output"]
  supplyCostUsd?: Maybe<Scalars["Float"]["output"]>
  supplyProvider?: Maybe<Provider>
  totalCostUsd?: Maybe<Scalars["Float"]["output"]>
  totalKwh: Scalars["Float"]["output"]
  transmissionCostUsd?: Maybe<Scalars["Float"]["output"]>
}

export type BillingMonthView = {
  __typename?: "BillingMonthView"
  end: Scalars["Date"]["output"]
  id?: Maybe<Scalars["Int"]["output"]>
  peakKw?: Maybe<FancyFloat>
  provider?: Maybe<Provider>
  start: Scalars["Date"]["output"]
  supplyCostUsd?: Maybe<FancyFloat>
  supplyProvider?: Maybe<Provider>
  totalCostUsd?: Maybe<FancyFloat>
  transmissionCostUsd?: Maybe<FancyFloat>
  usageKwh: FancyFloat
}

export type BoolPred = {
  value: Scalars["Boolean"]["input"]
}

export type BoxplotStats = {
  __typename?: "BoxplotStats"
  average: Scalars["Float"]["output"]
  max: Scalars["Float"]["output"]
  median: Scalars["Float"]["output"]
  min: Scalars["Float"]["output"]
  q1: Scalars["Float"]["output"]
  q3: Scalars["Float"]["output"]
}

export type BuildingData = {
  __typename?: "BuildingData"
  affordableType?: Maybe<Scalars["String"]["output"]>
  avgSqft1Bd?: Maybe<Scalars["Int"]["output"]>
  avgSqft2Bd?: Maybe<Scalars["Int"]["output"]>
  avgSqft3Bd?: Maybe<Scalars["Int"]["output"]>
  avgSqft4Bd?: Maybe<Scalars["Int"]["output"]>
  avgSqftStudio?: Maybe<Scalars["Int"]["output"]>
  buildingClass?: Maybe<Scalars["String"]["output"]>
  buildingFootprintGeojson?: Maybe<Scalars["JSON"]["output"]>
  buildingOpex?: Maybe<Scalars["String"]["output"]>
  buildingType?: Maybe<BuildingType>
  capRate?: Maybe<Scalars["Float"]["output"]>
  changelog: BuildingDataChangelog
  city: Scalars["String"]["output"]
  contactAddress?: Maybe<Scalars["String"]["output"]>
  contactCity?: Maybe<Scalars["String"]["output"]>
  contactPhone?: Maybe<Scalars["String"]["output"]>
  contactState?: Maybe<Scalars["String"]["output"]>
  contactZipCode?: Maybe<Scalars["String"]["output"]>
  costarPropertyType: Scalars["String"]["output"]
  costarSecondaryType?: Maybe<Scalars["String"]["output"]>
  county: Scalars["String"]["output"]
  createdBy?: Maybe<UserRef>
  dateCreated?: Maybe<Scalars["DateTime"]["output"]>
  electricPowerRating?: Maybe<Scalars["String"]["output"]>
  electricUtility?: Maybe<Scalars["String"]["output"]>
  energyStar?: Maybe<Scalars["String"]["output"]>
  fullAddress: Scalars["String"]["output"]
  gasUtility?: Maybe<Scalars["String"]["output"]>
  hasPool?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["Int"]["output"]
  lastSalePrice?: Maybe<Scalars["Int"]["output"]>
  latitude: Scalars["Float"]["output"]
  leedCertified?: Maybe<Scalars["String"]["output"]>
  longitude: Scalars["Float"]["output"]
  numBathrooms?: Maybe<Scalars["Float"]["output"]>
  numBedrooms?: Maybe<Scalars["Int"]["output"]>
  numElevators?: Maybe<Scalars["Int"]["output"]>
  numParkingSpaces?: Maybe<Scalars["Int"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  numUnits?: Maybe<Scalars["Int"]["output"]>
  numUnits1Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits2Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits3Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits4Bd?: Maybe<Scalars["Int"]["output"]>
  numUnitsStudio?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
  numVacantUnits1Bd?: Maybe<Scalars["Int"]["output"]>
  numVacantUnits2Bd?: Maybe<Scalars["Int"]["output"]>
  numVacantUnits3Bd?: Maybe<Scalars["Int"]["output"]>
  numVacantUnits4Bd?: Maybe<Scalars["Int"]["output"]>
  numVacantUnitsStudio?: Maybe<Scalars["Int"]["output"]>
  occupancyRate?: Maybe<Scalars["Float"]["output"]>
  ownerFirstName?: Maybe<Scalars["String"]["output"]>
  ownerLastName?: Maybe<Scalars["String"]["output"]>
  ownerName?: Maybe<Scalars["String"]["output"]>
  parcelNumberMax?: Maybe<Scalars["String"]["output"]>
  parcelNumberMin?: Maybe<Scalars["String"]["output"]>
  parentCompany?: Maybe<Scalars["String"]["output"]>
  propertyName?: Maybe<Scalars["String"]["output"]>
  rentType?: Maybe<Scalars["String"]["output"]>
  reonomyAssetType?: Maybe<Scalars["String"]["output"]>
  reonomyPropertyId?: Maybe<Scalars["String"]["output"]>
  reportedContactName?: Maybe<Scalars["String"]["output"]>
  reportedOwnerAddress?: Maybe<Scalars["String"]["output"]>
  reportedOwnerCity?: Maybe<Scalars["String"]["output"]>
  reportedOwnerName?: Maybe<Scalars["String"]["output"]>
  reportedOwnerPhone?: Maybe<Scalars["String"]["output"]>
  reportedOwnerState?: Maybe<Scalars["String"]["output"]>
  reportedOwnerZipCode?: Maybe<Scalars["String"]["output"]>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  sites: Array<SiteRef>
  source: Scalars["String"]["output"]
  sourceId?: Maybe<Scalars["String"]["output"]>
  sqft?: Maybe<Scalars["Int"]["output"]>
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  taxIdPrintFormat?: Maybe<Scalars["String"]["output"]>
  tenancy?: Maybe<Scalars["String"]["output"]>
  totalBuildings?: Maybe<Scalars["Int"]["output"]>
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  yearRenovated?: Maybe<Scalars["Int"]["output"]>
  zipCode: Scalars["String"]["output"]
  zoning?: Maybe<Scalars["String"]["output"]>
}

export type BuildingDataChangelogArgs = {
  fields: Array<BuildingDataChangelogColumn>
}

export type BuildingDataAmendments = {
  __typename?: "BuildingDataAmendments"
  assetManager?: Maybe<Scalars["String"]["output"]>
  buildingType?: Maybe<BuildingType>
  customerId?: Maybe<Scalars["String"]["output"]>
  latitude?: Maybe<Scalars["Float"]["output"]>
  longitude?: Maybe<Scalars["Float"]["output"]>
  mfUnits?: Maybe<CleanMultifamilyUnits>
  name?: Maybe<Scalars["String"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  sqft?: Maybe<Scalars["Float"]["output"]>
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
}

export type BuildingDataChangelog = {
  __typename?: "BuildingDataChangelog"
  all: Array<BuildingDataChangelogColumnBaseWrapper>
}

export enum BuildingDataChangelogColumn {
  AddressSha256 = "addressSha256",
  AffordableType = "affordableType",
  AvgSqft1Bd = "avgSqft1Bd",
  AvgSqft2Bd = "avgSqft2Bd",
  AvgSqft3Bd = "avgSqft3Bd",
  AvgSqft4Bd = "avgSqft4Bd",
  AvgSqftStudio = "avgSqftStudio",
  BuildingClass = "buildingClass",
  BuildingOpex = "buildingOpex",
  CapRate = "capRate",
  City = "city",
  ContactAddress = "contactAddress",
  ContactCity = "contactCity",
  ContactPhone = "contactPhone",
  ContactState = "contactState",
  ContactZipCode = "contactZipCode",
  CostarPropertyType = "costarPropertyType",
  CostarSecondaryType = "costarSecondaryType",
  County = "county",
  CreatedByUserId = "createdByUserId",
  CsvImportRowId = "csvImportRowId",
  DateCreated = "dateCreated",
  DoeReferenceType = "doeReferenceType",
  ElectricPowerRating = "electricPowerRating",
  ElectricUtility = "electricUtility",
  EnergyStar = "energyStar",
  FootprintStr = "footprintStr",
  GasUtility = "gasUtility",
  HasPool = "hasPool",
  Id = "id",
  LastSalePrice = "lastSalePrice",
  Latitude = "latitude",
  LeedCertified = "leedCertified",
  Longitude = "longitude",
  NumBathrooms = "numBathrooms",
  NumBedrooms = "numBedrooms",
  NumElevators = "numElevators",
  NumParkingSpaces = "numParkingSpaces",
  NumStories = "numStories",
  NumUnits1Bd = "numUnits1Bd",
  NumUnits2Bd = "numUnits2Bd",
  NumUnits3Bd = "numUnits3Bd",
  NumUnits4Bd = "numUnits4Bd",
  NumUnitsStudio = "numUnitsStudio",
  NumUnitsTotal = "numUnitsTotal",
  NumVacantUnits1Bd = "numVacantUnits1Bd",
  NumVacantUnits2Bd = "numVacantUnits2Bd",
  NumVacantUnits3Bd = "numVacantUnits3Bd",
  NumVacantUnits4Bd = "numVacantUnits4Bd",
  NumVacantUnitsStudio = "numVacantUnitsStudio",
  OwnerFirstName = "ownerFirstName",
  OwnerLastName = "ownerLastName",
  OwnerName = "ownerName",
  ParcelNumberMax = "parcelNumberMax",
  ParcelNumberMin = "parcelNumberMin",
  ParentCompany = "parentCompany",
  PropertyName = "propertyName",
  RentType = "rentType",
  ReonomyAssetType = "reonomyAssetType",
  ReonomyPropertyId = "reonomyPropertyId",
  ReportedContactName = "reportedContactName",
  ReportedOwnerAddress = "reportedOwnerAddress",
  ReportedOwnerCity = "reportedOwnerCity",
  ReportedOwnerName = "reportedOwnerName",
  ReportedOwnerPhone = "reportedOwnerPhone",
  ReportedOwnerState = "reportedOwnerState",
  ReportedOwnerZipCode = "reportedOwnerZipCode",
  RoofSqft = "roofSqft",
  Source = "source",
  SourceId = "sourceId",
  Sqft = "sqft",
  State = "state",
  StreetAddress = "streetAddress",
  TaxIdPrintFormat = "taxIdPrintFormat",
  Tenancy = "tenancy",
  TotalBuildings = "totalBuildings",
  YearBuilt = "yearBuilt",
  YearRenovated = "yearRenovated",
  ZipCode = "zipCode",
  Zoning = "zoning",
}

export type BuildingDataChangelogColumnBaseWrapper = {
  __typename?: "BuildingDataChangelogColumnBaseWrapper"
  column: BuildingDataChangelogColumn
  obj?: Maybe<Changelog>
}

export type BuildingFootprintFailure = {
  __typename?: "BuildingFootprintFailure"
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  message: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  site: SiteRef
}

export type BuildingFootprintFailureFinmodelFailureGuessTariffFailureLoadEstimateFailureParcelDataFailure =

    | BuildingFootprintFailure
    | FinmodelFailure
    | GuessTariffFailure
    | LoadEstimateFailure
    | ParcelDataFailure

export enum BuildingOccupancyType {
  MultipleThirdPartyTenants = "MULTIPLE_THIRD_PARTY_TENANTS",
  OwnerOccupied = "OWNER_OCCUPIED",
  SingleThirdPartyTenant = "SINGLE_THIRD_PARTY_TENANT",
}

export type BuildingOwnerEconomics = {
  __typename?: "BuildingOwnerEconomics"
  noiAnnual?: Maybe<Scalars["Float"]["output"]>
  noiLifetime?: Maybe<Scalars["Float"]["output"]>
  noiYearOne?: Maybe<Scalars["Float"]["output"]>
}

export enum BuildingSuperType {
  Commercial = "COMMERCIAL",
  Residential = "RESIDENTIAL",
}

export type BuildingSuperTypeCondition = {
  __typename?: "BuildingSuperTypeCondition"
  buildingSuperType: BuildingSuperType
}

export enum BuildingType {
  ColdStorage = "COLD_STORAGE",
  DataCenter = "DATA_CENTER",
  FullServiceRestaurant = "FULL_SERVICE_RESTAURANT",
  Hospital = "HOSPITAL",
  Hotel = "HOTEL",
  Industrial = "INDUSTRIAL",
  Multifamily = "MULTIFAMILY",
  Office = "OFFICE",
  Outpatient = "OUTPATIENT",
  ParkingLot = "PARKING_LOT",
  PrimarySchool = "PRIMARY_SCHOOL",
  QuickServiceRestaurant = "QUICK_SERVICE_RESTAURANT",
  RetailStandalone = "RETAIL_STANDALONE",
  RetailStripMall = "RETAIL_STRIP_MALL",
  SecondarySchool = "SECONDARY_SCHOOL",
  SingleFamilyDetached = "SINGLE_FAMILY_DETACHED",
  Supermarket = "SUPERMARKET",
  Warehouse = "WAREHOUSE",
}

export type BuildingTypeMappings = {
  __typename?: "BuildingTypeMappings"
  coldStorage: Array<Scalars["String"]["output"]>
  dataCenter: Array<Scalars["String"]["output"]>
  fullServiceRestaurant: Array<Scalars["String"]["output"]>
  hospital: Array<Scalars["String"]["output"]>
  hotel: Array<Scalars["String"]["output"]>
  industrial: Array<Scalars["String"]["output"]>
  multifamily: Array<Scalars["String"]["output"]>
  office: Array<Scalars["String"]["output"]>
  outpatient: Array<Scalars["String"]["output"]>
  parkingLot: Array<Scalars["String"]["output"]>
  primarySchool: Array<Scalars["String"]["output"]>
  quickServiceRestaurant: Array<Scalars["String"]["output"]>
  retailStandalone: Array<Scalars["String"]["output"]>
  retailStripMall: Array<Scalars["String"]["output"]>
  secondarySchool: Array<Scalars["String"]["output"]>
  singleFamilyDetached: Array<Scalars["String"]["output"]>
  supermarket: Array<Scalars["String"]["output"]>
  warehouse: Array<Scalars["String"]["output"]>
}

export type BuildingTypePred = {
  value: Array<InputMaybe<BuildingType>>
}

export type Bundle2 = {
  __typename?: "Bundle2"
  archivedAt?: Maybe<Scalars["DateTime"]["output"]>
  awardStatus?: Maybe<BundleAwardStatusSummary>
  bidReports?: Maybe<Array<PackageBidReport>>
  bidSubmissionStatus: BundleBidSubmissionSummary
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  documents: Array<Document>
  downloadBundleDocsZipHref: Scalars["String"]["output"]
  downloadBundleDotXlsxHref: Scalars["String"]["output"]
  downloadHelioscopesDotZipHref?: Maybe<Scalars["String"]["output"]>
  financier: BundleOrg
  hasVisibleReports: Scalars["Boolean"]["output"]
  lastViewed?: Maybe<Scalars["DateTime"]["output"]>
  name: Scalars["String"]["output"]
  note?: Maybe<Scalars["String"]["output"]>
  opsOwner?: Maybe<UserRef>
  optOut?: Maybe<InvestorOptOut>
  parentRef?: Maybe<BundleParentRef>
  pid: Scalars["String"]["output"]
  pricingNote?: Maybe<Scalars["String"]["output"]>
  recvr: BundleOrg
  rows: Array<BundleRow2>
  state: BundleState
  totalBids: Scalars["Int"]["output"]
  type: FinProductType
}

export enum BundleAwardStatus {
  Awarded = "AWARDED",
  BiddingStillOpen = "BIDDING_STILL_OPEN",
  NotAwarded = "NOT_AWARDED",
  Pending = "PENDING",
}

export type BundleAwardStatusSummary = {
  __typename?: "BundleAwardStatusSummary"
  awardStatus: BundleAwardStatus
  awardedBidCount?: Maybe<Scalars["Int"]["output"]>
  totalPossibleAwards?: Maybe<Scalars["Int"]["output"]>
}

export enum BundleBidSubmissionStatus {
  InProgress = "IN_PROGRESS",
  NotStarted = "NOT_STARTED",
  OptedOut = "OPTED_OUT",
  Submitted = "SUBMITTED",
}

export type BundleBidSubmissionSummary = {
  __typename?: "BundleBidSubmissionSummary"
  bidStatus: BundleBidSubmissionStatus
  submittedBidCount?: Maybe<Scalars["Int"]["output"]>
  totalRequestedBids?: Maybe<Scalars["Int"]["output"]>
}

export type BundleOrg = {
  __typename?: "BundleOrg"
  logoUrl: Scalars["String"]["output"]
  logomarkUrl?: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  orgSlug: Scalars["String"]["output"]
  orgUsers: Array<OrgUser>
  pid: Scalars["String"]["output"]
  profile?: Maybe<InvestorProfile>
}

export type BundleParent = {
  __typename?: "BundleParent"
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  bundles: Array<Bundle2>
  canAddNewBids: Scalars["Boolean"]["output"]
  canEditBids: Scalars["Boolean"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  customReports: Array<CustomBidReport>
  documents: Array<Document>
  hiddenFromFinancier?: Maybe<Scalars["DateTime"]["output"]>
  hiddenFromRecvr?: Maybe<Scalars["DateTime"]["output"]>
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  note?: Maybe<Scalars["String"]["output"]>
  opsOwner?: Maybe<UserRef>
  pid: Scalars["String"]["output"]
  pricingNote?: Maybe<Scalars["String"]["output"]>
  publicUrl: Scalars["String"]["output"]
  recvr: Org
  rows: Array<BundleParentRow>
  showAllBidsReport: Scalars["Boolean"]["output"]
  state: BundleState
  totalPvSizeKwDc: Scalars["Float"]["output"]
  type: FinProductType
}

export type BundleParentRef = {
  __typename?: "BundleParentRef"
  pid: Scalars["String"]["output"]
}

export type BundleParentRow = {
  __typename?: "BundleParentRow"
  awardedFinancier?: Maybe<Org>
  closeCustomReason?: Maybe<Scalars["String"]["output"]>
  closeReason?: Maybe<PackageRowCloseReason>
  closedAt?: Maybe<Scalars["DateTime"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  hubspotRecordId?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  lumenFeeUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  lumenRevenue?: Maybe<Scalars["Float"]["output"]>
  marketplaceStatus?: Maybe<MarketplaceStatus>
  milestoneSummary: MilestoneSummary
  notes?: Maybe<Scalars["String"]["output"]>
  opsOwner?: Maybe<UserRef>
  parent: BundleParent
  portfolio?: Maybe<PortfolioRef>
  recommendedBid?: Maybe<InvestorBid>
  salesOwner?: Maybe<UserRef>
  scenario?: Maybe<ScenarioRef>
  site: SiteRef
  specs: Array<BidSpec>
  status?: Maybe<PackageRowStatus>
}

export type BundleParentRowError = BundleParentRow | Error

export type BundleRow = {
  __typename?: "BundleRow"
  financing?: Maybe<RevampFinancing>
  helioscope?: Maybe<Helioscope>
  helioscopes: Array<Helioscope>
  id: Scalars["Int"]["output"]
  reason?: Maybe<CloseReason>
  result?: Maybe<Result>
  scenario?: Maybe<RevampScenario>
  site: RevampSite
  state?: Maybe<BundleState>
  systems: Array<BundleSystem>
}

export type BundleRow2 = {
  __typename?: "BundleRow2"
  bids: Array<InvestorBid>
  canAddNewBids: Scalars["Boolean"]["output"]
  customReason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  notes?: Maybe<Scalars["String"]["output"]>
  optOut?: Maybe<InvestorOptOut>
  ppaType?: Maybe<PpaProductType>
  reason?: Maybe<CloseReason>
  site: RevampSite
  specs: Array<BidSpec>
  state?: Maybe<BundleState>
}

export type BundleRowMutations = {
  __typename?: "BundleRowMutations"
  setBidReviewMeetingDate: BundleRow
  setCloseReason?: Maybe<Scalars["Void"]["output"]>
  setCodDate: BundleRow
  setContractSignedDate: BundleRow
  setNtpDate: BundleRow
  setPreBidMeetingDate: BundleRow
}

export type BundleRowMutationsSetBidReviewMeetingDateArgs = {
  bidReviewMeetingDate?: InputMaybe<Scalars["Date"]["input"]>
  id: Scalars["Int"]["input"]
}

export type BundleRowMutationsSetCloseReasonArgs = {
  bundleRowId: Scalars["Int"]["input"]
  customReason?: InputMaybe<Scalars["String"]["input"]>
  reason?: InputMaybe<CloseReason>
}

export type BundleRowMutationsSetCodDateArgs = {
  codDate?: InputMaybe<Scalars["Date"]["input"]>
  id: Scalars["Int"]["input"]
}

export type BundleRowMutationsSetContractSignedDateArgs = {
  contractSignedDate?: InputMaybe<Scalars["Date"]["input"]>
  id: Scalars["Int"]["input"]
}

export type BundleRowMutationsSetNtpDateArgs = {
  id: Scalars["Int"]["input"]
  ntpDate?: InputMaybe<Scalars["Date"]["input"]>
}

export type BundleRowMutationsSetPreBidMeetingDateArgs = {
  id: Scalars["Int"]["input"]
  preBidMeetingDate?: InputMaybe<Scalars["Date"]["input"]>
}

export enum BundleState {
  Closed = "CLOSED",
  Open = "OPEN",
  Preview = "PREVIEW",
}

export type BundleStatePred = {
  value?: InputMaybe<BundleState>
}

export type BundleSystem = {
  __typename?: "BundleSystem"
  battery: Array<BatterySystem2>
  pv: Array<PvSystem2>
  totalPvKw: Scalars["Float"]["output"]
}

export type BuyBox = {
  __typename?: "BuyBox"
  btmMinPortfolioSize?: Maybe<Scalars["Float"]["output"]>
  btmMinProjectSize?: Maybe<Scalars["Float"]["output"]>
  btmSeekingProjects?: Maybe<Scalars["Boolean"]["output"]>
  ftmMinPortfolioSize?: Maybe<Scalars["Float"]["output"]>
  ftmMinProjectSize?: Maybe<Scalars["Float"]["output"]>
  ftmSeekingProjects?: Maybe<Scalars["Boolean"]["output"]>
  state?: Maybe<UsState>
  utilityProgramNotes?: Maybe<Scalars["String"]["output"]>
}

export type CsBidSpec = {
  __typename?: "CSBidSpec"
  archivedAt?: Maybe<Scalars["DateTime"]["output"]>
  archivedBy?: Maybe<UserRef>
  buildingOwnerExtraPaymentsUsd?: Maybe<Array<Scalars["Float"]["output"]>>
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  interconnectionCostNonUtilityUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMaxUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMinUsd?: Maybe<Scalars["Float"]["output"]>
  itcPercentageAssumption?: Maybe<Scalars["Float"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  note?: Maybe<Scalars["String"]["output"]>
  pid: Scalars["String"]["output"]
  recOwner?: Maybe<RecOwner>
  roofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  roofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  site: SiteRef
  systemLite?: Maybe<SystemLite>
  termYears?: Maybe<Scalars["Int"]["output"]>
  type: FinProductType
}

export type CsFinProductInput = {
  financierId: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  prices: Array<CsPriceInput>
  status?: InputMaybe<FinProductStatus>
  targetOrgId?: InputMaybe<Scalars["Int"]["input"]>
  targetSiteId?: InputMaybe<Scalars["Int"]["input"]>
  targetSystemId?: InputMaybe<Scalars["Int"]["input"]>
}

export type CsInvestorBid = {
  __typename?: "CSInvestorBid"
  buildingOwnerExtraPaymentsUsd?: Maybe<Array<Scalars["Float"]["output"]>>
  errorClass?: Maybe<Scalars["String"]["output"]>
  errorMessage?: Maybe<Scalars["String"]["output"]>
  estimatedAwardDate?: Maybe<Scalars["DateTime"]["output"]>
  estimatedCod: Scalars["Date"]["output"]
  estimatedNtp: Scalars["Date"]["output"]
  extraPaymentsNotes?: Maybe<Scalars["String"]["output"]>
  financier: OrgRef
  finproduct: AdminFinProduct
  incentivesNotes?: Maybe<Scalars["String"]["output"]>
  interconnectionCostNonUtilityUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMaxUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMinUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionNotes?: Maybe<Scalars["String"]["output"]>
  interconnectionRepriceProcessNotes?: Maybe<Scalars["String"]["output"]>
  itcPercentageAssumption: Scalars["Float"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  otherNotes?: Maybe<Scalars["String"]["output"]>
  pid: Scalars["String"]["output"]
  recOwner: RecOwner
  result?: Maybe<RevampCs>
  roofRentEscalator: Scalars["Float"]["output"]
  roofRentY1Usd: Scalars["Float"]["output"]
  site: RevampSite
  spec?: Maybe<CsBidSpec>
  status?: Maybe<InvestorBidStatus>
  systemLite: SystemLite
  tariffProvision?: Maybe<Scalars["Boolean"]["output"]>
  termYears: Scalars["Int"]["output"]
}

export enum CsLeaseProjectionMethdology {
  Quartiles = "QUARTILES",
}

export type CsLeaseProjections = {
  __typename?: "CSLeaseProjections"
  annualRentLowerRangeUsd: Scalars["Int"]["output"]
  annualRentUpperRangeUsd: Scalars["Int"]["output"]
  methodology: CsLeaseProjectionMethdology
  systemSizeKw: Scalars["Int"]["output"]
}

export type CsPrice = {
  __typename?: "CSPrice"
  escalator: Scalars["Float"]["output"]
  maxPvKw: Scalars["Float"]["output"]
  minPvKw: Scalars["Float"]["output"]
  pvType?: Maybe<PvType>
  state?: Maybe<UsState>
  termYears: Scalars["Float"]["output"]
  usdPerKwPerYear: Scalars["Float"]["output"]
  utility: RevampUtility
}

export type CsPriceInput = {
  escalator: Scalars["Float"]["input"]
  extraPaymentsSeriesUsd?: InputMaybe<Array<Scalars["Float"]["input"]>>
  maxPvKw: Scalars["Float"]["input"]
  minPvKw: Scalars["Float"]["input"]
  pvType?: InputMaybe<PvType>
  state?: InputMaybe<Scalars["String"]["input"]>
  termYears: Scalars["Float"]["input"]
  usdPerKwPerYear: Scalars["Float"]["input"]
  utilityId: Scalars["Int"]["input"]
}

export type CsSiteBidReport = {
  __typename?: "CSSiteBidReport"
  awarded: Scalars["Boolean"]["output"]
  awardedPid?: Maybe<Scalars["String"]["output"]>
  bids: Array<CsInvestorBid>
  itcPercentageAssumption?: Maybe<BoxplotStats>
  noi?: Maybe<BoxplotStats>
  npv?: Maybe<BoxplotStats>
  roofRentEscalator?: Maybe<BoxplotStats>
  site: RevampSite
  systemSize?: Maybe<BoxplotStats>
  totalBids: Scalars["Int"]["output"]
  y1RoofRent?: Maybe<BoxplotStats>
}

export type ChangeLogEntry = {
  __typename?: "ChangeLogEntry"
  changedAt: Scalars["DateTime"]["output"]
  columnType: ChangelogType
  newValue?: Maybe<Scalars["JSON"]["output"]>
  oldValue?: Maybe<Scalars["JSON"]["output"]>
  source?: Maybe<ChangeSourceType>
  sourceId?: Maybe<Scalars["String"]["output"]>
}

export type ChangeSiteLabelColorInput = {
  newLabelColor: LabelColor
  siteLabelPid: Scalars["String"]["input"]
  slug?: InputMaybe<Scalars["String"]["input"]>
}

export type ChangeSiteLabelColorOutput = {
  __typename?: "ChangeSiteLabelColorOutput"
  label: SiteLabel
}

export type ChangeSiteLabelColorResponse = ChangeSiteLabelColorOutput | Error

export enum ChangeSourceType {
  AutoSet = "AUTO_SET",
  ThirdParty = "THIRD_PARTY",
  User = "USER",
}

export type Changelog = {
  __typename?: "Changelog"
  field?: Maybe<Scalars["String"]["output"]>
  newVal?: Maybe<Scalars["JSON"]["output"]>
  oldVal?: Maybe<Scalars["JSON"]["output"]>
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>
  updatedBy?: Maybe<UserRef>
}

export type ChangelogQuery = {
  __typename?: "ChangelogQuery"
  site: Array<AdminChangelog>
}

export type ChangelogQuerySiteArgs = {
  sitePid: Scalars["String"]["input"]
}

export enum ChangelogType {
  Array = "ARRAY",
  Bool = "BOOL",
  Date = "DATE",
  Datetime = "DATETIME",
  Float = "FLOAT",
  Int = "INT",
  Str = "STR",
}

export enum ChargeCategory {
  Demand = "DEMAND",
  Energy = "ENERGY",
  Fixed = "FIXED",
  Nbc = "NBC",
  Tax = "TAX",
}

export enum ChargeClass {
  AfterTax = "AFTER_TAX",
  Contracted = "CONTRACTED",
  Distribution = "DISTRIBUTION",
  NetExcess = "NET_EXCESS",
  NonBypassable = "NON_BYPASSABLE",
  Other = "OTHER",
  Supply = "SUPPLY",
  Tax = "TAX",
  Transmission = "TRANSMISSION",
  UserAdjusted = "USER_ADJUSTED",
}

export enum ChargePeriod {
  Annually = "ANNUALLY",
  Daily = "DAILY",
  Hourly = "HOURLY",
  Monthly = "MONTHLY",
  Quarterly = "QUARTERLY",
}

export enum ChargeStrategy {
  ExportAvoidance = "EXPORT_AVOIDANCE",
  LowestTou = "LOWEST_TOU",
  PeakShaving = "PEAK_SHAVING",
}

export enum ChargeType {
  ConsumptionBased = "CONSUMPTION_BASED",
  DemandBased = "DEMAND_BASED",
  FixedPrice = "FIXED_PRICE",
  Formula = "FORMULA",
  Maximum = "MAXIMUM",
  Minimum = "MINIMUM",
  NetExcessGeneration = "NET_EXCESS_GENERATION",
  Quantity = "QUANTITY",
  Tax = "TAX",
}

export type ChargeTypeCost = {
  __typename?: "ChargeTypeCost"
  chargeType?: Maybe<ChargeType>
  costUsd: Scalars["Float"]["output"]
}

export enum ChargeUnit {
  BillingCycle = "BILLING_CYCLE",
  Kw = "KW",
  Kwh = "KWH",
}

export enum ChargerInstallType {
  NewBuild = "NEW_BUILD",
  Retrofit = "RETROFIT",
}

export enum ChargerLocation {
  Garage = "GARAGE",
  Surface = "SURFACE",
}

export type CleanIntervals = {
  __typename?: "CleanIntervals"
  Year: Scalars["Int"]["output"]
  dateCreated: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  kwh8760: Array<Scalars["Float"]["output"]>
  maxKw: Scalars["Float"]["output"]
  timeZone: Scalars["String"]["output"]
  totalKwh: Scalars["Float"]["output"]
  units: Units
  year: Scalars["Int"]["output"]
}

export type CleanMeter = {
  __typename?: "CleanMeter"
  address?: Maybe<Scalars["String"]["output"]>
  dateCreated: Scalars["DateTime"]["output"]
  dirtyIntervals?: Maybe<DirtyIntervals>
  id: Scalars["Int"]["output"]
  label: Scalars["String"]["output"]
  siteRef: SiteRef
  source: MeterSource
  tariff?: Maybe<Tariff>
  utility?: Maybe<Utility>
}

export type CleanMeterQuery = {
  __typename?: "CleanMeterQuery"
  all: Array<CleanMeter>
  one: CleanMeter
}

export type CleanMeterQueryOneArgs = {
  id: Scalars["String"]["input"]
  source: MeterSource
}

export type CleanMultifamilyUnits = {
  __typename?: "CleanMultifamilyUnits"
  numUnits1Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits2Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits3Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits4Bd?: Maybe<Scalars["Int"]["output"]>
  numUnitsStudio?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
}

export type CleanRowData = {
  __typename?: "CleanRowData"
  assetManager?: Maybe<Scalars["String"]["output"]>
  buildingType?: Maybe<Scalars["String"]["output"]>
  city: Scalars["String"]["output"]
  customerId?: Maybe<Scalars["String"]["output"]>
  latitude?: Maybe<Scalars["Float"]["output"]>
  longitude?: Maybe<Scalars["Float"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  numUnits1Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits2Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits3Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits4Bd?: Maybe<Scalars["Int"]["output"]>
  numUnitsStudio?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
  sqft?: Maybe<Scalars["Float"]["output"]>
  state: UsState
  streetAddress: Scalars["String"]["output"]
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  zipCode?: Maybe<Scalars["String"]["output"]>
}

export type ClearDrawingsInput = {
  sitePid: Scalars["String"]["input"]
}

export enum CloseReason {
  BuildingSold = "BUILDING_SOLD",
  DisqualifiedDueToRoofAge = "DISQUALIFIED_DUE_TO_ROOF_AGE",
  FailedContractNegotiations = "FAILED_CONTRACT_NEGOTIATIONS",
  IneligibleForProgram = "INELIGIBLE_FOR_PROGRAM",
  Lost = "LOST",
  OptOut = "OPT_OUT",
  Other = "OTHER",
  WentOffPlatform = "WENT_OFF_PLATFORM",
  Won = "WON",
}

export type CloseReasonPred = {
  value?: InputMaybe<CloseReason>
}

export enum CoStarPropertyType {
  Flex = "FLEX",
  HealthCare = "HEALTH_CARE",
  Hospitality = "HOSPITALITY",
  Industrial = "INDUSTRIAL",
  Land = "LAND",
  Multifamily = "MULTIFAMILY",
  Office = "OFFICE",
  Retail = "RETAIL",
  ShoppingCenter = "SHOPPING_CENTER",
  SingleFamily = "SINGLE_FAMILY",
  Specialty = "SPECIALTY",
  SportsEntertainment = "SPORTS_ENTERTAINMENT",
  Student = "STUDENT",
}

export enum CoStarSecondaryType {
  Agricultural = "AGRICULTURAL",
  AirplaneHangar = "AIRPLANE_HANGAR",
  Airport = "AIRPORT",
  AmusementPark = "AMUSEMENT_PARK",
  Apartments = "APARTMENTS",
  ApartmentsStudent = "APARTMENTS_STUDENT",
  AssistedLiving = "ASSISTED_LIVING",
  AutoDealership = "AUTO_DEALERSHIP",
  AutoRepair = "AUTO_REPAIR",
  AutoSalvageFacility = "AUTO_SALVAGE_FACILITY",
  Bank = "BANK",
  Bar = "BAR",
  BarNightclub = "BAR_NIGHTCLUB",
  BaseballField = "BASEBALL_FIELD",
  BedAndBreakfast = "BED_AND_BREAKFAST",
  BowlingAlley = "BOWLING_ALLEY",
  CarWash = "CAR_WASH",
  Casino = "CASINO",
  CementGravelPlant = "CEMENT_GRAVEL_PLANT",
  CemeteryMausoleum = "CEMETERY_MAUSOLEUM",
  ChemicalOilRefinery = "CHEMICAL_OIL_REFINERY",
  Commercial = "COMMERCIAL",
  CongregateSeniorHousing = "CONGREGATE_SENIOR_HOUSING",
  ContinuingCareRetirementCommunity = "CONTINUING_CARE_RETIREMENT_COMMUNITY",
  ContractorStorageYard = "CONTRACTOR_STORAGE_YARD",
  ConvenienceStore = "CONVENIENCE_STORE",
  CorrectionalFacility = "CORRECTIONAL_FACILITY",
  DayCareCenter = "DAY_CARE_CENTER",
  DepartmentStore = "DEPARTMENT_STORE",
  Distribution = "DISTRIBUTION",
  Dormitory = "DORMITORY",
  DormitoryStudent = "DORMITORY_STUDENT",
  DriveInMovie = "DRIVE_IN_MOVIE",
  DrugStore = "DRUG_STORE",
  FastFood = "FAST_FOOD",
  Flex = "FLEX",
  FoodProcessing = "FOOD_PROCESSING",
  Freestanding = "FREESTANDING",
  FuneralHome = "FUNERAL_HOME",
  GardenCenter = "GARDEN_CENTER",
  GeneralRetail = "GENERAL_RETAIL",
  GolfCourseDrivingRange = "GOLF_COURSE_DRIVING_RANGE",
  HealthCare = "HEALTH_CARE",
  HealthClub = "HEALTH_CLUB",
  HorseStables = "HORSE_STABLES",
  Hospital = "HOSPITAL",
  Hospitality = "HOSPITALITY",
  Hostel = "HOSTEL",
  Hotel = "HOTEL",
  HotelCasino = "HOTEL_CASINO",
  Industrial = "INDUSTRIAL",
  IndustrialLiveWorkUnit = "INDUSTRIAL_LIVE_WORK_UNIT",
  Land = "LAND",
  Landfill = "LANDFILL",
  LightDistribution = "LIGHT_DISTRIBUTION",
  LightManufacturing = "LIGHT_MANUFACTURING",
  LodgeMeetingHall = "LODGE_MEETING_HALL",
  LoftCreativeSpace = "LOFT_CREATIVE_SPACE",
  Lumberyard = "LUMBERYARD",
  ManufacturedHousingMobileHomePark = "MANUFACTURED_HOUSING_MOBILE_HOME_PARK",
  ManufacturedHousingMobileHomeParkStudent = "MANUFACTURED_HOUSING_MOBILE_HOME_PARK_STUDENT",
  Manufacturing = "MANUFACTURING",
  Marina = "MARINA",
  Medical = "MEDICAL",
  Motel = "MOTEL",
  MovieRadioTvStudio = "MOVIE_RADIO_TV_STUDIO",
  MovieTheatre = "MOVIE_THEATRE",
  Multifamily = "MULTIFAMILY",
  OfficeBuilding = "OFFICE_BUILDING",
  OfficeLiveWorkUnit = "OFFICE_LIVE_WORK_UNIT",
  OfficeResidential = "OFFICE_RESIDENTIAL",
  ParkingGarage = "PARKING_GARAGE",
  ParkingLot = "PARKING_LOT",
  PoliceFireStation = "POLICE_FIRE_STATION",
  PostOffice = "POST_OFFICE",
  PublicLibrary = "PUBLIC_LIBRARY",
  Quickservice = "QUICKSERVICE",
  QuickService = "QUICK_SERVICE",
  RaceTrack = "RACE_TRACK",
  RadioTvTransmissionFacilities = "RADIO_TV_TRANSMISSION_FACILITIES",
  RailroadYard = "RAILROAD_YARD",
  RecyclingCenter = "RECYCLING_CENTER",
  RefrigerationColdStorage = "REFRIGERATION_COLD_STORAGE",
  RehabilitationCenter = "REHABILITATION_CENTER",
  ReligiousFacility = "RELIGIOUS_FACILITY",
  Residential = "RESIDENTIAL",
  ResidentialIncome = "RESIDENTIAL_INCOME",
  Restaurant = "RESTAURANT",
  Retail = "RETAIL",
  RetailBuilding = "RETAIL_BUILDING",
  RD = "R_D",
  Schools = "SCHOOLS",
  SelfStorage = "SELF_STORAGE",
  Service = "SERVICE",
  ServicedApartment = "SERVICED_APARTMENT",
  ServiceStation = "SERVICE_STATION",
  Shelter = "SHELTER",
  Shipyard = "SHIPYARD",
  Showroom = "SHOWROOM",
  SingleRoomOccupancyHotel = "SINGLE_ROOM_OCCUPANCY_HOTEL",
  SkatingRink = "SKATING_RINK",
  SkilledNursingFacility = "SKILLED_NURSING_FACILITY",
  SororityFraternityHouse = "SORORITY_FRATERNITY_HOUSE",
  Specialty = "SPECIALTY",
  SportsEntertainment = "SPORTS_ENTERTAINMENT",
  Storefront = "STOREFRONT",
  StorefrontRetailOffice = "STOREFRONT_RETAIL_OFFICE",
  StorefrontRetailResidential = "STOREFRONT_RETAIL_RESIDENTIAL",
  Supermarket = "SUPERMARKET",
  SwimmingPool = "SWIMMING_POOL",
  TelecomHotelDataHosting = "TELECOM_HOTEL_DATA_HOSTING",
  TheaterConcertHall = "THEATER_CONCERT_HALL",
  TrailerCamperPark = "TRAILER_CAMPER_PARK",
  TruckStop = "TRUCK_STOP",
  TruckTerminal = "TRUCK_TERMINAL",
  Unknown = "UNKNOWN",
  UtilitySubstation = "UTILITY_SUBSTATION",
  VeterinarianKennel = "VETERINARIAN_KENNEL",
  Warehouse = "WAREHOUSE",
  WaterRetentionFacility = "WATER_RETENTION_FACILITY",
  WaterTreatmentFacility = "WATER_TREATMENT_FACILITY",
  WineryVineyard = "WINERY_VINEYARD",
}

export type ColumnMappings = {
  __typename?: "ColumnMappings"
  assetManagerColumnId?: Maybe<Scalars["String"]["output"]>
  buildingTypeColumnId?: Maybe<Scalars["String"]["output"]>
  cityColumnId?: Maybe<Scalars["String"]["output"]>
  customerIdColumnId?: Maybe<Scalars["String"]["output"]>
  latitudeColumnId?: Maybe<Scalars["String"]["output"]>
  longitudeColumnId?: Maybe<Scalars["String"]["output"]>
  nameColumnId?: Maybe<Scalars["String"]["output"]>
  numStoriesColumnId?: Maybe<Scalars["String"]["output"]>
  numUnits1BdColumnId?: Maybe<Scalars["String"]["output"]>
  numUnits2BdColumnId?: Maybe<Scalars["String"]["output"]>
  numUnits3BdColumnId?: Maybe<Scalars["String"]["output"]>
  numUnits4BdColumnId?: Maybe<Scalars["String"]["output"]>
  numUnitsStudioColumnId?: Maybe<Scalars["String"]["output"]>
  numUnitsTotalColumnId?: Maybe<Scalars["String"]["output"]>
  sqftColumnId?: Maybe<Scalars["String"]["output"]>
  stateColumnId?: Maybe<Scalars["String"]["output"]>
  streetAddressColumnId?: Maybe<Scalars["String"]["output"]>
  yearBuiltColumnId?: Maybe<Scalars["String"]["output"]>
  zipCodeColumnId?: Maybe<Scalars["String"]["output"]>
}

export enum ConnectionType {
  Connected = "CONNECTED",
  FullBallast = "FULL_BALLAST",
  Hybrid = "HYBRID",
}

export type ConserviceSearch = {
  __typename?: "ConserviceSearch"
  count: Scalars["Int"]["output"]
  matched: Scalars["Boolean"]["output"]
  name: Scalars["String"]["output"]
}

export type Conversation = {
  __typename?: "Conversation"
  createdAt: Scalars["DateTime"]["output"]
  document?: Maybe<Document>
  id: Scalars["Int"]["output"]
  model: Scalars["String"]["output"]
  transcript?: Maybe<Array<Exchange>>
  user?: Maybe<UserRef>
}

export type CostCalculation = {
  __typename?: "CostCalculation"
  postSolarCosts: CostSummary_
  preSolarCosts: CostSummary_
}

export type CostItem = {
  __typename?: "CostItem"
  chargeCategory?: Maybe<ChargeCategory>
  chargeClass: ChargeClass
  chargeType: ChargeType
  cost: Scalars["Float"]["output"]
  name: Scalars["String"]["output"]
  rate: Scalars["Float"]["output"]
  rateId: Scalars["Int"]["output"]
  rateObj: DecodedRate
  volume: Scalars["Float"]["output"]
}

export type CostItemTaxItem = CostItem | TaxItem

export type CostSummary = {
  __typename?: "CostSummary"
  dateCreated: Scalars["DateTime"]["output"]
  demandCost: Scalars["Float"]["output"]
  endDate: Scalars["DateTime"]["output"]
  energyCost: Scalars["Float"]["output"]
  exportBenefit: Scalars["Float"]["output"]
  fixedCost: Scalars["Float"]["output"]
  id: Scalars["Int"]["output"]
  nbcCost: Scalars["Float"]["output"]
  startDate: Scalars["DateTime"]["output"]
  tariff?: Maybe<TariffRate>
  totalCost: Scalars["Float"]["output"]
  totalEnergyUsage: Scalars["Float"]["output"]
  usingHybridNem3ExportRate: Scalars["Boolean"]["output"]
}

export type CostSummary_ = {
  __typename?: "CostSummary_"
  demandCost: Scalars["Float"]["output"]
  endDate: Scalars["DateTime"]["output"]
  energyCost: Scalars["Float"]["output"]
  exportBenefit: Scalars["Float"]["output"]
  fixedCost: Scalars["Float"]["output"]
  nbcCost: Scalars["Float"]["output"]
  startDate: Scalars["DateTime"]["output"]
  tariff: Tariff
  totalCost: Scalars["Float"]["output"]
  totalEnergyUsage: Scalars["Float"]["output"]
  usingHybridNem3ExportRate: Scalars["Boolean"]["output"]
}

export type CostarSearch = {
  __typename?: "CostarSearch"
  countSitesInPortfolio: Scalars["Int"]["output"]
  countSitesNotInPortfolio: Scalars["Int"]["output"]
  ownerName: Scalars["String"]["output"]
  primaryState: Scalars["String"]["output"]
}

export enum CounselApproval {
  External = "EXTERNAL",
  Internal = "INTERNAL",
  InternalAndExternal = "INTERNAL_AND_EXTERNAL",
  NotRequired = "NOT_REQUIRED",
}

export type CounselApprovalPred = {
  value: Array<InputMaybe<CounselApproval>>
}

export type Count = {
  __typename?: "Count"
  failureCount: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  pendingCount: Scalars["Int"]["output"]
  runningCount: Scalars["Int"]["output"]
  successCount: Scalars["Int"]["output"]
}

export type CreateAndApplySiteLabelInput = {
  labelColor?: LabelColor
  labelName: Scalars["String"]["input"]
  sitePids: Array<Scalars["String"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

export type CreateAndApplySiteLabelOutput = {
  __typename?: "CreateAndApplySiteLabelOutput"
  label: SiteLabel
}

export type CreateAndApplySiteLabelResponse = CreateAndApplySiteLabelOutput | Error

export type CreateDraftInput = {
  bcc?: InputMaybe<Scalars["String"]["input"]>
  body: Scalars["String"]["input"]
  subject: Scalars["String"]["input"]
  to: Scalars["String"]["input"]
}

export type CsvImport = {
  __typename?: "CsvImport"
  buildingTypeMappings: BuildingTypeMappings
  buildingTypes: Array<Scalars["String"]["output"]>
  columnIds: Array<Scalars["String"]["output"]>
  columnMappings: ColumnMappings
  createdAt: Scalars["DateTime"]["output"]
  createdBy: UserRef
  fileName?: Maybe<Scalars["String"]["output"]>
  guessedBuildingTypeMappings: BuildingTypeMappings
  guessedSchema?: Maybe<CsvSchema>
  id: Scalars["Int"]["output"]
  labels: Array<SiteLabel>
  pid: Scalars["String"]["output"]
  portfolio: PortfolioRef
  rawCsvWithPidsHref: Scalars["String"]["output"]
  rowStats: CsvImportStats
  rows: Array<CsvImportRow>
}

export type CsvImportQuery = {
  __typename?: "CsvImportQuery"
  all: Array<CsvImport>
  one: CsvImport
}

export type CsvImportQueryOneArgs = {
  pid: Scalars["String"]["input"]
}

export type CsvImportRow = {
  __typename?: "CsvImportRow"
  amendments?: Maybe<BuildingDataAmendments>
  buildingData?: Maybe<BuildingData>
  clean?: Maybe<CleanRowData>
  dirty: DirtyRowData
  droppedAt?: Maybe<Scalars["DateTime"]["output"]>
  errors: Array<RowValidationError>
  id: Scalars["Int"]["output"]
  rawCells: Array<RawCsvCell>
  site?: Maybe<SiteRef>
  warnings: Array<RowValidationWarning>
}

export type CsvImportStats = {
  __typename?: "CsvImportStats"
  imported: Scalars["Int"]["output"]
  total: Scalars["Int"]["output"]
}

export type CsvSchema = {
  __typename?: "CsvSchema"
  org?: Maybe<Org>
  origin: SchemaOrigin
  pid: Scalars["String"]["output"]
}

export type CurrencyValue = {
  __typename?: "CurrencyValue"
  usd: Scalars["Float"]["output"]
}

export type CustomBidReport = {
  __typename?: "CustomBidReport"
  bids: Array<InvestorBid>
  buildingOwnerNotes?: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  notes: Scalars["String"]["output"]
  parent: BundleParent
  pid: Scalars["String"]["output"]
  visibleToBuildingOwners: Scalars["Boolean"]["output"]
  visibleToDevelopers: Scalars["Boolean"]["output"]
}

export type CustomRate = {
  __typename?: "CustomRate"
  chargeClass: ChargeClass
  chargePeriod: ChargePeriod
  chargeType: ChargeType
  name?: Maybe<Scalars["String"]["output"]>
  price: Scalars["Float"]["output"]
  rateUnit: RateUnit
  transactionType?: Maybe<TransactionType>
}

export type CustomTariff = {
  __typename?: "CustomTariff"
  archivedAt?: Maybe<Scalars["DateTime"]["output"]>
  billCalc: Array<OpsBillCalc>
  code: Scalars["String"]["output"]
  createdBy: UserRef
  customerClass: Scalars["String"]["output"]
  dateCreated: Scalars["DateTime"]["output"]
  hasNetMetering: Scalars["Boolean"]["output"]
  hasTouRates: Scalars["Boolean"]["output"]
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  opBased: Scalars["Boolean"]["output"]
  ops?: Maybe<Array<AddRateSubRateOverrideProperty>>
  parent?: Maybe<Tariff>
  postOpDetails: TariffDetails
  preOpDetails?: Maybe<TariffDetails>
  previewDetails?: Maybe<TariffDetails>
  site: SiteRef
  source?: Maybe<TariffRate>
  startDate: Scalars["DateTime"]["output"]
  utility: Utility
}

export type CustomTariffBillCalcArgs = {
  addRateOps: Array<AddRateInput>
  bauMeterPid: Scalars["String"]["input"]
  propertyOps: Array<OverridePropertyInput>
  subRateOps: Array<SubRateInput>
}

export type CustomTariffPreviewDetailsArgs = {
  addRateOps: Array<AddRateInput>
  propertyOps: Array<OverridePropertyInput>
  subRateOps: Array<SubRateInput>
}

export type DailyRollup = {
  __typename?: "DailyRollup"
  days: Array<Scalars["String"]["output"]>
  numbers: Array<Scalars["Float"]["output"]>
  season: Scalars["String"]["output"]
}

export type DatePred = {
  endDate?: InputMaybe<Scalars["Date"]["input"]>
  isEmpty?: InputMaybe<Scalars["Boolean"]["input"]>
  startDate?: InputMaybe<Scalars["Date"]["input"]>
}

export type DayIntervals = {
  __typename?: "DayIntervals"
  battDischarge: Array<Scalars["Float"]["output"]>
  gridToBldg: Array<Scalars["Float"]["output"]>
  pvToBldg: Array<Scalars["Float"]["output"]>
}

export type DecodedRate = {
  __typename?: "DecodedRate"
  chargeClass: ChargeClass
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
}

export type DeleteLabelInput = {
  labelPid: Scalars["String"]["input"]
}

export type Delta = {
  __typename?: "Delta"
  a: Scalars["Float"]["output"]
  b: Scalars["Float"]["output"]
  diff: Scalars["Float"]["output"]
  pct?: Maybe<Scalars["Float"]["output"]>
}

export type DirtyIntervals = {
  __typename?: "DirtyIntervals"
  intervals: Array<Maybe<Scalars["Float"]["output"]>>
  rollup: Array<DailyRollup>
  timestampStrings: Array<Scalars["String"]["output"]>
  timestamps: Array<Scalars["Float"]["output"]>
  totalKwh: Scalars["Float"]["output"]
  units: Units
}

export type DirtyRowData = {
  __typename?: "DirtyRowData"
  assetManager?: Maybe<Scalars["String"]["output"]>
  buildingType?: Maybe<Scalars["String"]["output"]>
  city?: Maybe<Scalars["String"]["output"]>
  customerId?: Maybe<Scalars["String"]["output"]>
  latitude?: Maybe<Scalars["String"]["output"]>
  longitude?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  numStories?: Maybe<Scalars["String"]["output"]>
  numUnits1Bd?: Maybe<Scalars["String"]["output"]>
  numUnits2Bd?: Maybe<Scalars["String"]["output"]>
  numUnits3Bd?: Maybe<Scalars["String"]["output"]>
  numUnits4Bd?: Maybe<Scalars["String"]["output"]>
  numUnitsStudio?: Maybe<Scalars["String"]["output"]>
  numUnitsTotal?: Maybe<Scalars["String"]["output"]>
  sqft?: Maybe<Scalars["String"]["output"]>
  state?: Maybe<Scalars["String"]["output"]>
  streetAddress?: Maybe<Scalars["String"]["output"]>
  yearBuilt?: Maybe<Scalars["String"]["output"]>
  zipCode?: Maybe<Scalars["String"]["output"]>
}

export enum DischargeStrategy {
  PeakShaving = "PEAK_SHAVING",
  PeakTou = "PEAK_TOU",
}

export type DispatchStrategy = {
  __typename?: "DispatchStrategy"
  charge: ChargeStrategy
  discharge: DischargeStrategy
}

export type Document = {
  __typename?: "Document"
  belongsToBundleParent: Scalars["Boolean"]["output"]
  canDelete: Scalars["Boolean"]["output"]
  contentType: Scalars["String"]["output"]
  csvPeek?: Maybe<Array<Array<Scalars["String"]["output"]>>>
  dateCreated: Scalars["DateTime"]["output"]
  downloadHref: Scalars["String"]["output"]
  fileName: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  ownerEmail: Scalars["String"]["output"]
  ownerName: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  tag?: Maybe<DocumentTag>
  viewHref: Scalars["String"]["output"]
}

export type DocumentBillingMonth = {
  __typename?: "DocumentBillingMonth"
  createdAt: Scalars["DateTime"]["output"]
  document: Document
  end: Scalars["Date"]["output"]
  id: Scalars["Int"]["output"]
  kind: BillType
  lineItems: Array<DocumentBillingMonthLineItem>
  meterId: Scalars["String"]["output"]
  peakKw?: Maybe<Scalars["Float"]["output"]>
  serviceAddress?: Maybe<Scalars["String"]["output"]>
  site: SiteRef
  start: Scalars["Date"]["output"]
  supplyCostUsd?: Maybe<Scalars["Float"]["output"]>
  supplyUtilityName?: Maybe<Scalars["String"]["output"]>
  tariffLabel?: Maybe<Scalars["String"]["output"]>
  totalCostUsd?: Maybe<Scalars["Float"]["output"]>
  totalKwh: Scalars["Float"]["output"]
  transmissionCostUsd?: Maybe<Scalars["Float"]["output"]>
  utilityName: Scalars["String"]["output"]
}

export type DocumentBillingMonthLineItem = {
  __typename?: "DocumentBillingMonthLineItem"
  chargeType?: Maybe<ChargeType>
  createdAt: Scalars["DateTime"]["output"]
  documentBillingMonth?: Maybe<DocumentBillingMonth>
  end: Scalars["Date"]["output"]
  id: Scalars["Int"]["output"]
  meterId?: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  perUnitPriceUsd?: Maybe<Scalars["Float"]["output"]>
  start: Scalars["Date"]["output"]
  totalCostUsd: Scalars["Float"]["output"]
  usage?: Maybe<Scalars["Float"]["output"]>
}

export type DocumentParseRequest = {
  __typename?: "DocumentParseRequest"
  createdAt: Scalars["DateTime"]["output"]
  document: Document
  errorClass?: Maybe<Scalars["String"]["output"]>
  errorMessage?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  results: Array<ParseResult>
  status: ParseStatus
}

export enum DocumentTag {
  CreditReport = "CREDIT_REPORT",
  EpcBuildQuote = "EPC__BUILD_QUOTE",
  EpcContract = "EPC__CONTRACT",
  EpcCosts = "EPC__COSTS",
  EpcDesign = "EPC__DESIGN",
  EpcEmr = "EPC__EMR",
  EpcFinancial = "EPC__FINANCIAL",
  EpcLicense = "EPC__LICENSE",
  EpcOther = "EPC__OTHER",
  EpcProduction = "EPC__PRODUCTION",
  EpcSchedule = "EPC__SCHEDULE",
  ExecutedRoofLease = "EXECUTED_ROOF_LEASE",
  Incentives = "INCENTIVES",
  InterconnectionApplication = "INTERCONNECTION__APPLICATION",
  InterconnectionOther = "INTERCONNECTION__OTHER",
  InterconnectionResult = "INTERCONNECTION__RESULT",
  InvestorBid = "INVESTOR__BID",
  InvestorOther = "INVESTOR__OTHER",
  PermitApplication = "PERMIT__APPLICATION",
  PermitOther = "PERMIT__OTHER",
  PermitResult = "PERMIT__RESULT",
  PpaContract = "PPA__CONTRACT",
  PpaOther = "PPA__OTHER",
  PpaTermSheet = "PPA__TERM_SHEET",
  Production_8760 = "PRODUCTION__8760",
  ProductionHelioscope = "PRODUCTION__HELIOSCOPE",
  ProductionOther = "PRODUCTION__OTHER",
  ProductionWeather = "PRODUCTION__WEATHER",
  SiteBlueprint = "SITE__BLUEPRINT",
  SiteElectricalDiagrams = "SITE__ELECTRICAL_DIAGRAMS",
  SiteEnergy = "SITE__ENERGY",
  SiteOther = "SITE__OTHER",
  SiteRoof = "SITE__ROOF",
  SiteRoofWarranty = "SITE__ROOF_WARRANTY",
  SiteStructuralDrawings = "SITE__STRUCTURAL_DRAWINGS",
  SiteWiringInstructions = "SITE__WIRING_INSTRUCTIONS",
  TermSheet = "TERM_SHEET",
}

export type DraftEmailInput = {
  bcc?: InputMaybe<Scalars["String"]["input"]>
  htmlBody: Scalars["String"]["input"]
  plaintextBody: Scalars["String"]["input"]
  subject: Scalars["String"]["input"]
  to: Scalars["String"]["input"]
}

export type DraftSite = {
  __typename?: "DraftSite"
  avgSqft1Bd?: Maybe<Scalars["Float"]["output"]>
  avgSqft2Bd?: Maybe<Scalars["Float"]["output"]>
  avgSqft3Bd?: Maybe<Scalars["Float"]["output"]>
  avgSqft4Bd?: Maybe<Scalars["Float"]["output"]>
  avgSqftStudio?: Maybe<Scalars["Float"]["output"]>
  canReify: Scalars["Boolean"]["output"]
  capRate?: Maybe<Scalars["Float"]["output"]>
  cbsaName?: Maybe<Scalars["String"]["output"]>
  city?: Maybe<Scalars["String"]["output"]>
  costarPropertyType?: Maybe<Scalars["String"]["output"]>
  county?: Maybe<Scalars["String"]["output"]>
  createdBy: UserRef
  dateCreated: Scalars["DateTime"]["output"]
  dateUpdated?: Maybe<Scalars["DateTime"]["output"]>
  doeReferenceType?: Maybe<BuildingType>
  errors: Array<ValidationError>
  latitude?: Maybe<Scalars["Float"]["output"]>
  longitude?: Maybe<Scalars["Float"]["output"]>
  numParkingSpaces?: Maybe<Scalars["Int"]["output"]>
  numStories?: Maybe<Scalars["Float"]["output"]>
  numUnits1Bd?: Maybe<Scalars["Float"]["output"]>
  numUnits2Bd?: Maybe<Scalars["Float"]["output"]>
  numUnits3Bd?: Maybe<Scalars["Float"]["output"]>
  numUnits4Bd?: Maybe<Scalars["Float"]["output"]>
  numUnitsStudio?: Maybe<Scalars["Float"]["output"]>
  numVacantUnits1Bd?: Maybe<Scalars["Float"]["output"]>
  numVacantUnits2Bd?: Maybe<Scalars["Float"]["output"]>
  numVacantUnits3Bd?: Maybe<Scalars["Float"]["output"]>
  numVacantUnits4Bd?: Maybe<Scalars["Float"]["output"]>
  numVacantUnitsStudio?: Maybe<Scalars["Float"]["output"]>
  ownedBy: UserRef
  pid: Scalars["String"]["output"]
  portfolioPid?: Maybe<Scalars["String"]["output"]>
  propertyName?: Maybe<Scalars["String"]["output"]>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  sqft?: Maybe<Scalars["Float"]["output"]>
  state?: Maybe<UsState>
  streetAddress?: Maybe<Scalars["String"]["output"]>
  timeZone?: Maybe<Scalars["String"]["output"]>
  totalBuildings?: Maybe<Scalars["Int"]["output"]>
  updatedBy?: Maybe<UserRef>
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  zipCode?: Maybe<Scalars["String"]["output"]>
}

export type DraftSiteFilter = {
  portfolioPids?: InputMaybe<Array<Scalars["String"]["input"]>>
}

export type DraftSiteInputs = {
  avgSqft1Bd?: InputMaybe<Scalars["Float"]["input"]>
  avgSqft2Bd?: InputMaybe<Scalars["Float"]["input"]>
  avgSqft3Bd?: InputMaybe<Scalars["Float"]["input"]>
  avgSqft4Bd?: InputMaybe<Scalars["Float"]["input"]>
  avgSqftStudio?: InputMaybe<Scalars["Float"]["input"]>
  capRate?: InputMaybe<Scalars["Float"]["input"]>
  city?: InputMaybe<Scalars["String"]["input"]>
  costarPropertyType?: InputMaybe<Scalars["String"]["input"]>
  doeReferenceType?: InputMaybe<BuildingType>
  latitude?: InputMaybe<Scalars["Float"]["input"]>
  longitude?: InputMaybe<Scalars["Float"]["input"]>
  numParkingSpaces?: InputMaybe<Scalars["Int"]["input"]>
  numStories?: InputMaybe<Scalars["Float"]["input"]>
  numUnits1Bd?: InputMaybe<Scalars["Float"]["input"]>
  numUnits2Bd?: InputMaybe<Scalars["Float"]["input"]>
  numUnits3Bd?: InputMaybe<Scalars["Float"]["input"]>
  numUnits4Bd?: InputMaybe<Scalars["Float"]["input"]>
  numUnitsStudio?: InputMaybe<Scalars["Float"]["input"]>
  numVacantUnits1Bd?: InputMaybe<Scalars["Float"]["input"]>
  numVacantUnits2Bd?: InputMaybe<Scalars["Float"]["input"]>
  numVacantUnits3Bd?: InputMaybe<Scalars["Float"]["input"]>
  numVacantUnits4Bd?: InputMaybe<Scalars["Float"]["input"]>
  numVacantUnitsStudio?: InputMaybe<Scalars["Float"]["input"]>
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
  propertyName?: InputMaybe<Scalars["String"]["input"]>
  roofSqft?: InputMaybe<Scalars["Float"]["input"]>
  sqft?: InputMaybe<Scalars["Float"]["input"]>
  state?: InputMaybe<UsState>
  streetAddress?: InputMaybe<Scalars["String"]["input"]>
  totalBuildings?: InputMaybe<Scalars["Int"]["input"]>
  yearBuilt?: InputMaybe<Scalars["Int"]["input"]>
  zipCode?: InputMaybe<Scalars["String"]["input"]>
}

export type DraftSiteMutations = {
  __typename?: "DraftSiteMutations"
  new: DraftSite
  reify: NewSite
  save: DraftSite
  trash?: Maybe<Scalars["Void"]["output"]>
}

export type DraftSiteMutationsNewArgs = {
  inputs: DraftSiteInputs
}

export type DraftSiteMutationsReifyArgs = {
  draftSitePid: Scalars["String"]["input"]
}

export type DraftSiteMutationsSaveArgs = {
  draftSitePid: Scalars["String"]["input"]
  inputs: DraftSiteInputs
}

export type DraftSiteMutationsTrashArgs = {
  draftSitePids: Array<Scalars["String"]["input"]>
}

export type DuplicatesAttachment = {
  __typename?: "DuplicatesAttachment"
  attachment: Attachment
}

export type E2Error = {
  __typename?: "E2Error"
  msg: Scalars["String"]["output"]
}

export type EiaGridEsc = {
  __typename?: "EIAGridEsc"
  cagrBlended: Scalars["Float"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  eiaId: Scalars["Int"]["output"]
  fromYear: Scalars["Int"]["output"]
  toYear: Scalars["Int"]["output"]
  updatedAt: Scalars["DateTime"]["output"]
}

export type EspmAccount = {
  __typename?: "ESPMAccount"
  createdAt: Scalars["DateTime"]["output"]
  externalAccountId: Scalars["Int"]["output"]
  externalData: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  lastUpdatedAt: Scalars["DateTime"]["output"]
  properties: Array<EspmProperty>
  xml: Scalars["String"]["output"]
}

export type EspmConsumption = {
  __typename?: "ESPMConsumption"
  costUsd?: Maybe<Scalars["Float"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  end: Scalars["DateTime"]["output"]
  espmMeter: EspmMeter
  externalConsumptionId: Scalars["String"]["output"]
  externalData: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  lastUpdatedAt: Scalars["DateTime"]["output"]
  start: Scalars["DateTime"]["output"]
  usageKwh: Scalars["Float"]["output"]
  xml: Scalars["String"]["output"]
}

export type EspmMeter = {
  __typename?: "ESPMMeter"
  billingMeter?: Maybe<BillingMeter>
  createdAt: Scalars["DateTime"]["output"]
  espmConsumptions: Array<EspmConsumption>
  espmProperty: EspmProperty
  externalData: Scalars["String"]["output"]
  externalMeterId: Scalars["Int"]["output"]
  id: Scalars["Int"]["output"]
  lastUpdatedAt: Scalars["DateTime"]["output"]
  meterType: Scalars["String"]["output"]
  unitOfMeasure: Scalars["String"]["output"]
  xml: Scalars["String"]["output"]
}

export type EspmProperty = {
  __typename?: "ESPMProperty"
  accounts: Array<EspmAccount>
  createdAt: Scalars["DateTime"]["output"]
  espmMeters: Array<EspmMeter>
  externalData: Scalars["String"]["output"]
  externalPropertyId: Scalars["Int"]["output"]
  id: Scalars["Int"]["output"]
  lastUpdatedAt: Scalars["DateTime"]["output"]
  site?: Maybe<SiteRef>
  xml: Scalars["String"]["output"]
}

export type EtbCosts = {
  __typename?: "ETBCosts"
  averageLoadFactor: Scalars["Float"]["output"]
  dateCreated: Scalars["DateTime"]["output"]
  demandCostAfter: Scalars["Float"]["output"]
  demandCostBefore: Scalars["Float"]["output"]
  demandCostSavings: Scalars["Float"]["output"]
  energyConsumptionKwhYear1: Scalars["Float"]["output"]
  energyCostAfter: Scalars["Float"]["output"]
  energyCostBefore: Scalars["Float"]["output"]
  energyCostSavings: Scalars["Float"]["output"]
  id: Scalars["Int"]["output"]
  netCost: Scalars["Float"]["output"]
  netEnergyConsumptionKwhYear1: Scalars["Float"]["output"]
  pvDegradationRate: Scalars["Float"]["output"]
  pvGenerationKwhYear1: Scalars["Float"]["output"]
  pvGenerationPercentExported: Scalars["Float"]["output"]
  pvKwhPerKwDc: Scalars["Float"]["output"]
  pvNetCost: Scalars["Float"]["output"]
  pvPowerRatingKwAc: Scalars["Float"]["output"]
  pvPowerRatingKwDc: Scalars["Float"]["output"]
  pvSavingsPerKwh: Scalars["Float"]["output"]
  pvTotalCost: Scalars["Float"]["output"]
  storageCapacityKwh: Scalars["Float"]["output"]
  storageConsumptionKwhYear1: Scalars["Float"]["output"]
  storageDegradationRate: Scalars["Float"]["output"]
  storageDischargeYear1: Scalars["Float"]["output"]
  storageMaxDischargePowerKw: Scalars["Float"]["output"]
  storageNetCost: Scalars["Float"]["output"]
  storageSavingsPerKw: Scalars["Float"]["output"]
  storageSavingsPerKwh: Scalars["Float"]["output"]
  storageTotalCost: Scalars["Float"]["output"]
  storageTwoHourPowerRatingKw: Scalars["Float"]["output"]
  totalCost: Scalars["Float"]["output"]
  totalCostAfter: Scalars["Float"]["output"]
  totalCostBefore: Scalars["Float"]["output"]
  totalCostSavings: Scalars["Float"]["output"]
  totalIncentiveSavings: Scalars["Float"]["output"]
  utilityCostPerKwh: Scalars["Float"]["output"]
}

export type EtbMeter = {
  __typename?: "ETBMeter"
  bauMeter?: Maybe<BauMeter>
  city: Scalars["String"]["output"]
  costs: EtbCosts
  dateCreated: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  pv: Array<EtbpvArray>
  pvType?: Maybe<PvType>
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  tariffAfter?: Maybe<Tariff>
  tariffBefore?: Maybe<Tariff>
  tariffEffectiveDateAfter: Scalars["DateTime"]["output"]
  tariffEffectiveDateBefore: Scalars["DateTime"]["output"]
  tariffFullDescriptionAfter: Scalars["String"]["output"]
  tariffFullDescriptionBefore: Scalars["String"]["output"]
  tariffShortDescriptionAfter: Scalars["String"]["output"]
  tariffShortDescriptionBefore: Scalars["String"]["output"]
  utility?: Maybe<Utility>
  utilityName: Scalars["String"]["output"]
  zipCode: Scalars["String"]["output"]
}

export type EtbMeterMutations = {
  __typename?: "ETBMeterMutations"
  setBauMeter: EtbMeter
  setPvType: EtbMeter
  setTariffAfter: EtbMeter
  setTariffBefore: EtbMeter
  setUtility: EtbMeter
}

export type EtbMeterMutationsSetBauMeterArgs = {
  bauMeterId?: InputMaybe<Scalars["Int"]["input"]>
  id: Scalars["Int"]["input"]
}

export type EtbMeterMutationsSetPvTypeArgs = {
  id: Scalars["Int"]["input"]
  pvType?: InputMaybe<PvType>
}

export type EtbMeterMutationsSetTariffAfterArgs = {
  id: Scalars["Int"]["input"]
  tariffAfterId?: InputMaybe<Scalars["Int"]["input"]>
}

export type EtbMeterMutationsSetTariffBeforeArgs = {
  id: Scalars["Int"]["input"]
  tariffBeforeId?: InputMaybe<Scalars["Int"]["input"]>
}

export type EtbMeterMutationsSetUtilityArgs = {
  id: Scalars["Int"]["input"]
  utilityId?: InputMaybe<Scalars["Int"]["input"]>
}

export type EtbMutations = {
  __typename?: "ETBMutations"
  setProjectName: EtbReport
}

export type EtbMutationsSetProjectNameArgs = {
  name: Scalars["String"]["input"]
}

export type EtbpvArray = {
  __typename?: "ETBPVArray"
  azimuth: Scalars["Float"]["output"]
  cost: Scalars["Float"]["output"]
  dateCreated: Scalars["DateTime"]["output"]
  degradationRate: Scalars["Float"]["output"]
  id: Scalars["Int"]["output"]
  meter: EtbMeter
  powerRatingKwAc: Scalars["Float"]["output"]
  powerRatingKwDc: Scalars["Float"]["output"]
  tilt: Scalars["Float"]["output"]
}

export type EtbReport = {
  __typename?: "ETBReport"
  attachment?: Maybe<Attachment>
  batteryKw?: Maybe<Scalars["Float"]["output"]>
  batteryKwh?: Maybe<Scalars["Float"]["output"]>
  carportPvKw?: Maybe<Scalars["Float"]["output"]>
  combinedCosts?: Maybe<EtbCosts>
  costCalculation?: Maybe<CostCalculation>
  dateCreated: Scalars["DateTime"]["output"]
  discountRate: Scalars["Float"]["output"]
  document?: Maybe<Document>
  electricityEscalationRate: Scalars["Float"]["output"]
  federalIncomeTaxRate: Scalars["Float"]["output"]
  groundPvKw?: Maybe<Scalars["Float"]["output"]>
  id: Scalars["Int"]["output"]
  meters: Array<EtbMeter>
  ownerSector: Scalars["String"]["output"]
  projectName: Scalars["String"]["output"]
  proposalDate: Scalars["DateTime"]["output"]
  roofPvKw?: Maybe<Scalars["Float"]["output"]>
  scenario?: Maybe<EtbScenarioRef>
  site: SiteRef
  solarLocation?: Maybe<SolarLocation>
  stateIncomeTaxRate: Scalars["Float"]["output"]
  taxType: Scalars["String"]["output"]
  transactions: Array<EtbTransaction>
}

export type EtbReportRef = {
  __typename?: "ETBReportRef"
  id: Scalars["Int"]["output"]
  projectName: Scalars["String"]["output"]
}

export type EtbScenarioRef = {
  __typename?: "ETBScenarioRef"
  includeStorage: Scalars["Boolean"]["output"]
  isPrimary: Scalars["Boolean"]["output"]
  loadCategory: LoadCategory
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  solarLocation: SolarLocation
}

export type EtbSeries = {
  __typename?: "ETBSeries"
  name: Scalars["String"]["output"]
  series: Array<Scalars["Float"]["output"]>
}

export type EtbTransaction = {
  __typename?: "ETBTransaction"
  dateCreated: Scalars["DateTime"]["output"]
  demandSavingsTerm: Scalars["Float"]["output"]
  energySavingsTerm: Scalars["Float"]["output"]
  id: Scalars["Int"]["output"]
  irr10Year?: Maybe<Scalars["Float"]["output"]>
  irr20Year?: Maybe<Scalars["Float"]["output"]>
  irrTerm?: Maybe<Scalars["Float"]["output"]>
  lcoeAfter: Scalars["Float"]["output"]
  lcoeBefore: Scalars["Float"]["output"]
  lcoePv: Scalars["Float"]["output"]
  name: Scalars["String"]["output"]
  netCost: Scalars["Float"]["output"]
  npvTerm: Scalars["Float"]["output"]
  paybackYears?: Maybe<Scalars["Float"]["output"]>
  ppaEscalationRate?: Maybe<Scalars["Float"]["output"]>
  ppaStartingRate?: Maybe<Scalars["Float"]["output"]>
  ppaTerm?: Maybe<Scalars["Float"]["output"]>
  pvGenerationKwhTerm: Scalars["Float"]["output"]
  roiTerm?: Maybe<Scalars["Float"]["output"]>
  series: Array<EtbSeries>
  storageConsumptionKwh: Scalars["Float"]["output"]
  storageDischargeKwhTerm: Scalars["Float"]["output"]
  termYears: Scalars["Int"]["output"]
  totalCost: Scalars["Float"]["output"]
  totalIncentives: Scalars["Float"]["output"]
  totalSavingsTerm: Scalars["Float"]["output"]
  upfrontCost?: Maybe<Scalars["Float"]["output"]>
}

export type EvCalc = {
  __typename?: "EVCalc"
  chargerLocation: ChargerLocation
  costPerKwhSeries: CleanIntervals
  createdAt: Scalars["DateTime"]["output"]
  dayRates: Array<Scalars["Float"]["output"]>
  downloadHourlyRatesHref: Scalars["String"]["output"]
  downloadXlsxHref: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  incentives: Array<EvIncentive>
  installCosts: Array<EvLineItem>
  markupUsdPerKwh: Scalars["Float"]["output"]
  npv: Scalars["Float"]["output"]
  numChargers: Scalars["Int"]["output"]
  optIters: Array<EvOptIter>
  optimalNumChargers: Scalars["Int"]["output"]
  outputs: EvOutputs
  parkingRatio?: Maybe<Scalars["Float"]["output"]>
  pid: Scalars["String"]["output"]
  projectInputs: EvProjectInputs
  propertyInputs: EvPropertyInputs
  seasonalDayRates: Array<SeasonalDayRate>
  site: SiteRef
  tariffRate: TariffRate
  timeZone: Scalars["String"]["output"]
  utility: UtilityRef
  utilityCostPerKwhSeries: CleanIntervals
  xlsx?: Maybe<Scalars["String"]["output"]>
  year3Expenses: Array<EvLineItem>
  yr3Cashflow?: Maybe<Scalars["Float"]["output"]>
  yr3NumEvs?: Maybe<Scalars["Float"]["output"]>
  yr3Revenue?: Maybe<Scalars["Float"]["output"]>
}

export type EvIncentive = {
  __typename?: "EVIncentive"
  calculation: Scalars["String"]["output"]
  eligibleAreas: Scalars["String"]["output"]
  incentiveAmount: Scalars["String"]["output"]
  incentiveCap: Scalars["String"]["output"]
  programConstraints: Scalars["String"]["output"]
  programName: Scalars["String"]["output"]
  state?: Maybe<Scalars["String"]["output"]>
  url: Scalars["String"]["output"]
}

export type EvLineItem = {
  __typename?: "EVLineItem"
  label: Scalars["String"]["output"]
  value: Scalars["Float"]["output"]
}

export type EvOptIter = {
  __typename?: "EVOptIter"
  npv: Scalars["Float"]["output"]
  numChargers: Scalars["Float"]["output"]
}

export type EvOutputs = {
  __typename?: "EVOutputs"
  breakevenYear: Scalars["Float"]["output"]
  capexUsd: Scalars["Float"]["output"]
  cashflowSeries: Array<Scalars["Float"]["output"]>
  incentiveUsd: Scalars["Float"]["output"]
  irr?: Maybe<Scalars["Float"]["output"]>
  npv: Scalars["Float"]["output"]
  numChargersDemandedSeries: Array<Scalars["Float"]["output"]>
  numEvSeries: Array<Scalars["Float"]["output"]>
  revenueSeries: Array<Scalars["Float"]["output"]>
  yr0NumTenantEvs: Scalars["Float"]["output"]
}

export type EvOverrideQueries = {
  __typename?: "EVOverrideQueries"
  current?: Maybe<EvOverrides>
  defaults: EvProjectInputs
}

export type EvOverrides = {
  __typename?: "EVOverrides"
  chargerKw?: Maybe<Scalars["Float"]["output"]>
  chargerLocation?: Maybe<ChargerLocation>
  cmsUsdPerChargerPerYr?: Maybe<Scalars["Float"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  demandUsdPerKw?: Maybe<Scalars["Float"]["output"]>
  discountRate?: Maybe<Scalars["Float"]["output"]>
  evGrowthPct?: Maybe<Scalars["Float"]["output"]>
  highEnergyUsdPerKwh?: Maybe<Scalars["Float"]["output"]>
  id: Scalars["Int"]["output"]
  incentiveCapNumChargers?: Maybe<Scalars["Int"]["output"]>
  incentivePct?: Maybe<Scalars["Float"]["output"]>
  installCostUsd?: Maybe<Scalars["Float"]["output"]>
  installType?: Maybe<ChargerInstallType>
  lowEnergyUsdPerKwh?: Maybe<Scalars["Float"]["output"]>
  maxEvAdoptionPct?: Maybe<Scalars["Float"]["output"]>
  maxUtilization?: Maybe<Scalars["Float"]["output"]>
  milesDrivenPerYear?: Maybe<Scalars["Float"]["output"]>
  milesPerKwh?: Maybe<Scalars["Float"]["output"]>
  numChargers?: Maybe<Scalars["Float"]["output"]>
  omUsdPerChargerPerYr?: Maybe<Scalars["Float"]["output"]>
  onPeakChargingPct?: Maybe<Scalars["Float"]["output"]>
  onSiteChargingPct?: Maybe<Scalars["Float"]["output"]>
  parent?: Maybe<EvOverrides>
  projectStartDate?: Maybe<Scalars["DateTime"]["output"]>
  rateManagementUsdPerChargerPerYr?: Maybe<Scalars["Float"]["output"]>
  salesTaxPct?: Maybe<Scalars["Float"]["output"]>
  termYears?: Maybe<Scalars["Int"]["output"]>
  transactionFeePct?: Maybe<Scalars["Float"]["output"]>
  usdPerKwhMarkup?: Maybe<Scalars["Float"]["output"]>
  user: UserRef
  yr0NumTenantEvs?: Maybe<Scalars["Int"]["output"]>
}

export type EvProjectInputs = {
  __typename?: "EVProjectInputs"
  chargerKw: Scalars["Float"]["output"]
  chargerLocation: ChargerLocation
  cmsUsdPerChargerPerYr: Scalars["Float"]["output"]
  demandUsdPerKw?: Maybe<Scalars["Float"]["output"]>
  discountRate: Scalars["Float"]["output"]
  evGrowthPct?: Maybe<Scalars["Float"]["output"]>
  highEnergyUsdPerKwh: Scalars["Float"]["output"]
  incentiveCapNumChargers?: Maybe<Scalars["Int"]["output"]>
  incentivePct: Scalars["Float"]["output"]
  installCostUsd?: Maybe<Scalars["Float"]["output"]>
  installType: ChargerInstallType
  lowEnergyUsdPerKwh: Scalars["Float"]["output"]
  maxEvAdoptionPct: Scalars["Float"]["output"]
  maxUtilization: Scalars["Float"]["output"]
  milesDrivenPerYear: Scalars["Float"]["output"]
  milesPerKwh: Scalars["Float"]["output"]
  numChargers?: Maybe<Scalars["Float"]["output"]>
  omUsdPerChargerPerYr: Scalars["Float"]["output"]
  onPeakChargingPct: Scalars["Float"]["output"]
  onSiteChargingPct: Scalars["Float"]["output"]
  projectStartDate: Scalars["DateTime"]["output"]
  rateManagementUsdPerChargerPerYr: Scalars["Float"]["output"]
  salesTaxPct: Scalars["Float"]["output"]
  termYears: Scalars["Int"]["output"]
  transactionFeePct: Scalars["Float"]["output"]
  usdPerKwhMarkup: Scalars["Float"]["output"]
  yr0NumTenantEvs?: Maybe<Scalars["Int"]["output"]>
}

export type EvPropertyInputs = {
  __typename?: "EVPropertyInputs"
  address: Scalars["String"]["output"]
  dataYear: Scalars["Int"]["output"]
  evGrowthRates: Array<Scalars["Float"]["output"]>
  evGrowthYears: Array<Scalars["Int"]["output"]>
  numEvs: Scalars["Int"]["output"]
  numHouseholds: Scalars["Int"]["output"]
  numParkingSpaces: Scalars["Int"]["output"]
  numUnits?: Maybe<Scalars["Int"]["output"]>
  numVehicles?: Maybe<Scalars["Int"]["output"]>
  pid: Scalars["String"]["output"]
}

export type EnergyProduction = {
  __typename?: "EnergyProduction"
  currentTime: Scalars["String"]["output"]
  kwhAllTime: Scalars["Float"]["output"]
  kwhPerDay: Array<SolarPerDay>
  kwhToday: Scalars["Float"]["output"]
  projectedNextInterval: Scalars["Float"]["output"]
  sites: Array<SolarSite>
}

export enum EnergyThing {
  CarportSolar = "CARPORT_SOLAR",
  GroundmountSolar = "GROUNDMOUNT_SOLAR",
  RooftopSolar = "ROOFTOP_SOLAR",
  Storage = "STORAGE",
}

export type EnergyThings = {
  __typename?: "EnergyThings"
  canCarportSolar?: Maybe<Scalars["Boolean"]["output"]>
  canGroundmountSolar?: Maybe<Scalars["Boolean"]["output"]>
  canRooftopSolar: Scalars["Boolean"]["output"]
  canStorage: Scalars["Boolean"]["output"]
}

export type EnergyThingsPred = {
  value: Array<EnergyThing>
}

export type Error = {
  __typename?: "Error"
  message: Scalars["String"]["output"]
}

export type Exchange = {
  __typename?: "Exchange"
  messages: Array<Message>
  response: Response
}

export type Experience = {
  __typename?: "Experience"
  btmAwardedPvKw?: Maybe<Scalars["Float"]["output"]>
  btmEnergizedPvKw?: Maybe<Scalars["Float"]["output"]>
  ftmAwardedPvKw?: Maybe<Scalars["Float"]["output"]>
  ftmEnergizedPvKw?: Maybe<Scalars["Float"]["output"]>
  state?: Maybe<UsState>
}

export type FmvPred = {
  value: Scalars["Int"]["input"]
}

export type FailureDetails = {
  __typename?: "FailureDetails"
  description: Scalars["String"]["output"]
  label: Scalars["String"]["output"]
}

export type FancyFloat = {
  __typename?: "FancyFloat"
  number: Scalars["Float"]["output"]
  source: FancySource
}

export enum FancySource {
  Ab802 = "AB802",
  Document = "DOCUMENT",
  Espm = "ESPM",
  Estimate = "ESTIMATE",
  Placeholder = "PLACEHOLDER",
  User = "USER",
}

export type FieldChangeLogHistory = {
  __typename?: "FieldChangeLogHistory"
  history: Array<ChangeLogEntry>
  latest?: Maybe<ChangeLogEntry>
}

export type FileContent = {
  __typename?: "FileContent"
  file: RawFile
  type: Scalars["String"]["output"]
}

export type FinProductMutations = {
  __typename?: "FinProductMutations"
  createCsFinproduct: AdminFinProduct
  createLoanFinproduct: AdminFinProduct
  createPpaFinproduct: AdminFinProduct
  editCsFinproductPrices: AdminFinProduct
  setDisabled: AdminFinProduct
  setIncludeStorage: AdminFinProduct
  setName: AdminFinProduct
  setStatus: AdminFinProduct
}

export type FinProductMutationsCreateCsFinproductArgs = {
  input: CsFinProductInput
}

export type FinProductMutationsCreateLoanFinproductArgs = {
  input: LoanFinProductInput
}

export type FinProductMutationsCreatePpaFinproductArgs = {
  input: PpaFinProductInput
}

export type FinProductMutationsEditCsFinproductPricesArgs = {
  id: Scalars["Int"]["input"]
  input: Array<CsPriceInput>
}

export type FinProductMutationsSetDisabledArgs = {
  disabled: Scalars["Boolean"]["input"]
  id: Scalars["Int"]["input"]
}

export type FinProductMutationsSetIncludeStorageArgs = {
  id: Scalars["Int"]["input"]
  includeStorage: Scalars["Boolean"]["input"]
}

export type FinProductMutationsSetNameArgs = {
  id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
}

export type FinProductMutationsSetStatusArgs = {
  id: Scalars["Int"]["input"]
  status?: InputMaybe<FinProductStatus>
}

export type FinProductRef = {
  __typename?: "FinProductRef"
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  type: FinProductType
}

export enum FinProductStatus {
  Estimated = "ESTIMATED",
  Final = "FINAL",
  Indicative = "INDICATIVE",
}

export enum FinProductType {
  Cs = "CS",
  Lease = "LEASE",
  Loan = "LOAN",
  Ppa = "PPA",
  Self = "SELF",
}

export type FinProductTypePred = {
  value: Array<InputMaybe<FinProductType>>
}

export type FinancierProjectTable = {
  __typename?: "FinancierProjectTable"
  rows: Array<FinancierProjectTableRow>
  view: FinancierProjectTableView
}

export type FinancierProjectTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type FinancierProjectTableViewArgs = {
  filterBy?: InputMaybe<FinancierProjectTableFilter>
  sortBy?: InputMaybe<Array<FinancierProjectTableSort>>
}

export enum FinancierProjectTableAttr {
  BidStatuses = "BID_STATUSES",
  BundleBiddingClosedAt = "BUNDLE_BIDDING_CLOSED_AT",
  BundleBiddingOpenAt = "BUNDLE_BIDDING_OPEN_AT",
  BundleName = "BUNDLE_NAME",
  BundlePid = "BUNDLE_PID",
  BundleRowCloseCustomReason = "BUNDLE_ROW_CLOSE_CUSTOM_REASON",
  BundleRowCloseReason = "BUNDLE_ROW_CLOSE_REASON",
  BundleRowIsClosed = "BUNDLE_ROW_IS_CLOSED",
  BundleRowState = "BUNDLE_ROW_STATE",
  BundleType = "BUNDLE_TYPE",
  City = "CITY",
  Name = "NAME",
  OptedOut = "OPTED_OUT",
  OrgName = "ORG_NAME",
  SitePid = "SITE_PID",
  State = "STATE",
  StreetAddress = "STREET_ADDRESS",
  ZipCode = "ZIP_CODE",
}

export type FinancierProjectTableFilter = {
  bundleBiddingClosedAt?: InputMaybe<DatePred>
  bundleBiddingOpenAt?: InputMaybe<DatePred>
  bundleName?: InputMaybe<StringPred>
  bundlePid?: InputMaybe<StringPred>
  bundleRowCloseCustomReason?: InputMaybe<StringPred>
  bundleRowCloseReason?: InputMaybe<CloseReasonPred>
  bundleRowIsClosed?: InputMaybe<BoolPred>
  bundleRowState?: InputMaybe<BundleStatePred>
  bundleType?: InputMaybe<StringPred>
  city?: InputMaybe<StringPred>
  id?: InputMaybe<StringPred>
  name?: InputMaybe<StringPred>
  optedOut?: InputMaybe<BoolPred>
  orgName?: InputMaybe<StringPred>
  search?: InputMaybe<SearchPred>
  sitePid?: InputMaybe<StringPred>
  state?: InputMaybe<UsStateMultiPred>
  streetAddress?: InputMaybe<StringPred>
}

export type FinancierProjectTableRow = {
  __typename?: "FinancierProjectTableRow"
  bidStatuses: Array<InvestorBidStatus>
  bundleBiddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  bundleBiddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  bundleName: Scalars["String"]["output"]
  bundlePid: Scalars["String"]["output"]
  bundleRowCloseCustomReason?: Maybe<Scalars["String"]["output"]>
  bundleRowCloseReason?: Maybe<CloseReason>
  bundleRowIsClosed: Scalars["Boolean"]["output"]
  bundleRowState?: Maybe<BundleState>
  bundleType: FinProductType
  city: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  optedOut: Scalars["Boolean"]["output"]
  orgName: Scalars["String"]["output"]
  sitePid: Scalars["String"]["output"]
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  zipCode: Scalars["String"]["output"]
}

export type FinancierProjectTableSort = {
  attr: FinancierProjectTableAttr
  order: SortOrder
}

export type FinancierProjectTableStats = {
  __typename?: "FinancierProjectTableStats"
  buildingOwners: Array<Scalars["String"]["output"]>
}

export type FinancierProjectTableView = {
  __typename?: "FinancierProjectTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
  stats: FinancierProjectTableStats
}

export type FinancingThings = {
  __typename?: "FinancingThings"
  canCommunitySolar?: Maybe<Scalars["Boolean"]["output"]>
  canLease?: Maybe<Scalars["Boolean"]["output"]>
  canLoan: Scalars["Boolean"]["output"]
  canPpa?: Maybe<Scalars["Boolean"]["output"]>
  canSelfInvest: Scalars["Boolean"]["output"]
}

export type FinancingThingsPred = {
  value: Array<FinProductType>
}

export type Finmodel = {
  __typename?: "Finmodel"
  buildingOwnerNoiAnnualUsd: Scalars["Float"]["output"]
  buildingOwnerNoiLifetimeUsd: Scalars["Float"]["output"]
  co2EmissionsReductionTonnes?: Maybe<Scalars["Float"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  failure: Array<FinmodelFailureRef>
  finproduct: AdminFinProduct
  fmvNum: Scalars["Int"]["output"]
  fmvStr: Scalars["String"]["output"]
  gridMeters: Array<GridMeter>
  id: Scalars["Int"]["output"]
  inputs: Scalars["JSON"]["output"]
  leDevFee: Scalars["Float"]["output"]
  leDevFeePct: Scalars["Float"]["output"]
  lux?: Maybe<Lux>
  pid: Scalars["String"]["output"]
  postTaxItcDeprIrr?: Maybe<Scalars["Float"]["output"]>
  preTaxIrr?: Maybe<Scalars["Float"]["output"]>
  pvSizeKw: Scalars["Float"]["output"]
  scenario?: Maybe<ScenarioRef>
  site: SiteRef
  storageSizeKw: Scalars["Float"]["output"]
  storageSizeKwh: Scalars["Float"]["output"]
  type: FinProductType
}

export type FinmodelCost = {
  __typename?: "FinmodelCost"
  items: Array<LineItem>
  tariffs: Array<RevampTariff>
  totalCostUsd: Scalars["Float"]["output"]
  totalKwh: Scalars["Float"]["output"]
  usdPerKwh: Scalars["Float"]["output"]
}

export type FinmodelFailure = {
  __typename?: "FinmodelFailure"
  createdAt: Scalars["DateTime"]["output"]
  finmodel?: Maybe<Finmodel>
  finproduct?: Maybe<AdminFinProduct>
  fmv: Scalars["Int"]["output"]
  id: Scalars["Int"]["output"]
  isCs: Scalars["Boolean"]["output"]
  isLux: Scalars["Boolean"]["output"]
  isPvopt: Scalars["Boolean"]["output"]
  message: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  scenario: ScenarioRef
  site: SiteRef
  source?: Maybe<FinmodelSource>
}

export type FinmodelFailureIndexRow = {
  __typename?: "FinmodelFailureIndexRow"
  failureCount: Scalars["Int"]["output"]
  fmv: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
}

export type FinmodelFailureRef = {
  __typename?: "FinmodelFailureRef"
  id: Scalars["Int"]["output"]
}

export type FinmodelFailureTable = {
  __typename?: "FinmodelFailureTable"
  rows: Array<FinmodelFailureTableRow>
  view: FinmodelFailureTableView
}

export type FinmodelFailureTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type FinmodelFailureTableViewArgs = {
  filterBy?: InputMaybe<FinmodelFailureTableFilter>
  sortBy?: InputMaybe<Array<FinmodelFailureTableSort>>
}

export enum FinmodelFailureTableAttr {
  CreatedAt = "CREATED_AT",
  Fmv = "FMV",
  Message = "MESSAGE",
  Name = "NAME",
}

export type FinmodelFailureTableFilter = {
  fmv?: InputMaybe<FmvPred>
  name?: InputMaybe<StringPred>
}

export type FinmodelFailureTableRow = {
  __typename?: "FinmodelFailureTableRow"
  createdAt: Scalars["DateTime"]["output"]
  fmv: Scalars["Int"]["output"]
  id: Scalars["Int"]["output"]
  message: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
}

export type FinmodelFailureTableSort = {
  attr: FinmodelFailureTableAttr
  order: SortOrder
}

export type FinmodelFailureTableView = {
  __typename?: "FinmodelFailureTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
}

export type FinmodelInputOverride = {
  __typename?: "FinmodelInputOverride"
  createdBy?: Maybe<Scalars["String"]["output"]>
  dateCreated: Scalars["DateTime"]["output"]
  dateTrashed?: Maybe<Scalars["DateTime"]["output"]>
  id: Scalars["Int"]["output"]
  inputName: Scalars["String"]["output"]
  inputValue: Scalars["String"]["output"]
  source: FinmodelInputOverrideSource
}

export type FinmodelInputOverrideError = Error | FinmodelInputOverride

export enum FinmodelInputOverrideSource {
  FinancingOrg = "FINANCING_ORG",
  Finproduct = "FINPRODUCT",
  Portfolio = "PORTFOLIO",
  Site = "SITE",
}

export type FinmodelMutations = {
  __typename?: "FinmodelMutations"
  addOverride: FinmodelInputOverrideError
  deleteOverride?: Maybe<FinmodelInputOverride>
}

export type FinmodelMutationsAddOverrideArgs = {
  finproductId?: InputMaybe<Scalars["Int"]["input"]>
  inputName: Scalars["String"]["input"]
  inputValue: Scalars["String"]["input"]
  orgPid?: InputMaybe<Scalars["String"]["input"]>
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
  sitePid?: InputMaybe<Scalars["String"]["input"]>
}

export type FinmodelMutationsDeleteOverrideArgs = {
  finproductId?: InputMaybe<Scalars["Int"]["input"]>
  inputName: Scalars["String"]["input"]
  orgPid?: InputMaybe<Scalars["String"]["input"]>
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
  sitePid?: InputMaybe<Scalars["String"]["input"]>
}

export type FinmodelSettings = {
  __typename?: "FinmodelSettings"
  possibleOverrides: Array<Overridable>
}

export type FinmodelSource = EtbReportRef | LuxRef | PVoptRef | ReoptRef

export type FinmodelTable = {
  __typename?: "FinmodelTable"
  rows: Array<FinmodelTableRow>
  view: FinmodelTableView
}

export type FinmodelTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type FinmodelTableViewArgs = {
  filterBy?: InputMaybe<FinmodelTableFilter>
  sortBy?: InputMaybe<Array<FinmodelTableSort>>
}

export enum FinmodelTableAttr {
  BuildingOwnerNoiLifetimeUsd = "BUILDING_OWNER_NOI_LIFETIME_USD",
  CreatedAt = "CREATED_AT",
  FmvStr = "FMV_STR",
  Name = "NAME",
  Pid = "PID",
  ScenarioIncludeStorage = "SCENARIO_INCLUDE_STORAGE",
  ScenarioName = "SCENARIO_NAME",
  ScenarioPid = "SCENARIO_PID",
  ScenarioSolarLocation = "SCENARIO_SOLAR_LOCATION",
  Type = "TYPE",
}

export type FinmodelTableFilter = {
  buildingOwnerNoiLifetimeUsd?: InputMaybe<FloatPred>
  scenarioPid?: InputMaybe<ScenarioPred>
}

export type FinmodelTableRow = {
  __typename?: "FinmodelTableRow"
  buildingOwnerNoiLifetimeUsd: Scalars["Float"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  fmvStr: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  scenarioIncludeStorage: Scalars["Boolean"]["output"]
  scenarioName: Scalars["String"]["output"]
  scenarioPid: Scalars["String"]["output"]
  scenarioSolarLocation: SolarLocation
  type: FinProductType
}

export type FinmodelTableSort = {
  attr: FinmodelTableAttr
  order: SortOrder
}

export type FinmodelTableView = {
  __typename?: "FinmodelTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
}

export type FloatPred = {
  gte?: InputMaybe<Scalars["Float"]["input"]>
  lte?: InputMaybe<Scalars["Float"]["input"]>
  missing?: Scalars["Boolean"]["input"]
}

export type Footprint = {
  __typename?: "Footprint"
  bounds?: Maybe<Scalars["JSON"]["output"]>
  carportShape?: Maybe<Scalars["JSON"]["output"]>
  carportShapeGeojson?: Maybe<Scalars["JSON"]["output"]>
  carportShapeUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>
  carportShapeUpdatedBy?: Maybe<UserRef>
  geocodedLocation: GeocodedLocation
  groundmountShape?: Maybe<Scalars["JSON"]["output"]>
  groundmountShapeGeojson?: Maybe<Scalars["JSON"]["output"]>
  groundmountShapeUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>
  groundmountShapeUpdatedBy?: Maybe<UserRef>
  keepoutsShape?: Maybe<Scalars["JSON"]["output"]>
  keepoutsShapeGeojson?: Maybe<Scalars["JSON"]["output"]>
  keepoutsShapeUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>
  keepoutsShapeUpdatedBy?: Maybe<UserRef>
  latitude: Scalars["Float"]["output"]
  longitude: Scalars["Float"]["output"]
  obstructionShape?: Maybe<Scalars["JSON"]["output"]>
  obstructionShapeGeojson?: Maybe<Scalars["JSON"]["output"]>
  parcelShape?: Maybe<Scalars["JSON"]["output"]>
  parcelShapeGeojson?: Maybe<Scalars["JSON"]["output"]>
  parcelShapeUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>
  parcelShapeUpdatedBy?: Maybe<UserRef>
  roofSetbackShape?: Maybe<Scalars["JSON"]["output"]>
  roofSetbackShapeGeojson?: Maybe<Scalars["JSON"]["output"]>
  roofSetbackShapeUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>
  roofSetbackShapeUpdatedBy?: Maybe<UserRef>
  roofShape?: Maybe<Scalars["JSON"]["output"]>
  roofShapeGeojson?: Maybe<Scalars["JSON"]["output"]>
  roofShapeUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>
  roofShapeUpdatedBy?: Maybe<UserRef>
}

export type FootprintError = Error | Footprint

export enum FootprintStrategy {
  AllBuildingsOnParcel = "ALL_BUILDINGS_ON_PARCEL",
  ClosestBuilding = "CLOSEST_BUILDING",
}

export type FormattedBill = {
  __typename?: "FormattedBill"
  charges: Array<BillSection>
  exports: Array<BillSection>
  kwhCharge: Scalars["Float"]["output"]
  kwhSupplyCharge: Scalars["Float"]["output"]
  month: Scalars["String"]["output"]
}

export type FormattedBills = {
  __typename?: "FormattedBills"
  bills: Array<FormattedBill>
  rate?: Maybe<TariffRate>
}

export type Function = {
  __typename?: "Function"
  arguments: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
}

export enum GaugeRazzleDazzle {
  Cold = "COLD",
  Fire = "FIRE",
  Hot = "HOT",
  Warm = "WARM",
}

export type GeocodedLocation = {
  __typename?: "GeocodedLocation"
  latitude: Scalars["Float"]["output"]
  longitude: Scalars["Float"]["output"]
}

export type GeographicIncentives = {
  __typename?: "GeographicIncentives"
  inEnergyCommunity: Scalars["Boolean"]["output"]
  inLowIncomeCommunity: Scalars["Boolean"]["output"]
}

export type GoogleApiMutations = {
  __typename?: "GoogleApiMutations"
  /** @deprecated use draft_email */
  createDraft?: Maybe<Scalars["Void"]["output"]>
  draftEmail?: Maybe<Scalars["Void"]["output"]>
}

export type GoogleApiMutationsCreateDraftArgs = {
  draftParams: CreateDraftInput
}

export type GoogleApiMutationsDraftEmailArgs = {
  draftParams: DraftEmailInput
}

export type GridMeter = {
  __typename?: "GridMeter"
  bauMeter?: Maybe<BauMeter>
  costs: CostCalculation
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  loadCategory: LoadCategory
  postBattery?: Maybe<MeterCalc>
  postSolar: MeterCalc
  preSolar: MeterCalc
}

export type GroupedLineItem = {
  __typename?: "GroupedLineItem"
  cost: Scalars["Float"]["output"]
  group?: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  rate: Scalars["Float"]["output"]
  unit?: Maybe<ChargeUnit>
  usage: Scalars["Float"]["output"]
}

export type GuardrailOverrideResult = {
  __typename?: "GuardrailOverrideResult"
  promotedFailure: Scalars["Boolean"]["output"]
}

export type GuardrailOverrideResultError = Error | GuardrailOverrideResult

export enum GuardrailScope {
  Portfolio = "PORTFOLIO",
  Scenario = "SCENARIO",
  Site = "SITE",
}

export type GuessTariffFailure = {
  __typename?: "GuessTariffFailure"
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  loadCategory: LoadCategory
  message: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  site: SiteRef
}

export type HelioPvSpec = {
  __typename?: "HelioPVSpec"
  pvType: PvType
  sizeKw: Scalars["Float"]["output"]
}

export type Helioscope = {
  __typename?: "Helioscope"
  acNameplateKw?: Maybe<Scalars["Float"]["output"]>
  allocations?: Maybe<Scalars["JSON"]["output"]>
  annualProductionAcKwh: Scalars["Float"]["output"]
  carportIsMax: Scalars["Boolean"]["output"]
  carportPvKw: Scalars["Float"]["output"]
  carportPvSixHighKw: Scalars["Float"]["output"]
  carportPvThreeHighKw: Scalars["Float"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  createdBy: UserRef
  dcNameplateKw?: Maybe<Scalars["Float"]["output"]>
  groundPvKw: Scalars["Float"]["output"]
  id: Scalars["Int"]["output"]
  inverterType?: Maybe<Scalars["String"]["output"]>
  isTrashed: Scalars["Boolean"]["output"]
  loadRatio?: Maybe<Scalars["Float"]["output"]>
  moduleType?: Maybe<Scalars["String"]["output"]>
  monthlyProductionAcKwh?: Maybe<Array<Scalars["Float"]["output"]>>
  notes?: Maybe<Scalars["String"]["output"]>
  pdf: Attachment
  pdfHref: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  productionCsv?: Maybe<Attachment>
  pvKw: Scalars["Float"]["output"]
  pvSpecs: Array<HelioPvSpec>
  rackingConnectionType?: Maybe<ConnectionType>
  rackingManufacturer?: Maybe<Scalars["String"]["output"]>
  rackingTiltDegrees?: Maybe<Scalars["Float"]["output"]>
  roofImage: Attachment
  roofImageHref: Scalars["String"]["output"]
  roofIsMax: Scalars["Boolean"]["output"]
  roofPvKw: Scalars["Float"]["output"]
  site: SiteRef
  systemProductivityKwhPerKw?: Maybe<Scalars["Float"]["output"]>
  trashedAt?: Maybe<Scalars["DateTime"]["output"]>
  trashedBy?: Maybe<UserRef>
}

export type HelioscopeAssumptionsInput = {
  acNameplateKw?: InputMaybe<Scalars["Float"]["input"]>
  dcNameplateKw?: InputMaybe<Scalars["Float"]["input"]>
  inverterType?: InputMaybe<Scalars["String"]["input"]>
  moduleType?: InputMaybe<Scalars["String"]["input"]>
  notes?: InputMaybe<Scalars["String"]["input"]>
  rackingConnectionType?: InputMaybe<ConnectionType>
  rackingManufacturer?: InputMaybe<Scalars["String"]["input"]>
  rackingTiltDegrees?: InputMaybe<Scalars["Float"]["input"]>
}

export type HostingCapacityMap = {
  __typename?: "HostingCapacityMap"
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  requiresLogin: Scalars["Boolean"]["output"]
  types: Array<HostingCapacityMapType>
  url: Scalars["String"]["output"]
  utility: Utility
}

export type HostingCapacityMapInputs = {
  requiresLogin: Scalars["Boolean"]["input"]
  types: Array<HostingCapacityMapType>
  url: Scalars["String"]["input"]
}

export type HostingCapacityMapMutations = {
  __typename?: "HostingCapacityMapMutations"
  create?: Maybe<Scalars["Void"]["output"]>
  delete?: Maybe<Scalars["Void"]["output"]>
  update?: Maybe<Scalars["Void"]["output"]>
}

export type HostingCapacityMapMutationsCreateArgs = {
  inputs: HostingCapacityMapInputs
  utilityPid: Scalars["String"]["input"]
}

export type HostingCapacityMapMutationsDeleteArgs = {
  mapId: Scalars["Int"]["input"]
}

export type HostingCapacityMapMutationsUpdateArgs = {
  inputs: HostingCapacityMapInputs
  mapId: Scalars["Int"]["input"]
}

export type HostingCapacityMapQuery = {
  __typename?: "HostingCapacityMapQuery"
  all: Array<HostingCapacityMap>
}

export enum HostingCapacityMapType {
  AssetMap = "ASSET_MAP",
  Der = "DER",
  Load = "LOAD",
  Storage = "STORAGE",
}

export enum IrrType {
  PostTaxItcDeprIrr = "POST_TAX_ITC_DEPR_IRR",
  PreTaxIrr = "PRE_TAX_IRR",
  PreTaxItcIrr = "PRE_TAX_ITC_IRR",
}

export type IrRs = {
  __typename?: "IRRs"
  postTaxItcDepr?: Maybe<Scalars["Float"]["output"]>
  postTaxItcDeprMultiple?: Maybe<Scalars["Float"]["output"]>
  preTax?: Maybe<Scalars["Float"]["output"]>
  preTaxMultiple?: Maybe<Scalars["Float"]["output"]>
}

export type ImageContent = {
  __typename?: "ImageContent"
  imageUrl: ImageUrl
  type: Scalars["String"]["output"]
}

export type ImageUrl = {
  __typename?: "ImageUrl"
  url: Scalars["String"]["output"]
}

export enum InputType {
  Bool = "BOOL",
  Datetime = "DATETIME",
  Float = "FLOAT",
  Int = "INT",
  List = "LIST",
  String = "STRING",
}

export type IntPred = {
  gte?: InputMaybe<Scalars["Int"]["input"]>
  lte?: InputMaybe<Scalars["Int"]["input"]>
  missing?: Scalars["Boolean"]["input"]
}

export type IntegerValue = {
  __typename?: "IntegerValue"
  integer: Scalars["Int"]["output"]
}

export type InvestorBid = {
  __typename?: "InvestorBid"
  canEdit: Scalars["Boolean"]["output"]
  cs?: Maybe<CsInvestorBid>
  ppa?: Maybe<PpaInvestorBid>
}

export type InvestorBidSpecOptOut = {
  __typename?: "InvestorBidSpecOptOut"
  archivedAt?: Maybe<Scalars["DateTime"]["output"]>
  archivedBy?: Maybe<UserRef>
  createdAt: Scalars["DateTime"]["output"]
  createdBy: UserRef
  customReason?: Maybe<Scalars["String"]["output"]>
  reason?: Maybe<SpecOptOutReason>
}

export enum InvestorBidStatus {
  InProgress = "IN_PROGRESS",
  Submitted = "SUBMITTED",
  Unset = "UNSET",
}

export type InvestorBidsTable = {
  __typename?: "InvestorBidsTable"
  rows: Array<InvestorBidsTableRow>
  view: InvestorBidsTableView
}

export type InvestorBidsTableRowsArgs = {
  keys: Array<Scalars["String"]["input"]>
}

export type InvestorBidsTableViewArgs = {
  filterBy?: InputMaybe<InvestorBidsTableFilter>
  sortBy?: InputMaybe<Array<InvestorBidsTableSort>>
}

export enum InvestorBidsTableAttr {
  AssetManager = "ASSET_MANAGER",
  BiddingClosedAt = "BIDDING_CLOSED_AT",
  BiddingOpenAt = "BIDDING_OPEN_AT",
  BidName = "BID_NAME",
  BidPackageName = "BID_PACKAGE_NAME",
  BidPackagePid = "BID_PACKAGE_PID",
  BuildingClass = "BUILDING_CLASS",
  BuildingFootprintCount = "BUILDING_FOOTPRINT_COUNT",
  BuildingFootprintSqft = "BUILDING_FOOTPRINT_SQFT",
  BuildingLegalName = "BUILDING_LEGAL_NAME",
  BuildingOwnerExtraPaymentsUsd = "BUILDING_OWNER_EXTRA_PAYMENTS_USD",
  BuildingType = "BUILDING_TYPE",
  BundleParentPid = "BUNDLE_PARENT_PID",
  BundleRowPid = "BUNDLE_ROW_PID",
  CbsaName = "CBSA_NAME",
  City = "CITY",
  ConstructionEmail = "CONSTRUCTION_EMAIL",
  CounselApproval = "COUNSEL_APPROVAL",
  County = "COUNTY",
  CsBuildingOwnerNoiLifetimeUsd = "CS_BUILDING_OWNER_NOI_LIFETIME_USD",
  CsEstimatedAwardDate = "CS_ESTIMATED_AWARD_DATE",
  CsRoofRentEscalator = "CS_ROOF_RENT_ESCALATOR",
  CsRoofRentNpv = "CS_ROOF_RENT_NPV",
  CsRoofRentY1Usd = "CS_ROOF_RENT_Y1_USD",
  EstimatedCod = "ESTIMATED_COD",
  EstimatedNtp = "ESTIMATED_NTP",
  ExternalLeaseApprovers = "EXTERNAL_LEASE_APPROVERS",
  ExtraPaymentsNotes = "EXTRA_PAYMENTS_NOTES",
  FinancierLogomarkUrl = "FINANCIER_LOGOMARK_URL",
  FinancierLogoUrl = "FINANCIER_LOGO_URL",
  FinancierName = "FINANCIER_NAME",
  FinancierPid = "FINANCIER_PID",
  FinancingType = "FINANCING_TYPE",
  IncentivesNotes = "INCENTIVES_NOTES",
  InterconnectionCostNonUtilityUsd = "INTERCONNECTION_COST_NON_UTILITY_USD",
  InterconnectionCostUsdPerWatt = "INTERCONNECTION_COST_USD_PER_WATT",
  InterconnectionCostUtilityMaxUsd = "INTERCONNECTION_COST_UTILITY_MAX_USD",
  InterconnectionCostUtilityMinUsd = "INTERCONNECTION_COST_UTILITY_MIN_USD",
  InterconnectionNotes = "INTERCONNECTION_NOTES",
  InterconnectionRepriceProcessNotes = "INTERCONNECTION_REPRICE_PROCESS_NOTES",
  IsAwardedBid = "IS_AWARDED_BID",
  IsFannieMaeLender = "IS_FANNIE_MAE_LENDER",
  IsFmGlobalInsurer = "IS_FM_GLOBAL_INSURER",
  IsRecommendedBid = "IS_RECOMMENDED_BID",
  ItcPercentageAssumption = "ITC_PERCENTAGE_ASSUMPTION",
  Latitude = "LATITUDE",
  LeaseApprovers = "LEASE_APPROVERS",
  LeaseLegalOwnerName = "LEASE_LEGAL_OWNER_NAME",
  LeasePropertyLegalDescription = "LEASE_PROPERTY_LEGAL_DESCRIPTION",
  LeaseSignatory = "LEASE_SIGNATORY",
  Longitude = "LONGITUDE",
  Name = "NAME",
  NeedsTenantApproval = "NEEDS_TENANT_APPROVAL",
  NumStories = "NUM_STORIES",
  NumUnitsTotal = "NUM_UNITS_TOTAL",
  OtherNotes = "OTHER_NOTES",
  PackageRowClosedAt = "PACKAGE_ROW_CLOSED_AT",
  PackageRowCloseCustomReason = "PACKAGE_ROW_CLOSE_CUSTOM_REASON",
  PackageRowCloseReason = "PACKAGE_ROW_CLOSE_REASON",
  PackageRowIsClosed = "PACKAGE_ROW_IS_CLOSED",
  PackageRowStatus = "PACKAGE_ROW_STATUS",
  PpaBuildingOwnerNoiLifetimeUsd = "PPA_BUILDING_OWNER_NOI_LIFETIME_USD",
  PpaOfftakerLifetimeSavingsUsd = "PPA_OFFTAKER_LIFETIME_SAVINGS_USD",
  PpaPriceEscalator = "PPA_PRICE_ESCALATOR",
  PpaPriceY1Usd = "PPA_PRICE_Y1_USD",
  PpaRoofRentEscalator = "PPA_ROOF_RENT_ESCALATOR",
  PpaRoofRentY1Usd = "PPA_ROOF_RENT_Y1_USD",
  PpaYearOneOfftakerSavingsUsd = "PPA_YEAR_ONE_OFFTAKER_SAVINGS_USD",
  PpaYearOneRoofRentalFee = "PPA_YEAR_ONE_ROOF_RENTAL_FEE",
  PropertyFundName = "PROPERTY_FUND_NAME",
  PropertyInsurer = "PROPERTY_INSURER",
  PropertyLenders = "PROPERTY_LENDERS",
  PropertySiteVisitContacts = "PROPERTY_SITE_VISIT_CONTACTS",
  RecOwner = "REC_OWNER",
  RoofCondition = "ROOF_CONDITION",
  RoofReplacedYr = "ROOF_REPLACED_YR",
  RoofRightsHolder = "ROOF_RIGHTS_HOLDER",
  RoofSqft = "ROOF_SQFT",
  SalePlannedYear = "SALE_PLANNED_YEAR",
  SalePlans = "SALE_PLANS",
  SignatureBlocks = "SIGNATURE_BLOCKS",
  SiteLabels = "SITE_LABELS",
  SitePid = "SITE_PID",
  Sqft = "SQFT",
  State = "STATE",
  StreetAddress = "STREET_ADDRESS",
  TariffProvision = "TARIFF_PROVISION",
  TermYears = "TERM_YEARS",
  Type = "TYPE",
  UsableRoofSqft = "USABLE_ROOF_SQFT",
  YearBuilt = "YEAR_BUILT",
  ZipCode = "ZIP_CODE",
}

export type InvestorBidsTableFilter = {
  assetManager?: InputMaybe<StringPred>
  bidName?: InputMaybe<StringPred>
  bidPackageName?: InputMaybe<StringPred>
  bidPackagePid?: InputMaybe<StringPred>
  buildingClass?: InputMaybe<StringPred>
  buildingFootprintCount?: InputMaybe<IntPred>
  buildingFootprintSqft?: InputMaybe<FloatPred>
  buildingLegalName?: InputMaybe<StringPred>
  buildingOwnerExtraPaymentsUsd?: InputMaybe<FloatPred>
  buildingType?: InputMaybe<BuildingTypePred>
  bundleParentPid?: InputMaybe<StringPred>
  bundleRowPid?: InputMaybe<StringPred>
  cbsaName?: InputMaybe<StringPred>
  city?: InputMaybe<StringPred>
  constructionEmail?: InputMaybe<StringPred>
  counselApproval?: InputMaybe<CounselApprovalPred>
  county?: InputMaybe<StringPred>
  csBuildingOwnerNoiLifetimeUsd?: InputMaybe<FloatPred>
  csRoofRentEscalator?: InputMaybe<FloatPred>
  csRoofRentNpv?: InputMaybe<FloatPred>
  csRoofRentY1Usd?: InputMaybe<FloatPred>
  financierName?: InputMaybe<StringPred>
  financierPid?: InputMaybe<StringPred>
  financingType?: InputMaybe<FinProductTypePred>
  interconnectionCostNonUtilityUsd?: InputMaybe<FloatPred>
  interconnectionCostUsdPerWatt?: InputMaybe<FloatPred>
  interconnectionCostUtilityMaxUsd?: InputMaybe<FloatPred>
  interconnectionCostUtilityMinUsd?: InputMaybe<FloatPred>
  isAwardedBid?: InputMaybe<BidAwardedPred>
  isFannieMaeLender?: InputMaybe<BoolPred>
  isFmGlobalInsurer?: InputMaybe<BoolPred>
  isRecommendedBid?: InputMaybe<BidAwardedPred>
  itcPercentageAssumption?: InputMaybe<FloatPred>
  latitude?: InputMaybe<FloatPred>
  leaseLegalOwnerName?: InputMaybe<StringPred>
  leasePropertyLegalDescription?: InputMaybe<StringPred>
  leaseSignatory?: InputMaybe<StringPred>
  longitude?: InputMaybe<FloatPred>
  name?: InputMaybe<StringPred>
  needsTenantApproval?: InputMaybe<BoolPred>
  numStories?: InputMaybe<IntPred>
  numUnitsTotal?: InputMaybe<IntPred>
  packageRowIsClosed?: InputMaybe<BoolPred>
  packageRowStatus?: InputMaybe<PackageRowStatusPred>
  pid?: InputMaybe<StringPred>
  ppaBuildingOwnerNoiLifetimeUsd?: InputMaybe<FloatPred>
  ppaOfftakerLifetimeSavingsUsd?: InputMaybe<FloatPred>
  ppaPriceEscalator?: InputMaybe<FloatPred>
  ppaPriceY1Usd?: InputMaybe<FloatPred>
  ppaRoofRentEscalator?: InputMaybe<FloatPred>
  ppaRoofRentY1Usd?: InputMaybe<FloatPred>
  ppaYearOneOfftakerSavingsUsd?: InputMaybe<FloatPred>
  ppaYearOneRoofRentalFee?: InputMaybe<FloatPred>
  propertyFundName?: InputMaybe<StringPred>
  propertyInsurer?: InputMaybe<StringPred>
  propertyLenders?: InputMaybe<StringPred>
  recOwner?: InputMaybe<RecOwnerPred>
  roofReplacedYr?: InputMaybe<FloatPred>
  roofRightsHolder?: InputMaybe<RoofRightsHolderPred>
  roofSqft?: InputMaybe<FloatPred>
  salePlannedYear?: InputMaybe<FloatPred>
  salePlans?: InputMaybe<StringPred>
  siteLabels?: InputMaybe<SiteLabelNamesPred>
  sitePid?: InputMaybe<StringPred>
  sqft?: InputMaybe<FloatPred>
  state?: InputMaybe<UsStateMultiPred>
  streetAddress?: InputMaybe<StringPred>
  termYears?: InputMaybe<FloatPred>
  type?: InputMaybe<FinProductTypePred>
  usableRoofSqft?: InputMaybe<FloatPred>
  yearBuilt?: InputMaybe<IntPred>
}

export type InvestorBidsTableRow = {
  __typename?: "InvestorBidsTableRow"
  assetManager?: Maybe<Scalars["String"]["output"]>
  bidName?: Maybe<Scalars["String"]["output"]>
  bidPackageName: Scalars["String"]["output"]
  bidPackagePid: Scalars["String"]["output"]
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  buildingClass?: Maybe<Scalars["String"]["output"]>
  buildingFootprintCount?: Maybe<Scalars["Int"]["output"]>
  buildingFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  buildingLegalName?: Maybe<Scalars["String"]["output"]>
  buildingOwnerExtraPaymentsUsd?: Maybe<Array<Scalars["Float"]["output"]>>
  buildingType?: Maybe<BuildingType>
  bundleParentPid: Scalars["String"]["output"]
  bundleRowPid: Scalars["String"]["output"]
  cbsaName?: Maybe<Scalars["String"]["output"]>
  city: Scalars["String"]["output"]
  constructionEmail?: Maybe<Scalars["String"]["output"]>
  counselApproval?: Maybe<CounselApproval>
  county: Scalars["String"]["output"]
  csBuildingOwnerNoiLifetimeUsd?: Maybe<Scalars["Float"]["output"]>
  csEstimatedAwardDate?: Maybe<Scalars["DateTime"]["output"]>
  csRoofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  csRoofRentNpv?: Maybe<Scalars["Float"]["output"]>
  csRoofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  csSystem?: Maybe<SystemLite>
  estimatedCod: Scalars["Date"]["output"]
  estimatedNtp: Scalars["Date"]["output"]
  externalLeaseApprovers?: Maybe<Array<Scalars["String"]["output"]>>
  extraPaymentsNotes?: Maybe<Scalars["String"]["output"]>
  financierLogoUrl: Scalars["String"]["output"]
  financierLogomarkUrl?: Maybe<Scalars["String"]["output"]>
  financierName: Scalars["String"]["output"]
  financierPid: Scalars["String"]["output"]
  financingType: FinProductType
  incentivesNotes?: Maybe<Scalars["String"]["output"]>
  interconnectionCostNonUtilityUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMaxUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMinUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionNotes?: Maybe<Scalars["String"]["output"]>
  interconnectionRepriceProcessNotes?: Maybe<Scalars["String"]["output"]>
  isAwardedBid?: Maybe<Scalars["Boolean"]["output"]>
  isFannieMaeLender?: Maybe<Scalars["Boolean"]["output"]>
  isFmGlobalInsurer?: Maybe<Scalars["Boolean"]["output"]>
  isRecommendedBid?: Maybe<Scalars["Boolean"]["output"]>
  itcPercentageAssumption: Scalars["Float"]["output"]
  latitude: Scalars["Float"]["output"]
  leaseApprovers?: Maybe<Array<Scalars["String"]["output"]>>
  leaseLegalOwnerName?: Maybe<Scalars["String"]["output"]>
  leasePropertyLegalDescription?: Maybe<Scalars["String"]["output"]>
  leaseSignatory?: Maybe<Scalars["String"]["output"]>
  longitude: Scalars["Float"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  needsTenantApproval?: Maybe<Scalars["Boolean"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
  otherNotes?: Maybe<Scalars["String"]["output"]>
  packageRowCloseCustomReason?: Maybe<Scalars["String"]["output"]>
  packageRowCloseReason?: Maybe<PackageRowCloseReason>
  packageRowClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  packageRowIsClosed: Scalars["Boolean"]["output"]
  packageRowStatus?: Maybe<PackageRowStatus>
  pid: Scalars["String"]["output"]
  ppaBuildingOwnerNoiLifetimeUsd?: Maybe<Scalars["Float"]["output"]>
  ppaOfftakerLifetimeSavingsUsd?: Maybe<Scalars["Float"]["output"]>
  ppaPriceEscalator?: Maybe<Scalars["Float"]["output"]>
  ppaPriceY1Usd?: Maybe<Scalars["Float"]["output"]>
  ppaRoofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  ppaRoofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  ppaSystem?: Maybe<System>
  ppaYearOneOfftakerSavingsUsd?: Maybe<Scalars["Float"]["output"]>
  ppaYearOneRoofRentalFee?: Maybe<Scalars["Float"]["output"]>
  propertyFundName?: Maybe<Scalars["String"]["output"]>
  propertyInsurer?: Maybe<Scalars["String"]["output"]>
  propertyLenders?: Maybe<Scalars["String"]["output"]>
  propertySiteVisitContacts?: Maybe<Array<Scalars["String"]["output"]>>
  recOwner: RecOwner
  roofCondition?: Maybe<Scalars["String"]["output"]>
  roofReplacedYr?: Maybe<Scalars["Int"]["output"]>
  roofRightsHolder?: Maybe<RoofRightsHolder>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  salePlannedYear?: Maybe<Scalars["Int"]["output"]>
  salePlans?: Maybe<Scalars["String"]["output"]>
  signatureBlocks?: Maybe<Array<Scalars["String"]["output"]>>
  siteLabels: Array<SiteLabel>
  sitePid: Scalars["String"]["output"]
  sqft?: Maybe<Scalars["Float"]["output"]>
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  targetUtility?: Maybe<Utility>
  tariffProvision?: Maybe<Scalars["Boolean"]["output"]>
  termYears: Scalars["Int"]["output"]
  type: FinProductType
  usableRoofSqft?: Maybe<Scalars["Float"]["output"]>
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  zipCode: Scalars["String"]["output"]
}

export type InvestorBidsTableSort = {
  attr: InvestorBidsTableAttr
  order: SortOrder
}

export type InvestorBidsTableStats = {
  __typename?: "InvestorBidsTableStats"
  financiers: Array<Scalars["String"]["output"]>
  siteNames: Array<Scalars["String"]["output"]>
  siteStates: Array<Scalars["String"]["output"]>
  siteStreetAddresses: Array<Scalars["String"]["output"]>
}

export type InvestorBidsTableView = {
  __typename?: "InvestorBidsTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["String"]["output"]>
  stats: InvestorBidsTableStats
}

export type InvestorDetails = {
  __typename?: "InvestorDetails"
  capex?: Maybe<Scalars["Float"]["output"]>
  investorXlsxHref: Scalars["String"]["output"]
  irrs: IrRs
}

export type InvestorOptOut = {
  __typename?: "InvestorOptOut"
  archivedAt?: Maybe<Scalars["DateTime"]["output"]>
  archivedBy?: Maybe<UserRef>
  createdAt: Scalars["DateTime"]["output"]
  createdBy: UserRef
  customReason?: Maybe<Scalars["String"]["output"]>
  reason?: Maybe<InvestorOptOutReason>
}

export enum InvestorOptOutReason {
  EconomicsInsufficient = "ECONOMICS_INSUFFICIENT",
  NotAPriority = "NOT_A_PRIORITY",
  Other = "OTHER",
  TooSmall = "TOO_SMALL",
  UnsupportedMarkets = "UNSUPPORTED_MARKETS",
}

export type InvestorProfile = {
  __typename?: "InvestorProfile"
  buyBoxes: Array<BuyBox>
  committedFunding?: Maybe<Scalars["String"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  createdBy: UserRef
  description?: Maybe<Scalars["String"]["output"]>
  distinguishingFeatures?: Maybe<Scalars["String"]["output"]>
  experiences: Array<Experience>
  hq?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  investorBacking?: Maybe<Scalars["String"]["output"]>
  longTermOwnershipApproach?: Maybe<Scalars["String"]["output"]>
  managementTeam: Array<Scalars["String"]["output"]>
  subscriptionMgmtApproach?: Maybe<Scalars["String"]["output"]>
  website?: Maybe<Scalars["String"]["output"]>
  yearFounded?: Maybe<Scalars["Int"]["output"]>
}

export type IterBattery = {
  __typename?: "IterBattery"
  product: BatteryProduct
  strategy: DispatchStrategy
}

export type IterPv = {
  __typename?: "IterPV"
  productionKwh: Scalars["Float"]["output"]
  pvType: PvType
  sizeKw: Scalars["Float"]["output"]
}

export type Iteration = {
  __typename?: "Iteration"
  cashPurchaseNpv: Scalars["Float"]["output"]
  marginalCo2Averted?: Maybe<Scalars["Float"]["output"]>
  meters: Array<MeterIteration>
  metric: Scalars["Float"]["output"]
  postTaxItcDeprIrr?: Maybe<Scalars["Float"]["output"]>
  preTaxIrr?: Maybe<Scalars["Float"]["output"]>
}

export type Jurisdiction = {
  __typename?: "Jurisdiction"
  name: Scalars["String"]["output"]
  scope: JurisdictionScope
}

export enum JurisdictionScope {
  County = "COUNTY",
  Federal = "FEDERAL",
  Municipality = "MUNICIPALITY",
  Region = "REGION",
  State = "STATE",
  Utility = "UTILITY",
}

export type KwhFlow = {
  __typename?: "KwhFlow"
  batteryChargeKwh: Scalars["Float"]["output"]
  batteryDischargeKwh: Scalars["Float"]["output"]
  bauLoadKwh: Scalars["Float"]["output"]
  exportsKwh: Scalars["Float"]["output"]
  importsKwh: Scalars["Float"]["output"]
  pvProductionKwh: Scalars["Float"]["output"]
  pvToLoadKwh: Scalars["Float"]["output"]
}

export enum LabelColor {
  Accent_1 = "ACCENT_1",
  Accent_2 = "ACCENT_2",
  Accent_3 = "ACCENT_3",
  BrandPrimary = "BRAND_PRIMARY",
  BrandSecondary = "BRAND_SECONDARY",
  Error = "ERROR",
  Neutral = "NEUTRAL",
  Success = "SUCCESS",
}

export enum LeaseType {
  GrossLease = "GROSS_LEASE",
  NetLease = "NET_LEASE",
  NnnLease = "NNN_LEASE",
  NnLease = "NN_LEASE",
}

export type LicenseAgreement = {
  __typename?: "LicenseAgreement"
  acceptedAt: Scalars["DateTime"]["output"]
  forOrg?: Maybe<Org>
  id: Scalars["Int"]["output"]
  remoteIp?: Maybe<Scalars["String"]["output"]>
  user: UserRef
  version: Scalars["Int"]["output"]
}

export type LineItem = {
  __typename?: "LineItem"
  name: Scalars["String"]["output"]
  usd: Scalars["Float"]["output"]
}

export type LineItemCharge = {
  __typename?: "LineItemCharge"
  chargeType?: Maybe<ChargeType>
  costUsd: Scalars["Float"]["output"]
}

export type LineItem_ = {
  __typename?: "LineItem_"
  costUsd?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  label: Scalars["String"]["output"]
  rate?: Maybe<Scalars["Float"]["output"]>
  unit?: Maybe<Scalars["String"]["output"]>
  volume?: Maybe<Scalars["Float"]["output"]>
}

export enum LoadCategory {
  CommercialTenants = "COMMERCIAL_TENANTS",
  MfCombined = "MF_COMBINED",
  MfHouse = "MF_HOUSE",
  MfTenants = "MF_TENANTS",
}

export type LoadEstimateFailure = {
  __typename?: "LoadEstimateFailure"
  dateCreated: Scalars["DateTime"]["output"]
  errorClass?: Maybe<Scalars["String"]["output"]>
  errorMessage?: Maybe<Scalars["String"]["output"]>
  exception?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  site: SiteRef
}

export enum LoadOrigin {
  Merge = "MERGE",
  MeterIntervals = "METER_INTERVALS",
  ScaledAnnually = "SCALED_ANNUALLY",
  ScaledMonthly = "SCALED_MONTHLY",
  StockEstimate = "STOCK_ESTIMATE",
}

export type LoadOriginPred = {
  value: Array<InputMaybe<LoadOrigin>>
}

export type LoanEconomics = {
  __typename?: "LoanEconomics"
  flows?: Maybe<LoanRecvrCashflows>
  interestPct: Scalars["Float"]["output"]
  loanRecvrXlsxHref: Scalars["String"]["output"]
  loanTermYears: Scalars["Int"]["output"]
  ownershipTermYears: Scalars["Int"]["output"]
  product: LoanFinProduct
  srecToInvestor: Scalars["Boolean"]["output"]
}

export type LoanFinProduct = {
  __typename?: "LoanFinProduct"
  financierName: Scalars["String"]["output"]
  loanDealerFeePct: Scalars["Float"]["output"]
  loanInterestPct: Scalars["Float"]["output"]
  loanTermYears: Scalars["Int"]["output"]
  productName: Scalars["String"]["output"]
}

export type LoanFinProductInput = {
  constructionLoanInterestRate: Scalars["Float"]["input"]
  financierId: Scalars["Int"]["input"]
  investorDiscountRate: Scalars["Float"]["input"]
  loanDealerFeePct: Scalars["Float"]["input"]
  loanInterestPct: Scalars["Float"]["input"]
  loanSpecialPayment: Scalars["Boolean"]["input"]
  loanTermYears: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  status?: InputMaybe<FinProductStatus>
  targetOrgId?: InputMaybe<Scalars["Int"]["input"]>
  targetSiteId?: InputMaybe<Scalars["Int"]["input"]>
  targetSystemId?: InputMaybe<Scalars["Int"]["input"]>
}

export type LoanRecvrCashflows = {
  __typename?: "LoanRecvrCashflows"
  greenLeaseTenantFlows?: Maybe<TenantCashflows>
  monthlyPayment: Scalars["Float"]["output"]
  netCashflowPerYear: Array<Scalars["Float"]["output"]>
  totalCapex: Scalars["Float"]["output"]
  totalItc: Scalars["Float"]["output"]
  totalLoanFunding: Scalars["Float"]["output"]
  totalLoanPayments: Scalars["Float"]["output"]
  totalNet: Scalars["Float"]["output"]
  totalOpex: Scalars["Float"]["output"]
  totalRevenue: Scalars["Float"]["output"]
  totalUtilitySavings: Scalars["Float"]["output"]
}

export type Lux = {
  __typename?: "Lux"
  battKw: Scalars["Float"]["output"]
  battKwh: Scalars["Float"]["output"]
  carportPvSixHighKw: Scalars["Float"]["output"]
  carportPvThreeHighKw: Scalars["Float"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  etbReport?: Maybe<EtbReport>
  finmodel?: Maybe<Finmodel>
  fmvNum: Scalars["Int"]["output"]
  fmvStr: Scalars["String"]["output"]
  goal: PVoptGoal
  id: Scalars["Int"]["output"]
  isMultimeter: Scalars["Boolean"]["output"]
  iterations: Array<Iteration>
  maxOffsetPct?: Maybe<Scalars["Float"]["output"]>
  meterSet: MeterSet
  meters: Array<LuxMeter>
  postLuxYear: Scalars["Int"]["output"]
  pvKw: Scalars["Float"]["output"]
  roofPvKw: Scalars["Float"]["output"]
  scenario: ScenarioRef
  site: SiteRef
}

export type LuxMeter = {
  __typename?: "LuxMeter"
  bauMeter: BauMeter
  bauTariff: TariffRate
  createdAt: Scalars["DateTime"]["output"]
  dayIntervals: DayIntervals
  gridMeter?: Maybe<GridMeter>
  id: Scalars["Int"]["output"]
  lux: Lux
  postBatteryMeter?: Maybe<PostBatteryMeter>
  postSolarMeter?: Maybe<PostSolarMeter>
}

export type LuxRef = {
  __typename?: "LuxRef"
  id: Scalars["Int"]["output"]
}

export type MfUnitBreakdownInput = {
  numUnits1Bd?: InputMaybe<Scalars["Int"]["input"]>
  numUnits2Bd?: InputMaybe<Scalars["Int"]["input"]>
  numUnits3Bd?: InputMaybe<Scalars["Int"]["input"]>
  numUnits4Bd?: InputMaybe<Scalars["Int"]["input"]>
  numUnitsStudio?: InputMaybe<Scalars["Int"]["input"]>
}

export type MagicLink = {
  __typename?: "MagicLink"
  city: Scalars["String"]["output"]
  country: Scalars["String"]["output"]
  dateCreated: Scalars["DateTime"]["output"]
  expiresAt: Scalars["DateTime"]["output"]
  href: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  latitude?: Maybe<Scalars["Float"]["output"]>
  longitude?: Maybe<Scalars["Float"]["output"]>
  pid: Scalars["String"]["output"]
  region: Scalars["String"]["output"]
  remoteAddr: Scalars["String"]["output"]
  tz: Scalars["String"]["output"]
  user: UserRef
  userAgent: Scalars["String"]["output"]
}

export type MapSolarPanel = {
  __typename?: "MapSolarPanel"
  angle: Scalars["Float"]["output"]
  latitude: Scalars["Float"]["output"]
  longitude: Scalars["Float"]["output"]
}

export type MapView = {
  __typename?: "MapView"
  lat: Scalars["Float"]["output"]
  lon: Scalars["Float"]["output"]
  pid: Scalars["String"]["output"]
}

export type MarketplaceMutations = {
  __typename?: "MarketplaceMutations"
  updateBundleParentRow: BundleParentRowError
}

export type MarketplaceMutationsUpdateBundleParentRowArgs = {
  bundleParentRowId: Scalars["Int"]["input"]
  inputs: MarketplaceRowInputs
}

export type MarketplaceRowInputs = {
  hubspotRecordId?: InputMaybe<Scalars["String"]["input"]>
  lumenFeeUsdPerWatt?: InputMaybe<Scalars["Float"]["input"]>
  lumenRevenue?: InputMaybe<Scalars["Float"]["input"]>
  milestones?: InputMaybe<AllMilestonesInput>
  opsOwnerPid?: InputMaybe<Scalars["String"]["input"]>
  salesOwnerPid?: InputMaybe<Scalars["String"]["input"]>
}

export type MarketplaceSiteSearchTerm = {
  __typename?: "MarketplaceSiteSearchTerm"
  address: Scalars["String"]["output"]
  packagePid: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  propertyName?: Maybe<Scalars["String"]["output"]>
}

export enum MarketplaceStatus {
  CollectingBids = "COLLECTING_BIDS",
  NegotiatingContracts = "NEGOTIATING_CONTRACTS",
  PendingCod = "PENDING_COD",
  PendingNtp = "PENDING_NTP",
  ReviewingBids = "REVIEWING_BIDS",
  Shipped = "SHIPPED",
}

export type Message = {
  __typename?: "Message"
  content: Array<TextContentImageContentFileContent>
  functionCall?: Maybe<Scalars["String"]["output"]>
  role: Role
  toolCalls?: Maybe<Array<ToolCall>>
}

export type MeterCalc = {
  __typename?: "MeterCalc"
  costSummary: CostSummary
  createdAt: Scalars["DateTime"]["output"]
  exports: CleanIntervals
  id: Scalars["Int"]["output"]
  imports: CleanIntervals
  pvProduction: CleanIntervals
  tariffRate: TariffRate
}

export type MeterIteration = {
  __typename?: "MeterIteration"
  battery?: Maybe<IterBattery>
  bauMeterId: Scalars["Int"]["output"]
  costSummary: SlimCostSummary
  marginalCo2Averted?: Maybe<Scalars["Float"]["output"]>
  pv: Array<IterPv>
  totalPvKw: Scalars["Float"]["output"]
}

export type MeterSet = {
  __typename?: "MeterSet"
  createdAt: Scalars["DateTime"]["output"]
  createdBy?: Maybe<UserRef>
  id: Scalars["Int"]["output"]
  intervalsBauXlsxHref?: Maybe<Scalars["String"]["output"]>
  loadKwh?: Maybe<Scalars["Float"]["output"]>
  loadMaxKw?: Maybe<Scalars["Float"]["output"]>
  loadOrigin?: Maybe<LoadOrigin>
  meterSources: Array<MeterSource>
  meters: Array<BauMeter>
  pid: Scalars["String"]["output"]
  rollup: Array<DailyRollup>
  totalCost: Scalars["Float"]["output"]
}

export enum MeterSource {
  Bill = "BILL",
  Comstock = "COMSTOCK",
  Merge = "MERGE",
  Resstock = "RESSTOCK",
  Upload = "UPLOAD",
  UtilityApi = "UTILITY_API",
}

export type Meter_ = {
  __typename?: "Meter_"
  id?: Maybe<Scalars["Int"]["output"]>
  lineItems: Array<LineItem_>
  maxKw?: Maybe<Scalars["Float"]["output"]>
  meterId: Scalars["String"]["output"]
  peakKw?: Maybe<Scalars["Float"]["output"]>
  serviceAccount?: Maybe<Scalars["String"]["output"]>
  serviceAddress?: Maybe<Scalars["String"]["output"]>
  tariffLabel: Scalars["String"]["output"]
  tariffParentId?: Maybe<Scalars["Int"]["output"]>
  totalCostUsd?: Maybe<Scalars["Float"]["output"]>
  totalKwh?: Maybe<Scalars["Float"]["output"]>
}

export enum Metering {
  MasterMetered = "MASTER_METERED",
  SubMetered = "SUB_METERED",
  UtilityMetered = "UTILITY_METERED",
  UtilityMeteredCommonsRubs = "UTILITY_METERED_COMMONS_RUBS",
}

export type MeteringPred = {
  value: Array<InputMaybe<Metering>>
}

export type MilestoneSummary = {
  __typename?: "MilestoneSummary"
  awardedToDeveloperActual?: Maybe<Scalars["Date"]["output"]>
  awardedToDeveloperEstimated?: Maybe<Scalars["Date"]["output"]>
  biddingClosedActual?: Maybe<Scalars["Date"]["output"]>
  biddingClosedEstimated?: Maybe<Scalars["Date"]["output"]>
  biddingOpenedActual?: Maybe<Scalars["Date"]["output"]>
  biddingOpenedEstimated?: Maybe<Scalars["Date"]["output"]>
  bidsPresentedActual?: Maybe<Scalars["Date"]["output"]>
  bidsPresentedEstimated?: Maybe<Scalars["Date"]["output"]>
  codActual?: Maybe<Scalars["Date"]["output"]>
  codEstimated?: Maybe<Scalars["Date"]["output"]>
  csProgramApprovedActual?: Maybe<Scalars["Date"]["output"]>
  csProgramApprovedEstimated?: Maybe<Scalars["Date"]["output"]>
  csProgramSubmittedActual?: Maybe<Scalars["Date"]["output"]>
  csProgramSubmittedEstimated?: Maybe<Scalars["Date"]["output"]>
  ixApprovedActual?: Maybe<Scalars["Date"]["output"]>
  ixApprovedEstimated?: Maybe<Scalars["Date"]["output"]>
  ixSubmittedActual?: Maybe<Scalars["Date"]["output"]>
  ixSubmittedEstimated?: Maybe<Scalars["Date"]["output"]>
  leaseSignedActual?: Maybe<Scalars["Date"]["output"]>
  leaseSignedEstimated?: Maybe<Scalars["Date"]["output"]>
  ntpActual?: Maybe<Scalars["Date"]["output"]>
  ntpEstimated?: Maybe<Scalars["Date"]["output"]>
  rofoSignedActual?: Maybe<Scalars["Date"]["output"]>
  rofoSignedEstimated?: Maybe<Scalars["Date"]["output"]>
}

export type MonthlyBill2 = {
  __typename?: "MonthlyBill2"
  end: Scalars["Date"]["output"]
  sections: Array<BillGroup>
  start: Scalars["Date"]["output"]
}

export type MoreDetails = {
  __typename?: "MoreDetails"
  cashPurchaseNpv: Scalars["Float"]["output"]
  failureId?: Maybe<Scalars["Int"]["output"]>
  finmodelInputs: Scalars["JSON"]["output"]
  finmodelOutputs: Scalars["JSON"]["output"]
  lineage: Array<RevampFinmodel>
  luxId?: Maybe<Scalars["Int"]["output"]>
  pvCostPerWatt?: Maybe<Scalars["Float"]["output"]>
  storageCostPerKwh?: Maybe<Scalars["Float"]["output"]>
  totalInstallCost?: Maybe<Scalars["Float"]["output"]>
}

export type Mutation = {
  __typename?: "Mutation"
  bundleRows: BundleRowMutations
  draftSite: DraftSiteMutations
  etb: EtbMutations
  etbMeter: EtbMeterMutations
  finmodel: FinmodelMutations
  finproduct: FinProductMutations
  googleApi: GoogleApiMutations
  helioscopes: AdminHelioscopeMutations
  hostingCapacityMaps: HostingCapacityMapMutations
  marketplace: MarketplaceMutations
  note: AdminNoteMutations
  openInvite: AdminOpenInviteMutations
  orgs: AdminOrgMutations
  overrideFinmodelFailure: GuardrailOverrideResultError
  portfolio: PortfolioMutations
  promoteTheFinmodelAnyway?: Maybe<Scalars["Void"]["output"]>
  queue: QueueMutations
  scenario: ScenarioMutations
  site: SiteMutations
  tariff: TariffMutations
  todos: TodoMutations
  trashGuardrailOverride?: Maybe<Error>
  updateMfUnits?: Maybe<Scalars["Void"]["output"]>
  user: AdminUserMutations
  utility: UtilityMutations
}

export type MutationEtbArgs = {
  etbId: Scalars["Int"]["input"]
}

export type MutationOverrideFinmodelFailureArgs = {
  finmodelFailureId: Scalars["Int"]["input"]
  names: Array<Scalars["String"]["input"]>
  note?: InputMaybe<Scalars["String"]["input"]>
  scope: GuardrailScope
}

export type MutationPromoteTheFinmodelAnywayArgs = {
  finmodelId: Scalars["Int"]["input"]
}

export type MutationScenarioArgs = {
  scenarioPid: Scalars["String"]["input"]
}

export type MutationTrashGuardrailOverrideArgs = {
  guardrailId: Scalars["Int"]["input"]
}

export type MutationUpdateMfUnitsArgs = {
  input: MfUnitBreakdownInput
  sitePid: Scalars["String"]["input"]
}

export type NameThatTariffDetail = {
  __typename?: "NameThatTariffDetail"
  groups: Array<BillGroup>
  result: NameThatTariffResult
  tariff: Tariff
}

export type NameThatTariffResult = {
  __typename?: "NameThatTariffResult"
  actual: BillMonth
  delta: TariffDeltas
  document: Document
  expected: BillMonth
  notTheCorrectRateVersion: Scalars["Boolean"]["output"]
  rate: TariffRate
}

export type NewSite = {
  __typename?: "NewSite"
  dateCreated: Scalars["DateTime"]["output"]
  pid: Scalars["String"]["output"]
}

export type NewUserResponse = AdminUser | Error

export type Note = {
  __typename?: "Note"
  createdAt: Scalars["DateTime"]["output"]
  createdBy: UserRef
  pid: Scalars["String"]["output"]
  text: Scalars["String"]["output"]
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>
  updatedBy?: Maybe<UserRef>
}

export type NumberValue = {
  __typename?: "NumberValue"
  number: Scalars["Float"]["output"]
}

export enum OfferStatus {
  Estimated = "ESTIMATED",
  Final = "FINAL",
  PpaContract = "PPA_CONTRACT",
  TermSheet = "TERM_SHEET",
  Unavailable = "UNAVAILABLE",
  Verified = "VERIFIED",
}

export enum OpType {
  Add = "ADD",
  OverrideProperty = "OVERRIDE_PROPERTY",
  Sub = "SUB",
}

export type OpsBillCalc = {
  __typename?: "OpsBillCalc"
  details: Array<BillGroup>
  end: Scalars["Date"]["output"]
  start: Scalars["Date"]["output"]
  summary: Array<ChargeTypeCost>
}

export type Org = {
  __typename?: "Org"
  allLabels: Array<SiteLabel>
  awardedProjects: AwardedProjectTable
  bestCsSite?: Maybe<BestCommunitySolarSite>
  bid?: Maybe<InvestorBid>
  bidPackage?: Maybe<BidPackage>
  bidPackageBids: InvestorBidsTable
  bidPackageSites: BidPackageSitesTable
  bidPackageSpecs: BidSpecsTable
  bidPackages: Array<BidPackage>
  bundles: Array<Bundle2>
  csvImports: CsvImportQuery
  currentUserPermissions: Array<Permission>
  description?: Maybe<Scalars["String"]["output"]>
  financierProjects: FinancierProjectTable
  finproducts: Array<FinProductRef>
  inactivityTimeoutMs?: Maybe<Scalars["Int"]["output"]>
  investorProfile: InvestorProfile
  irrFlavor: IrrType
  isDeveloper: Scalars["Boolean"]["output"]
  /** @deprecated use is_developer */
  isFinancier: Scalars["Boolean"]["output"]
  logoUrl?: Maybe<Scalars["String"]["output"]>
  logomarkUrl?: Maybe<Scalars["String"]["output"]>
  mapView: Array<MapView>
  marketplaceSiteSearchTerms: Array<MarketplaceSiteSearchTerm>
  name: Scalars["String"]["output"]
  orgUsers: Array<OrgUser>
  pid: Scalars["String"]["output"]
  portfolioPdfReportHref?: Maybe<Scalars["String"]["output"]>
  portfolios: Array<PortfolioRef>
  /** @deprecated use is_developer */
  revampIsFinancier: Scalars["Boolean"]["output"]
  shine: ShineOrg
  site?: Maybe<RevampSite>
  siteBids: SiteBidsTable
  siteFromPortfolioBuildingData?: Maybe<SiteRef>
  siteSearchTerms: Array<SiteSearchTerm>
  sites: OrgSiteTable
  slug: Scalars["String"]["output"]
  unclaimedInvites: Array<AdminInvitation>
  userRoles: Array<UserRole>
  users: Array<UserRef>
}

export type OrgBidArgs = {
  pid: Scalars["String"]["input"]
}

export type OrgBidPackageArgs = {
  pid: Scalars["String"]["input"]
}

export type OrgSiteArgs = {
  pid: Scalars["String"]["input"]
}

export type OrgSiteBidsArgs = {
  sitePid: Scalars["String"]["input"]
}

export type OrgSiteFromPortfolioBuildingDataArgs = {
  buildingDataId: Scalars["Int"]["input"]
  portfolioPid: Scalars["String"]["input"]
}

export type OrgRef = {
  __typename?: "OrgRef"
  logoUrl: Scalars["String"]["output"]
  logomarkUrl?: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  orgSlug: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  profile?: Maybe<InvestorProfile>
}

export type OrgSiteTable = {
  __typename?: "OrgSiteTable"
  rows: Array<OrgSiteTableRow>
  view: OrgSiteTableView
}

export type OrgSiteTableRowsArgs = {
  keys: Array<Scalars["String"]["input"]>
}

export type OrgSiteTableViewArgs = {
  filterBy?: InputMaybe<OrgSiteTableFilter>
  sortBy?: InputMaybe<Array<OrgSiteTableSort>>
}

export enum OrgSiteTableAttr {
  AssetManager = "ASSET_MANAGER",
  BauCo2EmissionsTons = "BAU_CO2_EMISSIONS_TONS",
  BauCo2EmissionsTonsPerMwh = "BAU_CO2_EMISSIONS_TONS_PER_MWH",
  BuildingClass = "BUILDING_CLASS",
  BuildingFootprintCount = "BUILDING_FOOTPRINT_COUNT",
  BuildingFootprintRoofSqftError = "BUILDING_FOOTPRINT_ROOF_SQFT_ERROR",
  BuildingFootprintSqft = "BUILDING_FOOTPRINT_SQFT",
  BuildingSqftRoofSqftError = "BUILDING_SQFT_ROOF_SQFT_ERROR",
  BuildingType = "BUILDING_TYPE",
  CarportMaxPvKw = "CARPORT_MAX_PV_KW",
  CbsaName = "CBSA_NAME",
  City = "CITY",
  Co2EmissionsReductionTonnesPpaMax = "CO2_EMISSIONS_REDUCTION_TONNES_PPA_MAX",
  Co2EmissionsReductionTonnesSelfMax = "CO2_EMISSIONS_REDUCTION_TONNES_SELF_MAX",
  CostPerKwhPpaMax = "COST_PER_KWH_PPA_MAX",
  County = "COUNTY",
  CustomerId = "CUSTOMER_ID",
  ExistingSolarDetectionScore = "EXISTING_SOLAR_DETECTION_SCORE",
  GpvLoanMax = "GPV_LOAN_MAX",
  GpvPpaMax = "GPV_PPA_MAX",
  GpvSelfMax = "GPV_SELF_MAX",
  GroundMaxPvKw = "GROUND_MAX_PV_KW",
  IncludeStoragePpaMax = "INCLUDE_STORAGE_PPA_MAX",
  IncludeStorageSelfMax = "INCLUDE_STORAGE_SELF_MAX",
  InEnergyCommunity = "IN_ENERGY_COMMUNITY",
  InLowIncomeCommunity = "IN_LOW_INCOME_COMMUNITY",
  IrrSelfMax = "IRR_SELF_MAX",
  IsBidding = "IS_BIDDING",
  IsFavorite = "IS_FAVORITE",
  Latitude = "LATITUDE",
  LeaseType = "LEASE_TYPE",
  LeDevFeeLoanMax = "LE_DEV_FEE_LOAN_MAX",
  LeDevFeePpaMax = "LE_DEV_FEE_PPA_MAX",
  LeDevFeeSelfMax = "LE_DEV_FEE_SELF_MAX",
  LifetimeCapexSelfMax = "LIFETIME_CAPEX_SELF_MAX",
  LifetimeUtilitySavingsPpaMax = "LIFETIME_UTILITY_SAVINGS_PPA_MAX",
  LifetimeUtilitySavingsSelfMax = "LIFETIME_UTILITY_SAVINGS_SELF_MAX",
  LoadKwh = "LOAD_KWH",
  LoadOrigin = "LOAD_ORIGIN",
  LoadUsd = "LOAD_USD",
  LoadUsdPerKwh = "LOAD_USD_PER_KWH",
  Longitude = "LONGITUDE",
  MarketplaceClosedAt = "MARKETPLACE_CLOSED_AT",
  MarketplaceCloseCustomReason = "MARKETPLACE_CLOSE_CUSTOM_REASON",
  MarketplaceCloseReason = "MARKETPLACE_CLOSE_REASON",
  MarketplaceStatus = "MARKETPLACE_STATUS",
  Metering = "METERING",
  MeterCount = "METER_COUNT",
  MortgageLender = "MORTGAGE_LENDER",
  Name = "NAME",
  NoiCsMax = "NOI_CS_MAX",
  NoiLeaseMax = "NOI_LEASE_MAX",
  NoiLoanMax = "NOI_LOAN_MAX",
  NoiPpaMax = "NOI_PPA_MAX",
  NoiRangeMax = "NOI_RANGE_MAX",
  NoiRangeMin = "NOI_RANGE_MIN",
  NoiSelfMax = "NOI_SELF_MAX",
  NumStories = "NUM_STORIES",
  NumUnitsTotal = "NUM_UNITS_TOTAL",
  OccupancyType = "OCCUPANCY_TYPE",
  OwnerName = "OWNER_NAME",
  Portfolio = "PORTFOLIO",
  PpaEscPpaMax = "PPA_ESC_PPA_MAX",
  PpaOfftaker = "PPA_OFFTAKER",
  PpaSignatory = "PPA_SIGNATORY",
  PvSizeKwCsMax = "PV_SIZE_KW_CS_MAX",
  PvSizeKwPpaMax = "PV_SIZE_KW_PPA_MAX",
  PvSizeKwSelfMax = "PV_SIZE_KW_SELF_MAX",
  RoofCondition = "ROOF_CONDITION",
  RoofMaxPvKw = "ROOF_MAX_PV_KW",
  RoofReplacedYr = "ROOF_REPLACED_YR",
  RoofSqft = "ROOF_SQFT",
  SalePlannedYear = "SALE_PLANNED_YEAR",
  SalePlans = "SALE_PLANS",
  SiteLabels = "SITE_LABELS",
  SolarLocationPpaMax = "SOLAR_LOCATION_PPA_MAX",
  SolarLocationSelfMax = "SOLAR_LOCATION_SELF_MAX",
  SoleTariffName = "SOLE_TARIFF_NAME",
  Sqft = "SQFT",
  State = "STATE",
  Status = "STATUS",
  StatusCustomReason = "STATUS_CUSTOM_REASON",
  StatusReason = "STATUS_REASON",
  StorageSizeKwhPpaMax = "STORAGE_SIZE_KWH_PPA_MAX",
  StorageSizeKwhSelfMax = "STORAGE_SIZE_KWH_SELF_MAX",
  StorageSizeKwPpaMax = "STORAGE_SIZE_KW_PPA_MAX",
  StorageSizeKwSelfMax = "STORAGE_SIZE_KW_SELF_MAX",
  StreetAddress = "STREET_ADDRESS",
  TenantInterest = "TENANT_INTEREST",
  TenantLeaseEnds = "TENANT_LEASE_ENDS",
  TenantLeaseTerm = "TENANT_LEASE_TERM",
  UsableRoofSqft = "USABLE_ROOF_SQFT",
  UtilityCagr = "UTILITY_CAGR",
  UtilityName = "UTILITY_NAME",
  UtilityShortName = "UTILITY_SHORT_NAME",
  YearBuilt = "YEAR_BUILT",
  YearOneOfftakerSavingsPpaMax = "YEAR_ONE_OFFTAKER_SAVINGS_PPA_MAX",
  ZipCode = "ZIP_CODE",
}

export type OrgSiteTableFilter = {
  assetManager?: InputMaybe<StringPred>
  bauCo2EmissionsTons?: InputMaybe<FloatPred>
  bauCo2EmissionsTonsPerMwh?: InputMaybe<FloatPred>
  buildingClass?: InputMaybe<StringPred>
  buildingFootprintCount?: InputMaybe<IntPred>
  buildingFootprintRoofSqftError?: InputMaybe<FloatPred>
  buildingFootprintSqft?: InputMaybe<FloatPred>
  buildingSqftRoofSqftError?: InputMaybe<FloatPred>
  buildingType?: InputMaybe<BuildingTypePred>
  carportMaxPvKw?: InputMaybe<FloatPred>
  cbsaName?: InputMaybe<StringPred>
  city?: InputMaybe<StringPred>
  co2EmissionsReductionTonnesPpaMax?: InputMaybe<FloatPred>
  co2EmissionsReductionTonnesSelfMax?: InputMaybe<FloatPred>
  costPerKwhPpaMax?: InputMaybe<FloatPred>
  county?: InputMaybe<StringPred>
  energyThings?: InputMaybe<EnergyThingsPred>
  existingSolarDetectionScore?: InputMaybe<IntPred>
  financingThings?: InputMaybe<FinancingThingsPred>
  flagSummary?: InputMaybe<SiteFlagSummaryPred>
  gpvLoanMax?: InputMaybe<FloatPred>
  gpvPpaMax?: InputMaybe<FloatPred>
  gpvSelfMax?: InputMaybe<FloatPred>
  groundMaxPvKw?: InputMaybe<FloatPred>
  inEnergyCommunity?: InputMaybe<BoolPred>
  inLowIncomeCommunity?: InputMaybe<BoolPred>
  includeStoragePpaMax?: InputMaybe<BoolPred>
  includeStorageSelfMax?: InputMaybe<BoolPred>
  irrSelfMax?: InputMaybe<FloatPred>
  isBidding?: InputMaybe<BoolPred>
  isFavorite?: InputMaybe<BoolPred>
  latitude?: InputMaybe<FloatPred>
  leDevFeeLoanMax?: InputMaybe<FloatPred>
  leDevFeePpaMax?: InputMaybe<FloatPred>
  leDevFeeSelfMax?: InputMaybe<FloatPred>
  lifetimeCapexSelfMax?: InputMaybe<FloatPred>
  lifetimeUtilitySavingsPpaMax?: InputMaybe<FloatPred>
  lifetimeUtilitySavingsSelfMax?: InputMaybe<FloatPred>
  loadKwh?: InputMaybe<FloatPred>
  loadOrigin?: InputMaybe<LoadOriginPred>
  loadUsd?: InputMaybe<FloatPred>
  loadUsdPerKwh?: InputMaybe<FloatPred>
  longitude?: InputMaybe<FloatPred>
  marketplaceStatus?: InputMaybe<PackageRowStatusPred>
  meterCount?: InputMaybe<FloatPred>
  metering?: InputMaybe<MeteringPred>
  noiCsMax?: InputMaybe<FloatPred>
  noiLeaseMax?: InputMaybe<FloatPred>
  noiLoanMax?: InputMaybe<FloatPred>
  noiPpaMax?: InputMaybe<FloatPred>
  noiSelfMax?: InputMaybe<FloatPred>
  numStories?: InputMaybe<IntPred>
  numUnitsTotal?: InputMaybe<IntPred>
  ownerName?: InputMaybe<StringPred>
  pid?: InputMaybe<StringPred>
  portfolio?: InputMaybe<StringPred>
  ppaEscPpaMax?: InputMaybe<FloatPred>
  pvSizeKwCsMax?: InputMaybe<FloatPred>
  pvSizeKwPpaMax?: InputMaybe<FloatPred>
  pvSizeKwSelfMax?: InputMaybe<FloatPred>
  roofMaxPvKw?: InputMaybe<FloatPred>
  roofReplacedYr?: InputMaybe<FloatPred>
  roofSqft?: InputMaybe<FloatPred>
  salePlannedYear?: InputMaybe<IntPred>
  salePlans?: InputMaybe<YesNoUnsurePred>
  search?: InputMaybe<SearchPred>
  siteLabels?: InputMaybe<SiteLabelNamesPred>
  solarLocationPpaMax?: InputMaybe<SolarLocationPred>
  solarLocationSelfMax?: InputMaybe<SolarLocationPred>
  sqft?: InputMaybe<FloatPred>
  state?: InputMaybe<UsStateMultiPred>
  status?: InputMaybe<SiteStatusPred>
  statusReason?: InputMaybe<StringPred>
  storageSizeKwPpaMax?: InputMaybe<FloatPred>
  storageSizeKwSelfMax?: InputMaybe<FloatPred>
  storageSizeKwhPpaMax?: InputMaybe<FloatPred>
  storageSizeKwhSelfMax?: InputMaybe<FloatPred>
  tenantInterest?: InputMaybe<YesNoUnsurePred>
  usableRoofSqft?: InputMaybe<FloatPred>
  utilityCagr?: InputMaybe<FloatPred>
  utilityName?: InputMaybe<StringPred>
  yearBuilt?: InputMaybe<IntPred>
  yearOneOfftakerSavingsPpaMax?: InputMaybe<FloatPred>
}

export type OrgSiteTableRow = {
  __typename?: "OrgSiteTableRow"
  assetManager?: Maybe<Scalars["String"]["output"]>
  bauCo2EmissionsTons?: Maybe<Scalars["Float"]["output"]>
  bauCo2EmissionsTonsPerMwh?: Maybe<Scalars["Float"]["output"]>
  buildingClass?: Maybe<Scalars["String"]["output"]>
  buildingFootprintCount?: Maybe<Scalars["Int"]["output"]>
  buildingFootprintRoofSqftError?: Maybe<Scalars["Float"]["output"]>
  buildingFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  buildingSqftRoofSqftError?: Maybe<Scalars["Float"]["output"]>
  buildingType?: Maybe<BuildingType>
  carportMaxPvKw: Scalars["Float"]["output"]
  cbsaName?: Maybe<Scalars["String"]["output"]>
  city: Scalars["String"]["output"]
  co2EmissionsReductionTonnesPpaMax?: Maybe<Scalars["Float"]["output"]>
  co2EmissionsReductionTonnesSelfMax?: Maybe<Scalars["Float"]["output"]>
  costPerKwhPpaMax?: Maybe<Scalars["Float"]["output"]>
  county: Scalars["String"]["output"]
  customerId?: Maybe<Scalars["String"]["output"]>
  energyThings?: Maybe<EnergyThings>
  existingSolarDetectionScore?: Maybe<Scalars["Int"]["output"]>
  financingThings?: Maybe<FinancingThings>
  flagSummary?: Maybe<SiteFlagSummary>
  footprint?: Maybe<Footprint>
  gpvLoanMax?: Maybe<Scalars["Float"]["output"]>
  gpvPpaMax?: Maybe<Scalars["Float"]["output"]>
  gpvSelfMax?: Maybe<Scalars["Float"]["output"]>
  groundMaxPvKw?: Maybe<Scalars["Float"]["output"]>
  inEnergyCommunity: Scalars["Boolean"]["output"]
  inLowIncomeCommunity: Scalars["Boolean"]["output"]
  includeStoragePpaMax?: Maybe<Scalars["Boolean"]["output"]>
  includeStorageSelfMax?: Maybe<Scalars["Boolean"]["output"]>
  irrSelfMax?: Maybe<Scalars["Float"]["output"]>
  isBidding: Scalars["Boolean"]["output"]
  isFavorite: Scalars["Boolean"]["output"]
  latitude: Scalars["Float"]["output"]
  leDevFeeLoanMax?: Maybe<Scalars["Float"]["output"]>
  leDevFeePpaMax?: Maybe<Scalars["Float"]["output"]>
  leDevFeeSelfMax?: Maybe<Scalars["Float"]["output"]>
  leaseType?: Maybe<LeaseType>
  lifetimeCapexSelfMax?: Maybe<Scalars["Float"]["output"]>
  lifetimeUtilitySavingsPpaMax?: Maybe<Scalars["Float"]["output"]>
  lifetimeUtilitySavingsSelfMax?: Maybe<Scalars["Float"]["output"]>
  loadKwh?: Maybe<Scalars["Float"]["output"]>
  loadOrigin?: Maybe<LoadOrigin>
  loadUsd?: Maybe<Scalars["Float"]["output"]>
  loadUsdPerKwh?: Maybe<Scalars["Float"]["output"]>
  longitude: Scalars["Float"]["output"]
  marketplaceCloseCustomReason?: Maybe<Scalars["String"]["output"]>
  marketplaceCloseReason?: Maybe<PackageRowCloseReason>
  marketplaceClosedAt?: Maybe<Scalars["String"]["output"]>
  marketplaceStatus?: Maybe<PackageRowStatus>
  meterCount: Scalars["Int"]["output"]
  metering?: Maybe<Metering>
  mortgageLender?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  noiCsMax?: Maybe<Scalars["Float"]["output"]>
  noiLeaseMax?: Maybe<Scalars["Float"]["output"]>
  noiLoanMax?: Maybe<Scalars["Float"]["output"]>
  noiPpaMax?: Maybe<Scalars["Float"]["output"]>
  noiRangeMax?: Maybe<Scalars["Float"]["output"]>
  noiRangeMin?: Maybe<Scalars["Float"]["output"]>
  noiSelfMax?: Maybe<Scalars["Float"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
  occupancyType?: Maybe<BuildingOccupancyType>
  ownerName?: Maybe<Scalars["String"]["output"]>
  physicalCheck?: Maybe<PhysicalCheck>
  pid: Scalars["String"]["output"]
  portfolio: Scalars["String"]["output"]
  ppaEscPpaMax?: Maybe<Scalars["Float"]["output"]>
  ppaOfftaker?: Maybe<PpaOfftaker>
  ppaSignatory?: Maybe<Scalars["String"]["output"]>
  pvSizeKwCsMax?: Maybe<Scalars["Float"]["output"]>
  pvSizeKwPpaMax?: Maybe<Scalars["Float"]["output"]>
  pvSizeKwSelfMax?: Maybe<Scalars["Float"]["output"]>
  roofCondition?: Maybe<Scalars["String"]["output"]>
  roofMaxPvKw: Scalars["Float"]["output"]
  roofReplacedYr?: Maybe<Scalars["Int"]["output"]>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  salePlannedYear?: Maybe<Scalars["Int"]["output"]>
  salePlans?: Maybe<Scalars["String"]["output"]>
  siteLabels: Array<SiteLabel>
  solarLocationPpaMax?: Maybe<SolarLocation>
  solarLocationSelfMax?: Maybe<SolarLocation>
  soleTariffCode?: Maybe<Scalars["String"]["output"]>
  soleTariffName?: Maybe<Scalars["String"]["output"]>
  sqft?: Maybe<Scalars["Float"]["output"]>
  state: Scalars["String"]["output"]
  status: SiteStatus
  statusCustomReason?: Maybe<Scalars["String"]["output"]>
  statusReason?: Maybe<StatusReason>
  storageSizeKwPpaMax?: Maybe<Scalars["Float"]["output"]>
  storageSizeKwSelfMax?: Maybe<Scalars["Float"]["output"]>
  storageSizeKwhPpaMax?: Maybe<Scalars["Float"]["output"]>
  storageSizeKwhSelfMax?: Maybe<Scalars["Float"]["output"]>
  streetAddress: Scalars["String"]["output"]
  tenantInterest?: Maybe<YesNoUnsure>
  tenantLeaseEnds?: Maybe<Scalars["DateTime"]["output"]>
  tenantLeaseTerm?: Maybe<Scalars["String"]["output"]>
  usableRoofSqft?: Maybe<Scalars["Float"]["output"]>
  utilityCagr?: Maybe<Scalars["Float"]["output"]>
  utilityCagrFromYear?: Maybe<Scalars["Int"]["output"]>
  utilityCagrToYear?: Maybe<Scalars["Int"]["output"]>
  utilityName?: Maybe<Scalars["String"]["output"]>
  utilityShortName?: Maybe<Scalars["String"]["output"]>
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  yearOneOfftakerSavingsPpaMax?: Maybe<Scalars["Float"]["output"]>
  zipCode: Scalars["String"]["output"]
}

export type OrgSiteTableSort = {
  attr: OrgSiteTableAttr
  order: SortOrder
}

export type OrgSiteTableStats = {
  __typename?: "OrgSiteTableStats"
  annualNoi: Scalars["Float"]["output"]
  assetManagers: Array<Scalars["String"]["output"]>
  buildingClasses: Array<Scalars["String"]["output"]>
  buildingTypes: Array<BuildingType>
  cashAnnualNoi: Scalars["Float"]["output"]
  cashCo2EmissionsReductionTonnes: Scalars["Float"]["output"]
  cashMaxPvSizeKw: Scalars["Float"]["output"]
  cbsaNames: Array<Scalars["String"]["output"]>
  co2EmissionsReductionTonnes: Scalars["Float"]["output"]
  counties: Array<Scalars["String"]["output"]>
  coveredStates: Array<Scalars["String"]["output"]>
  csAnnualNoi: Scalars["Float"]["output"]
  csMaxPvSizeKw: Scalars["Float"]["output"]
  maxPvSizeKw: Scalars["Float"]["output"]
  ownerNames: Array<Scalars["String"]["output"]>
  portfolios: Array<Scalars["String"]["output"]>
  ppaAnnualNoi: Scalars["Float"]["output"]
  ppaCo2EmissionsReductionTonnes: Scalars["Float"]["output"]
  ppaMaxPvSizeKw: Scalars["Float"]["output"]
  utilityNames: Array<Scalars["String"]["output"]>
}

export type OrgSiteTableView = {
  __typename?: "OrgSiteTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["String"]["output"]>
  stats: OrgSiteTableStats
}

export type OrgUser = {
  __typename?: "OrgUser"
  user: UserRef
  userRoles: Array<UserRole>
}

export type Overridable = {
  __typename?: "Overridable"
  name: Scalars["String"]["output"]
  type: InputType
}

export type OverrideProperty = {
  __typename?: "OverrideProperty"
  keyName: Scalars["String"]["output"]
  op: OpType
  propertyValue: Scalars["String"]["output"]
}

export type OverridePropertyInput = {
  keyName: Scalars["String"]["input"]
  propertyValue: Scalars["String"]["input"]
}

export type PpaBidSpec = {
  __typename?: "PPABidSpec"
  archivedAt?: Maybe<Scalars["DateTime"]["output"]>
  archivedBy?: Maybe<UserRef>
  buildingOwnerExtraPaymentsUsd?: Maybe<Array<Scalars["Float"]["output"]>>
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  interconnectionCostNonUtilityUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMaxUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMinUsd?: Maybe<Scalars["Float"]["output"]>
  itcPercentageAssumption?: Maybe<Scalars["Float"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  note?: Maybe<Scalars["String"]["output"]>
  pid: Scalars["String"]["output"]
  ppaPriceEscalator?: Maybe<Scalars["Float"]["output"]>
  ppaPriceY1Usd?: Maybe<Scalars["Float"]["output"]>
  recOwner?: Maybe<RecOwner>
  roofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  roofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  site: SiteRef
  system?: Maybe<System>
  termYears?: Maybe<Scalars["Int"]["output"]>
  type: FinProductType
}

export type PpaEconomics = {
  __typename?: "PPAEconomics"
  offtakerXlsxHref: Scalars["String"]["output"]
  ppaCostPerKwh: Scalars["Float"]["output"]
  ppaEsc?: Maybe<Scalars["Float"]["output"]>
  ppaTermYears: Scalars["Int"]["output"]
  ppaType: PpaProductType
  product: PpaFinProduct
  roofRent?: Maybe<RoofRentEconomics>
  srecToInvestor: Scalars["Boolean"]["output"]
  tenantFlows?: Maybe<TenantCashflows>
}

export type PpaFinProduct = {
  __typename?: "PPAFinProduct"
  financierName: Scalars["String"]["output"]
  financierPid: Scalars["String"]["output"]
  ppaEscalator: Scalars["Float"]["output"]
  productName: Scalars["String"]["output"]
  srecToInvestor: Scalars["Boolean"]["output"]
}

export type PpaFinProductInput = {
  financierId: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  ppaEsc: Scalars["Float"]["input"]
  ppaTermTwoYearsTenantPpaWithSiteLease: Scalars["Float"]["input"]
  ppaTermYearsOwnerPpa: Scalars["Float"]["input"]
  ppaTermYearsTenantPpaWithSiteLease: Scalars["Float"]["input"]
  srecToInvestor: Scalars["Boolean"]["input"]
  status?: InputMaybe<FinProductStatus>
  targetIrrOwnerPpa: Scalars["Float"]["input"]
  targetIrrTenantPpaWithSiteLease: Scalars["Float"]["input"]
  targetOrgId?: InputMaybe<Scalars["Int"]["input"]>
  targetSiteId?: InputMaybe<Scalars["Int"]["input"]>
  targetSystemId?: InputMaybe<Scalars["Int"]["input"]>
}

export type PpaInvestorBid = {
  __typename?: "PPAInvestorBid"
  buildingOwnerExtraPaymentsUsd?: Maybe<Array<Scalars["Float"]["output"]>>
  errorClass?: Maybe<Scalars["String"]["output"]>
  errorMessage?: Maybe<Scalars["String"]["output"]>
  estimatedCod: Scalars["Date"]["output"]
  estimatedNtp: Scalars["Date"]["output"]
  extraPaymentsNotes?: Maybe<Scalars["String"]["output"]>
  financier: OrgRef
  finproduct: AdminFinProduct
  incentivesNotes?: Maybe<Scalars["String"]["output"]>
  interconnectionCostNonUtilityUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMaxUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMinUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionNotes?: Maybe<Scalars["String"]["output"]>
  interconnectionRepriceProcessNotes?: Maybe<Scalars["String"]["output"]>
  itcPercentageAssumption: Scalars["Float"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  otherNotes?: Maybe<Scalars["String"]["output"]>
  pid: Scalars["String"]["output"]
  ppaPriceEscalator: Scalars["Float"]["output"]
  ppaPriceY1Usd: Scalars["Float"]["output"]
  recOwner: RecOwner
  result?: Maybe<RevampFinmodel>
  roofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  roofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  site: RevampSite
  spec?: Maybe<PpaBidSpec>
  status?: Maybe<InvestorBidStatus>
  system: System
  tariffProvision?: Maybe<Scalars["Boolean"]["output"]>
  termYears: Scalars["Int"]["output"]
}

export enum PpaOfftaker {
  PropertyOwner = "PROPERTY_OWNER",
  Tenant = "TENANT",
}

export enum PpaProductType {
  OwnerPpa = "OWNER_PPA",
  TenantPpaWithSiteLease = "TENANT_PPA_WITH_SITE_LEASE",
}

export type PpaSiteBidReport = {
  __typename?: "PPASiteBidReport"
  awarded: Scalars["Boolean"]["output"]
  awardedPid?: Maybe<Scalars["String"]["output"]>
  bids: Array<PpaInvestorBid>
  itcPercentageAssumption?: Maybe<BoxplotStats>
  noi?: Maybe<BoxplotStats>
  npv?: Maybe<BoxplotStats>
  ppaPriceEscalator?: Maybe<BoxplotStats>
  site: RevampSite
  systemSize?: Maybe<BoxplotStats>
  totalBids: Scalars["Int"]["output"]
  y1RoofRent?: Maybe<BoxplotStats>
}

export type PvAllocation = {
  __typename?: "PVAllocation"
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  meter: BillingMeter
  percentage: Scalars["Int"]["output"]
  pvSpec: PvSpec
}

export type PvConfig = {
  __typename?: "PVConfig"
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  meter: PostSolarMeter
  origin: ProductionOrigin
  production: CleanIntervals
  productionKwh: Scalars["Float"]["output"]
  pvType: PvType
  sizeKw: Scalars["Float"]["output"]
}

export type PvProductionSource = {
  __typename?: "PVProductionSource"
  dateCreated: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  origin: ProductionOrigin
}

export type PvSpec = {
  __typename?: "PVSpec"
  allocations: Array<PvAllocation>
  createdAt: Scalars["DateTime"]["output"]
  etbMeterId?: Maybe<Scalars["Int"]["output"]>
  helioscope2Id?: Maybe<Scalars["Int"]["output"]>
  helioscopePdf?: Maybe<Document>
  id: Scalars["Int"]["output"]
  productionCsv?: Maybe<Document>
  productionSource?: Maybe<PvProductionSource>
  pvTypes: Array<PvType>
  roofImage?: Maybe<Document>
  sizeKwAc?: Maybe<Scalars["Float"]["output"]>
  sizeKwDc: Scalars["Float"]["output"]
  system?: Maybe<System>
  systemLite?: Maybe<SystemLite>
}

export type PvSystem = {
  __typename?: "PVSystem"
  sizeKw: Scalars["Float"]["output"]
  type: PvType
}

export type PvSystem2 = {
  __typename?: "PVSystem2"
  sizeKwAc?: Maybe<Scalars["Float"]["output"]>
  sizeKwDc: Scalars["Float"]["output"]
  types: Array<PvType>
}

export enum PvType {
  CarportSixHigh = "CARPORT_SIX_HIGH",
  CarportThreeHigh = "CARPORT_THREE_HIGH",
  Ground = "GROUND",
  Roof = "ROOF",
}

export enum PVoptGoal {
  ForceKw = "FORCE_KW",
  MaxCashPurchaseNpv = "MAX_CASH_PURCHASE_NPV",
}

export type PVoptRef = {
  __typename?: "PVoptRef"
  id: Scalars["Int"]["output"]
}

export type PackageBidReport = {
  __typename?: "PackageBidReport"
  cs?: Maybe<Array<CsSiteBidReport>>
  name?: Maybe<Scalars["String"]["output"]>
  notes?: Maybe<Scalars["String"]["output"]>
  pid?: Maybe<Scalars["String"]["output"]>
  ppa?: Maybe<Array<PpaSiteBidReport>>
  totalBids: Scalars["Int"]["output"]
  totalDevelopers: Scalars["Int"]["output"]
  visible: Scalars["Boolean"]["output"]
}

export enum PackageRowCloseReason {
  BuildingSold = "BUILDING_SOLD",
  FailedContractNegotiations = "FAILED_CONTRACT_NEGOTIATIONS",
  IneligibleForProgram = "INELIGIBLE_FOR_PROGRAM",
  NoBids = "NO_BIDS",
  Other = "OTHER",
  RoofAge = "ROOF_AGE",
  UnattractiveEconomics = "UNATTRACTIVE_ECONOMICS",
  WentOffPlatform = "WENT_OFF_PLATFORM",
}

export enum PackageRowStatus {
  CollectingBids = "COLLECTING_BIDS",
  DevelopingProject = "DEVELOPING_PROJECT",
  NegotiatingContracts = "NEGOTIATING_CONTRACTS",
  PreparingLaunch = "PREPARING_LAUNCH",
  ReviewingBids = "REVIEWING_BIDS",
  Shipped = "SHIPPED",
  VettingInterest = "VETTING_INTEREST",
}

export type PackageRowStatusPred = {
  value: Array<InputMaybe<PackageRowStatus>>
}

export type ParcelDataFailure = {
  __typename?: "ParcelDataFailure"
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  message: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  site: SiteRef
}

export type ParseResult = {
  __typename?: "ParseResult"
  kind?: Maybe<BillType>
  parse: DocumentBillingMonth
  target?: Maybe<BillingMeter>
}

export enum ParseStatus {
  Failure = "FAILURE",
  Pending = "PENDING",
  Running = "RUNNING",
  Success = "SUCCESS",
}

export type Period = {
  __typename?: "Period"
  fromDayOfWeek: Scalars["Int"]["output"]
  fromHour?: Maybe<Scalars["Int"]["output"]>
  fromMinute?: Maybe<Scalars["Int"]["output"]>
  toDayOfWeek: Scalars["Int"]["output"]
  toHour?: Maybe<Scalars["Int"]["output"]>
  toMinute?: Maybe<Scalars["Int"]["output"]>
}

export enum Permission {
  CreatePortfolios = "CREATE_PORTFOLIOS",
  EditOwners = "EDIT_OWNERS",
  EditViewers = "EDIT_VIEWERS",
  OverrideFinmodel = "OVERRIDE_FINMODEL",
  ViewSites = "VIEW_SITES",
}

export type PhysicalCheck = {
  __typename?: "PhysicalCheck"
  badRoof?: Maybe<Scalars["Boolean"]["output"]>
  carportIsGood: Scalars["Boolean"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  existingSolar?: Maybe<Scalars["Boolean"]["output"]>
  groundmountIsGood: Scalars["Boolean"]["output"]
  roofIsGood: Scalars["Boolean"]["output"]
  unobstructedFlatRoof?: Maybe<Scalars["Boolean"]["output"]>
}

export type PhysicalCheckPolicyCheckRevampFinmodelFailureRevampFinmodelRevampCsViability =

    | PhysicalCheck
    | PolicyCheck
    | RevampCs
    | RevampFinmodel
    | RevampFinmodelFailure
    | Viability

export enum PhysicalCheckSource {
  Ab802 = "AB802",
  Buildzoom = "BUILDZOOM",
  Costar = "COSTAR",
  HumanInputHighConfidence = "HUMAN_INPUT_HIGH_CONFIDENCE",
  HumanInputLowConfidence = "HUMAN_INPUT_LOW_CONFIDENCE",
  Verisk = "VERISK",
}

export type Policy = {
  __typename?: "Policy"
  application: PolicyApplication
  conditions: Array<PolicyCondition>
  description: Scalars["String"]["output"]
  endDate?: Maybe<Scalars["Date"]["output"]>
  jurisdiction: Jurisdiction
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  publicDescription: Scalars["String"]["output"]
  publicName: Scalars["String"]["output"]
  rules: Array<Rule>
  sources: Array<Source>
  startDate?: Maybe<Scalars["Date"]["output"]>
  status: PolicyStatus
  userVisible: Scalars["Boolean"]["output"]
}

export type PolicyApplication = {
  __typename?: "PolicyApplication"
  status: PolicyApplicationStatus
}

export enum PolicyApplicationStatus {
  Full = "FULL",
  No = "NO",
  Partial = "PARTIAL",
  UnclearPolicy = "UNCLEAR_POLICY",
  Unknown = "UNKNOWN",
}

export type PolicyCheck = {
  __typename?: "PolicyCheck"
  createdAt: Scalars["DateTime"]["output"]
  disqualReason?: Maybe<PolicyReason>
  isGood: Scalars["Boolean"]["output"]
  productType?: Maybe<FinProductType>
  violatedPolicy?: Maybe<Policy>
  violatedPolicyPid?: Maybe<Scalars["String"]["output"]>
}

export type PolicyCondition = BuildingSuperTypeCondition | VnemEligibilityCondition

export type PolicyQuery = {
  __typename?: "PolicyQuery"
  all: Array<Policy>
  policy?: Maybe<Policy>
}

export type PolicyQueryPolicyArgs = {
  policyPid: Scalars["String"]["input"]
}

export enum PolicyReason {
  CsNotAllowed = "CS_NOT_ALLOWED",
  CsNotFeasible = "CS_NOT_FEASIBLE",
  CsStatusUnknown = "CS_STATUS_UNKNOWN",
  PpasNotAllowed = "PPAS_NOT_ALLOWED",
  PpaStatusUnknown = "PPA_STATUS_UNKNOWN",
}

export enum PolicyStatus {
  Active = "ACTIVE",
  Ended = "ENDED",
  Planned = "PLANNED",
}

export type PolicyViolation = {
  __typename?: "PolicyViolation"
  policy: Policy
  value: RuleValue
  violatedRule: Rule
}

export type PortfolioMutations = {
  __typename?: "PortfolioMutations"
  addSitesByOwnerName: Scalars["Int"]["output"]
  new: PortfolioRow
  removeUserFromPortfolio: AdminPortfolio
  rename: AdminPortfolio
  setPortfolioMinKw: PortfolioRow
}

export type PortfolioMutationsAddSitesByOwnerNameArgs = {
  names: Array<Scalars["String"]["input"]>
  portfolioPid: Scalars["String"]["input"]
}

export type PortfolioMutationsNewArgs = {
  createEponymousOrg: Scalars["Boolean"]["input"]
  createOpenInvite?: Scalars["Boolean"]["input"]
  orgPid?: InputMaybe<Scalars["String"]["input"]>
  title: Scalars["String"]["input"]
  upload: Scalars["Upload"]["input"]
}

export type PortfolioMutationsRemoveUserFromPortfolioArgs = {
  portfolioPid: Scalars["String"]["input"]
  userId: Scalars["Int"]["input"]
}

export type PortfolioMutationsRenameArgs = {
  newName: Scalars["String"]["input"]
  portfolioPid: Scalars["String"]["input"]
}

export type PortfolioMutationsSetPortfolioMinKwArgs = {
  minKw?: InputMaybe<Scalars["Float"]["input"]>
  portfolioPid: Scalars["String"]["input"]
}

export type PortfolioRef = {
  __typename?: "PortfolioRef"
  pid: Scalars["String"]["output"]
  title: Scalars["String"]["output"]
}

export type PortfolioRow = {
  __typename?: "PortfolioRow"
  logoUrl?: Maybe<Scalars["String"]["output"]>
  minKw?: Maybe<Scalars["Float"]["output"]>
  minKwSetBy?: Maybe<Scalars["String"]["output"]>
  minKwSetDate?: Maybe<Scalars["DateTime"]["output"]>
  numSites: Scalars["Int"]["output"]
  org: AdminOrg
  pid: Scalars["String"]["output"]
  title: Scalars["String"]["output"]
  views: Array<ViewType>
}

export type PostBatteryMeter = {
  __typename?: "PostBatteryMeter"
  batt?: Maybe<BatteryConfig>
  bauMeter?: Maybe<BauMeter>
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  postSolarMeter?: Maybe<PostSolarMeter>
  tariff: TariffRate
  year: Scalars["Int"]["output"]
}

export type PostSolarMeter = {
  __typename?: "PostSolarMeter"
  bauMeter: BauMeter
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  pv: Array<PvConfig>
  tariff: TariffRate
  year: Scalars["Int"]["output"]
}

export enum ProductionOrigin {
  Bid = "BID",
  Etb = "ETB",
  Helioscope = "HELIOSCOPE",
  Pvwatts = "PVWATTS",
}

export type ProjectMilestoneInput = {
  actual?: InputMaybe<Scalars["Date"]["input"]>
  estimated?: InputMaybe<Scalars["Date"]["input"]>
}

export type Projected = {
  __typename?: "Projected"
  annualCostUsd: Scalars["Float"]["output"]
  annualKwh: Scalars["Float"]["output"]
  costAndKwhDownloadHref: Scalars["String"]["output"]
  kwh8760: Zoned8760
  monthlyBills: Array<MonthlyBill2>
  monthlyCostUsd: Array<Scalars["Float"]["output"]>
  monthlyUsageKwh: Array<Scalars["Float"]["output"]>
  peakKw: Scalars["Float"]["output"]
  tariff: Tariff
  year: Scalars["Int"]["output"]
}

export type ProjectedE2Error = E2Error | Projected

export type Provider = {
  __typename?: "Provider"
  aiModel?: Maybe<AiModel>
  createdAt: Scalars["DateTime"]["output"]
  document?: Maybe<Document>
  documentBillingMonth?: Maybe<DocumentBillingMonth>
  espmConsumption?: Maybe<EspmConsumption>
  id: Scalars["Int"]["output"]
  user?: Maybe<UserRef>
}

export type Query = {
  __typename?: "Query"
  activeAdmins: Array<UserRef>
  activeBoosts: Scalars["Int"]["output"]
  allBids: AdminBidsTable
  allSites: AdminSitesTable
  bauMeter: BauMeter
  buildingData: BuildingData
  bundleRowParentDocuments: Array<SiteDocuments>
  bundleRows: AdminBundleTable
  changelogs: ChangelogQuery
  costarPropertyTypes: Array<Scalars["String"]["output"]>
  currentUser: AuthUser
  draftSite: DraftSite
  draftSites: Array<Maybe<DraftSite>>
  energy: EnergyProduction
  financierOrgs: Array<AdminOrg>
  finmodelFailure?: Maybe<FinmodelFailure>
  finmodelFailureIndex: Array<FinmodelFailureIndexRow>
  finmodelFailures: FinmodelFailureTable
  finmodelSettings: FinmodelSettings
  finproduct: AdminFinProduct
  hostingCapacityMaps: HostingCapacityMapQuery
  listDraftSites: Array<DraftSite>
  marketplace: AdminMarketplaceTable
  myDraftSites: Array<DraftSite>
  openInvites: Array<AdminOpenInvite>
  oplogCounts: Array<Count>
  org: AdminOrg
  orgBySlug?: Maybe<AdminOrg>
  orgPriority: Scalars["Int"]["output"]
  orgs: Array<AdminOrg>
  policies: PolicyQuery
  portfolio?: Maybe<AdminPortfolio>
  portfolios: Array<PortfolioRow>
  schemaVersion: SchemaVersion
  search: Array<SearchSiteRow>
  searchForOwnerName: Array<CostarSearch>
  site?: Maybe<Site>
  sites: Array<Maybe<Site>>
  sitesByOwnerName: Array<Site>
  sitesInPortfolios: Array<Site>
  tariffRateId: Scalars["Int"]["output"]
  tariffs: AdminTariffQuery
  taskCounts: Array<Count>
  taskHistory: TaskHistory
  thirdPartySuppliers: Array<ThirdPartySupplier>
  user?: Maybe<AdminUser>
  users: Array<AdminUser>
  xl2: Scalars["String"]["output"]
}

export type QueryActiveBoostsArgs = {
  orgPid: Scalars["String"]["input"]
}

export type QueryBauMeterArgs = {
  id: Scalars["Int"]["input"]
}

export type QueryBuildingDataArgs = {
  id: Scalars["Int"]["input"]
}

export type QueryBundleRowParentDocumentsArgs = {
  bundleParentRowIds: Array<Scalars["Int"]["input"]>
  includeTags: Array<DocumentTag>
}

export type QueryDraftSiteArgs = {
  draftSitePid: Scalars["String"]["input"]
}

export type QueryDraftSitesArgs = {
  draftSitePids: Array<Scalars["String"]["input"]>
}

export type QueryFinmodelFailureArgs = {
  id: Scalars["Int"]["input"]
}

export type QueryFinproductArgs = {
  finproductId: Scalars["Int"]["input"]
}

export type QueryListDraftSitesArgs = {
  filterBy?: InputMaybe<DraftSiteFilter>
}

export type QueryOpenInvitesArgs = {
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
}

export type QueryOrgArgs = {
  orgPid: Scalars["String"]["input"]
}

export type QueryOrgBySlugArgs = {
  pid?: InputMaybe<Scalars["String"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

export type QueryOrgPriorityArgs = {
  orgPid: Scalars["String"]["input"]
}

export type QueryPortfolioArgs = {
  pid: Scalars["String"]["input"]
}

export type QuerySearchArgs = {
  q: Scalars["String"]["input"]
}

export type QuerySearchForOwnerNameArgs = {
  q: Scalars["String"]["input"]
}

export type QuerySiteArgs = {
  pid: Scalars["String"]["input"]
}

export type QuerySitesArgs = {
  sitePids: Array<Scalars["String"]["input"]>
}

export type QuerySitesByOwnerNameArgs = {
  name: Scalars["String"]["input"]
}

export type QuerySitesInPortfoliosArgs = {
  portfolioPids: Array<Scalars["String"]["input"]>
  statuses: Array<SiteStatus>
}

export type QueryTariffRateIdArgs = {
  tariffParentId: Scalars["Int"]["input"]
}

export type QueryTaskCountsArgs = {
  orgPid?: InputMaybe<Scalars["String"]["input"]>
  sitePid?: InputMaybe<Scalars["String"]["input"]>
}

export type QueryUserArgs = {
  userId: Scalars["Int"]["input"]
}

export type QueueMutations = {
  __typename?: "QueueMutations"
  boost?: Maybe<Scalars["Void"]["output"]>
}

export type QueueMutationsBoostArgs = {
  orgPid: Scalars["String"]["input"]
}

export enum RecOwner {
  Investor = "INVESTOR",
  OwnerOrTenant = "OWNER_OR_TENANT",
}

export type RecOwnerPred = {
  value: Array<InputMaybe<RecOwner>>
}

export type Rate = {
  __typename?: "Rate"
  applicabilityKey?: Maybe<Scalars["String"]["output"]>
  applicabilityValues?: Maybe<Array<Scalars["String"]["output"]>>
  applicableBands: Array<RateBand>
  bands: Array<RateBand>
  chargeClass: Scalars["String"]["output"]
  chargePeriod: ChargePeriod
  chargeType?: Maybe<ChargeType>
  classes: Array<ChargeClass>
  groupName?: Maybe<Scalars["String"]["output"]>
  isDemandCharge: Scalars["Boolean"]["output"]
  isFixedPrice: Scalars["Boolean"]["output"]
  isQuantity: Scalars["Boolean"]["output"]
  isTou: Scalars["Boolean"]["output"]
  name: Scalars["String"]["output"]
  quantityKey?: Maybe<Scalars["String"]["output"]>
  season?: Maybe<Season>
  tariffRateId: Scalars["Int"]["output"]
  tou?: Maybe<TimeOfUse>
  transactionType: TransactionType
  variableLimitValue?: Maybe<TariffPropertyKey>
}

export type RateBand = {
  __typename?: "RateBand"
  applicabilityValue?: Maybe<Scalars["String"]["output"]>
  calculationFactor?: Maybe<Scalars["Float"]["output"]>
  consumptionUpperLimit?: Maybe<Scalars["Float"]["output"]>
  demandUpperLimit?: Maybe<Scalars["Float"]["output"]>
  hasConsumptionLimit?: Maybe<Scalars["Boolean"]["output"]>
  isCredit: Scalars["Boolean"]["output"]
  price: Scalars["Float"]["output"]
  propertyUpperLimit?: Maybe<Scalars["Float"]["output"]>
  rateUnit: RateUnit
  tariffRateBandId: Scalars["Int"]["output"]
}

export enum RateUnit {
  CostPerUnit = "COST_PER_UNIT",
  Percentage = "PERCENTAGE",
}

export type RawCsvCell = {
  __typename?: "RawCsvCell"
  columnId: Scalars["String"]["output"]
  value?: Maybe<Scalars["String"]["output"]>
}

export type RawFile = {
  __typename?: "RawFile"
  fileData: Scalars["String"]["output"]
  filename: Scalars["String"]["output"]
}

export enum RbacRole {
  Owner = "OWNER",
  PrimaryContact = "PRIMARY_CONTACT",
  Viewer = "VIEWER",
}

export type RemoveLabelInput = {
  labelPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type RenameLabelInput = {
  labelName: Scalars["String"]["input"]
  labelPid: Scalars["String"]["input"]
}

export type RenameSiteLabelOutput = {
  __typename?: "RenameSiteLabelOutput"
  label: SiteLabel
}

export type RenameSiteLabelResponse = Error | RenameSiteLabelOutput

export type ReoptRef = {
  __typename?: "ReoptRef"
  pid: Scalars["String"]["output"]
}

export type Response = {
  __typename?: "Response"
  choices: Array<ResponseChoice>
  created: Scalars["Float"]["output"]
  id: Scalars["String"]["output"]
  model: Scalars["String"]["output"]
  object: Scalars["String"]["output"]
  responseMs: Scalars["Int"]["output"]
  usage?: Maybe<Usage>
}

export type ResponseChoice = {
  __typename?: "ResponseChoice"
  finishReason: Scalars["String"]["output"]
  index: Scalars["Int"]["output"]
  message: Message
}

export type Result = {
  __typename?: "Result"
  createdAt: Scalars["DateTime"]["output"]
  financing: RevampFinancing
  helioscope?: Maybe<Helioscope>
  id: Scalars["Int"]["output"]
  pid: Scalars["String"]["output"]
  result?: Maybe<PhysicalCheckPolicyCheckRevampFinmodelFailureRevampFinmodelRevampCsViability>
  salesPdfReportHref?: Maybe<Scalars["String"]["output"]>
  scenario: RevampScenario
}

export type ResultConfig = {
  __typename?: "ResultConfig"
  disabledAt?: Maybe<Scalars["DateTime"]["output"]>
  finproduct: AdminFinProduct
  finrelDisabledAt?: Maybe<Scalars["DateTime"]["output"]>
}

export type ResultForTariff = {
  __typename?: "ResultForTariff"
  currentlyActive: Scalars["Boolean"]["output"]
  medianCostDelta?: Maybe<Scalars["Float"]["output"]>
  results: Array<NameThatTariffResult>
  tariff: Tariff
}

export type ResultTable = {
  __typename?: "ResultTable"
  rows: Array<ResultTableRow>
  view: ResultTableView
}

export type ResultTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type ResultTableViewArgs = {
  filterBy?: InputMaybe<ResultTableFilter>
  sortBy?: InputMaybe<Array<ResultTableSort>>
}

export enum ResultTableAttr {
  CreatedAt = "CREATED_AT",
  FailureFmv = "FAILURE_FMV",
  FailureId = "FAILURE_ID",
  FailureMessage = "FAILURE_MESSAGE",
  FailureName = "FAILURE_NAME",
  FinancierName = "FINANCIER_NAME",
  FinancierPid = "FINANCIER_PID",
  FinmodelFmv = "FINMODEL_FMV",
  FinmodelId = "FINMODEL_ID",
  FinmodelNoi = "FINMODEL_NOI",
  FinproductName = "FINPRODUCT_NAME",
  FinproductType = "FINPRODUCT_TYPE",
  Pid = "PID",
  PolicyCheckIsGood = "POLICY_CHECK_IS_GOOD",
  PortfolioPid = "PORTFOLIO_PID",
  ScenarioIncludeStorage = "SCENARIO_INCLUDE_STORAGE",
  ScenarioName = "SCENARIO_NAME",
  ScenarioPid = "SCENARIO_PID",
  ScenarioSolarLocation = "SCENARIO_SOLAR_LOCATION",
  SiteCity = "SITE_CITY",
  SiteHiddenFromCustomers = "SITE_HIDDEN_FROM_CUSTOMERS",
  SiteName = "SITE_NAME",
  SitePid = "SITE_PID",
  SiteState = "SITE_STATE",
  SiteStatus = "SITE_STATUS",
  SiteStreetAddress = "SITE_STREET_ADDRESS",
}

export type ResultTableFilter = {
  finmodelNoi?: InputMaybe<FloatPred>
  finproductType?: InputMaybe<FinProductTypePred>
  portfolioPid?: InputMaybe<StringPred>
  scenarioIncludeStorage?: InputMaybe<BoolPred>
  scenarioSolarLocation?: InputMaybe<SolarLocationPred>
}

export type ResultTableRow = {
  __typename?: "ResultTableRow"
  createdAt: Scalars["DateTime"]["output"]
  failureFmv?: Maybe<Scalars["String"]["output"]>
  failureId?: Maybe<Scalars["Int"]["output"]>
  failureMessage?: Maybe<Scalars["String"]["output"]>
  failureName?: Maybe<Scalars["String"]["output"]>
  financierName: Scalars["String"]["output"]
  financierPid: Scalars["String"]["output"]
  finmodelFmv?: Maybe<Scalars["String"]["output"]>
  finmodelId?: Maybe<Scalars["Int"]["output"]>
  finmodelNoi?: Maybe<Scalars["Float"]["output"]>
  finproductName: Scalars["String"]["output"]
  finproductType: FinProductType
  id: Scalars["Int"]["output"]
  physicalCheckCarportIsGood?: Maybe<Scalars["Boolean"]["output"]>
  physicalCheckGroundmountIsGood?: Maybe<Scalars["Boolean"]["output"]>
  physicalCheckRoofIsGood?: Maybe<Scalars["Boolean"]["output"]>
  pid: Scalars["String"]["output"]
  policyCheckIsGood?: Maybe<Scalars["Boolean"]["output"]>
  portfolioPid: Scalars["String"]["output"]
  scenarioIncludeStorage: Scalars["Boolean"]["output"]
  scenarioName: Scalars["String"]["output"]
  scenarioPid: Scalars["String"]["output"]
  scenarioSolarLocation: SolarLocation
  siteCity: Scalars["String"]["output"]
  siteHiddenFromCustomers: Scalars["Boolean"]["output"]
  siteName?: Maybe<Scalars["String"]["output"]>
  sitePid: Scalars["String"]["output"]
  siteState: Scalars["String"]["output"]
  siteStatus: SiteStatus
  siteStreetAddress: Scalars["String"]["output"]
}

export type ResultTableSort = {
  attr: ResultTableAttr
  order: SortOrder
}

export type ResultTableView = {
  __typename?: "ResultTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
}

export type RevampCs = {
  __typename?: "RevampCS"
  buildingOwner: BuildingOwnerEconomics
  createdAt: Scalars["DateTime"]["output"]
  financing: RevampFinancing
  goal?: Maybe<PVoptGoal>
  id: Scalars["Int"]["output"]
  leaseProjections?: Maybe<CsLeaseProjections>
  pricing: CsPrice
  roofRent?: Maybe<RoofRentEconomics>
  systems: Array<RevampSystem>
  termYears: Scalars["Int"]["output"]
}

export type RevampDer = {
  __typename?: "RevampDer"
  averageDayKwhFlow: Array<KwhFlow>
  totalKwhFlow: KwhFlow
}

export type RevampEmissions = {
  __typename?: "RevampEmissions"
  bauAverageDayCo2Tons: Array<Scalars["Float"]["output"]>
  bauCo2Tons: Scalars["Float"]["output"]
  derAverageDayCo2Tons: Array<Scalars["Float"]["output"]>
  derCo2Tons: Scalars["Float"]["output"]
}

export type RevampFinancing = {
  __typename?: "RevampFinancing"
  financierLogo?: Maybe<Scalars["String"]["output"]>
  financierLogomark?: Maybe<Scalars["String"]["output"]>
  financierName: Scalars["String"]["output"]
  financierPid: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  isThirdParty: Scalars["Boolean"]["output"]
  name: Scalars["String"]["output"]
  status: FinProductStatus
  type: FinProductType
}

export type RevampFinmodel = {
  __typename?: "RevampFinmodel"
  bauCostPerYear: Array<Scalars["Float"]["output"]>
  buildingOwner: BuildingOwnerEconomics
  buildingOwnerXlsx?: Maybe<Scalars["String"]["output"]>
  buildingOwnerXlsxHref?: Maybe<Scalars["String"]["output"]>
  commOpDate: Scalars["DateTime"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  derCostPerYear: Array<Scalars["Float"]["output"]>
  emissions?: Maybe<RevampEmissions>
  financing: RevampFinancing
  fmvStr: Scalars["String"]["output"]
  goal?: Maybe<PVoptGoal>
  id: Scalars["Int"]["output"]
  importReductionPct: Scalars["Float"]["output"]
  intervalsAndCostsXlsxHref: Scalars["String"]["output"]
  investorDetails?: Maybe<InvestorDetails>
  isGreenLease: Scalars["Boolean"]["output"]
  isVnem: Scalars["Boolean"]["output"]
  itcAssumptions: RevampItcAssumptions
  iterations: Array<RevampIteration>
  loan?: Maybe<LoanEconomics>
  meters: Array<RevampMeter>
  moreDetails?: Maybe<MoreDetails>
  offerStatus: OfferStatus
  pid: Scalars["String"]["output"]
  ppa?: Maybe<PpaEconomics>
  scenario: RevampScenario
  selfInvest?: Maybe<SelfInvestEconomics>
  systems: Array<RevampSystem>
  thirdPartySupplier?: Maybe<ThirdPartySupplier>
  totalPvExportKwh?: Maybe<Scalars["Float"]["output"]>
  totalPvProductionKwh: Scalars["Float"]["output"]
  type: FinProductType
  utilityCosts: UtilityCost
}

export type RevampFinmodelFailure = {
  __typename?: "RevampFinmodelFailure"
  createdAt: Scalars["DateTime"]["output"]
  details: FailureDetails
  fmvStr: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
}

export type RevampItcAssumptions = {
  __typename?: "RevampItcAssumptions"
  domesticMaterialsAdder: Scalars["Boolean"]["output"]
  inEnergyCommunity: Scalars["Boolean"]["output"]
  inLowIncomeCommunity: Scalars["Boolean"]["output"]
  rate: Scalars["Float"]["output"]
}

export type RevampIteration = {
  __typename?: "RevampIteration"
  cashPurchaseNpv: Scalars["Float"]["output"]
  marginalCo2Averted?: Maybe<Scalars["Float"]["output"]>
  pvKw: Scalars["Float"]["output"]
  storagePvKw?: Maybe<Scalars["Float"]["output"]>
  storagePvKwh?: Maybe<Scalars["Float"]["output"]>
}

export type RevampMeter = {
  __typename?: "RevampMeter"
  bau: RevampDer
  der?: Maybe<RevampDer>
  loadCategory: LoadCategory
  meterSource: MeterSource
  name: Scalars["String"]["output"]
}

export type RevampScenario = {
  __typename?: "RevampScenario"
  includeStorage: Scalars["Boolean"]["output"]
  loadCategory: LoadCategory
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  solarLocation: SolarLocation
}

export type RevampSite = {
  __typename?: "RevampSite"
  activeResults: Array<Result>
  assetManager?: Maybe<Scalars["String"]["output"]>
  bidPackages: Array<BidPackage>
  biddingConfigResult?: Maybe<Result>
  billingMeters: Array<BillingMeter>
  buildingClass?: Maybe<Scalars["String"]["output"]>
  buildingData?: Maybe<BuildingData>
  carportMaxPvKw: Scalars["Float"]["output"]
  cbsaName?: Maybe<Scalars["String"]["output"]>
  city: Scalars["String"]["output"]
  county: Scalars["String"]["output"]
  customTariff?: Maybe<CustomTariff>
  customTariffs: Array<CustomTariff>
  documentParseRequests: Array<DocumentParseRequest>
  documents: Array<Document>
  doeReferenceType?: Maybe<BuildingType>
  energyThings?: Maybe<EnergyThings>
  evCalc?: Maybe<EvCalc>
  evOverrides: EvOverrideQueries
  feasibility: SolarFeasibility
  fieldHistory: SiteFieldChangeLog
  financingThings?: Maybe<FinancingThings>
  flags: Array<SiteFlag>
  footprint: Footprint
  fullAddress: Scalars["String"]["output"]
  /** Solar financing feasibility */
  gaugeStatus?: Maybe<GaugeRazzleDazzle>
  gridEscalator?: Maybe<Scalars["Float"]["output"]>
  groundAvailableSqft?: Maybe<Scalars["Float"]["output"]>
  groundmountMaxPvKw?: Maybe<Scalars["Float"]["output"]>
  hasSubmittedEnergyData: Scalars["Boolean"]["output"]
  hideBuildingFootprint: Scalars["Boolean"]["output"]
  highlightedResults: Array<Result>
  impliedCarportLinearFt?: Maybe<Scalars["Float"]["output"]>
  impliedUsableRoofSqft?: Maybe<Scalars["Float"]["output"]>
  impliedUsableRoofSqftExplanation: RoofSqftExplanation
  isBehindTheMeter?: Maybe<Scalars["Boolean"]["output"]>
  isEnergyCommunity: Scalars["Boolean"]["output"]
  isFavorite: Scalars["Boolean"]["output"]
  isLowIncomeCommunity?: Maybe<Scalars["Boolean"]["output"]>
  isMultifamily: Scalars["Boolean"]["output"]
  isRecalculating: Scalars["Boolean"]["output"]
  keepoutsFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  labels: Array<SiteLabel>
  latitude: Scalars["Float"]["output"]
  leaseType?: Maybe<LeaseType>
  longitude: Scalars["Float"]["output"]
  marketplaceStatus?: Maybe<MarketplaceStatus>
  maxPvKwPolicyLimited: Scalars["Boolean"]["output"]
  meterSet?: Maybe<MeterSet>
  metering?: Maybe<Metering>
  mortgageLender?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  notes: Array<Note>
  numParkingSpaces?: Maybe<Scalars["Int"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
  occupancyType?: Maybe<BuildingOccupancyType>
  physicalCheck: PhysicalCheck
  pid: Scalars["String"]["output"]
  policies: Array<Policy>
  ppaType?: Maybe<PpaProductType>
  probableUtilities: Array<UtilityRef>
  recommendedResult?: Maybe<Result>
  result?: Maybe<Result>
  resultPerLocation: Array<Result>
  roofCondition?: Maybe<Scalars["String"]["output"]>
  roofMaxPvKw: Scalars["Float"]["output"]
  roofReplacedYr?: Maybe<Scalars["Int"]["output"]>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  scenarios: Array<RevampScenario>
  selectedConfig?: Maybe<SiteConfig>
  selectedConfigResult?: Maybe<Result>
  selectedResults: Array<Result>
  shine: ShineSite
  siteDetails: SiteDetails
  sqft?: Maybe<Scalars["Float"]["output"]>
  state: Scalars["String"]["output"]
  status?: Maybe<SiteStatus>
  statusDisplayText?: Maybe<Scalars["String"]["output"]>
  streetAddress: Scalars["String"]["output"]
  targetUtility?: Maybe<Utility>
  tenantInterest?: Maybe<YesNoUnsure>
  tenantLeaseEnds?: Maybe<Scalars["Date"]["output"]>
  tenantLeaseTerm?: Maybe<Scalars["String"]["output"]>
  thirdPartySupplier?: Maybe<ThirdPartySupplier>
  usableCarportFt?: Maybe<Scalars["Float"]["output"]>
  usableRoofSqft?: Maybe<Scalars["Float"]["output"]>
  usingBillingMeters?: Maybe<Scalars["DateTime"]["output"]>
  visuals: SiteVisuals
  vnemAllowed: Scalars["Boolean"]["output"]
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  zipCode: Scalars["String"]["output"]
}

export type RevampSiteCustomTariffArgs = {
  tariffId: Scalars["Int"]["input"]
}

export type RevampSiteResultArgs = {
  pid: Scalars["String"]["input"]
}

export type RevampSystem = BatterySystem | PvSystem

export type RevampTariff = {
  __typename?: "RevampTariff"
  code: Scalars["String"]["output"]
  endDate?: Maybe<Scalars["DateTime"]["output"]>
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  startDate: Scalars["DateTime"]["output"]
  utility: RevampUtility
}

export type RevampUtility = {
  __typename?: "RevampUtility"
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  shortName: Scalars["String"]["output"]
}

export type RevertToEstimatesInput = {
  sitePid: Scalars["String"]["input"]
}

export enum Role {
  Assistant = "ASSISTANT",
  System = "SYSTEM",
  User = "USER",
}

export type RoofRentEconomics = {
  __typename?: "RoofRentEconomics"
  annualUsd: Scalars["Float"]["output"]
  discountRate: Scalars["Float"]["output"]
  lifetimeUsd: Scalars["Float"]["output"]
  npv: Scalars["Float"]["output"]
  roofRentPerYear: Array<Scalars["Float"]["output"]>
  usdPerSqft: Scalars["Float"]["output"]
}

export enum RoofRightsHolder {
  BuildingOwner = "BUILDING_OWNER",
  Other = "OTHER",
  Tenant = "TENANT",
}

export type RoofRightsHolderPred = {
  value: Array<InputMaybe<RoofRightsHolder>>
}

export enum RoofSqftExplanation {
  NoUsableRoofInfo = "NO_USABLE_ROOF_INFO",
  RoofDrawingNoKeepouts = "ROOF_DRAWING_NO_KEEPOUTS",
  RoofDrawingWithKeepouts = "ROOF_DRAWING_WITH_KEEPOUTS",
  SlopedRoofDrawingNoKeepouts = "SLOPED_ROOF_DRAWING_NO_KEEPOUTS",
  SlopedRoofDrawingWithKeepouts = "SLOPED_ROOF_DRAWING_WITH_KEEPOUTS",
  SlopedUsableRoofManuallySet = "SLOPED_USABLE_ROOF_MANUALLY_SET",
  SlopedUsableRoofPctDefault = "SLOPED_USABLE_ROOF_PCT_DEFAULT",
  SlopedUsableRoofPctManuallySet = "SLOPED_USABLE_ROOF_PCT_MANUALLY_SET",
  UsableRoofManuallySet = "USABLE_ROOF_MANUALLY_SET",
  UsableRoofPctDefault = "USABLE_ROOF_PCT_DEFAULT",
  UsableRoofPctManuallySet = "USABLE_ROOF_PCT_MANUALLY_SET",
}

export type RowValidationError = {
  __typename?: "RowValidationError"
  message: Scalars["String"]["output"]
  type: RowValidationErrorType
}

export enum RowValidationErrorType {
  AddressNotFound = "ADDRESS_NOT_FOUND",
  CostarValidationFailed = "COSTAR_VALIDATION_FAILED",
  DuplicateAddressInFile = "DUPLICATE_ADDRESS_IN_FILE",
  InvalidLatLon = "INVALID_LAT_LON",
  InvalidSqft = "INVALID_SQFT",
  MissingRequiredField = "MISSING_REQUIRED_FIELD",
  SiteAlreadyExists = "SITE_ALREADY_EXISTS",
  UnsupportedBuildingType = "UNSUPPORTED_BUILDING_TYPE",
}

export type RowValidationWarning = {
  __typename?: "RowValidationWarning"
  message: Scalars["String"]["output"]
  type: RowValidationWarningType
}

export enum RowValidationWarningType {
  AddressMismatch = "ADDRESS_MISMATCH",
  InvalidYearBuilt = "INVALID_YEAR_BUILT",
  MaxDistanceExceeded = "MAX_DISTANCE_EXCEEDED",
}

export type Rule = {
  __typename?: "Rule"
  application: RuleApplication
  conditions: Array<PolicyCondition>
  description: Scalars["String"]["output"]
  id: Scalars["String"]["output"]
  units?: Maybe<RuleValueUnits>
  value: RuleValue
}

export type RuleApplication = {
  __typename?: "RuleApplication"
  detail?: Maybe<Scalars["String"]["output"]>
  status: RuleApplicationStatus
}

export enum RuleApplicationStatus {
  Full = "FULL",
  No = "NO",
  Partial = "PARTIAL",
  Unknown = "UNKNOWN",
}

export type RuleValue =
  | CurrencyValue
  | IntegerValue
  | NumberValue
  | TextValue
  | YesNoValue

export enum RuleValueUnits {
  Dollars = "DOLLARS",
  Kw = "KW",
  Percentage = "PERCENTAGE",
  Years = "YEARS",
}

export type ScenarioConfig = {
  __typename?: "ScenarioConfig"
  battery?: Maybe<BatteryProduct>
  carportKw?: Maybe<Scalars["Float"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  etb?: Maybe<EtbReport>
  finproduct?: Maybe<AdminFinProduct>
  finproductType?: Maybe<FinProductType>
  goal: PVoptGoal
  groundKw?: Maybe<Scalars["Float"]["output"]>
  helioscope?: Maybe<Helioscope>
  id: Scalars["Int"]["output"]
  roofImage?: Maybe<Attachment>
  roofKw?: Maybe<Scalars["Float"]["output"]>
  scenario: ScenarioRef
  site: SiteRef
}

export type ScenarioMutations = {
  __typename?: "ScenarioMutations"
  removeConfig?: Maybe<Scalars["Void"]["output"]>
  setConfig: AdminScenario
  setEtb: AdminScenario
  setHelioscope: AdminScenario
  setName: Site
  setPrimary: Site
  setPvoptGoal: AdminScenario
  toggleMulticonnect: AdminScenario
  toggleVisibility: AdminScenario
}

export type ScenarioMutationsRemoveConfigArgs = {
  scenarioConfigId: Scalars["Int"]["input"]
}

export type ScenarioMutationsSetConfigArgs = {
  carportKw?: InputMaybe<Scalars["Float"]["input"]>
  finproductId?: InputMaybe<Scalars["Int"]["input"]>
  finproductType?: InputMaybe<FinProductType>
  goal?: InputMaybe<PVoptGoal>
  groundKw?: InputMaybe<Scalars["Float"]["input"]>
  helioscopePid?: InputMaybe<Scalars["String"]["input"]>
  roofKw?: InputMaybe<Scalars["Float"]["input"]>
}

export type ScenarioMutationsSetEtbArgs = {
  etbId?: InputMaybe<Scalars["Int"]["input"]>
}

export type ScenarioMutationsSetHelioscopeArgs = {
  finproductId?: InputMaybe<Scalars["Int"]["input"]>
  finproductType?: InputMaybe<FinProductType>
  helioscopePid?: InputMaybe<Scalars["String"]["input"]>
}

export type ScenarioMutationsSetNameArgs = {
  name: Scalars["String"]["input"]
}

export type ScenarioMutationsSetPvoptGoalArgs = {
  carportKw?: InputMaybe<Scalars["Float"]["input"]>
  finproductId?: InputMaybe<Scalars["Int"]["input"]>
  finproductType?: InputMaybe<FinProductType>
  groundKw?: InputMaybe<Scalars["Float"]["input"]>
  pvoptGoal: PVoptGoal
  roofKw?: InputMaybe<Scalars["Float"]["input"]>
}

export type ScenarioMutationsToggleMulticonnectArgs = {
  allow: Scalars["Boolean"]["input"]
}

export type ScenarioMutationsToggleVisibilityArgs = {
  hidden: Scalars["Boolean"]["input"]
}

export type ScenarioPred = {
  value?: InputMaybe<Scalars["String"]["input"]>
}

export type ScenarioRef = {
  __typename?: "ScenarioRef"
  includeStorage: Scalars["Boolean"]["output"]
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  solarLocation: SolarLocation
}

export enum SchemaOrigin {
  Costar = "COSTAR",
  Custom = "CUSTOM",
  Reonomy = "REONOMY",
}

export type SchemaVersion = {
  __typename?: "SchemaVersion"
  version: Scalars["String"]["output"]
}

export type SearchPred = {
  value: Scalars["String"]["input"]
}

export type SearchSiteRow = {
  __typename?: "SearchSiteRow"
  fullAddress: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  pid: Scalars["String"]["output"]
  portfolio?: Maybe<PortfolioRef>
}

export type Season = {
  __typename?: "Season"
  seasonFromDay: Scalars["Int"]["output"]
  seasonFromMonth: Scalars["Int"]["output"]
  seasonToDay: Scalars["Int"]["output"]
  seasonToMonth: Scalars["Int"]["output"]
}

export type SeasonalDayRate = {
  __typename?: "SeasonalDayRate"
  dayRates: Array<Scalars["Float"]["output"]>
  endMonth: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  startMonth: Scalars["Int"]["output"]
}

export type SelfInvestCashflows = {
  __typename?: "SelfInvestCashflows"
  greenLeaseTenantFlows?: Maybe<TenantCashflows>
  netCashflowPerYear: Array<Scalars["Float"]["output"]>
  totalCapex: Scalars["Float"]["output"]
  totalItc: Scalars["Float"]["output"]
  totalNet: Scalars["Float"]["output"]
  totalOpex: Scalars["Float"]["output"]
  totalRevenue: Scalars["Float"]["output"]
  totalUtilitySavings: Scalars["Float"]["output"]
}

export type SelfInvestEconomics = {
  __typename?: "SelfInvestEconomics"
  discountRate: Scalars["Float"]["output"]
  flows?: Maybe<SelfInvestCashflows>
  irrs: IrRs
  npv: Scalars["Float"]["output"]
  product: SelfInvestFinProduct
  selfInvestXlsxHref: Scalars["String"]["output"]
  srecToInvestor: Scalars["Boolean"]["output"]
  termYears: Scalars["Int"]["output"]
}

export type SelfInvestFinProduct = {
  __typename?: "SelfInvestFinProduct"
  financierName: Scalars["String"]["output"]
  productName: Scalars["String"]["output"]
}

export type SetBauMeterLabelInput = {
  bauMeterId: Scalars["Int"]["input"]
  label: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type SetBauMeterTariffInput = {
  bauMeterId: Scalars["Int"]["input"]
  sitePid: Scalars["String"]["input"]
  slot: TariffSlot
  tariffParentId: Scalars["Int"]["input"]
}

export enum ShineDuration {
  Daily = "DAILY",
  Monthly = "MONTHLY",
  Weekly = "WEEKLY",
}

export type ShineOrg = {
  __typename?: "ShineOrg"
  siteRefs: Array<ShineSiteRef>
  stats?: Maybe<ShineStats>
  status: ShineStatus
  units: Array<ShineUnit>
}

export type ShineOrgUnitsArgs = {
  duration: ShineDuration
}

export type ShineSite = {
  __typename?: "ShineSite"
  stats?: Maybe<ShineStats>
  status: ShineStatus
  units: Array<ShineUnit>
}

export type ShineSiteUnitsArgs = {
  duration: ShineDuration
}

export type ShineSiteRef = {
  __typename?: "ShineSiteRef"
  lat: Scalars["Float"]["output"]
  lon: Scalars["Float"]["output"]
  monthlyGrossRevenue: Scalars["Float"]["output"]
  pid: Scalars["String"]["output"]
  status: ShineStatus
}

export type ShineStats = {
  __typename?: "ShineStats"
  numProperties: Scalars["Int"]["output"]
  pvKwInstalled: Scalars["Float"]["output"]
  totalCo2ReducedTonnes: Scalars["Float"]["output"]
  totalGrossRevenue: Scalars["Float"]["output"]
  totalPvProductionKwh: Scalars["Float"]["output"]
}

export enum ShineStatus {
  NotSoShiny = "NOT_SO_SHINY",
  Shiny = "SHINY",
}

/** Aggregated statistics for a Shine site or portfolio over a given time period starting from the Commercial Operation Date. */
export type ShineUnit = {
  __typename?: "ShineUnit"
  actualGrossRevenue: Scalars["Float"]["output"]
  actualPvProductionKwh: Scalars["Float"]["output"]
  co2EmissionsReductionTonnes: Scalars["Float"]["output"]
  duration: ShineDuration
  expectedGrossRevenue: Scalars["Float"]["output"]
  expectedPvProductionKwh: Scalars["Float"]["output"]
  start: Scalars["Date"]["output"]
}

export type Site = {
  __typename?: "Site"
  activeMeters?: Maybe<MeterSet>
  activeResults: Array<Result>
  attachment: Attachment
  attachments: Array<Attachment>
  bauMeters: Array<BauMeter>
  billSuggestions: Array<BillSuggestion>
  buildingClass?: Maybe<Scalars["String"]["output"]>
  buildingData?: Maybe<BuildingData>
  buildingFootprintCount?: Maybe<Scalars["Int"]["output"]>
  buildingFootprintNeedsReview: Scalars["Boolean"]["output"]
  buildingFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  buildingType: Scalars["String"]["output"]
  capRate?: Maybe<Scalars["Float"]["output"]>
  carportMaxPvKw?: Maybe<Scalars["Float"]["output"]>
  cbsaId?: Maybe<Scalars["String"]["output"]>
  cbsaName?: Maybe<Scalars["String"]["output"]>
  changelog: SiteChangelog
  city: Scalars["String"]["output"]
  cleanMeters: CleanMeterQuery
  closestSites: Array<RevampSite>
  computedCarportMaxPvKw: Scalars["Float"]["output"]
  computedGroundMaxPvKw?: Maybe<Scalars["Float"]["output"]>
  computedRoofMaxPvKw: Scalars["Float"]["output"]
  conserviceSearch: Array<ConserviceSearch>
  costarPropertyType?: Maybe<CoStarPropertyType>
  costarSecondaryType?: Maybe<CoStarSecondaryType>
  county: Scalars["String"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  currentPolicyChecks: Array<PolicyCheck>
  currentStatus?: Maybe<SiteStatusChange>
  customTariffs: Array<CustomTariff>
  customerId?: Maybe<Scalars["String"]["output"]>
  dateTargetUtilitySet?: Maybe<Scalars["DateTime"]["output"]>
  displayName?: Maybe<Scalars["String"]["output"]>
  documentsV0: Array<Document>
  doeReferenceType?: Maybe<BuildingType>
  espm?: Maybe<EspmProperty>
  etbReport?: Maybe<EtbReport>
  etbReports: Array<EtbReport>
  etbScenarioOptions: Array<EtbScenarioRef>
  evCalc?: Maybe<EvCalc>
  existingSolarDetectionScore?: Maybe<Scalars["Int"]["output"]>
  explainCarportHeuristic: Scalars["String"]["output"]
  explainCarportParkingSpaceHeuristic: Scalars["String"]["output"]
  explainGroundHeuristic: Scalars["String"]["output"]
  explainRoofHeuristic: Scalars["String"]["output"]
  explainSlopedHeuristic: Scalars["String"]["output"]
  failures: Array<BuildingFootprintFailureFinmodelFailureGuessTariffFailureLoadEstimateFailureParcelDataFailure>
  finmodel: RevampFinmodel
  finmodelTable: FinmodelTable
  footprint: Footprint
  fullAddress: Scalars["String"]["output"]
  groundAvailableSqft?: Maybe<Scalars["Float"]["output"]>
  groundMaxPvKw?: Maybe<Scalars["Float"]["output"]>
  hasIntervalDownload: Scalars["Boolean"]["output"]
  hasRoofImage: Scalars["Boolean"]["output"]
  helioscopes: Array<Helioscope>
  hiddenFromCustomers: Scalars["Boolean"]["output"]
  hideFakePanels: Scalars["Boolean"]["output"]
  id: Scalars["Int"]["output"]
  impliedCarportLinearFt?: Maybe<Scalars["Float"]["output"]>
  impliedUsableRoofSqft?: Maybe<Scalars["Float"]["output"]>
  impliedUsableRoofSqftExplanation: RoofSqftExplanation
  incentives: GeographicIncentives
  includeStorage: Scalars["Boolean"]["output"]
  isBehindTheMeter?: Maybe<Scalars["Boolean"]["output"]>
  isEnergyCommunity: Scalars["Boolean"]["output"]
  isFavorite?: Maybe<Scalars["Boolean"]["output"]>
  isLowIncomeCommunity?: Maybe<Scalars["Boolean"]["output"]>
  isMultifamily: Scalars["Boolean"]["output"]
  labels: Array<SiteLabel>
  latitude: Scalars["Float"]["output"]
  leaseType?: Maybe<LeaseType>
  longitude: Scalars["Float"]["output"]
  lux: Lux
  mappedDoeReferenceType: Scalars["String"]["output"]
  meterSet: MeterSet
  metering?: Maybe<Metering>
  meteringSetBy?: Maybe<UserRef>
  meteringSetDate?: Maybe<Scalars["DateTime"]["output"]>
  mortgageLender?: Maybe<Scalars["String"]["output"]>
  notes: Array<AdminNote>
  numParkingSpaces?: Maybe<Scalars["Int"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  numUnits1Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits2Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits3Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits4Bd?: Maybe<Scalars["Int"]["output"]>
  numUnitsStudio?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
  numberOfBuildings?: Maybe<Scalars["Float"]["output"]>
  occupancyRate?: Maybe<Scalars["Float"]["output"]>
  occupancyType?: Maybe<BuildingOccupancyType>
  orgSlug?: Maybe<Scalars["String"]["output"]>
  overrides: Array<FinmodelInputOverride>
  parcelFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  physicalCheck: PhysicalCheck
  pid: Scalars["String"]["output"]
  policies: Array<Policy>
  policyViolations: Array<PolicyViolation>
  portfolio?: Maybe<AdminPortfolio>
  possibleTariffs: Array<Tariff>
  previewBuildingFootprints: FootprintError
  primaryScenario?: Maybe<AdminScenario>
  probableUtilities: Array<Utility>
  propertyName?: Maybe<Scalars["String"]["output"]>
  result: Result
  resultConfig: Array<ResultConfig>
  roofCondition?: Maybe<Scalars["String"]["output"]>
  roofImage?: Maybe<Attachment>
  roofKeepoutsSqft?: Maybe<Scalars["Float"]["output"]>
  roofMaxKw?: Maybe<Scalars["Float"]["output"]>
  roofMaxPvKw?: Maybe<Scalars["Float"]["output"]>
  roofObstructionsSqft?: Maybe<Scalars["Float"]["output"]>
  roofReplacedYr?: Maybe<Scalars["Int"]["output"]>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  roofUsableSqft?: Maybe<Scalars["Float"]["output"]>
  scenario?: Maybe<AdminScenario>
  scenarios: Array<AdminScenario>
  setbackRoofSqft?: Maybe<Scalars["Float"]["output"]>
  shine: ShineSite
  slopedRoof?: Maybe<Scalars["Boolean"]["output"]>
  solarLocation?: Maybe<SolarLocation>
  sqft?: Maybe<Scalars["Float"]["output"]>
  state: Scalars["String"]["output"]
  staticMapUrl: Scalars["String"]["output"]
  status?: Maybe<SiteStatus>
  statusCheck: Array<StatusCheck>
  statusCheckPassed: Scalars["Boolean"]["output"]
  statusDisplayText?: Maybe<Scalars["String"]["output"]>
  streetAddress: Scalars["String"]["output"]
  targetUtility: Utility
  targetUtilitySetBy?: Maybe<UserRef>
  tariffDetail: TariffDetails
  thirdPartySupplier?: Maybe<ThirdPartySupplier>
  timeZone: Scalars["String"]["output"]
  todos: Array<TodoItem>
  usableCarportFt?: Maybe<Scalars["Float"]["output"]>
  usableRoofPct?: Maybe<Scalars["Float"]["output"]>
  usableRoofSqft?: Maybe<Scalars["Float"]["output"]>
  usingBillingMeters?: Maybe<Scalars["DateTime"]["output"]>
  utilityByLabel?: Maybe<Utility>
  utilityName?: Maybe<Scalars["String"]["output"]>
  visuals: SiteVisuals
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  zipCode: Scalars["String"]["output"]
}

export type SiteAttachmentArgs = {
  id: Scalars["Int"]["input"]
}

export type SiteChangelogArgs = {
  fields: Array<SiteChangelogColumn>
}

export type SiteClosestSitesArgs = {
  num?: Scalars["Int"]["input"]
  withinFt?: Scalars["Int"]["input"]
}

export type SiteConserviceSearchArgs = {
  onlyHouse: Scalars["Boolean"]["input"]
}

export type SiteEtbReportArgs = {
  id: Scalars["Int"]["input"]
}

export type SiteFinmodelArgs = {
  id: Scalars["Int"]["input"]
}

export type SiteLuxArgs = {
  id: Scalars["Int"]["input"]
}

export type SiteMeterSetArgs = {
  id: Scalars["Int"]["input"]
}

export type SiteNotesArgs = {
  hiddenFromCustomers?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type SitePossibleTariffsArgs = {
  includeCustom?: Scalars["Boolean"]["input"]
  includeUnpreferred?: Scalars["Boolean"]["input"]
  loadCategory?: InputMaybe<LoadCategory>
  preferred?: Scalars["Boolean"]["input"]
}

export type SitePreviewBuildingFootprintsArgs = {
  strategy: FootprintStrategy
}

export type SiteResultArgs = {
  id: Scalars["Int"]["input"]
}

export type SiteScenarioArgs = {
  pid: Scalars["String"]["input"]
}

export type SiteTariffDetailArgs = {
  tariffParentId: Scalars["Int"]["input"]
}

export type SiteUtilityByLabelArgs = {
  label: Scalars["String"]["input"]
}

export type SiteBidsTable = {
  __typename?: "SiteBidsTable"
  rows: Array<SiteBidsTableRow>
  view: SiteBidsTableView
}

export type SiteBidsTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type SiteBidsTableViewArgs = {
  filterBy?: InputMaybe<SiteBidsTableFilter>
  sortBy?: InputMaybe<Array<SiteBidsTableSort>>
}

export enum SiteBidsTableAttr {
  BiddingClosedAt = "BIDDING_CLOSED_AT",
  BiddingOpenAt = "BIDDING_OPEN_AT",
  BidPackageName = "BID_PACKAGE_NAME",
  BidPackagePid = "BID_PACKAGE_PID",
  BuildingOwnerExtraPaymentsUsd = "BUILDING_OWNER_EXTRA_PAYMENTS_USD",
  BuildingOwnerNoiLifetimeUsd = "BUILDING_OWNER_NOI_LIFETIME_USD",
  BundlePid = "BUNDLE_PID",
  CsEstimatedAwardDate = "CS_ESTIMATED_AWARD_DATE",
  EstimatedCod = "ESTIMATED_COD",
  EstimatedNtp = "ESTIMATED_NTP",
  ExtraPaymentsNotes = "EXTRA_PAYMENTS_NOTES",
  FinproductType = "FINPRODUCT_TYPE",
  IncentivesNotes = "INCENTIVES_NOTES",
  InterconnectionCostNonUtilityUsd = "INTERCONNECTION_COST_NON_UTILITY_USD",
  InterconnectionCostUsdPerWatt = "INTERCONNECTION_COST_USD_PER_WATT",
  InterconnectionCostUtilityMaxUsd = "INTERCONNECTION_COST_UTILITY_MAX_USD",
  InterconnectionCostUtilityMinUsd = "INTERCONNECTION_COST_UTILITY_MIN_USD",
  InterconnectionNotes = "INTERCONNECTION_NOTES",
  IsAwarded = "IS_AWARDED",
  IsCustom = "IS_CUSTOM",
  ItcPercentageAssumption = "ITC_PERCENTAGE_ASSUMPTION",
  Name = "NAME",
  OtherNotes = "OTHER_NOTES",
  PackageRowClosedAt = "PACKAGE_ROW_CLOSED_AT",
  PackageRowCloseCustomReason = "PACKAGE_ROW_CLOSE_CUSTOM_REASON",
  PackageRowCloseReason = "PACKAGE_ROW_CLOSE_REASON",
  PackageRowIsClosed = "PACKAGE_ROW_IS_CLOSED",
  PackageRowStatus = "PACKAGE_ROW_STATUS",
  PvSizeKwAc = "PV_SIZE_KW_AC",
  PvSizeKwDc = "PV_SIZE_KW_DC",
  PvTypes = "PV_TYPES",
  RecOwner = "REC_OWNER",
  RoofRentEscalator = "ROOF_RENT_ESCALATOR",
  RoofRentY1Usd = "ROOF_RENT_Y1_USD",
  TermYears = "TERM_YEARS",
}

export type SiteBidsTableFilter = {
  bidPackageName?: InputMaybe<StringPred>
  bidPackagePid?: InputMaybe<StringPred>
  biddingClosedAt?: InputMaybe<DatePred>
  biddingOpenAt?: InputMaybe<DatePred>
  buildingOwnerNoiLifetimeUsd?: InputMaybe<FloatPred>
  bundlePid?: InputMaybe<StringPred>
  csEstimatedAwardDate?: InputMaybe<DatePred>
  estimatedCod?: InputMaybe<DatePred>
  estimatedNtp?: InputMaybe<DatePred>
  finproductType?: InputMaybe<FinProductTypePred>
  id?: InputMaybe<StringPred>
  interconnectionCostNonUtilityUsd?: InputMaybe<FloatPred>
  interconnectionCostUsdPerWatt?: InputMaybe<FloatPred>
  interconnectionCostUtilityMaxUsd?: InputMaybe<FloatPred>
  interconnectionCostUtilityMinUsd?: InputMaybe<FloatPred>
  isAwarded?: InputMaybe<BoolPred>
  isCustom?: InputMaybe<BoolPred>
  itcPercentageAssumption?: InputMaybe<FloatPred>
  name?: InputMaybe<StringPred>
  packageRowClosedAt?: InputMaybe<DatePred>
  packageRowIsClosed?: InputMaybe<BoolPred>
  packageRowStatus?: InputMaybe<PackageRowStatusPred>
  pvSizeKwAc?: InputMaybe<FloatPred>
  pvSizeKwDc?: InputMaybe<FloatPred>
  roofRentEscalator?: InputMaybe<FloatPred>
  roofRentY1Usd?: InputMaybe<FloatPred>
  termYears?: InputMaybe<FloatPred>
}

export type SiteBidsTableRow = {
  __typename?: "SiteBidsTableRow"
  bidPackageName: Scalars["String"]["output"]
  bidPackagePid: Scalars["String"]["output"]
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  buildingOwnerExtraPaymentsUsd?: Maybe<Array<Scalars["Float"]["output"]>>
  buildingOwnerNoiLifetimeUsd?: Maybe<Scalars["Float"]["output"]>
  bundlePid: Scalars["String"]["output"]
  csEstimatedAwardDate?: Maybe<Scalars["DateTime"]["output"]>
  estimatedCod: Scalars["Date"]["output"]
  estimatedNtp: Scalars["Date"]["output"]
  extraPaymentsNotes?: Maybe<Scalars["String"]["output"]>
  finproductType: FinProductType
  id: Scalars["Int"]["output"]
  incentivesNotes?: Maybe<Scalars["String"]["output"]>
  interconnectionCostNonUtilityUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMaxUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMinUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionNotes?: Maybe<Scalars["String"]["output"]>
  isAwarded: Scalars["Boolean"]["output"]
  isCustom: Scalars["Boolean"]["output"]
  itcPercentageAssumption: Scalars["Float"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  otherNotes?: Maybe<Scalars["String"]["output"]>
  packageRowCloseCustomReason?: Maybe<Scalars["String"]["output"]>
  packageRowCloseReason?: Maybe<PackageRowCloseReason>
  packageRowClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  packageRowIsClosed: Scalars["Boolean"]["output"]
  packageRowStatus?: Maybe<PackageRowStatus>
  pvSizeKwAc?: Maybe<Scalars["Float"]["output"]>
  pvSizeKwDc?: Maybe<Scalars["Float"]["output"]>
  pvTypes: Array<PvType>
  recOwner: RecOwner
  roofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  roofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  termYears?: Maybe<Scalars["Int"]["output"]>
}

export type SiteBidsTableSort = {
  attr: SiteBidsTableAttr
  order: SortOrder
}

export type SiteBidsTableView = {
  __typename?: "SiteBidsTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
}

export type SiteChangelog = {
  __typename?: "SiteChangelog"
  all: Array<SiteChangelogColumnBaseWrapper>
}

export enum SiteChangelogColumn {
  Tsvector2 = "Tsvector2",
  Ab802GuessedAt = "ab802GuessedAt",
  AddressSha256 = "addressSha256",
  AllowableSolarLocations = "allowableSolarLocations",
  AllowableSolarLocationsOther = "allowableSolarLocationsOther",
  AssetManager = "assetManager",
  BiddingConfigId = "biddingConfigId",
  BuildingClass = "buildingClass",
  BuildingDataId = "buildingDataId",
  BuildingFootprintCount = "buildingFootprintCount",
  BuildingFootprintSetbackSqft = "buildingFootprintSetbackSqft",
  BuildingFootprintSetbackStr = "buildingFootprintSetbackStr",
  BuildingFootprintSetbackStrUpdatedAt = "buildingFootprintSetbackStrUpdatedAt",
  BuildingFootprintSetbackStrUpdatedByUserId = "buildingFootprintSetbackStrUpdatedByUserId",
  BuildingFootprintSqft = "buildingFootprintSqft",
  BuildingFootprintUpdatedAt = "buildingFootprintUpdatedAt",
  BuildingFootprintUpdatedByUserId = "buildingFootprintUpdatedByUserId",
  CapRate = "capRate",
  CapRateUpdatedAt = "capRateUpdatedAt",
  CarportFootprintFt = "carportFootprintFt",
  CarportFootprintStr = "carportFootprintStr",
  CarportFootprintStrUpdatedAt = "carportFootprintStrUpdatedAt",
  CarportFootprintUpdatedByUserId = "carportFootprintUpdatedByUserId",
  CarportMaxPvKw = "carportMaxPvKw",
  CarportMaxPvKwDateUpdated = "carportMaxPvKwDateUpdated",
  CarportMaxPvKwUserIdUpdated = "carportMaxPvKwUserIdUpdated",
  CbsaId = "cbsaId",
  CbsaName = "cbsaName",
  City = "city",
  CostarPropertyType = "costarPropertyType",
  CostarSecondaryType = "costarSecondaryType",
  County = "county",
  CreatedByUserId = "createdByUserId",
  CurrentStatusId = "currentStatusId",
  CustomerId = "customerId",
  DateCreated = "dateCreated",
  DateDoeReferenceTypeUpdated = "dateDoeReferenceTypeUpdated",
  DateMeteringUpdated = "dateMeteringUpdated",
  DateTargetUtilitySet = "dateTargetUtilitySet",
  DoeReferenceType = "doeReferenceType",
  DoeReferenceTypeUpdatedByUserId = "doeReferenceTypeUpdatedByUserId",
  EnergyThingsId = "energyThingsId",
  EvCalcId = "evCalcId",
  EvOverridesId = "evOverridesId",
  ExistingSolarDetectionScore = "existingSolarDetectionScore",
  FinalKeepoutsFootprintSqft = "finalKeepoutsFootprintSqft",
  FinancingThingsId = "financingThingsId",
  FinmodelDepsUpdatedAt = "finmodelDepsUpdatedAt",
  FinmodelInputOverridesUpdatedAt = "finmodelInputOverridesUpdatedAt",
  FinmodelVersion = "finmodelVersion",
  FinmodelVersionNum = "finmodelVersionNum",
  FinmodelVersionSetAt = "finmodelVersionSetAt",
  FinmodelVersionSetByUserId = "finmodelVersionSetByUserId",
  FlagSummaryId = "flagSummaryId",
  FootprintStr = "footprintStr",
  GeocodeResponseId = "geocodeResponseId",
  GroundAvailableSqft = "groundAvailableSqft",
  GroundAvailableSqftDateUpdated = "groundAvailableSqftDateUpdated",
  GroundAvailableSqftUserIdUpdated = "groundAvailableSqftUserIdUpdated",
  GroundMaxPvKw = "groundMaxPvKw",
  GroundMaxPvKwDateUpdated = "groundMaxPvKwDateUpdated",
  GroundMaxPvKwUserIdUpdated = "groundMaxPvKwUserIdUpdated",
  GroundmountFootprintSqft = "groundmountFootprintSqft",
  GroundmountFootprintStr = "groundmountFootprintStr",
  GroundmountFootprintStrUpdatedAt = "groundmountFootprintStrUpdatedAt",
  GroundmountFootprintUpdatedByUserId = "groundmountFootprintUpdatedByUserId",
  HiddenFromCustomers = "hiddenFromCustomers",
  HideFakePanels = "hideFakePanels",
  Id = "id",
  IsBehindTheMeter = "isBehindTheMeter",
  IsMultifamily = "isMultifamily",
  KeepoutsFootprintSqft = "keepoutsFootprintSqft",
  KeepoutsFootprintStr = "keepoutsFootprintStr",
  KeepoutsFootprintStrUpdatedAt = "keepoutsFootprintStrUpdatedAt",
  KeepoutsFootprintUpdatedByUserId = "keepoutsFootprintUpdatedByUserId",
  Latitude = "latitude",
  LeaseType = "leaseType",
  LeaseTypeUpdatedAt = "leaseTypeUpdatedAt",
  Longitude = "longitude",
  Metering = "metering",
  MeteringUpdatedByUserId = "meteringUpdatedByUserId",
  MetersId = "metersId",
  MetersUpdatedAt = "metersUpdatedAt",
  MortgageLender = "mortgageLender",
  Name = "name_",
  NumParkingSpaces = "numParkingSpaces",
  NumStories = "numStories",
  OccupancyPct = "occupancyPct",
  OccupancyType = "occupancyType",
  OccupancyTypeUpdatedAt = "occupancyTypeUpdatedAt",
  ParcelFootprintSqft = "parcelFootprintSqft",
  ParcelFootprintStr = "parcelFootprintStr",
  ParcelFootprintStrUpdatedAt = "parcelFootprintStrUpdatedAt",
  ParcelFootprintUpdatedByUserId = "parcelFootprintUpdatedByUserId",
  ParentSiteId = "parentSiteId",
  PhysicalCheckId = "physicalCheckId",
  PhysicalCheckUpdatedAt = "physicalCheckUpdatedAt",
  Pid = "pid",
  PortfolioId = "portfolioId",
  PortfolioUpdatedAt = "portfolioUpdatedAt",
  PpaOfftaker = "ppaOfftaker",
  PpaSignatory = "ppaSignatory",
  PrimaryScenarioId = "primaryScenarioId",
  PrimaryScenarioSetById = "primaryScenarioSetById",
  ProcessedObstructionsSqft = "processedObstructionsSqft",
  ProcessedObstructionsStr = "processedObstructionsStr",
  ProcessedObstructionsUpdatedAt = "processedObstructionsUpdatedAt",
  PvwattsUpdatedAt = "pvwattsUpdatedAt",
  ResultGridId = "resultGridId",
  RofoSigned = "rofoSigned",
  RoofImageId = "roofImageId",
  RoofMaxPvKw = "roofMaxPvKw",
  RoofMaxPvKwDateUpdated = "roofMaxPvKwDateUpdated",
  RoofMaxPvKwUserIdUpdated = "roofMaxPvKwUserIdUpdated",
  RoofSqft = "roofSqft",
  RoofSqftUpdatedAt = "roofSqftUpdatedAt",
  SelectedConfigId = "selectedConfigId",
  SiteDataOrigin = "siteDataOrigin",
  SiteDetailsId = "siteDetailsId",
  SlopedRoof = "slopedRoof",
  SlopedRoofUpdatedAt = "slopedRoofUpdatedAt",
  SlopedRoofUpdatedByUserId = "slopedRoofUpdatedByUserId",
  Sqft = "sqft",
  SqftUpdatedAt = "sqftUpdatedAt",
  State = "state",
  StreetAddress = "streetAddress",
  TargetUtilityId = "targetUtilityId",
  TargetUtilitySetByUserId = "targetUtilitySetByUserId",
  TenantInterest = "tenantInterest",
  TenantLeaseEnds = "tenantLeaseEnds",
  TenantLeaseTerm = "tenantLeaseTerm",
  ThirdPartySupplierId = "thirdPartySupplierId",
  ThirdPartySupplierSetByUserId = "thirdPartySupplierSetByUserId",
  TimeZone = "timeZone",
  UsableCarportFt = "usableCarportFt",
  UsableCarportFtUpdatedAt = "usableCarportFtUpdatedAt",
  UsableCarportFtUpdatedByUserId = "usableCarportFtUpdatedByUserId",
  UsableRoofPct = "usableRoofPct",
  UsableRoofPctUpdatedAt = "usableRoofPctUpdatedAt",
  UsableRoofPctUpdatedByUserId = "usableRoofPctUpdatedByUserId",
  UsableRoofSqft = "usableRoofSqft",
  UsableRoofSqftUpdatedAt = "usableRoofSqftUpdatedAt",
  UsableRoofSqftUpdatedByUserId = "usableRoofSqftUpdatedByUserId",
  UsingBillingMeters = "usingBillingMeters",
  YearBuilt = "yearBuilt",
  ZipCode = "zipCode",
  ZipCodeUpdatedAt = "zipCodeUpdatedAt",
}

export type SiteChangelogColumnBaseWrapper = {
  __typename?: "SiteChangelogColumnBaseWrapper"
  column: SiteChangelogColumn
  obj?: Maybe<Changelog>
}

export type SiteConfig = {
  __typename?: "SiteConfig"
  createdAt?: Maybe<Scalars["DateTime"]["output"]>
  createdBy?: Maybe<UserRef>
  financing: RevampFinancing
  scenario: RevampScenario
}

export type SiteDetails = {
  __typename?: "SiteDetails"
  buildingLegalName?: Maybe<Scalars["String"]["output"]>
  constructionEmail?: Maybe<Scalars["String"]["output"]>
  counselApproval?: Maybe<CounselApproval>
  createdAt: Scalars["DateTime"]["output"]
  externalLeaseApprovers?: Maybe<Array<Scalars["String"]["output"]>>
  fieldHistory?: Maybe<SiteDetailsFieldChangeLog>
  id: Scalars["Int"]["output"]
  isFannieMaeLender?: Maybe<Scalars["Boolean"]["output"]>
  isFmGlobalInsurer?: Maybe<Scalars["Boolean"]["output"]>
  lastEditedBy?: Maybe<UserRef>
  leaseApprovers: Array<Scalars["String"]["output"]>
  leaseLegalOwnerName?: Maybe<Scalars["String"]["output"]>
  leasePropertyLegalDescription?: Maybe<Scalars["String"]["output"]>
  leaseSignatory?: Maybe<Scalars["String"]["output"]>
  needsTenantApproval?: Maybe<Scalars["Boolean"]["output"]>
  propertyFundName?: Maybe<Scalars["String"]["output"]>
  propertyInsurer?: Maybe<Scalars["String"]["output"]>
  propertyLenders?: Maybe<Scalars["String"]["output"]>
  propertySiteVisitContacts?: Maybe<Array<Scalars["String"]["output"]>>
  roofCondition?: Maybe<Scalars["String"]["output"]>
  roofReplacedYr?: Maybe<Scalars["Int"]["output"]>
  roofRightsHolder?: Maybe<RoofRightsHolder>
  salePlannedYear?: Maybe<Scalars["Int"]["output"]>
  salePlans?: Maybe<Scalars["String"]["output"]>
  signatureBlocks?: Maybe<Array<Scalars["String"]["output"]>>
}

export type SiteDetailsFieldChangeLog = {
  __typename?: "SiteDetailsFieldChangeLog"
  buildingLegalName: FieldChangeLogHistory
  constructionEmail: FieldChangeLogHistory
  counselApproval: FieldChangeLogHistory
  externalLeaseApprovers: FieldChangeLogHistory
  isFannieMaeLender: FieldChangeLogHistory
  isFmGlobalInsurer: FieldChangeLogHistory
  leaseApprovers: FieldChangeLogHistory
  leaseLegalOwnerName: FieldChangeLogHistory
  leasePropertyLegalDescription: FieldChangeLogHistory
  leaseSignatory: FieldChangeLogHistory
  needsTenantApproval: FieldChangeLogHistory
  propertyFundName: FieldChangeLogHistory
  propertyInsurer: FieldChangeLogHistory
  propertyLenders: FieldChangeLogHistory
  propertySiteVisitContacts: FieldChangeLogHistory
  roofCondition: FieldChangeLogHistory
  roofReplacedYr: FieldChangeLogHistory
  roofRightsHolder: FieldChangeLogHistory
  salePlannedYear: FieldChangeLogHistory
  salePlans: FieldChangeLogHistory
  signatureBlocks: FieldChangeLogHistory
}

export type SiteDocuments = {
  __typename?: "SiteDocuments"
  documents: Array<Document>
  sitePid: Scalars["String"]["output"]
}

export type SiteFieldChangeLog = {
  __typename?: "SiteFieldChangeLog"
  leaseType: FieldChangeLogHistory
  occupancyType: FieldChangeLogHistory
  targetUtilityId: FieldChangeLogHistory
  tenantLeaseTerm: FieldChangeLogHistory
}

export type SiteFlag = {
  __typename?: "SiteFlag"
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  resolvedAt?: Maybe<Scalars["DateTime"]["output"]>
  site: SiteRef
  type: SiteFlagType
}

export type SiteFlagSummary = {
  __typename?: "SiteFlagSummary"
  duplicateAddressFound?: Maybe<Scalars["Boolean"]["output"]>
  existingSolarLikely?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["Int"]["output"]
  improbableEnergyCosts?: Maybe<Scalars["Boolean"]["output"]>
  tariffNotFound?: Maybe<Scalars["Boolean"]["output"]>
  utilityNotFound?: Maybe<Scalars["Boolean"]["output"]>
}

export type SiteFlagSummaryPred = {
  value: Array<SiteFlagType>
}

export enum SiteFlagType {
  DuplicateAddressFound = "DUPLICATE_ADDRESS_FOUND",
  ExistingSolarLikely = "EXISTING_SOLAR_LIKELY",
  ImprobableEnergyCosts = "IMPROBABLE_ENERGY_COSTS",
  TariffNotFound = "TARIFF_NOT_FOUND",
  UtilityNotFound = "UTILITY_NOT_FOUND",
}

export type SiteLabel = {
  __typename?: "SiteLabel"
  createdAt: Scalars["DateTime"]["output"]
  createdBy?: Maybe<UserRef>
  description: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  perms: SiteLabelPerms
  pid: Scalars["String"]["output"]
  sites: Array<Scalars["String"]["output"]>
  themeColor: LabelColor
}

export type SiteLabelNamesPred = {
  value: Array<Scalars["String"]["input"]>
}

export type SiteLabelPerms = {
  __typename?: "SiteLabelPerms"
  canAdd: Scalars["Boolean"]["output"]
  canRemove: Scalars["Boolean"]["output"]
}

export type SiteMutations = {
  __typename?: "SiteMutations"
  addEtb: Site
  addHelioscope: Helioscope
  addScenario: AddScenarioResponse
  attachFile: AttachFileResponse
  clearDrawings?: Maybe<Scalars["Void"]["output"]>
  deleteBuildingFootprint: Site
  deleteParcelFootprint: Site
  findBuildingFootprints?: Maybe<Scalars["Void"]["output"]>
  labels: AdminSiteLabelMutations
  linkConserviceAddresses?: Maybe<Error>
  new: Site
  newEvCalc: EvCalc
  revertToEstimates?: Maybe<Scalars["Void"]["output"]>
  setBadRoof: Site
  setBauMeterLabel: Site
  setBauMeterTariff: Site
  setBuildingClass?: Maybe<Scalars["Void"]["output"]>
  setCapRate: Site
  setCarportMaxPvKw: Site
  setCostarPropertyType: Site
  setCostarSecondaryType: Site
  setCustomerId?: Maybe<Scalars["Void"]["output"]>
  setDoeReferenceType: Site
  setExistingSolar: Site
  setGroundAvailableSqft: Site
  setGroundMaxPvKw: Site
  setHelioscopeAllocation?: Maybe<Scalars["Void"]["output"]>
  setLatitude?: Maybe<Scalars["Void"]["output"]>
  setLeaseType?: Maybe<Scalars["Void"]["output"]>
  setLongitude?: Maybe<Scalars["Void"]["output"]>
  setMetering?: Maybe<Scalars["Void"]["output"]>
  setNumParkingSpaces: Site
  setNumStories: Site
  setOccupancyType?: Maybe<Scalars["Void"]["output"]>
  setPortfolio: Site
  setRoofImage: Site
  setRoofMaxPvKw: Site
  setRoofSqft: Site
  setSiteHiddenFromCustomers: Site
  setSlopedRoof: Site
  setSqft: Site
  setStatus: Site
  setTargetUtility: Site
  setThirdPartySupplier: Site
  setUnobstructedFlatRoof: Site
  setUnobstructedFlatRoofSqft: Site
  setUsableCarportFt: Site
  setUsableRoofPct: Site
  setUsableRoofSqft: Site
  setYearBuilt: Site
  setZipCode: Site
  toggleFinproduct?: Maybe<Scalars["Void"]["output"]>
  toggleHideFakePanels?: Maybe<Scalars["Void"]["output"]>
  trashAttachment: Site
  trashHelioscope: Site
  turnOffBillingMeters?: Maybe<Scalars["Void"]["output"]>
  /** @deprecated to be replaced by uploadHelioscope */
  uploadHelioscopePdf: UploadHelioscopePdfResponse
}

export type SiteMutationsAddEtbArgs = {
  carportPvKw?: InputMaybe<Scalars["Float"]["input"]>
  loadOrigin: LoadOrigin
  makeActive: Scalars["Boolean"]["input"]
  roofPvKw?: InputMaybe<Scalars["Float"]["input"]>
  scenarioPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  upload: Scalars["Upload"]["input"]
}

export type SiteMutationsAddHelioscopeArgs = {
  carportIsMax: Scalars["Boolean"]["input"]
  carportPvSixHighKw: Scalars["Float"]["input"]
  carportPvThreeHighKw: Scalars["Float"]["input"]
  groundPvKw: Scalars["Float"]["input"]
  pdfId: Scalars["Int"]["input"]
  productionCsvId: Scalars["Int"]["input"]
  roofImageId: Scalars["Int"]["input"]
  roofIsMax: Scalars["Boolean"]["input"]
  roofPvKw: Scalars["Float"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsAddScenarioArgs = {
  includeStorage: Scalars["Boolean"]["input"]
  loadCategory: LoadCategory
  name?: InputMaybe<Scalars["String"]["input"]>
  sitePid: Scalars["String"]["input"]
  solarLocation: SolarLocation
}

export type SiteMutationsAttachFileArgs = {
  pid: Scalars["String"]["input"]
  tag?: InputMaybe<Scalars["String"]["input"]>
  upload: Scalars["Upload"]["input"]
}

export type SiteMutationsClearDrawingsArgs = {
  input: ClearDrawingsInput
}

export type SiteMutationsDeleteBuildingFootprintArgs = {
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsDeleteParcelFootprintArgs = {
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsFindBuildingFootprintsArgs = {
  sitePid: Scalars["String"]["input"]
  strategy: FootprintStrategy
}

export type SiteMutationsLinkConserviceAddressesArgs = {
  conserviceAddresses: Array<Scalars["String"]["input"]>
  orgPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsNewArgs = {
  buildingDataId: Scalars["Int"]["input"]
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
}

export type SiteMutationsNewEvCalcArgs = {
  markupUsdPerKwh: Scalars["Float"]["input"]
  numChargers: Scalars["Int"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsRevertToEstimatesArgs = {
  input: RevertToEstimatesInput
}

export type SiteMutationsSetBadRoofArgs = {
  sitePid: Scalars["String"]["input"]
  source: PhysicalCheckSource
  value?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type SiteMutationsSetBauMeterLabelArgs = {
  input: SetBauMeterLabelInput
}

export type SiteMutationsSetBauMeterTariffArgs = {
  input: SetBauMeterTariffInput
}

export type SiteMutationsSetBuildingClassArgs = {
  buildingClass?: InputMaybe<Scalars["String"]["input"]>
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsSetCapRateArgs = {
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Float"]["input"]>
}

export type SiteMutationsSetCarportMaxPvKwArgs = {
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Float"]["input"]>
}

export type SiteMutationsSetCostarPropertyTypeArgs = {
  sitePid: Scalars["String"]["input"]
  value: CoStarPropertyType
}

export type SiteMutationsSetCostarSecondaryTypeArgs = {
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<CoStarSecondaryType>
}

export type SiteMutationsSetCustomerIdArgs = {
  customerId?: InputMaybe<Scalars["String"]["input"]>
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsSetDoeReferenceTypeArgs = {
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<BuildingType>
}

export type SiteMutationsSetExistingSolarArgs = {
  sitePid: Scalars["String"]["input"]
  source: PhysicalCheckSource
  value?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type SiteMutationsSetGroundAvailableSqftArgs = {
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}

export type SiteMutationsSetGroundMaxPvKwArgs = {
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Float"]["input"]>
}

export type SiteMutationsSetHelioscopeAllocationArgs = {
  allocations: Array<Allocation>
  helioscopeId: Scalars["Int"]["input"]
}

export type SiteMutationsSetLatitudeArgs = {
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}

export type SiteMutationsSetLeaseTypeArgs = {
  leaseType?: InputMaybe<LeaseType>
  sitePids: Array<Scalars["String"]["input"]>
}

export type SiteMutationsSetLongitudeArgs = {
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}

export type SiteMutationsSetMeteringArgs = {
  metering?: InputMaybe<Metering>
  sitePids: Array<Scalars["String"]["input"]>
}

export type SiteMutationsSetNumParkingSpacesArgs = {
  numParkingSpaces?: InputMaybe<Scalars["Int"]["input"]>
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsSetNumStoriesArgs = {
  numStories?: InputMaybe<Scalars["Int"]["input"]>
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsSetOccupancyTypeArgs = {
  occupancyType?: InputMaybe<BuildingOccupancyType>
  sitePids: Array<Scalars["String"]["input"]>
}

export type SiteMutationsSetPortfolioArgs = {
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsSetRoofImageArgs = {
  attachmentId?: InputMaybe<Scalars["Int"]["input"]>
  pid: Scalars["String"]["input"]
}

export type SiteMutationsSetRoofMaxPvKwArgs = {
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Float"]["input"]>
}

export type SiteMutationsSetRoofSqftArgs = {
  sitePid: Scalars["String"]["input"]
  sourceId?: InputMaybe<Scalars["String"]["input"]>
  sourceType?: InputMaybe<ChangeSourceType>
  value: Scalars["Float"]["input"]
}

export type SiteMutationsSetSiteHiddenFromCustomersArgs = {
  hiddenFromCustomers: Scalars["Boolean"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsSetSlopedRoofArgs = {
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type SiteMutationsSetSqftArgs = {
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}

export type SiteMutationsSetStatusArgs = {
  customReason?: InputMaybe<Scalars["String"]["input"]>
  reason?: InputMaybe<StatusReason>
  sitePid: Scalars["String"]["input"]
  status: SiteStatus
  unixtimeSec?: InputMaybe<Scalars["Int"]["input"]>
}

export type SiteMutationsSetTargetUtilityArgs = {
  sitePid: Scalars["String"]["input"]
  utilityId: Scalars["Int"]["input"]
}

export type SiteMutationsSetThirdPartySupplierArgs = {
  sitePid: Scalars["String"]["input"]
  thirdPartySupplierId?: InputMaybe<Scalars["Int"]["input"]>
}

export type SiteMutationsSetUnobstructedFlatRoofArgs = {
  sitePid: Scalars["String"]["input"]
  source: PhysicalCheckSource
  value?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type SiteMutationsSetUnobstructedFlatRoofSqftArgs = {
  sitePid: Scalars["String"]["input"]
  source: PhysicalCheckSource
  value?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type SiteMutationsSetUsableCarportFtArgs = {
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}

export type SiteMutationsSetUsableRoofPctArgs = {
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}

export type SiteMutationsSetUsableRoofSqftArgs = {
  sitePid: Scalars["String"]["input"]
  sourceId?: InputMaybe<Scalars["String"]["input"]>
  sourceType?: InputMaybe<ChangeSourceType>
  value: Scalars["Float"]["input"]
}

export type SiteMutationsSetYearBuiltArgs = {
  sitePid: Scalars["String"]["input"]
  yearBuilt?: InputMaybe<Scalars["Int"]["input"]>
}

export type SiteMutationsSetZipCodeArgs = {
  sitePid: Scalars["String"]["input"]
  value: Scalars["String"]["input"]
}

export type SiteMutationsToggleFinproductArgs = {
  enabled: Scalars["Boolean"]["input"]
  finproductId: Scalars["Int"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsToggleHideFakePanelsArgs = {
  hide: Scalars["Boolean"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsTrashAttachmentArgs = {
  attachmentId: Scalars["Int"]["input"]
  pid: Scalars["String"]["input"]
}

export type SiteMutationsTrashHelioscopeArgs = {
  helioscopePid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsTurnOffBillingMetersArgs = {
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsUploadHelioscopePdfArgs = {
  reportPdf: Scalars["Upload"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type SiteRef = {
  __typename?: "SiteRef"
  buildingType?: Maybe<BuildingType>
  city: Scalars["String"]["output"]
  lat: Scalars["Float"]["output"]
  lon: Scalars["Float"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  pid: Scalars["String"]["output"]
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  zipCode: Scalars["String"]["output"]
}

export type SiteSearchTerm = {
  __typename?: "SiteSearchTerm"
  address: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  propertyName?: Maybe<Scalars["String"]["output"]>
}

export enum SiteStatus {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
  OnHold = "ON_HOLD",
}

export type SiteStatusChange = {
  __typename?: "SiteStatusChange"
  createdBy: UserRef
  customReason?: Maybe<Scalars["String"]["output"]>
  dateCreated: Scalars["DateTime"]["output"]
  displayText: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  status: SiteStatus
  statusDisplayText: Scalars["String"]["output"]
  statusReasonDisplayText?: Maybe<Scalars["String"]["output"]>
}

export type SiteStatusPred = {
  value?: InputMaybe<SiteStatus>
}

export type SiteVisuals = {
  __typename?: "SiteVisuals"
  solarPanels: Array<MapSolarPanel>
}

export type SlimCostSummary = {
  __typename?: "SlimCostSummary"
  demandCost: Scalars["Float"]["output"]
  energyCost: Scalars["Float"]["output"]
  exportBenefit: Scalars["Float"]["output"]
  fixedCost: Scalars["Float"]["output"]
  nbcCost: Scalars["Float"]["output"]
  totalCost: Scalars["Float"]["output"]
  totalEnergyUsage: Scalars["Float"]["output"]
}

export type SolarFeasibility = {
  __typename?: "SolarFeasibility"
  economics?: Maybe<GaugeRazzleDazzle>
  physical?: Maybe<GaugeRazzleDazzle>
}

export enum SolarLocation {
  CarportOnly = "CARPORT_ONLY",
  Ground = "GROUND",
  RoofAndCarport = "ROOF_AND_CARPORT",
  RoofOnly = "ROOF_ONLY",
}

export type SolarLocationPred = {
  value: Array<InputMaybe<SolarLocation>>
}

export type SolarPerDay = {
  __typename?: "SolarPerDay"
  day: Scalars["Date"]["output"]
  kwh: Scalars["Float"]["output"]
}

export type SolarSite = {
  __typename?: "SolarSite"
  daysActive: Scalars["Int"]["output"]
  kwhLifetime: Scalars["Float"]["output"]
  name: Scalars["String"]["output"]
}

export enum SortOrder {
  Asc = "ASC",
  Desc = "DESC",
}

export type Source = {
  __typename?: "Source"
  text?: Maybe<Scalars["String"]["output"]>
  url?: Maybe<Scalars["String"]["output"]>
}

export enum SpecOptOutReason {
  Other = "OTHER",
}

export type StatusCheck = {
  __typename?: "StatusCheck"
  desc: Scalars["String"]["output"]
  hint: Scalars["String"]["output"]
  status: Scalars["Boolean"]["output"]
}

export enum StatusReason {
  BuildingWillBeSoldSoon = "BUILDING_WILL_BE_SOLD_SOON",
  Duplicate = "DUPLICATE",
  HighRiseWithBusyRoof = "HIGH_RISE_WITH_BUSY_ROOF",
  InsufficientFinancialReturn = "INSUFFICIENT_FINANCIAL_RETURN",
  Other = "OTHER",
  PpasNotAllowed = "PPAS_NOT_ALLOWED",
  RoofNeedsReplacing = "ROOF_NEEDS_REPLACING",
  SolarInstalled = "SOLAR_INSTALLED",
  SystemSizeTooSmall = "SYSTEM_SIZE_TOO_SMALL",
}

export type StringPred = {
  value: Array<InputMaybe<Scalars["String"]["input"]>>
}

export type SubRate = {
  __typename?: "SubRate"
  chargeClass?: Maybe<ChargeClass>
  op: OpType
  rateId?: Maybe<Scalars["Int"]["output"]>
}

export type SubRateInput = {
  chargeClass?: InputMaybe<ChargeClass>
  rateId?: InputMaybe<Scalars["Int"]["input"]>
}

export type System = {
  __typename?: "System"
  batterySpecs: Array<BatterySpec>
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  pid: Scalars["String"]["output"]
  pvSpecs: Array<PvSpec>
  totalPvSizeKw: Scalars["Float"]["output"]
}

export type SystemLite = {
  __typename?: "SystemLite"
  batterySpecs: Array<BatterySpecLite>
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  pid: Scalars["String"]["output"]
  pvSpecs: Array<PvSpec>
  totalPvSizeKw: Scalars["Float"]["output"]
}

export type Tariff = {
  __typename?: "Tariff"
  closedDate?: Maybe<Scalars["DateTime"]["output"]>
  code: Scalars["String"]["output"]
  customerClass: Scalars["String"]["output"]
  customerCount?: Maybe<Scalars["Int"]["output"]>
  customerLikelihood: Scalars["Float"]["output"]
  hasNetMetering: Scalars["Boolean"]["output"]
  hasTouRates: Scalars["Boolean"]["output"]
  history?: Maybe<TariffHistory>
  id: Scalars["Int"]["output"]
  isCustom: Scalars["Boolean"]["output"]
  isPreferred?: Maybe<Scalars["Boolean"]["output"]>
  isPrimaryConnection: Scalars["Boolean"]["output"]
  masterTariffId?: Maybe<Scalars["Int"]["output"]>
  maxMonthlyKw?: Maybe<Scalars["Float"]["output"]>
  maxMonthlyKwh?: Maybe<Scalars["Float"]["output"]>
  minMonthlyKw?: Maybe<Scalars["Float"]["output"]>
  minMonthlyKwh?: Maybe<Scalars["Float"]["output"]>
  name: Scalars["String"]["output"]
  notes?: Maybe<Scalars["String"]["output"]>
  pid: Scalars["String"]["output"]
  rateDetails: Array<TariffDetails>
  requiresPv?: Maybe<Scalars["Boolean"]["output"]>
  requiresStorage?: Maybe<Scalars["Boolean"]["output"]>
  tariffType?: Maybe<Scalars["String"]["output"]>
  trashedAt?: Maybe<Scalars["DateTime"]["output"]>
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>
  utility: Utility
}

export type TariffDeltas = {
  __typename?: "TariffDeltas"
  kw?: Maybe<Delta>
  kwh: Delta
  usd: Delta
}

export type TariffDetails = {
  __typename?: "TariffDetails"
  allRates: Array<Rate>
  properties: Array<TariffProperty>
  rates: Array<Rate>
  rawJson: Scalars["JSON"]["output"]
  tariff: Tariff
  usingHybridNem3ExportRate: Scalars["Boolean"]["output"]
  version?: Maybe<TariffVersion>
}

export type TariffHistory = {
  __typename?: "TariffHistory"
  dateCreated: Scalars["DateTime"]["output"]
  dateLastUpdated: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  parent: Tariff
  versions: Array<TariffVersion>
}

export type TariffMutations = {
  __typename?: "TariffMutations"
  archiveCustomTariff?: Maybe<Scalars["Void"]["output"]>
  createCustomTariff: Tariff
  fetchTariffVersion?: Maybe<Scalars["Void"]["output"]>
  setFields?: Maybe<Tariff>
}

export type TariffMutationsArchiveCustomTariffArgs = {
  customTariffId: Scalars["Int"]["input"]
}

export type TariffMutationsCreateCustomTariffArgs = {
  cfg: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  utilityId: Scalars["Int"]["input"]
}

export type TariffMutationsFetchTariffVersionArgs = {
  effectiveOn: Scalars["DateTime"]["input"]
  masterTariffId: Scalars["Int"]["input"]
}

export type TariffMutationsSetFieldsArgs = {
  id: Scalars["Int"]["input"]
  isPreferred?: InputMaybe<Scalars["Boolean"]["input"]>
  notes?: InputMaybe<Scalars["String"]["input"]>
  requiresPv?: InputMaybe<Scalars["Boolean"]["input"]>
  requiresStorage?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type TariffProperty = {
  __typename?: "TariffProperty"
  dataType: Scalars["String"]["output"]
  formulaDetail?: Maybe<Scalars["String"]["output"]>
  keyName: Scalars["String"]["output"]
  propertyValue?: Maybe<Scalars["String"]["output"]>
  propertyValues: Array<Scalars["String"]["output"]>
}

export type TariffPropertyKey = {
  __typename?: "TariffPropertyKey"
  formulaDetail?: Maybe<Scalars["String"]["output"]>
  keyName: Scalars["String"]["output"]
}

export type TariffRate = {
  __typename?: "TariffRate"
  closedDate?: Maybe<Scalars["DateTime"]["output"]>
  dateCreated: Scalars["DateTime"]["output"]
  dateLastUpdated: Scalars["DateTime"]["output"]
  endDate?: Maybe<Scalars["DateTime"]["output"]>
  id: Scalars["Int"]["output"]
  isPrimaryConnection: Scalars["Boolean"]["output"]
  masterTariffId?: Maybe<Scalars["Int"]["output"]>
  parent: Tariff
  startDate: Scalars["DateTime"]["output"]
  tariffId?: Maybe<Scalars["Int"]["output"]>
  utility: Utility
}

export enum TariffSlot {
  Bau = "BAU",
  PostBattery = "POST_BATTERY",
  PostSolar = "POST_SOLAR",
}

export type TariffVersion = {
  __typename?: "TariffVersion"
  effectiveDate: Scalars["DateTime"]["output"]
  endDate?: Maybe<Scalars["DateTime"]["output"]>
  isDownloaded: Scalars["Boolean"]["output"]
  tariffId?: Maybe<Scalars["Int"]["output"]>
}

export type TaskHistory = {
  __typename?: "TaskHistory"
  series: Array<TaskSeries>
  taskNames: Array<Scalars["String"]["output"]>
  timestamps: Array<Scalars["DateTime"]["output"]>
}

export type TaskSeries = {
  __typename?: "TaskSeries"
  counts: Array<Scalars["Int"]["output"]>
  taskName: Scalars["String"]["output"]
}

export type TaxItem = {
  __typename?: "TaxItem"
  cost: Scalars["Float"]["output"]
  name: Scalars["String"]["output"]
  percentage: Scalars["Float"]["output"]
  subtotal: Scalars["Float"]["output"]
  taxId: Scalars["Int"]["output"]
}

export type TenantCashflows = {
  __typename?: "TenantCashflows"
  discountRate: Scalars["Float"]["output"]
  netCashflowPerYear: Array<Scalars["Float"]["output"]>
  npv: Scalars["Float"]["output"]
  totalCapex: Scalars["Float"]["output"]
  totalNet: Scalars["Float"]["output"]
  totalOpex: Scalars["Float"]["output"]
  totalUtilitySavings: Scalars["Float"]["output"]
}

export type TenantDetails = {
  __typename?: "TenantDetails"
  numUnits1Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits2Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits3Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits4Bd?: Maybe<Scalars["Int"]["output"]>
  numUnitsStudio?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
}

export type TextContent = {
  __typename?: "TextContent"
  text: Scalars["String"]["output"]
  type: Scalars["String"]["output"]
}

export type TextContentImageContentFileContent =
  | FileContent
  | ImageContent
  | TextContent

export type TextValue = {
  __typename?: "TextValue"
  text: Scalars["String"]["output"]
}

export type ThirdPartySupplier = {
  __typename?: "ThirdPartySupplier"
  dateCreated: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
}

export type TimeOfUse = {
  __typename?: "TimeOfUse"
  season?: Maybe<Season>
  touName: Scalars["String"]["output"]
  touPeriods: Array<Period>
  touType?: Maybe<Scalars["String"]["output"]>
}

export type TodoItem = {
  __typename?: "TodoItem"
  completedAt?: Maybe<Scalars["DateTime"]["output"]>
  completedBy?: Maybe<UserRef>
  content: Scalars["String"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  createdBy?: Maybe<UserRef>
  id: Scalars["Int"]["output"]
  index: Scalars["Int"]["output"]
  section: TodoSection
  site: SiteRef
  updatedAt: Scalars["DateTime"]["output"]
  updatedBy?: Maybe<UserRef>
}

export type TodoMutations = {
  __typename?: "TodoMutations"
  add?: Maybe<Scalars["Void"]["output"]>
  delete?: Maybe<Scalars["Void"]["output"]>
  setComplete?: Maybe<Scalars["Void"]["output"]>
  setContent?: Maybe<Scalars["Void"]["output"]>
  setSection?: Maybe<Scalars["Void"]["output"]>
  setSectionIndex?: Maybe<Scalars["Void"]["output"]>
  setSectionName?: Maybe<Scalars["Void"]["output"]>
}

export type TodoMutationsAddArgs = {
  content: Scalars["String"]["input"]
  sectionName: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type TodoMutationsDeleteArgs = {
  sitePid: Scalars["String"]["input"]
  todoItemId: Scalars["Int"]["input"]
}

export type TodoMutationsSetCompleteArgs = {
  complete: Scalars["Boolean"]["input"]
  sitePid: Scalars["String"]["input"]
  todoItemId: Scalars["Int"]["input"]
}

export type TodoMutationsSetContentArgs = {
  content: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  todoItemId: Scalars["Int"]["input"]
}

export type TodoMutationsSetSectionArgs = {
  index: Scalars["Int"]["input"]
  sectionName: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  todoItemId: Scalars["Int"]["input"]
}

export type TodoMutationsSetSectionIndexArgs = {
  index: Scalars["Int"]["input"]
  sectionName: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type TodoMutationsSetSectionNameArgs = {
  newName: Scalars["String"]["input"]
  sectionName: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type TodoSection = {
  __typename?: "TodoSection"
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  index: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  site: SiteRef
}

export type ToolCall = {
  __typename?: "ToolCall"
  function: Function
  id: Scalars["String"]["output"]
  type: Scalars["String"]["output"]
}

export enum TransactionType {
  Buy = "BUY",
  BuyImport = "BUY_IMPORT",
  Net = "NET",
  Sell = "SELL",
  SellExport = "SELL_EXPORT",
}

export enum UsState {
  Ak = "AK",
  Al = "AL",
  Ar = "AR",
  Az = "AZ",
  Ca = "CA",
  Co = "CO",
  Ct = "CT",
  Dc = "DC",
  De = "DE",
  Fl = "FL",
  Ga = "GA",
  Hi = "HI",
  Ia = "IA",
  Id = "ID",
  Il = "IL",
  In = "IN",
  Ks = "KS",
  Ky = "KY",
  La = "LA",
  Ma = "MA",
  Md = "MD",
  Me = "ME",
  Mi = "MI",
  Mn = "MN",
  Mo = "MO",
  Ms = "MS",
  Mt = "MT",
  Nc = "NC",
  Nd = "ND",
  Ne = "NE",
  Nh = "NH",
  Nj = "NJ",
  Nm = "NM",
  Nv = "NV",
  Ny = "NY",
  Oh = "OH",
  Ok = "OK",
  Or = "OR",
  Pa = "PA",
  Pr = "PR",
  Ri = "RI",
  Sc = "SC",
  Sd = "SD",
  Tn = "TN",
  Tx = "TX",
  Ut = "UT",
  Va = "VA",
  Vt = "VT",
  Wa = "WA",
  Wi = "WI",
  Wv = "WV",
  Wy = "WY",
}

export type UsStateMultiPred = {
  value: Array<InputMaybe<UsState>>
}

export enum Units {
  Kw = "KW",
  Kwh = "KWH",
  Tons = "TONS",
  TonsPerKwh = "TONS_PER_KWH",
  Usd = "USD",
  UsdPerKwh = "USD_PER_KWH",
}

export type UploadHelioscopePdfResponse = {
  __typename?: "UploadHelioscopePdfResponse"
  reportPdf: Attachment
  roofImage: Attachment
}

export type Usage = {
  __typename?: "Usage"
  completionTokens: Scalars["Int"]["output"]
  promptTokens: Scalars["Int"]["output"]
  totalTokens: Scalars["Int"]["output"]
}

export type UserRef = {
  __typename?: "UserRef"
  avatarUrl?: Maybe<Scalars["String"]["output"]>
  email: Scalars["String"]["output"]
  isAdmin: Scalars["Boolean"]["output"]
  meetingSchedulingUrl?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  pid: Scalars["String"]["output"]
}

export type UserRole = {
  __typename?: "UserRole"
  org?: Maybe<Org>
  portfolio?: Maybe<PortfolioRef>
  role: RbacRole
  user: UserRef
}

export type Utility = {
  __typename?: "Utility"
  dateCreated: Scalars["DateTime"]["output"]
  dateTariffsRefreshed?: Maybe<Scalars["DateTime"]["output"]>
  eiaGridEsc?: Maybe<EiaGridEsc>
  hostingCapacityMaps: Array<HostingCapacityMap>
  id: Scalars["Int"]["output"]
  isPreferred?: Maybe<Scalars["Boolean"]["output"]>
  lseId: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  notes?: Maybe<Scalars["String"]["output"]>
  numTariffs?: Maybe<Scalars["Int"]["output"]>
  ownership: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  shortName: Scalars["String"]["output"]
  tariffs: Array<Tariff>
  utilityApiName?: Maybe<Scalars["String"]["output"]>
}

export type UtilityCost = {
  __typename?: "UtilityCost"
  bau: FinmodelCost
  der: FinmodelCost
}

export type UtilityMutations = {
  __typename?: "UtilityMutations"
  setIsPreferred: Utility
  setNotes: Utility
  setUtilityApiName: Utility
}

export type UtilityMutationsSetIsPreferredArgs = {
  id: Scalars["Int"]["input"]
  isPreferred?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type UtilityMutationsSetNotesArgs = {
  id: Scalars["Int"]["input"]
  notes?: InputMaybe<Scalars["String"]["input"]>
}

export type UtilityMutationsSetUtilityApiNameArgs = {
  id: Scalars["Int"]["input"]
  utilityApiName?: InputMaybe<Scalars["String"]["input"]>
}

export type UtilityRef = {
  __typename?: "UtilityRef"
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  shortName: Scalars["String"]["output"]
}

export type ValidationError = {
  __typename?: "ValidationError"
  message: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
}

export type Viability = {
  __typename?: "Viability"
  createdAt: Scalars["DateTime"]["output"]
  disabledAt?: Maybe<Scalars["DateTime"]["output"]>
  hasStorage?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["Int"]["output"]
  isAllowed: Scalars["Boolean"]["output"]
  level: ViabilityLevel
  loadCategory?: Maybe<LoadCategory>
  notes?: Maybe<Scalars["String"]["output"]>
  org?: Maybe<Org>
  physicalSource?: Maybe<PhysicalCheckSource>
  policyDbVersion?: Maybe<Scalars["String"]["output"]>
  productType?: Maybe<FinProductType>
  reason?: Maybe<ViabilityReason>
  site?: Maybe<SiteRef>
  solarLocation?: Maybe<SolarLocation>
  type: ViabilityType
  violatedPolicyPid?: Maybe<Scalars["String"]["output"]>
}

export enum ViabilityLevel {
  Global = "GLOBAL",
  Org = "ORG",
  Site = "SITE",
}

export enum ViabilityReason {
  Bad = "BAD",
  CannotModel = "CANNOT_MODEL",
  ExistingSolar = "EXISTING_SOLAR",
  NoSpace = "NO_SPACE",
  PolicyNotAllowed = "POLICY_NOT_ALLOWED",
  PolicyNotFeasible = "POLICY_NOT_FEASIBLE",
  PolicyUnknown = "POLICY_UNKNOWN",
  SpaceUnknown = "SPACE_UNKNOWN",
}

export enum ViabilityType {
  Admin = "ADMIN",
  Capability = "CAPABILITY",
  Physical = "PHYSICAL",
  Policy = "POLICY",
}

export enum ViewType {
  Investor = "INVESTOR",
  Offtaker = "OFFTAKER",
}

export type VnemEligibilityCondition = {
  __typename?: "VnemEligibilityCondition"
  vnemEligibilityRequired: Scalars["Boolean"]["output"]
}

export enum YesNoUnsure {
  No = "NO",
  Unsure = "UNSURE",
  Yes = "YES",
}

export type YesNoUnsurePred = {
  value: Array<InputMaybe<YesNoUnsure>>
}

export type YesNoValue = {
  __typename?: "YesNoValue"
  yes: Scalars["Boolean"]["output"]
}

export type Zoned = {
  __typename?: "Zoned"
  kwh8760: Array<Scalars["Float"]["output"]>
  maxKw: Scalars["Float"]["output"]
  timeZone: Scalars["String"]["output"]
  totalKwh: Scalars["Float"]["output"]
  units: Units
  year: Scalars["Int"]["output"]
}

export type Zoned8760 = {
  __typename?: "Zoned8760"
  intervals: Array<Scalars["Float"]["output"]>
  start: Scalars["DateTime"]["output"]
  timeZone: Scalars["String"]["output"]
  year: Scalars["Int"]["output"]
}

export type CostSummary_Fragment = {
  __typename?: "CostSummary_"
  totalCost: number
  totalEnergyUsage: number
  tariff: {
    __typename?: "Tariff"
    id: number
    code: string
    utility: { __typename?: "Utility"; shortName: string }
  }
}

export type OrgRefFragment = { __typename?: "OrgRef"; pid: string; name: string }

export type CostsFragmentFragment = {
  __typename?: "ETBCosts"
  totalCost: number
  totalIncentiveSavings: number
  netCost: number
  energyConsumptionKwhYear1: number
  netEnergyConsumptionKwhYear1: number
  utilityCostPerKwh: number
  averageLoadFactor: number
  energyCostBefore: number
  energyCostAfter: number
  energyCostSavings: number
  demandCostBefore: number
  demandCostAfter: number
  demandCostSavings: number
  totalCostBefore: number
  totalCostAfter: number
  totalCostSavings: number
  pvTotalCost: number
  pvNetCost: number
  pvPowerRatingKwDc: number
  pvPowerRatingKwAc: number
  pvDegradationRate: number
  pvGenerationKwhYear1: number
  pvKwhPerKwDc: number
  pvSavingsPerKwh: number
  pvGenerationPercentExported: number
  storageTotalCost: number
  storageNetCost: number
  storageCapacityKwh: number
  storageMaxDischargePowerKw: number
  storageTwoHourPowerRatingKw: number
  storageDegradationRate: number
  storageDischargeYear1: number
  storageConsumptionKwhYear1: number
  storageSavingsPerKw: number
  storageSavingsPerKwh: number
}

export type OverrideFragment = {
  __typename?: "FinmodelInputOverride"
  id: number
  dateCreated: string
  dateTrashed?: string | null
  inputName: string
  inputValue: string
  source: FinmodelInputOverrideSource
  createdBy?: string | null
}

export type FinmodelFailureDetailFragment = {
  __typename?: "FinmodelFailure"
  id: number
  createdAt: string
  fmv: number
  name: string
  message: string
  isPvopt: boolean
  isLux: boolean
  site: {
    __typename?: "SiteRef"
    pid: string
    name?: string | null
    streetAddress: string
  }
  scenario: { __typename?: "ScenarioRef"; pid: string; name: string }
  source?:
    | { __typename: "ETBReportRef"; id: number; projectName: string }
    | { __typename: "LuxRef"; id: number }
    | { __typename: "PVoptRef"; id: number }
    | { __typename: "ReoptRef"; pid: string }
    | null
}

type FinmodelSourceFragment_EtbReportRef_Fragment = {
  __typename: "ETBReportRef"
  id: number
  projectName: string
}

type FinmodelSourceFragment_LuxRef_Fragment = { __typename: "LuxRef"; id: number }

type FinmodelSourceFragment_PVoptRef_Fragment = { __typename: "PVoptRef"; id: number }

type FinmodelSourceFragment_ReoptRef_Fragment = { __typename: "ReoptRef"; pid: string }

export type FinmodelSourceFragmentFragment =
  | FinmodelSourceFragment_EtbReportRef_Fragment
  | FinmodelSourceFragment_LuxRef_Fragment
  | FinmodelSourceFragment_PVoptRef_Fragment
  | FinmodelSourceFragment_ReoptRef_Fragment

export type FinmodelFailureRefFragment = {
  __typename?: "FinmodelFailureRef"
  id: number
}

export type SitesTableFragment = {
  __typename?: "Site"
  pid: string
  propertyName?: string | null
  fullAddress: string
  state: string
  buildingType: string
  sqft?: number | null
  roofSqft?: number | null
  occupancyType?: BuildingOccupancyType | null
  leaseType?: LeaseType | null
  metering?: Metering | null
  mortgageLender?: string | null
  roofReplacedYr?: number | null
  hiddenFromCustomers: boolean
  roofMaxPvKw?: number | null
  carportMaxPvKw?: number | null
  createdAt: string
  portfolio?: {
    __typename?: "AdminPortfolio"
    pid: string
    title: string
    org: { __typename?: "AdminOrg"; slug: string }
  } | null
  roofImage?: { __typename?: "Attachment"; id: number } | null
  primaryScenario?: {
    __typename?: "AdminScenario"
    pid: string
    solarLocation: SolarLocation
    includeStorage: boolean
  } | null
  currentStatus?: {
    __typename?: "SiteStatusChange"
    pid: string
    status: SiteStatus
  } | null
}

export type DraftSiteFragmentFragment = {
  __typename?: "DraftSite"
  pid: string
  portfolioPid?: string | null
  doeReferenceType?: BuildingType | null
  costarPropertyType?: string | null
  propertyName?: string | null
  streetAddress?: string | null
  city?: string | null
  state?: UsState | null
  zipCode?: string | null
  county?: string | null
  latitude?: number | null
  longitude?: number | null
  sqft?: number | null
  roofSqft?: number | null
  capRate?: number | null
  totalBuildings?: number | null
  numStories?: number | null
  numParkingSpaces?: number | null
  yearBuilt?: number | null
  numUnitsStudio?: number | null
  numUnits1Bd?: number | null
  numUnits2Bd?: number | null
  numUnits3Bd?: number | null
  numUnits4Bd?: number | null
  avgSqftStudio?: number | null
  avgSqft1Bd?: number | null
  avgSqft2Bd?: number | null
  avgSqft3Bd?: number | null
  avgSqft4Bd?: number | null
  numVacantUnitsStudio?: number | null
  numVacantUnits1Bd?: number | null
  numVacantUnits2Bd?: number | null
  numVacantUnits3Bd?: number | null
  numVacantUnits4Bd?: number | null
  timeZone?: string | null
  cbsaName?: string | null
  canReify: boolean
  dateCreated: string
  errors: Array<{ __typename?: "ValidationError"; name: string; message: string }>
}

export type MeteringFragment = {
  __typename?: "Site"
  metering?: Metering | null
  meteringSetDate?: string | null
  meteringSetBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
}

export type LeaseTypeFragment = { __typename?: "Site"; leaseType?: LeaseType | null }

export type BuildingOccupancyTypeFragment = {
  __typename?: "Site"
  occupancyType?: BuildingOccupancyType | null
}

export type SiteRefFragment = {
  __typename?: "SiteRef"
  pid: string
  name?: string | null
  streetAddress: string
}

export type ScenarioRefFragment = {
  __typename?: "ScenarioRef"
  pid: string
  name: string
}

export type EtbReportRefFragment = {
  __typename?: "ETBReportRef"
  id: number
  projectName: string
}

export type EtbScenarioRefFragment = {
  __typename?: "ETBScenarioRef"
  pid: string
  name: string
  isPrimary: boolean
  solarLocation: SolarLocation
  includeStorage: boolean
  loadCategory: LoadCategory
}

export type AttachmentFragmentFragment = {
  __typename?: "Attachment"
  id: number
  size: number
  name: string
  contentType: string
  downloadHref: string
  createdAt: string
  trashedAt?: string | null
  isTrashable: boolean
  isRoofImageCandidate: boolean
  isEtb?: boolean | null
  createdBy: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  }
}

export type ScenarioHelioscopeFragmentFragment = {
  __typename?: "Helioscope"
  id: number
  pid: string
  createdAt: string
  isTrashed: boolean
  roofPvKw: number
  carportPvKw: number
  pdf: {
    __typename?: "Attachment"
    id: number
    size: number
    name: string
    contentType: string
    downloadHref: string
    createdAt: string
    trashedAt?: string | null
    isTrashable: boolean
    isRoofImageCandidate: boolean
    isEtb?: boolean | null
    createdBy: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    }
  }
  roofImage: {
    __typename?: "Attachment"
    id: number
    size: number
    name: string
    contentType: string
    downloadHref: string
    createdAt: string
    trashedAt?: string | null
    isTrashable: boolean
    isRoofImageCandidate: boolean
    isEtb?: boolean | null
    createdBy: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    }
  }
}

export type ScenarioEtbFragmentFragment = {
  __typename?: "ETBReport"
  id: number
  dateCreated: string
  projectName: string
  roofPvKw?: number | null
  carportPvKw?: number | null
  groundPvKw?: number | null
  batteryKw?: number | null
  batteryKwh?: number | null
}

export type TariffDetailFragmentFragment = {
  __typename?: "TariffDetails"
  rawJson: any
  tariff: {
    __typename?: "Tariff"
    id: number
    code: string
    name: string
    customerClass: string
  }
  version?: {
    __typename?: "TariffVersion"
    tariffId?: number | null
    effectiveDate: string
    endDate?: string | null
  } | null
  properties: Array<{
    __typename?: "TariffProperty"
    keyName: string
    dataType: string
    propertyValue?: string | null
    formulaDetail?: string | null
  }>
  rates: Array<{
    __typename?: "Rate"
    tariffRateId: number
    name: string
    classes: Array<ChargeClass>
    chargeClass: string
    chargeType?: ChargeType | null
    chargePeriod: ChargePeriod
    transactionType: TransactionType
    applicabilityKey?: string | null
    quantityKey?: string | null
    isDemandCharge: boolean
    isFixedPrice: boolean
    isQuantity: boolean
    isTou: boolean
    variableLimitValue?: {
      __typename?: "TariffPropertyKey"
      keyName: string
      formulaDetail?: string | null
    } | null
    bands: Array<{
      __typename?: "RateBand"
      tariffRateBandId: number
      rateUnit: RateUnit
      price: number
      isCredit: boolean
      hasConsumptionLimit?: boolean | null
      propertyUpperLimit?: number | null
      consumptionUpperLimit?: number | null
      demandUpperLimit?: number | null
      calculationFactor?: number | null
      applicabilityValue?: string | null
    }>
    season?: {
      __typename?: "Season"
      seasonFromMonth: number
      seasonToMonth: number
      seasonFromDay: number
      seasonToDay: number
    } | null
    tou?: {
      __typename?: "TimeOfUse"
      touName: string
      season?: {
        __typename?: "Season"
        seasonFromMonth: number
        seasonToMonth: number
        seasonFromDay: number
        seasonToDay: number
      } | null
      touPeriods: Array<{
        __typename?: "Period"
        fromDayOfWeek: number
        toDayOfWeek: number
        fromHour?: number | null
        toHour?: number | null
        fromMinute?: number | null
        toMinute?: number | null
      }>
    } | null
  }>
}

export type FinRelFragment = {
  __typename?: "AdminFinRel"
  disabledAt?: string | null
  finproduct: {
    __typename?: "AdminFinProduct"
    id: number
    type: FinProductType
    name: string
    financier: { __typename?: "OrgRef"; name: string; pid: string }
  }
  recvr: { __typename?: "Org"; pid: string }
}

export type AdminOrgFragment = {
  __typename?: "AdminOrg"
  pid: string
  name: string
  logoUrl: string
}

export type UserListUserFragment = {
  __typename?: "AdminUser"
  id: number
  pid: string
  email: string
  name?: string | null
  affiliation?: string | null
  isAdmin: boolean
  isEnabled: boolean
  avatarUrl?: string | null
  meetingSchedulingUrl?: string | null
  lastSeenAt?: string | null
  portfoliosWithRole: Array<{ __typename?: "PortfolioRef"; pid: string; title: string }>
  unclaimedInvitations: Array<{
    __typename?: "AdminInvitation"
    isClaimed: boolean
    isExpired: boolean
    expiresAt: string
    portfolio?: { __typename?: "PortfolioRef"; pid: string; title: string } | null
  }>
  licenseAgreements: Array<{
    __typename?: "LicenseAgreement"
    acceptedAt: string
    forOrg?: { __typename?: "Org"; pid: string; name: string } | null
  }>
  org?: { __typename?: "Org"; pid: string; name: string; slug: string } | null
}

export type PolicyListItemFragment = {
  __typename?: "Policy"
  pid: string
  name: string
  status: PolicyStatus
  startDate?: string | null
  endDate?: string | null
  userVisible: boolean
  jurisdiction: { __typename?: "Jurisdiction"; scope: JurisdictionScope; name: string }
  application: { __typename?: "PolicyApplication"; status: PolicyApplicationStatus }
  rules: Array<{
    __typename?: "Rule"
    id: string
    description: string
    units?: RuleValueUnits | null
    value:
      | { __typename: "CurrencyValue"; usd: number }
      | { __typename: "IntegerValue"; integer: number }
      | { __typename: "NumberValue"; number: number }
      | { __typename: "TextValue"; text: string }
      | { __typename: "YesNoValue"; yes: boolean }
    application: {
      __typename?: "RuleApplication"
      status: RuleApplicationStatus
      detail?: string | null
    }
    conditions: Array<
      | {
          __typename: "BuildingSuperTypeCondition"
          buildingSuperType: BuildingSuperType
        }
      | { __typename: "VnemEligibilityCondition"; vnemEligibilityRequired: boolean }
    >
  }>
}

export type RuleFragment = {
  __typename?: "Rule"
  id: string
  description: string
  units?: RuleValueUnits | null
  value:
    | { __typename: "CurrencyValue"; usd: number }
    | { __typename: "IntegerValue"; integer: number }
    | { __typename: "NumberValue"; number: number }
    | { __typename: "TextValue"; text: string }
    | { __typename: "YesNoValue"; yes: boolean }
  application: {
    __typename?: "RuleApplication"
    status: RuleApplicationStatus
    detail?: string | null
  }
  conditions: Array<
    | { __typename: "BuildingSuperTypeCondition"; buildingSuperType: BuildingSuperType }
    | { __typename: "VnemEligibilityCondition"; vnemEligibilityRequired: boolean }
  >
}

type PolicyCondition_BuildingSuperTypeCondition_Fragment = {
  __typename: "BuildingSuperTypeCondition"
  buildingSuperType: BuildingSuperType
}

type PolicyCondition_VnemEligibilityCondition_Fragment = {
  __typename: "VnemEligibilityCondition"
  vnemEligibilityRequired: boolean
}

export type PolicyConditionFragment =
  | PolicyCondition_BuildingSuperTypeCondition_Fragment
  | PolicyCondition_VnemEligibilityCondition_Fragment

type RuleValue_CurrencyValue_Fragment = { __typename: "CurrencyValue"; usd: number }

type RuleValue_IntegerValue_Fragment = { __typename: "IntegerValue"; integer: number }

type RuleValue_NumberValue_Fragment = { __typename: "NumberValue"; number: number }

type RuleValue_TextValue_Fragment = { __typename: "TextValue"; text: string }

type RuleValue_YesNoValue_Fragment = { __typename: "YesNoValue"; yes: boolean }

export type RuleValueFragment =
  | RuleValue_CurrencyValue_Fragment
  | RuleValue_IntegerValue_Fragment
  | RuleValue_NumberValue_Fragment
  | RuleValue_TextValue_Fragment
  | RuleValue_YesNoValue_Fragment

export type BauTariffFragment = {
  __typename?: "Tariff"
  id: number
  name: string
  code: string
  masterTariffId?: number | null
}

export type BauMeterFragment = {
  __typename?: "BauMeter"
  id: number
  createdAt: string
  label: string
  loadOrigin: LoadOrigin
  loadCategory: LoadCategory
  meterSource: MeterSource
  underHumanControl: boolean
  tariffsUnderHumanControl: boolean
  archivedAt?: string | null
  archivedReason?: string | null
  createdBy?: { __typename?: "UserRef"; email: string } | null
  utility: { __typename?: "Utility"; id: number; name: string }
  tariff: {
    __typename?: "Tariff"
    id: number
    name: string
    code: string
    masterTariffId?: number | null
  }
  tariffSetBy?: { __typename?: "UserRef"; pid: string; email: string } | null
  postSolarTariff?: {
    __typename?: "Tariff"
    id: number
    name: string
    code: string
    masterTariffId?: number | null
  } | null
  postSolarTariffSetBy?: { __typename?: "UserRef"; pid: string; email: string } | null
  postBatteryTariff?: {
    __typename?: "Tariff"
    id: number
    name: string
    code: string
    masterTariffId?: number | null
  } | null
  postBatteryTariffSetBy?: { __typename?: "UserRef"; pid: string; email: string } | null
  archivedBy?: { __typename?: "UserRef"; pid: string; email: string } | null
  rollup: Array<{
    __typename?: "DailyRollup"
    season: string
    days: Array<string>
    numbers: Array<number>
  }>
}

export type BauMeterIntervalsFragment = {
  __typename?: "BauMeter"
  id: number
  tariffUsdPerKwh: number
  rollup: Array<{
    __typename?: "DailyRollup"
    season: string
    days: Array<string>
    numbers: Array<number>
  }>
  intervals: {
    __typename?: "Zoned"
    units: Units
    year: number
    timeZone: string
    maxKw: number
    totalKwh: number
    kwh8760: Array<number>
  }
}

export type PvConfigFragment = {
  __typename?: "PVConfig"
  pvType: PvType
  origin: ProductionOrigin
  sizeKw: number
  productionKwh: number
}

export type BatteryConfigFragment = {
  __typename?: "BatteryConfig"
  vendor: BatteryVendor
  sizeKwh: number
  sizeKw: number
  chargeStrategy: ChargeStrategy
  dischargeStrategy: DischargeStrategy
}

export type CostSummaryFragment = {
  __typename?: "CostSummary"
  totalCost: number
  totalEnergyUsage: number
  energyCost: number
  demandCost: number
  fixedCost: number
  nbcCost: number
  exportBenefit: number
}

export type LuxMeterFragment = {
  __typename?: "LuxMeter"
  id: number
  gridMeter?: {
    __typename?: "GridMeter"
    preSolar: {
      __typename?: "MeterCalc"
      costSummary: {
        __typename?: "CostSummary"
        totalCost: number
        totalEnergyUsage: number
        energyCost: number
        demandCost: number
        fixedCost: number
        nbcCost: number
        exportBenefit: number
      }
    }
    postSolar: {
      __typename?: "MeterCalc"
      costSummary: {
        __typename?: "CostSummary"
        totalCost: number
        totalEnergyUsage: number
        energyCost: number
        demandCost: number
        fixedCost: number
        nbcCost: number
        exportBenefit: number
      }
    }
    postBattery?: {
      __typename?: "MeterCalc"
      costSummary: {
        __typename?: "CostSummary"
        totalCost: number
        totalEnergyUsage: number
        energyCost: number
        demandCost: number
        fixedCost: number
        nbcCost: number
        exportBenefit: number
      }
    } | null
  } | null
  dayIntervals: {
    __typename?: "DayIntervals"
    pvToBldg: Array<number>
    battDischarge: Array<number>
    gridToBldg: Array<number>
  }
  bauMeter: {
    __typename?: "BauMeter"
    id: number
    label: string
    importsKwh: number
    tariff: { __typename?: "Tariff"; name: string; code: string }
  }
  postSolarMeter?: {
    __typename?: "PostSolarMeter"
    pv: Array<{
      __typename?: "PVConfig"
      pvType: PvType
      origin: ProductionOrigin
      sizeKw: number
      productionKwh: number
    }>
    tariff: {
      __typename?: "TariffRate"
      parent: { __typename?: "Tariff"; name: string; code: string }
    }
  } | null
  postBatteryMeter?: {
    __typename?: "PostBatteryMeter"
    batt?: {
      __typename?: "BatteryConfig"
      vendor: BatteryVendor
      sizeKwh: number
      sizeKw: number
      chargeStrategy: ChargeStrategy
      dischargeStrategy: DischargeStrategy
    } | null
    tariff: {
      __typename?: "TariffRate"
      parent: { __typename?: "Tariff"; name: string; code: string }
    }
  } | null
}

export type LuxFragment = {
  __typename?: "Lux"
  id: number
  createdAt: string
  fmvStr: string
  goal: PVoptGoal
  maxOffsetPct?: number | null
  pvKw: number
  roofPvKw: number
  carportPvThreeHighKw: number
  carportPvSixHighKw: number
  battKw: number
  battKwh: number
  meters: Array<{
    __typename?: "LuxMeter"
    id: number
    bauMeter: {
      __typename?: "BauMeter"
      id: number
      label: string
      importsKwh: number
      tariff: { __typename?: "Tariff"; name: string; code: string }
    }
    postSolarMeter?: {
      __typename?: "PostSolarMeter"
      pv: Array<{
        __typename?: "PVConfig"
        pvType: PvType
        origin: ProductionOrigin
        sizeKw: number
        productionKwh: number
      }>
      tariff: {
        __typename?: "TariffRate"
        parent: { __typename?: "Tariff"; name: string; code: string }
      }
    } | null
    postBatteryMeter?: {
      __typename?: "PostBatteryMeter"
      batt?: {
        __typename?: "BatteryConfig"
        vendor: BatteryVendor
        sizeKwh: number
        sizeKw: number
        chargeStrategy: ChargeStrategy
        dischargeStrategy: DischargeStrategy
      } | null
      tariff: {
        __typename?: "TariffRate"
        parent: { __typename?: "Tariff"; name: string; code: string }
      }
    } | null
    gridMeter?: {
      __typename?: "GridMeter"
      preSolar: {
        __typename?: "MeterCalc"
        costSummary: {
          __typename?: "CostSummary"
          totalCost: number
          totalEnergyUsage: number
          energyCost: number
          demandCost: number
          fixedCost: number
          nbcCost: number
          exportBenefit: number
        }
      }
      postSolar: {
        __typename?: "MeterCalc"
        costSummary: {
          __typename?: "CostSummary"
          totalCost: number
          totalEnergyUsage: number
          energyCost: number
          demandCost: number
          fixedCost: number
          nbcCost: number
          exportBenefit: number
        }
      }
      postBattery?: {
        __typename?: "MeterCalc"
        costSummary: {
          __typename?: "CostSummary"
          totalCost: number
          totalEnergyUsage: number
          energyCost: number
          demandCost: number
          fixedCost: number
          nbcCost: number
          exportBenefit: number
        }
      } | null
    } | null
    dayIntervals: {
      __typename?: "DayIntervals"
      pvToBldg: Array<number>
      battDischarge: Array<number>
      gridToBldg: Array<number>
    }
  }>
  iterations: Array<{
    __typename?: "Iteration"
    metric: number
    postTaxItcDeprIrr?: number | null
    meters: Array<{
      __typename?: "MeterIteration"
      bauMeterId: number
      totalPvKw: number
      pv: Array<{ __typename?: "IterPV"; pvType: PvType; sizeKw: number }>
    }>
  }>
  etbReport?: { __typename?: "ETBReport"; id: number } | null
  meterSet: { __typename?: "MeterSet"; id: number }
}

export type SlimLuxFragment = {
  __typename?: "Lux"
  id: number
  createdAt: string
  fmvStr: string
  goal: PVoptGoal
  maxOffsetPct?: number | null
  pvKw: number
  roofPvKw: number
  carportPvThreeHighKw: number
  carportPvSixHighKw: number
  battKw: number
  battKwh: number
  etbReport?: { __typename?: "ETBReport"; id: number } | null
  meterSet: { __typename?: "MeterSet"; id: number }
  meters: Array<{
    __typename?: "LuxMeter"
    bauMeter: { __typename?: "BauMeter"; id: number }
    postSolarMeter?: {
      __typename?: "PostSolarMeter"
      pv: Array<{
        __typename?: "PVConfig"
        pvType: PvType
        origin: ProductionOrigin
        sizeKw: number
        productionKwh: number
      }>
    } | null
    postBatteryMeter?: {
      __typename?: "PostBatteryMeter"
      batt?: {
        __typename?: "BatteryConfig"
        vendor: BatteryVendor
        sizeKwh: number
        sizeKw: number
        chargeStrategy: ChargeStrategy
        dischargeStrategy: DischargeStrategy
      } | null
    } | null
  }>
}

export type CleanBillSuggestionFragment = {
  __typename?: "Bill_"
  utilityName: string
  customerName?: string | null
  serviceIdentifier?: string | null
  billingAccountNumber?: string | null
  billingAddress?: string | null
  billingPeriodStart: string
  billingPeriodEnd: string
  meters: Array<{
    __typename?: "Meter_"
    serviceAccount?: string | null
    meterId: string
    serviceAddress?: string | null
    tariffLabel: string
    totalKwh?: number | null
    peakKw?: number | null
    totalCostUsd?: number | null
    lineItems: Array<{
      __typename?: "LineItem_"
      label: string
      unit?: string | null
      volume?: number | null
      rate?: number | null
      costUsd?: number | null
    }>
  }>
}

export type ChangelogFragment = {
  __typename?: "Changelog"
  field?: string | null
  updatedAt?: string | null
  updatedBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
}

export type CreatePortfolioMutationVariables = Exact<{
  title: Scalars["String"]["input"]
  logo: Scalars["Upload"]["input"]
  orgPid?: InputMaybe<Scalars["String"]["input"]>
  createEponymousOrg: Scalars["Boolean"]["input"]
  createOpenInvite: Scalars["Boolean"]["input"]
}>

export type CreatePortfolioMutation = {
  __typename?: "Mutation"
  portfolio: {
    __typename?: "PortfolioMutations"
    new: { __typename?: "PortfolioRow"; pid: string; title: string }
  }
}

export type CreateDraftSiteMutationVariables = Exact<{
  inputs: DraftSiteInputs
}>

export type CreateDraftSiteMutation = {
  __typename?: "Mutation"
  draftSite: {
    __typename?: "DraftSiteMutations"
    new: {
      __typename?: "DraftSite"
      pid: string
      portfolioPid?: string | null
      doeReferenceType?: BuildingType | null
      costarPropertyType?: string | null
      propertyName?: string | null
      streetAddress?: string | null
      city?: string | null
      state?: UsState | null
      zipCode?: string | null
      county?: string | null
      latitude?: number | null
      longitude?: number | null
      sqft?: number | null
      roofSqft?: number | null
      capRate?: number | null
      totalBuildings?: number | null
      numStories?: number | null
      numParkingSpaces?: number | null
      yearBuilt?: number | null
      numUnitsStudio?: number | null
      numUnits1Bd?: number | null
      numUnits2Bd?: number | null
      numUnits3Bd?: number | null
      numUnits4Bd?: number | null
      avgSqftStudio?: number | null
      avgSqft1Bd?: number | null
      avgSqft2Bd?: number | null
      avgSqft3Bd?: number | null
      avgSqft4Bd?: number | null
      numVacantUnitsStudio?: number | null
      numVacantUnits1Bd?: number | null
      numVacantUnits2Bd?: number | null
      numVacantUnits3Bd?: number | null
      numVacantUnits4Bd?: number | null
      timeZone?: string | null
      cbsaName?: string | null
      canReify: boolean
      dateCreated: string
      errors: Array<{ __typename?: "ValidationError"; name: string; message: string }>
    }
  }
}

export type SaveDraftSiteMutationVariables = Exact<{
  draftSitePid: Scalars["String"]["input"]
  inputs: DraftSiteInputs
}>

export type SaveDraftSiteMutation = {
  __typename?: "Mutation"
  draftSite: {
    __typename?: "DraftSiteMutations"
    save: {
      __typename?: "DraftSite"
      pid: string
      portfolioPid?: string | null
      doeReferenceType?: BuildingType | null
      costarPropertyType?: string | null
      propertyName?: string | null
      streetAddress?: string | null
      city?: string | null
      state?: UsState | null
      zipCode?: string | null
      county?: string | null
      latitude?: number | null
      longitude?: number | null
      sqft?: number | null
      roofSqft?: number | null
      capRate?: number | null
      totalBuildings?: number | null
      numStories?: number | null
      numParkingSpaces?: number | null
      yearBuilt?: number | null
      numUnitsStudio?: number | null
      numUnits1Bd?: number | null
      numUnits2Bd?: number | null
      numUnits3Bd?: number | null
      numUnits4Bd?: number | null
      avgSqftStudio?: number | null
      avgSqft1Bd?: number | null
      avgSqft2Bd?: number | null
      avgSqft3Bd?: number | null
      avgSqft4Bd?: number | null
      numVacantUnitsStudio?: number | null
      numVacantUnits1Bd?: number | null
      numVacantUnits2Bd?: number | null
      numVacantUnits3Bd?: number | null
      numVacantUnits4Bd?: number | null
      timeZone?: string | null
      cbsaName?: string | null
      canReify: boolean
      dateCreated: string
      errors: Array<{ __typename?: "ValidationError"; name: string; message: string }>
    }
  }
}

export type ReifyDraftSiteMutationVariables = Exact<{
  draftSitePid: Scalars["String"]["input"]
}>

export type ReifyDraftSiteMutation = {
  __typename?: "Mutation"
  draftSite: {
    __typename?: "DraftSiteMutations"
    reify: { __typename?: "NewSite"; pid: string }
  }
}

export type TrashDraftSiteMutationVariables = Exact<{
  draftSitePids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
}>

export type TrashDraftSiteMutation = {
  __typename?: "Mutation"
  draftSite: { __typename?: "DraftSiteMutations"; trash?: any | null }
}

export type SetSitePortfolioMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
}>

export type SetSitePortfolioMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setPortfolio: {
      __typename?: "Site"
      pid: string
      portfolio?: { __typename?: "AdminPortfolio"; pid: string; title: string } | null
    }
  }
}

export type SetDoeReferenceTypeMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<BuildingType>
}>

export type SetDoeReferenceTypeMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setDoeReferenceType: {
      __typename?: "Site"
      pid: string
      doeReferenceType?: BuildingType | null
    }
  }
}

export type SetCostarPropertyTypeMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value: CoStarPropertyType
}>

export type SetCostarPropertyTypeMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setCostarPropertyType: {
      __typename?: "Site"
      pid: string
      costarPropertyType?: CoStarPropertyType | null
    }
  }
}

export type SetCostarSecondaryTypeMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<CoStarSecondaryType>
}>

export type SetCostarSecondaryTypeMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setCostarSecondaryType: {
      __typename?: "Site"
      pid: string
      costarSecondaryType?: CoStarSecondaryType | null
    }
  }
}

export type SetCapRateMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Float"]["input"]>
}>

export type SetCapRateMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setCapRate: { __typename?: "Site"; pid: string; capRate?: number | null }
  }
}

export type SetZipCodeMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value: Scalars["String"]["input"]
}>

export type SetZipCodeMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setZipCode: { __typename?: "Site"; pid: string; zipCode: string }
  }
}

export type SetBuildingClassMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  buildingClass?: InputMaybe<Scalars["String"]["input"]>
}>

export type SetBuildingClassMutation = {
  __typename?: "Mutation"
  site: { __typename?: "SiteMutations"; setBuildingClass?: any | null }
}

export type SetSqftMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}>

export type SetSqftMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setSqft: { __typename?: "Site"; pid: string; sqft?: number | null }
  }
}

export type SetRoofSqftMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
  sourceType?: InputMaybe<ChangeSourceType>
  sourceId?: InputMaybe<Scalars["String"]["input"]>
}>

export type SetRoofSqftMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setRoofSqft: { __typename?: "Site"; pid: string; roofSqft?: number | null }
  }
}

export type SetUsableRoofSqftMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}>

export type SetUsableRoofSqftMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setUsableRoofSqft: {
      __typename?: "Site"
      pid: string
      usableRoofSqft?: number | null
    }
  }
}

export type SetUsableRoofPctMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}>

export type SetUsableRoofPctMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setUsableRoofPct: {
      __typename?: "Site"
      pid: string
      usableRoofPct?: number | null
    }
  }
}

export type SetGroundAvailableSqftMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}>

export type SetGroundAvailableSqftMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setGroundAvailableSqft: {
      __typename?: "Site"
      pid: string
      groundAvailableSqft?: number | null
    }
  }
}

export type SetUsableCarportFtMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}>

export type SetUsableCarportFtMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setUsableCarportFt: {
      __typename?: "Site"
      pid: string
      usableCarportFt?: number | null
    }
  }
}

export type SetSlopedRoofMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type SetSlopedRoofMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setSlopedRoof: { __typename?: "Site"; pid: string; slopedRoof?: boolean | null }
  }
}

export type SetYearBuiltMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Int"]["input"]>
}>

export type SetYearBuiltMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setYearBuilt: { __typename?: "Site"; pid: string }
  }
}

export type SetNumStoriesMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Int"]["input"]>
}>

export type SetNumStoriesMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setNumStories: { __typename?: "Site"; pid: string }
  }
}

export type SetNumParkingSpacesMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Int"]["input"]>
}>

export type SetNumParkingSpacesMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setNumParkingSpaces: { __typename?: "Site"; pid: string }
  }
}

export type SetExistingSolarMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Boolean"]["input"]>
  source: PhysicalCheckSource
}>

export type SetExistingSolarMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setExistingSolar: {
      __typename?: "Site"
      pid: string
      physicalCheck: { __typename?: "PhysicalCheck"; existingSolar?: boolean | null }
    }
  }
}

export type SetUnobstructedFlatRoofMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Boolean"]["input"]>
  source: PhysicalCheckSource
}>

export type SetUnobstructedFlatRoofMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setUnobstructedFlatRoof: {
      __typename?: "Site"
      pid: string
      physicalCheck: {
        __typename?: "PhysicalCheck"
        unobstructedFlatRoof?: boolean | null
      }
    }
  }
}

export type SetBadRoofMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Boolean"]["input"]>
  source: PhysicalCheckSource
}>

export type SetBadRoofMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setBadRoof: {
      __typename?: "Site"
      pid: string
      physicalCheck: { __typename?: "PhysicalCheck"; badRoof?: boolean | null }
    }
  }
}

export type SetCustomerIdMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  customerId?: InputMaybe<Scalars["String"]["input"]>
}>

export type SetCustomerIdMutation = {
  __typename?: "Mutation"
  site: { __typename?: "SiteMutations"; setCustomerId?: any | null }
}

export type TrashAttachmentMutationVariables = Exact<{
  pid: Scalars["String"]["input"]
  attachmentId: Scalars["Int"]["input"]
}>

export type TrashAttachmentMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    trashAttachment: {
      __typename?: "Site"
      pid: string
      roofImage?: { __typename?: "Attachment"; id: number; name: string } | null
      attachments: Array<{
        __typename?: "Attachment"
        id: number
        trashedAt?: string | null
        isTrashable: boolean
        isRoofImageCandidate: boolean
      }>
    }
  }
}

export type SetSiteHiddenFromCustomersMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  hiddenFromCustomers: Scalars["Boolean"]["input"]
}>

export type SetSiteHiddenFromCustomersMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setSiteHiddenFromCustomers: {
      __typename?: "Site"
      pid: string
      hiddenFromCustomers: boolean
    }
  }
}

export type AttachFileMutationVariables = Exact<{
  pid: Scalars["String"]["input"]
  file: Scalars["Upload"]["input"]
  tag?: InputMaybe<Scalars["String"]["input"]>
}>

export type AttachFileMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    attachFile:
      | {
          __typename: "DuplicatesAttachment"
          attachment: { __typename?: "Attachment"; name: string }
        }
      | { __typename: "Error"; message: string }
      | {
          __typename: "Site"
          pid: string
          attachments: Array<{
            __typename?: "Attachment"
            id: number
            size: number
            name: string
            contentType: string
            downloadHref: string
            createdAt: string
            trashedAt?: string | null
            isTrashable: boolean
            isRoofImageCandidate: boolean
            isEtb?: boolean | null
            createdBy: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            }
          }>
        }
  }
}

export type CreateUserMutationVariables = Exact<{
  email: Scalars["String"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  orgPid: Scalars["String"]["input"]
  portfolioPids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  sendInvite: Scalars["Boolean"]["input"]
}>

export type CreateUserMutation = {
  __typename?: "Mutation"
  user: {
    __typename?: "AdminUserMutations"
    new:
      | { __typename: "AdminUser"; id: number; email: string; name?: string | null }
      | { __typename: "Error"; message: string }
  }
}

export type ChangeUserNameMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
}>

export type ChangeUserNameMutation = {
  __typename?: "Mutation"
  user: {
    __typename?: "AdminUserMutations"
    setName: { __typename?: "AdminUser"; id: number; name?: string | null }
  }
}

export type SetUserMeetingUrlMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  url: Scalars["String"]["input"]
}>

export type SetUserMeetingUrlMutation = {
  __typename?: "Mutation"
  user: {
    __typename?: "AdminUserMutations"
    setMeetingSchedulingUrl:
      | {
          __typename: "AdminUser"
          id: number
          name?: string | null
          email: string
          meetingSchedulingUrl?: string | null
        }
      | { __typename: "Error"; message: string }
  }
}

export type InviteToPortfolioMutationVariables = Exact<{
  email: Scalars["String"]["input"]
  orgPid: Scalars["String"]["input"]
  portfolioPid: Scalars["String"]["input"]
}>

export type InviteToPortfolioMutation = {
  __typename?: "Mutation"
  user: { __typename?: "AdminUserMutations"; inviteToPortfolio?: any | null }
}

export type GiveMeAMagicLinkMutationVariables = Exact<{
  email: Scalars["String"]["input"]
}>

export type GiveMeAMagicLinkMutation = {
  __typename?: "Mutation"
  user: {
    __typename?: "AdminUserMutations"
    giveMeAMagicLink: { __typename?: "MagicLink"; href: string; expiresAt: string }
  }
}

export type AddUserToPortfolioMutationVariables = Exact<{
  userId: Scalars["Int"]["input"]
  portfolioPid: Scalars["String"]["input"]
  sendEmail: Scalars["Boolean"]["input"]
}>

export type AddUserToPortfolioMutation = {
  __typename?: "Mutation"
  user: {
    __typename?: "AdminUserMutations"
    addToPortfolio: { __typename?: "AdminUser"; id: number; pid: string }
  }
}

export type RemoveFromPortfolioMutationVariables = Exact<{
  userId: Scalars["Int"]["input"]
  portfolioPid: Scalars["String"]["input"]
}>

export type RemoveFromPortfolioMutation = {
  __typename?: "Mutation"
  user: {
    __typename?: "AdminUserMutations"
    removeFromPortfolio: { __typename?: "AdminUser"; id: number; pid: string }
  }
}

export type SetRoofMaxPvKwMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Float"]["input"]>
}>

export type SetRoofMaxPvKwMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setRoofMaxPvKw: { __typename?: "Site"; pid: string; roofMaxPvKw?: number | null }
  }
}

export type SetCarportMaxPvKwMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Float"]["input"]>
}>

export type SetCarportMaxPvKwMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setCarportMaxPvKw: {
      __typename?: "Site"
      pid: string
      carportMaxPvKw?: number | null
    }
  }
}

export type SetGroundMaxPvKwMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Float"]["input"]>
}>

export type SetGroundMaxPvKwMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setGroundMaxPvKw: {
      __typename?: "Site"
      pid: string
      groundMaxPvKw?: number | null
    }
  }
}

export type UpdateTariffMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  isPreferred?: InputMaybe<Scalars["Boolean"]["input"]>
  requiresPv?: InputMaybe<Scalars["Boolean"]["input"]>
  requiresStorage?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type UpdateTariffMutation = {
  __typename?: "Mutation"
  tariff: {
    __typename?: "TariffMutations"
    setFields?: {
      __typename?: "Tariff"
      id: number
      isPreferred?: boolean | null
      requiresPv?: boolean | null
      requiresStorage?: boolean | null
    } | null
  }
}

export type AddOverrideMutationVariables = Exact<{
  sitePid?: InputMaybe<Scalars["String"]["input"]>
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
  orgPid?: InputMaybe<Scalars["String"]["input"]>
  finProductId?: InputMaybe<Scalars["Int"]["input"]>
  inputName: Scalars["String"]["input"]
  inputValue: Scalars["String"]["input"]
}>

export type AddOverrideMutation = {
  __typename?: "Mutation"
  finmodel: {
    __typename?: "FinmodelMutations"
    addOverride:
      | { __typename: "Error"; message: string }
      | { __typename: "FinmodelInputOverride"; inputName: string; inputValue: string }
  }
}

export type DeleteOverrideMutationVariables = Exact<{
  sitePid?: InputMaybe<Scalars["String"]["input"]>
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
  orgPid?: InputMaybe<Scalars["String"]["input"]>
  finProductId?: InputMaybe<Scalars["Int"]["input"]>
  inputName: Scalars["String"]["input"]
}>

export type DeleteOverrideMutation = {
  __typename?: "Mutation"
  finmodel: {
    __typename?: "FinmodelMutations"
    deleteOverride?: {
      __typename?: "FinmodelInputOverride"
      inputName: string
      inputValue: string
    } | null
  }
}

export type SetPortfolioMinKwMutationVariables = Exact<{
  portfolioPid: Scalars["String"]["input"]
  minKw?: InputMaybe<Scalars["Float"]["input"]>
}>

export type SetPortfolioMinKwMutation = {
  __typename?: "Mutation"
  portfolio: {
    __typename?: "PortfolioMutations"
    setPortfolioMinKw: {
      __typename?: "PortfolioRow"
      pid: string
      minKw?: number | null
      minKwSetBy?: string | null
      minKwSetDate?: string | null
    }
  }
}

export type SetEtbProjectNameMutationVariables = Exact<{
  etbId: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
}>

export type SetEtbProjectNameMutation = {
  __typename?: "Mutation"
  etb: {
    __typename?: "ETBMutations"
    setProjectName: { __typename?: "ETBReport"; id: number; projectName: string }
  }
}

export type SetEtbMeterTariffBeforeMutationVariables = Exact<{
  etbMeterId: Scalars["Int"]["input"]
  tariffId?: InputMaybe<Scalars["Int"]["input"]>
}>

export type SetEtbMeterTariffBeforeMutation = {
  __typename?: "Mutation"
  etbMeter: {
    __typename?: "ETBMeterMutations"
    setTariffBefore: {
      __typename?: "ETBMeter"
      id: number
      genabilityTariffBefore?: {
        __typename?: "Tariff"
        id: number
        name: string
        code: string
      } | null
    }
  }
}

export type SetEtbMeterTariffAfterMutationVariables = Exact<{
  etbMeterId: Scalars["Int"]["input"]
  tariffId?: InputMaybe<Scalars["Int"]["input"]>
}>

export type SetEtbMeterTariffAfterMutation = {
  __typename?: "Mutation"
  etbMeter: {
    __typename?: "ETBMeterMutations"
    setTariffAfter: {
      __typename?: "ETBMeter"
      id: number
      genabilityTariffAfter?: {
        __typename?: "Tariff"
        id: number
        name: string
        code: string
      } | null
    }
  }
}

export type SetEtbMeterBauMeterMutationVariables = Exact<{
  etbMeterId: Scalars["Int"]["input"]
  bauMeterId: Scalars["Int"]["input"]
}>

export type SetEtbMeterBauMeterMutation = {
  __typename?: "Mutation"
  etbMeter: {
    __typename?: "ETBMeterMutations"
    setBauMeter: { __typename?: "ETBMeter"; id: number }
  }
}

export type SetETbMeterPvTypeMutationVariables = Exact<{
  etbMeterId: Scalars["Int"]["input"]
  pvType?: InputMaybe<PvType>
}>

export type SetETbMeterPvTypeMutation = {
  __typename?: "Mutation"
  etbMeter: {
    __typename?: "ETBMeterMutations"
    setPvType: { __typename?: "ETBMeter"; id: number }
  }
}

export type SetSiteStatusMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  status: SiteStatus
  reason?: InputMaybe<StatusReason>
  customReason?: InputMaybe<Scalars["String"]["input"]>
  unixtimeSec?: InputMaybe<Scalars["Int"]["input"]>
}>

export type SetSiteStatusMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setStatus: {
      __typename?: "Site"
      pid: string
      currentStatus?: { __typename?: "SiteStatusChange"; pid: string } | null
    }
  }
}

export type SetPrimaryScenarioMutationVariables = Exact<{
  scenarioPid: Scalars["String"]["input"]
}>

export type SetPrimaryScenarioMutation = {
  __typename?: "Mutation"
  scenario: {
    __typename?: "ScenarioMutations"
    setPrimary: {
      __typename?: "Site"
      pid: string
      scenarios: Array<{
        __typename?: "AdminScenario"
        pid: string
        isPrimary: boolean
      }>
    }
  }
}

export type SetScenarioNameMutationVariables = Exact<{
  scenarioPid: Scalars["String"]["input"]
  name: Scalars["String"]["input"]
}>

export type SetScenarioNameMutation = {
  __typename?: "Mutation"
  scenario: {
    __typename?: "ScenarioMutations"
    setName: {
      __typename?: "Site"
      pid: string
      scenarios: Array<{ __typename?: "AdminScenario"; pid: string; name: string }>
    }
  }
}

export type SetScenarioEtbMutationVariables = Exact<{
  scenarioPid: Scalars["String"]["input"]
  etbId?: InputMaybe<Scalars["Int"]["input"]>
}>

export type SetScenarioEtbMutation = {
  __typename?: "Mutation"
  scenario: {
    __typename?: "ScenarioMutations"
    setEtb: {
      __typename?: "AdminScenario"
      pid: string
      activeEtbReport?: {
        __typename?: "ETBReport"
        id: number
        projectName: string
      } | null
    }
  }
}

export type AddScenarioMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  solarLocation: SolarLocation
  includeStorage: Scalars["Boolean"]["input"]
  loadCategory: LoadCategory
  name?: InputMaybe<Scalars["String"]["input"]>
}>

export type AddScenarioMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    addScenario:
      | { __typename: "Error"; message: string }
      | { __typename: "ScenarioRef"; pid: string }
  }
}

export type ToggleScenarioVisibilityMutationVariables = Exact<{
  scenarioPid: Scalars["String"]["input"]
  hidden: Scalars["Boolean"]["input"]
}>

export type ToggleScenarioVisibilityMutation = {
  __typename?: "Mutation"
  scenario: {
    __typename?: "ScenarioMutations"
    toggleVisibility: {
      __typename?: "AdminScenario"
      pid: string
      hiddenFromCustomers: boolean
    }
  }
}

export type ToggleMulticonnectMutationVariables = Exact<{
  scenarioPid: Scalars["String"]["input"]
  allow: Scalars["Boolean"]["input"]
}>

export type ToggleMulticonnectMutation = {
  __typename?: "Mutation"
  scenario: {
    __typename?: "ScenarioMutations"
    toggleMulticonnect: {
      __typename?: "AdminScenario"
      pid: string
      allowMulticonnect: boolean
    }
  }
}

export type AddEtbMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  scenarioPid: Scalars["String"]["input"]
  loadOrigin: LoadOrigin
  upload: Scalars["Upload"]["input"]
  roofPvKw?: InputMaybe<Scalars["Float"]["input"]>
  carportPvKw?: InputMaybe<Scalars["Float"]["input"]>
  makeActive: Scalars["Boolean"]["input"]
}>

export type AddEtbMutation = {
  __typename?: "Mutation"
  site: { __typename?: "SiteMutations"; addEtb: { __typename?: "Site"; pid: string } }
}

export type AddSitesToPortfolioByOwnerNameMutationVariables = Exact<{
  portfolioPid: Scalars["String"]["input"]
  names: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
}>

export type AddSitesToPortfolioByOwnerNameMutation = {
  __typename?: "Mutation"
  portfolio: { __typename?: "PortfolioMutations"; addSitesByOwnerName: number }
}

export type SetTargetUtilityMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  utilityId: Scalars["Int"]["input"]
}>

export type SetTargetUtilityMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setTargetUtility: {
      __typename?: "Site"
      pid: string
      dateTargetUtilitySet?: string | null
      targetUtility: { __typename?: "Utility"; id: number; name: string }
      targetUtilitySetBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
    }
  }
}

export type SetThirdPartySupplierMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  thirdPartySupplierId?: InputMaybe<Scalars["Int"]["input"]>
}>

export type SetThirdPartySupplierMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setThirdPartySupplier: {
      __typename?: "Site"
      pid: string
      thirdPartySupplier?: {
        __typename?: "ThirdPartySupplier"
        id: number
        name: string
      } | null
    }
  }
}

export type SetMeteringMutationVariables = Exact<{
  sitePids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  metering?: InputMaybe<Metering>
}>

export type SetMeteringMutation = {
  __typename?: "Mutation"
  site: { __typename?: "SiteMutations"; setMetering?: any | null }
}

export type SetLeaseTypeMutationVariables = Exact<{
  sitePids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  leaseType?: InputMaybe<LeaseType>
}>

export type SetLeaseTypeMutation = {
  __typename?: "Mutation"
  site: { __typename?: "SiteMutations"; setLeaseType?: any | null }
}

export type SetOccupancyTypeMutationVariables = Exact<{
  sitePids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  occupancyType?: InputMaybe<BuildingOccupancyType>
}>

export type SetOccupancyTypeMutation = {
  __typename?: "Mutation"
  site: { __typename?: "SiteMutations"; setOccupancyType?: any | null }
}

export type RemoveUserFromPortfolioMutationVariables = Exact<{
  portfolioPid: Scalars["String"]["input"]
  userId: Scalars["Int"]["input"]
}>

export type RemoveUserFromPortfolioMutation = {
  __typename?: "Mutation"
  portfolio: {
    __typename?: "PortfolioMutations"
    removeUserFromPortfolio: {
      __typename?: "AdminPortfolio"
      pid: string
      users: Array<{ __typename?: "AdminUser"; id: number; email: string }>
    }
  }
}

export type RenamePortfolioMutationVariables = Exact<{
  portfolioPid: Scalars["String"]["input"]
  newName: Scalars["String"]["input"]
}>

export type RenamePortfolioMutation = {
  __typename?: "Mutation"
  portfolio: {
    __typename?: "PortfolioMutations"
    rename: { __typename?: "AdminPortfolio"; pid: string; title: string }
  }
}

export type UtilityApiNameMutationVariables = Exact<{
  utilityId: Scalars["Int"]["input"]
  utilityApiName?: InputMaybe<Scalars["String"]["input"]>
}>

export type UtilityApiNameMutation = {
  __typename?: "Mutation"
  utility: {
    __typename?: "UtilityMutations"
    setUtilityApiName: {
      __typename?: "Utility"
      id: number
      utilityApiName?: string | null
    }
  }
}

export type UtilityIsPreferredMutationVariables = Exact<{
  utilityId: Scalars["Int"]["input"]
  isPreferred?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type UtilityIsPreferredMutation = {
  __typename?: "Mutation"
  utility: {
    __typename?: "UtilityMutations"
    setIsPreferred: { __typename?: "Utility"; id: number; isPreferred?: boolean | null }
  }
}

export type UtilityNotesMutationVariables = Exact<{
  utilityId: Scalars["Int"]["input"]
  notes?: InputMaybe<Scalars["String"]["input"]>
}>

export type UtilityNotesMutation = {
  __typename?: "Mutation"
  utility: {
    __typename?: "UtilityMutations"
    setNotes: { __typename?: "Utility"; id: number; notes?: string | null }
  }
}

export type CreatePropertyNoteMutationVariables = Exact<{
  propertyPid: Scalars["String"]["input"]
  text: Scalars["String"]["input"]
  hiddenFromCustomers: Scalars["Boolean"]["input"]
}>

export type CreatePropertyNoteMutation = {
  __typename?: "Mutation"
  note: {
    __typename?: "AdminNoteMutations"
    new: { __typename?: "AdminNote"; pid: string }
  }
}

export type EditPropertyNoteMutationVariables = Exact<{
  notePid: Scalars["String"]["input"]
  text: Scalars["String"]["input"]
  hiddenFromCustomers: Scalars["Boolean"]["input"]
}>

export type EditPropertyNoteMutation = {
  __typename?: "Mutation"
  note: {
    __typename?: "AdminNoteMutations"
    edit: { __typename?: "AdminNote"; pid: string }
  }
}

export type TrashPropertyNoteMutationVariables = Exact<{
  notePid: Scalars["String"]["input"]
}>

export type TrashPropertyNoteMutation = {
  __typename?: "Mutation"
  note: {
    __typename?: "AdminNoteMutations"
    trash: { __typename?: "AdminNote"; pid: string }
  }
}

export type AddHelioscopeMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  pdfId: Scalars["Int"]["input"]
  roofImageId: Scalars["Int"]["input"]
  productionCsvId: Scalars["Int"]["input"]
  roofPvKw: Scalars["Float"]["input"]
  carportPvThreeHighKw: Scalars["Float"]["input"]
  carportPvSixHighKw: Scalars["Float"]["input"]
  groundPvKw: Scalars["Float"]["input"]
  roofIsMax: Scalars["Boolean"]["input"]
  carportIsMax: Scalars["Boolean"]["input"]
}>

export type AddHelioscopeMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    addHelioscope: { __typename: "Helioscope"; pid: string }
  }
}

export type UploadHelioscopePdfMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  reportPdf: Scalars["Upload"]["input"]
}>

export type UploadHelioscopePdfMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    uploadHelioscopePdf: {
      __typename?: "UploadHelioscopePdfResponse"
      reportPdf: {
        __typename?: "Attachment"
        id: number
        size: number
        name: string
        contentType: string
        downloadHref: string
        createdAt: string
        trashedAt?: string | null
        isTrashable: boolean
        isRoofImageCandidate: boolean
        isEtb?: boolean | null
        createdBy: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        }
      }
      roofImage: {
        __typename?: "Attachment"
        id: number
        size: number
        name: string
        contentType: string
        downloadHref: string
        createdAt: string
        trashedAt?: string | null
        isTrashable: boolean
        isRoofImageCandidate: boolean
        isEtb?: boolean | null
        createdBy: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        }
      }
    }
  }
}

export type SetScenarioHelioscopeMutationVariables = Exact<{
  scenarioPid: Scalars["String"]["input"]
  helioscopePid?: InputMaybe<Scalars["String"]["input"]>
  finproductId?: InputMaybe<Scalars["Int"]["input"]>
  finproductType?: InputMaybe<FinProductType>
}>

export type SetScenarioHelioscopeMutation = {
  __typename?: "Mutation"
  scenario: {
    __typename?: "ScenarioMutations"
    setHelioscope: { __typename: "AdminScenario"; pid: string }
  }
}

export type TrashHelioscopeMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  helioscopePid: Scalars["String"]["input"]
}>

export type TrashHelioscopeMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    trashHelioscope: { __typename?: "Site"; pid: string }
  }
}

export type DeleteParcelFootprintMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type DeleteParcelFootprintMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    deleteParcelFootprint: {
      __typename?: "Site"
      pid: string
      footprint: {
        __typename?: "Footprint"
        roofShape?: any | null
        parcelShape?: any | null
      }
    }
  }
}

export type DeleteBuildingFootprintMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type DeleteBuildingFootprintMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    deleteBuildingFootprint: {
      __typename?: "Site"
      pid: string
      footprint: {
        __typename?: "Footprint"
        roofShape?: any | null
        parcelShape?: any | null
        obstructionShape?: any | null
      }
    }
  }
}

export type SetOrgNameMutationVariables = Exact<{
  pid: Scalars["String"]["input"]
  value: Scalars["String"]["input"]
}>

export type SetOrgNameMutation = {
  __typename?: "Mutation"
  orgs: {
    __typename?: "AdminOrgMutations"
    setName: { __typename?: "AdminOrg"; pid: string; name: string }
  }
}

export type SetOrgSlugMutationVariables = Exact<{
  pid: Scalars["String"]["input"]
  value: Scalars["String"]["input"]
}>

export type SetOrgSlugMutation = {
  __typename?: "Mutation"
  orgs: {
    __typename?: "AdminOrgMutations"
    setSlug: { __typename?: "AdminOrg"; pid: string; slug: string }
  }
}

export type SetOrgLogoMutationVariables = Exact<{
  pid: Scalars["String"]["input"]
  upload: Scalars["Upload"]["input"]
}>

export type SetOrgLogoMutation = {
  __typename?: "Mutation"
  orgs: {
    __typename?: "AdminOrgMutations"
    setLogo: { __typename?: "AdminOrg"; pid: string; slug: string; logoUrl: string }
  }
}

export type SetOrgLogomarkMutationVariables = Exact<{
  pid: Scalars["String"]["input"]
  upload: Scalars["Upload"]["input"]
}>

export type SetOrgLogomarkMutation = {
  __typename?: "Mutation"
  orgs: {
    __typename?: "AdminOrgMutations"
    setLogomark: { __typename?: "AdminOrg"; pid: string; slug: string; logoUrl: string }
  }
}

export type SetOrgAllowlistMutationVariables = Exact<{
  orgPid: Scalars["String"]["input"]
  domains?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>
}>

export type SetOrgAllowlistMutation = {
  __typename?: "Mutation"
  orgs: {
    __typename?: "AdminOrgMutations"
    setAllowedEmailDomains: {
      __typename?: "AdminOrg"
      pid: string
      allowedEmailDomains?: Array<string> | null
    }
  }
}

export type SetUserAvatarMutationVariables = Exact<{
  userId: Scalars["Int"]["input"]
  upload: Scalars["Upload"]["input"]
}>

export type SetUserAvatarMutation = {
  __typename?: "Mutation"
  user: {
    __typename?: "AdminUserMutations"
    setAvatar: { __typename?: "AdminUser"; avatarUrl?: string | null }
  }
}

export type UpdateUserOrgMembershipMutationVariables = Exact<{
  userId: Scalars["Int"]["input"]
  orgPid: Scalars["String"]["input"]
}>

export type UpdateUserOrgMembershipMutation = {
  __typename?: "Mutation"
  user: {
    __typename?: "AdminUserMutations"
    updateOrgMembership: {
      __typename?: "AdminUser"
      id: number
      pid: string
      email: string
      name?: string | null
      affiliation?: string | null
      isAdmin: boolean
      isEnabled: boolean
      avatarUrl?: string | null
      meetingSchedulingUrl?: string | null
      lastSeenAt?: string | null
      portfoliosWithRole: Array<{
        __typename?: "PortfolioRef"
        pid: string
        title: string
      }>
      unclaimedInvitations: Array<{
        __typename?: "AdminInvitation"
        isClaimed: boolean
        isExpired: boolean
        expiresAt: string
        portfolio?: { __typename?: "PortfolioRef"; pid: string; title: string } | null
      }>
      licenseAgreements: Array<{
        __typename?: "LicenseAgreement"
        acceptedAt: string
        forOrg?: { __typename?: "Org"; pid: string; name: string } | null
      }>
      org?: { __typename?: "Org"; pid: string; name: string; slug: string } | null
    }
  }
}

export type RemoveUserOrgMembershipMutationVariables = Exact<{
  userId: Scalars["Int"]["input"]
}>

export type RemoveUserOrgMembershipMutation = {
  __typename?: "Mutation"
  user: {
    __typename?: "AdminUserMutations"
    removeOrgMembership: {
      __typename?: "AdminUser"
      id: number
      pid: string
      email: string
      name?: string | null
      affiliation?: string | null
      isAdmin: boolean
      isEnabled: boolean
      avatarUrl?: string | null
      meetingSchedulingUrl?: string | null
      lastSeenAt?: string | null
      portfoliosWithRole: Array<{
        __typename?: "PortfolioRef"
        pid: string
        title: string
      }>
      unclaimedInvitations: Array<{
        __typename?: "AdminInvitation"
        isClaimed: boolean
        isExpired: boolean
        expiresAt: string
        portfolio?: { __typename?: "PortfolioRef"; pid: string; title: string } | null
      }>
      licenseAgreements: Array<{
        __typename?: "LicenseAgreement"
        acceptedAt: string
        forOrg?: { __typename?: "Org"; pid: string; name: string } | null
      }>
      org?: { __typename?: "Org"; pid: string; name: string; slug: string } | null
    }
  }
}

export type CreateCustomTariffMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  utilityId: Scalars["Int"]["input"]
  cfg: Scalars["String"]["input"]
}>

export type CreateCustomTariffMutation = {
  __typename?: "Mutation"
  tariff: {
    __typename?: "TariffMutations"
    createCustomTariff: {
      __typename?: "Tariff"
      id: number
      name: string
      code: string
      isCustom: boolean
      utility: { __typename?: "Utility"; id: number; name: string }
    }
  }
}

export type ArchiveCustomTariffMutationVariables = Exact<{
  customTariffId: Scalars["Int"]["input"]
}>

export type ArchiveCustomTariffMutation = {
  __typename?: "Mutation"
  tariff: { __typename?: "TariffMutations"; archiveCustomTariff?: any | null }
}

export type SetPVoptGoalMutationVariables = Exact<{
  scenarioPid: Scalars["String"]["input"]
  pvoptGoal: PVoptGoal
  roofKw?: InputMaybe<Scalars["Float"]["input"]>
  carportKw?: InputMaybe<Scalars["Float"]["input"]>
  groundKw?: InputMaybe<Scalars["Float"]["input"]>
}>

export type SetPVoptGoalMutation = {
  __typename?: "Mutation"
  scenario: {
    __typename?: "ScenarioMutations"
    setPvoptGoal: { __typename?: "AdminScenario"; pid: string }
  }
}

export type SetScenarioConfigMutationVariables = Exact<{
  scenarioPid: Scalars["String"]["input"]
  finproductId?: InputMaybe<Scalars["Int"]["input"]>
  finproductType?: InputMaybe<FinProductType>
  helioscopePid?: InputMaybe<Scalars["String"]["input"]>
  goal?: InputMaybe<PVoptGoal>
  roofKw?: InputMaybe<Scalars["Float"]["input"]>
  carportKw?: InputMaybe<Scalars["Float"]["input"]>
  groundKw?: InputMaybe<Scalars["Float"]["input"]>
}>

export type SetScenarioConfigMutation = {
  __typename?: "Mutation"
  scenario: {
    __typename?: "ScenarioMutations"
    setConfig: { __typename?: "AdminScenario"; pid: string }
  }
}

export type RemoveScenarioConfigMutationVariables = Exact<{
  scenarioPid: Scalars["String"]["input"]
  scenarioConfigId: Scalars["Int"]["input"]
}>

export type RemoveScenarioConfigMutation = {
  __typename?: "Mutation"
  scenario: { __typename?: "ScenarioMutations"; removeConfig?: any | null }
}

export type CreateOpenInviteMutationVariables = Exact<{
  portfolioPid: Scalars["String"]["input"]
}>

export type CreateOpenInviteMutation = {
  __typename?: "Mutation"
  openInvite: {
    __typename?: "AdminOpenInviteMutations"
    new: { __typename?: "AdminOpenInvite"; pid: string }
  }
}

export type SetOpenInviteExpiresAtMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  expiresAt: Scalars["DateTime"]["input"]
}>

export type SetOpenInviteExpiresAtMutation = {
  __typename?: "Mutation"
  openInvite: {
    __typename?: "AdminOpenInviteMutations"
    setExpiresAt: { __typename?: "AdminOpenInvite"; id: number; expiresAt: string }
  }
}

export type SetBauMeterTariffMutationVariables = Exact<{
  input: SetBauMeterTariffInput
}>

export type SetBauMeterTariffMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setBauMeterTariff: { __typename?: "Site"; pid: string }
  }
}

export type SetBauMeterLabelMutationVariables = Exact<{
  input: SetBauMeterLabelInput
}>

export type SetBauMeterLabelMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    setBauMeterLabel: { __typename?: "Site"; pid: string }
  }
}

export type OverrideFailureMutationVariables = Exact<{
  finmodelFailureId: Scalars["Int"]["input"]
  scope: GuardrailScope
  names: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  note?: InputMaybe<Scalars["String"]["input"]>
}>

export type OverrideFailureMutation = {
  __typename?: "Mutation"
  overrideFinmodelFailure:
    | { __typename: "Error"; message: string }
    | { __typename: "GuardrailOverrideResult"; promotedFailure: boolean }
}

export type OrgFinRelToggleMutationVariables = Exact<{
  orgPid: Scalars["String"]["input"]
  finproductId: Scalars["Int"]["input"]
  enable: Scalars["Boolean"]["input"]
}>

export type OrgFinRelToggleMutation = {
  __typename?: "Mutation"
  orgs: {
    __typename?: "AdminOrgMutations"
    finrelToggle: {
      __typename?: "AdminFinRel"
      disabledAt?: string | null
      finproduct: {
        __typename?: "AdminFinProduct"
        id: number
        type: FinProductType
        name: string
        financier: { __typename?: "OrgRef"; name: string; pid: string }
      }
      recvr: { __typename?: "Org"; pid: string }
    }
  }
}

export type CreateAndApplySiteLabelMutationVariables = Exact<{
  input: CreateAndApplySiteLabelInput
}>

export type CreateAndApplySiteLabelMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    labels: {
      __typename?: "AdminSiteLabelMutations"
      createAndApplySiteLabel:
        | {
            __typename: "CreateAndApplySiteLabelOutput"
            label: { __typename?: "SiteLabel"; pid: string }
          }
        | { __typename: "Error"; message: string }
    }
  }
}

export type ApplySiteLabelMutationVariables = Exact<{
  input: ApplyLabelToSiteInput
}>

export type ApplySiteLabelMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    labels: {
      __typename?: "AdminSiteLabelMutations"
      applyLabelToSite?: { __typename: "Error"; message: string } | null
    }
  }
}

export type RenameSiteLabelMutationVariables = Exact<{
  input: RenameLabelInput
}>

export type RenameSiteLabelMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    labels: {
      __typename?: "AdminSiteLabelMutations"
      renameLabel:
        | { __typename: "Error"; message: string }
        | {
            __typename: "RenameSiteLabelOutput"
            label: { __typename?: "SiteLabel"; pid: string; name: string }
          }
    }
  }
}

export type ChangeSiteLabelColorMutationVariables = Exact<{
  input: ChangeSiteLabelColorInput
}>

export type ChangeSiteLabelColorMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    labels: {
      __typename?: "AdminSiteLabelMutations"
      changeSiteLabelColor:
        | {
            __typename: "ChangeSiteLabelColorOutput"
            label: { __typename?: "SiteLabel"; pid: string; themeColor: LabelColor }
          }
        | { __typename: "Error"; message: string }
    }
  }
}

export type RemoveSiteLabelMutationVariables = Exact<{
  input: RemoveLabelInput
}>

export type RemoveSiteLabelMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    labels: { __typename?: "AdminSiteLabelMutations"; removeLabel?: any | null }
  }
}

export type DeleteSiteLabelMutationVariables = Exact<{
  input: DeleteLabelInput
}>

export type DeleteSiteLabelMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    labels: {
      __typename?: "AdminSiteLabelMutations"
      deleteLabel?: { __typename: "Error"; message: string } | null
    }
  }
}

export type SetLatitudeMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}>

export type SetLatitudeMutation = {
  __typename?: "Mutation"
  site: { __typename?: "SiteMutations"; setLatitude?: any | null }
}

export type SetLongitudeMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}>

export type SetLongitudeMutation = {
  __typename?: "Mutation"
  site: { __typename?: "SiteMutations"; setLongitude?: any | null }
}

export type BoostMutationVariables = Exact<{
  orgPid: Scalars["String"]["input"]
}>

export type BoostMutation = {
  __typename?: "Mutation"
  queue: { __typename?: "QueueMutations"; boost?: any | null }
}

export type LinkConserviceAddressesMutationVariables = Exact<{
  orgPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  conserviceAddresses: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
}>

export type LinkConserviceAddressesMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    linkConserviceAddresses?: { __typename: "Error"; message: string } | null
  }
}

export type CreateCsFinProductMutationVariables = Exact<{
  input: CsFinProductInput
}>

export type CreateCsFinProductMutation = {
  __typename?: "Mutation"
  finproduct: {
    __typename?: "FinProductMutations"
    createCsFinproduct: { __typename?: "AdminFinProduct"; id: number }
  }
}

export type EditCsFinProductPricesMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  input: Array<CsPriceInput> | CsPriceInput
}>

export type EditCsFinProductPricesMutation = {
  __typename?: "Mutation"
  finproduct: {
    __typename?: "FinProductMutations"
    editCsFinproductPrices: { __typename?: "AdminFinProduct"; id: number }
  }
}

export type CreatePpaFinProductMutationVariables = Exact<{
  input: PpaFinProductInput
}>

export type CreatePpaFinProductMutation = {
  __typename?: "Mutation"
  finproduct: {
    __typename?: "FinProductMutations"
    createPpaFinproduct: { __typename?: "AdminFinProduct"; id: number }
  }
}

export type CreateLoanFinProductMutationVariables = Exact<{
  input: LoanFinProductInput
}>

export type CreateLoanFinProductMutation = {
  __typename?: "Mutation"
  finproduct: {
    __typename?: "FinProductMutations"
    createLoanFinproduct: { __typename?: "AdminFinProduct"; id: number }
  }
}

export type FinProductSetNameMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  value: Scalars["String"]["input"]
}>

export type FinProductSetNameMutation = {
  __typename?: "Mutation"
  finproduct: {
    __typename?: "FinProductMutations"
    setName: { __typename?: "AdminFinProduct"; id: number }
  }
}

export type FinProductSetStatusMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  value?: InputMaybe<FinProductStatus>
}>

export type FinProductSetStatusMutation = {
  __typename?: "Mutation"
  finproduct: {
    __typename?: "FinProductMutations"
    setStatus: { __typename?: "AdminFinProduct"; id: number }
  }
}

export type FinProductSetDisabledMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  value: Scalars["Boolean"]["input"]
}>

export type FinProductSetDisabledMutation = {
  __typename?: "Mutation"
  finproduct: {
    __typename?: "FinProductMutations"
    setDisabled: { __typename?: "AdminFinProduct"; id: number }
  }
}

export type FinProductSetIncludeStorageMutationVariables = Exact<{
  finproductId: Scalars["Int"]["input"]
  enable: Scalars["Boolean"]["input"]
}>

export type FinProductSetIncludeStorageMutation = {
  __typename?: "Mutation"
  finproduct: {
    __typename?: "FinProductMutations"
    setIncludeStorage: { __typename?: "AdminFinProduct"; id: number }
  }
}

export type SiteToggleFinProductMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  finproductId: Scalars["Int"]["input"]
  enabled: Scalars["Boolean"]["input"]
}>

export type SiteToggleFinProductMutation = {
  __typename?: "Mutation"
  site: { __typename?: "SiteMutations"; toggleFinproduct?: any | null }
}

export type ToggleHideFakePanelsMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  hide: Scalars["Boolean"]["input"]
}>

export type ToggleHideFakePanelsMutation = {
  __typename?: "Mutation"
  site: { __typename?: "SiteMutations"; toggleHideFakePanels?: any | null }
}

export type TodoItemAddMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  content: Scalars["String"]["input"]
  sectionName: Scalars["String"]["input"]
}>

export type TodoItemAddMutation = {
  __typename?: "Mutation"
  todos: { __typename?: "TodoMutations"; add?: any | null }
}

export type TodoItemDeleteMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  todoItemId: Scalars["Int"]["input"]
}>

export type TodoItemDeleteMutation = {
  __typename?: "Mutation"
  todos: { __typename?: "TodoMutations"; delete?: any | null }
}

export type TodoItemSetContentMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  todoItemId: Scalars["Int"]["input"]
  content: Scalars["String"]["input"]
}>

export type TodoItemSetContentMutation = {
  __typename?: "Mutation"
  todos: { __typename?: "TodoMutations"; setContent?: any | null }
}

export type TodoItemSetCompleteMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  todoItemId: Scalars["Int"]["input"]
  complete: Scalars["Boolean"]["input"]
}>

export type TodoItemSetCompleteMutation = {
  __typename?: "Mutation"
  todos: { __typename?: "TodoMutations"; setComplete?: any | null }
}

export type TodoItemSetLocationMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  todoItemId: Scalars["Int"]["input"]
  sectionName: Scalars["String"]["input"]
  index: Scalars["Int"]["input"]
}>

export type TodoItemSetLocationMutation = {
  __typename?: "Mutation"
  todos: { __typename?: "TodoMutations"; setSection?: any | null }
}

export type TodoSectionSetIndexMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  sectionName: Scalars["String"]["input"]
  index: Scalars["Int"]["input"]
}>

export type TodoSectionSetIndexMutation = {
  __typename?: "Mutation"
  todos: { __typename?: "TodoMutations"; setSectionIndex?: any | null }
}

export type TodoSectionSetNameMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  sectionName: Scalars["String"]["input"]
  newName: Scalars["String"]["input"]
}>

export type TodoSectionSetNameMutation = {
  __typename?: "Mutation"
  todos: { __typename?: "TodoMutations"; setSectionName?: any | null }
}

export type SetHelioscopeAllocationMutationVariables = Exact<{
  helioscopeId: Scalars["Int"]["input"]
  allocations: Array<Allocation> | Allocation
}>

export type SetHelioscopeAllocationMutation = {
  __typename?: "Mutation"
  site: { __typename?: "SiteMutations"; setHelioscopeAllocation?: any | null }
}

export type NewEvCalcMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  markupUsdPerKwh: Scalars["Float"]["input"]
  numChargers: Scalars["Int"]["input"]
}>

export type NewEvCalcMutation = {
  __typename?: "Mutation"
  site: {
    __typename?: "SiteMutations"
    newEvCalc: {
      __typename?: "EVCalc"
      id: number
      createdAt: string
      numChargers: number
      optimalNumChargers: number
      npv: number
      markupUsdPerKwh: number
      timeZone: string
      dayRates: Array<number>
      downloadHourlyRatesHref: string
      xlsx?: string | null
      downloadXlsxHref: string
      yr3Revenue?: number | null
      yr3Cashflow?: number | null
      yr3NumEvs?: number | null
      parkingRatio?: number | null
      projectInputs: {
        __typename?: "EVProjectInputs"
        projectStartDate: string
        installType: ChargerInstallType
        termYears: number
        chargerKw: number
        yr0NumTenantEvs?: number | null
        discountRate: number
      }
      outputs: {
        __typename?: "EVOutputs"
        irr?: number | null
        npv: number
        yr0NumTenantEvs: number
        breakevenYear: number
        numChargersDemandedSeries: Array<number>
        cashflowSeries: Array<number>
        revenueSeries: Array<number>
        incentiveUsd: number
      }
      tariffRate: {
        __typename?: "TariffRate"
        parent: { __typename?: "Tariff"; name: string; code: string }
      }
      utility: { __typename?: "UtilityRef"; shortName: string }
      seasonalDayRates: Array<{
        __typename?: "SeasonalDayRate"
        name: string
        startMonth: number
        endMonth: number
        dayRates: Array<number>
      }>
      optIters: Array<{ __typename?: "EVOptIter"; numChargers: number; npv: number }>
      year3Expenses: Array<{ __typename?: "EVLineItem"; label: string; value: number }>
      installCosts: Array<{ __typename?: "EVLineItem"; label: string; value: number }>
    }
  }
}

export type FetchTariffVersionMutationVariables = Exact<{
  masterTariffId: Scalars["Int"]["input"]
  effectiveOn: Scalars["DateTime"]["input"]
}>

export type FetchTariffVersionMutation = {
  __typename?: "Mutation"
  tariff: { __typename?: "TariffMutations"; fetchTariffVersion?: any | null }
}

export type UpdateHelioscopeAssumptionsMutationVariables = Exact<{
  helioscopePid: Scalars["String"]["input"]
  assumptions: HelioscopeAssumptionsInput
}>

export type UpdateHelioscopeAssumptionsMutation = {
  __typename?: "Mutation"
  helioscopes: {
    __typename?: "AdminHelioscopeMutations"
    updateHelioscopeAssumptions: { __typename: "Helioscope" }
  }
}

export type UpdateMultifamilyUnitsMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  input: MfUnitBreakdownInput
}>

export type UpdateMultifamilyUnitsMutation = {
  __typename?: "Mutation"
  updateMfUnits?: any | null
}

export type SetUserEnabledMutationVariables = Exact<{
  userId: Scalars["Int"]["input"]
  isEnabled: Scalars["Boolean"]["input"]
}>

export type SetUserEnabledMutation = {
  __typename?: "Mutation"
  user: {
    __typename?: "AdminUserMutations"
    setIsEnabled: {
      __typename: "AdminUser"
      isEnabled: boolean
      lastSeenAt?: string | null
    }
  }
}

export type ClearSiteDrawingsMutationVariables = Exact<{
  input: ClearDrawingsInput
}>

export type ClearSiteDrawingsMutation = {
  __typename?: "Mutation"
  site: { __typename?: "SiteMutations"; clearDrawings?: any | null }
}

export type RevertSiteToEstimatesMutationVariables = Exact<{
  input: RevertToEstimatesInput
}>

export type RevertSiteToEstimatesMutation = {
  __typename?: "Mutation"
  site: { __typename?: "SiteMutations"; revertToEstimates?: any | null }
}

export type PromoteTheFinmodelAnywayMutationVariables = Exact<{
  finmodelId: Scalars["Int"]["input"]
}>

export type PromoteTheFinmodelAnywayMutation = {
  __typename?: "Mutation"
  promoteTheFinmodelAnyway?: any | null
}

export type TurnOffBillingMetersMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type TurnOffBillingMetersMutation = {
  __typename?: "Mutation"
  site: { __typename?: "SiteMutations"; turnOffBillingMeters?: any | null }
}

export type UpdateBundleRowMilestonesMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  preBidMeetingDate?: InputMaybe<Scalars["Date"]["input"]>
  bidReviewMeetingDate?: InputMaybe<Scalars["Date"]["input"]>
  contractSignedDate?: InputMaybe<Scalars["Date"]["input"]>
  ntpDate?: InputMaybe<Scalars["Date"]["input"]>
  codDate?: InputMaybe<Scalars["Date"]["input"]>
  reason?: InputMaybe<CloseReason>
  customReason?: InputMaybe<Scalars["String"]["input"]>
}>

export type UpdateBundleRowMilestonesMutation = {
  __typename?: "Mutation"
  bundleRows: {
    __typename?: "BundleRowMutations"
    setCloseReason?: any | null
    setPreBidMeetingDate: { __typename: "BundleRow" }
    setBidReviewMeetingDate: { __typename: "BundleRow" }
    setContractSignedDate: { __typename: "BundleRow" }
    setNtpDate: { __typename: "BundleRow" }
    setCodDate: { __typename: "BundleRow" }
  }
}

export type FindBuildingFootprintsMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  strategy: FootprintStrategy
}>

export type FindBuildingFootprintsMutation = {
  __typename?: "Mutation"
  site: { __typename?: "SiteMutations"; findBuildingFootprints?: any | null }
}

export type CreateHostingCapacityMapMutationVariables = Exact<{
  utilityPid: Scalars["String"]["input"]
  hostingCapacityMap: HostingCapacityMapInputs
}>

export type CreateHostingCapacityMapMutation = {
  __typename?: "Mutation"
  hostingCapacityMaps: {
    __typename?: "HostingCapacityMapMutations"
    create?: any | null
  }
}

export type UpdateHostingCapacityMapMutationVariables = Exact<{
  mapId: Scalars["Int"]["input"]
  hostingCapacityMap: HostingCapacityMapInputs
}>

export type UpdateHostingCapacityMapMutation = {
  __typename?: "Mutation"
  hostingCapacityMaps: {
    __typename?: "HostingCapacityMapMutations"
    update?: any | null
  }
}

export type DeleteHostingCapacityMapMutationVariables = Exact<{
  mapId: Scalars["Int"]["input"]
}>

export type DeleteHostingCapacityMapMutation = {
  __typename?: "Mutation"
  hostingCapacityMaps: {
    __typename?: "HostingCapacityMapMutations"
    delete?: any | null
  }
}

export type CreateEmailDraftMutationVariables = Exact<{
  draftParams: CreateDraftInput
}>

export type CreateEmailDraftMutation = {
  __typename?: "Mutation"
  googleApi: { __typename?: "GoogleApiMutations"; createDraft?: any | null }
}

export type UpdateBundleParentRowMutationVariables = Exact<{
  bundleParentRowId: Scalars["Int"]["input"]
  inputs: MarketplaceRowInputs
}>

export type UpdateBundleParentRowMutation = {
  __typename?: "Mutation"
  marketplace: {
    __typename?: "MarketplaceMutations"
    updateBundleParentRow:
      | { __typename: "BundleParentRow"; id: number }
      | { __typename: "Error"; message: string }
  }
}

export type GetVersionQueryVariables = Exact<{ [key: string]: never }>

export type GetVersionQuery = {
  __typename?: "Query"
  schemaVersion: { __typename?: "SchemaVersion"; version: string }
}

export type CurrentAdminUserQueryVariables = Exact<{ [key: string]: never }>

export type CurrentAdminUserQuery = {
  __typename?: "Query"
  currentUser: {
    __typename?: "AuthUser"
    pid?: string | null
    isAuthenticated: boolean
    isAdmin: boolean
  }
}

export type AdminPortfolioListQueryVariables = Exact<{ [key: string]: never }>

export type AdminPortfolioListQuery = {
  __typename?: "Query"
  portfolios: Array<{
    __typename?: "PortfolioRow"
    pid: string
    title: string
    numSites: number
    org: { __typename?: "AdminOrg"; pid: string; name: string }
  }>
}

export type AdminOrgBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars["String"]["input"]>
  pid?: InputMaybe<Scalars["String"]["input"]>
}>

export type AdminOrgBySlugQuery = {
  __typename?: "Query"
  orgBySlug?: { __typename?: "AdminOrg"; pid: string; slug: string } | null
}

export type OrgsAndPortfoliosQueryVariables = Exact<{ [key: string]: never }>

export type OrgsAndPortfoliosQuery = {
  __typename?: "Query"
  orgs: Array<{ __typename?: "AdminOrg"; pid: string; name: string }>
  portfolios: Array<{
    __typename?: "PortfolioRow"
    pid: string
    title: string
    numSites: number
    org: { __typename?: "AdminOrg"; pid: string }
  }>
}

export type GetEnergyProductionQueryVariables = Exact<{ [key: string]: never }>

export type GetEnergyProductionQuery = {
  __typename?: "Query"
  energy: {
    __typename?: "EnergyProduction"
    currentTime: string
    kwhAllTime: number
    kwhToday: number
    projectedNextInterval: number
    sites: Array<{
      __typename?: "SolarSite"
      name: string
      daysActive: number
      kwhLifetime: number
    }>
    kwhPerDay: Array<{ __typename?: "SolarPerDay"; day: string; kwh: number }>
  }
}

export type MultiPortfolioSitesQueryVariables = Exact<{
  portfolioPids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  statuses: Array<SiteStatus> | SiteStatus
}>

export type MultiPortfolioSitesQuery = {
  __typename?: "Query"
  sitesInPortfolios: Array<{
    __typename?: "Site"
    pid: string
    propertyName?: string | null
    fullAddress: string
    state: string
    buildingType: string
    sqft?: number | null
    roofSqft?: number | null
    occupancyType?: BuildingOccupancyType | null
    leaseType?: LeaseType | null
    metering?: Metering | null
    mortgageLender?: string | null
    roofReplacedYr?: number | null
    hiddenFromCustomers: boolean
    roofMaxPvKw?: number | null
    carportMaxPvKw?: number | null
    createdAt: string
    portfolio?: {
      __typename?: "AdminPortfolio"
      pid: string
      title: string
      org: { __typename?: "AdminOrg"; slug: string }
    } | null
    roofImage?: { __typename?: "Attachment"; id: number } | null
    primaryScenario?: {
      __typename?: "AdminScenario"
      pid: string
      solarLocation: SolarLocation
      includeStorage: boolean
    } | null
    currentStatus?: {
      __typename?: "SiteStatusChange"
      pid: string
      status: SiteStatus
    } | null
  }>
}

export type PortfolioSitesQueryVariables = Exact<{
  pid: Scalars["String"]["input"]
  sitePids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
}>

export type PortfolioSitesQuery = {
  __typename?: "Query"
  portfolio?: {
    __typename?: "AdminPortfolio"
    pid: string
    sites: Array<{
      __typename?: "Site"
      pid: string
      propertyName?: string | null
      fullAddress: string
      state: string
      buildingType: string
      sqft?: number | null
      roofSqft?: number | null
      occupancyType?: BuildingOccupancyType | null
      leaseType?: LeaseType | null
      metering?: Metering | null
      mortgageLender?: string | null
      roofReplacedYr?: number | null
      hiddenFromCustomers: boolean
      roofMaxPvKw?: number | null
      carportMaxPvKw?: number | null
      createdAt: string
      portfolio?: {
        __typename?: "AdminPortfolio"
        pid: string
        title: string
        org: { __typename?: "AdminOrg"; slug: string }
      } | null
      roofImage?: { __typename?: "Attachment"; id: number } | null
      primaryScenario?: {
        __typename?: "AdminScenario"
        pid: string
        solarLocation: SolarLocation
        includeStorage: boolean
      } | null
      currentStatus?: {
        __typename?: "SiteStatusChange"
        pid: string
        status: SiteStatus
      } | null
    } | null>
  } | null
}

export type SitesQueryVariables = Exact<{
  sitePids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
}>

export type SitesQuery = {
  __typename?: "Query"
  sites: Array<{
    __typename?: "Site"
    pid: string
    propertyName?: string | null
    fullAddress: string
    state: string
    buildingType: string
    sqft?: number | null
    roofSqft?: number | null
    occupancyType?: BuildingOccupancyType | null
    leaseType?: LeaseType | null
    metering?: Metering | null
    mortgageLender?: string | null
    roofReplacedYr?: number | null
    hiddenFromCustomers: boolean
    roofMaxPvKw?: number | null
    carportMaxPvKw?: number | null
    createdAt: string
    portfolio?: {
      __typename?: "AdminPortfolio"
      pid: string
      title: string
      org: { __typename?: "AdminOrg"; slug: string }
    } | null
    roofImage?: { __typename?: "Attachment"; id: number } | null
    primaryScenario?: {
      __typename?: "AdminScenario"
      pid: string
      solarLocation: SolarLocation
      includeStorage: boolean
    } | null
    currentStatus?: {
      __typename?: "SiteStatusChange"
      pid: string
      status: SiteStatus
    } | null
  } | null>
}

export type GetPortfolioSiteRefsQueryVariables = Exact<{
  pid: Scalars["String"]["input"]
}>

export type GetPortfolioSiteRefsQuery = {
  __typename?: "Query"
  portfolio?: {
    __typename?: "AdminPortfolio"
    pid: string
    siteRefs: Array<{
      __typename?: "SiteRef"
      pid: string
      name?: string | null
      streetAddress: string
    }>
  } | null
}

export type SiteBuildingDataQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type SiteBuildingDataQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    customerId?: string | null
    propertyName?: string | null
    capRate?: number | null
    buildingClass?: string | null
    streetAddress: string
    city: string
    state: string
    zipCode: string
    county: string
    latitude: number
    longitude: number
    sqft?: number | null
    yearBuilt?: number | null
    numStories?: number | null
    numParkingSpaces?: number | null
    numUnitsTotal?: number | null
    numUnitsStudio?: number | null
    numUnits1Bd?: number | null
    numUnits2Bd?: number | null
    numUnits3Bd?: number | null
    numUnits4Bd?: number | null
    occupancyType?: BuildingOccupancyType | null
    leaseType?: LeaseType | null
    metering?: Metering | null
    meteringSetDate?: string | null
    doeReferenceType?: BuildingType | null
    costarPropertyType?: CoStarPropertyType | null
    costarSecondaryType?: CoStarSecondaryType | null
    mappedDoeReferenceType: string
    mortgageLender?: string | null
    roofReplacedYr?: number | null
    roofCondition?: string | null
    cbsaId?: string | null
    cbsaName?: string | null
    timeZone: string
    roofSqft?: number | null
    roofMaxPvKw?: number | null
    carportMaxPvKw?: number | null
    groundMaxPvKw?: number | null
    computedRoofMaxPvKw: number
    computedCarportMaxPvKw: number
    computedGroundMaxPvKw?: number | null
    meteringSetBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    buildingData?: {
      __typename?: "BuildingData"
      id: number
      affordableType?: string | null
      source: string
      sourceId?: string | null
      streetAddress: string
      city: string
      state: string
      zipCode: string
      county: string
      latitude: number
      longitude: number
      sqft?: number | null
      totalBuildings?: number | null
      numStories?: number | null
      numParkingSpaces?: number | null
      costarPropertyType: string
      costarSecondaryType?: string | null
      buildingType?: BuildingType | null
      yearBuilt?: number | null
      numUnitsTotal?: number | null
      numUnitsStudio?: number | null
      numUnits1Bd?: number | null
      numUnits2Bd?: number | null
      numUnits3Bd?: number | null
      numUnits4Bd?: number | null
      yearRenovated?: number | null
      parentCompany?: string | null
      buildingClass?: string | null
      buildingOpex?: string | null
      energyStar?: string | null
      leedCertified?: string | null
      lastSalePrice?: number | null
      electricPowerRating?: string | null
      zoning?: string | null
      propertyName?: string | null
      capRate?: number | null
      numVacantUnitsStudio?: number | null
      numVacantUnits1Bd?: number | null
      numVacantUnits2Bd?: number | null
      numVacantUnits3Bd?: number | null
      numVacantUnits4Bd?: number | null
      avgSqftStudio?: number | null
      avgSqft1Bd?: number | null
      avgSqft2Bd?: number | null
      avgSqft3Bd?: number | null
      avgSqft4Bd?: number | null
      numElevators?: number | null
      taxIdPrintFormat?: string | null
      parcelNumberMin?: string | null
      parcelNumberMax?: string | null
      rentType?: string | null
      reportedOwnerName?: string | null
      reportedContactName?: string | null
      reportedOwnerAddress?: string | null
      reportedOwnerCity?: string | null
      reportedOwnerState?: string | null
      reportedOwnerZipCode?: string | null
      reportedOwnerPhone?: string | null
      ownerName?: string | null
      ownerFirstName?: string | null
      ownerLastName?: string | null
      contactAddress?: string | null
      contactCity?: string | null
      contactState?: string | null
      contactZipCode?: string | null
      contactPhone?: string | null
    } | null
  } | null
}

export type SitePossibleTariffsQueryVariables = Exact<{
  pid: Scalars["String"]["input"]
  loadCategory?: InputMaybe<LoadCategory>
  preferred?: Scalars["Boolean"]["input"]
  includeUnpreferred?: Scalars["Boolean"]["input"]
  includeCustom?: Scalars["Boolean"]["input"]
}>

export type SitePossibleTariffsQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    possibleTariffs: Array<{
      __typename?: "Tariff"
      id: number
      name: string
      code: string
      tariffType?: string | null
      customerClass: string
      customerCount?: number | null
      customerLikelihood: number
      masterTariffId?: number | null
      isPreferred?: boolean | null
      hasNetMetering: boolean
      requiresPv?: boolean | null
      requiresStorage?: boolean | null
      minMonthlyKw?: number | null
      maxMonthlyKw?: number | null
      minMonthlyKwh?: number | null
      maxMonthlyKwh?: number | null
    }>
  } | null
}

export type GetSiteAdminQueryVariables = Exact<{
  pid: Scalars["String"]["input"]
}>

export type GetSiteAdminQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    id: number
    pid: string
    fullAddress: string
    hiddenFromCustomers: boolean
    hideFakePanels: boolean
    buildingFootprintNeedsReview: boolean
    roofSqft?: number | null
    roofMaxPvKw?: number | null
    computedRoofMaxPvKw: number
    groundMaxPvKw?: number | null
    carportMaxPvKw?: number | null
    parcelFootprintSqft?: number | null
    buildingFootprintSqft?: number | null
    buildingFootprintCount?: number | null
    roofObstructionsSqft?: number | null
    roofUsableSqft?: number | null
    portfolio?: {
      __typename?: "AdminPortfolio"
      pid: string
      title: string
      org: { __typename?: "AdminOrg"; pid: string; slug: string }
    } | null
    buildingData?: { __typename?: "BuildingData"; id: number } | null
    primaryScenario?: { __typename?: "AdminScenario"; pid: string; name: string } | null
    currentStatus?: {
      __typename?: "SiteStatusChange"
      pid: string
      displayText: string
      dateCreated: string
      createdBy: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      }
    } | null
    footprint: {
      __typename?: "Footprint"
      parcelShape?: any | null
      parcelShapeGeojson?: any | null
      parcelShapeUpdatedAt?: string | null
      latitude: number
      longitude: number
      bounds?: any | null
      obstructionShape?: any | null
      roofShape?: any | null
      roofShapeGeojson?: any | null
      roofShapeUpdatedAt?: string | null
      roofSetbackShape?: any | null
      roofSetbackShapeGeojson?: any | null
      roofSetbackShapeUpdatedAt?: string | null
      carportShape?: any | null
      carportShapeGeojson?: any | null
      carportShapeUpdatedAt?: string | null
      groundmountShape?: any | null
      groundmountShapeGeojson?: any | null
      groundmountShapeUpdatedAt?: string | null
      keepoutsShape?: any | null
      keepoutsShapeGeojson?: any | null
      keepoutsShapeUpdatedAt?: string | null
      parcelShapeUpdatedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      roofShapeUpdatedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      roofSetbackShapeUpdatedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      carportShapeUpdatedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      groundmountShapeUpdatedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      keepoutsShapeUpdatedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
    }
    physicalCheck: {
      __typename?: "PhysicalCheck"
      existingSolar?: boolean | null
      badRoof?: boolean | null
    }
    currentPolicyChecks: Array<{
      __typename?: "PolicyCheck"
      productType?: FinProductType | null
      isGood: boolean
      disqualReason?: PolicyReason | null
      violatedPolicy?: { __typename?: "Policy"; pid: string; name: string } | null
    }>
    roofImage?: { __typename?: "Attachment"; id: number; name: string } | null
    attachments: Array<{
      __typename?: "Attachment"
      id: number
      size: number
      name: string
      contentType: string
      downloadHref: string
      createdAt: string
      trashedAt?: string | null
      isTrashable: boolean
      isRoofImageCandidate: boolean
      isEtb?: boolean | null
      createdBy: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      }
    }>
  } | null
}

export type UserListQueryVariables = Exact<{ [key: string]: never }>

export type UserListQuery = {
  __typename?: "Query"
  users: Array<{
    __typename?: "AdminUser"
    id: number
    pid: string
    email: string
    name?: string | null
    affiliation?: string | null
    isAdmin: boolean
    isEnabled: boolean
    avatarUrl?: string | null
    meetingSchedulingUrl?: string | null
    lastSeenAt?: string | null
    portfoliosWithRole: Array<{
      __typename?: "PortfolioRef"
      pid: string
      title: string
    }>
    unclaimedInvitations: Array<{
      __typename?: "AdminInvitation"
      isClaimed: boolean
      isExpired: boolean
      expiresAt: string
      portfolio?: { __typename?: "PortfolioRef"; pid: string; title: string } | null
    }>
    licenseAgreements: Array<{
      __typename?: "LicenseAgreement"
      acceptedAt: string
      forOrg?: { __typename?: "Org"; pid: string; name: string } | null
    }>
    org?: { __typename?: "Org"; pid: string; name: string; slug: string } | null
  }>
}

export type DraftSitePageQueryVariables = Exact<{ [key: string]: never }>

export type DraftSitePageQuery = {
  __typename?: "Query"
  costarPropertyTypes: Array<string>
  portfolios: Array<{
    __typename?: "PortfolioRow"
    pid: string
    title: string
    numSites: number
  }>
  myDraftSites: Array<{
    __typename?: "DraftSite"
    pid: string
    portfolioPid?: string | null
    doeReferenceType?: BuildingType | null
    costarPropertyType?: string | null
    propertyName?: string | null
    streetAddress?: string | null
    city?: string | null
    state?: UsState | null
    zipCode?: string | null
    county?: string | null
    latitude?: number | null
    longitude?: number | null
    sqft?: number | null
    roofSqft?: number | null
    capRate?: number | null
    totalBuildings?: number | null
    numStories?: number | null
    numParkingSpaces?: number | null
    yearBuilt?: number | null
    numUnitsStudio?: number | null
    numUnits1Bd?: number | null
    numUnits2Bd?: number | null
    numUnits3Bd?: number | null
    numUnits4Bd?: number | null
    avgSqftStudio?: number | null
    avgSqft1Bd?: number | null
    avgSqft2Bd?: number | null
    avgSqft3Bd?: number | null
    avgSqft4Bd?: number | null
    numVacantUnitsStudio?: number | null
    numVacantUnits1Bd?: number | null
    numVacantUnits2Bd?: number | null
    numVacantUnits3Bd?: number | null
    numVacantUnits4Bd?: number | null
    timeZone?: string | null
    cbsaName?: string | null
    canReify: boolean
    dateCreated: string
    errors: Array<{ __typename?: "ValidationError"; name: string; message: string }>
  }>
}

export type PortfolioDetailQueryVariables = Exact<{
  pid: Scalars["String"]["input"]
}>

export type PortfolioDetailQuery = {
  __typename?: "Query"
  portfolio?: {
    __typename?: "AdminPortfolio"
    pid: string
    title: string
    logoUrl?: string | null
    minKw?: number | null
    minKwSetBy?: string | null
    minKwSetDate?: string | null
    view: { __typename?: "AdminPortfolioView"; sitePids: Array<string> }
    org: { __typename?: "AdminOrg"; pid: string; name: string; slug: string }
  } | null
}

export type UtilityFragmentFragment = {
  __typename?: "Utility"
  id: number
  pid: string
  name: string
  shortName: string
  numTariffs?: number | null
  dateTariffsRefreshed?: string | null
  utilityApiName?: string | null
  isPreferred?: boolean | null
  notes?: string | null
}

export type UtilityListQueryVariables = Exact<{
  zipCode?: InputMaybe<Scalars["String"]["input"]>
}>

export type UtilityListQuery = {
  __typename?: "Query"
  tariffs: {
    __typename?: "AdminTariffQuery"
    utilities: Array<{
      __typename?: "Utility"
      id: number
      pid: string
      name: string
      shortName: string
      numTariffs?: number | null
      dateTariffsRefreshed?: string | null
      utilityApiName?: string | null
      isPreferred?: boolean | null
      notes?: string | null
    }>
  }
}

export type UtilityDetailQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type UtilityDetailQuery = {
  __typename?: "Query"
  tariffs: {
    __typename?: "AdminTariffQuery"
    utility?: {
      __typename?: "Utility"
      id: number
      pid: string
      name: string
      shortName: string
      numTariffs?: number | null
      dateTariffsRefreshed?: string | null
      utilityApiName?: string | null
      isPreferred?: boolean | null
      notes?: string | null
    } | null
  }
}

export type TariffListQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type TariffListQuery = {
  __typename?: "Query"
  tariffs: {
    __typename?: "AdminTariffQuery"
    utility?: {
      __typename?: "Utility"
      id: number
      shortName: string
      name: string
      tariffs: Array<{
        __typename?: "Tariff"
        id: number
        masterTariffId?: number | null
        code: string
        name: string
        tariffType?: string | null
        customerClass: string
        isPreferred?: boolean | null
        requiresPv?: boolean | null
        requiresStorage?: boolean | null
        customerLikelihood: number
        hasNetMetering: boolean
        hasTouRates: boolean
        minMonthlyKwh?: number | null
        maxMonthlyKwh?: number | null
        minMonthlyKw?: number | null
        maxMonthlyKw?: number | null
      }>
    } | null
  }
}

export type CustomTariffListQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type CustomTariffListQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    displayName?: string | null
    targetUtility: { __typename?: "Utility"; id: number; name: string }
    customTariffs: Array<{
      __typename?: "CustomTariff"
      id: number
      dateCreated: string
      name: string
      code: string
      customerClass: string
      archivedAt?: string | null
      parent?: { __typename?: "Tariff"; id: number } | null
      utility: { __typename?: "Utility"; id: number; name: string }
      createdBy: { __typename?: "UserRef"; pid: string; email: string }
    }>
  } | null
}

export type TariffDetailQueryVariables = Exact<{
  tariffId: Scalars["Int"]["input"]
}>

export type TariffDetailQuery = {
  __typename?: "Query"
  tariffs: {
    __typename?: "AdminTariffQuery"
    tariff?: {
      __typename?: "Tariff"
      id: number
      masterTariffId?: number | null
      code: string
      name: string
      tariffType?: string | null
      customerClass: string
      customerCount?: number | null
      customerLikelihood: number
      minMonthlyKwh?: number | null
      maxMonthlyKwh?: number | null
      minMonthlyKw?: number | null
      maxMonthlyKw?: number | null
      hasTouRates: boolean
      hasNetMetering: boolean
      isPreferred?: boolean | null
      notes?: string | null
      requiresPv?: boolean | null
      requiresStorage?: boolean | null
      utility: { __typename?: "Utility"; id: number; name: string }
      rateDetails: Array<{
        __typename?: "TariffDetails"
        rawJson: any
        tariff: {
          __typename?: "Tariff"
          id: number
          code: string
          name: string
          customerClass: string
        }
        version?: {
          __typename?: "TariffVersion"
          tariffId?: number | null
          effectiveDate: string
          endDate?: string | null
        } | null
        properties: Array<{
          __typename?: "TariffProperty"
          keyName: string
          dataType: string
          propertyValue?: string | null
          formulaDetail?: string | null
        }>
        rates: Array<{
          __typename?: "Rate"
          tariffRateId: number
          name: string
          classes: Array<ChargeClass>
          chargeClass: string
          chargeType?: ChargeType | null
          chargePeriod: ChargePeriod
          transactionType: TransactionType
          applicabilityKey?: string | null
          quantityKey?: string | null
          isDemandCharge: boolean
          isFixedPrice: boolean
          isQuantity: boolean
          isTou: boolean
          variableLimitValue?: {
            __typename?: "TariffPropertyKey"
            keyName: string
            formulaDetail?: string | null
          } | null
          bands: Array<{
            __typename?: "RateBand"
            tariffRateBandId: number
            rateUnit: RateUnit
            price: number
            isCredit: boolean
            hasConsumptionLimit?: boolean | null
            propertyUpperLimit?: number | null
            consumptionUpperLimit?: number | null
            demandUpperLimit?: number | null
            calculationFactor?: number | null
            applicabilityValue?: string | null
          }>
          season?: {
            __typename?: "Season"
            seasonFromMonth: number
            seasonToMonth: number
            seasonFromDay: number
            seasonToDay: number
          } | null
          tou?: {
            __typename?: "TimeOfUse"
            touName: string
            season?: {
              __typename?: "Season"
              seasonFromMonth: number
              seasonToMonth: number
              seasonFromDay: number
              seasonToDay: number
            } | null
            touPeriods: Array<{
              __typename?: "Period"
              fromDayOfWeek: number
              toDayOfWeek: number
              fromHour?: number | null
              toHour?: number | null
              fromMinute?: number | null
              toMinute?: number | null
            }>
          } | null
        }>
      }>
      history?: {
        __typename?: "TariffHistory"
        dateLastUpdated: string
        versions: Array<{
          __typename?: "TariffVersion"
          isDownloaded: boolean
          tariffId?: number | null
          effectiveDate: string
          endDate?: string | null
        }>
      } | null
    } | null
  }
}

export type EtbMissingDataFragment = {
  __typename?: "ETBReport"
  id: number
  meters: Array<{
    __typename?: "ETBMeter"
    id: number
    name: string
    state: string
    zipCode: string
    utilityName: string
    tariffShortDescriptionBefore: string
    tariffShortDescriptionAfter: string
    utility?: {
      __typename?: "Utility"
      id: number
      name: string
      shortName: string
    } | null
  }>
  site: { __typename?: "SiteRef"; pid: string }
}

export type SiteHeaderQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type SiteHeaderQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    id: number
    pid: string
    customerId?: string | null
    propertyName?: string | null
    streetAddress: string
    city: string
    state: string
    zipCode: string
    status?: SiteStatus | null
    hiddenFromCustomers: boolean
    statusCheckPassed: boolean
    portfolio?: {
      __typename?: "AdminPortfolio"
      pid: string
      title: string
      org: { __typename?: "AdminOrg"; pid: string; name: string; slug: string }
    } | null
    policyViolations: Array<{
      __typename?: "PolicyViolation"
      policy: { __typename?: "Policy"; pid: string }
    }>
  } | null
}

export type GetEtbDetailQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  etbId: Scalars["Int"]["input"]
}>

export type GetEtbDetailQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    activeMeters?: {
      __typename?: "MeterSet"
      id: number
      meters: Array<{
        __typename?: "BauMeter"
        id: number
        createdAt: string
        label: string
        loadOrigin: LoadOrigin
        loadCategory: LoadCategory
        meterSource: MeterSource
        underHumanControl: boolean
        tariffsUnderHumanControl: boolean
        archivedAt?: string | null
        archivedReason?: string | null
        createdBy?: { __typename?: "UserRef"; email: string } | null
        utility: { __typename?: "Utility"; id: number; name: string }
        tariff: {
          __typename?: "Tariff"
          id: number
          name: string
          code: string
          masterTariffId?: number | null
        }
        tariffSetBy?: { __typename?: "UserRef"; pid: string; email: string } | null
        postSolarTariff?: {
          __typename?: "Tariff"
          id: number
          name: string
          code: string
          masterTariffId?: number | null
        } | null
        postSolarTariffSetBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
        } | null
        postBatteryTariff?: {
          __typename?: "Tariff"
          id: number
          name: string
          code: string
          masterTariffId?: number | null
        } | null
        postBatteryTariffSetBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
        } | null
        archivedBy?: { __typename?: "UserRef"; pid: string; email: string } | null
        rollup: Array<{
          __typename?: "DailyRollup"
          season: string
          days: Array<string>
          numbers: Array<number>
        }>
      }>
    } | null
    etbReport?: {
      __typename?: "ETBReport"
      id: number
      dateCreated: string
      projectName: string
      proposalDate: string
      taxType: string
      ownerSector: string
      federalIncomeTaxRate: number
      stateIncomeTaxRate: number
      discountRate: number
      electricityEscalationRate: number
      roofPvKw?: number | null
      carportPvKw?: number | null
      scenario?: {
        __typename?: "ETBScenarioRef"
        pid: string
        name: string
        isPrimary: boolean
        solarLocation: SolarLocation
        includeStorage: boolean
        loadCategory: LoadCategory
      } | null
      combinedCosts?: {
        __typename?: "ETBCosts"
        totalCost: number
        totalIncentiveSavings: number
        netCost: number
        energyConsumptionKwhYear1: number
        netEnergyConsumptionKwhYear1: number
        utilityCostPerKwh: number
        averageLoadFactor: number
        energyCostBefore: number
        energyCostAfter: number
        energyCostSavings: number
        demandCostBefore: number
        demandCostAfter: number
        demandCostSavings: number
        totalCostBefore: number
        totalCostAfter: number
        totalCostSavings: number
        pvTotalCost: number
        pvNetCost: number
        pvPowerRatingKwDc: number
        pvPowerRatingKwAc: number
        pvDegradationRate: number
        pvGenerationKwhYear1: number
        pvKwhPerKwDc: number
        pvSavingsPerKwh: number
        pvGenerationPercentExported: number
        storageTotalCost: number
        storageNetCost: number
        storageCapacityKwh: number
        storageMaxDischargePowerKw: number
        storageTwoHourPowerRatingKw: number
        storageDegradationRate: number
        storageDischargeYear1: number
        storageConsumptionKwhYear1: number
        storageSavingsPerKw: number
        storageSavingsPerKwh: number
      } | null
      meters: Array<{
        __typename?: "ETBMeter"
        id: number
        name: string
        streetAddress: string
        city: string
        state: string
        zipCode: string
        utilityName: string
        tariffFullDescriptionBefore: string
        tariffFullDescriptionAfter: string
        pvType?: PvType | null
        genabilityUtility?: {
          __typename?: "Utility"
          id: number
          name: string
          shortName: string
        } | null
        genabilityTariffBefore?: {
          __typename?: "Tariff"
          id: number
          name: string
          code: string
        } | null
        genabilityTariffAfter?: {
          __typename?: "Tariff"
          id: number
          name: string
          code: string
        } | null
        costs: {
          __typename?: "ETBCosts"
          totalCost: number
          totalIncentiveSavings: number
          netCost: number
          energyConsumptionKwhYear1: number
          netEnergyConsumptionKwhYear1: number
          utilityCostPerKwh: number
          averageLoadFactor: number
          energyCostBefore: number
          energyCostAfter: number
          energyCostSavings: number
          demandCostBefore: number
          demandCostAfter: number
          demandCostSavings: number
          totalCostBefore: number
          totalCostAfter: number
          totalCostSavings: number
          pvTotalCost: number
          pvNetCost: number
          pvPowerRatingKwDc: number
          pvPowerRatingKwAc: number
          pvDegradationRate: number
          pvGenerationKwhYear1: number
          pvKwhPerKwDc: number
          pvSavingsPerKwh: number
          pvGenerationPercentExported: number
          storageTotalCost: number
          storageNetCost: number
          storageCapacityKwh: number
          storageMaxDischargePowerKw: number
          storageTwoHourPowerRatingKw: number
          storageDegradationRate: number
          storageDischargeYear1: number
          storageConsumptionKwhYear1: number
          storageSavingsPerKw: number
          storageSavingsPerKwh: number
        }
        pv: Array<{
          __typename?: "ETBPVArray"
          cost: number
          powerRatingKwDc: number
          powerRatingKwAc: number
          degradationRate: number
          tilt: number
          azimuth: number
        }>
        bauMeter?: {
          __typename?: "BauMeter"
          id: number
          archivedAt?: string | null
        } | null
      }>
      transactions: Array<{
        __typename?: "ETBTransaction"
        name: string
        termYears: number
        irr10Year?: number | null
        irr20Year?: number | null
        irrTerm?: number | null
        lcoeBefore: number
        lcoeAfter: number
        lcoePv: number
        npvTerm: number
        paybackYears?: number | null
        roiTerm?: number | null
        demandSavingsTerm: number
        energySavingsTerm: number
        totalSavingsTerm: number
        pvGenerationKwhTerm: number
        storageDischargeKwhTerm: number
        storageConsumptionKwh: number
        totalCost: number
        totalIncentives: number
        netCost: number
        upfrontCost?: number | null
        ppaTerm?: number | null
        ppaStartingRate?: number | null
        ppaEscalationRate?: number | null
        series: Array<{ __typename?: "ETBSeries"; name: string; series: Array<number> }>
      }>
    } | null
  } | null
}

export type EtbIndexQueryVariables = Exact<{
  pid: Scalars["String"]["input"]
}>

export type EtbIndexQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    etbReports: Array<{
      __typename?: "ETBReport"
      id: number
      projectName: string
      dateCreated: string
      proposalDate: string
      scenario?: {
        __typename?: "ETBScenarioRef"
        pid: string
        name: string
        isPrimary: boolean
        solarLocation: SolarLocation
        includeStorage: boolean
        loadCategory: LoadCategory
      } | null
    }>
    etbScenarioOptions: Array<{
      __typename?: "ETBScenarioRef"
      pid: string
      name: string
      isPrimary: boolean
      solarLocation: SolarLocation
      includeStorage: boolean
      loadCategory: LoadCategory
    }>
  } | null
}

export type HelioscopeIndexQueryVariables = Exact<{
  pid: Scalars["String"]["input"]
}>

export type HelioscopeIndexQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    activeMeters?: {
      __typename?: "MeterSet"
      meters: Array<{ __typename?: "BauMeter"; label: string }>
    } | null
    helioscopes: Array<{
      __typename?: "Helioscope"
      id: number
      pid: string
      createdAt: string
      isTrashed: boolean
      roofPvKw: number
      carportPvKw: number
      carportPvThreeHighKw: number
      carportPvSixHighKw: number
      groundPvKw: number
      roofIsMax: boolean
      carportIsMax: boolean
      annualProductionAcKwh: number
      monthlyProductionAcKwh?: Array<number> | null
      systemProductivityKwhPerKw?: number | null
      allocations?: any | null
      roofImageHref: string
      dcNameplateKw?: number | null
      acNameplateKw?: number | null
      loadRatio?: number | null
      moduleType?: string | null
      inverterType?: string | null
      rackingTiltDegrees?: number | null
      rackingManufacturer?: string | null
      rackingConnectionType?: ConnectionType | null
      notes?: string | null
      createdBy: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      }
      pvSpecs: Array<{ __typename?: "HelioPVSpec"; pvType: PvType; sizeKw: number }>
      pdf: {
        __typename?: "Attachment"
        id: number
        size: number
        name: string
        contentType: string
        downloadHref: string
        createdAt: string
        trashedAt?: string | null
        isTrashable: boolean
        isRoofImageCandidate: boolean
        isEtb?: boolean | null
        createdBy: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        }
      }
      roofImage: {
        __typename?: "Attachment"
        id: number
        size: number
        name: string
        contentType: string
        downloadHref: string
        createdAt: string
        trashedAt?: string | null
        isTrashable: boolean
        isRoofImageCandidate: boolean
        isEtb?: boolean | null
        createdBy: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        }
      }
      productionCsv?: {
        __typename?: "Attachment"
        id: number
        size: number
        name: string
        contentType: string
        downloadHref: string
        createdAt: string
        trashedAt?: string | null
        isTrashable: boolean
        isRoofImageCandidate: boolean
        isEtb?: boolean | null
        createdBy: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        }
      } | null
    }>
  } | null
}

export type HelioscopeUploadQueryVariables = Exact<{
  pid: Scalars["String"]["input"]
}>

export type HelioscopeUploadQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    scenarios: Array<{
      __typename?: "AdminScenario"
      id: number
      pid: string
      name: string
      dateCreated: string
      includeStorage: boolean
      isPrimary: boolean
      isMultifamily: boolean
      loadCategory: LoadCategory
      solarLocation: SolarLocation
      hiddenFromCustomers: boolean
      allowMulticonnect: boolean
      createdBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
    }>
  } | null
}

export type LuxDetailQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  id: Scalars["Int"]["input"]
}>

export type LuxDetailQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    lux: {
      __typename?: "Lux"
      id: number
      createdAt: string
      fmvStr: string
      goal: PVoptGoal
      maxOffsetPct?: number | null
      pvKw: number
      roofPvKw: number
      carportPvThreeHighKw: number
      carportPvSixHighKw: number
      battKw: number
      battKwh: number
      meters: Array<{
        __typename?: "LuxMeter"
        id: number
        bauMeter: {
          __typename?: "BauMeter"
          id: number
          label: string
          importsKwh: number
          tariff: { __typename?: "Tariff"; name: string; code: string }
        }
        postSolarMeter?: {
          __typename?: "PostSolarMeter"
          pv: Array<{
            __typename?: "PVConfig"
            pvType: PvType
            origin: ProductionOrigin
            sizeKw: number
            productionKwh: number
          }>
          tariff: {
            __typename?: "TariffRate"
            parent: { __typename?: "Tariff"; name: string; code: string }
          }
        } | null
        postBatteryMeter?: {
          __typename?: "PostBatteryMeter"
          batt?: {
            __typename?: "BatteryConfig"
            vendor: BatteryVendor
            sizeKwh: number
            sizeKw: number
            chargeStrategy: ChargeStrategy
            dischargeStrategy: DischargeStrategy
          } | null
          tariff: {
            __typename?: "TariffRate"
            parent: { __typename?: "Tariff"; name: string; code: string }
          }
        } | null
        gridMeter?: {
          __typename?: "GridMeter"
          preSolar: {
            __typename?: "MeterCalc"
            costSummary: {
              __typename?: "CostSummary"
              totalCost: number
              totalEnergyUsage: number
              energyCost: number
              demandCost: number
              fixedCost: number
              nbcCost: number
              exportBenefit: number
            }
          }
          postSolar: {
            __typename?: "MeterCalc"
            costSummary: {
              __typename?: "CostSummary"
              totalCost: number
              totalEnergyUsage: number
              energyCost: number
              demandCost: number
              fixedCost: number
              nbcCost: number
              exportBenefit: number
            }
          }
          postBattery?: {
            __typename?: "MeterCalc"
            costSummary: {
              __typename?: "CostSummary"
              totalCost: number
              totalEnergyUsage: number
              energyCost: number
              demandCost: number
              fixedCost: number
              nbcCost: number
              exportBenefit: number
            }
          } | null
        } | null
        dayIntervals: {
          __typename?: "DayIntervals"
          pvToBldg: Array<number>
          battDischarge: Array<number>
          gridToBldg: Array<number>
        }
      }>
      iterations: Array<{
        __typename?: "Iteration"
        metric: number
        postTaxItcDeprIrr?: number | null
        meters: Array<{
          __typename?: "MeterIteration"
          bauMeterId: number
          totalPvKw: number
          pv: Array<{ __typename?: "IterPV"; pvType: PvType; sizeKw: number }>
        }>
      }>
      etbReport?: { __typename?: "ETBReport"; id: number } | null
      meterSet: { __typename?: "MeterSet"; id: number }
    }
  } | null
}

export type GetPortfolioOverridesQueryVariables = Exact<{
  portfolioPid: Scalars["String"]["input"]
}>

export type GetPortfolioOverridesQuery = {
  __typename?: "Query"
  portfolio?: {
    __typename?: "AdminPortfolio"
    pid: string
    overrides: Array<{
      __typename?: "FinmodelInputOverride"
      id: number
      dateCreated: string
      dateTrashed?: string | null
      inputName: string
      inputValue: string
      source: FinmodelInputOverrideSource
      createdBy?: string | null
    }>
  } | null
  finmodelSettings: {
    __typename?: "FinmodelSettings"
    possibleOverrides: Array<{
      __typename?: "Overridable"
      name: string
      type: InputType
    }>
  }
}

export type GetSiteOverridesQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type GetSiteOverridesQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    overrides: Array<{
      __typename?: "FinmodelInputOverride"
      id: number
      dateCreated: string
      dateTrashed?: string | null
      inputName: string
      inputValue: string
      source: FinmodelInputOverrideSource
      createdBy?: string | null
    }>
    portfolio?: {
      __typename?: "AdminPortfolio"
      pid: string
      overrides: Array<{
        __typename?: "FinmodelInputOverride"
        id: number
        dateCreated: string
        dateTrashed?: string | null
        inputName: string
        inputValue: string
        source: FinmodelInputOverrideSource
        createdBy?: string | null
      }>
    } | null
  } | null
  finmodelSettings: {
    __typename?: "FinmodelSettings"
    possibleOverrides: Array<{
      __typename?: "Overridable"
      name: string
      type: InputType
    }>
  }
}

export type GetFinancingGiverOrgOverridesQueryVariables = Exact<{
  orgPid: Scalars["String"]["input"]
}>

export type GetFinancingGiverOrgOverridesQuery = {
  __typename?: "Query"
  org: {
    __typename?: "AdminOrg"
    pid: string
    overrides: Array<{
      __typename?: "FinmodelInputOverride"
      id: number
      dateCreated: string
      dateTrashed?: string | null
      inputName: string
      inputValue: string
      source: FinmodelInputOverrideSource
      createdBy?: string | null
    }>
  }
  finmodelSettings: {
    __typename?: "FinmodelSettings"
    possibleOverrides: Array<{
      __typename?: "Overridable"
      name: string
      type: InputType
    }>
  }
}

export type FinproductOverridesQueryVariables = Exact<{
  finProductId: Scalars["Int"]["input"]
}>

export type FinproductOverridesQuery = {
  __typename?: "Query"
  finproduct: {
    __typename?: "AdminFinProduct"
    id: number
    finmodelInputOverrides: Array<{
      __typename?: "FinmodelInputOverride"
      id: number
      dateCreated: string
      dateTrashed?: string | null
      inputName: string
      inputValue: string
      source: FinmodelInputOverrideSource
      createdBy?: string | null
    }>
  }
  finmodelSettings: {
    __typename?: "FinmodelSettings"
    possibleOverrides: Array<{
      __typename?: "Overridable"
      name: string
      type: InputType
    }>
  }
}

export type SiteUtilityQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type SiteUtilityQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    zipCode: string
    dateTargetUtilitySet?: string | null
    utilityName?: string | null
    isMultifamily: boolean
    metering?: Metering | null
    meteringSetDate?: string | null
    thirdPartySupplier?: {
      __typename?: "ThirdPartySupplier"
      id: number
      name: string
    } | null
    targetUtility: {
      __typename?: "Utility"
      id: number
      name: string
      shortName: string
    }
    targetUtilitySetBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    probableUtilities: Array<{ __typename?: "Utility"; id: number; name: string }>
    customTariffs: Array<{
      __typename?: "CustomTariff"
      id: number
      name: string
      code: string
      parent?: { __typename?: "Tariff"; id: number } | null
    }>
    meteringSetBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
  } | null
}

export type UtilitySearchQueryVariables = Exact<{
  name: Scalars["String"]["input"]
}>

export type UtilitySearchQuery = {
  __typename?: "Query"
  tariffs: {
    __typename?: "AdminTariffQuery"
    searchGenabilityByUtilityName: Array<{
      __typename?: "Utility"
      id: number
      name: string
    }>
  }
}

export type SiteUtilityByLabelQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  label: Scalars["String"]["input"]
}>

export type SiteUtilityByLabelQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    utilityByLabel?: { __typename?: "Utility"; id: number; name: string } | null
    probableUtilities: Array<{ __typename?: "Utility"; id: number; name: string }>
  } | null
}

export type ThirdPartySuppliersQueryVariables = Exact<{ [key: string]: never }>

export type ThirdPartySuppliersQuery = {
  __typename?: "Query"
  thirdPartySuppliers: Array<{
    __typename?: "ThirdPartySupplier"
    id: number
    pid: string
    name: string
  }>
}

export type TariffRateDetailQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  tariffParentId: Scalars["Int"]["input"]
}>

export type TariffRateDetailQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    tariffDetail: {
      __typename?: "TariffDetails"
      rawJson: any
      tariff: {
        __typename?: "Tariff"
        id: number
        code: string
        name: string
        customerClass: string
      }
      version?: {
        __typename?: "TariffVersion"
        tariffId?: number | null
        effectiveDate: string
        endDate?: string | null
      } | null
      properties: Array<{
        __typename?: "TariffProperty"
        keyName: string
        dataType: string
        propertyValue?: string | null
        formulaDetail?: string | null
      }>
      rates: Array<{
        __typename?: "Rate"
        tariffRateId: number
        name: string
        classes: Array<ChargeClass>
        chargeClass: string
        chargeType?: ChargeType | null
        chargePeriod: ChargePeriod
        transactionType: TransactionType
        applicabilityKey?: string | null
        quantityKey?: string | null
        isDemandCharge: boolean
        isFixedPrice: boolean
        isQuantity: boolean
        isTou: boolean
        variableLimitValue?: {
          __typename?: "TariffPropertyKey"
          keyName: string
          formulaDetail?: string | null
        } | null
        bands: Array<{
          __typename?: "RateBand"
          tariffRateBandId: number
          rateUnit: RateUnit
          price: number
          isCredit: boolean
          hasConsumptionLimit?: boolean | null
          propertyUpperLimit?: number | null
          consumptionUpperLimit?: number | null
          demandUpperLimit?: number | null
          calculationFactor?: number | null
          applicabilityValue?: string | null
        }>
        season?: {
          __typename?: "Season"
          seasonFromMonth: number
          seasonToMonth: number
          seasonFromDay: number
          seasonToDay: number
        } | null
        tou?: {
          __typename?: "TimeOfUse"
          touName: string
          season?: {
            __typename?: "Season"
            seasonFromMonth: number
            seasonToMonth: number
            seasonFromDay: number
            seasonToDay: number
          } | null
          touPeriods: Array<{
            __typename?: "Period"
            fromDayOfWeek: number
            toDayOfWeek: number
            fromHour?: number | null
            toHour?: number | null
            fromMinute?: number | null
            toMinute?: number | null
          }>
        } | null
      }>
    }
  } | null
}

export type AdminSearchQueryVariables = Exact<{
  q: Scalars["String"]["input"]
}>

export type AdminSearchQuery = {
  __typename?: "Query"
  search: Array<{
    __typename?: "SearchSiteRow"
    id: number
    pid: string
    name?: string | null
    fullAddress: string
    portfolio?: { __typename?: "PortfolioRef"; pid: string; title: string } | null
  }>
}

export type CostarOwnerNameSearchQueryVariables = Exact<{
  q: Scalars["String"]["input"]
}>

export type CostarOwnerNameSearchQuery = {
  __typename?: "Query"
  searchForOwnerName: Array<{
    __typename?: "CostarSearch"
    ownerName: string
    countSitesInPortfolio: number
    countSitesNotInPortfolio: number
    primaryState: string
  }>
}

export type CostarSitesByOwnerNameQueryVariables = Exact<{
  name: Scalars["String"]["input"]
}>

export type CostarSitesByOwnerNameQuery = {
  __typename?: "Query"
  sitesByOwnerName: Array<{
    __typename?: "Site"
    pid: string
    displayName?: string | null
    costarPropertyType?: CoStarPropertyType | null
    city: string
    state: string
  }>
}

export type SmallScenarioFragmentFragment = {
  __typename?: "AdminScenario"
  id: number
  pid: string
  name: string
  dateCreated: string
  includeStorage: boolean
  isPrimary: boolean
  isMultifamily: boolean
  loadCategory: LoadCategory
  solarLocation: SolarLocation
  hiddenFromCustomers: boolean
  allowMulticonnect: boolean
  createdBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
}

export type ScenarioFragmentFragment = {
  __typename?: "AdminScenario"
  id: number
  pid: string
  name: string
  dateCreated: string
  includeStorage: boolean
  isPrimary: boolean
  isMultifamily: boolean
  loadCategory: LoadCategory
  solarLocation: SolarLocation
  hiddenFromCustomers: boolean
  allowMulticonnect: boolean
  activeEtbReport?: { __typename?: "ETBReport"; id: number; projectName: string } | null
  helioscope?: { __typename?: "Helioscope"; id: number; pid: string } | null
  createdBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
}

export type ScenarioListQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type ScenarioListQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    scenarios: Array<{
      __typename?: "AdminScenario"
      id: number
      pid: string
      name: string
      dateCreated: string
      includeStorage: boolean
      isPrimary: boolean
      isMultifamily: boolean
      loadCategory: LoadCategory
      solarLocation: SolarLocation
      hiddenFromCustomers: boolean
      allowMulticonnect: boolean
      activeEtbReport?: {
        __typename?: "ETBReport"
        id: number
        projectName: string
      } | null
      helioscope?: { __typename?: "Helioscope"; id: number; pid: string } | null
      createdBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
    }>
  } | null
}

export type ScenarioDetailQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  scenarioPid: Scalars["String"]["input"]
}>

export type ScenarioDetailQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    attachments: Array<{
      __typename?: "Attachment"
      id: number
      size: number
      name: string
      contentType: string
      downloadHref: string
      createdAt: string
      trashedAt?: string | null
      isTrashable: boolean
      isRoofImageCandidate: boolean
      isEtb?: boolean | null
      createdBy: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      }
    }>
    helioscopes: Array<{
      __typename?: "Helioscope"
      id: number
      pid: string
      createdAt: string
      isTrashed: boolean
      roofPvKw: number
      carportPvKw: number
      pdf: {
        __typename?: "Attachment"
        id: number
        size: number
        name: string
        contentType: string
        downloadHref: string
        createdAt: string
        trashedAt?: string | null
        isTrashable: boolean
        isRoofImageCandidate: boolean
        isEtb?: boolean | null
        createdBy: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        }
      }
      roofImage: {
        __typename?: "Attachment"
        id: number
        size: number
        name: string
        contentType: string
        downloadHref: string
        createdAt: string
        trashedAt?: string | null
        isTrashable: boolean
        isRoofImageCandidate: boolean
        isEtb?: boolean | null
        createdBy: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        }
      }
    }>
    etbReports: Array<{
      __typename?: "ETBReport"
      id: number
      dateCreated: string
      projectName: string
      roofPvKw?: number | null
      carportPvKw?: number | null
      groundPvKw?: number | null
      batteryKw?: number | null
      batteryKwh?: number | null
    }>
    scenario?: {
      __typename?: "AdminScenario"
      id: number
      pid: string
      name: string
      dateCreated: string
      includeStorage: boolean
      isPrimary: boolean
      isMultifamily: boolean
      loadCategory: LoadCategory
      solarLocation: SolarLocation
      hiddenFromCustomers: boolean
      allowMulticonnect: boolean
      etbs: Array<{
        __typename?: "ETBReport"
        id: number
        projectName: string
        dateCreated: string
      }>
      configs: Array<{
        __typename?: "ScenarioConfig"
        id: number
        createdAt: string
        finproductType?: FinProductType | null
        goal: PVoptGoal
        roofKw?: number | null
        carportKw?: number | null
        groundKw?: number | null
        finproduct?: {
          __typename: "AdminFinProduct"
          id: number
          createdAt: string
          name: string
          type: FinProductType
          financier: { __typename?: "OrgRef"; pid: string; name: string }
        } | null
        helioscope?: {
          __typename?: "Helioscope"
          id: number
          pid: string
          createdAt: string
          isTrashed: boolean
          roofPvKw: number
          carportPvKw: number
          pdf: {
            __typename?: "Attachment"
            id: number
            size: number
            name: string
            contentType: string
            downloadHref: string
            createdAt: string
            trashedAt?: string | null
            isTrashable: boolean
            isRoofImageCandidate: boolean
            isEtb?: boolean | null
            createdBy: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            }
          }
          roofImage: {
            __typename?: "Attachment"
            id: number
            size: number
            name: string
            contentType: string
            downloadHref: string
            createdAt: string
            trashedAt?: string | null
            isTrashable: boolean
            isRoofImageCandidate: boolean
            isEtb?: boolean | null
            createdBy: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            }
          }
        } | null
        etb?: {
          __typename?: "ETBReport"
          id: number
          dateCreated: string
          projectName: string
          roofPvKw?: number | null
          carportPvKw?: number | null
          groundPvKw?: number | null
          batteryKw?: number | null
          batteryKwh?: number | null
        } | null
      }>
      activeEtbReport?: {
        __typename?: "ETBReport"
        id: number
        projectName: string
      } | null
      helioscope?: { __typename?: "Helioscope"; id: number; pid: string } | null
      createdBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
    } | null
  } | null
}

export type PortfolioUsersQueryVariables = Exact<{
  portfolioPid: Scalars["String"]["input"]
}>

export type PortfolioUsersQuery = {
  __typename?: "Query"
  portfolio?: {
    __typename?: "AdminPortfolio"
    pid: string
    title: string
    users: Array<{ __typename?: "AdminUser"; id: number; email: string }>
  } | null
}

export type SiteChangelogQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type SiteChangelogQuery = {
  __typename?: "Query"
  changelogs: {
    __typename?: "ChangelogQuery"
    site: Array<{
      __typename?: "AdminChangelog"
      id: number
      transactionId: string
      dateCreated: string
      columnName?: string | null
      oldVal?: any | null
      newVal?: any | null
      changedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
    }>
  }
}

export type SiteAttachmentsQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type SiteAttachmentsQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    attachments: Array<{
      __typename?: "Attachment"
      id: number
      size: number
      name: string
      contentType: string
      downloadHref: string
      createdAt: string
      trashedAt?: string | null
      isTrashable: boolean
      isRoofImageCandidate: boolean
      isEtb?: boolean | null
      createdBy: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      }
    }>
  } | null
}

export type AttachmentAsCsvQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  attachmentId: Scalars["Int"]["input"]
}>

export type AttachmentAsCsvQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    isMultifamily: boolean
    attachment: {
      __typename?: "Attachment"
      csvPeek?: Array<Array<string>> | null
      id: number
      size: number
      name: string
      contentType: string
      downloadHref: string
      createdAt: string
      trashedAt?: string | null
      isTrashable: boolean
      isRoofImageCandidate: boolean
      isEtb?: boolean | null
      createdBy: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      }
    }
  } | null
}

export type CleanMetersQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type CleanMetersQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    isMultifamily: boolean
    cleanMeters: {
      __typename?: "CleanMeterQuery"
      all: Array<{
        __typename?: "CleanMeter"
        id: number
        dateCreated: string
        source: MeterSource
        label: string
        address?: string | null
        dirtyIntervals?: {
          __typename?: "DirtyIntervals"
          units: Units
          totalKwh: number
          rollup: Array<{
            __typename?: "DailyRollup"
            season: string
            days: Array<string>
            numbers: Array<number>
          }>
        } | null
      }>
    }
  } | null
}

export type SiteStatusCheckQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type SiteStatusCheckQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    statusCheck: Array<{
      __typename?: "StatusCheck"
      desc: string
      hint: string
      status: boolean
    }>
  } | null
}

export type FailuresQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type FailuresQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    failures: Array<
      | {
          __typename: "BuildingFootprintFailure"
          createdAt: string
          name: string
          message: string
        }
      | {
          __typename: "FinmodelFailure"
          id: number
          createdAt: string
          name: string
          message: string
          scenario: { __typename?: "ScenarioRef"; pid: string; name: string }
        }
      | {
          __typename: "GuessTariffFailure"
          createdAt: string
          name: string
          message: string
        }
      | {
          __typename: "LoadEstimateFailure"
          errorClass?: string | null
          errorMessage?: string | null
          createdAt: string
        }
      | {
          __typename: "ParcelDataFailure"
          createdAt: string
          name: string
          message: string
        }
    >
  } | null
}

export type BillDocumentsQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type BillDocumentsQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    isMultifamily: boolean
    targetUtility: {
      __typename?: "Utility"
      id: number
      name: string
      shortName: string
    }
    documentsV0: Array<{
      __typename?: "Document"
      id: number
      pid: string
      fileName: string
      dateCreated: string
      ownerEmail: string
      contentType: string
      tag?: DocumentTag | null
      downloadHref: string
      viewHref: string
    }>
    billSuggestions: Array<{
      __typename?: "BillSuggestion"
      id: number
      document: { __typename?: "Document"; pid: string }
    }>
  } | null
}

export type AiMessageFragment = {
  __typename?: "Message"
  role: Role
  content: Array<
    | { __typename: "FileContent" }
    | { __typename: "ImageContent"; imageUrl: { __typename?: "ImageUrl"; url: string } }
    | { __typename: "TextContent"; text: string }
  >
  toolCalls?: Array<{
    __typename?: "ToolCall"
    id: string
    type: string
    function: { __typename?: "Function"; name: string; arguments: string }
  }> | null
}

export type OrgsQueryVariables = Exact<{ [key: string]: never }>

export type OrgsQuery = {
  __typename?: "Query"
  orgs: Array<{ __typename?: "AdminOrg"; pid: string; name: string }>
}

export type BasicOrgDetailsFragment = {
  __typename?: "AdminOrg"
  id: number
  pid: string
  name: string
  slug: string
  rawSlug: string
  description?: string | null
  logoUrl: string
  logomarkUrl?: string | null
}

export type OrgsDetailListQueryVariables = Exact<{ [key: string]: never }>

export type OrgsDetailListQuery = {
  __typename?: "Query"
  orgs: Array<{
    __typename?: "AdminOrg"
    id: number
    pid: string
    name: string
    slug: string
    rawSlug: string
    description?: string | null
    logoUrl: string
    logomarkUrl?: string | null
  }>
  financierOrgs: Array<{
    __typename?: "AdminOrg"
    id: number
    pid: string
    name: string
    slug: string
    rawSlug: string
    description?: string | null
    logoUrl: string
    logomarkUrl?: string | null
  }>
}

export type SiteIraIncentiveDataQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type SiteIraIncentiveDataQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    isLowIncomeCommunity?: boolean | null
    isEnergyCommunity: boolean
  } | null
}

export type SiteLeaseTypeQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type SiteLeaseTypeQuery = {
  __typename?: "Query"
  site?: { __typename?: "Site"; pid: string; leaseType?: LeaseType | null } | null
}

export type SiteOccupancyTypeQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type SiteOccupancyTypeQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    occupancyType?: BuildingOccupancyType | null
  } | null
}

export type OrgDetailQueryVariables = Exact<{
  orgPid: Scalars["String"]["input"]
}>

export type OrgDetailQuery = {
  __typename?: "Query"
  org: {
    __typename?: "AdminOrg"
    allowedEmailDomains?: Array<string> | null
    id: number
    pid: string
    name: string
    slug: string
    rawSlug: string
    description?: string | null
    logoUrl: string
    logomarkUrl?: string | null
    portfolios: Array<{ __typename?: "PortfolioRef"; pid: string; title: string }>
    labels: Array<{
      __typename?: "SiteLabel"
      pid: string
      name: string
      themeColor: LabelColor
    }>
    financing: Array<{
      __typename?: "AdminFinRel"
      disabledAt?: string | null
      finproduct: {
        __typename?: "AdminFinProduct"
        id: number
        type: FinProductType
        name: string
        financier: { __typename?: "OrgRef"; name: string; pid: string }
      }
      recvr: { __typename?: "Org"; pid: string }
    }>
    finproducts: Array<{
      __typename: "AdminFinProduct"
      id: number
      createdAt: string
      name: string
      type: FinProductType
      disabledAt?: string | null
      includeStorage: boolean
      status?: FinProductStatus | null
      financier: { __typename?: "OrgRef"; pid: string; name: string }
      activeOverrides: Array<{
        __typename?: "FinmodelInputOverride"
        id: number
        dateCreated: string
        dateTrashed?: string | null
        inputName: string
        inputValue: string
        source: FinmodelInputOverrideSource
        createdBy?: string | null
      }>
      targetOrg?: { __typename?: "Org"; pid: string; name: string } | null
      targetSite?: {
        __typename?: "SiteRef"
        pid: string
        name?: string | null
        streetAddress: string
      } | null
      csPrices?: Array<{
        __typename?: "CSPrice"
        state?: UsState | null
        usdPerKwPerYear: number
        escalator: number
        termYears: number
        minPvKw: number
        maxPvKw: number
        pvType?: PvType | null
        utility: {
          __typename?: "RevampUtility"
          name: string
          id: number
          shortName: string
        }
      }> | null
    }>
  }
}

export type OrgUsersQueryVariables = Exact<{
  orgPid: Scalars["String"]["input"]
}>

export type OrgUsersQuery = {
  __typename?: "Query"
  org: {
    __typename?: "AdminOrg"
    pid: string
    name: string
    logoUrl: string
    logomarkUrl?: string | null
    users: Array<{
      __typename?: "AdminUser"
      id: number
      pid: string
      email: string
      name?: string | null
      affiliation?: string | null
      isAdmin: boolean
      isEnabled: boolean
      avatarUrl?: string | null
      meetingSchedulingUrl?: string | null
      lastSeenAt?: string | null
      portfoliosWithRole: Array<{
        __typename?: "PortfolioRef"
        pid: string
        title: string
      }>
      unclaimedInvitations: Array<{
        __typename?: "AdminInvitation"
        isClaimed: boolean
        isExpired: boolean
        expiresAt: string
        portfolio?: { __typename?: "PortfolioRef"; pid: string; title: string } | null
      }>
      licenseAgreements: Array<{
        __typename?: "LicenseAgreement"
        acceptedAt: string
        forOrg?: { __typename?: "Org"; pid: string; name: string } | null
      }>
      org?: { __typename?: "Org"; pid: string; name: string; slug: string } | null
    }>
  }
}

export type FinmodelFailureIndexQueryVariables = Exact<{ [key: string]: never }>

export type FinmodelFailureIndexQuery = {
  __typename?: "Query"
  finmodelFailureIndex: Array<{
    __typename?: "FinmodelFailureIndexRow"
    fmv: number
    name: string
    failureCount: number
  }>
}

export type FinmodelFailureViewQueryVariables = Exact<{
  filterBy: FinmodelFailureTableFilter
  sortBy?: InputMaybe<Array<FinmodelFailureTableSort> | FinmodelFailureTableSort>
}>

export type FinmodelFailureViewQuery = {
  __typename?: "Query"
  finmodelFailures: {
    __typename?: "FinmodelFailureTable"
    view: {
      __typename?: "FinmodelFailureTableView"
      count: number
      keys: Array<number>
    }
  }
}

export type FinmodelFailureRowQueryVariables = Exact<{
  keys: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
}>

export type FinmodelFailureRowQuery = {
  __typename?: "Query"
  finmodelFailures: {
    __typename?: "FinmodelFailureTable"
    rows: Array<{
      __typename?: "FinmodelFailureTableRow"
      id: number
      createdAt: string
      fmv: number
      name: string
      message: string
    }>
  }
}

export type FinmodelFailureDetailQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type FinmodelFailureDetailQuery = {
  __typename?: "Query"
  finmodelFailure?: {
    __typename?: "FinmodelFailure"
    id: number
    createdAt: string
    fmv: number
    name: string
    message: string
    isPvopt: boolean
    isLux: boolean
    finmodel?: { __typename?: "Finmodel"; id: number; fmvStr: string } | null
    site: {
      __typename?: "SiteRef"
      pid: string
      name?: string | null
      streetAddress: string
    }
    scenario: { __typename?: "ScenarioRef"; pid: string; name: string }
    source?:
      | { __typename: "ETBReportRef"; id: number; projectName: string }
      | { __typename: "LuxRef"; id: number }
      | { __typename: "PVoptRef"; id: number }
      | { __typename: "ReoptRef"; pid: string }
      | null
  } | null
}

export type OpenInvitesQueryVariables = Exact<{
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
}>

export type OpenInvitesQuery = {
  __typename?: "Query"
  openInvites: Array<{
    __typename?: "AdminOpenInvite"
    id: number
    pid: string
    url: string
    expiresAt: string
    isExpired: boolean
    createdAt: string
    createdBy: {
      __typename?: "UserRef"
      pid: string
      name?: string | null
      email: string
    }
    portfolio: { __typename?: "PortfolioRef"; pid: string; title: string }
  }>
  portfolios: Array<{ __typename?: "PortfolioRow"; pid: string; title: string }>
}

export type SitePoliciesQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type SitePoliciesQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    state: string
    targetUtility: {
      __typename?: "Utility"
      id: number
      name: string
      shortName: string
    }
    policies: Array<{
      __typename?: "Policy"
      pid: string
      name: string
      status: PolicyStatus
      startDate?: string | null
      endDate?: string | null
      userVisible: boolean
      jurisdiction: {
        __typename?: "Jurisdiction"
        scope: JurisdictionScope
        name: string
      }
      application: { __typename?: "PolicyApplication"; status: PolicyApplicationStatus }
      rules: Array<{
        __typename?: "Rule"
        id: string
        description: string
        units?: RuleValueUnits | null
        value:
          | { __typename: "CurrencyValue"; usd: number }
          | { __typename: "IntegerValue"; integer: number }
          | { __typename: "NumberValue"; number: number }
          | { __typename: "TextValue"; text: string }
          | { __typename: "YesNoValue"; yes: boolean }
        application: {
          __typename?: "RuleApplication"
          status: RuleApplicationStatus
          detail?: string | null
        }
        conditions: Array<
          | {
              __typename: "BuildingSuperTypeCondition"
              buildingSuperType: BuildingSuperType
            }
          | { __typename: "VnemEligibilityCondition"; vnemEligibilityRequired: boolean }
        >
      }>
    }>
  } | null
}

export type AllPoliciesQueryVariables = Exact<{ [key: string]: never }>

export type AllPoliciesQuery = {
  __typename?: "Query"
  policies: {
    __typename?: "PolicyQuery"
    all: Array<{
      __typename?: "Policy"
      pid: string
      name: string
      status: PolicyStatus
      startDate?: string | null
      endDate?: string | null
      userVisible: boolean
      jurisdiction: {
        __typename?: "Jurisdiction"
        scope: JurisdictionScope
        name: string
      }
      application: { __typename?: "PolicyApplication"; status: PolicyApplicationStatus }
      rules: Array<{
        __typename?: "Rule"
        id: string
        description: string
        units?: RuleValueUnits | null
        value:
          | { __typename: "CurrencyValue"; usd: number }
          | { __typename: "IntegerValue"; integer: number }
          | { __typename: "NumberValue"; number: number }
          | { __typename: "TextValue"; text: string }
          | { __typename: "YesNoValue"; yes: boolean }
        application: {
          __typename?: "RuleApplication"
          status: RuleApplicationStatus
          detail?: string | null
        }
        conditions: Array<
          | {
              __typename: "BuildingSuperTypeCondition"
              buildingSuperType: BuildingSuperType
            }
          | { __typename: "VnemEligibilityCondition"; vnemEligibilityRequired: boolean }
        >
      }>
    }>
  }
}

export type PolicyDetailQueryVariables = Exact<{
  policyPid: Scalars["String"]["input"]
}>

export type PolicyDetailQuery = {
  __typename?: "Query"
  policies: {
    __typename?: "PolicyQuery"
    policy?: {
      __typename?: "Policy"
      pid: string
      name: string
      userVisible: boolean
      description: string
      publicDescription: string
      status: PolicyStatus
      startDate?: string | null
      endDate?: string | null
      application: { __typename?: "PolicyApplication"; status: PolicyApplicationStatus }
      jurisdiction: {
        __typename?: "Jurisdiction"
        scope: JurisdictionScope
        name: string
      }
      rules: Array<{
        __typename?: "Rule"
        id: string
        description: string
        units?: RuleValueUnits | null
        value:
          | { __typename: "CurrencyValue"; usd: number }
          | { __typename: "IntegerValue"; integer: number }
          | { __typename: "NumberValue"; number: number }
          | { __typename: "TextValue"; text: string }
          | { __typename: "YesNoValue"; yes: boolean }
        application: {
          __typename?: "RuleApplication"
          status: RuleApplicationStatus
          detail?: string | null
        }
        conditions: Array<
          | {
              __typename: "BuildingSuperTypeCondition"
              buildingSuperType: BuildingSuperType
            }
          | { __typename: "VnemEligibilityCondition"; vnemEligibilityRequired: boolean }
        >
      }>
      conditions: Array<
        | {
            __typename: "BuildingSuperTypeCondition"
            buildingSuperType: BuildingSuperType
          }
        | { __typename: "VnemEligibilityCondition"; vnemEligibilityRequired: boolean }
      >
      sources: Array<{
        __typename?: "Source"
        text?: string | null
        url?: string | null
      }>
    } | null
  }
}

export type SitePolicyViolationsQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type SitePolicyViolationsQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    policyViolations: Array<{
      __typename?: "PolicyViolation"
      policy: { __typename?: "Policy"; pid: string; name: string }
      violatedRule: {
        __typename?: "Rule"
        id: string
        description: string
        units?: RuleValueUnits | null
        value:
          | { __typename: "CurrencyValue"; usd: number }
          | { __typename: "IntegerValue"; integer: number }
          | { __typename: "NumberValue"; number: number }
          | { __typename: "TextValue"; text: string }
          | { __typename: "YesNoValue"; yes: boolean }
      }
      value:
        | { __typename: "CurrencyValue"; usd: number }
        | { __typename: "IntegerValue"; integer: number }
        | { __typename: "NumberValue"; number: number }
        | { __typename: "TextValue"; text: string }
        | { __typename: "YesNoValue"; yes: boolean }
    }>
  } | null
}

export type MultiMeterQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type MultiMeterQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    isMultifamily: boolean
    usingBillingMeters?: string | null
    orgSlug?: string | null
    dateTargetUtilitySet?: string | null
    utilityName?: string | null
    bauMeters: Array<{
      __typename?: "BauMeter"
      hasTruth: boolean
      id: number
      createdAt: string
      label: string
      loadOrigin: LoadOrigin
      loadCategory: LoadCategory
      meterSource: MeterSource
      underHumanControl: boolean
      tariffsUnderHumanControl: boolean
      archivedAt?: string | null
      archivedReason?: string | null
      createdBy?: { __typename?: "UserRef"; email: string } | null
      utility: { __typename?: "Utility"; id: number; name: string }
      tariff: {
        __typename?: "Tariff"
        id: number
        name: string
        code: string
        masterTariffId?: number | null
      }
      tariffSetBy?: { __typename?: "UserRef"; pid: string; email: string } | null
      postSolarTariff?: {
        __typename?: "Tariff"
        id: number
        name: string
        code: string
        masterTariffId?: number | null
      } | null
      postSolarTariffSetBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
      } | null
      postBatteryTariff?: {
        __typename?: "Tariff"
        id: number
        name: string
        code: string
        masterTariffId?: number | null
      } | null
      postBatteryTariffSetBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
      } | null
      archivedBy?: { __typename?: "UserRef"; pid: string; email: string } | null
      rollup: Array<{
        __typename?: "DailyRollup"
        season: string
        days: Array<string>
        numbers: Array<number>
      }>
    }>
    activeMeters?: {
      __typename?: "MeterSet"
      id: number
      createdAt: string
      createdBy?: { __typename?: "UserRef"; pid: string; email: string } | null
      meters: Array<{
        __typename?: "BauMeter"
        id: number
        createdAt: string
        label: string
        loadOrigin: LoadOrigin
        loadCategory: LoadCategory
        meterSource: MeterSource
        underHumanControl: boolean
        tariffsUnderHumanControl: boolean
        archivedAt?: string | null
        archivedReason?: string | null
        createdBy?: { __typename?: "UserRef"; email: string } | null
        utility: { __typename?: "Utility"; id: number; name: string }
        tariff: {
          __typename?: "Tariff"
          id: number
          name: string
          code: string
          masterTariffId?: number | null
        }
        tariffSetBy?: { __typename?: "UserRef"; pid: string; email: string } | null
        postSolarTariff?: {
          __typename?: "Tariff"
          id: number
          name: string
          code: string
          masterTariffId?: number | null
        } | null
        postSolarTariffSetBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
        } | null
        postBatteryTariff?: {
          __typename?: "Tariff"
          id: number
          name: string
          code: string
          masterTariffId?: number | null
        } | null
        postBatteryTariffSetBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
        } | null
        archivedBy?: { __typename?: "UserRef"; pid: string; email: string } | null
        rollup: Array<{
          __typename?: "DailyRollup"
          season: string
          days: Array<string>
          numbers: Array<number>
        }>
      }>
    } | null
    thirdPartySupplier?: {
      __typename?: "ThirdPartySupplier"
      id: number
      name: string
    } | null
    targetUtility: {
      __typename?: "Utility"
      id: number
      name: string
      shortName: string
    }
    targetUtilitySetBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    probableUtilities: Array<{ __typename?: "Utility"; id: number; name: string }>
    customTariffs: Array<{
      __typename?: "CustomTariff"
      id: number
      name: string
      code: string
      parent?: { __typename?: "Tariff"; id: number } | null
    }>
  } | null
}

export type MultiMeterDetailQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type MultiMeterDetailQuery = {
  __typename?: "Query"
  bauMeter: {
    __typename?: "BauMeter"
    id: number
    tariffUsdPerKwh: number
    formattedBill: {
      __typename?: "FormattedBills"
      rate?: {
        __typename?: "TariffRate"
        tariffId?: number | null
        startDate: string
        endDate?: string | null
      } | null
      bills: Array<{
        __typename?: "FormattedBill"
        month: string
        kwhSupplyCharge: number
        kwhCharge: number
        charges: Array<{
          __typename?: "BillSection"
          name: string
          rates: Array<{
            __typename?: "DecodedRate"
            id: number
            name: string
            chargeClass: ChargeClass
          }>
          costs: Array<
            | {
                __typename: "CostItem"
                name: string
                rateId: number
                chargeType: ChargeType
                chargeCategory?: ChargeCategory | null
                volume: number
                rate: number
                cost: number
                rateObj: {
                  __typename?: "DecodedRate"
                  id: number
                  name: string
                  chargeClass: ChargeClass
                }
              }
            | {
                __typename: "TaxItem"
                taxId: number
                subtotal: number
                cost: number
                percentage: number
              }
            | null
          >
        }>
        exports: Array<{
          __typename?: "BillSection"
          name: string
          rates: Array<{
            __typename?: "DecodedRate"
            id: number
            name: string
            chargeClass: ChargeClass
          }>
          costs: Array<
            | {
                __typename: "CostItem"
                name: string
                rateId: number
                chargeType: ChargeType
                chargeCategory?: ChargeCategory | null
                volume: number
                rate: number
                cost: number
                rateObj: {
                  __typename?: "DecodedRate"
                  id: number
                  name: string
                  chargeClass: ChargeClass
                }
              }
            | {
                __typename: "TaxItem"
                taxId: number
                subtotal: number
                cost: number
                percentage: number
              }
            | null
          >
        }>
      }>
    }
    formattedPostBill: {
      __typename?: "FormattedBills"
      rate?: {
        __typename?: "TariffRate"
        tariffId?: number | null
        startDate: string
        endDate?: string | null
      } | null
      bills: Array<{
        __typename?: "FormattedBill"
        month: string
        kwhSupplyCharge: number
        kwhCharge: number
        charges: Array<{
          __typename?: "BillSection"
          name: string
          rates: Array<{
            __typename?: "DecodedRate"
            id: number
            name: string
            chargeClass: ChargeClass
          }>
          costs: Array<
            | {
                __typename: "CostItem"
                name: string
                rateId: number
                chargeType: ChargeType
                chargeCategory?: ChargeCategory | null
                volume: number
                rate: number
                cost: number
                rateObj: {
                  __typename?: "DecodedRate"
                  id: number
                  name: string
                  chargeClass: ChargeClass
                }
              }
            | {
                __typename: "TaxItem"
                taxId: number
                subtotal: number
                cost: number
                percentage: number
              }
            | null
          >
        }>
        exports: Array<{
          __typename?: "BillSection"
          name: string
          rates: Array<{
            __typename?: "DecodedRate"
            id: number
            name: string
            chargeClass: ChargeClass
          }>
          costs: Array<
            | {
                __typename: "CostItem"
                name: string
                rateId: number
                chargeType: ChargeType
                chargeCategory?: ChargeCategory | null
                volume: number
                rate: number
                cost: number
                rateObj: {
                  __typename?: "DecodedRate"
                  id: number
                  name: string
                  chargeClass: ChargeClass
                }
              }
            | {
                __typename: "TaxItem"
                taxId: number
                subtotal: number
                cost: number
                percentage: number
              }
            | null
          >
        }>
      }>
    }
    tariff: { __typename?: "Tariff"; name: string; code: string }
    postTariff: { __typename?: "Tariff"; name: string; code: string }
  }
}

export type NameThatTariffResultFragment = {
  __typename?: "NameThatTariffResult"
  notTheCorrectRateVersion: boolean
  rate: {
    __typename?: "TariffRate"
    startDate: string
    endDate?: string | null
    tariffId?: number | null
  }
  expected: {
    __typename?: "BillMonth"
    start: string
    end?: string | null
    totalCostUsd: number
    totalKwh: number
    peakKw?: number | null
    lineItems: Array<{
      __typename?: "LineItemCharge"
      chargeType?: ChargeType | null
      costUsd: number
    }>
  }
  actual: {
    __typename?: "BillMonth"
    start: string
    end?: string | null
    totalCostUsd: number
    totalKwh: number
    peakKw?: number | null
    lineItems: Array<{
      __typename?: "LineItemCharge"
      chargeType?: ChargeType | null
      costUsd: number
    }>
  }
  delta: {
    __typename?: "TariffDeltas"
    usd: {
      __typename?: "Delta"
      a: number
      b: number
      diff: number
      pct?: number | null
    }
    kwh: {
      __typename?: "Delta"
      a: number
      b: number
      diff: number
      pct?: number | null
    }
    kw?: {
      __typename?: "Delta"
      a: number
      b: number
      diff: number
      pct?: number | null
    } | null
  }
  document: {
    __typename?: "Document"
    pid: string
    contentType: string
    viewHref: string
  }
}

export type DeltaFragment = {
  __typename?: "Delta"
  a: number
  b: number
  diff: number
  pct?: number | null
}

export type BauMeterNameThatTariffDetailQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
  tariffId: Scalars["Int"]["input"]
  documentBillingMonthId: Scalars["Int"]["input"]
}>

export type BauMeterNameThatTariffDetailQuery = {
  __typename?: "Query"
  bauMeter: {
    __typename?: "BauMeter"
    nameThatTariffDetail?: {
      __typename?: "NameThatTariffDetail"
      tariff: {
        __typename?: "Tariff"
        id: number
        masterTariffId?: number | null
        code: string
        name: string
      }
      result: {
        __typename?: "NameThatTariffResult"
        notTheCorrectRateVersion: boolean
        rate: {
          __typename?: "TariffRate"
          startDate: string
          endDate?: string | null
          tariffId?: number | null
        }
        expected: {
          __typename?: "BillMonth"
          start: string
          end?: string | null
          totalCostUsd: number
          totalKwh: number
          peakKw?: number | null
          lineItems: Array<{
            __typename?: "LineItemCharge"
            chargeType?: ChargeType | null
            costUsd: number
          }>
        }
        actual: {
          __typename?: "BillMonth"
          start: string
          end?: string | null
          totalCostUsd: number
          totalKwh: number
          peakKw?: number | null
          lineItems: Array<{
            __typename?: "LineItemCharge"
            chargeType?: ChargeType | null
            costUsd: number
          }>
        }
        delta: {
          __typename?: "TariffDeltas"
          usd: {
            __typename?: "Delta"
            a: number
            b: number
            diff: number
            pct?: number | null
          }
          kwh: {
            __typename?: "Delta"
            a: number
            b: number
            diff: number
            pct?: number | null
          }
          kw?: {
            __typename?: "Delta"
            a: number
            b: number
            diff: number
            pct?: number | null
          } | null
        }
        document: {
          __typename?: "Document"
          pid: string
          contentType: string
          viewHref: string
        }
      }
      groups: Array<{
        __typename?: "BillGroup"
        group: string
        items: Array<{
          __typename?: "GroupedLineItem"
          cost: number
          usage: number
          name: string
          rate: number
        }>
      }>
    } | null
  }
}

export type TestCustomTariffQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
  cfg: Scalars["String"]["input"]
  utilityId: Scalars["Int"]["input"]
}>

export type TestCustomTariffQuery = {
  __typename?: "Query"
  bauMeter: {
    __typename?: "BauMeter"
    id: number
    testCustomTariff: {
      __typename?: "FormattedBills"
      rate?: {
        __typename?: "TariffRate"
        tariffId?: number | null
        startDate: string
        endDate?: string | null
      } | null
      bills: Array<{
        __typename?: "FormattedBill"
        month: string
        kwhSupplyCharge: number
        kwhCharge: number
        charges: Array<{
          __typename?: "BillSection"
          name: string
          rates: Array<{
            __typename?: "DecodedRate"
            id: number
            name: string
            chargeClass: ChargeClass
          }>
          costs: Array<
            | {
                __typename: "CostItem"
                name: string
                rateId: number
                chargeType: ChargeType
                chargeCategory?: ChargeCategory | null
                volume: number
                rate: number
                cost: number
                rateObj: {
                  __typename?: "DecodedRate"
                  id: number
                  name: string
                  chargeClass: ChargeClass
                }
              }
            | {
                __typename: "TaxItem"
                taxId: number
                subtotal: number
                cost: number
                percentage: number
              }
            | null
          >
        }>
        exports: Array<{
          __typename?: "BillSection"
          name: string
          rates: Array<{
            __typename?: "DecodedRate"
            id: number
            name: string
            chargeClass: ChargeClass
          }>
          costs: Array<
            | {
                __typename: "CostItem"
                name: string
                rateId: number
                chargeType: ChargeType
                chargeCategory?: ChargeCategory | null
                volume: number
                rate: number
                cost: number
                rateObj: {
                  __typename?: "DecodedRate"
                  id: number
                  name: string
                  chargeClass: ChargeClass
                }
              }
            | {
                __typename: "TaxItem"
                taxId: number
                subtotal: number
                cost: number
                percentage: number
              }
            | null
          >
        }>
      }>
    }
  }
}

export type BauMeterIntervalsQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type BauMeterIntervalsQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    bauMeters: Array<{
      __typename?: "BauMeter"
      id: number
      tariffUsdPerKwh: number
      rollup: Array<{
        __typename?: "DailyRollup"
        season: string
        days: Array<string>
        numbers: Array<number>
      }>
      intervals: {
        __typename?: "Zoned"
        units: Units
        year: number
        timeZone: string
        maxKw: number
        totalKwh: number
        kwh8760: Array<number>
      }
    }>
  } | null
}

export type MeterSetQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  id: Scalars["Int"]["input"]
}>

export type MeterSetQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    isMultifamily: boolean
    meterSet: {
      __typename?: "MeterSet"
      id: number
      meters: Array<{
        __typename?: "BauMeter"
        hasTruth: boolean
        id: number
        createdAt: string
        label: string
        loadOrigin: LoadOrigin
        loadCategory: LoadCategory
        meterSource: MeterSource
        underHumanControl: boolean
        tariffsUnderHumanControl: boolean
        archivedAt?: string | null
        archivedReason?: string | null
        tariffUsdPerKwh: number
        createdBy?: { __typename?: "UserRef"; email: string } | null
        utility: { __typename?: "Utility"; id: number; name: string }
        tariff: {
          __typename?: "Tariff"
          id: number
          name: string
          code: string
          masterTariffId?: number | null
        }
        tariffSetBy?: { __typename?: "UserRef"; pid: string; email: string } | null
        postSolarTariff?: {
          __typename?: "Tariff"
          id: number
          name: string
          code: string
          masterTariffId?: number | null
        } | null
        postSolarTariffSetBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
        } | null
        postBatteryTariff?: {
          __typename?: "Tariff"
          id: number
          name: string
          code: string
          masterTariffId?: number | null
        } | null
        postBatteryTariffSetBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
        } | null
        archivedBy?: { __typename?: "UserRef"; pid: string; email: string } | null
        rollup: Array<{
          __typename?: "DailyRollup"
          season: string
          days: Array<string>
          numbers: Array<number>
        }>
        intervals: {
          __typename?: "Zoned"
          units: Units
          year: number
          timeZone: string
          maxKw: number
          totalKwh: number
          kwh8760: Array<number>
        }
      }>
    }
    customTariffs: Array<{
      __typename?: "CustomTariff"
      id: number
      name: string
      code: string
      parent?: { __typename?: "Tariff"; id: number } | null
    }>
  } | null
}

export type AdminNotesQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type AdminNotesQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    notes: Array<{
      __typename?: "AdminNote"
      pid: string
      text: string
      createdAt: string
      updatedAt?: string | null
      trashedAt?: string | null
      hiddenFromCustomers: boolean
      createdBy: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      }
      updatedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      trashedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
    }>
  } | null
}

export type BatchPhysicalCheckQueryVariables = Exact<{
  orgPid: Scalars["String"]["input"]
  propertyPids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  siteFields: Array<SiteChangelogColumn> | SiteChangelogColumn
  buildingDataFields: Array<BuildingDataChangelogColumn> | BuildingDataChangelogColumn
}>

export type BatchPhysicalCheckQuery = {
  __typename?: "Query"
  org: { __typename?: "AdminOrg"; pid: string; name: string }
  sites: Array<{
    __typename?: "Site"
    pid: string
    slopedRoof?: boolean | null
    propertyName?: string | null
    numberOfBuildings?: number | null
    sqft?: number | null
    numStories?: number | null
    fullAddress: string
    roofMaxPvKw?: number | null
    computedRoofMaxPvKw: number
    explainRoofHeuristic: string
    explainSlopedHeuristic: string
    computedCarportMaxPvKw: number
    explainCarportHeuristic: string
    explainCarportParkingSpaceHeuristic: string
    computedGroundMaxPvKw?: number | null
    explainGroundHeuristic: string
    impliedCarportLinearFt?: number | null
    impliedUsableRoofSqft?: number | null
    impliedUsableRoofSqftExplanation: RoofSqftExplanation
    roofSqft?: number | null
    usableRoofPct?: number | null
    usableRoofSqft?: number | null
    setbackRoofSqft?: number | null
    roofKeepoutsSqft?: number | null
    groundAvailableSqft?: number | null
    groundMaxPvKw?: number | null
    usableCarportFt?: number | null
    numParkingSpaces?: number | null
    carportMaxPvKw?: number | null
    existingSolarDetectionScore?: number | null
    portfolio?: { __typename?: "AdminPortfolio"; name: string } | null
    changelog: {
      __typename?: "SiteChangelog"
      all: Array<{
        __typename?: "SiteChangelogColumnBaseWrapper"
        column: SiteChangelogColumn
        obj?: {
          __typename?: "Changelog"
          field?: string | null
          updatedAt?: string | null
          updatedBy?: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          } | null
        } | null
      }>
    }
    buildingData?: {
      __typename?: "BuildingData"
      changelog: {
        __typename?: "BuildingDataChangelog"
        all: Array<{
          __typename?: "BuildingDataChangelogColumnBaseWrapper"
          column: BuildingDataChangelogColumn
          obj?: {
            __typename?: "Changelog"
            field?: string | null
            updatedAt?: string | null
            updatedBy?: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            } | null
          } | null
        }>
      }
    } | null
    notes: Array<{
      __typename?: "AdminNote"
      pid: string
      text: string
      createdAt: string
      updatedAt?: string | null
      createdBy: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      }
      updatedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
    }>
    currentStatus?: {
      __typename?: "SiteStatusChange"
      pid: string
      status: SiteStatus
    } | null
    physicalCheck: { __typename?: "PhysicalCheck"; existingSolar?: boolean | null }
    footprint: {
      __typename?: "Footprint"
      latitude: number
      longitude: number
      roofShape?: any | null
      roofShapeGeojson?: any | null
      roofSetbackShape?: any | null
      roofSetbackShapeGeojson?: any | null
      keepoutsShape?: any | null
      keepoutsShapeGeojson?: any | null
      parcelShape?: any | null
      parcelShapeGeojson?: any | null
      carportShape?: any | null
      carportShapeGeojson?: any | null
      groundmountShape?: any | null
      groundmountShapeGeojson?: any | null
      bounds?: any | null
    }
  } | null>
}

export type ClosestParcelsQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type ClosestParcelsQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    closestSites: Array<{
      __typename?: "RevampSite"
      pid: string
      name?: string | null
      fullAddress: string
      footprint: {
        __typename?: "Footprint"
        latitude: number
        longitude: number
        parcelShape?: any | null
      }
    }>
  } | null
}

export type GeocodedLocationQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type GeocodedLocationQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    fullAddress: string
    footprint: {
      __typename?: "Footprint"
      geocodedLocation: {
        __typename?: "GeocodedLocation"
        latitude: number
        longitude: number
      }
    }
  } | null
}

export type ActiveResultListQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type ActiveResultListQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    activeResults: Array<{
      __typename?: "Result"
      id: number
      pid: string
      createdAt: string
      scenario: {
        __typename?: "RevampScenario"
        pid: string
        name: string
        solarLocation: SolarLocation
        loadCategory: LoadCategory
        includeStorage: boolean
      }
      financing: {
        __typename?: "RevampFinancing"
        id: number
        name: string
        type: FinProductType
        financierName: string
        financierPid: string
        financierLogo?: string | null
        financierLogomark?: string | null
        isThirdParty: boolean
        status: FinProductStatus
      }
      result?:
        | {
            __typename: "PhysicalCheck"
            createdAt: string
            roofIsGood: boolean
            carportIsGood: boolean
            existingSolar?: boolean | null
            badRoof?: boolean | null
            groundmountIsGood: boolean
          }
        | {
            __typename: "PolicyCheck"
            createdAt: string
            productType?: FinProductType | null
            isGood: boolean
            disqualReason?: PolicyReason | null
          }
        | {
            __typename: "RevampCS"
            id: number
            termYears: number
            createdAt: string
            goal?: PVoptGoal | null
            systems: Array<
              | {
                  __typename: "BatterySystem"
                  vendor: BatteryVendor
                  sizeKw: number
                  sizeKwh: number
                  assumptions: { __typename?: "BattAssumptions"; battChemName: string }
                }
              | { __typename: "PVSystem"; type: PvType; sizeKw: number }
            >
            financing: {
              __typename?: "RevampFinancing"
              id: number
              name: string
              type: FinProductType
              financierName: string
              financierPid: string
              financierLogo?: string | null
              financierLogomark?: string | null
              isThirdParty: boolean
            }
            buildingOwner: {
              __typename?: "BuildingOwnerEconomics"
              noiYearOne?: number | null
              noiLifetime?: number | null
              noiAnnual?: number | null
            }
            roofRent?: {
              __typename?: "RoofRentEconomics"
              lifetimeUsd: number
              annualUsd: number
              usdPerSqft: number
              npv: number
              discountRate: number
              roofRentPerYear: Array<number>
            } | null
            pricing: {
              __typename?: "CSPrice"
              usdPerKwPerYear: number
              escalator: number
              minPvKw: number
              maxPvKw: number
              utility: { __typename?: "RevampUtility"; id: number; name: string }
            }
            leaseProjections?: {
              __typename?: "CSLeaseProjections"
              systemSizeKw: number
              annualRentLowerRangeUsd: number
              annualRentUpperRangeUsd: number
              methodology: CsLeaseProjectionMethdology
            } | null
          }
        | {
            __typename: "RevampFinmodel"
            id: number
            pid: string
            createdAt: string
            type: FinProductType
            intervalsAndCostsXlsxHref: string
            buildingOwnerXlsxHref?: string | null
            offerStatus: OfferStatus
            fmvStr: string
            totalPvProductionKwh: number
            totalPvExportKwh?: number | null
            bauCostPerYear: Array<number>
            derCostPerYear: Array<number>
            goal?: PVoptGoal | null
            isVnem: boolean
            isGreenLease: boolean
            moreDetails?: {
              __typename?: "MoreDetails"
              pvCostPerWatt?: number | null
              storageCostPerKwh?: number | null
              totalInstallCost?: number | null
            } | null
            thirdPartySupplier?: {
              __typename?: "ThirdPartySupplier"
              pid: string
              name: string
            } | null
            buildingOwner: {
              __typename?: "BuildingOwnerEconomics"
              noiYearOne?: number | null
              noiLifetime?: number | null
              noiAnnual?: number | null
            }
            ppa?: {
              __typename: "PPAEconomics"
              ppaType: PpaProductType
              ppaCostPerKwh: number
              ppaTermYears: number
              ppaEsc?: number | null
              srecToInvestor: boolean
              offtakerXlsxHref: string
              product: {
                __typename?: "PPAFinProduct"
                productName: string
                financierName: string
              }
              roofRent?: {
                __typename?: "RoofRentEconomics"
                lifetimeUsd: number
                annualUsd: number
                usdPerSqft: number
                roofRentPerYear: Array<number>
              } | null
              tenantFlows?: {
                __typename?: "TenantCashflows"
                npv: number
                discountRate: number
                totalUtilitySavings: number
                totalCapex: number
                totalOpex: number
                totalNet: number
                netCashflowPerYear: Array<number>
              } | null
            } | null
            loan?: {
              __typename: "LoanEconomics"
              loanRecvrXlsxHref: string
              loanTermYears: number
              ownershipTermYears: number
              interestPct: number
              srecToInvestor: boolean
              product: {
                __typename?: "LoanFinProduct"
                productName: string
                financierName: string
                loanDealerFeePct: number
              }
              flows?: {
                __typename?: "LoanRecvrCashflows"
                monthlyPayment: number
                totalRevenue: number
                totalUtilitySavings: number
                totalOpex: number
                totalCapex: number
                totalItc: number
                totalLoanFunding: number
                totalLoanPayments: number
                totalNet: number
                netCashflowPerYear: Array<number>
                greenLeaseTenantFlows?: {
                  __typename?: "TenantCashflows"
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  totalCapex: number
                  totalOpex: number
                  totalUtilitySavings: number
                  npv: number
                  discountRate: number
                } | null
              } | null
            } | null
            selfInvest?: {
              __typename: "SelfInvestEconomics"
              npv: number
              discountRate: number
              selfInvestXlsxHref: string
              termYears: number
              srecToInvestor: boolean
              irrs: {
                __typename?: "IRRs"
                postTaxItcDepr?: number | null
                postTaxItcDeprMultiple?: number | null
              }
              product: {
                __typename?: "SelfInvestFinProduct"
                productName: string
                financierName: string
              }
              flows?: {
                __typename?: "SelfInvestCashflows"
                totalRevenue: number
                totalUtilitySavings: number
                totalOpex: number
                totalCapex: number
                totalItc: number
                totalNet: number
                netCashflowPerYear: Array<number>
                greenLeaseTenantFlows?: {
                  __typename?: "TenantCashflows"
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  totalCapex: number
                  totalOpex: number
                  totalUtilitySavings: number
                  npv: number
                  discountRate: number
                } | null
              } | null
            } | null
            meters: Array<{
              __typename?: "RevampMeter"
              name: string
              loadCategory: LoadCategory
              meterSource: MeterSource
              bau: {
                __typename?: "RevampDer"
                totalKwhFlow: {
                  __typename?: "KwhFlow"
                  bauLoadKwh: number
                  importsKwh: number
                  exportsKwh: number
                  pvProductionKwh: number
                  pvToLoadKwh: number
                  batteryChargeKwh: number
                  batteryDischargeKwh: number
                }
              }
              der?: {
                __typename?: "RevampDer"
                totalKwhFlow: {
                  __typename?: "KwhFlow"
                  bauLoadKwh: number
                  importsKwh: number
                  exportsKwh: number
                  pvProductionKwh: number
                  pvToLoadKwh: number
                  batteryChargeKwh: number
                  batteryDischargeKwh: number
                }
                averageDayKwhFlow: Array<{
                  __typename?: "KwhFlow"
                  bauLoadKwh: number
                  importsKwh: number
                  exportsKwh: number
                  pvProductionKwh: number
                  pvToLoadKwh: number
                  batteryChargeKwh: number
                  batteryDischargeKwh: number
                }>
              } | null
            }>
            systems: Array<
              | {
                  __typename: "BatterySystem"
                  vendor: BatteryVendor
                  sizeKw: number
                  sizeKwh: number
                  assumptions: { __typename?: "BattAssumptions"; battChemName: string }
                }
              | { __typename: "PVSystem"; type: PvType; sizeKw: number }
            >
            utilityCosts: {
              __typename?: "UtilityCost"
              bau: {
                __typename?: "FinmodelCost"
                totalKwh: number
                totalCostUsd: number
                usdPerKwh: number
                items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                tariffs: Array<{
                  __typename?: "RevampTariff"
                  id: number
                  name: string
                  code: string
                  startDate: string
                  endDate?: string | null
                  utility: {
                    __typename?: "RevampUtility"
                    id: number
                    name: string
                    shortName: string
                  }
                }>
              }
              der: {
                __typename?: "FinmodelCost"
                totalKwh: number
                totalCostUsd: number
                usdPerKwh: number
                items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                tariffs: Array<{
                  __typename?: "RevampTariff"
                  id: number
                  name: string
                  code: string
                  startDate: string
                  endDate?: string | null
                  utility: {
                    __typename?: "RevampUtility"
                    id: number
                    name: string
                    shortName: string
                  }
                }>
              }
            }
          }
        | {
            __typename: "RevampFinmodelFailure"
            id: number
            createdAt: string
            fmvStr: string
            details: {
              __typename?: "FailureDetails"
              label: string
              description: string
            }
          }
        | {
            __typename: "Viability"
            isAllowed: boolean
            reason?: ViabilityReason | null
            level: ViabilityLevel
            viabilityType: ViabilityType
          }
        | null
      helioscope?: {
        __typename?: "Helioscope"
        pid: string
        roofPvKw: number
        carportPvKw: number
        groundPvKw: number
        systemProductivityKwhPerKw?: number | null
        roofImageHref: string
        pdfHref: string
        dcNameplateKw?: number | null
        acNameplateKw?: number | null
        loadRatio?: number | null
        moduleType?: string | null
        inverterType?: string | null
        rackingTiltDegrees?: number | null
        rackingManufacturer?: string | null
        rackingConnectionType?: ConnectionType | null
        notes?: string | null
        roofImage: {
          __typename?: "Attachment"
          id: number
          name: string
          downloadHref: string
        }
        pdf: {
          __typename?: "Attachment"
          downloadHref: string
          contentType: string
          name: string
          id: number
        }
      } | null
    }>
  } | null
}

export type ResultDetailQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  id: Scalars["Int"]["input"]
}>

export type ResultDetailQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    result: {
      __typename?: "Result"
      id: number
      pid: string
      createdAt: string
      salesPdfReportHref?: string | null
      scenario: {
        __typename?: "RevampScenario"
        pid: string
        name: string
        solarLocation: SolarLocation
        loadCategory: LoadCategory
        includeStorage: boolean
      }
      financing: {
        __typename?: "RevampFinancing"
        id: number
        name: string
        type: FinProductType
        financierName: string
        financierPid: string
        financierLogo?: string | null
        financierLogomark?: string | null
        isThirdParty: boolean
        status: FinProductStatus
      }
      result?:
        | {
            __typename: "PhysicalCheck"
            createdAt: string
            roofIsGood: boolean
            carportIsGood: boolean
            existingSolar?: boolean | null
            badRoof?: boolean | null
            groundmountIsGood: boolean
          }
        | {
            __typename: "PolicyCheck"
            createdAt: string
            productType?: FinProductType | null
            isGood: boolean
            disqualReason?: PolicyReason | null
          }
        | {
            __typename: "RevampCS"
            id: number
            termYears: number
            createdAt: string
            goal?: PVoptGoal | null
            systems: Array<
              | {
                  __typename: "BatterySystem"
                  vendor: BatteryVendor
                  sizeKw: number
                  sizeKwh: number
                  assumptions: { __typename?: "BattAssumptions"; battChemName: string }
                }
              | { __typename: "PVSystem"; type: PvType; sizeKw: number }
            >
            financing: {
              __typename?: "RevampFinancing"
              id: number
              name: string
              type: FinProductType
              financierName: string
              financierPid: string
              financierLogo?: string | null
              financierLogomark?: string | null
              isThirdParty: boolean
            }
            buildingOwner: {
              __typename?: "BuildingOwnerEconomics"
              noiYearOne?: number | null
              noiLifetime?: number | null
              noiAnnual?: number | null
            }
            roofRent?: {
              __typename?: "RoofRentEconomics"
              lifetimeUsd: number
              annualUsd: number
              usdPerSqft: number
              npv: number
              discountRate: number
              roofRentPerYear: Array<number>
            } | null
            pricing: {
              __typename?: "CSPrice"
              usdPerKwPerYear: number
              escalator: number
              minPvKw: number
              maxPvKw: number
              utility: { __typename?: "RevampUtility"; id: number; name: string }
            }
            leaseProjections?: {
              __typename?: "CSLeaseProjections"
              systemSizeKw: number
              annualRentLowerRangeUsd: number
              annualRentUpperRangeUsd: number
              methodology: CsLeaseProjectionMethdology
            } | null
          }
        | {
            __typename: "RevampFinmodel"
            id: number
            pid: string
            createdAt: string
            type: FinProductType
            intervalsAndCostsXlsxHref: string
            buildingOwnerXlsxHref?: string | null
            offerStatus: OfferStatus
            fmvStr: string
            totalPvProductionKwh: number
            totalPvExportKwh?: number | null
            bauCostPerYear: Array<number>
            derCostPerYear: Array<number>
            goal?: PVoptGoal | null
            isVnem: boolean
            isGreenLease: boolean
            iterations: Array<{
              __typename?: "RevampIteration"
              cashPurchaseNpv: number
              pvKw: number
              marginalCo2Averted?: number | null
              storagePvKw?: number | null
              storagePvKwh?: number | null
            }>
            meters: Array<{
              __typename?: "RevampMeter"
              loadCategory: LoadCategory
              meterSource: MeterSource
              name: string
              bau: {
                __typename?: "RevampDer"
                totalKwhFlow: {
                  __typename?: "KwhFlow"
                  bauLoadKwh: number
                  importsKwh: number
                  exportsKwh: number
                  pvProductionKwh: number
                  pvToLoadKwh: number
                  batteryChargeKwh: number
                  batteryDischargeKwh: number
                }
              }
              der?: {
                __typename?: "RevampDer"
                totalKwhFlow: {
                  __typename?: "KwhFlow"
                  bauLoadKwh: number
                  importsKwh: number
                  exportsKwh: number
                  pvProductionKwh: number
                  pvToLoadKwh: number
                  batteryChargeKwh: number
                  batteryDischargeKwh: number
                }
                averageDayKwhFlow: Array<{
                  __typename?: "KwhFlow"
                  bauLoadKwh: number
                  importsKwh: number
                  exportsKwh: number
                  pvProductionKwh: number
                  pvToLoadKwh: number
                  batteryChargeKwh: number
                  batteryDischargeKwh: number
                }>
              } | null
            }>
            emissions?: {
              __typename?: "RevampEmissions"
              bauCo2Tons: number
              derCo2Tons: number
              bauAverageDayCo2Tons: Array<number>
              derAverageDayCo2Tons: Array<number>
            } | null
            thirdPartySupplier?: {
              __typename?: "ThirdPartySupplier"
              pid: string
              name: string
            } | null
            buildingOwner: {
              __typename?: "BuildingOwnerEconomics"
              noiYearOne?: number | null
              noiLifetime?: number | null
              noiAnnual?: number | null
            }
            ppa?: {
              __typename: "PPAEconomics"
              ppaType: PpaProductType
              ppaCostPerKwh: number
              ppaTermYears: number
              ppaEsc?: number | null
              srecToInvestor: boolean
              offtakerXlsxHref: string
              product: {
                __typename?: "PPAFinProduct"
                productName: string
                financierName: string
              }
              roofRent?: {
                __typename?: "RoofRentEconomics"
                lifetimeUsd: number
                annualUsd: number
                usdPerSqft: number
                roofRentPerYear: Array<number>
              } | null
              tenantFlows?: {
                __typename?: "TenantCashflows"
                npv: number
                discountRate: number
                totalUtilitySavings: number
                totalCapex: number
                totalOpex: number
                totalNet: number
                netCashflowPerYear: Array<number>
              } | null
            } | null
            loan?: {
              __typename: "LoanEconomics"
              loanRecvrXlsxHref: string
              loanTermYears: number
              ownershipTermYears: number
              interestPct: number
              srecToInvestor: boolean
              product: {
                __typename?: "LoanFinProduct"
                productName: string
                financierName: string
                loanDealerFeePct: number
              }
              flows?: {
                __typename?: "LoanRecvrCashflows"
                monthlyPayment: number
                totalRevenue: number
                totalUtilitySavings: number
                totalOpex: number
                totalCapex: number
                totalItc: number
                totalLoanFunding: number
                totalLoanPayments: number
                totalNet: number
                netCashflowPerYear: Array<number>
                greenLeaseTenantFlows?: {
                  __typename?: "TenantCashflows"
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  totalCapex: number
                  totalOpex: number
                  totalUtilitySavings: number
                  npv: number
                  discountRate: number
                } | null
              } | null
            } | null
            selfInvest?: {
              __typename: "SelfInvestEconomics"
              npv: number
              discountRate: number
              selfInvestXlsxHref: string
              termYears: number
              srecToInvestor: boolean
              irrs: {
                __typename?: "IRRs"
                postTaxItcDepr?: number | null
                postTaxItcDeprMultiple?: number | null
              }
              product: {
                __typename?: "SelfInvestFinProduct"
                productName: string
                financierName: string
              }
              flows?: {
                __typename?: "SelfInvestCashflows"
                totalRevenue: number
                totalUtilitySavings: number
                totalOpex: number
                totalCapex: number
                totalItc: number
                totalNet: number
                netCashflowPerYear: Array<number>
                greenLeaseTenantFlows?: {
                  __typename?: "TenantCashflows"
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  totalCapex: number
                  totalOpex: number
                  totalUtilitySavings: number
                  npv: number
                  discountRate: number
                } | null
              } | null
            } | null
            systems: Array<
              | {
                  __typename: "BatterySystem"
                  vendor: BatteryVendor
                  sizeKw: number
                  sizeKwh: number
                  assumptions: { __typename?: "BattAssumptions"; battChemName: string }
                }
              | { __typename: "PVSystem"; type: PvType; sizeKw: number }
            >
            utilityCosts: {
              __typename?: "UtilityCost"
              bau: {
                __typename?: "FinmodelCost"
                totalKwh: number
                totalCostUsd: number
                usdPerKwh: number
                items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                tariffs: Array<{
                  __typename?: "RevampTariff"
                  id: number
                  name: string
                  code: string
                  startDate: string
                  endDate?: string | null
                  utility: {
                    __typename?: "RevampUtility"
                    id: number
                    name: string
                    shortName: string
                  }
                }>
              }
              der: {
                __typename?: "FinmodelCost"
                totalKwh: number
                totalCostUsd: number
                usdPerKwh: number
                items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                tariffs: Array<{
                  __typename?: "RevampTariff"
                  id: number
                  name: string
                  code: string
                  startDate: string
                  endDate?: string | null
                  utility: {
                    __typename?: "RevampUtility"
                    id: number
                    name: string
                    shortName: string
                  }
                }>
              }
            }
          }
        | {
            __typename: "RevampFinmodelFailure"
            id: number
            createdAt: string
            fmvStr: string
            details: {
              __typename?: "FailureDetails"
              label: string
              description: string
            }
          }
        | {
            __typename: "Viability"
            isAllowed: boolean
            reason?: ViabilityReason | null
            level: ViabilityLevel
            viabilityType: ViabilityType
          }
        | null
      helioscope?: {
        __typename?: "Helioscope"
        pid: string
        roofPvKw: number
        carportPvKw: number
        groundPvKw: number
        systemProductivityKwhPerKw?: number | null
        roofImageHref: string
        pdfHref: string
        dcNameplateKw?: number | null
        acNameplateKw?: number | null
        loadRatio?: number | null
        moduleType?: string | null
        inverterType?: string | null
        rackingTiltDegrees?: number | null
        rackingManufacturer?: string | null
        rackingConnectionType?: ConnectionType | null
        notes?: string | null
        roofImage: {
          __typename?: "Attachment"
          id: number
          name: string
          downloadHref: string
        }
        pdf: {
          __typename?: "Attachment"
          downloadHref: string
          contentType: string
          name: string
          id: number
        }
      } | null
    }
  } | null
}

export type ResultTableQueryVariables = Exact<{
  slug: Scalars["String"]["input"]
  filterBy?: InputMaybe<ResultTableFilter>
  sortBy?: InputMaybe<Array<ResultTableSort> | ResultTableSort>
}>

export type ResultTableQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "AdminOrg"
    resultTable: {
      __typename?: "ResultTable"
      view: { __typename?: "ResultTableView"; keys: Array<number> }
    }
  } | null
}

export type ResultTableRowsQueryVariables = Exact<{
  slug: Scalars["String"]["input"]
  ids: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
}>

export type ResultTableRowsQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "AdminOrg"
    resultTable: {
      __typename?: "ResultTable"
      rows: Array<{
        __typename?: "ResultTableRow"
        id: number
        createdAt: string
        sitePid: string
        siteName?: string | null
        siteStreetAddress: string
        siteCity: string
        siteState: string
        siteStatus: SiteStatus
        siteHiddenFromCustomers: boolean
        scenarioPid: string
        scenarioName: string
        scenarioSolarLocation: SolarLocation
        scenarioIncludeStorage: boolean
        finproductType: FinProductType
        financierName: string
        financierPid: string
        finmodelId?: number | null
        finmodelFmv?: string | null
        finmodelNoi?: number | null
        failureId?: number | null
        failureFmv?: string | null
        failureName?: string | null
        failureMessage?: string | null
        policyCheckIsGood?: boolean | null
        physicalCheckRoofIsGood?: boolean | null
        physicalCheckCarportIsGood?: boolean | null
        physicalCheckGroundmountIsGood?: boolean | null
      }>
    }
  } | null
}

export type FinmodelTableQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  filterBy?: InputMaybe<FinmodelTableFilter>
  sortBy?: InputMaybe<Array<FinmodelTableSort> | FinmodelTableSort>
}>

export type FinmodelTableQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    finmodelTable: {
      __typename?: "FinmodelTable"
      view: { __typename?: "FinmodelTableView"; keys: Array<number> }
    }
  } | null
}

export type FinmodelTableRowsQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  ids: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
}>

export type FinmodelTableRowsQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    finmodelTable: {
      __typename?: "FinmodelTable"
      rows: Array<{
        __typename?: "FinmodelTableRow"
        id: number
        createdAt: string
        name: string
        fmvStr: string
        type: FinProductType
        buildingOwnerNoiLifetimeUsd: number
        scenarioPid: string
        scenarioName: string
        scenarioSolarLocation: SolarLocation
        scenarioIncludeStorage: boolean
      }>
    }
  } | null
}

export type AdminFinmodelDetailFragment = {
  __typename: "RevampFinmodel"
  importReductionPct: number
  id: number
  pid: string
  createdAt: string
  type: FinProductType
  intervalsAndCostsXlsxHref: string
  buildingOwnerXlsxHref?: string | null
  offerStatus: OfferStatus
  fmvStr: string
  totalPvProductionKwh: number
  totalPvExportKwh?: number | null
  bauCostPerYear: Array<number>
  derCostPerYear: Array<number>
  goal?: PVoptGoal | null
  isVnem: boolean
  isGreenLease: boolean
  financing: {
    __typename?: "RevampFinancing"
    id: number
    name: string
    type: FinProductType
    financierName: string
    financierPid: string
    isThirdParty: boolean
    status: FinProductStatus
  }
  scenario: {
    __typename?: "RevampScenario"
    pid: string
    name: string
    loadCategory: LoadCategory
    includeStorage: boolean
    solarLocation: SolarLocation
  }
  investorDetails?: {
    __typename?: "InvestorDetails"
    investorXlsxHref: string
    irrs: {
      __typename?: "IRRs"
      preTax?: number | null
      postTaxItcDepr?: number | null
    }
  } | null
  moreDetails?: {
    __typename?: "MoreDetails"
    cashPurchaseNpv: number
    totalInstallCost?: number | null
    pvCostPerWatt?: number | null
    finmodelInputs: any
    finmodelOutputs: any
    luxId?: number | null
    failureId?: number | null
  } | null
  thirdPartySupplier?: {
    __typename?: "ThirdPartySupplier"
    pid: string
    name: string
  } | null
  buildingOwner: {
    __typename?: "BuildingOwnerEconomics"
    noiYearOne?: number | null
    noiLifetime?: number | null
    noiAnnual?: number | null
  }
  ppa?: {
    __typename: "PPAEconomics"
    ppaType: PpaProductType
    ppaCostPerKwh: number
    ppaTermYears: number
    ppaEsc?: number | null
    srecToInvestor: boolean
    offtakerXlsxHref: string
    product: {
      __typename?: "PPAFinProduct"
      productName: string
      financierName: string
    }
    roofRent?: {
      __typename?: "RoofRentEconomics"
      lifetimeUsd: number
      annualUsd: number
      usdPerSqft: number
      roofRentPerYear: Array<number>
    } | null
    tenantFlows?: {
      __typename?: "TenantCashflows"
      npv: number
      discountRate: number
      totalUtilitySavings: number
      totalCapex: number
      totalOpex: number
      totalNet: number
      netCashflowPerYear: Array<number>
    } | null
  } | null
  loan?: {
    __typename: "LoanEconomics"
    loanRecvrXlsxHref: string
    loanTermYears: number
    ownershipTermYears: number
    interestPct: number
    srecToInvestor: boolean
    product: {
      __typename?: "LoanFinProduct"
      productName: string
      financierName: string
      loanDealerFeePct: number
    }
    flows?: {
      __typename?: "LoanRecvrCashflows"
      monthlyPayment: number
      totalRevenue: number
      totalUtilitySavings: number
      totalOpex: number
      totalCapex: number
      totalItc: number
      totalLoanFunding: number
      totalLoanPayments: number
      totalNet: number
      netCashflowPerYear: Array<number>
      greenLeaseTenantFlows?: {
        __typename?: "TenantCashflows"
        totalNet: number
        netCashflowPerYear: Array<number>
        totalCapex: number
        totalOpex: number
        totalUtilitySavings: number
        npv: number
        discountRate: number
      } | null
    } | null
  } | null
  selfInvest?: {
    __typename: "SelfInvestEconomics"
    npv: number
    discountRate: number
    selfInvestXlsxHref: string
    termYears: number
    srecToInvestor: boolean
    irrs: {
      __typename?: "IRRs"
      postTaxItcDepr?: number | null
      postTaxItcDeprMultiple?: number | null
    }
    product: {
      __typename?: "SelfInvestFinProduct"
      productName: string
      financierName: string
    }
    flows?: {
      __typename?: "SelfInvestCashflows"
      totalRevenue: number
      totalUtilitySavings: number
      totalOpex: number
      totalCapex: number
      totalItc: number
      totalNet: number
      netCashflowPerYear: Array<number>
      greenLeaseTenantFlows?: {
        __typename?: "TenantCashflows"
        totalNet: number
        netCashflowPerYear: Array<number>
        totalCapex: number
        totalOpex: number
        totalUtilitySavings: number
        npv: number
        discountRate: number
      } | null
    } | null
  } | null
  meters: Array<{
    __typename?: "RevampMeter"
    name: string
    loadCategory: LoadCategory
    meterSource: MeterSource
    bau: {
      __typename?: "RevampDer"
      totalKwhFlow: {
        __typename?: "KwhFlow"
        bauLoadKwh: number
        importsKwh: number
        exportsKwh: number
        pvProductionKwh: number
        pvToLoadKwh: number
        batteryChargeKwh: number
        batteryDischargeKwh: number
      }
    }
    der?: {
      __typename?: "RevampDer"
      totalKwhFlow: {
        __typename?: "KwhFlow"
        bauLoadKwh: number
        importsKwh: number
        exportsKwh: number
        pvProductionKwh: number
        pvToLoadKwh: number
        batteryChargeKwh: number
        batteryDischargeKwh: number
      }
      averageDayKwhFlow: Array<{
        __typename?: "KwhFlow"
        bauLoadKwh: number
        importsKwh: number
        exportsKwh: number
        pvProductionKwh: number
        pvToLoadKwh: number
        batteryChargeKwh: number
        batteryDischargeKwh: number
      }>
    } | null
  }>
  systems: Array<
    | {
        __typename: "BatterySystem"
        vendor: BatteryVendor
        sizeKw: number
        sizeKwh: number
        assumptions: { __typename?: "BattAssumptions"; battChemName: string }
      }
    | { __typename: "PVSystem"; type: PvType; sizeKw: number }
  >
  utilityCosts: {
    __typename?: "UtilityCost"
    bau: {
      __typename?: "FinmodelCost"
      totalKwh: number
      totalCostUsd: number
      usdPerKwh: number
      items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
      tariffs: Array<{
        __typename?: "RevampTariff"
        id: number
        name: string
        code: string
        startDate: string
        endDate?: string | null
        utility: {
          __typename?: "RevampUtility"
          id: number
          name: string
          shortName: string
        }
      }>
    }
    der: {
      __typename?: "FinmodelCost"
      totalKwh: number
      totalCostUsd: number
      usdPerKwh: number
      items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
      tariffs: Array<{
        __typename?: "RevampTariff"
        id: number
        name: string
        code: string
        startDate: string
        endDate?: string | null
        utility: {
          __typename?: "RevampUtility"
          id: number
          name: string
          shortName: string
        }
      }>
    }
  }
}

export type FinmodelDetail2QueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  id: Scalars["Int"]["input"]
}>

export type FinmodelDetail2Query = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    finmodel: {
      __typename: "RevampFinmodel"
      importReductionPct: number
      id: number
      pid: string
      createdAt: string
      type: FinProductType
      intervalsAndCostsXlsxHref: string
      buildingOwnerXlsxHref?: string | null
      offerStatus: OfferStatus
      fmvStr: string
      totalPvProductionKwh: number
      totalPvExportKwh?: number | null
      bauCostPerYear: Array<number>
      derCostPerYear: Array<number>
      goal?: PVoptGoal | null
      isVnem: boolean
      isGreenLease: boolean
      financing: {
        __typename?: "RevampFinancing"
        id: number
        name: string
        type: FinProductType
        financierName: string
        financierPid: string
        isThirdParty: boolean
        status: FinProductStatus
      }
      scenario: {
        __typename?: "RevampScenario"
        pid: string
        name: string
        loadCategory: LoadCategory
        includeStorage: boolean
        solarLocation: SolarLocation
      }
      investorDetails?: {
        __typename?: "InvestorDetails"
        investorXlsxHref: string
        irrs: {
          __typename?: "IRRs"
          preTax?: number | null
          postTaxItcDepr?: number | null
        }
      } | null
      moreDetails?: {
        __typename?: "MoreDetails"
        cashPurchaseNpv: number
        totalInstallCost?: number | null
        pvCostPerWatt?: number | null
        finmodelInputs: any
        finmodelOutputs: any
        luxId?: number | null
        failureId?: number | null
      } | null
      thirdPartySupplier?: {
        __typename?: "ThirdPartySupplier"
        pid: string
        name: string
      } | null
      buildingOwner: {
        __typename?: "BuildingOwnerEconomics"
        noiYearOne?: number | null
        noiLifetime?: number | null
        noiAnnual?: number | null
      }
      ppa?: {
        __typename: "PPAEconomics"
        ppaType: PpaProductType
        ppaCostPerKwh: number
        ppaTermYears: number
        ppaEsc?: number | null
        srecToInvestor: boolean
        offtakerXlsxHref: string
        product: {
          __typename?: "PPAFinProduct"
          productName: string
          financierName: string
        }
        roofRent?: {
          __typename?: "RoofRentEconomics"
          lifetimeUsd: number
          annualUsd: number
          usdPerSqft: number
          roofRentPerYear: Array<number>
        } | null
        tenantFlows?: {
          __typename?: "TenantCashflows"
          npv: number
          discountRate: number
          totalUtilitySavings: number
          totalCapex: number
          totalOpex: number
          totalNet: number
          netCashflowPerYear: Array<number>
        } | null
      } | null
      loan?: {
        __typename: "LoanEconomics"
        loanRecvrXlsxHref: string
        loanTermYears: number
        ownershipTermYears: number
        interestPct: number
        srecToInvestor: boolean
        product: {
          __typename?: "LoanFinProduct"
          productName: string
          financierName: string
          loanDealerFeePct: number
        }
        flows?: {
          __typename?: "LoanRecvrCashflows"
          monthlyPayment: number
          totalRevenue: number
          totalUtilitySavings: number
          totalOpex: number
          totalCapex: number
          totalItc: number
          totalLoanFunding: number
          totalLoanPayments: number
          totalNet: number
          netCashflowPerYear: Array<number>
          greenLeaseTenantFlows?: {
            __typename?: "TenantCashflows"
            totalNet: number
            netCashflowPerYear: Array<number>
            totalCapex: number
            totalOpex: number
            totalUtilitySavings: number
            npv: number
            discountRate: number
          } | null
        } | null
      } | null
      selfInvest?: {
        __typename: "SelfInvestEconomics"
        npv: number
        discountRate: number
        selfInvestXlsxHref: string
        termYears: number
        srecToInvestor: boolean
        irrs: {
          __typename?: "IRRs"
          postTaxItcDepr?: number | null
          postTaxItcDeprMultiple?: number | null
        }
        product: {
          __typename?: "SelfInvestFinProduct"
          productName: string
          financierName: string
        }
        flows?: {
          __typename?: "SelfInvestCashflows"
          totalRevenue: number
          totalUtilitySavings: number
          totalOpex: number
          totalCapex: number
          totalItc: number
          totalNet: number
          netCashflowPerYear: Array<number>
          greenLeaseTenantFlows?: {
            __typename?: "TenantCashflows"
            totalNet: number
            netCashflowPerYear: Array<number>
            totalCapex: number
            totalOpex: number
            totalUtilitySavings: number
            npv: number
            discountRate: number
          } | null
        } | null
      } | null
      meters: Array<{
        __typename?: "RevampMeter"
        name: string
        loadCategory: LoadCategory
        meterSource: MeterSource
        bau: {
          __typename?: "RevampDer"
          totalKwhFlow: {
            __typename?: "KwhFlow"
            bauLoadKwh: number
            importsKwh: number
            exportsKwh: number
            pvProductionKwh: number
            pvToLoadKwh: number
            batteryChargeKwh: number
            batteryDischargeKwh: number
          }
        }
        der?: {
          __typename?: "RevampDer"
          totalKwhFlow: {
            __typename?: "KwhFlow"
            bauLoadKwh: number
            importsKwh: number
            exportsKwh: number
            pvProductionKwh: number
            pvToLoadKwh: number
            batteryChargeKwh: number
            batteryDischargeKwh: number
          }
          averageDayKwhFlow: Array<{
            __typename?: "KwhFlow"
            bauLoadKwh: number
            importsKwh: number
            exportsKwh: number
            pvProductionKwh: number
            pvToLoadKwh: number
            batteryChargeKwh: number
            batteryDischargeKwh: number
          }>
        } | null
      }>
      systems: Array<
        | {
            __typename: "BatterySystem"
            vendor: BatteryVendor
            sizeKw: number
            sizeKwh: number
            assumptions: { __typename?: "BattAssumptions"; battChemName: string }
          }
        | { __typename: "PVSystem"; type: PvType; sizeKw: number }
      >
      utilityCosts: {
        __typename?: "UtilityCost"
        bau: {
          __typename?: "FinmodelCost"
          totalKwh: number
          totalCostUsd: number
          usdPerKwh: number
          items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
          tariffs: Array<{
            __typename?: "RevampTariff"
            id: number
            name: string
            code: string
            startDate: string
            endDate?: string | null
            utility: {
              __typename?: "RevampUtility"
              id: number
              name: string
              shortName: string
            }
          }>
        }
        der: {
          __typename?: "FinmodelCost"
          totalKwh: number
          totalCostUsd: number
          usdPerKwh: number
          items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
          tariffs: Array<{
            __typename?: "RevampTariff"
            id: number
            name: string
            code: string
            startDate: string
            endDate?: string | null
            utility: {
              __typename?: "RevampUtility"
              id: number
              name: string
              shortName: string
            }
          }>
        }
      }
    }
  } | null
}

export type FinmodelLineageQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  id: Scalars["Int"]["input"]
}>

export type FinmodelLineageQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    finmodel: {
      __typename?: "RevampFinmodel"
      id: number
      moreDetails?: {
        __typename?: "MoreDetails"
        lineage: Array<{
          __typename: "RevampFinmodel"
          importReductionPct: number
          id: number
          pid: string
          createdAt: string
          type: FinProductType
          intervalsAndCostsXlsxHref: string
          buildingOwnerXlsxHref?: string | null
          offerStatus: OfferStatus
          fmvStr: string
          totalPvProductionKwh: number
          totalPvExportKwh?: number | null
          bauCostPerYear: Array<number>
          derCostPerYear: Array<number>
          goal?: PVoptGoal | null
          isVnem: boolean
          isGreenLease: boolean
          financing: {
            __typename?: "RevampFinancing"
            id: number
            name: string
            type: FinProductType
            financierName: string
            financierPid: string
            isThirdParty: boolean
            status: FinProductStatus
          }
          scenario: {
            __typename?: "RevampScenario"
            pid: string
            name: string
            loadCategory: LoadCategory
            includeStorage: boolean
            solarLocation: SolarLocation
          }
          investorDetails?: {
            __typename?: "InvestorDetails"
            investorXlsxHref: string
            irrs: {
              __typename?: "IRRs"
              preTax?: number | null
              postTaxItcDepr?: number | null
            }
          } | null
          moreDetails?: {
            __typename?: "MoreDetails"
            cashPurchaseNpv: number
            totalInstallCost?: number | null
            pvCostPerWatt?: number | null
            finmodelInputs: any
            finmodelOutputs: any
            luxId?: number | null
            failureId?: number | null
          } | null
          thirdPartySupplier?: {
            __typename?: "ThirdPartySupplier"
            pid: string
            name: string
          } | null
          buildingOwner: {
            __typename?: "BuildingOwnerEconomics"
            noiYearOne?: number | null
            noiLifetime?: number | null
            noiAnnual?: number | null
          }
          ppa?: {
            __typename: "PPAEconomics"
            ppaType: PpaProductType
            ppaCostPerKwh: number
            ppaTermYears: number
            ppaEsc?: number | null
            srecToInvestor: boolean
            offtakerXlsxHref: string
            product: {
              __typename?: "PPAFinProduct"
              productName: string
              financierName: string
            }
            roofRent?: {
              __typename?: "RoofRentEconomics"
              lifetimeUsd: number
              annualUsd: number
              usdPerSqft: number
              roofRentPerYear: Array<number>
            } | null
            tenantFlows?: {
              __typename?: "TenantCashflows"
              npv: number
              discountRate: number
              totalUtilitySavings: number
              totalCapex: number
              totalOpex: number
              totalNet: number
              netCashflowPerYear: Array<number>
            } | null
          } | null
          loan?: {
            __typename: "LoanEconomics"
            loanRecvrXlsxHref: string
            loanTermYears: number
            ownershipTermYears: number
            interestPct: number
            srecToInvestor: boolean
            product: {
              __typename?: "LoanFinProduct"
              productName: string
              financierName: string
              loanDealerFeePct: number
            }
            flows?: {
              __typename?: "LoanRecvrCashflows"
              monthlyPayment: number
              totalRevenue: number
              totalUtilitySavings: number
              totalOpex: number
              totalCapex: number
              totalItc: number
              totalLoanFunding: number
              totalLoanPayments: number
              totalNet: number
              netCashflowPerYear: Array<number>
              greenLeaseTenantFlows?: {
                __typename?: "TenantCashflows"
                totalNet: number
                netCashflowPerYear: Array<number>
                totalCapex: number
                totalOpex: number
                totalUtilitySavings: number
                npv: number
                discountRate: number
              } | null
            } | null
          } | null
          selfInvest?: {
            __typename: "SelfInvestEconomics"
            npv: number
            discountRate: number
            selfInvestXlsxHref: string
            termYears: number
            srecToInvestor: boolean
            irrs: {
              __typename?: "IRRs"
              postTaxItcDepr?: number | null
              postTaxItcDeprMultiple?: number | null
            }
            product: {
              __typename?: "SelfInvestFinProduct"
              productName: string
              financierName: string
            }
            flows?: {
              __typename?: "SelfInvestCashflows"
              totalRevenue: number
              totalUtilitySavings: number
              totalOpex: number
              totalCapex: number
              totalItc: number
              totalNet: number
              netCashflowPerYear: Array<number>
              greenLeaseTenantFlows?: {
                __typename?: "TenantCashflows"
                totalNet: number
                netCashflowPerYear: Array<number>
                totalCapex: number
                totalOpex: number
                totalUtilitySavings: number
                npv: number
                discountRate: number
              } | null
            } | null
          } | null
          meters: Array<{
            __typename?: "RevampMeter"
            name: string
            loadCategory: LoadCategory
            meterSource: MeterSource
            bau: {
              __typename?: "RevampDer"
              totalKwhFlow: {
                __typename?: "KwhFlow"
                bauLoadKwh: number
                importsKwh: number
                exportsKwh: number
                pvProductionKwh: number
                pvToLoadKwh: number
                batteryChargeKwh: number
                batteryDischargeKwh: number
              }
            }
            der?: {
              __typename?: "RevampDer"
              totalKwhFlow: {
                __typename?: "KwhFlow"
                bauLoadKwh: number
                importsKwh: number
                exportsKwh: number
                pvProductionKwh: number
                pvToLoadKwh: number
                batteryChargeKwh: number
                batteryDischargeKwh: number
              }
              averageDayKwhFlow: Array<{
                __typename?: "KwhFlow"
                bauLoadKwh: number
                importsKwh: number
                exportsKwh: number
                pvProductionKwh: number
                pvToLoadKwh: number
                batteryChargeKwh: number
                batteryDischargeKwh: number
              }>
            } | null
          }>
          systems: Array<
            | {
                __typename: "BatterySystem"
                vendor: BatteryVendor
                sizeKw: number
                sizeKwh: number
                assumptions: { __typename?: "BattAssumptions"; battChemName: string }
              }
            | { __typename: "PVSystem"; type: PvType; sizeKw: number }
          >
          utilityCosts: {
            __typename?: "UtilityCost"
            bau: {
              __typename?: "FinmodelCost"
              totalKwh: number
              totalCostUsd: number
              usdPerKwh: number
              items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
              tariffs: Array<{
                __typename?: "RevampTariff"
                id: number
                name: string
                code: string
                startDate: string
                endDate?: string | null
                utility: {
                  __typename?: "RevampUtility"
                  id: number
                  name: string
                  shortName: string
                }
              }>
            }
            der: {
              __typename?: "FinmodelCost"
              totalKwh: number
              totalCostUsd: number
              usdPerKwh: number
              items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
              tariffs: Array<{
                __typename?: "RevampTariff"
                id: number
                name: string
                code: string
                startDate: string
                endDate?: string | null
                utility: {
                  __typename?: "RevampUtility"
                  id: number
                  name: string
                  shortName: string
                }
              }>
            }
          }
        }>
      } | null
    }
  } | null
}

export type SiteLabelsQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type SiteLabelsQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    labels: Array<{
      __typename?: "SiteLabel"
      pid: string
      name: string
      themeColor: LabelColor
    }>
    portfolio?: {
      __typename?: "AdminPortfolio"
      pid: string
      org: {
        __typename?: "AdminOrg"
        labels: Array<{
          __typename?: "SiteLabel"
          pid: string
          name: string
          themeColor: LabelColor
        }>
      }
    } | null
  } | null
}

export type Xl2RenderQueryVariables = Exact<{ [key: string]: never }>

export type Xl2RenderQuery = { __typename?: "Query"; xl2: string }

export type TaskCountsQueryVariables = Exact<{
  orgPid?: InputMaybe<Scalars["String"]["input"]>
  sitePid?: InputMaybe<Scalars["String"]["input"]>
}>

export type TaskCountsQuery = {
  __typename?: "Query"
  taskCounts: Array<{
    __typename?: "Count"
    name: string
    runningCount: number
    pendingCount: number
    successCount: number
    failureCount: number
  }>
}

export type OplogCountsQueryVariables = Exact<{ [key: string]: never }>

export type OplogCountsQuery = {
  __typename?: "Query"
  oplogCounts: Array<{
    __typename?: "Count"
    name: string
    runningCount: number
    pendingCount: number
    successCount: number
    failureCount: number
  }>
}

export type ActiveBoostsQueryVariables = Exact<{
  orgPid: Scalars["String"]["input"]
}>

export type ActiveBoostsQuery = { __typename?: "Query"; activeBoosts: number }

export type OrgPriorityQueryVariables = Exact<{
  orgPid: Scalars["String"]["input"]
}>

export type OrgPriorityQuery = { __typename?: "Query"; orgPriority: number }

export type ConserviceSearchQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  onlyHouse: Scalars["Boolean"]["input"]
}>

export type ConserviceSearchQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    portfolio?: {
      __typename?: "AdminPortfolio"
      pid: string
      org: { __typename?: "AdminOrg"; pid: string }
    } | null
    conserviceSearch: Array<{
      __typename?: "ConserviceSearch"
      name: string
      count: number
      matched: boolean
    }>
  } | null
}

export type SiteResultConfigQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type SiteResultConfigQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    resultConfig: Array<{
      __typename?: "ResultConfig"
      disabledAt?: string | null
      finrelDisabledAt?: string | null
      finproduct: {
        __typename?: "AdminFinProduct"
        id: number
        type: FinProductType
        name: string
        financier: { __typename?: "OrgRef"; name: string; pid: string }
      }
    }>
  } | null
}

export type SiteTodosQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type SiteTodosQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    id: number
    pid: string
    todos: Array<{
      __typename?: "TodoItem"
      id: number
      content: string
      index: number
      createdAt: string
      updatedAt: string
      completedAt?: string | null
      createdBy?: { __typename?: "UserRef"; pid: string; email: string } | null
      updatedBy?: { __typename?: "UserRef"; pid: string; email: string } | null
      completedBy?: { __typename?: "UserRef"; pid: string; email: string } | null
      section: { __typename?: "TodoSection"; id: number; name: string; index: number }
    }>
  } | null
}

export type SiteEspmQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type SiteEspmQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    espm?: {
      __typename?: "ESPMProperty"
      id: number
      createdAt: string
      lastUpdatedAt: string
      externalPropertyId: number
      xml: string
      accounts: Array<{
        __typename?: "ESPMAccount"
        id: number
        createdAt: string
        lastUpdatedAt: string
        externalAccountId: number
        xml: string
      }>
      espmMeters: Array<{
        __typename?: "ESPMMeter"
        id: number
        createdAt: string
        lastUpdatedAt: string
        externalMeterId: number
        xml: string
        unitOfMeasure: string
        meterType: string
        espmConsumptions: Array<{
          __typename?: "ESPMConsumption"
          id: number
          createdAt: string
          lastUpdatedAt: string
          externalConsumptionId: string
          xml: string
          start: string
          end: string
          usageKwh: number
          costUsd?: number | null
        }>
      }>
    } | null
  } | null
}

export type TaskHistoryQueryVariables = Exact<{ [key: string]: never }>

export type TaskHistoryQuery = {
  __typename?: "Query"
  taskHistory: {
    __typename?: "TaskHistory"
    timestamps: Array<string>
    taskNames: Array<string>
    series: Array<{
      __typename?: "TaskSeries"
      taskName: string
      counts: Array<number>
    }>
  }
}

export type AdminBundleRowViewQueryVariables = Exact<{ [key: string]: never }>

export type AdminBundleRowViewQuery = {
  __typename?: "Query"
  bundleRows: {
    __typename?: "AdminBundleTable"
    view: { __typename?: "AdminBundleTableView"; count: number; keys: Array<number> }
  }
}

export type AdminBundleRowsQueryVariables = Exact<{
  keys: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
}>

export type AdminBundleRowsQuery = {
  __typename?: "Query"
  bundleRows: {
    __typename?: "AdminBundleTable"
    rows: Array<{
      __typename?: "AdminBundleTableRow"
      id: number
      createdAt: string
      bundleName: string
      finproductType: FinProductType
      sitePid: string
      siteName?: string | null
      receiverPid: string
      receiverName: string
      financierPid: string
      financierName: string
      portfolioPid: string
      portfolioName: string
      biddingOpenAt?: string | null
      biddingClosedAt?: string | null
      preBidMeetingDate?: string | null
      bidReviewMeetingDate?: string | null
      contractSignedDate?: string | null
      ntpDate?: string | null
      codDate?: string | null
      state?: BundleState | null
      reason?: CloseReason | null
      customReason?: string | null
      leDevFee?: number | null
      pvKw?: number | null
    }>
  }
}

export type SolarCaptchaSitesQueryVariables = Exact<{
  sitePids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
}>

export type SolarCaptchaSitesQuery = {
  __typename?: "Query"
  sites: Array<{
    __typename?: "Site"
    pid: string
    fullAddress: string
    staticMapUrl: string
    existingSolarDetectionScore?: number | null
    latitude: number
    longitude: number
    orgSlug?: string | null
  } | null>
}

export type PreviewBuildingFootprintsQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  strategy: FootprintStrategy
}>

export type PreviewBuildingFootprintsQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    previewBuildingFootprints:
      | { __typename: "Error"; message: string }
      | {
          __typename: "Footprint"
          latitude: number
          longitude: number
          bounds?: any | null
          roofShape?: any | null
          roofShapeGeojson?: any | null
          parcelShape?: any | null
          parcelShapeGeojson?: any | null
        }
  } | null
}

export type ListHostingCapacityMapsQueryVariables = Exact<{ [key: string]: never }>

export type ListHostingCapacityMapsQuery = {
  __typename?: "Query"
  hostingCapacityMaps: {
    __typename?: "HostingCapacityMapQuery"
    all: Array<{
      __typename?: "HostingCapacityMap"
      id: number
      url: string
      requiresLogin: boolean
      types: Array<HostingCapacityMapType>
      utility: {
        __typename?: "Utility"
        id: number
        pid: string
        name: string
        shortName: string
      }
    }>
  }
}

export type BauMeterBillComparisonQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  meterId: Scalars["Int"]["input"]
}>

export type BauMeterBillComparisonQuery = {
  __typename?: "Query"
  site?: {
    __typename?: "Site"
    pid: string
    isMultifamily: boolean
    customTariffs: Array<{
      __typename?: "CustomTariff"
      id: number
      name: string
      code: string
      parent?: { __typename?: "Tariff"; id: number } | null
    }>
  } | null
  bauMeter: {
    __typename?: "BauMeter"
    loadCategory: LoadCategory
    tariff: { __typename?: "Tariff"; id: number; code: string; name: string }
    documentBillingMonths: Array<{
      __typename?: "DocumentBillingMonth"
      id: number
      start: string
      end: string
    }>
  }
}

export type AdminMarketplaceViewQueryVariables = Exact<{
  filterBy?: InputMaybe<AdminMarketplaceTableFilter>
  sortBy?: InputMaybe<Array<AdminMarketplaceTableSort> | AdminMarketplaceTableSort>
}>

export type AdminMarketplaceViewQuery = {
  __typename?: "Query"
  marketplace: {
    __typename?: "AdminMarketplaceTable"
    view: {
      __typename?: "AdminMarketplaceTableView"
      keys: Array<number>
      count: number
      stats: {
        __typename?: "AdminMarketplaceTableStats"
        buildingOwners: Array<string>
        assetManagers: Array<string>
        bidPackageNames: Array<string>
        siteStates: Array<string>
        financiers: Array<string>
        portfolios: Array<string>
        salesOwners: Array<string>
        opsOwners: Array<string>
      }
    }
  }
}

export type AdminMarketplaceRowsQueryVariables = Exact<{
  keys: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
}>

export type AdminMarketplaceRowsQuery = {
  __typename?: "Query"
  marketplace: {
    __typename?: "AdminMarketplaceTable"
    rows: Array<{
      __typename?: "AdminMarketplaceTableRow"
      id: number
      orgSlug: string
      orgName: string
      portfolioName: string
      sitePid: string
      bidPackagePid: string
      bidPackageName: string
      name?: string | null
      city: string
      state: string
      zipCode: string
      streetAddress: string
      county: string
      cbsaName?: string | null
      assetManager?: string | null
      packageRowStatus?: PackageRowStatus | null
      packageRowIsClosed: boolean
      packageRowClosedAt?: string | null
      packageRowCloseReason?: PackageRowCloseReason | null
      packageRowCloseCustomReason?: string | null
      isAwarded: boolean
      buildingType?: BuildingType | null
      yearBuilt?: number | null
      sqft?: number | null
      buildingFootprintSqft?: number | null
      roofSqft?: number | null
      usableRoofSqft?: number | null
      numStories?: number | null
      numUnitsTotal?: number | null
      buildingClass?: string | null
      roofReplacedYr?: number | null
      roofCondition?: string | null
      salePlannedYear?: number | null
      salePlans?: string | null
      buildingLegalName?: string | null
      propertyFundName?: string | null
      leaseSignatory?: string | null
      counselApproval?: CounselApproval | null
      leaseApprovers?: Array<string> | null
      externalLeaseApprovers?: Array<string> | null
      needsTenantApproval?: boolean | null
      roofRightsHolder?: RoofRightsHolder | null
      propertyLenders?: string | null
      propertyInsurer?: string | null
      constructionEmail?: string | null
      propertySiteVisitContacts?: Array<string> | null
      leasePropertyLegalDescription?: string | null
      leaseLegalOwnerName?: string | null
      signatureBlocks?: Array<string> | null
      isFannieMaeLender?: boolean | null
      isFmGlobalInsurer?: boolean | null
      utilityShortName?: string | null
      finproductType: FinProductType
      biddingOpenAt?: string | null
      biddingClosedAt?: string | null
      bidReviewMeetingDate?: string | null
      estimatedNtp?: string | null
      estimatedCod?: string | null
      bidCount: number
      awardedTo?: string | null
      roofRentY1Usd?: number | null
      noiLifetimeUsd?: number | null
      roofRentEscalator?: number | null
      pvSizeKwDc?: number | null
      lumenRevenue?: number | null
      lumenFeeUsdPerWatt?: number | null
      hubspotRecordId?: string | null
      salesOwnerEmail?: string | null
      salesOwnerPid?: string | null
      opsOwnerEmail?: string | null
      opsOwnerPid?: string | null
      rofoSignedDate?: string | null
      rofoSignedEstimated?: string | null
      rofoSignedActual?: string | null
      preBidMeetingEstimated?: string | null
      preBidMeetingActual?: string | null
      preBidMeetingDate?: string | null
      biddingOpenedEstimated?: string | null
      biddingOpenedActual?: string | null
      biddingOpenedDate?: string | null
      biddingClosedEstimated?: string | null
      biddingClosedActual?: string | null
      biddingClosedDate?: string | null
      bidsPresentedEstimated?: string | null
      bidsPresentedActual?: string | null
      bidsPresentedDate?: string | null
      ixSubmittedEstimated?: string | null
      ixSubmittedActual?: string | null
      ixSubmittedDate?: string | null
      ixApprovedEstimated?: string | null
      ixApprovedActual?: string | null
      ixApprovedDate?: string | null
      csProgramSubmittedEstimated?: string | null
      csProgramSubmittedActual?: string | null
      csProgramSubmittedDate?: string | null
      csProgramApprovedEstimated?: string | null
      csProgramApprovedActual?: string | null
      csProgramApprovedDate?: string | null
      awardedToDeveloperEstimated?: string | null
      awardedToDeveloperActual?: string | null
      awardedToDeveloperDate?: string | null
      leaseSignedEstimated?: string | null
      leaseSignedActual?: string | null
      leaseSignedDate?: string | null
      ntpEstimated?: string | null
      ntpActual?: string | null
      ntpDate?: string | null
      codEstimated?: string | null
      codActual?: string | null
      codDate?: string | null
    }>
  }
}

export type AdminMarketplaceSiteDocumentsQueryVariables = Exact<{
  keys: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
}>

export type AdminMarketplaceSiteDocumentsQuery = {
  __typename?: "Query"
  bundleRowParentDocuments: Array<{
    __typename?: "SiteDocuments"
    sitePid: string
    documents: Array<{
      __typename?: "Document"
      pid: string
      fileName: string
      downloadHref: string
      tag?: DocumentTag | null
    }>
  }>
}

export type ActiveAdminsQueryVariables = Exact<{ [key: string]: never }>

export type ActiveAdminsQuery = {
  __typename?: "Query"
  activeAdmins: Array<{
    __typename?: "UserRef"
    pid: string
    isAdmin: boolean
    name?: string | null
    email: string
  }>
}

export type AdminUserDetailQueryVariables = Exact<{
  userId: Scalars["Int"]["input"]
}>

export type AdminUserDetailQuery = {
  __typename?: "Query"
  user?: {
    __typename?: "AdminUser"
    id: number
    pid: string
    email: string
    name?: string | null
    affiliation?: string | null
    isAdmin: boolean
    isEnabled: boolean
    avatarUrl?: string | null
    meetingSchedulingUrl?: string | null
    lastSeenAt?: string | null
    pageViews: Array<{
      __typename?: "AdminUserPageView"
      pathname: string
      createdAt: string
    }>
    portfoliosWithRole: Array<{
      __typename?: "PortfolioRef"
      pid: string
      title: string
    }>
    unclaimedInvitations: Array<{
      __typename?: "AdminInvitation"
      isClaimed: boolean
      isExpired: boolean
      expiresAt: string
      portfolio?: { __typename?: "PortfolioRef"; pid: string; title: string } | null
    }>
    licenseAgreements: Array<{
      __typename?: "LicenseAgreement"
      acceptedAt: string
      forOrg?: { __typename?: "Org"; pid: string; name: string } | null
    }>
    org?: { __typename?: "Org"; pid: string; name: string; slug: string } | null
  } | null
}

export type AdminSitesTableViewQueryVariables = Exact<{
  filterBy?: InputMaybe<AdminSitesTableFilter>
  sortBy?: InputMaybe<Array<AdminSitesTableSort> | AdminSitesTableSort>
}>

export type AdminSitesTableViewQuery = {
  __typename?: "Query"
  allSites: {
    __typename?: "AdminSitesTable"
    view: {
      __typename?: "AdminSitesTableView"
      keys: Array<number>
      count: number
      stats: {
        __typename?: "AdminSitesTableStats"
        orgNames: Array<string>
        portfolios: Array<string>
        utilityNames: Array<string>
        cities: Array<string>
      }
    }
  }
}

export type AdminSitesTableRowsQueryVariables = Exact<{
  keys: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
}>

export type AdminSitesTableRowsQuery = {
  __typename?: "Query"
  allSites: {
    __typename?: "AdminSitesTable"
    rows: Array<{
      __typename?: "AdminSitesTableRow"
      id: number
      orgName: string
      orgPid: string
      orgSlug: string
      portfolioPid: string
      portfolioName: string
      sitePid: string
      createdAt: string
      status: SiteStatus
      statusReason?: StatusReason | null
      statusCustomReason?: string | null
      name?: string | null
      customerId?: string | null
      streetAddress: string
      city: string
      state: string
      zipCode: string
      roofMaxPvKw: number
      utilityId?: number | null
      utilityShortName?: string | null
      utilityName?: string | null
    }>
  }
}

export type AdminBidsTableViewQueryVariables = Exact<{
  filterBy?: InputMaybe<AdminBidsTableFilter>
  sortBy?: InputMaybe<Array<AdminBidsTableSort> | AdminBidsTableSort>
}>

export type AdminBidsTableViewQuery = {
  __typename?: "Query"
  allBids: {
    __typename?: "AdminBidsTable"
    view: {
      __typename?: "AdminBidsTableView"
      count: number
      keys: Array<number>
      stats: {
        __typename?: "AdminBidsTableStats"
        buildingOwnerNames: Array<string>
        financierNames: Array<string>
      }
    }
  }
}

export type AdminBidsTableRowsQueryVariables = Exact<{
  keys: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
}>

export type AdminBidsTableRowsQuery = {
  __typename?: "Query"
  allBids: {
    __typename?: "AdminBidsTable"
    rows: Array<{
      __typename?: "AdminBidsTableRow"
      id: number
      bidPackagePid: string
      bundlePid: string
      bidPackageName: string
      name?: string | null
      createdAt: string
      isAwarded: boolean
      isCustom: boolean
      packageRowStatus?: PackageRowStatus | null
      packageRowIsClosed: boolean
      packageRowClosedAt?: string | null
      packageRowCloseReason?: PackageRowCloseReason | null
      packageRowCloseCustomReason?: string | null
      estimatedCod: string
      estimatedNtp: string
      csEstimatedAwardDate?: string | null
      pvSizeKwDc?: number | null
      pvSizeKwAc?: number | null
      pvTypes: Array<PvType>
      buildingOwnerPid: string
      buildingOwnerName: string
      financierPid: string
      financierName: string
      sitePid: string
      siteName?: string | null
      streetAddress: string
      city: string
      state: string
      zipCode: string
      utilityId?: number | null
      utilityName?: string | null
      utilityShortName?: string | null
      termYears?: number | null
      roofRentY1Usd?: number | null
      roofRentEscalator?: number | null
      buildingOwnerExtraPaymentsUsd?: Array<number> | null
      extraPaymentsNotes?: string | null
      buildingOwnerNoiLifetimeUsd?: number | null
      interconnectionCostUtilityMaxUsd?: number | null
      interconnectionCostUtilityMinUsd?: number | null
      interconnectionCostNonUtilityUsd?: number | null
      interconnectionCostUsdPerWatt?: number | null
      interconnectionNotes?: string | null
      itcPercentageAssumption: number
      recOwner: RecOwner
      incentivesNotes?: string | null
      otherNotes?: string | null
    }>
  }
}

export type RevampFinmodelFragment = {
  __typename: "RevampFinmodel"
  id: number
  pid: string
  createdAt: string
  type: FinProductType
  intervalsAndCostsXlsxHref: string
  buildingOwnerXlsxHref?: string | null
  offerStatus: OfferStatus
  fmvStr: string
  totalPvProductionKwh: number
  totalPvExportKwh?: number | null
  bauCostPerYear: Array<number>
  derCostPerYear: Array<number>
  goal?: PVoptGoal | null
  isVnem: boolean
  isGreenLease: boolean
  thirdPartySupplier?: {
    __typename?: "ThirdPartySupplier"
    pid: string
    name: string
  } | null
  buildingOwner: {
    __typename?: "BuildingOwnerEconomics"
    noiYearOne?: number | null
    noiLifetime?: number | null
    noiAnnual?: number | null
  }
  ppa?: {
    __typename: "PPAEconomics"
    ppaType: PpaProductType
    ppaCostPerKwh: number
    ppaTermYears: number
    ppaEsc?: number | null
    srecToInvestor: boolean
    offtakerXlsxHref: string
    product: {
      __typename?: "PPAFinProduct"
      productName: string
      financierName: string
    }
    roofRent?: {
      __typename?: "RoofRentEconomics"
      lifetimeUsd: number
      annualUsd: number
      usdPerSqft: number
      roofRentPerYear: Array<number>
    } | null
    tenantFlows?: {
      __typename?: "TenantCashflows"
      npv: number
      discountRate: number
      totalUtilitySavings: number
      totalCapex: number
      totalOpex: number
      totalNet: number
      netCashflowPerYear: Array<number>
    } | null
  } | null
  loan?: {
    __typename: "LoanEconomics"
    loanRecvrXlsxHref: string
    loanTermYears: number
    ownershipTermYears: number
    interestPct: number
    srecToInvestor: boolean
    product: {
      __typename?: "LoanFinProduct"
      productName: string
      financierName: string
      loanDealerFeePct: number
    }
    flows?: {
      __typename?: "LoanRecvrCashflows"
      monthlyPayment: number
      totalRevenue: number
      totalUtilitySavings: number
      totalOpex: number
      totalCapex: number
      totalItc: number
      totalLoanFunding: number
      totalLoanPayments: number
      totalNet: number
      netCashflowPerYear: Array<number>
      greenLeaseTenantFlows?: {
        __typename?: "TenantCashflows"
        totalNet: number
        netCashflowPerYear: Array<number>
        totalCapex: number
        totalOpex: number
        totalUtilitySavings: number
        npv: number
        discountRate: number
      } | null
    } | null
  } | null
  selfInvest?: {
    __typename: "SelfInvestEconomics"
    npv: number
    discountRate: number
    selfInvestXlsxHref: string
    termYears: number
    srecToInvestor: boolean
    irrs: {
      __typename?: "IRRs"
      postTaxItcDepr?: number | null
      postTaxItcDeprMultiple?: number | null
    }
    product: {
      __typename?: "SelfInvestFinProduct"
      productName: string
      financierName: string
    }
    flows?: {
      __typename?: "SelfInvestCashflows"
      totalRevenue: number
      totalUtilitySavings: number
      totalOpex: number
      totalCapex: number
      totalItc: number
      totalNet: number
      netCashflowPerYear: Array<number>
      greenLeaseTenantFlows?: {
        __typename?: "TenantCashflows"
        totalNet: number
        netCashflowPerYear: Array<number>
        totalCapex: number
        totalOpex: number
        totalUtilitySavings: number
        npv: number
        discountRate: number
      } | null
    } | null
  } | null
  meters: Array<{
    __typename?: "RevampMeter"
    name: string
    loadCategory: LoadCategory
    meterSource: MeterSource
    bau: {
      __typename?: "RevampDer"
      totalKwhFlow: {
        __typename?: "KwhFlow"
        bauLoadKwh: number
        importsKwh: number
        exportsKwh: number
        pvProductionKwh: number
        pvToLoadKwh: number
        batteryChargeKwh: number
        batteryDischargeKwh: number
      }
    }
    der?: {
      __typename?: "RevampDer"
      totalKwhFlow: {
        __typename?: "KwhFlow"
        bauLoadKwh: number
        importsKwh: number
        exportsKwh: number
        pvProductionKwh: number
        pvToLoadKwh: number
        batteryChargeKwh: number
        batteryDischargeKwh: number
      }
      averageDayKwhFlow: Array<{
        __typename?: "KwhFlow"
        bauLoadKwh: number
        importsKwh: number
        exportsKwh: number
        pvProductionKwh: number
        pvToLoadKwh: number
        batteryChargeKwh: number
        batteryDischargeKwh: number
      }>
    } | null
  }>
  systems: Array<
    | {
        __typename: "BatterySystem"
        vendor: BatteryVendor
        sizeKw: number
        sizeKwh: number
        assumptions: { __typename?: "BattAssumptions"; battChemName: string }
      }
    | { __typename: "PVSystem"; type: PvType; sizeKw: number }
  >
  utilityCosts: {
    __typename?: "UtilityCost"
    bau: {
      __typename?: "FinmodelCost"
      totalKwh: number
      totalCostUsd: number
      usdPerKwh: number
      items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
      tariffs: Array<{
        __typename?: "RevampTariff"
        id: number
        name: string
        code: string
        startDate: string
        endDate?: string | null
        utility: {
          __typename?: "RevampUtility"
          id: number
          name: string
          shortName: string
        }
      }>
    }
    der: {
      __typename?: "FinmodelCost"
      totalKwh: number
      totalCostUsd: number
      usdPerKwh: number
      items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
      tariffs: Array<{
        __typename?: "RevampTariff"
        id: number
        name: string
        code: string
        startDate: string
        endDate?: string | null
        utility: {
          __typename?: "RevampUtility"
          id: number
          name: string
          shortName: string
        }
      }>
    }
  }
}

type RevampSystem_BatterySystem_Fragment = {
  __typename: "BatterySystem"
  vendor: BatteryVendor
  sizeKw: number
  sizeKwh: number
  assumptions: { __typename?: "BattAssumptions"; battChemName: string }
}

type RevampSystem_PvSystem_Fragment = {
  __typename: "PVSystem"
  type: PvType
  sizeKw: number
}

export type RevampSystemFragment =
  | RevampSystem_BatterySystem_Fragment
  | RevampSystem_PvSystem_Fragment

export type RevampCsFragment = {
  __typename: "RevampCS"
  id: number
  termYears: number
  createdAt: string
  goal?: PVoptGoal | null
  systems: Array<
    | {
        __typename: "BatterySystem"
        vendor: BatteryVendor
        sizeKw: number
        sizeKwh: number
        assumptions: { __typename?: "BattAssumptions"; battChemName: string }
      }
    | { __typename: "PVSystem"; type: PvType; sizeKw: number }
  >
  financing: {
    __typename?: "RevampFinancing"
    id: number
    name: string
    type: FinProductType
    financierName: string
    financierPid: string
    financierLogo?: string | null
    financierLogomark?: string | null
    isThirdParty: boolean
  }
  buildingOwner: {
    __typename?: "BuildingOwnerEconomics"
    noiYearOne?: number | null
    noiLifetime?: number | null
    noiAnnual?: number | null
  }
  roofRent?: {
    __typename?: "RoofRentEconomics"
    lifetimeUsd: number
    annualUsd: number
    usdPerSqft: number
    npv: number
    discountRate: number
    roofRentPerYear: Array<number>
  } | null
  pricing: {
    __typename?: "CSPrice"
    usdPerKwPerYear: number
    escalator: number
    minPvKw: number
    maxPvKw: number
    utility: { __typename?: "RevampUtility"; id: number; name: string }
  }
  leaseProjections?: {
    __typename?: "CSLeaseProjections"
    systemSizeKw: number
    annualRentLowerRangeUsd: number
    annualRentUpperRangeUsd: number
    methodology: CsLeaseProjectionMethdology
  } | null
}

export type FinmodelCostFragment = {
  __typename?: "FinmodelCost"
  totalKwh: number
  totalCostUsd: number
  usdPerKwh: number
  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
  tariffs: Array<{
    __typename?: "RevampTariff"
    id: number
    name: string
    code: string
    startDate: string
    endDate?: string | null
    utility: {
      __typename?: "RevampUtility"
      id: number
      name: string
      shortName: string
    }
  }>
}

export type PossibleTariffFragment = {
  __typename?: "Tariff"
  id: number
  name: string
  code: string
  customerClass: string
  customerCount?: number | null
  customerLikelihood: number
  isPreferred?: boolean | null
  minMonthlyKw?: number | null
  maxMonthlyKw?: number | null
  minMonthlyKwh?: number | null
  maxMonthlyKwh?: number | null
  masterTariffId?: number | null
  hasNetMetering: boolean
  requiresPv?: boolean | null
  requiresStorage?: boolean | null
  tariffType?: string | null
}

export type ResultRefFragment = {
  __typename?: "Result"
  id: number
  pid: string
  createdAt: string
  scenario: {
    __typename?: "RevampScenario"
    pid: string
    name: string
    solarLocation: SolarLocation
    loadCategory: LoadCategory
    includeStorage: boolean
  }
  financing: {
    __typename?: "RevampFinancing"
    id: number
    name: string
    type: FinProductType
    financierName: string
    financierPid: string
    financierLogo?: string | null
    financierLogomark?: string | null
    isThirdParty: boolean
    status: FinProductStatus
  }
}

export type ResultFragment = {
  __typename?: "Result"
  id: number
  pid: string
  createdAt: string
  salesPdfReportHref?: string | null
  scenario: {
    __typename?: "RevampScenario"
    pid: string
    name: string
    solarLocation: SolarLocation
    loadCategory: LoadCategory
    includeStorage: boolean
  }
  financing: {
    __typename?: "RevampFinancing"
    id: number
    name: string
    type: FinProductType
    financierName: string
    financierPid: string
    financierLogo?: string | null
    financierLogomark?: string | null
    isThirdParty: boolean
    status: FinProductStatus
  }
  result?:
    | {
        __typename: "PhysicalCheck"
        createdAt: string
        roofIsGood: boolean
        carportIsGood: boolean
        existingSolar?: boolean | null
        badRoof?: boolean | null
        groundmountIsGood: boolean
      }
    | {
        __typename: "PolicyCheck"
        createdAt: string
        productType?: FinProductType | null
        isGood: boolean
        disqualReason?: PolicyReason | null
      }
    | {
        __typename: "RevampCS"
        id: number
        termYears: number
        createdAt: string
        goal?: PVoptGoal | null
        systems: Array<
          | {
              __typename: "BatterySystem"
              vendor: BatteryVendor
              sizeKw: number
              sizeKwh: number
              assumptions: { __typename?: "BattAssumptions"; battChemName: string }
            }
          | { __typename: "PVSystem"; type: PvType; sizeKw: number }
        >
        financing: {
          __typename?: "RevampFinancing"
          id: number
          name: string
          type: FinProductType
          financierName: string
          financierPid: string
          financierLogo?: string | null
          financierLogomark?: string | null
          isThirdParty: boolean
        }
        buildingOwner: {
          __typename?: "BuildingOwnerEconomics"
          noiYearOne?: number | null
          noiLifetime?: number | null
          noiAnnual?: number | null
        }
        roofRent?: {
          __typename?: "RoofRentEconomics"
          lifetimeUsd: number
          annualUsd: number
          usdPerSqft: number
          npv: number
          discountRate: number
          roofRentPerYear: Array<number>
        } | null
        pricing: {
          __typename?: "CSPrice"
          usdPerKwPerYear: number
          escalator: number
          minPvKw: number
          maxPvKw: number
          utility: { __typename?: "RevampUtility"; id: number; name: string }
        }
        leaseProjections?: {
          __typename?: "CSLeaseProjections"
          systemSizeKw: number
          annualRentLowerRangeUsd: number
          annualRentUpperRangeUsd: number
          methodology: CsLeaseProjectionMethdology
        } | null
      }
    | {
        __typename: "RevampFinmodel"
        id: number
        pid: string
        createdAt: string
        type: FinProductType
        intervalsAndCostsXlsxHref: string
        buildingOwnerXlsxHref?: string | null
        offerStatus: OfferStatus
        fmvStr: string
        totalPvProductionKwh: number
        totalPvExportKwh?: number | null
        bauCostPerYear: Array<number>
        derCostPerYear: Array<number>
        goal?: PVoptGoal | null
        isVnem: boolean
        isGreenLease: boolean
        iterations: Array<{
          __typename?: "RevampIteration"
          cashPurchaseNpv: number
          pvKw: number
          marginalCo2Averted?: number | null
          storagePvKw?: number | null
          storagePvKwh?: number | null
        }>
        meters: Array<{
          __typename?: "RevampMeter"
          loadCategory: LoadCategory
          meterSource: MeterSource
          name: string
          bau: {
            __typename?: "RevampDer"
            totalKwhFlow: {
              __typename?: "KwhFlow"
              bauLoadKwh: number
              importsKwh: number
              exportsKwh: number
              pvProductionKwh: number
              pvToLoadKwh: number
              batteryChargeKwh: number
              batteryDischargeKwh: number
            }
          }
          der?: {
            __typename?: "RevampDer"
            totalKwhFlow: {
              __typename?: "KwhFlow"
              bauLoadKwh: number
              importsKwh: number
              exportsKwh: number
              pvProductionKwh: number
              pvToLoadKwh: number
              batteryChargeKwh: number
              batteryDischargeKwh: number
            }
            averageDayKwhFlow: Array<{
              __typename?: "KwhFlow"
              bauLoadKwh: number
              importsKwh: number
              exportsKwh: number
              pvProductionKwh: number
              pvToLoadKwh: number
              batteryChargeKwh: number
              batteryDischargeKwh: number
            }>
          } | null
        }>
        emissions?: {
          __typename?: "RevampEmissions"
          bauCo2Tons: number
          derCo2Tons: number
          bauAverageDayCo2Tons: Array<number>
          derAverageDayCo2Tons: Array<number>
        } | null
        thirdPartySupplier?: {
          __typename?: "ThirdPartySupplier"
          pid: string
          name: string
        } | null
        buildingOwner: {
          __typename?: "BuildingOwnerEconomics"
          noiYearOne?: number | null
          noiLifetime?: number | null
          noiAnnual?: number | null
        }
        ppa?: {
          __typename: "PPAEconomics"
          ppaType: PpaProductType
          ppaCostPerKwh: number
          ppaTermYears: number
          ppaEsc?: number | null
          srecToInvestor: boolean
          offtakerXlsxHref: string
          product: {
            __typename?: "PPAFinProduct"
            productName: string
            financierName: string
          }
          roofRent?: {
            __typename?: "RoofRentEconomics"
            lifetimeUsd: number
            annualUsd: number
            usdPerSqft: number
            roofRentPerYear: Array<number>
          } | null
          tenantFlows?: {
            __typename?: "TenantCashflows"
            npv: number
            discountRate: number
            totalUtilitySavings: number
            totalCapex: number
            totalOpex: number
            totalNet: number
            netCashflowPerYear: Array<number>
          } | null
        } | null
        loan?: {
          __typename: "LoanEconomics"
          loanRecvrXlsxHref: string
          loanTermYears: number
          ownershipTermYears: number
          interestPct: number
          srecToInvestor: boolean
          product: {
            __typename?: "LoanFinProduct"
            productName: string
            financierName: string
            loanDealerFeePct: number
          }
          flows?: {
            __typename?: "LoanRecvrCashflows"
            monthlyPayment: number
            totalRevenue: number
            totalUtilitySavings: number
            totalOpex: number
            totalCapex: number
            totalItc: number
            totalLoanFunding: number
            totalLoanPayments: number
            totalNet: number
            netCashflowPerYear: Array<number>
            greenLeaseTenantFlows?: {
              __typename?: "TenantCashflows"
              totalNet: number
              netCashflowPerYear: Array<number>
              totalCapex: number
              totalOpex: number
              totalUtilitySavings: number
              npv: number
              discountRate: number
            } | null
          } | null
        } | null
        selfInvest?: {
          __typename: "SelfInvestEconomics"
          npv: number
          discountRate: number
          selfInvestXlsxHref: string
          termYears: number
          srecToInvestor: boolean
          irrs: {
            __typename?: "IRRs"
            postTaxItcDepr?: number | null
            postTaxItcDeprMultiple?: number | null
          }
          product: {
            __typename?: "SelfInvestFinProduct"
            productName: string
            financierName: string
          }
          flows?: {
            __typename?: "SelfInvestCashflows"
            totalRevenue: number
            totalUtilitySavings: number
            totalOpex: number
            totalCapex: number
            totalItc: number
            totalNet: number
            netCashflowPerYear: Array<number>
            greenLeaseTenantFlows?: {
              __typename?: "TenantCashflows"
              totalNet: number
              netCashflowPerYear: Array<number>
              totalCapex: number
              totalOpex: number
              totalUtilitySavings: number
              npv: number
              discountRate: number
            } | null
          } | null
        } | null
        systems: Array<
          | {
              __typename: "BatterySystem"
              vendor: BatteryVendor
              sizeKw: number
              sizeKwh: number
              assumptions: { __typename?: "BattAssumptions"; battChemName: string }
            }
          | { __typename: "PVSystem"; type: PvType; sizeKw: number }
        >
        utilityCosts: {
          __typename?: "UtilityCost"
          bau: {
            __typename?: "FinmodelCost"
            totalKwh: number
            totalCostUsd: number
            usdPerKwh: number
            items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
            tariffs: Array<{
              __typename?: "RevampTariff"
              id: number
              name: string
              code: string
              startDate: string
              endDate?: string | null
              utility: {
                __typename?: "RevampUtility"
                id: number
                name: string
                shortName: string
              }
            }>
          }
          der: {
            __typename?: "FinmodelCost"
            totalKwh: number
            totalCostUsd: number
            usdPerKwh: number
            items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
            tariffs: Array<{
              __typename?: "RevampTariff"
              id: number
              name: string
              code: string
              startDate: string
              endDate?: string | null
              utility: {
                __typename?: "RevampUtility"
                id: number
                name: string
                shortName: string
              }
            }>
          }
        }
      }
    | {
        __typename: "RevampFinmodelFailure"
        id: number
        createdAt: string
        fmvStr: string
        details: { __typename?: "FailureDetails"; label: string; description: string }
      }
    | {
        __typename: "Viability"
        isAllowed: boolean
        reason?: ViabilityReason | null
        level: ViabilityLevel
        viabilityType: ViabilityType
      }
    | null
  helioscope?: {
    __typename?: "Helioscope"
    pid: string
    roofPvKw: number
    carportPvKw: number
    groundPvKw: number
    systemProductivityKwhPerKw?: number | null
    roofImageHref: string
    pdfHref: string
    dcNameplateKw?: number | null
    acNameplateKw?: number | null
    loadRatio?: number | null
    moduleType?: string | null
    inverterType?: string | null
    rackingTiltDegrees?: number | null
    rackingManufacturer?: string | null
    rackingConnectionType?: ConnectionType | null
    notes?: string | null
    roofImage: {
      __typename?: "Attachment"
      id: number
      name: string
      downloadHref: string
    }
    pdf: {
      __typename?: "Attachment"
      downloadHref: string
      contentType: string
      name: string
      id: number
    }
  } | null
}

export type ResultWithEnergyDataFragment = {
  __typename?: "Result"
  id: number
  result?:
    | { __typename?: "PhysicalCheck" }
    | { __typename?: "PolicyCheck" }
    | { __typename?: "RevampCS" }
    | {
        __typename?: "RevampFinmodel"
        meters: Array<{
          __typename?: "RevampMeter"
          loadCategory: LoadCategory
          meterSource: MeterSource
          bau: {
            __typename?: "RevampDer"
            totalKwhFlow: {
              __typename?: "KwhFlow"
              bauLoadKwh: number
              importsKwh: number
              exportsKwh: number
              pvProductionKwh: number
              pvToLoadKwh: number
              batteryChargeKwh: number
              batteryDischargeKwh: number
            }
          }
          der?: {
            __typename?: "RevampDer"
            totalKwhFlow: {
              __typename?: "KwhFlow"
              bauLoadKwh: number
              importsKwh: number
              exportsKwh: number
              pvProductionKwh: number
              pvToLoadKwh: number
              batteryChargeKwh: number
              batteryDischargeKwh: number
            }
            averageDayKwhFlow: Array<{
              __typename?: "KwhFlow"
              bauLoadKwh: number
              importsKwh: number
              exportsKwh: number
              pvProductionKwh: number
              pvToLoadKwh: number
              batteryChargeKwh: number
              batteryDischargeKwh: number
            }>
          } | null
        }>
        emissions?: {
          __typename?: "RevampEmissions"
          bauCo2Tons: number
          derCo2Tons: number
          bauAverageDayCo2Tons: Array<number>
          derAverageDayCo2Tons: Array<number>
        } | null
      }
    | { __typename?: "RevampFinmodelFailure" }
    | { __typename?: "Viability" }
    | null
}

export type KwhFlowFragment = {
  __typename?: "KwhFlow"
  bauLoadKwh: number
  importsKwh: number
  exportsKwh: number
  pvProductionKwh: number
  pvToLoadKwh: number
  batteryChargeKwh: number
  batteryDischargeKwh: number
}

export type DecodedRateFragment = {
  __typename?: "DecodedRate"
  id: number
  name: string
  chargeClass: ChargeClass
}

export type BillSectionFragment = {
  __typename?: "BillSection"
  name: string
  rates: Array<{
    __typename?: "DecodedRate"
    id: number
    name: string
    chargeClass: ChargeClass
  }>
  costs: Array<
    | {
        __typename: "CostItem"
        name: string
        rateId: number
        chargeType: ChargeType
        chargeCategory?: ChargeCategory | null
        volume: number
        rate: number
        cost: number
        rateObj: {
          __typename?: "DecodedRate"
          id: number
          name: string
          chargeClass: ChargeClass
        }
      }
    | {
        __typename: "TaxItem"
        taxId: number
        subtotal: number
        cost: number
        percentage: number
      }
    | null
  >
}

type CostOrTaxItem_CostItem_Fragment = {
  __typename: "CostItem"
  name: string
  rateId: number
  chargeType: ChargeType
  chargeCategory?: ChargeCategory | null
  volume: number
  rate: number
  cost: number
  rateObj: {
    __typename?: "DecodedRate"
    id: number
    name: string
    chargeClass: ChargeClass
  }
}

type CostOrTaxItem_TaxItem_Fragment = {
  __typename: "TaxItem"
  taxId: number
  subtotal: number
  cost: number
  percentage: number
}

export type CostOrTaxItemFragment =
  | CostOrTaxItem_CostItem_Fragment
  | CostOrTaxItem_TaxItem_Fragment

export type FormattedBillFragment = {
  __typename?: "FormattedBills"
  rate?: {
    __typename?: "TariffRate"
    tariffId?: number | null
    startDate: string
    endDate?: string | null
  } | null
  bills: Array<{
    __typename?: "FormattedBill"
    month: string
    kwhSupplyCharge: number
    kwhCharge: number
    charges: Array<{
      __typename?: "BillSection"
      name: string
      rates: Array<{
        __typename?: "DecodedRate"
        id: number
        name: string
        chargeClass: ChargeClass
      }>
      costs: Array<
        | {
            __typename: "CostItem"
            name: string
            rateId: number
            chargeType: ChargeType
            chargeCategory?: ChargeCategory | null
            volume: number
            rate: number
            cost: number
            rateObj: {
              __typename?: "DecodedRate"
              id: number
              name: string
              chargeClass: ChargeClass
            }
          }
        | {
            __typename: "TaxItem"
            taxId: number
            subtotal: number
            cost: number
            percentage: number
          }
        | null
      >
    }>
    exports: Array<{
      __typename?: "BillSection"
      name: string
      rates: Array<{
        __typename?: "DecodedRate"
        id: number
        name: string
        chargeClass: ChargeClass
      }>
      costs: Array<
        | {
            __typename: "CostItem"
            name: string
            rateId: number
            chargeType: ChargeType
            chargeCategory?: ChargeCategory | null
            volume: number
            rate: number
            cost: number
            rateObj: {
              __typename?: "DecodedRate"
              id: number
              name: string
              chargeClass: ChargeClass
            }
          }
        | {
            __typename: "TaxItem"
            taxId: number
            subtotal: number
            cost: number
            percentage: number
          }
        | null
      >
    }>
  }>
}

export type SiteConfigFragment = {
  __typename?: "SiteConfig"
  createdAt?: string | null
  createdBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
  scenario: {
    __typename?: "RevampScenario"
    pid: string
    name: string
    loadCategory: LoadCategory
    solarLocation: SolarLocation
    includeStorage: boolean
  }
  financing: {
    __typename?: "RevampFinancing"
    id: number
    name: string
    type: FinProductType
    financierName: string
    financierPid: string
    financierLogo?: string | null
    financierLogomark?: string | null
    isThirdParty: boolean
  }
}

export type BidRevampSiteFragment = {
  __typename?: "RevampSite"
  pid: string
  name?: string | null
  streetAddress: string
  city: string
  state: string
  zipCode: string
  county: string
  fullAddress: string
  assetManager?: string | null
  doeReferenceType?: BuildingType | null
  yearBuilt?: number | null
  numStories?: number | null
  sqft?: number | null
  roofSqft?: number | null
  roofMaxPvKw: number
  buildingClass?: string | null
  ppaType?: PpaProductType | null
  meterSet?: {
    __typename?: "MeterSet"
    totalCost: number
    loadKwh?: number | null
  } | null
  siteDetails: {
    __typename?: "SiteDetails"
    salePlans?: string | null
    roofCondition?: string | null
    roofReplacedYr?: number | null
  }
  targetUtility?: {
    __typename?: "Utility"
    name: string
    pid: string
    id: number
  } | null
}

export type RevampSiteBasicsFragment = {
  __typename?: "RevampSite"
  pid: string
  name?: string | null
  isFavorite: boolean
  isBehindTheMeter?: boolean | null
  isEnergyCommunity: boolean
  isLowIncomeCommunity?: boolean | null
  streetAddress: string
  city: string
  state: string
  zipCode: string
  county: string
  fullAddress: string
  metering?: Metering | null
  assetManager?: string | null
  vnemAllowed: boolean
  doeReferenceType?: BuildingType | null
  usingBillingMeters?: string | null
  numParkingSpaces?: number | null
  yearBuilt?: number | null
  numStories?: number | null
  sqft?: number | null
  roofSqft?: number | null
  usableRoofSqft?: number | null
  usableCarportFt?: number | null
  impliedCarportLinearFt?: number | null
  impliedUsableRoofSqft?: number | null
  impliedUsableRoofSqftExplanation: RoofSqftExplanation
  groundAvailableSqft?: number | null
  hideBuildingFootprint: boolean
  keepoutsFootprintSqft?: number | null
  roofMaxPvKw: number
  carportMaxPvKw: number
  groundmountMaxPvKw?: number | null
  maxPvKwPolicyLimited: boolean
  isMultifamily: boolean
  occupancyType?: BuildingOccupancyType | null
  leaseType?: LeaseType | null
  tenantLeaseTerm?: string | null
  tenantLeaseEnds?: string | null
  tenantInterest?: YesNoUnsure | null
  mortgageLender?: string | null
  buildingClass?: string | null
  hasSubmittedEnergyData: boolean
  selectedConfig?: {
    __typename?: "SiteConfig"
    createdAt?: string | null
    createdBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    scenario: {
      __typename?: "RevampScenario"
      pid: string
      name: string
      loadCategory: LoadCategory
      solarLocation: SolarLocation
      includeStorage: boolean
    }
    financing: {
      __typename?: "RevampFinancing"
      id: number
      name: string
      type: FinProductType
      financierName: string
      financierPid: string
      financierLogo?: string | null
      financierLogomark?: string | null
      isThirdParty: boolean
    }
  } | null
  documents: Array<{
    __typename?: "Document"
    pid: string
    downloadHref: string
    fileName: string
    tag?: DocumentTag | null
  }>
  energyThings?: {
    __typename?: "EnergyThings"
    canRooftopSolar: boolean
    canCarportSolar?: boolean | null
    canGroundmountSolar?: boolean | null
    canStorage: boolean
  } | null
  financingThings?: {
    __typename?: "FinancingThings"
    canSelfInvest: boolean
    canLoan: boolean
    canPpa?: boolean | null
    canCommunitySolar?: boolean | null
  } | null
  physicalCheck: {
    __typename?: "PhysicalCheck"
    existingSolar?: boolean | null
    unobstructedFlatRoof?: boolean | null
    badRoof?: boolean | null
  }
  siteDetails: {
    __typename?: "SiteDetails"
    leaseApprovers: Array<string>
    externalLeaseApprovers?: Array<string> | null
    needsTenantApproval?: boolean | null
    roofRightsHolder?: RoofRightsHolder | null
    propertyLenders?: string | null
    propertyInsurer?: string | null
    constructionEmail?: string | null
    propertySiteVisitContacts?: Array<string> | null
    leasePropertyLegalDescription?: string | null
    leaseLegalOwnerName?: string | null
    signatureBlocks?: Array<string> | null
    isFannieMaeLender?: boolean | null
    isFmGlobalInsurer?: boolean | null
    roofReplacedYr?: number | null
    roofCondition?: string | null
    salePlans?: string | null
    buildingLegalName?: string | null
    propertyFundName?: string | null
    leaseSignatory?: string | null
    counselApproval?: CounselApproval | null
  }
  notes: Array<{ __typename?: "Note"; text: string }>
  buildingData?: {
    __typename?: "BuildingData"
    numStories?: number | null
    numUnits?: number | null
    yearBuilt?: number | null
    sqft?: number | null
    roofSqft?: number | null
    numParkingSpaces?: number | null
    occupancyRate?: number | null
    totalBuildings?: number | null
    yearRenovated?: number | null
    parentCompany?: string | null
    lastSalePrice?: number | null
    leedCertified?: string | null
    energyStar?: string | null
    buildingOpex?: string | null
    capRate?: number | null
  } | null
  footprint: {
    __typename?: "Footprint"
    latitude: number
    longitude: number
    bounds?: any | null
    obstructionShape?: any | null
    roofShape?: any | null
    roofShapeGeojson?: any | null
    roofShapeUpdatedAt?: string | null
    roofSetbackShape?: any | null
    roofSetbackShapeGeojson?: any | null
    roofSetbackShapeUpdatedAt?: string | null
    carportShape?: any | null
    carportShapeGeojson?: any | null
    carportShapeUpdatedAt?: string | null
    groundmountShape?: any | null
    groundmountShapeGeojson?: any | null
    groundmountShapeUpdatedAt?: string | null
    keepoutsShape?: any | null
    keepoutsShapeGeojson?: any | null
    keepoutsShapeUpdatedAt?: string | null
    roofShapeUpdatedBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    roofSetbackShapeUpdatedBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    carportShapeUpdatedBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    groundmountShapeUpdatedBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    keepoutsShapeUpdatedBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
  }
  thirdPartySupplier?: {
    __typename?: "ThirdPartySupplier"
    pid: string
    name: string
  } | null
  meterSet?: { __typename?: "MeterSet"; loadOrigin?: LoadOrigin | null } | null
  targetUtility?: {
    __typename?: "Utility"
    name: string
    pid: string
    id: number
    eiaGridEsc?: {
      __typename?: "EIAGridEsc"
      cagrBlended: number
      fromYear: number
      toYear: number
    } | null
    hostingCapacityMaps: Array<{
      __typename?: "HostingCapacityMap"
      url: string
      requiresLogin: boolean
      types: Array<HostingCapacityMapType>
    }>
  } | null
}

export type UserRefFragment = {
  __typename?: "UserRef"
  pid: string
  email: string
  name?: string | null
  isAdmin: boolean
  avatarUrl?: string | null
}

export type FootprintFragment = {
  __typename?: "Footprint"
  latitude: number
  longitude: number
  bounds?: any | null
  obstructionShape?: any | null
  roofShape?: any | null
  roofShapeGeojson?: any | null
  roofShapeUpdatedAt?: string | null
  roofSetbackShape?: any | null
  roofSetbackShapeGeojson?: any | null
  roofSetbackShapeUpdatedAt?: string | null
  carportShape?: any | null
  carportShapeGeojson?: any | null
  carportShapeUpdatedAt?: string | null
  groundmountShape?: any | null
  groundmountShapeGeojson?: any | null
  groundmountShapeUpdatedAt?: string | null
  keepoutsShape?: any | null
  keepoutsShapeGeojson?: any | null
  keepoutsShapeUpdatedAt?: string | null
  roofShapeUpdatedBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
  roofSetbackShapeUpdatedBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
  carportShapeUpdatedBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
  groundmountShapeUpdatedBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
  keepoutsShapeUpdatedBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
}

export type HelioscopeFragment = {
  __typename?: "Helioscope"
  pid: string
  roofPvKw: number
  carportPvKw: number
  groundPvKw: number
  systemProductivityKwhPerKw?: number | null
  roofImageHref: string
  pdfHref: string
  dcNameplateKw?: number | null
  acNameplateKw?: number | null
  loadRatio?: number | null
  moduleType?: string | null
  inverterType?: string | null
  rackingTiltDegrees?: number | null
  rackingManufacturer?: string | null
  rackingConnectionType?: ConnectionType | null
  notes?: string | null
  roofImage: {
    __typename?: "Attachment"
    id: number
    name: string
    downloadHref: string
  }
  pdf: {
    __typename?: "Attachment"
    downloadHref: string
    contentType: string
    name: string
    id: number
  }
}

export type SiteVisualsFragment = {
  __typename?: "SiteVisuals"
  solarPanels: Array<{
    __typename?: "MapSolarPanel"
    latitude: number
    longitude: number
    angle: number
  }>
}

export type BasicEvCalcFragment = {
  __typename?: "EVCalc"
  id: number
  createdAt: string
  numChargers: number
  optimalNumChargers: number
  npv: number
  markupUsdPerKwh: number
  timeZone: string
  dayRates: Array<number>
  downloadHourlyRatesHref: string
  xlsx?: string | null
  downloadXlsxHref: string
  yr3Revenue?: number | null
  yr3Cashflow?: number | null
  yr3NumEvs?: number | null
  parkingRatio?: number | null
  projectInputs: {
    __typename?: "EVProjectInputs"
    projectStartDate: string
    installType: ChargerInstallType
    termYears: number
    chargerKw: number
    yr0NumTenantEvs?: number | null
    discountRate: number
  }
  outputs: {
    __typename?: "EVOutputs"
    irr?: number | null
    npv: number
    yr0NumTenantEvs: number
    breakevenYear: number
    numChargersDemandedSeries: Array<number>
    cashflowSeries: Array<number>
    revenueSeries: Array<number>
    incentiveUsd: number
  }
  tariffRate: {
    __typename?: "TariffRate"
    parent: { __typename?: "Tariff"; name: string; code: string }
  }
  utility: { __typename?: "UtilityRef"; shortName: string }
  seasonalDayRates: Array<{
    __typename?: "SeasonalDayRate"
    name: string
    startMonth: number
    endMonth: number
    dayRates: Array<number>
  }>
  optIters: Array<{ __typename?: "EVOptIter"; numChargers: number; npv: number }>
  year3Expenses: Array<{ __typename?: "EVLineItem"; label: string; value: number }>
  installCosts: Array<{ __typename?: "EVLineItem"; label: string; value: number }>
}

export type DocumentFragment = {
  __typename?: "Document"
  id: number
  pid: string
  contentType: string
  dateCreated: string
  fileName: string
  ownerName: string
  ownerEmail: string
  downloadHref: string
  viewHref: string
  tag?: DocumentTag | null
}

export const CostSummary_FragmentDoc = `
    fragment CostSummary_ on CostSummary_ {
  totalCost
  totalEnergyUsage
  tariff {
    id
    code
    utility {
      shortName
    }
  }
}
    `
export const OrgRefFragmentDoc = `
    fragment OrgRef on OrgRef {
  pid
  name
}
    `
export const CostsFragmentFragmentDoc = `
    fragment CostsFragment on ETBCosts {
  totalCost
  totalIncentiveSavings
  netCost
  energyConsumptionKwhYear1
  netEnergyConsumptionKwhYear1
  utilityCostPerKwh
  averageLoadFactor
  energyCostBefore
  energyCostAfter
  energyCostSavings
  demandCostBefore
  demandCostAfter
  demandCostSavings
  totalCostBefore
  totalCostAfter
  totalCostSavings
  pvTotalCost
  pvNetCost
  pvPowerRatingKwDc
  pvPowerRatingKwAc
  pvDegradationRate
  pvGenerationKwhYear1
  pvKwhPerKwDc
  pvSavingsPerKwh
  pvGenerationPercentExported
  storageTotalCost
  storageNetCost
  storageCapacityKwh
  storageMaxDischargePowerKw
  storageTwoHourPowerRatingKw
  storageDegradationRate
  storageDischargeYear1
  storageConsumptionKwhYear1
  storageSavingsPerKw
  storageSavingsPerKwh
}
    `
export const OverrideFragmentDoc = `
    fragment Override on FinmodelInputOverride {
  id
  dateCreated
  dateTrashed
  inputName
  inputValue
  source
  createdBy
}
    `
export const SiteRefFragmentDoc = `
    fragment SiteRef on SiteRef {
  pid
  name
  streetAddress
}
    `
export const ScenarioRefFragmentDoc = `
    fragment ScenarioRef on ScenarioRef {
  pid
  name
}
    `
export const FinmodelSourceFragmentFragmentDoc = `
    fragment FinmodelSourceFragment on FinmodelSource {
  __typename
  ... on PVoptRef {
    id
  }
  ... on LuxRef {
    id
  }
  ... on ReoptRef {
    pid
  }
  ... on ETBReportRef {
    id
    projectName
  }
}
    `
export const FinmodelFailureDetailFragmentDoc = `
    fragment FinmodelFailureDetail on FinmodelFailure {
  id
  createdAt
  fmv
  name
  message
  isPvopt
  isLux
  site {
    ...SiteRef
  }
  scenario {
    ...ScenarioRef
  }
  source {
    ...FinmodelSourceFragment
  }
}
    `
export const FinmodelFailureRefFragmentDoc = `
    fragment FinmodelFailureRef on FinmodelFailureRef {
  id
}
    `
export const SitesTableFragmentDoc = `
    fragment SitesTable on Site {
  pid
  propertyName
  fullAddress
  state
  buildingType
  sqft
  roofSqft
  occupancyType
  leaseType
  metering
  mortgageLender
  roofReplacedYr
  hiddenFromCustomers
  portfolio {
    pid
    title
    org {
      slug
    }
  }
  roofImage {
    id
  }
  roofMaxPvKw
  carportMaxPvKw
  primaryScenario {
    pid
    solarLocation
    includeStorage
  }
  currentStatus {
    pid
    status
  }
  createdAt
}
    `
export const DraftSiteFragmentFragmentDoc = `
    fragment DraftSiteFragment on DraftSite {
  pid
  portfolioPid
  doeReferenceType
  costarPropertyType
  propertyName
  streetAddress
  city
  state
  zipCode
  county
  latitude
  longitude
  sqft
  roofSqft
  capRate
  totalBuildings
  numStories
  numParkingSpaces
  yearBuilt
  numUnitsStudio
  numUnits1Bd
  numUnits2Bd
  numUnits3Bd
  numUnits4Bd
  avgSqftStudio
  avgSqft1Bd
  avgSqft2Bd
  avgSqft3Bd
  avgSqft4Bd
  numVacantUnitsStudio
  numVacantUnits1Bd
  numVacantUnits2Bd
  numVacantUnits3Bd
  numVacantUnits4Bd
  timeZone
  cbsaName
  errors {
    name
    message
  }
  canReify
  dateCreated
}
    `
export const UserRefFragmentDoc = `
    fragment UserRef on UserRef {
  pid
  email
  name
  isAdmin
  avatarUrl
}
    `
export const MeteringFragmentDoc = `
    fragment Metering on Site {
  metering
  meteringSetDate
  meteringSetBy {
    ...UserRef
  }
}
    `
export const LeaseTypeFragmentDoc = `
    fragment LeaseType on Site {
  leaseType
}
    `
export const BuildingOccupancyTypeFragmentDoc = `
    fragment BuildingOccupancyType on Site {
  occupancyType
}
    `
export const EtbReportRefFragmentDoc = `
    fragment ETBReportRef on ETBReportRef {
  id
  projectName
}
    `
export const EtbScenarioRefFragmentDoc = `
    fragment ETBScenarioRef on ETBScenarioRef {
  pid
  name
  isPrimary
  solarLocation
  includeStorage
  loadCategory
}
    `
export const AttachmentFragmentFragmentDoc = `
    fragment AttachmentFragment on Attachment {
  id
  size
  name
  contentType
  downloadHref
  createdAt
  trashedAt
  isTrashable
  isRoofImageCandidate
  isEtb
  createdBy {
    ...UserRef
  }
}
    `
export const ScenarioHelioscopeFragmentFragmentDoc = `
    fragment ScenarioHelioscopeFragment on Helioscope {
  id
  pid
  createdAt
  isTrashed
  roofPvKw
  carportPvKw
  pdf {
    ...AttachmentFragment
  }
  roofImage {
    ...AttachmentFragment
  }
}
    `
export const ScenarioEtbFragmentFragmentDoc = `
    fragment ScenarioEtbFragment on ETBReport {
  id
  dateCreated
  projectName
  roofPvKw
  carportPvKw
  groundPvKw
  batteryKw
  batteryKwh
}
    `
export const TariffDetailFragmentFragmentDoc = `
    fragment TariffDetailFragment on TariffDetails {
  tariff {
    id
    code
    name
    customerClass
  }
  version {
    tariffId
    effectiveDate
    endDate
  }
  properties {
    keyName
    dataType
    propertyValue
    formulaDetail
  }
  rawJson
  rates {
    tariffRateId
    name
    classes
    chargeClass
    chargeType
    chargePeriod
    transactionType
    applicabilityKey
    quantityKey
    isDemandCharge
    isFixedPrice
    isQuantity
    isTou
    variableLimitValue {
      keyName
      formulaDetail
    }
    bands {
      tariffRateBandId
      rateUnit
      price
      isCredit
      hasConsumptionLimit
      propertyUpperLimit
      consumptionUpperLimit
      demandUpperLimit
      calculationFactor
      applicabilityValue
    }
    season {
      seasonFromMonth
      seasonToMonth
      seasonFromDay
      seasonToDay
    }
    tou {
      touName
      season {
        seasonFromMonth
        seasonToMonth
        seasonFromDay
        seasonToDay
      }
      touPeriods {
        fromDayOfWeek
        toDayOfWeek
        fromHour
        toHour
        fromMinute
        toMinute
      }
    }
  }
}
    `
export const FinRelFragmentDoc = `
    fragment FinRel on AdminFinRel {
  disabledAt
  finproduct {
    id
    type
    name
    financier {
      name
      pid
    }
  }
  recvr {
    pid
  }
}
    `
export const AdminOrgFragmentDoc = `
    fragment AdminOrg on AdminOrg {
  pid
  name
  logoUrl
}
    `
export const UserListUserFragmentDoc = `
    fragment UserListUser on AdminUser {
  id
  pid
  email
  name
  affiliation
  isAdmin
  isEnabled
  avatarUrl
  meetingSchedulingUrl
  portfoliosWithRole {
    pid
    title
  }
  unclaimedInvitations {
    isClaimed
    isExpired
    expiresAt
    portfolio {
      pid
      title
    }
  }
  licenseAgreements {
    forOrg {
      pid
      name
    }
    acceptedAt
  }
  org {
    pid
    name
    slug
  }
  lastSeenAt
}
    `
export const RuleValueFragmentDoc = `
    fragment RuleValue on RuleValue {
  __typename
  ... on YesNoValue {
    yes
  }
  ... on NumberValue {
    number
  }
  ... on CurrencyValue {
    usd
  }
  ... on IntegerValue {
    integer
  }
  ... on TextValue {
    text
  }
}
    `
export const PolicyConditionFragmentDoc = `
    fragment PolicyCondition on PolicyCondition {
  __typename
  ... on BuildingSuperTypeCondition {
    buildingSuperType
  }
  ... on VnemEligibilityCondition {
    vnemEligibilityRequired
  }
}
    `
export const RuleFragmentDoc = `
    fragment Rule on Rule {
  id
  description
  units
  value {
    ...RuleValue
  }
  application {
    status
    detail
  }
  conditions {
    ...PolicyCondition
  }
}
    `
export const PolicyListItemFragmentDoc = `
    fragment PolicyListItem on Policy {
  pid
  name
  jurisdiction {
    scope
    name
  }
  status
  startDate
  endDate
  userVisible
  application {
    status
  }
  rules {
    ...Rule
  }
}
    `
export const BauTariffFragmentDoc = `
    fragment BauTariff on Tariff {
  id
  name
  code
  masterTariffId
}
    `
export const BauMeterFragmentDoc = `
    fragment BauMeter on BauMeter {
  id
  createdAt
  createdBy {
    email
  }
  label
  loadOrigin
  loadCategory
  meterSource
  utility {
    id
    name
  }
  tariff {
    ...BauTariff
  }
  tariffSetBy {
    pid
    email
  }
  underHumanControl
  tariffsUnderHumanControl
  postSolarTariff {
    ...BauTariff
  }
  postSolarTariffSetBy {
    pid
    email
  }
  postBatteryTariff {
    ...BauTariff
  }
  postBatteryTariffSetBy {
    pid
    email
  }
  archivedAt
  archivedBy {
    pid
    email
  }
  archivedReason
  rollup {
    season
    days
    numbers
  }
}
    `
export const BauMeterIntervalsFragmentDoc = `
    fragment BauMeterIntervals on BauMeter {
  id
  tariffUsdPerKwh
  rollup {
    season
    days
    numbers
  }
  intervals {
    units
    year
    timeZone
    maxKw
    totalKwh
    kwh8760
  }
}
    `
export const PvConfigFragmentDoc = `
    fragment PVConfig on PVConfig {
  pvType
  origin
  sizeKw
  productionKwh
}
    `
export const BatteryConfigFragmentDoc = `
    fragment BatteryConfig on BatteryConfig {
  vendor
  sizeKwh
  sizeKw
  chargeStrategy
  dischargeStrategy
}
    `
export const SlimLuxFragmentDoc = `
    fragment SlimLux on Lux {
  id
  etbReport {
    id
  }
  createdAt
  fmvStr
  goal
  maxOffsetPct
  pvKw
  roofPvKw
  carportPvThreeHighKw
  carportPvSixHighKw
  battKw
  battKwh
  meterSet {
    id
  }
  meters {
    bauMeter {
      id
    }
    postSolarMeter {
      pv {
        ...PVConfig
      }
    }
    postBatteryMeter {
      batt {
        ...BatteryConfig
      }
    }
  }
}
    `
export const CostSummaryFragmentDoc = `
    fragment CostSummary on CostSummary {
  totalCost
  totalEnergyUsage
  energyCost
  demandCost
  fixedCost
  nbcCost
  exportBenefit
}
    `
export const LuxMeterFragmentDoc = `
    fragment LuxMeter on LuxMeter {
  id
  gridMeter {
    preSolar {
      costSummary {
        ...CostSummary
      }
    }
    postSolar {
      costSummary {
        ...CostSummary
      }
    }
    postBattery {
      costSummary {
        ...CostSummary
      }
    }
  }
  dayIntervals {
    pvToBldg
    battDischarge
    gridToBldg
  }
  bauMeter {
    id
    label
    importsKwh
    tariff {
      name
      code
    }
  }
  postSolarMeter {
    pv {
      ...PVConfig
    }
    tariff {
      parent {
        name
        code
      }
    }
  }
  postBatteryMeter {
    batt {
      ...BatteryConfig
    }
    tariff {
      parent {
        name
        code
      }
    }
  }
}
    `
export const LuxFragmentDoc = `
    fragment Lux on Lux {
  ...SlimLux
  meters {
    ...LuxMeter
  }
  iterations {
    meters {
      bauMeterId
      totalPvKw
      pv {
        pvType
        sizeKw
      }
    }
    metric
    postTaxItcDeprIrr
  }
}
    `
export const CleanBillSuggestionFragmentDoc = `
    fragment CleanBillSuggestion on Bill_ {
  utilityName
  customerName
  serviceIdentifier
  billingAccountNumber
  billingAddress
  billingPeriodStart
  billingPeriodEnd
  meters {
    serviceAccount
    meterId
    serviceAddress
    tariffLabel
    totalKwh
    peakKw
    totalCostUsd
    lineItems {
      label
      unit
      volume
      rate
      costUsd
    }
  }
}
    `
export const ChangelogFragmentDoc = `
    fragment Changelog on Changelog {
  field
  updatedAt
  updatedBy {
    ...UserRef
  }
}
    `
export const UtilityFragmentFragmentDoc = `
    fragment UtilityFragment on Utility {
  id
  pid
  name
  shortName
  numTariffs
  dateTariffsRefreshed
  utilityApiName
  isPreferred
  notes
}
    `
export const EtbMissingDataFragmentDoc = `
    fragment ETBMissingData on ETBReport {
  id
  meters {
    id
    name
    state
    zipCode
    utilityName
    tariffShortDescriptionBefore
    tariffShortDescriptionAfter
    utility {
      id
      name
      shortName
    }
  }
  site {
    pid
  }
}
    `
export const SmallScenarioFragmentFragmentDoc = `
    fragment SmallScenarioFragment on AdminScenario {
  id
  pid
  name
  dateCreated
  includeStorage
  isPrimary
  isMultifamily
  loadCategory
  solarLocation
  createdBy {
    ...UserRef
  }
  hiddenFromCustomers
  allowMulticonnect
}
    `
export const ScenarioFragmentFragmentDoc = `
    fragment ScenarioFragment on AdminScenario {
  ...SmallScenarioFragment
  activeEtbReport {
    id
    projectName
  }
  helioscope {
    id
    pid
  }
}
    `
export const AiMessageFragmentDoc = `
    fragment AIMessage on Message {
  role
  content {
    __typename
    ... on TextContent {
      text
    }
    ... on ImageContent {
      imageUrl {
        url
      }
    }
  }
  toolCalls {
    id
    type
    function {
      name
      arguments
    }
  }
}
    `
export const BasicOrgDetailsFragmentDoc = `
    fragment BasicOrgDetails on AdminOrg {
  id
  pid
  name
  slug
  rawSlug
  description
  logoUrl
  logomarkUrl
}
    `
export const DeltaFragmentDoc = `
    fragment Delta on Delta {
  a
  b
  diff
  pct
}
    `
export const NameThatTariffResultFragmentDoc = `
    fragment NameThatTariffResult on NameThatTariffResult {
  notTheCorrectRateVersion
  rate {
    startDate
    endDate
    tariffId
  }
  expected {
    start
    end
    totalCostUsd
    totalKwh
    peakKw
    lineItems {
      chargeType
      costUsd
    }
  }
  actual {
    start
    end
    totalCostUsd
    totalKwh
    peakKw
    lineItems {
      chargeType
      costUsd
    }
  }
  delta {
    usd {
      ...Delta
    }
    kwh {
      ...Delta
    }
    kw {
      ...Delta
    }
  }
  document {
    pid
    contentType
    viewHref
  }
}
    `
export const KwhFlowFragmentDoc = `
    fragment KwhFlow on KwhFlow {
  bauLoadKwh
  importsKwh
  exportsKwh
  pvProductionKwh
  pvToLoadKwh
  batteryChargeKwh
  batteryDischargeKwh
}
    `
export const RevampSystemFragmentDoc = `
    fragment RevampSystem on RevampSystem {
  __typename
  ... on PVSystem {
    type
    sizeKw
  }
  ... on BatterySystem {
    vendor
    sizeKw
    sizeKwh
    assumptions {
      battChemName
    }
  }
}
    `
export const FinmodelCostFragmentDoc = `
    fragment FinmodelCost on FinmodelCost {
  totalKwh
  totalCostUsd
  usdPerKwh
  items {
    name
    usd
  }
  tariffs {
    utility {
      id
      name
      shortName
    }
    id
    name
    code
    startDate
    endDate
  }
}
    `
export const RevampFinmodelFragmentDoc = `
    fragment RevampFinmodel on RevampFinmodel {
  __typename
  id
  pid
  createdAt
  type
  intervalsAndCostsXlsxHref
  buildingOwnerXlsxHref
  offerStatus
  fmvStr
  totalPvProductionKwh
  totalPvExportKwh
  bauCostPerYear
  derCostPerYear
  goal
  isVnem
  isGreenLease
  thirdPartySupplier {
    pid
    name
  }
  buildingOwner {
    noiYearOne
    noiLifetime
    noiAnnual
  }
  ppa {
    __typename
    ppaType
    ppaCostPerKwh
    ppaTermYears
    ppaEsc
    srecToInvestor
    offtakerXlsxHref
    product {
      productName
      financierName
    }
    roofRent {
      lifetimeUsd
      annualUsd
      usdPerSqft
      roofRentPerYear
    }
    tenantFlows {
      npv
      discountRate
      totalUtilitySavings
      totalCapex
      totalOpex
      totalNet
      netCashflowPerYear
    }
  }
  loan {
    __typename
    loanRecvrXlsxHref
    loanTermYears
    ownershipTermYears
    interestPct
    srecToInvestor
    product {
      productName
      financierName
      loanDealerFeePct
    }
    flows {
      monthlyPayment
      totalRevenue
      totalUtilitySavings
      totalOpex
      totalCapex
      totalItc
      totalLoanFunding
      totalLoanPayments
      totalNet
      netCashflowPerYear
      greenLeaseTenantFlows {
        totalNet
        netCashflowPerYear
        totalCapex
        totalOpex
        totalUtilitySavings
        npv
        discountRate
      }
    }
  }
  selfInvest {
    __typename
    npv
    discountRate
    selfInvestXlsxHref
    termYears
    srecToInvestor
    irrs {
      postTaxItcDepr
      postTaxItcDeprMultiple
    }
    product {
      productName
      financierName
    }
    flows {
      totalRevenue
      totalUtilitySavings
      totalOpex
      totalCapex
      totalItc
      totalNet
      netCashflowPerYear
      greenLeaseTenantFlows {
        totalNet
        netCashflowPerYear
        totalCapex
        totalOpex
        totalUtilitySavings
        npv
        discountRate
      }
    }
  }
  meters {
    name
    loadCategory
    meterSource
    bau {
      totalKwhFlow {
        ...KwhFlow
      }
    }
    der {
      totalKwhFlow {
        ...KwhFlow
      }
      averageDayKwhFlow {
        ...KwhFlow
      }
    }
  }
  systems {
    ...RevampSystem
  }
  utilityCosts {
    bau {
      ...FinmodelCost
    }
    der {
      ...FinmodelCost
    }
  }
}
    `
export const AdminFinmodelDetailFragmentDoc = `
    fragment AdminFinmodelDetail on RevampFinmodel {
  __typename
  ...RevampFinmodel
  financing {
    id
    name
    type
    financierName
    financierPid
    isThirdParty
    status
  }
  scenario {
    pid
    name
    loadCategory
    includeStorage
    solarLocation
  }
  investorDetails {
    investorXlsxHref
    irrs {
      preTax
      postTaxItcDepr
    }
  }
  moreDetails {
    cashPurchaseNpv
    totalInstallCost
    pvCostPerWatt
    finmodelInputs
    finmodelOutputs
    luxId
    failureId
  }
  importReductionPct
}
    `
export const PossibleTariffFragmentDoc = `
    fragment PossibleTariff on Tariff {
  id
  name
  code
  customerClass
  customerCount
  customerLikelihood
  isPreferred
  minMonthlyKw
  maxMonthlyKw
  minMonthlyKwh
  maxMonthlyKwh
  masterTariffId
  hasNetMetering
  requiresPv
  requiresStorage
  tariffType
}
    `
export const ResultRefFragmentDoc = `
    fragment ResultRef on Result {
  id
  pid
  createdAt
  scenario {
    pid
    name
    solarLocation
    loadCategory
    includeStorage
  }
  financing {
    id
    name
    type
    financierName
    financierPid
    financierLogo
    financierLogomark
    isThirdParty
    status
  }
}
    `
export const RevampCsFragmentDoc = `
    fragment RevampCS on RevampCS {
  __typename
  id
  termYears
  createdAt
  goal
  systems {
    ...RevampSystem
  }
  financing {
    id
    name
    type
    financierName
    financierPid
    financierLogo
    financierLogomark
    isThirdParty
  }
  buildingOwner {
    noiYearOne
    noiLifetime
    noiAnnual
  }
  roofRent {
    lifetimeUsd
    annualUsd
    usdPerSqft
    npv
    discountRate
    roofRentPerYear
  }
  pricing {
    utility {
      id
      name
    }
    usdPerKwPerYear
    escalator
    minPvKw
    maxPvKw
  }
  leaseProjections {
    systemSizeKw
    annualRentLowerRangeUsd
    annualRentUpperRangeUsd
    methodology
  }
}
    `
export const HelioscopeFragmentDoc = `
    fragment Helioscope on Helioscope {
  pid
  roofPvKw
  carportPvKw
  groundPvKw
  systemProductivityKwhPerKw
  roofImage {
    id
    name
    downloadHref
  }
  pdf {
    downloadHref
    contentType
    name
    id
  }
  roofImageHref
  pdfHref
  dcNameplateKw
  acNameplateKw
  loadRatio
  moduleType
  inverterType
  rackingTiltDegrees
  rackingManufacturer
  rackingConnectionType
  notes
}
    `
export const ResultFragmentDoc = `
    fragment Result on Result {
  id
  pid
  createdAt
  salesPdfReportHref
  scenario {
    pid
    name
    solarLocation
    loadCategory
    includeStorage
  }
  financing {
    id
    name
    type
    financierName
    financierPid
    financierLogo
    financierLogomark
    isThirdParty
    status
  }
  result {
    __typename
    ... on PhysicalCheck {
      createdAt
      roofIsGood
      carportIsGood
      existingSolar
      badRoof
      groundmountIsGood
    }
    ... on PolicyCheck {
      createdAt
      productType
      isGood
      disqualReason
    }
    ... on RevampFinmodelFailure {
      id
      createdAt
      fmvStr
      details {
        label
        description
      }
    }
    ... on RevampFinmodel {
      ...RevampFinmodel
      iterations {
        cashPurchaseNpv
        pvKw
        marginalCo2Averted
        storagePvKw
        storagePvKwh
      }
      meters {
        loadCategory
        meterSource
        bau {
          totalKwhFlow {
            ...KwhFlow
          }
        }
        der {
          totalKwhFlow {
            ...KwhFlow
          }
          averageDayKwhFlow {
            ...KwhFlow
          }
        }
      }
      emissions {
        bauCo2Tons
        derCo2Tons
        bauAverageDayCo2Tons
        derAverageDayCo2Tons
      }
    }
    ... on RevampCS {
      ...RevampCS
    }
    ... on Viability {
      isAllowed
      viabilityType: type
      reason
      level
    }
  }
  helioscope {
    ...Helioscope
  }
}
    `
export const ResultWithEnergyDataFragmentDoc = `
    fragment ResultWithEnergyData on Result {
  id
  result {
    ... on RevampFinmodel {
      meters {
        loadCategory
        meterSource
        bau {
          totalKwhFlow {
            ...KwhFlow
          }
        }
        der {
          totalKwhFlow {
            ...KwhFlow
          }
          averageDayKwhFlow {
            ...KwhFlow
          }
        }
      }
      emissions {
        bauCo2Tons
        derCo2Tons
        bauAverageDayCo2Tons
        derAverageDayCo2Tons
      }
    }
  }
}
    `
export const DecodedRateFragmentDoc = `
    fragment DecodedRate on DecodedRate {
  id
  name
  chargeClass
}
    `
export const CostOrTaxItemFragmentDoc = `
    fragment CostOrTaxItem on CostItemTaxItem {
  __typename
  ... on CostItem {
    rateObj {
      ...DecodedRate
    }
    name
    rateId
    chargeType
    chargeCategory
    volume
    rate
    cost
  }
  ... on TaxItem {
    taxId
    subtotal
    cost
    percentage
  }
}
    `
export const BillSectionFragmentDoc = `
    fragment BillSection on BillSection {
  name
  rates {
    ...DecodedRate
  }
  costs {
    ...CostOrTaxItem
  }
}
    `
export const FormattedBillFragmentDoc = `
    fragment FormattedBill on FormattedBills {
  rate {
    tariffId
    startDate
    endDate
  }
  bills {
    month
    charges {
      ...BillSection
    }
    exports {
      ...BillSection
    }
    kwhSupplyCharge
    kwhCharge
  }
}
    `
export const BidRevampSiteFragmentDoc = `
    fragment BidRevampSite on RevampSite {
  pid
  name
  streetAddress
  city
  state
  zipCode
  county
  fullAddress
  assetManager
  doeReferenceType
  meterSet {
    totalCost
    loadKwh
  }
  yearBuilt
  numStories
  sqft
  roofSqft
  siteDetails {
    salePlans
    roofCondition
    roofReplacedYr
  }
  roofMaxPvKw
  buildingClass
  targetUtility {
    name
    pid
    id
  }
  ppaType
}
    `
export const SiteConfigFragmentDoc = `
    fragment SiteConfig on SiteConfig {
  createdAt
  createdBy {
    ...UserRef
  }
  scenario {
    pid
    name
    loadCategory
    solarLocation
    includeStorage
  }
  financing {
    id
    name
    type
    financierName
    financierPid
    financierLogo
    financierLogomark
    isThirdParty
  }
}
    `
export const FootprintFragmentDoc = `
    fragment Footprint on Footprint {
  latitude
  longitude
  bounds
  obstructionShape
  roofShape
  roofShapeGeojson
  roofShapeUpdatedAt
  roofShapeUpdatedBy {
    ...UserRef
  }
  roofSetbackShape
  roofSetbackShapeGeojson
  roofSetbackShapeUpdatedAt
  roofSetbackShapeUpdatedBy {
    ...UserRef
  }
  carportShape
  carportShapeGeojson
  carportShapeUpdatedAt
  carportShapeUpdatedBy {
    ...UserRef
  }
  groundmountShape
  groundmountShapeGeojson
  groundmountShapeUpdatedAt
  groundmountShapeUpdatedBy {
    ...UserRef
  }
  keepoutsShape
  keepoutsShapeGeojson
  keepoutsShapeUpdatedAt
  keepoutsShapeUpdatedBy {
    ...UserRef
  }
}
    `
export const RevampSiteBasicsFragmentDoc = `
    fragment RevampSiteBasics on RevampSite {
  pid
  name
  isFavorite
  isBehindTheMeter
  isEnergyCommunity
  isLowIncomeCommunity
  streetAddress
  city
  state
  zipCode
  county
  fullAddress
  metering
  assetManager
  vnemAllowed
  doeReferenceType
  usingBillingMeters
  numParkingSpaces
  selectedConfig {
    ...SiteConfig
  }
  documents {
    pid
    downloadHref
    fileName
    tag
  }
  energyThings {
    canRooftopSolar
    canCarportSolar
    canGroundmountSolar
    canStorage
  }
  financingThings {
    canSelfInvest
    canLoan
    canPpa
    canCommunitySolar
  }
  physicalCheck {
    existingSolar
    unobstructedFlatRoof
    badRoof
  }
  siteDetails {
    leaseApprovers
    externalLeaseApprovers
    needsTenantApproval
    roofRightsHolder
    propertyLenders
    propertyInsurer
    constructionEmail
    propertySiteVisitContacts
    leasePropertyLegalDescription
    leaseLegalOwnerName
    signatureBlocks
    isFannieMaeLender
    isFmGlobalInsurer
    roofReplacedYr
    roofCondition
    salePlans
    buildingLegalName
    propertyFundName
    leaseSignatory
    counselApproval
  }
  yearBuilt
  numStories
  sqft
  roofSqft
  usableRoofSqft
  usableCarportFt
  impliedCarportLinearFt
  impliedUsableRoofSqft
  impliedUsableRoofSqftExplanation
  groundAvailableSqft
  hideBuildingFootprint
  keepoutsFootprintSqft
  roofMaxPvKw
  carportMaxPvKw
  groundmountMaxPvKw
  maxPvKwPolicyLimited
  isMultifamily
  occupancyType
  leaseType
  tenantLeaseTerm
  tenantLeaseEnds
  tenantInterest
  mortgageLender
  notes {
    text
  }
  buildingClass
  buildingData {
    numStories
    numUnits
    yearBuilt
    sqft
    roofSqft
    numParkingSpaces
    occupancyRate
    totalBuildings
    yearRenovated
    parentCompany
    lastSalePrice
    leedCertified
    energyStar
    buildingOpex
    capRate
  }
  footprint {
    ...Footprint
  }
  thirdPartySupplier {
    pid
    name
  }
  meterSet {
    loadOrigin
  }
  targetUtility {
    name
    pid
    id
    eiaGridEsc {
      cagrBlended
      fromYear
      toYear
    }
    hostingCapacityMaps {
      url
      requiresLogin
      types
    }
  }
  hasSubmittedEnergyData
}
    `
export const SiteVisualsFragmentDoc = `
    fragment SiteVisuals on SiteVisuals {
  solarPanels {
    latitude
    longitude
    angle
  }
}
    `
export const BasicEvCalcFragmentDoc = `
    fragment BasicEVCalc on EVCalc {
  id
  createdAt
  projectInputs {
    projectStartDate
    installType
    termYears
    chargerKw
    yr0NumTenantEvs
    discountRate
  }
  outputs {
    irr
    npv
    yr0NumTenantEvs
    breakevenYear
    numChargersDemandedSeries
    cashflowSeries
    revenueSeries
    incentiveUsd
  }
  numChargers
  optimalNumChargers
  npv
  markupUsdPerKwh
  tariffRate {
    parent {
      name
      code
    }
  }
  utility {
    shortName
  }
  timeZone
  dayRates
  seasonalDayRates {
    name
    startMonth
    endMonth
    dayRates
  }
  downloadHourlyRatesHref
  xlsx
  downloadXlsxHref
  optIters {
    numChargers
    npv
  }
  yr3Revenue
  yr3Cashflow
  yr3NumEvs
  parkingRatio
  year3Expenses {
    label
    value
  }
  installCosts {
    label
    value
  }
}
    `
export const DocumentFragmentDoc = `
    fragment Document on Document {
  id
  pid
  contentType
  dateCreated
  fileName
  ownerName
  ownerEmail
  downloadHref
  viewHref
  tag
}
    `
export const CreatePortfolioDocument = `
    mutation CreatePortfolio($title: String!, $logo: Upload!, $orgPid: String, $createEponymousOrg: Boolean!, $createOpenInvite: Boolean!) {
  portfolio {
    new(
      title: $title
      upload: $logo
      orgPid: $orgPid
      createEponymousOrg: $createEponymousOrg
      createOpenInvite: $createOpenInvite
    ) {
      pid
      title
    }
  }
}
    `

export const useCreatePortfolioMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreatePortfolioMutation,
    TError,
    CreatePortfolioMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreatePortfolioMutation,
    TError,
    CreatePortfolioMutationVariables,
    TContext
  >({
    mutationKey: ["CreatePortfolio"],
    mutationFn: (variables?: CreatePortfolioMutationVariables) =>
      adminFetcher<CreatePortfolioMutation, CreatePortfolioMutationVariables>(
        CreatePortfolioDocument,
        variables,
      )(),
    ...options,
  })
}

useCreatePortfolioMutation.fetcher = (
  variables: CreatePortfolioMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<CreatePortfolioMutation, CreatePortfolioMutationVariables>(
    CreatePortfolioDocument,
    variables,
    options,
  )

export const CreateDraftSiteDocument = `
    mutation CreateDraftSite($inputs: DraftSiteInputs!) {
  draftSite {
    new(inputs: $inputs) {
      ...DraftSiteFragment
    }
  }
}
    ${DraftSiteFragmentFragmentDoc}`

export const useCreateDraftSiteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateDraftSiteMutation,
    TError,
    CreateDraftSiteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateDraftSiteMutation,
    TError,
    CreateDraftSiteMutationVariables,
    TContext
  >({
    mutationKey: ["CreateDraftSite"],
    mutationFn: (variables?: CreateDraftSiteMutationVariables) =>
      adminFetcher<CreateDraftSiteMutation, CreateDraftSiteMutationVariables>(
        CreateDraftSiteDocument,
        variables,
      )(),
    ...options,
  })
}

useCreateDraftSiteMutation.fetcher = (
  variables: CreateDraftSiteMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<CreateDraftSiteMutation, CreateDraftSiteMutationVariables>(
    CreateDraftSiteDocument,
    variables,
    options,
  )

export const SaveDraftSiteDocument = `
    mutation SaveDraftSite($draftSitePid: String!, $inputs: DraftSiteInputs!) {
  draftSite {
    save(draftSitePid: $draftSitePid, inputs: $inputs) {
      ...DraftSiteFragment
    }
  }
}
    ${DraftSiteFragmentFragmentDoc}`

export const useSaveDraftSiteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SaveDraftSiteMutation,
    TError,
    SaveDraftSiteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SaveDraftSiteMutation,
    TError,
    SaveDraftSiteMutationVariables,
    TContext
  >({
    mutationKey: ["SaveDraftSite"],
    mutationFn: (variables?: SaveDraftSiteMutationVariables) =>
      adminFetcher<SaveDraftSiteMutation, SaveDraftSiteMutationVariables>(
        SaveDraftSiteDocument,
        variables,
      )(),
    ...options,
  })
}

useSaveDraftSiteMutation.fetcher = (
  variables: SaveDraftSiteMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SaveDraftSiteMutation, SaveDraftSiteMutationVariables>(
    SaveDraftSiteDocument,
    variables,
    options,
  )

export const ReifyDraftSiteDocument = `
    mutation ReifyDraftSite($draftSitePid: String!) {
  draftSite {
    reify(draftSitePid: $draftSitePid) {
      pid
    }
  }
}
    `

export const useReifyDraftSiteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ReifyDraftSiteMutation,
    TError,
    ReifyDraftSiteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ReifyDraftSiteMutation,
    TError,
    ReifyDraftSiteMutationVariables,
    TContext
  >({
    mutationKey: ["ReifyDraftSite"],
    mutationFn: (variables?: ReifyDraftSiteMutationVariables) =>
      adminFetcher<ReifyDraftSiteMutation, ReifyDraftSiteMutationVariables>(
        ReifyDraftSiteDocument,
        variables,
      )(),
    ...options,
  })
}

useReifyDraftSiteMutation.fetcher = (
  variables: ReifyDraftSiteMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ReifyDraftSiteMutation, ReifyDraftSiteMutationVariables>(
    ReifyDraftSiteDocument,
    variables,
    options,
  )

export const TrashDraftSiteDocument = `
    mutation TrashDraftSite($draftSitePids: [String!]!) {
  draftSite {
    trash(draftSitePids: $draftSitePids)
  }
}
    `

export const useTrashDraftSiteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    TrashDraftSiteMutation,
    TError,
    TrashDraftSiteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    TrashDraftSiteMutation,
    TError,
    TrashDraftSiteMutationVariables,
    TContext
  >({
    mutationKey: ["TrashDraftSite"],
    mutationFn: (variables?: TrashDraftSiteMutationVariables) =>
      adminFetcher<TrashDraftSiteMutation, TrashDraftSiteMutationVariables>(
        TrashDraftSiteDocument,
        variables,
      )(),
    ...options,
  })
}

useTrashDraftSiteMutation.fetcher = (
  variables: TrashDraftSiteMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<TrashDraftSiteMutation, TrashDraftSiteMutationVariables>(
    TrashDraftSiteDocument,
    variables,
    options,
  )

export const SetSitePortfolioDocument = `
    mutation SetSitePortfolio($sitePid: String!, $portfolioPid: String) {
  site {
    setPortfolio(sitePid: $sitePid, portfolioPid: $portfolioPid) {
      pid
      portfolio {
        pid
        title
      }
    }
  }
}
    `

export const useSetSitePortfolioMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetSitePortfolioMutation,
    TError,
    SetSitePortfolioMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetSitePortfolioMutation,
    TError,
    SetSitePortfolioMutationVariables,
    TContext
  >({
    mutationKey: ["SetSitePortfolio"],
    mutationFn: (variables?: SetSitePortfolioMutationVariables) =>
      adminFetcher<SetSitePortfolioMutation, SetSitePortfolioMutationVariables>(
        SetSitePortfolioDocument,
        variables,
      )(),
    ...options,
  })
}

useSetSitePortfolioMutation.fetcher = (
  variables: SetSitePortfolioMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetSitePortfolioMutation, SetSitePortfolioMutationVariables>(
    SetSitePortfolioDocument,
    variables,
    options,
  )

export const SetDoeReferenceTypeDocument = `
    mutation SetDoeReferenceType($sitePid: String!, $value: BuildingType) {
  site {
    setDoeReferenceType(sitePid: $sitePid, value: $value) {
      pid
      doeReferenceType
    }
  }
}
    `

export const useSetDoeReferenceTypeMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetDoeReferenceTypeMutation,
    TError,
    SetDoeReferenceTypeMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetDoeReferenceTypeMutation,
    TError,
    SetDoeReferenceTypeMutationVariables,
    TContext
  >({
    mutationKey: ["SetDoeReferenceType"],
    mutationFn: (variables?: SetDoeReferenceTypeMutationVariables) =>
      adminFetcher<SetDoeReferenceTypeMutation, SetDoeReferenceTypeMutationVariables>(
        SetDoeReferenceTypeDocument,
        variables,
      )(),
    ...options,
  })
}

useSetDoeReferenceTypeMutation.fetcher = (
  variables: SetDoeReferenceTypeMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetDoeReferenceTypeMutation, SetDoeReferenceTypeMutationVariables>(
    SetDoeReferenceTypeDocument,
    variables,
    options,
  )

export const SetCostarPropertyTypeDocument = `
    mutation SetCostarPropertyType($sitePid: String!, $value: CoStarPropertyType!) {
  site {
    setCostarPropertyType(sitePid: $sitePid, value: $value) {
      pid
      costarPropertyType
    }
  }
}
    `

export const useSetCostarPropertyTypeMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetCostarPropertyTypeMutation,
    TError,
    SetCostarPropertyTypeMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetCostarPropertyTypeMutation,
    TError,
    SetCostarPropertyTypeMutationVariables,
    TContext
  >({
    mutationKey: ["SetCostarPropertyType"],
    mutationFn: (variables?: SetCostarPropertyTypeMutationVariables) =>
      adminFetcher<
        SetCostarPropertyTypeMutation,
        SetCostarPropertyTypeMutationVariables
      >(SetCostarPropertyTypeDocument, variables)(),
    ...options,
  })
}

useSetCostarPropertyTypeMutation.fetcher = (
  variables: SetCostarPropertyTypeMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetCostarPropertyTypeMutation, SetCostarPropertyTypeMutationVariables>(
    SetCostarPropertyTypeDocument,
    variables,
    options,
  )

export const SetCostarSecondaryTypeDocument = `
    mutation SetCostarSecondaryType($sitePid: String!, $value: CoStarSecondaryType) {
  site {
    setCostarSecondaryType(sitePid: $sitePid, value: $value) {
      pid
      costarSecondaryType
    }
  }
}
    `

export const useSetCostarSecondaryTypeMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetCostarSecondaryTypeMutation,
    TError,
    SetCostarSecondaryTypeMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetCostarSecondaryTypeMutation,
    TError,
    SetCostarSecondaryTypeMutationVariables,
    TContext
  >({
    mutationKey: ["SetCostarSecondaryType"],
    mutationFn: (variables?: SetCostarSecondaryTypeMutationVariables) =>
      adminFetcher<
        SetCostarSecondaryTypeMutation,
        SetCostarSecondaryTypeMutationVariables
      >(SetCostarSecondaryTypeDocument, variables)(),
    ...options,
  })
}

useSetCostarSecondaryTypeMutation.fetcher = (
  variables: SetCostarSecondaryTypeMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetCostarSecondaryTypeMutation, SetCostarSecondaryTypeMutationVariables>(
    SetCostarSecondaryTypeDocument,
    variables,
    options,
  )

export const SetCapRateDocument = `
    mutation SetCapRate($sitePid: String!, $value: Float) {
  site {
    setCapRate(sitePid: $sitePid, value: $value) {
      pid
      capRate
    }
  }
}
    `

export const useSetCapRateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetCapRateMutation,
    TError,
    SetCapRateMutationVariables,
    TContext
  >,
) => {
  return useMutation<SetCapRateMutation, TError, SetCapRateMutationVariables, TContext>(
    {
      mutationKey: ["SetCapRate"],
      mutationFn: (variables?: SetCapRateMutationVariables) =>
        adminFetcher<SetCapRateMutation, SetCapRateMutationVariables>(
          SetCapRateDocument,
          variables,
        )(),
      ...options,
    },
  )
}

useSetCapRateMutation.fetcher = (
  variables: SetCapRateMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetCapRateMutation, SetCapRateMutationVariables>(
    SetCapRateDocument,
    variables,
    options,
  )

export const SetZipCodeDocument = `
    mutation SetZipCode($sitePid: String!, $value: String!) {
  site {
    setZipCode(sitePid: $sitePid, value: $value) {
      pid
      zipCode
    }
  }
}
    `

export const useSetZipCodeMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetZipCodeMutation,
    TError,
    SetZipCodeMutationVariables,
    TContext
  >,
) => {
  return useMutation<SetZipCodeMutation, TError, SetZipCodeMutationVariables, TContext>(
    {
      mutationKey: ["SetZipCode"],
      mutationFn: (variables?: SetZipCodeMutationVariables) =>
        adminFetcher<SetZipCodeMutation, SetZipCodeMutationVariables>(
          SetZipCodeDocument,
          variables,
        )(),
      ...options,
    },
  )
}

useSetZipCodeMutation.fetcher = (
  variables: SetZipCodeMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetZipCodeMutation, SetZipCodeMutationVariables>(
    SetZipCodeDocument,
    variables,
    options,
  )

export const SetBuildingClassDocument = `
    mutation SetBuildingClass($sitePid: String!, $buildingClass: String) {
  site {
    setBuildingClass(sitePid: $sitePid, buildingClass: $buildingClass)
  }
}
    `

export const useSetBuildingClassMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetBuildingClassMutation,
    TError,
    SetBuildingClassMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetBuildingClassMutation,
    TError,
    SetBuildingClassMutationVariables,
    TContext
  >({
    mutationKey: ["SetBuildingClass"],
    mutationFn: (variables?: SetBuildingClassMutationVariables) =>
      adminFetcher<SetBuildingClassMutation, SetBuildingClassMutationVariables>(
        SetBuildingClassDocument,
        variables,
      )(),
    ...options,
  })
}

useSetBuildingClassMutation.fetcher = (
  variables: SetBuildingClassMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetBuildingClassMutation, SetBuildingClassMutationVariables>(
    SetBuildingClassDocument,
    variables,
    options,
  )

export const SetSqftDocument = `
    mutation SetSqft($sitePid: String!, $value: Float!) {
  site {
    setSqft(sitePid: $sitePid, value: $value) {
      pid
      sqft
    }
  }
}
    `

export const useSetSqftMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetSqftMutation,
    TError,
    SetSqftMutationVariables,
    TContext
  >,
) => {
  return useMutation<SetSqftMutation, TError, SetSqftMutationVariables, TContext>({
    mutationKey: ["SetSqft"],
    mutationFn: (variables?: SetSqftMutationVariables) =>
      adminFetcher<SetSqftMutation, SetSqftMutationVariables>(
        SetSqftDocument,
        variables,
      )(),
    ...options,
  })
}

useSetSqftMutation.fetcher = (
  variables: SetSqftMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetSqftMutation, SetSqftMutationVariables>(
    SetSqftDocument,
    variables,
    options,
  )

export const SetRoofSqftDocument = `
    mutation SetRoofSqft($sitePid: String!, $value: Float!, $sourceType: ChangeSourceType, $sourceId: String) {
  site {
    setRoofSqft(
      sitePid: $sitePid
      value: $value
      sourceType: $sourceType
      sourceId: $sourceId
    ) {
      pid
      roofSqft
    }
  }
}
    `

export const useSetRoofSqftMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetRoofSqftMutation,
    TError,
    SetRoofSqftMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetRoofSqftMutation,
    TError,
    SetRoofSqftMutationVariables,
    TContext
  >({
    mutationKey: ["SetRoofSqft"],
    mutationFn: (variables?: SetRoofSqftMutationVariables) =>
      adminFetcher<SetRoofSqftMutation, SetRoofSqftMutationVariables>(
        SetRoofSqftDocument,
        variables,
      )(),
    ...options,
  })
}

useSetRoofSqftMutation.fetcher = (
  variables: SetRoofSqftMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetRoofSqftMutation, SetRoofSqftMutationVariables>(
    SetRoofSqftDocument,
    variables,
    options,
  )

export const SetUsableRoofSqftDocument = `
    mutation SetUsableRoofSqft($sitePid: String!, $value: Float!) {
  site {
    setUsableRoofSqft(sitePid: $sitePid, value: $value) {
      pid
      usableRoofSqft
    }
  }
}
    `

export const useSetUsableRoofSqftMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetUsableRoofSqftMutation,
    TError,
    SetUsableRoofSqftMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetUsableRoofSqftMutation,
    TError,
    SetUsableRoofSqftMutationVariables,
    TContext
  >({
    mutationKey: ["SetUsableRoofSqft"],
    mutationFn: (variables?: SetUsableRoofSqftMutationVariables) =>
      adminFetcher<SetUsableRoofSqftMutation, SetUsableRoofSqftMutationVariables>(
        SetUsableRoofSqftDocument,
        variables,
      )(),
    ...options,
  })
}

useSetUsableRoofSqftMutation.fetcher = (
  variables: SetUsableRoofSqftMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetUsableRoofSqftMutation, SetUsableRoofSqftMutationVariables>(
    SetUsableRoofSqftDocument,
    variables,
    options,
  )

export const SetUsableRoofPctDocument = `
    mutation SetUsableRoofPct($sitePid: String!, $value: Float!) {
  site {
    setUsableRoofPct(sitePid: $sitePid, value: $value) {
      pid
      usableRoofPct
    }
  }
}
    `

export const useSetUsableRoofPctMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetUsableRoofPctMutation,
    TError,
    SetUsableRoofPctMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetUsableRoofPctMutation,
    TError,
    SetUsableRoofPctMutationVariables,
    TContext
  >({
    mutationKey: ["SetUsableRoofPct"],
    mutationFn: (variables?: SetUsableRoofPctMutationVariables) =>
      adminFetcher<SetUsableRoofPctMutation, SetUsableRoofPctMutationVariables>(
        SetUsableRoofPctDocument,
        variables,
      )(),
    ...options,
  })
}

useSetUsableRoofPctMutation.fetcher = (
  variables: SetUsableRoofPctMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetUsableRoofPctMutation, SetUsableRoofPctMutationVariables>(
    SetUsableRoofPctDocument,
    variables,
    options,
  )

export const SetGroundAvailableSqftDocument = `
    mutation SetGroundAvailableSqft($sitePid: String!, $value: Float!) {
  site {
    setGroundAvailableSqft(sitePid: $sitePid, value: $value) {
      pid
      groundAvailableSqft
    }
  }
}
    `

export const useSetGroundAvailableSqftMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetGroundAvailableSqftMutation,
    TError,
    SetGroundAvailableSqftMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetGroundAvailableSqftMutation,
    TError,
    SetGroundAvailableSqftMutationVariables,
    TContext
  >({
    mutationKey: ["SetGroundAvailableSqft"],
    mutationFn: (variables?: SetGroundAvailableSqftMutationVariables) =>
      adminFetcher<
        SetGroundAvailableSqftMutation,
        SetGroundAvailableSqftMutationVariables
      >(SetGroundAvailableSqftDocument, variables)(),
    ...options,
  })
}

useSetGroundAvailableSqftMutation.fetcher = (
  variables: SetGroundAvailableSqftMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetGroundAvailableSqftMutation, SetGroundAvailableSqftMutationVariables>(
    SetGroundAvailableSqftDocument,
    variables,
    options,
  )

export const SetUsableCarportFtDocument = `
    mutation SetUsableCarportFt($sitePid: String!, $value: Float!) {
  site {
    setUsableCarportFt(sitePid: $sitePid, value: $value) {
      pid
      usableCarportFt
    }
  }
}
    `

export const useSetUsableCarportFtMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetUsableCarportFtMutation,
    TError,
    SetUsableCarportFtMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetUsableCarportFtMutation,
    TError,
    SetUsableCarportFtMutationVariables,
    TContext
  >({
    mutationKey: ["SetUsableCarportFt"],
    mutationFn: (variables?: SetUsableCarportFtMutationVariables) =>
      adminFetcher<SetUsableCarportFtMutation, SetUsableCarportFtMutationVariables>(
        SetUsableCarportFtDocument,
        variables,
      )(),
    ...options,
  })
}

useSetUsableCarportFtMutation.fetcher = (
  variables: SetUsableCarportFtMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetUsableCarportFtMutation, SetUsableCarportFtMutationVariables>(
    SetUsableCarportFtDocument,
    variables,
    options,
  )

export const SetSlopedRoofDocument = `
    mutation SetSlopedRoof($sitePid: String!, $value: Boolean) {
  site {
    setSlopedRoof(sitePid: $sitePid, value: $value) {
      pid
      slopedRoof
    }
  }
}
    `

export const useSetSlopedRoofMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetSlopedRoofMutation,
    TError,
    SetSlopedRoofMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetSlopedRoofMutation,
    TError,
    SetSlopedRoofMutationVariables,
    TContext
  >({
    mutationKey: ["SetSlopedRoof"],
    mutationFn: (variables?: SetSlopedRoofMutationVariables) =>
      adminFetcher<SetSlopedRoofMutation, SetSlopedRoofMutationVariables>(
        SetSlopedRoofDocument,
        variables,
      )(),
    ...options,
  })
}

useSetSlopedRoofMutation.fetcher = (
  variables: SetSlopedRoofMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetSlopedRoofMutation, SetSlopedRoofMutationVariables>(
    SetSlopedRoofDocument,
    variables,
    options,
  )

export const SetYearBuiltDocument = `
    mutation SetYearBuilt($sitePid: String!, $value: Int) {
  site {
    setYearBuilt(sitePid: $sitePid, yearBuilt: $value) {
      pid
    }
  }
}
    `

export const useSetYearBuiltMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetYearBuiltMutation,
    TError,
    SetYearBuiltMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetYearBuiltMutation,
    TError,
    SetYearBuiltMutationVariables,
    TContext
  >({
    mutationKey: ["SetYearBuilt"],
    mutationFn: (variables?: SetYearBuiltMutationVariables) =>
      adminFetcher<SetYearBuiltMutation, SetYearBuiltMutationVariables>(
        SetYearBuiltDocument,
        variables,
      )(),
    ...options,
  })
}

useSetYearBuiltMutation.fetcher = (
  variables: SetYearBuiltMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetYearBuiltMutation, SetYearBuiltMutationVariables>(
    SetYearBuiltDocument,
    variables,
    options,
  )

export const SetNumStoriesDocument = `
    mutation SetNumStories($sitePid: String!, $value: Int) {
  site {
    setNumStories(sitePid: $sitePid, numStories: $value) {
      pid
    }
  }
}
    `

export const useSetNumStoriesMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetNumStoriesMutation,
    TError,
    SetNumStoriesMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetNumStoriesMutation,
    TError,
    SetNumStoriesMutationVariables,
    TContext
  >({
    mutationKey: ["SetNumStories"],
    mutationFn: (variables?: SetNumStoriesMutationVariables) =>
      adminFetcher<SetNumStoriesMutation, SetNumStoriesMutationVariables>(
        SetNumStoriesDocument,
        variables,
      )(),
    ...options,
  })
}

useSetNumStoriesMutation.fetcher = (
  variables: SetNumStoriesMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetNumStoriesMutation, SetNumStoriesMutationVariables>(
    SetNumStoriesDocument,
    variables,
    options,
  )

export const SetNumParkingSpacesDocument = `
    mutation SetNumParkingSpaces($sitePid: String!, $value: Int) {
  site {
    setNumParkingSpaces(sitePid: $sitePid, numParkingSpaces: $value) {
      pid
    }
  }
}
    `

export const useSetNumParkingSpacesMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetNumParkingSpacesMutation,
    TError,
    SetNumParkingSpacesMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetNumParkingSpacesMutation,
    TError,
    SetNumParkingSpacesMutationVariables,
    TContext
  >({
    mutationKey: ["SetNumParkingSpaces"],
    mutationFn: (variables?: SetNumParkingSpacesMutationVariables) =>
      adminFetcher<SetNumParkingSpacesMutation, SetNumParkingSpacesMutationVariables>(
        SetNumParkingSpacesDocument,
        variables,
      )(),
    ...options,
  })
}

useSetNumParkingSpacesMutation.fetcher = (
  variables: SetNumParkingSpacesMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetNumParkingSpacesMutation, SetNumParkingSpacesMutationVariables>(
    SetNumParkingSpacesDocument,
    variables,
    options,
  )

export const SetExistingSolarDocument = `
    mutation SetExistingSolar($sitePid: String!, $value: Boolean, $source: PhysicalCheckSource!) {
  site {
    setExistingSolar(sitePid: $sitePid, value: $value, source: $source) {
      pid
      physicalCheck {
        existingSolar
      }
    }
  }
}
    `

export const useSetExistingSolarMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetExistingSolarMutation,
    TError,
    SetExistingSolarMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetExistingSolarMutation,
    TError,
    SetExistingSolarMutationVariables,
    TContext
  >({
    mutationKey: ["SetExistingSolar"],
    mutationFn: (variables?: SetExistingSolarMutationVariables) =>
      adminFetcher<SetExistingSolarMutation, SetExistingSolarMutationVariables>(
        SetExistingSolarDocument,
        variables,
      )(),
    ...options,
  })
}

useSetExistingSolarMutation.fetcher = (
  variables: SetExistingSolarMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetExistingSolarMutation, SetExistingSolarMutationVariables>(
    SetExistingSolarDocument,
    variables,
    options,
  )

export const SetUnobstructedFlatRoofDocument = `
    mutation SetUnobstructedFlatRoof($sitePid: String!, $value: Boolean, $source: PhysicalCheckSource!) {
  site {
    setUnobstructedFlatRoof(sitePid: $sitePid, value: $value, source: $source) {
      pid
      physicalCheck {
        unobstructedFlatRoof
      }
    }
  }
}
    `

export const useSetUnobstructedFlatRoofMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetUnobstructedFlatRoofMutation,
    TError,
    SetUnobstructedFlatRoofMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetUnobstructedFlatRoofMutation,
    TError,
    SetUnobstructedFlatRoofMutationVariables,
    TContext
  >({
    mutationKey: ["SetUnobstructedFlatRoof"],
    mutationFn: (variables?: SetUnobstructedFlatRoofMutationVariables) =>
      adminFetcher<
        SetUnobstructedFlatRoofMutation,
        SetUnobstructedFlatRoofMutationVariables
      >(SetUnobstructedFlatRoofDocument, variables)(),
    ...options,
  })
}

useSetUnobstructedFlatRoofMutation.fetcher = (
  variables: SetUnobstructedFlatRoofMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    SetUnobstructedFlatRoofMutation,
    SetUnobstructedFlatRoofMutationVariables
  >(SetUnobstructedFlatRoofDocument, variables, options)

export const SetBadRoofDocument = `
    mutation SetBadRoof($sitePid: String!, $value: Boolean, $source: PhysicalCheckSource!) {
  site {
    setBadRoof(sitePid: $sitePid, value: $value, source: $source) {
      pid
      physicalCheck {
        badRoof
      }
    }
  }
}
    `

export const useSetBadRoofMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetBadRoofMutation,
    TError,
    SetBadRoofMutationVariables,
    TContext
  >,
) => {
  return useMutation<SetBadRoofMutation, TError, SetBadRoofMutationVariables, TContext>(
    {
      mutationKey: ["SetBadRoof"],
      mutationFn: (variables?: SetBadRoofMutationVariables) =>
        adminFetcher<SetBadRoofMutation, SetBadRoofMutationVariables>(
          SetBadRoofDocument,
          variables,
        )(),
      ...options,
    },
  )
}

useSetBadRoofMutation.fetcher = (
  variables: SetBadRoofMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetBadRoofMutation, SetBadRoofMutationVariables>(
    SetBadRoofDocument,
    variables,
    options,
  )

export const SetCustomerIdDocument = `
    mutation SetCustomerId($sitePid: String!, $customerId: String) {
  site {
    setCustomerId(sitePid: $sitePid, customerId: $customerId)
  }
}
    `

export const useSetCustomerIdMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetCustomerIdMutation,
    TError,
    SetCustomerIdMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetCustomerIdMutation,
    TError,
    SetCustomerIdMutationVariables,
    TContext
  >({
    mutationKey: ["SetCustomerId"],
    mutationFn: (variables?: SetCustomerIdMutationVariables) =>
      adminFetcher<SetCustomerIdMutation, SetCustomerIdMutationVariables>(
        SetCustomerIdDocument,
        variables,
      )(),
    ...options,
  })
}

useSetCustomerIdMutation.fetcher = (
  variables: SetCustomerIdMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetCustomerIdMutation, SetCustomerIdMutationVariables>(
    SetCustomerIdDocument,
    variables,
    options,
  )

export const TrashAttachmentDocument = `
    mutation TrashAttachment($pid: String!, $attachmentId: Int!) {
  site {
    trashAttachment(pid: $pid, attachmentId: $attachmentId) {
      pid
      roofImage {
        id
        name
      }
      attachments {
        id
        trashedAt
        isTrashable
        isRoofImageCandidate
      }
    }
  }
}
    `

export const useTrashAttachmentMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    TrashAttachmentMutation,
    TError,
    TrashAttachmentMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    TrashAttachmentMutation,
    TError,
    TrashAttachmentMutationVariables,
    TContext
  >({
    mutationKey: ["TrashAttachment"],
    mutationFn: (variables?: TrashAttachmentMutationVariables) =>
      adminFetcher<TrashAttachmentMutation, TrashAttachmentMutationVariables>(
        TrashAttachmentDocument,
        variables,
      )(),
    ...options,
  })
}

useTrashAttachmentMutation.fetcher = (
  variables: TrashAttachmentMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<TrashAttachmentMutation, TrashAttachmentMutationVariables>(
    TrashAttachmentDocument,
    variables,
    options,
  )

export const SetSiteHiddenFromCustomersDocument = `
    mutation SetSiteHiddenFromCustomers($sitePid: String!, $hiddenFromCustomers: Boolean!) {
  site {
    setSiteHiddenFromCustomers(
      sitePid: $sitePid
      hiddenFromCustomers: $hiddenFromCustomers
    ) {
      pid
      hiddenFromCustomers
    }
  }
}
    `

export const useSetSiteHiddenFromCustomersMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetSiteHiddenFromCustomersMutation,
    TError,
    SetSiteHiddenFromCustomersMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetSiteHiddenFromCustomersMutation,
    TError,
    SetSiteHiddenFromCustomersMutationVariables,
    TContext
  >({
    mutationKey: ["SetSiteHiddenFromCustomers"],
    mutationFn: (variables?: SetSiteHiddenFromCustomersMutationVariables) =>
      adminFetcher<
        SetSiteHiddenFromCustomersMutation,
        SetSiteHiddenFromCustomersMutationVariables
      >(SetSiteHiddenFromCustomersDocument, variables)(),
    ...options,
  })
}

useSetSiteHiddenFromCustomersMutation.fetcher = (
  variables: SetSiteHiddenFromCustomersMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    SetSiteHiddenFromCustomersMutation,
    SetSiteHiddenFromCustomersMutationVariables
  >(SetSiteHiddenFromCustomersDocument, variables, options)

export const AttachFileDocument = `
    mutation AttachFile($pid: String!, $file: Upload!, $tag: String) {
  site {
    attachFile(pid: $pid, upload: $file, tag: $tag) {
      __typename
      ... on Site {
        pid
        attachments {
          ...AttachmentFragment
        }
      }
      ... on DuplicatesAttachment {
        attachment {
          name
        }
      }
      ... on Error {
        message
      }
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${UserRefFragmentDoc}`

export const useAttachFileMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AttachFileMutation,
    TError,
    AttachFileMutationVariables,
    TContext
  >,
) => {
  return useMutation<AttachFileMutation, TError, AttachFileMutationVariables, TContext>(
    {
      mutationKey: ["AttachFile"],
      mutationFn: (variables?: AttachFileMutationVariables) =>
        adminFetcher<AttachFileMutation, AttachFileMutationVariables>(
          AttachFileDocument,
          variables,
        )(),
      ...options,
    },
  )
}

useAttachFileMutation.fetcher = (
  variables: AttachFileMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AttachFileMutation, AttachFileMutationVariables>(
    AttachFileDocument,
    variables,
    options,
  )

export const CreateUserDocument = `
    mutation CreateUser($email: String!, $name: String, $orgPid: String!, $portfolioPids: [String!]!, $sendInvite: Boolean!) {
  user {
    new(
      email: $email
      name: $name
      orgPid: $orgPid
      portfolioPids: $portfolioPids
      sendInvite: $sendInvite
    ) {
      __typename
      ... on AdminUser {
        id
        email
        name
      }
      ... on Error {
        message
      }
    }
  }
}
    `

export const useCreateUserMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateUserMutation,
    TError,
    CreateUserMutationVariables,
    TContext
  >,
) => {
  return useMutation<CreateUserMutation, TError, CreateUserMutationVariables, TContext>(
    {
      mutationKey: ["CreateUser"],
      mutationFn: (variables?: CreateUserMutationVariables) =>
        adminFetcher<CreateUserMutation, CreateUserMutationVariables>(
          CreateUserDocument,
          variables,
        )(),
      ...options,
    },
  )
}

useCreateUserMutation.fetcher = (
  variables: CreateUserMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<CreateUserMutation, CreateUserMutationVariables>(
    CreateUserDocument,
    variables,
    options,
  )

export const ChangeUserNameDocument = `
    mutation ChangeUserName($id: Int!, $name: String!) {
  user {
    setName(id: $id, name: $name) {
      id
      name
    }
  }
}
    `

export const useChangeUserNameMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ChangeUserNameMutation,
    TError,
    ChangeUserNameMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ChangeUserNameMutation,
    TError,
    ChangeUserNameMutationVariables,
    TContext
  >({
    mutationKey: ["ChangeUserName"],
    mutationFn: (variables?: ChangeUserNameMutationVariables) =>
      adminFetcher<ChangeUserNameMutation, ChangeUserNameMutationVariables>(
        ChangeUserNameDocument,
        variables,
      )(),
    ...options,
  })
}

useChangeUserNameMutation.fetcher = (
  variables: ChangeUserNameMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ChangeUserNameMutation, ChangeUserNameMutationVariables>(
    ChangeUserNameDocument,
    variables,
    options,
  )

export const SetUserMeetingUrlDocument = `
    mutation SetUserMeetingUrl($id: Int!, $url: String!) {
  user {
    setMeetingSchedulingUrl(userId: $id, url: $url) {
      __typename
      ... on Error {
        message
      }
      ... on AdminUser {
        id
        name
        email
        meetingSchedulingUrl
      }
    }
  }
}
    `

export const useSetUserMeetingUrlMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetUserMeetingUrlMutation,
    TError,
    SetUserMeetingUrlMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetUserMeetingUrlMutation,
    TError,
    SetUserMeetingUrlMutationVariables,
    TContext
  >({
    mutationKey: ["SetUserMeetingUrl"],
    mutationFn: (variables?: SetUserMeetingUrlMutationVariables) =>
      adminFetcher<SetUserMeetingUrlMutation, SetUserMeetingUrlMutationVariables>(
        SetUserMeetingUrlDocument,
        variables,
      )(),
    ...options,
  })
}

useSetUserMeetingUrlMutation.fetcher = (
  variables: SetUserMeetingUrlMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetUserMeetingUrlMutation, SetUserMeetingUrlMutationVariables>(
    SetUserMeetingUrlDocument,
    variables,
    options,
  )

export const InviteToPortfolioDocument = `
    mutation InviteToPortfolio($email: String!, $orgPid: String!, $portfolioPid: String!) {
  user {
    inviteToPortfolio(email: $email, orgPid: $orgPid, portfolioPid: $portfolioPid)
  }
}
    `

export const useInviteToPortfolioMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    InviteToPortfolioMutation,
    TError,
    InviteToPortfolioMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    InviteToPortfolioMutation,
    TError,
    InviteToPortfolioMutationVariables,
    TContext
  >({
    mutationKey: ["InviteToPortfolio"],
    mutationFn: (variables?: InviteToPortfolioMutationVariables) =>
      adminFetcher<InviteToPortfolioMutation, InviteToPortfolioMutationVariables>(
        InviteToPortfolioDocument,
        variables,
      )(),
    ...options,
  })
}

useInviteToPortfolioMutation.fetcher = (
  variables: InviteToPortfolioMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<InviteToPortfolioMutation, InviteToPortfolioMutationVariables>(
    InviteToPortfolioDocument,
    variables,
    options,
  )

export const GiveMeAMagicLinkDocument = `
    mutation GiveMeAMagicLink($email: String!) {
  user {
    giveMeAMagicLink(email: $email) {
      href
      expiresAt
    }
  }
}
    `

export const useGiveMeAMagicLinkMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    GiveMeAMagicLinkMutation,
    TError,
    GiveMeAMagicLinkMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    GiveMeAMagicLinkMutation,
    TError,
    GiveMeAMagicLinkMutationVariables,
    TContext
  >({
    mutationKey: ["GiveMeAMagicLink"],
    mutationFn: (variables?: GiveMeAMagicLinkMutationVariables) =>
      adminFetcher<GiveMeAMagicLinkMutation, GiveMeAMagicLinkMutationVariables>(
        GiveMeAMagicLinkDocument,
        variables,
      )(),
    ...options,
  })
}

useGiveMeAMagicLinkMutation.fetcher = (
  variables: GiveMeAMagicLinkMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<GiveMeAMagicLinkMutation, GiveMeAMagicLinkMutationVariables>(
    GiveMeAMagicLinkDocument,
    variables,
    options,
  )

export const AddUserToPortfolioDocument = `
    mutation AddUserToPortfolio($userId: Int!, $portfolioPid: String!, $sendEmail: Boolean!) {
  user {
    addToPortfolio(
      userId: $userId
      portfolioPid: $portfolioPid
      sendEmail: $sendEmail
    ) {
      id
      pid
    }
  }
}
    `

export const useAddUserToPortfolioMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AddUserToPortfolioMutation,
    TError,
    AddUserToPortfolioMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AddUserToPortfolioMutation,
    TError,
    AddUserToPortfolioMutationVariables,
    TContext
  >({
    mutationKey: ["AddUserToPortfolio"],
    mutationFn: (variables?: AddUserToPortfolioMutationVariables) =>
      adminFetcher<AddUserToPortfolioMutation, AddUserToPortfolioMutationVariables>(
        AddUserToPortfolioDocument,
        variables,
      )(),
    ...options,
  })
}

useAddUserToPortfolioMutation.fetcher = (
  variables: AddUserToPortfolioMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AddUserToPortfolioMutation, AddUserToPortfolioMutationVariables>(
    AddUserToPortfolioDocument,
    variables,
    options,
  )

export const RemoveFromPortfolioDocument = `
    mutation RemoveFromPortfolio($userId: Int!, $portfolioPid: String!) {
  user {
    removeFromPortfolio(userId: $userId, portfolioPid: $portfolioPid) {
      id
      pid
    }
  }
}
    `

export const useRemoveFromPortfolioMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    RemoveFromPortfolioMutation,
    TError,
    RemoveFromPortfolioMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RemoveFromPortfolioMutation,
    TError,
    RemoveFromPortfolioMutationVariables,
    TContext
  >({
    mutationKey: ["RemoveFromPortfolio"],
    mutationFn: (variables?: RemoveFromPortfolioMutationVariables) =>
      adminFetcher<RemoveFromPortfolioMutation, RemoveFromPortfolioMutationVariables>(
        RemoveFromPortfolioDocument,
        variables,
      )(),
    ...options,
  })
}

useRemoveFromPortfolioMutation.fetcher = (
  variables: RemoveFromPortfolioMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<RemoveFromPortfolioMutation, RemoveFromPortfolioMutationVariables>(
    RemoveFromPortfolioDocument,
    variables,
    options,
  )

export const SetRoofMaxPvKwDocument = `
    mutation SetRoofMaxPvKw($sitePid: String!, $value: Float) {
  site {
    setRoofMaxPvKw(sitePid: $sitePid, value: $value) {
      pid
      roofMaxPvKw
    }
  }
}
    `

export const useSetRoofMaxPvKwMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetRoofMaxPvKwMutation,
    TError,
    SetRoofMaxPvKwMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetRoofMaxPvKwMutation,
    TError,
    SetRoofMaxPvKwMutationVariables,
    TContext
  >({
    mutationKey: ["SetRoofMaxPvKw"],
    mutationFn: (variables?: SetRoofMaxPvKwMutationVariables) =>
      adminFetcher<SetRoofMaxPvKwMutation, SetRoofMaxPvKwMutationVariables>(
        SetRoofMaxPvKwDocument,
        variables,
      )(),
    ...options,
  })
}

useSetRoofMaxPvKwMutation.fetcher = (
  variables: SetRoofMaxPvKwMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetRoofMaxPvKwMutation, SetRoofMaxPvKwMutationVariables>(
    SetRoofMaxPvKwDocument,
    variables,
    options,
  )

export const SetCarportMaxPvKwDocument = `
    mutation SetCarportMaxPvKw($sitePid: String!, $value: Float) {
  site {
    setCarportMaxPvKw(sitePid: $sitePid, value: $value) {
      pid
      carportMaxPvKw
    }
  }
}
    `

export const useSetCarportMaxPvKwMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetCarportMaxPvKwMutation,
    TError,
    SetCarportMaxPvKwMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetCarportMaxPvKwMutation,
    TError,
    SetCarportMaxPvKwMutationVariables,
    TContext
  >({
    mutationKey: ["SetCarportMaxPvKw"],
    mutationFn: (variables?: SetCarportMaxPvKwMutationVariables) =>
      adminFetcher<SetCarportMaxPvKwMutation, SetCarportMaxPvKwMutationVariables>(
        SetCarportMaxPvKwDocument,
        variables,
      )(),
    ...options,
  })
}

useSetCarportMaxPvKwMutation.fetcher = (
  variables: SetCarportMaxPvKwMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetCarportMaxPvKwMutation, SetCarportMaxPvKwMutationVariables>(
    SetCarportMaxPvKwDocument,
    variables,
    options,
  )

export const SetGroundMaxPvKwDocument = `
    mutation SetGroundMaxPvKw($sitePid: String!, $value: Float) {
  site {
    setGroundMaxPvKw(sitePid: $sitePid, value: $value) {
      pid
      groundMaxPvKw
    }
  }
}
    `

export const useSetGroundMaxPvKwMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetGroundMaxPvKwMutation,
    TError,
    SetGroundMaxPvKwMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetGroundMaxPvKwMutation,
    TError,
    SetGroundMaxPvKwMutationVariables,
    TContext
  >({
    mutationKey: ["SetGroundMaxPvKw"],
    mutationFn: (variables?: SetGroundMaxPvKwMutationVariables) =>
      adminFetcher<SetGroundMaxPvKwMutation, SetGroundMaxPvKwMutationVariables>(
        SetGroundMaxPvKwDocument,
        variables,
      )(),
    ...options,
  })
}

useSetGroundMaxPvKwMutation.fetcher = (
  variables: SetGroundMaxPvKwMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetGroundMaxPvKwMutation, SetGroundMaxPvKwMutationVariables>(
    SetGroundMaxPvKwDocument,
    variables,
    options,
  )

export const UpdateTariffDocument = `
    mutation UpdateTariff($id: Int!, $isPreferred: Boolean, $requiresPv: Boolean, $requiresStorage: Boolean) {
  tariff {
    setFields(
      id: $id
      isPreferred: $isPreferred
      requiresPv: $requiresPv
      requiresStorage: $requiresStorage
    ) {
      id
      isPreferred
      requiresPv
      requiresStorage
    }
  }
}
    `

export const useUpdateTariffMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateTariffMutation,
    TError,
    UpdateTariffMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateTariffMutation,
    TError,
    UpdateTariffMutationVariables,
    TContext
  >({
    mutationKey: ["UpdateTariff"],
    mutationFn: (variables?: UpdateTariffMutationVariables) =>
      adminFetcher<UpdateTariffMutation, UpdateTariffMutationVariables>(
        UpdateTariffDocument,
        variables,
      )(),
    ...options,
  })
}

useUpdateTariffMutation.fetcher = (
  variables: UpdateTariffMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<UpdateTariffMutation, UpdateTariffMutationVariables>(
    UpdateTariffDocument,
    variables,
    options,
  )

export const AddOverrideDocument = `
    mutation AddOverride($sitePid: String, $portfolioPid: String, $orgPid: String, $finProductId: Int, $inputName: String!, $inputValue: String!) {
  finmodel {
    addOverride(
      sitePid: $sitePid
      portfolioPid: $portfolioPid
      orgPid: $orgPid
      finproductId: $finProductId
      inputName: $inputName
      inputValue: $inputValue
    ) {
      __typename
      ... on Error {
        message
      }
      ... on FinmodelInputOverride {
        inputName
        inputValue
      }
    }
  }
}
    `

export const useAddOverrideMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AddOverrideMutation,
    TError,
    AddOverrideMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AddOverrideMutation,
    TError,
    AddOverrideMutationVariables,
    TContext
  >({
    mutationKey: ["AddOverride"],
    mutationFn: (variables?: AddOverrideMutationVariables) =>
      adminFetcher<AddOverrideMutation, AddOverrideMutationVariables>(
        AddOverrideDocument,
        variables,
      )(),
    ...options,
  })
}

useAddOverrideMutation.fetcher = (
  variables: AddOverrideMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AddOverrideMutation, AddOverrideMutationVariables>(
    AddOverrideDocument,
    variables,
    options,
  )

export const DeleteOverrideDocument = `
    mutation DeleteOverride($sitePid: String, $portfolioPid: String, $orgPid: String, $finProductId: Int, $inputName: String!) {
  finmodel {
    deleteOverride(
      sitePid: $sitePid
      portfolioPid: $portfolioPid
      orgPid: $orgPid
      finproductId: $finProductId
      inputName: $inputName
    ) {
      inputName
      inputValue
    }
  }
}
    `

export const useDeleteOverrideMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteOverrideMutation,
    TError,
    DeleteOverrideMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeleteOverrideMutation,
    TError,
    DeleteOverrideMutationVariables,
    TContext
  >({
    mutationKey: ["DeleteOverride"],
    mutationFn: (variables?: DeleteOverrideMutationVariables) =>
      adminFetcher<DeleteOverrideMutation, DeleteOverrideMutationVariables>(
        DeleteOverrideDocument,
        variables,
      )(),
    ...options,
  })
}

useDeleteOverrideMutation.fetcher = (
  variables: DeleteOverrideMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<DeleteOverrideMutation, DeleteOverrideMutationVariables>(
    DeleteOverrideDocument,
    variables,
    options,
  )

export const SetPortfolioMinKwDocument = `
    mutation SetPortfolioMinKw($portfolioPid: String!, $minKw: Float) {
  portfolio {
    setPortfolioMinKw(portfolioPid: $portfolioPid, minKw: $minKw) {
      pid
      minKw
      minKwSetBy
      minKwSetDate
    }
  }
}
    `

export const useSetPortfolioMinKwMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetPortfolioMinKwMutation,
    TError,
    SetPortfolioMinKwMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetPortfolioMinKwMutation,
    TError,
    SetPortfolioMinKwMutationVariables,
    TContext
  >({
    mutationKey: ["SetPortfolioMinKw"],
    mutationFn: (variables?: SetPortfolioMinKwMutationVariables) =>
      adminFetcher<SetPortfolioMinKwMutation, SetPortfolioMinKwMutationVariables>(
        SetPortfolioMinKwDocument,
        variables,
      )(),
    ...options,
  })
}

useSetPortfolioMinKwMutation.fetcher = (
  variables: SetPortfolioMinKwMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetPortfolioMinKwMutation, SetPortfolioMinKwMutationVariables>(
    SetPortfolioMinKwDocument,
    variables,
    options,
  )

export const SetEtbProjectNameDocument = `
    mutation SetEtbProjectName($etbId: Int!, $name: String!) {
  etb(etbId: $etbId) {
    setProjectName(name: $name) {
      id
      projectName
    }
  }
}
    `

export const useSetEtbProjectNameMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetEtbProjectNameMutation,
    TError,
    SetEtbProjectNameMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetEtbProjectNameMutation,
    TError,
    SetEtbProjectNameMutationVariables,
    TContext
  >({
    mutationKey: ["SetEtbProjectName"],
    mutationFn: (variables?: SetEtbProjectNameMutationVariables) =>
      adminFetcher<SetEtbProjectNameMutation, SetEtbProjectNameMutationVariables>(
        SetEtbProjectNameDocument,
        variables,
      )(),
    ...options,
  })
}

useSetEtbProjectNameMutation.fetcher = (
  variables: SetEtbProjectNameMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetEtbProjectNameMutation, SetEtbProjectNameMutationVariables>(
    SetEtbProjectNameDocument,
    variables,
    options,
  )

export const SetEtbMeterTariffBeforeDocument = `
    mutation SetEtbMeterTariffBefore($etbMeterId: Int!, $tariffId: Int) {
  etbMeter {
    setTariffBefore(id: $etbMeterId, tariffBeforeId: $tariffId) {
      id
      genabilityTariffBefore: tariffBefore {
        id
        name
        code
      }
    }
  }
}
    `

export const useSetEtbMeterTariffBeforeMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetEtbMeterTariffBeforeMutation,
    TError,
    SetEtbMeterTariffBeforeMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetEtbMeterTariffBeforeMutation,
    TError,
    SetEtbMeterTariffBeforeMutationVariables,
    TContext
  >({
    mutationKey: ["SetEtbMeterTariffBefore"],
    mutationFn: (variables?: SetEtbMeterTariffBeforeMutationVariables) =>
      adminFetcher<
        SetEtbMeterTariffBeforeMutation,
        SetEtbMeterTariffBeforeMutationVariables
      >(SetEtbMeterTariffBeforeDocument, variables)(),
    ...options,
  })
}

useSetEtbMeterTariffBeforeMutation.fetcher = (
  variables: SetEtbMeterTariffBeforeMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    SetEtbMeterTariffBeforeMutation,
    SetEtbMeterTariffBeforeMutationVariables
  >(SetEtbMeterTariffBeforeDocument, variables, options)

export const SetEtbMeterTariffAfterDocument = `
    mutation SetEtbMeterTariffAfter($etbMeterId: Int!, $tariffId: Int) {
  etbMeter {
    setTariffAfter(id: $etbMeterId, tariffAfterId: $tariffId) {
      id
      genabilityTariffAfter: tariffAfter {
        id
        name
        code
      }
    }
  }
}
    `

export const useSetEtbMeterTariffAfterMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetEtbMeterTariffAfterMutation,
    TError,
    SetEtbMeterTariffAfterMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetEtbMeterTariffAfterMutation,
    TError,
    SetEtbMeterTariffAfterMutationVariables,
    TContext
  >({
    mutationKey: ["SetEtbMeterTariffAfter"],
    mutationFn: (variables?: SetEtbMeterTariffAfterMutationVariables) =>
      adminFetcher<
        SetEtbMeterTariffAfterMutation,
        SetEtbMeterTariffAfterMutationVariables
      >(SetEtbMeterTariffAfterDocument, variables)(),
    ...options,
  })
}

useSetEtbMeterTariffAfterMutation.fetcher = (
  variables: SetEtbMeterTariffAfterMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetEtbMeterTariffAfterMutation, SetEtbMeterTariffAfterMutationVariables>(
    SetEtbMeterTariffAfterDocument,
    variables,
    options,
  )

export const SetEtbMeterBauMeterDocument = `
    mutation SetEtbMeterBauMeter($etbMeterId: Int!, $bauMeterId: Int!) {
  etbMeter {
    setBauMeter(id: $etbMeterId, bauMeterId: $bauMeterId) {
      id
    }
  }
}
    `

export const useSetEtbMeterBauMeterMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetEtbMeterBauMeterMutation,
    TError,
    SetEtbMeterBauMeterMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetEtbMeterBauMeterMutation,
    TError,
    SetEtbMeterBauMeterMutationVariables,
    TContext
  >({
    mutationKey: ["SetEtbMeterBauMeter"],
    mutationFn: (variables?: SetEtbMeterBauMeterMutationVariables) =>
      adminFetcher<SetEtbMeterBauMeterMutation, SetEtbMeterBauMeterMutationVariables>(
        SetEtbMeterBauMeterDocument,
        variables,
      )(),
    ...options,
  })
}

useSetEtbMeterBauMeterMutation.fetcher = (
  variables: SetEtbMeterBauMeterMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetEtbMeterBauMeterMutation, SetEtbMeterBauMeterMutationVariables>(
    SetEtbMeterBauMeterDocument,
    variables,
    options,
  )

export const SetETbMeterPvTypeDocument = `
    mutation SetETbMeterPvType($etbMeterId: Int!, $pvType: PVType) {
  etbMeter {
    setPvType(id: $etbMeterId, pvType: $pvType) {
      id
    }
  }
}
    `

export const useSetETbMeterPvTypeMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetETbMeterPvTypeMutation,
    TError,
    SetETbMeterPvTypeMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetETbMeterPvTypeMutation,
    TError,
    SetETbMeterPvTypeMutationVariables,
    TContext
  >({
    mutationKey: ["SetETbMeterPvType"],
    mutationFn: (variables?: SetETbMeterPvTypeMutationVariables) =>
      adminFetcher<SetETbMeterPvTypeMutation, SetETbMeterPvTypeMutationVariables>(
        SetETbMeterPvTypeDocument,
        variables,
      )(),
    ...options,
  })
}

useSetETbMeterPvTypeMutation.fetcher = (
  variables: SetETbMeterPvTypeMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetETbMeterPvTypeMutation, SetETbMeterPvTypeMutationVariables>(
    SetETbMeterPvTypeDocument,
    variables,
    options,
  )

export const SetSiteStatusDocument = `
    mutation SetSiteStatus($sitePid: String!, $status: SiteStatus!, $reason: StatusReason, $customReason: String, $unixtimeSec: Int) {
  site {
    setStatus(
      status: $status
      sitePid: $sitePid
      reason: $reason
      customReason: $customReason
      unixtimeSec: $unixtimeSec
    ) {
      pid
      currentStatus {
        pid
      }
    }
  }
}
    `

export const useSetSiteStatusMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetSiteStatusMutation,
    TError,
    SetSiteStatusMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetSiteStatusMutation,
    TError,
    SetSiteStatusMutationVariables,
    TContext
  >({
    mutationKey: ["SetSiteStatus"],
    mutationFn: (variables?: SetSiteStatusMutationVariables) =>
      adminFetcher<SetSiteStatusMutation, SetSiteStatusMutationVariables>(
        SetSiteStatusDocument,
        variables,
      )(),
    ...options,
  })
}

useSetSiteStatusMutation.fetcher = (
  variables: SetSiteStatusMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetSiteStatusMutation, SetSiteStatusMutationVariables>(
    SetSiteStatusDocument,
    variables,
    options,
  )

export const SetPrimaryScenarioDocument = `
    mutation SetPrimaryScenario($scenarioPid: String!) {
  scenario(scenarioPid: $scenarioPid) {
    setPrimary {
      pid
      scenarios {
        pid
        isPrimary
      }
    }
  }
}
    `

export const useSetPrimaryScenarioMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetPrimaryScenarioMutation,
    TError,
    SetPrimaryScenarioMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetPrimaryScenarioMutation,
    TError,
    SetPrimaryScenarioMutationVariables,
    TContext
  >({
    mutationKey: ["SetPrimaryScenario"],
    mutationFn: (variables?: SetPrimaryScenarioMutationVariables) =>
      adminFetcher<SetPrimaryScenarioMutation, SetPrimaryScenarioMutationVariables>(
        SetPrimaryScenarioDocument,
        variables,
      )(),
    ...options,
  })
}

useSetPrimaryScenarioMutation.fetcher = (
  variables: SetPrimaryScenarioMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetPrimaryScenarioMutation, SetPrimaryScenarioMutationVariables>(
    SetPrimaryScenarioDocument,
    variables,
    options,
  )

export const SetScenarioNameDocument = `
    mutation SetScenarioName($scenarioPid: String!, $name: String!) {
  scenario(scenarioPid: $scenarioPid) {
    setName(name: $name) {
      pid
      scenarios {
        pid
        name
      }
    }
  }
}
    `

export const useSetScenarioNameMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetScenarioNameMutation,
    TError,
    SetScenarioNameMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetScenarioNameMutation,
    TError,
    SetScenarioNameMutationVariables,
    TContext
  >({
    mutationKey: ["SetScenarioName"],
    mutationFn: (variables?: SetScenarioNameMutationVariables) =>
      adminFetcher<SetScenarioNameMutation, SetScenarioNameMutationVariables>(
        SetScenarioNameDocument,
        variables,
      )(),
    ...options,
  })
}

useSetScenarioNameMutation.fetcher = (
  variables: SetScenarioNameMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetScenarioNameMutation, SetScenarioNameMutationVariables>(
    SetScenarioNameDocument,
    variables,
    options,
  )

export const SetScenarioEtbDocument = `
    mutation SetScenarioETB($scenarioPid: String!, $etbId: Int) {
  scenario(scenarioPid: $scenarioPid) {
    setEtb(etbId: $etbId) {
      pid
      activeEtbReport {
        id
        projectName
      }
    }
  }
}
    `

export const useSetScenarioEtbMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetScenarioEtbMutation,
    TError,
    SetScenarioEtbMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetScenarioEtbMutation,
    TError,
    SetScenarioEtbMutationVariables,
    TContext
  >({
    mutationKey: ["SetScenarioETB"],
    mutationFn: (variables?: SetScenarioEtbMutationVariables) =>
      adminFetcher<SetScenarioEtbMutation, SetScenarioEtbMutationVariables>(
        SetScenarioEtbDocument,
        variables,
      )(),
    ...options,
  })
}

useSetScenarioEtbMutation.fetcher = (
  variables: SetScenarioEtbMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetScenarioEtbMutation, SetScenarioEtbMutationVariables>(
    SetScenarioEtbDocument,
    variables,
    options,
  )

export const AddScenarioDocument = `
    mutation AddScenario($sitePid: String!, $solarLocation: SolarLocation!, $includeStorage: Boolean!, $loadCategory: LoadCategory!, $name: String) {
  site {
    addScenario(
      sitePid: $sitePid
      solarLocation: $solarLocation
      includeStorage: $includeStorage
      loadCategory: $loadCategory
      name: $name
    ) {
      __typename
      ... on ScenarioRef {
        pid
      }
      ... on Error {
        message
      }
    }
  }
}
    `

export const useAddScenarioMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AddScenarioMutation,
    TError,
    AddScenarioMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AddScenarioMutation,
    TError,
    AddScenarioMutationVariables,
    TContext
  >({
    mutationKey: ["AddScenario"],
    mutationFn: (variables?: AddScenarioMutationVariables) =>
      adminFetcher<AddScenarioMutation, AddScenarioMutationVariables>(
        AddScenarioDocument,
        variables,
      )(),
    ...options,
  })
}

useAddScenarioMutation.fetcher = (
  variables: AddScenarioMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AddScenarioMutation, AddScenarioMutationVariables>(
    AddScenarioDocument,
    variables,
    options,
  )

export const ToggleScenarioVisibilityDocument = `
    mutation ToggleScenarioVisibility($scenarioPid: String!, $hidden: Boolean!) {
  scenario(scenarioPid: $scenarioPid) {
    toggleVisibility(hidden: $hidden) {
      pid
      hiddenFromCustomers
    }
  }
}
    `

export const useToggleScenarioVisibilityMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    ToggleScenarioVisibilityMutation,
    TError,
    ToggleScenarioVisibilityMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ToggleScenarioVisibilityMutation,
    TError,
    ToggleScenarioVisibilityMutationVariables,
    TContext
  >({
    mutationKey: ["ToggleScenarioVisibility"],
    mutationFn: (variables?: ToggleScenarioVisibilityMutationVariables) =>
      adminFetcher<
        ToggleScenarioVisibilityMutation,
        ToggleScenarioVisibilityMutationVariables
      >(ToggleScenarioVisibilityDocument, variables)(),
    ...options,
  })
}

useToggleScenarioVisibilityMutation.fetcher = (
  variables: ToggleScenarioVisibilityMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    ToggleScenarioVisibilityMutation,
    ToggleScenarioVisibilityMutationVariables
  >(ToggleScenarioVisibilityDocument, variables, options)

export const ToggleMulticonnectDocument = `
    mutation ToggleMulticonnect($scenarioPid: String!, $allow: Boolean!) {
  scenario(scenarioPid: $scenarioPid) {
    toggleMulticonnect(allow: $allow) {
      pid
      allowMulticonnect
    }
  }
}
    `

export const useToggleMulticonnectMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ToggleMulticonnectMutation,
    TError,
    ToggleMulticonnectMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ToggleMulticonnectMutation,
    TError,
    ToggleMulticonnectMutationVariables,
    TContext
  >({
    mutationKey: ["ToggleMulticonnect"],
    mutationFn: (variables?: ToggleMulticonnectMutationVariables) =>
      adminFetcher<ToggleMulticonnectMutation, ToggleMulticonnectMutationVariables>(
        ToggleMulticonnectDocument,
        variables,
      )(),
    ...options,
  })
}

useToggleMulticonnectMutation.fetcher = (
  variables: ToggleMulticonnectMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ToggleMulticonnectMutation, ToggleMulticonnectMutationVariables>(
    ToggleMulticonnectDocument,
    variables,
    options,
  )

export const AddEtbDocument = `
    mutation AddETB($sitePid: String!, $scenarioPid: String!, $loadOrigin: LoadOrigin!, $upload: Upload!, $roofPvKw: Float, $carportPvKw: Float, $makeActive: Boolean!) {
  site {
    addEtb(
      sitePid: $sitePid
      scenarioPid: $scenarioPid
      loadOrigin: $loadOrigin
      upload: $upload
      roofPvKw: $roofPvKw
      carportPvKw: $carportPvKw
      makeActive: $makeActive
    ) {
      pid
    }
  }
}
    `

export const useAddEtbMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AddEtbMutation,
    TError,
    AddEtbMutationVariables,
    TContext
  >,
) => {
  return useMutation<AddEtbMutation, TError, AddEtbMutationVariables, TContext>({
    mutationKey: ["AddETB"],
    mutationFn: (variables?: AddEtbMutationVariables) =>
      adminFetcher<AddEtbMutation, AddEtbMutationVariables>(
        AddEtbDocument,
        variables,
      )(),
    ...options,
  })
}

useAddEtbMutation.fetcher = (
  variables: AddEtbMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AddEtbMutation, AddEtbMutationVariables>(
    AddEtbDocument,
    variables,
    options,
  )

export const AddSitesToPortfolioByOwnerNameDocument = `
    mutation AddSitesToPortfolioByOwnerName($portfolioPid: String!, $names: [String!]!) {
  portfolio {
    addSitesByOwnerName(portfolioPid: $portfolioPid, names: $names)
  }
}
    `

export const useAddSitesToPortfolioByOwnerNameMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    AddSitesToPortfolioByOwnerNameMutation,
    TError,
    AddSitesToPortfolioByOwnerNameMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AddSitesToPortfolioByOwnerNameMutation,
    TError,
    AddSitesToPortfolioByOwnerNameMutationVariables,
    TContext
  >({
    mutationKey: ["AddSitesToPortfolioByOwnerName"],
    mutationFn: (variables?: AddSitesToPortfolioByOwnerNameMutationVariables) =>
      adminFetcher<
        AddSitesToPortfolioByOwnerNameMutation,
        AddSitesToPortfolioByOwnerNameMutationVariables
      >(AddSitesToPortfolioByOwnerNameDocument, variables)(),
    ...options,
  })
}

useAddSitesToPortfolioByOwnerNameMutation.fetcher = (
  variables: AddSitesToPortfolioByOwnerNameMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    AddSitesToPortfolioByOwnerNameMutation,
    AddSitesToPortfolioByOwnerNameMutationVariables
  >(AddSitesToPortfolioByOwnerNameDocument, variables, options)

export const SetTargetUtilityDocument = `
    mutation SetTargetUtility($sitePid: String!, $utilityId: Int!) {
  site {
    setTargetUtility(sitePid: $sitePid, utilityId: $utilityId) {
      pid
      targetUtility {
        id
        name
      }
      targetUtilitySetBy {
        ...UserRef
      }
      dateTargetUtilitySet
    }
  }
}
    ${UserRefFragmentDoc}`

export const useSetTargetUtilityMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetTargetUtilityMutation,
    TError,
    SetTargetUtilityMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetTargetUtilityMutation,
    TError,
    SetTargetUtilityMutationVariables,
    TContext
  >({
    mutationKey: ["SetTargetUtility"],
    mutationFn: (variables?: SetTargetUtilityMutationVariables) =>
      adminFetcher<SetTargetUtilityMutation, SetTargetUtilityMutationVariables>(
        SetTargetUtilityDocument,
        variables,
      )(),
    ...options,
  })
}

useSetTargetUtilityMutation.fetcher = (
  variables: SetTargetUtilityMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetTargetUtilityMutation, SetTargetUtilityMutationVariables>(
    SetTargetUtilityDocument,
    variables,
    options,
  )

export const SetThirdPartySupplierDocument = `
    mutation SetThirdPartySupplier($sitePid: String!, $thirdPartySupplierId: Int) {
  site {
    setThirdPartySupplier(
      sitePid: $sitePid
      thirdPartySupplierId: $thirdPartySupplierId
    ) {
      pid
      thirdPartySupplier {
        id
        name
      }
    }
  }
}
    `

export const useSetThirdPartySupplierMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetThirdPartySupplierMutation,
    TError,
    SetThirdPartySupplierMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetThirdPartySupplierMutation,
    TError,
    SetThirdPartySupplierMutationVariables,
    TContext
  >({
    mutationKey: ["SetThirdPartySupplier"],
    mutationFn: (variables?: SetThirdPartySupplierMutationVariables) =>
      adminFetcher<
        SetThirdPartySupplierMutation,
        SetThirdPartySupplierMutationVariables
      >(SetThirdPartySupplierDocument, variables)(),
    ...options,
  })
}

useSetThirdPartySupplierMutation.fetcher = (
  variables: SetThirdPartySupplierMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetThirdPartySupplierMutation, SetThirdPartySupplierMutationVariables>(
    SetThirdPartySupplierDocument,
    variables,
    options,
  )

export const SetMeteringDocument = `
    mutation SetMetering($sitePids: [String!]!, $metering: Metering) {
  site {
    setMetering(sitePids: $sitePids, metering: $metering)
  }
}
    `

export const useSetMeteringMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetMeteringMutation,
    TError,
    SetMeteringMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetMeteringMutation,
    TError,
    SetMeteringMutationVariables,
    TContext
  >({
    mutationKey: ["SetMetering"],
    mutationFn: (variables?: SetMeteringMutationVariables) =>
      adminFetcher<SetMeteringMutation, SetMeteringMutationVariables>(
        SetMeteringDocument,
        variables,
      )(),
    ...options,
  })
}

useSetMeteringMutation.fetcher = (
  variables: SetMeteringMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetMeteringMutation, SetMeteringMutationVariables>(
    SetMeteringDocument,
    variables,
    options,
  )

export const SetLeaseTypeDocument = `
    mutation SetLeaseType($sitePids: [String!]!, $leaseType: LeaseType) {
  site {
    setLeaseType(sitePids: $sitePids, leaseType: $leaseType)
  }
}
    `

export const useSetLeaseTypeMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetLeaseTypeMutation,
    TError,
    SetLeaseTypeMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetLeaseTypeMutation,
    TError,
    SetLeaseTypeMutationVariables,
    TContext
  >({
    mutationKey: ["SetLeaseType"],
    mutationFn: (variables?: SetLeaseTypeMutationVariables) =>
      adminFetcher<SetLeaseTypeMutation, SetLeaseTypeMutationVariables>(
        SetLeaseTypeDocument,
        variables,
      )(),
    ...options,
  })
}

useSetLeaseTypeMutation.fetcher = (
  variables: SetLeaseTypeMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetLeaseTypeMutation, SetLeaseTypeMutationVariables>(
    SetLeaseTypeDocument,
    variables,
    options,
  )

export const SetOccupancyTypeDocument = `
    mutation SetOccupancyType($sitePids: [String!]!, $occupancyType: BuildingOccupancyType) {
  site {
    setOccupancyType(sitePids: $sitePids, occupancyType: $occupancyType)
  }
}
    `

export const useSetOccupancyTypeMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetOccupancyTypeMutation,
    TError,
    SetOccupancyTypeMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetOccupancyTypeMutation,
    TError,
    SetOccupancyTypeMutationVariables,
    TContext
  >({
    mutationKey: ["SetOccupancyType"],
    mutationFn: (variables?: SetOccupancyTypeMutationVariables) =>
      adminFetcher<SetOccupancyTypeMutation, SetOccupancyTypeMutationVariables>(
        SetOccupancyTypeDocument,
        variables,
      )(),
    ...options,
  })
}

useSetOccupancyTypeMutation.fetcher = (
  variables: SetOccupancyTypeMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetOccupancyTypeMutation, SetOccupancyTypeMutationVariables>(
    SetOccupancyTypeDocument,
    variables,
    options,
  )

export const RemoveUserFromPortfolioDocument = `
    mutation RemoveUserFromPortfolio($portfolioPid: String!, $userId: Int!) {
  portfolio {
    removeUserFromPortfolio(portfolioPid: $portfolioPid, userId: $userId) {
      pid
      users {
        id
        email
      }
    }
  }
}
    `

export const useRemoveUserFromPortfolioMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    RemoveUserFromPortfolioMutation,
    TError,
    RemoveUserFromPortfolioMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RemoveUserFromPortfolioMutation,
    TError,
    RemoveUserFromPortfolioMutationVariables,
    TContext
  >({
    mutationKey: ["RemoveUserFromPortfolio"],
    mutationFn: (variables?: RemoveUserFromPortfolioMutationVariables) =>
      adminFetcher<
        RemoveUserFromPortfolioMutation,
        RemoveUserFromPortfolioMutationVariables
      >(RemoveUserFromPortfolioDocument, variables)(),
    ...options,
  })
}

useRemoveUserFromPortfolioMutation.fetcher = (
  variables: RemoveUserFromPortfolioMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    RemoveUserFromPortfolioMutation,
    RemoveUserFromPortfolioMutationVariables
  >(RemoveUserFromPortfolioDocument, variables, options)

export const RenamePortfolioDocument = `
    mutation RenamePortfolio($portfolioPid: String!, $newName: String!) {
  portfolio {
    rename(portfolioPid: $portfolioPid, newName: $newName) {
      pid
      title
    }
  }
}
    `

export const useRenamePortfolioMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    RenamePortfolioMutation,
    TError,
    RenamePortfolioMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RenamePortfolioMutation,
    TError,
    RenamePortfolioMutationVariables,
    TContext
  >({
    mutationKey: ["RenamePortfolio"],
    mutationFn: (variables?: RenamePortfolioMutationVariables) =>
      adminFetcher<RenamePortfolioMutation, RenamePortfolioMutationVariables>(
        RenamePortfolioDocument,
        variables,
      )(),
    ...options,
  })
}

useRenamePortfolioMutation.fetcher = (
  variables: RenamePortfolioMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<RenamePortfolioMutation, RenamePortfolioMutationVariables>(
    RenamePortfolioDocument,
    variables,
    options,
  )

export const UtilityApiNameDocument = `
    mutation UtilityApiName($utilityId: Int!, $utilityApiName: String) {
  utility {
    setUtilityApiName(id: $utilityId, utilityApiName: $utilityApiName) {
      id
      utilityApiName
    }
  }
}
    `

export const useUtilityApiNameMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UtilityApiNameMutation,
    TError,
    UtilityApiNameMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UtilityApiNameMutation,
    TError,
    UtilityApiNameMutationVariables,
    TContext
  >({
    mutationKey: ["UtilityApiName"],
    mutationFn: (variables?: UtilityApiNameMutationVariables) =>
      adminFetcher<UtilityApiNameMutation, UtilityApiNameMutationVariables>(
        UtilityApiNameDocument,
        variables,
      )(),
    ...options,
  })
}

useUtilityApiNameMutation.fetcher = (
  variables: UtilityApiNameMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<UtilityApiNameMutation, UtilityApiNameMutationVariables>(
    UtilityApiNameDocument,
    variables,
    options,
  )

export const UtilityIsPreferredDocument = `
    mutation UtilityIsPreferred($utilityId: Int!, $isPreferred: Boolean) {
  utility {
    setIsPreferred(id: $utilityId, isPreferred: $isPreferred) {
      id
      isPreferred
    }
  }
}
    `

export const useUtilityIsPreferredMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UtilityIsPreferredMutation,
    TError,
    UtilityIsPreferredMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UtilityIsPreferredMutation,
    TError,
    UtilityIsPreferredMutationVariables,
    TContext
  >({
    mutationKey: ["UtilityIsPreferred"],
    mutationFn: (variables?: UtilityIsPreferredMutationVariables) =>
      adminFetcher<UtilityIsPreferredMutation, UtilityIsPreferredMutationVariables>(
        UtilityIsPreferredDocument,
        variables,
      )(),
    ...options,
  })
}

useUtilityIsPreferredMutation.fetcher = (
  variables: UtilityIsPreferredMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<UtilityIsPreferredMutation, UtilityIsPreferredMutationVariables>(
    UtilityIsPreferredDocument,
    variables,
    options,
  )

export const UtilityNotesDocument = `
    mutation UtilityNotes($utilityId: Int!, $notes: String) {
  utility {
    setNotes(id: $utilityId, notes: $notes) {
      id
      notes
    }
  }
}
    `

export const useUtilityNotesMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UtilityNotesMutation,
    TError,
    UtilityNotesMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UtilityNotesMutation,
    TError,
    UtilityNotesMutationVariables,
    TContext
  >({
    mutationKey: ["UtilityNotes"],
    mutationFn: (variables?: UtilityNotesMutationVariables) =>
      adminFetcher<UtilityNotesMutation, UtilityNotesMutationVariables>(
        UtilityNotesDocument,
        variables,
      )(),
    ...options,
  })
}

useUtilityNotesMutation.fetcher = (
  variables: UtilityNotesMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<UtilityNotesMutation, UtilityNotesMutationVariables>(
    UtilityNotesDocument,
    variables,
    options,
  )

export const CreatePropertyNoteDocument = `
    mutation CreatePropertyNote($propertyPid: String!, $text: String!, $hiddenFromCustomers: Boolean!) {
  note {
    new(
      sitePid: $propertyPid
      text: $text
      hiddenFromCustomers: $hiddenFromCustomers
    ) {
      pid
    }
  }
}
    `

export const useCreatePropertyNoteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreatePropertyNoteMutation,
    TError,
    CreatePropertyNoteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreatePropertyNoteMutation,
    TError,
    CreatePropertyNoteMutationVariables,
    TContext
  >({
    mutationKey: ["CreatePropertyNote"],
    mutationFn: (variables?: CreatePropertyNoteMutationVariables) =>
      adminFetcher<CreatePropertyNoteMutation, CreatePropertyNoteMutationVariables>(
        CreatePropertyNoteDocument,
        variables,
      )(),
    ...options,
  })
}

useCreatePropertyNoteMutation.fetcher = (
  variables: CreatePropertyNoteMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<CreatePropertyNoteMutation, CreatePropertyNoteMutationVariables>(
    CreatePropertyNoteDocument,
    variables,
    options,
  )

export const EditPropertyNoteDocument = `
    mutation EditPropertyNote($notePid: String!, $text: String!, $hiddenFromCustomers: Boolean!) {
  note {
    edit(notePid: $notePid, text: $text, hiddenFromCustomers: $hiddenFromCustomers) {
      pid
    }
  }
}
    `

export const useEditPropertyNoteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    EditPropertyNoteMutation,
    TError,
    EditPropertyNoteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    EditPropertyNoteMutation,
    TError,
    EditPropertyNoteMutationVariables,
    TContext
  >({
    mutationKey: ["EditPropertyNote"],
    mutationFn: (variables?: EditPropertyNoteMutationVariables) =>
      adminFetcher<EditPropertyNoteMutation, EditPropertyNoteMutationVariables>(
        EditPropertyNoteDocument,
        variables,
      )(),
    ...options,
  })
}

useEditPropertyNoteMutation.fetcher = (
  variables: EditPropertyNoteMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<EditPropertyNoteMutation, EditPropertyNoteMutationVariables>(
    EditPropertyNoteDocument,
    variables,
    options,
  )

export const TrashPropertyNoteDocument = `
    mutation TrashPropertyNote($notePid: String!) {
  note {
    trash(notePid: $notePid) {
      pid
    }
  }
}
    `

export const useTrashPropertyNoteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    TrashPropertyNoteMutation,
    TError,
    TrashPropertyNoteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    TrashPropertyNoteMutation,
    TError,
    TrashPropertyNoteMutationVariables,
    TContext
  >({
    mutationKey: ["TrashPropertyNote"],
    mutationFn: (variables?: TrashPropertyNoteMutationVariables) =>
      adminFetcher<TrashPropertyNoteMutation, TrashPropertyNoteMutationVariables>(
        TrashPropertyNoteDocument,
        variables,
      )(),
    ...options,
  })
}

useTrashPropertyNoteMutation.fetcher = (
  variables: TrashPropertyNoteMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<TrashPropertyNoteMutation, TrashPropertyNoteMutationVariables>(
    TrashPropertyNoteDocument,
    variables,
    options,
  )

export const AddHelioscopeDocument = `
    mutation AddHelioscope($sitePid: String!, $pdfId: Int!, $roofImageId: Int!, $productionCsvId: Int!, $roofPvKw: Float!, $carportPvThreeHighKw: Float!, $carportPvSixHighKw: Float!, $groundPvKw: Float!, $roofIsMax: Boolean!, $carportIsMax: Boolean!) {
  site {
    addHelioscope(
      sitePid: $sitePid
      pdfId: $pdfId
      roofImageId: $roofImageId
      productionCsvId: $productionCsvId
      roofPvKw: $roofPvKw
      carportPvThreeHighKw: $carportPvThreeHighKw
      carportPvSixHighKw: $carportPvSixHighKw
      groundPvKw: $groundPvKw
      roofIsMax: $roofIsMax
      carportIsMax: $carportIsMax
    ) {
      __typename
      pid
    }
  }
}
    `

export const useAddHelioscopeMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AddHelioscopeMutation,
    TError,
    AddHelioscopeMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AddHelioscopeMutation,
    TError,
    AddHelioscopeMutationVariables,
    TContext
  >({
    mutationKey: ["AddHelioscope"],
    mutationFn: (variables?: AddHelioscopeMutationVariables) =>
      adminFetcher<AddHelioscopeMutation, AddHelioscopeMutationVariables>(
        AddHelioscopeDocument,
        variables,
      )(),
    ...options,
  })
}

useAddHelioscopeMutation.fetcher = (
  variables: AddHelioscopeMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AddHelioscopeMutation, AddHelioscopeMutationVariables>(
    AddHelioscopeDocument,
    variables,
    options,
  )

export const UploadHelioscopePdfDocument = `
    mutation UploadHelioscopePdf($sitePid: String!, $reportPdf: Upload!) {
  site {
    uploadHelioscopePdf(sitePid: $sitePid, reportPdf: $reportPdf) {
      reportPdf {
        ...AttachmentFragment
      }
      roofImage {
        ...AttachmentFragment
      }
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${UserRefFragmentDoc}`

export const useUploadHelioscopePdfMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UploadHelioscopePdfMutation,
    TError,
    UploadHelioscopePdfMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UploadHelioscopePdfMutation,
    TError,
    UploadHelioscopePdfMutationVariables,
    TContext
  >({
    mutationKey: ["UploadHelioscopePdf"],
    mutationFn: (variables?: UploadHelioscopePdfMutationVariables) =>
      adminFetcher<UploadHelioscopePdfMutation, UploadHelioscopePdfMutationVariables>(
        UploadHelioscopePdfDocument,
        variables,
      )(),
    ...options,
  })
}

useUploadHelioscopePdfMutation.fetcher = (
  variables: UploadHelioscopePdfMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<UploadHelioscopePdfMutation, UploadHelioscopePdfMutationVariables>(
    UploadHelioscopePdfDocument,
    variables,
    options,
  )

export const SetScenarioHelioscopeDocument = `
    mutation SetScenarioHelioscope($scenarioPid: String!, $helioscopePid: String, $finproductId: Int, $finproductType: FinProductType) {
  scenario(scenarioPid: $scenarioPid) {
    setHelioscope(
      helioscopePid: $helioscopePid
      finproductId: $finproductId
      finproductType: $finproductType
    ) {
      __typename
      pid
    }
  }
}
    `

export const useSetScenarioHelioscopeMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetScenarioHelioscopeMutation,
    TError,
    SetScenarioHelioscopeMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetScenarioHelioscopeMutation,
    TError,
    SetScenarioHelioscopeMutationVariables,
    TContext
  >({
    mutationKey: ["SetScenarioHelioscope"],
    mutationFn: (variables?: SetScenarioHelioscopeMutationVariables) =>
      adminFetcher<
        SetScenarioHelioscopeMutation,
        SetScenarioHelioscopeMutationVariables
      >(SetScenarioHelioscopeDocument, variables)(),
    ...options,
  })
}

useSetScenarioHelioscopeMutation.fetcher = (
  variables: SetScenarioHelioscopeMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetScenarioHelioscopeMutation, SetScenarioHelioscopeMutationVariables>(
    SetScenarioHelioscopeDocument,
    variables,
    options,
  )

export const TrashHelioscopeDocument = `
    mutation TrashHelioscope($sitePid: String!, $helioscopePid: String!) {
  site {
    trashHelioscope(sitePid: $sitePid, helioscopePid: $helioscopePid) {
      pid
    }
  }
}
    `

export const useTrashHelioscopeMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    TrashHelioscopeMutation,
    TError,
    TrashHelioscopeMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    TrashHelioscopeMutation,
    TError,
    TrashHelioscopeMutationVariables,
    TContext
  >({
    mutationKey: ["TrashHelioscope"],
    mutationFn: (variables?: TrashHelioscopeMutationVariables) =>
      adminFetcher<TrashHelioscopeMutation, TrashHelioscopeMutationVariables>(
        TrashHelioscopeDocument,
        variables,
      )(),
    ...options,
  })
}

useTrashHelioscopeMutation.fetcher = (
  variables: TrashHelioscopeMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<TrashHelioscopeMutation, TrashHelioscopeMutationVariables>(
    TrashHelioscopeDocument,
    variables,
    options,
  )

export const DeleteParcelFootprintDocument = `
    mutation DeleteParcelFootprint($sitePid: String!) {
  site {
    deleteParcelFootprint(sitePid: $sitePid) {
      pid
      footprint {
        roofShape
        parcelShape
      }
    }
  }
}
    `

export const useDeleteParcelFootprintMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteParcelFootprintMutation,
    TError,
    DeleteParcelFootprintMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeleteParcelFootprintMutation,
    TError,
    DeleteParcelFootprintMutationVariables,
    TContext
  >({
    mutationKey: ["DeleteParcelFootprint"],
    mutationFn: (variables?: DeleteParcelFootprintMutationVariables) =>
      adminFetcher<
        DeleteParcelFootprintMutation,
        DeleteParcelFootprintMutationVariables
      >(DeleteParcelFootprintDocument, variables)(),
    ...options,
  })
}

useDeleteParcelFootprintMutation.fetcher = (
  variables: DeleteParcelFootprintMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<DeleteParcelFootprintMutation, DeleteParcelFootprintMutationVariables>(
    DeleteParcelFootprintDocument,
    variables,
    options,
  )

export const DeleteBuildingFootprintDocument = `
    mutation DeleteBuildingFootprint($sitePid: String!) {
  site {
    deleteBuildingFootprint(sitePid: $sitePid) {
      pid
      footprint {
        roofShape
        parcelShape
        obstructionShape
      }
    }
  }
}
    `

export const useDeleteBuildingFootprintMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DeleteBuildingFootprintMutation,
    TError,
    DeleteBuildingFootprintMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeleteBuildingFootprintMutation,
    TError,
    DeleteBuildingFootprintMutationVariables,
    TContext
  >({
    mutationKey: ["DeleteBuildingFootprint"],
    mutationFn: (variables?: DeleteBuildingFootprintMutationVariables) =>
      adminFetcher<
        DeleteBuildingFootprintMutation,
        DeleteBuildingFootprintMutationVariables
      >(DeleteBuildingFootprintDocument, variables)(),
    ...options,
  })
}

useDeleteBuildingFootprintMutation.fetcher = (
  variables: DeleteBuildingFootprintMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    DeleteBuildingFootprintMutation,
    DeleteBuildingFootprintMutationVariables
  >(DeleteBuildingFootprintDocument, variables, options)

export const SetOrgNameDocument = `
    mutation setOrgName($pid: String!, $value: String!) {
  orgs {
    setName(pid: $pid, name: $value) {
      pid
      name
    }
  }
}
    `

export const useSetOrgNameMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetOrgNameMutation,
    TError,
    SetOrgNameMutationVariables,
    TContext
  >,
) => {
  return useMutation<SetOrgNameMutation, TError, SetOrgNameMutationVariables, TContext>(
    {
      mutationKey: ["setOrgName"],
      mutationFn: (variables?: SetOrgNameMutationVariables) =>
        adminFetcher<SetOrgNameMutation, SetOrgNameMutationVariables>(
          SetOrgNameDocument,
          variables,
        )(),
      ...options,
    },
  )
}

useSetOrgNameMutation.fetcher = (
  variables: SetOrgNameMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetOrgNameMutation, SetOrgNameMutationVariables>(
    SetOrgNameDocument,
    variables,
    options,
  )

export const SetOrgSlugDocument = `
    mutation setOrgSlug($pid: String!, $value: String!) {
  orgs {
    setSlug(pid: $pid, slug: $value) {
      pid
      slug
    }
  }
}
    `

export const useSetOrgSlugMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetOrgSlugMutation,
    TError,
    SetOrgSlugMutationVariables,
    TContext
  >,
) => {
  return useMutation<SetOrgSlugMutation, TError, SetOrgSlugMutationVariables, TContext>(
    {
      mutationKey: ["setOrgSlug"],
      mutationFn: (variables?: SetOrgSlugMutationVariables) =>
        adminFetcher<SetOrgSlugMutation, SetOrgSlugMutationVariables>(
          SetOrgSlugDocument,
          variables,
        )(),
      ...options,
    },
  )
}

useSetOrgSlugMutation.fetcher = (
  variables: SetOrgSlugMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetOrgSlugMutation, SetOrgSlugMutationVariables>(
    SetOrgSlugDocument,
    variables,
    options,
  )

export const SetOrgLogoDocument = `
    mutation setOrgLogo($pid: String!, $upload: Upload!) {
  orgs {
    setLogo(pid: $pid, upload: $upload) {
      pid
      slug
      logoUrl
    }
  }
}
    `

export const useSetOrgLogoMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetOrgLogoMutation,
    TError,
    SetOrgLogoMutationVariables,
    TContext
  >,
) => {
  return useMutation<SetOrgLogoMutation, TError, SetOrgLogoMutationVariables, TContext>(
    {
      mutationKey: ["setOrgLogo"],
      mutationFn: (variables?: SetOrgLogoMutationVariables) =>
        adminFetcher<SetOrgLogoMutation, SetOrgLogoMutationVariables>(
          SetOrgLogoDocument,
          variables,
        )(),
      ...options,
    },
  )
}

useSetOrgLogoMutation.fetcher = (
  variables: SetOrgLogoMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetOrgLogoMutation, SetOrgLogoMutationVariables>(
    SetOrgLogoDocument,
    variables,
    options,
  )

export const SetOrgLogomarkDocument = `
    mutation setOrgLogomark($pid: String!, $upload: Upload!) {
  orgs {
    setLogomark(pid: $pid, upload: $upload) {
      pid
      slug
      logoUrl
    }
  }
}
    `

export const useSetOrgLogomarkMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetOrgLogomarkMutation,
    TError,
    SetOrgLogomarkMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetOrgLogomarkMutation,
    TError,
    SetOrgLogomarkMutationVariables,
    TContext
  >({
    mutationKey: ["setOrgLogomark"],
    mutationFn: (variables?: SetOrgLogomarkMutationVariables) =>
      adminFetcher<SetOrgLogomarkMutation, SetOrgLogomarkMutationVariables>(
        SetOrgLogomarkDocument,
        variables,
      )(),
    ...options,
  })
}

useSetOrgLogomarkMutation.fetcher = (
  variables: SetOrgLogomarkMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetOrgLogomarkMutation, SetOrgLogomarkMutationVariables>(
    SetOrgLogomarkDocument,
    variables,
    options,
  )

export const SetOrgAllowlistDocument = `
    mutation SetOrgAllowlist($orgPid: String!, $domains: [String!]) {
  orgs {
    setAllowedEmailDomains(pid: $orgPid, allowedEmailDomains: $domains) {
      pid
      allowedEmailDomains
    }
  }
}
    `

export const useSetOrgAllowlistMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetOrgAllowlistMutation,
    TError,
    SetOrgAllowlistMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetOrgAllowlistMutation,
    TError,
    SetOrgAllowlistMutationVariables,
    TContext
  >({
    mutationKey: ["SetOrgAllowlist"],
    mutationFn: (variables?: SetOrgAllowlistMutationVariables) =>
      adminFetcher<SetOrgAllowlistMutation, SetOrgAllowlistMutationVariables>(
        SetOrgAllowlistDocument,
        variables,
      )(),
    ...options,
  })
}

useSetOrgAllowlistMutation.fetcher = (
  variables: SetOrgAllowlistMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetOrgAllowlistMutation, SetOrgAllowlistMutationVariables>(
    SetOrgAllowlistDocument,
    variables,
    options,
  )

export const SetUserAvatarDocument = `
    mutation setUserAvatar($userId: Int!, $upload: Upload!) {
  user {
    setAvatar(userId: $userId, upload: $upload) {
      avatarUrl
    }
  }
}
    `

export const useSetUserAvatarMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetUserAvatarMutation,
    TError,
    SetUserAvatarMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetUserAvatarMutation,
    TError,
    SetUserAvatarMutationVariables,
    TContext
  >({
    mutationKey: ["setUserAvatar"],
    mutationFn: (variables?: SetUserAvatarMutationVariables) =>
      adminFetcher<SetUserAvatarMutation, SetUserAvatarMutationVariables>(
        SetUserAvatarDocument,
        variables,
      )(),
    ...options,
  })
}

useSetUserAvatarMutation.fetcher = (
  variables: SetUserAvatarMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetUserAvatarMutation, SetUserAvatarMutationVariables>(
    SetUserAvatarDocument,
    variables,
    options,
  )

export const UpdateUserOrgMembershipDocument = `
    mutation updateUserOrgMembership($userId: Int!, $orgPid: String!) {
  user {
    updateOrgMembership(userId: $userId, orgPid: $orgPid) {
      ...UserListUser
    }
  }
}
    ${UserListUserFragmentDoc}`

export const useUpdateUserOrgMembershipMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateUserOrgMembershipMutation,
    TError,
    UpdateUserOrgMembershipMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateUserOrgMembershipMutation,
    TError,
    UpdateUserOrgMembershipMutationVariables,
    TContext
  >({
    mutationKey: ["updateUserOrgMembership"],
    mutationFn: (variables?: UpdateUserOrgMembershipMutationVariables) =>
      adminFetcher<
        UpdateUserOrgMembershipMutation,
        UpdateUserOrgMembershipMutationVariables
      >(UpdateUserOrgMembershipDocument, variables)(),
    ...options,
  })
}

useUpdateUserOrgMembershipMutation.fetcher = (
  variables: UpdateUserOrgMembershipMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    UpdateUserOrgMembershipMutation,
    UpdateUserOrgMembershipMutationVariables
  >(UpdateUserOrgMembershipDocument, variables, options)

export const RemoveUserOrgMembershipDocument = `
    mutation removeUserOrgMembership($userId: Int!) {
  user {
    removeOrgMembership(userId: $userId) {
      ...UserListUser
    }
  }
}
    ${UserListUserFragmentDoc}`

export const useRemoveUserOrgMembershipMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    RemoveUserOrgMembershipMutation,
    TError,
    RemoveUserOrgMembershipMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RemoveUserOrgMembershipMutation,
    TError,
    RemoveUserOrgMembershipMutationVariables,
    TContext
  >({
    mutationKey: ["removeUserOrgMembership"],
    mutationFn: (variables?: RemoveUserOrgMembershipMutationVariables) =>
      adminFetcher<
        RemoveUserOrgMembershipMutation,
        RemoveUserOrgMembershipMutationVariables
      >(RemoveUserOrgMembershipDocument, variables)(),
    ...options,
  })
}

useRemoveUserOrgMembershipMutation.fetcher = (
  variables: RemoveUserOrgMembershipMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    RemoveUserOrgMembershipMutation,
    RemoveUserOrgMembershipMutationVariables
  >(RemoveUserOrgMembershipDocument, variables, options)

export const CreateCustomTariffDocument = `
    mutation CreateCustomTariff($sitePid: String!, $utilityId: Int!, $cfg: String!) {
  tariff {
    createCustomTariff(sitePid: $sitePid, utilityId: $utilityId, cfg: $cfg) {
      id
      name
      code
      isCustom
      utility {
        id
        name
      }
    }
  }
}
    `

export const useCreateCustomTariffMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateCustomTariffMutation,
    TError,
    CreateCustomTariffMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateCustomTariffMutation,
    TError,
    CreateCustomTariffMutationVariables,
    TContext
  >({
    mutationKey: ["CreateCustomTariff"],
    mutationFn: (variables?: CreateCustomTariffMutationVariables) =>
      adminFetcher<CreateCustomTariffMutation, CreateCustomTariffMutationVariables>(
        CreateCustomTariffDocument,
        variables,
      )(),
    ...options,
  })
}

useCreateCustomTariffMutation.fetcher = (
  variables: CreateCustomTariffMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<CreateCustomTariffMutation, CreateCustomTariffMutationVariables>(
    CreateCustomTariffDocument,
    variables,
    options,
  )

export const ArchiveCustomTariffDocument = `
    mutation ArchiveCustomTariff($customTariffId: Int!) {
  tariff {
    archiveCustomTariff(customTariffId: $customTariffId)
  }
}
    `

export const useArchiveCustomTariffMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ArchiveCustomTariffMutation,
    TError,
    ArchiveCustomTariffMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ArchiveCustomTariffMutation,
    TError,
    ArchiveCustomTariffMutationVariables,
    TContext
  >({
    mutationKey: ["ArchiveCustomTariff"],
    mutationFn: (variables?: ArchiveCustomTariffMutationVariables) =>
      adminFetcher<ArchiveCustomTariffMutation, ArchiveCustomTariffMutationVariables>(
        ArchiveCustomTariffDocument,
        variables,
      )(),
    ...options,
  })
}

useArchiveCustomTariffMutation.fetcher = (
  variables: ArchiveCustomTariffMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ArchiveCustomTariffMutation, ArchiveCustomTariffMutationVariables>(
    ArchiveCustomTariffDocument,
    variables,
    options,
  )

export const SetPVoptGoalDocument = `
    mutation SetPVoptGoal($scenarioPid: String!, $pvoptGoal: PVoptGoal!, $roofKw: Float, $carportKw: Float, $groundKw: Float) {
  scenario(scenarioPid: $scenarioPid) {
    setPvoptGoal(
      pvoptGoal: $pvoptGoal
      roofKw: $roofKw
      carportKw: $carportKw
      groundKw: $groundKw
    ) {
      pid
    }
  }
}
    `

export const useSetPVoptGoalMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetPVoptGoalMutation,
    TError,
    SetPVoptGoalMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetPVoptGoalMutation,
    TError,
    SetPVoptGoalMutationVariables,
    TContext
  >({
    mutationKey: ["SetPVoptGoal"],
    mutationFn: (variables?: SetPVoptGoalMutationVariables) =>
      adminFetcher<SetPVoptGoalMutation, SetPVoptGoalMutationVariables>(
        SetPVoptGoalDocument,
        variables,
      )(),
    ...options,
  })
}

useSetPVoptGoalMutation.fetcher = (
  variables: SetPVoptGoalMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetPVoptGoalMutation, SetPVoptGoalMutationVariables>(
    SetPVoptGoalDocument,
    variables,
    options,
  )

export const SetScenarioConfigDocument = `
    mutation SetScenarioConfig($scenarioPid: String!, $finproductId: Int, $finproductType: FinProductType, $helioscopePid: String, $goal: PVoptGoal, $roofKw: Float, $carportKw: Float, $groundKw: Float) {
  scenario(scenarioPid: $scenarioPid) {
    setConfig(
      finproductId: $finproductId
      finproductType: $finproductType
      goal: $goal
      roofKw: $roofKw
      carportKw: $carportKw
      groundKw: $groundKw
      helioscopePid: $helioscopePid
    ) {
      pid
    }
  }
}
    `

export const useSetScenarioConfigMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetScenarioConfigMutation,
    TError,
    SetScenarioConfigMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetScenarioConfigMutation,
    TError,
    SetScenarioConfigMutationVariables,
    TContext
  >({
    mutationKey: ["SetScenarioConfig"],
    mutationFn: (variables?: SetScenarioConfigMutationVariables) =>
      adminFetcher<SetScenarioConfigMutation, SetScenarioConfigMutationVariables>(
        SetScenarioConfigDocument,
        variables,
      )(),
    ...options,
  })
}

useSetScenarioConfigMutation.fetcher = (
  variables: SetScenarioConfigMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetScenarioConfigMutation, SetScenarioConfigMutationVariables>(
    SetScenarioConfigDocument,
    variables,
    options,
  )

export const RemoveScenarioConfigDocument = `
    mutation RemoveScenarioConfig($scenarioPid: String!, $scenarioConfigId: Int!) {
  scenario(scenarioPid: $scenarioPid) {
    removeConfig(scenarioConfigId: $scenarioConfigId)
  }
}
    `

export const useRemoveScenarioConfigMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    RemoveScenarioConfigMutation,
    TError,
    RemoveScenarioConfigMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RemoveScenarioConfigMutation,
    TError,
    RemoveScenarioConfigMutationVariables,
    TContext
  >({
    mutationKey: ["RemoveScenarioConfig"],
    mutationFn: (variables?: RemoveScenarioConfigMutationVariables) =>
      adminFetcher<RemoveScenarioConfigMutation, RemoveScenarioConfigMutationVariables>(
        RemoveScenarioConfigDocument,
        variables,
      )(),
    ...options,
  })
}

useRemoveScenarioConfigMutation.fetcher = (
  variables: RemoveScenarioConfigMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<RemoveScenarioConfigMutation, RemoveScenarioConfigMutationVariables>(
    RemoveScenarioConfigDocument,
    variables,
    options,
  )

export const CreateOpenInviteDocument = `
    mutation CreateOpenInvite($portfolioPid: String!) {
  openInvite {
    new(portfolioPid: $portfolioPid) {
      pid
    }
  }
}
    `

export const useCreateOpenInviteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateOpenInviteMutation,
    TError,
    CreateOpenInviteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateOpenInviteMutation,
    TError,
    CreateOpenInviteMutationVariables,
    TContext
  >({
    mutationKey: ["CreateOpenInvite"],
    mutationFn: (variables?: CreateOpenInviteMutationVariables) =>
      adminFetcher<CreateOpenInviteMutation, CreateOpenInviteMutationVariables>(
        CreateOpenInviteDocument,
        variables,
      )(),
    ...options,
  })
}

useCreateOpenInviteMutation.fetcher = (
  variables: CreateOpenInviteMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<CreateOpenInviteMutation, CreateOpenInviteMutationVariables>(
    CreateOpenInviteDocument,
    variables,
    options,
  )

export const SetOpenInviteExpiresAtDocument = `
    mutation SetOpenInviteExpiresAt($id: Int!, $expiresAt: DateTime!) {
  openInvite {
    setExpiresAt(id: $id, expiresAt: $expiresAt) {
      id
      expiresAt
    }
  }
}
    `

export const useSetOpenInviteExpiresAtMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetOpenInviteExpiresAtMutation,
    TError,
    SetOpenInviteExpiresAtMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetOpenInviteExpiresAtMutation,
    TError,
    SetOpenInviteExpiresAtMutationVariables,
    TContext
  >({
    mutationKey: ["SetOpenInviteExpiresAt"],
    mutationFn: (variables?: SetOpenInviteExpiresAtMutationVariables) =>
      adminFetcher<
        SetOpenInviteExpiresAtMutation,
        SetOpenInviteExpiresAtMutationVariables
      >(SetOpenInviteExpiresAtDocument, variables)(),
    ...options,
  })
}

useSetOpenInviteExpiresAtMutation.fetcher = (
  variables: SetOpenInviteExpiresAtMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetOpenInviteExpiresAtMutation, SetOpenInviteExpiresAtMutationVariables>(
    SetOpenInviteExpiresAtDocument,
    variables,
    options,
  )

export const SetBauMeterTariffDocument = `
    mutation SetBauMeterTariff($input: SetBauMeterTariffInput!) {
  site {
    setBauMeterTariff(input: $input) {
      pid
    }
  }
}
    `

export const useSetBauMeterTariffMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetBauMeterTariffMutation,
    TError,
    SetBauMeterTariffMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetBauMeterTariffMutation,
    TError,
    SetBauMeterTariffMutationVariables,
    TContext
  >({
    mutationKey: ["SetBauMeterTariff"],
    mutationFn: (variables?: SetBauMeterTariffMutationVariables) =>
      adminFetcher<SetBauMeterTariffMutation, SetBauMeterTariffMutationVariables>(
        SetBauMeterTariffDocument,
        variables,
      )(),
    ...options,
  })
}

useSetBauMeterTariffMutation.fetcher = (
  variables: SetBauMeterTariffMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetBauMeterTariffMutation, SetBauMeterTariffMutationVariables>(
    SetBauMeterTariffDocument,
    variables,
    options,
  )

export const SetBauMeterLabelDocument = `
    mutation SetBauMeterLabel($input: SetBauMeterLabelInput!) {
  site {
    setBauMeterLabel(input: $input) {
      pid
    }
  }
}
    `

export const useSetBauMeterLabelMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetBauMeterLabelMutation,
    TError,
    SetBauMeterLabelMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetBauMeterLabelMutation,
    TError,
    SetBauMeterLabelMutationVariables,
    TContext
  >({
    mutationKey: ["SetBauMeterLabel"],
    mutationFn: (variables?: SetBauMeterLabelMutationVariables) =>
      adminFetcher<SetBauMeterLabelMutation, SetBauMeterLabelMutationVariables>(
        SetBauMeterLabelDocument,
        variables,
      )(),
    ...options,
  })
}

useSetBauMeterLabelMutation.fetcher = (
  variables: SetBauMeterLabelMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetBauMeterLabelMutation, SetBauMeterLabelMutationVariables>(
    SetBauMeterLabelDocument,
    variables,
    options,
  )

export const OverrideFailureDocument = `
    mutation OverrideFailure($finmodelFailureId: Int!, $scope: GuardrailScope!, $names: [String!]!, $note: String) {
  overrideFinmodelFailure(
    finmodelFailureId: $finmodelFailureId
    scope: $scope
    names: $names
    note: $note
  ) {
    __typename
    ... on Error {
      message
    }
    ... on GuardrailOverrideResult {
      promotedFailure
    }
  }
}
    `

export const useOverrideFailureMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    OverrideFailureMutation,
    TError,
    OverrideFailureMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    OverrideFailureMutation,
    TError,
    OverrideFailureMutationVariables,
    TContext
  >({
    mutationKey: ["OverrideFailure"],
    mutationFn: (variables?: OverrideFailureMutationVariables) =>
      adminFetcher<OverrideFailureMutation, OverrideFailureMutationVariables>(
        OverrideFailureDocument,
        variables,
      )(),
    ...options,
  })
}

useOverrideFailureMutation.fetcher = (
  variables: OverrideFailureMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<OverrideFailureMutation, OverrideFailureMutationVariables>(
    OverrideFailureDocument,
    variables,
    options,
  )

export const OrgFinRelToggleDocument = `
    mutation OrgFinRelToggle($orgPid: String!, $finproductId: Int!, $enable: Boolean!) {
  orgs {
    finrelToggle(orgPid: $orgPid, finproductId: $finproductId, enable: $enable) {
      ...FinRel
    }
  }
}
    ${FinRelFragmentDoc}`

export const useOrgFinRelToggleMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    OrgFinRelToggleMutation,
    TError,
    OrgFinRelToggleMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    OrgFinRelToggleMutation,
    TError,
    OrgFinRelToggleMutationVariables,
    TContext
  >({
    mutationKey: ["OrgFinRelToggle"],
    mutationFn: (variables?: OrgFinRelToggleMutationVariables) =>
      adminFetcher<OrgFinRelToggleMutation, OrgFinRelToggleMutationVariables>(
        OrgFinRelToggleDocument,
        variables,
      )(),
    ...options,
  })
}

useOrgFinRelToggleMutation.fetcher = (
  variables: OrgFinRelToggleMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<OrgFinRelToggleMutation, OrgFinRelToggleMutationVariables>(
    OrgFinRelToggleDocument,
    variables,
    options,
  )

export const CreateAndApplySiteLabelDocument = `
    mutation CreateAndApplySiteLabel($input: CreateAndApplySiteLabelInput!) {
  site {
    labels {
      createAndApplySiteLabel(input: $input) {
        __typename
        ... on Error {
          message
        }
        ... on CreateAndApplySiteLabelOutput {
          label {
            pid
          }
        }
      }
    }
  }
}
    `

export const useCreateAndApplySiteLabelMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateAndApplySiteLabelMutation,
    TError,
    CreateAndApplySiteLabelMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateAndApplySiteLabelMutation,
    TError,
    CreateAndApplySiteLabelMutationVariables,
    TContext
  >({
    mutationKey: ["CreateAndApplySiteLabel"],
    mutationFn: (variables?: CreateAndApplySiteLabelMutationVariables) =>
      adminFetcher<
        CreateAndApplySiteLabelMutation,
        CreateAndApplySiteLabelMutationVariables
      >(CreateAndApplySiteLabelDocument, variables)(),
    ...options,
  })
}

useCreateAndApplySiteLabelMutation.fetcher = (
  variables: CreateAndApplySiteLabelMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    CreateAndApplySiteLabelMutation,
    CreateAndApplySiteLabelMutationVariables
  >(CreateAndApplySiteLabelDocument, variables, options)

export const ApplySiteLabelDocument = `
    mutation ApplySiteLabel($input: ApplyLabelToSiteInput!) {
  site {
    labels {
      applyLabelToSite(input: $input) {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
}
    `

export const useApplySiteLabelMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ApplySiteLabelMutation,
    TError,
    ApplySiteLabelMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ApplySiteLabelMutation,
    TError,
    ApplySiteLabelMutationVariables,
    TContext
  >({
    mutationKey: ["ApplySiteLabel"],
    mutationFn: (variables?: ApplySiteLabelMutationVariables) =>
      adminFetcher<ApplySiteLabelMutation, ApplySiteLabelMutationVariables>(
        ApplySiteLabelDocument,
        variables,
      )(),
    ...options,
  })
}

useApplySiteLabelMutation.fetcher = (
  variables: ApplySiteLabelMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ApplySiteLabelMutation, ApplySiteLabelMutationVariables>(
    ApplySiteLabelDocument,
    variables,
    options,
  )

export const RenameSiteLabelDocument = `
    mutation RenameSiteLabel($input: RenameLabelInput!) {
  site {
    labels {
      renameLabel(input: $input) {
        __typename
        ... on RenameSiteLabelOutput {
          label {
            pid
            name
          }
        }
        ... on Error {
          message
        }
      }
    }
  }
}
    `

export const useRenameSiteLabelMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    RenameSiteLabelMutation,
    TError,
    RenameSiteLabelMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RenameSiteLabelMutation,
    TError,
    RenameSiteLabelMutationVariables,
    TContext
  >({
    mutationKey: ["RenameSiteLabel"],
    mutationFn: (variables?: RenameSiteLabelMutationVariables) =>
      adminFetcher<RenameSiteLabelMutation, RenameSiteLabelMutationVariables>(
        RenameSiteLabelDocument,
        variables,
      )(),
    ...options,
  })
}

useRenameSiteLabelMutation.fetcher = (
  variables: RenameSiteLabelMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<RenameSiteLabelMutation, RenameSiteLabelMutationVariables>(
    RenameSiteLabelDocument,
    variables,
    options,
  )

export const ChangeSiteLabelColorDocument = `
    mutation ChangeSiteLabelColor($input: ChangeSiteLabelColorInput!) {
  site {
    labels {
      changeSiteLabelColor(input: $input) {
        __typename
        ... on ChangeSiteLabelColorOutput {
          label {
            pid
            themeColor
          }
        }
        ... on Error {
          message
        }
      }
    }
  }
}
    `

export const useChangeSiteLabelColorMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ChangeSiteLabelColorMutation,
    TError,
    ChangeSiteLabelColorMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ChangeSiteLabelColorMutation,
    TError,
    ChangeSiteLabelColorMutationVariables,
    TContext
  >({
    mutationKey: ["ChangeSiteLabelColor"],
    mutationFn: (variables?: ChangeSiteLabelColorMutationVariables) =>
      adminFetcher<ChangeSiteLabelColorMutation, ChangeSiteLabelColorMutationVariables>(
        ChangeSiteLabelColorDocument,
        variables,
      )(),
    ...options,
  })
}

useChangeSiteLabelColorMutation.fetcher = (
  variables: ChangeSiteLabelColorMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ChangeSiteLabelColorMutation, ChangeSiteLabelColorMutationVariables>(
    ChangeSiteLabelColorDocument,
    variables,
    options,
  )

export const RemoveSiteLabelDocument = `
    mutation RemoveSiteLabel($input: RemoveLabelInput!) {
  site {
    labels {
      removeLabel(input: $input)
    }
  }
}
    `

export const useRemoveSiteLabelMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    RemoveSiteLabelMutation,
    TError,
    RemoveSiteLabelMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RemoveSiteLabelMutation,
    TError,
    RemoveSiteLabelMutationVariables,
    TContext
  >({
    mutationKey: ["RemoveSiteLabel"],
    mutationFn: (variables?: RemoveSiteLabelMutationVariables) =>
      adminFetcher<RemoveSiteLabelMutation, RemoveSiteLabelMutationVariables>(
        RemoveSiteLabelDocument,
        variables,
      )(),
    ...options,
  })
}

useRemoveSiteLabelMutation.fetcher = (
  variables: RemoveSiteLabelMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<RemoveSiteLabelMutation, RemoveSiteLabelMutationVariables>(
    RemoveSiteLabelDocument,
    variables,
    options,
  )

export const DeleteSiteLabelDocument = `
    mutation DeleteSiteLabel($input: DeleteLabelInput!) {
  site {
    labels {
      deleteLabel(input: $input) {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
}
    `

export const useDeleteSiteLabelMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteSiteLabelMutation,
    TError,
    DeleteSiteLabelMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeleteSiteLabelMutation,
    TError,
    DeleteSiteLabelMutationVariables,
    TContext
  >({
    mutationKey: ["DeleteSiteLabel"],
    mutationFn: (variables?: DeleteSiteLabelMutationVariables) =>
      adminFetcher<DeleteSiteLabelMutation, DeleteSiteLabelMutationVariables>(
        DeleteSiteLabelDocument,
        variables,
      )(),
    ...options,
  })
}

useDeleteSiteLabelMutation.fetcher = (
  variables: DeleteSiteLabelMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<DeleteSiteLabelMutation, DeleteSiteLabelMutationVariables>(
    DeleteSiteLabelDocument,
    variables,
    options,
  )

export const SetLatitudeDocument = `
    mutation SetLatitude($sitePid: String!, $value: Float!) {
  site {
    setLatitude(sitePid: $sitePid, value: $value)
  }
}
    `

export const useSetLatitudeMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetLatitudeMutation,
    TError,
    SetLatitudeMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetLatitudeMutation,
    TError,
    SetLatitudeMutationVariables,
    TContext
  >({
    mutationKey: ["SetLatitude"],
    mutationFn: (variables?: SetLatitudeMutationVariables) =>
      adminFetcher<SetLatitudeMutation, SetLatitudeMutationVariables>(
        SetLatitudeDocument,
        variables,
      )(),
    ...options,
  })
}

useSetLatitudeMutation.fetcher = (
  variables: SetLatitudeMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetLatitudeMutation, SetLatitudeMutationVariables>(
    SetLatitudeDocument,
    variables,
    options,
  )

export const SetLongitudeDocument = `
    mutation SetLongitude($sitePid: String!, $value: Float!) {
  site {
    setLongitude(sitePid: $sitePid, value: $value)
  }
}
    `

export const useSetLongitudeMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetLongitudeMutation,
    TError,
    SetLongitudeMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetLongitudeMutation,
    TError,
    SetLongitudeMutationVariables,
    TContext
  >({
    mutationKey: ["SetLongitude"],
    mutationFn: (variables?: SetLongitudeMutationVariables) =>
      adminFetcher<SetLongitudeMutation, SetLongitudeMutationVariables>(
        SetLongitudeDocument,
        variables,
      )(),
    ...options,
  })
}

useSetLongitudeMutation.fetcher = (
  variables: SetLongitudeMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetLongitudeMutation, SetLongitudeMutationVariables>(
    SetLongitudeDocument,
    variables,
    options,
  )

export const BoostDocument = `
    mutation Boost($orgPid: String!) {
  queue {
    boost(orgPid: $orgPid)
  }
}
    `

export const useBoostMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<BoostMutation, TError, BoostMutationVariables, TContext>,
) => {
  return useMutation<BoostMutation, TError, BoostMutationVariables, TContext>({
    mutationKey: ["Boost"],
    mutationFn: (variables?: BoostMutationVariables) =>
      adminFetcher<BoostMutation, BoostMutationVariables>(BoostDocument, variables)(),
    ...options,
  })
}

useBoostMutation.fetcher = (
  variables: BoostMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<BoostMutation, BoostMutationVariables>(BoostDocument, variables, options)

export const LinkConserviceAddressesDocument = `
    mutation LinkConserviceAddresses($orgPid: String!, $sitePid: String!, $conserviceAddresses: [String!]!) {
  site {
    linkConserviceAddresses(
      orgPid: $orgPid
      sitePid: $sitePid
      conserviceAddresses: $conserviceAddresses
    ) {
      ... on Error {
        __typename
        message
      }
    }
  }
}
    `

export const useLinkConserviceAddressesMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    LinkConserviceAddressesMutation,
    TError,
    LinkConserviceAddressesMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    LinkConserviceAddressesMutation,
    TError,
    LinkConserviceAddressesMutationVariables,
    TContext
  >({
    mutationKey: ["LinkConserviceAddresses"],
    mutationFn: (variables?: LinkConserviceAddressesMutationVariables) =>
      adminFetcher<
        LinkConserviceAddressesMutation,
        LinkConserviceAddressesMutationVariables
      >(LinkConserviceAddressesDocument, variables)(),
    ...options,
  })
}

useLinkConserviceAddressesMutation.fetcher = (
  variables: LinkConserviceAddressesMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    LinkConserviceAddressesMutation,
    LinkConserviceAddressesMutationVariables
  >(LinkConserviceAddressesDocument, variables, options)

export const CreateCsFinProductDocument = `
    mutation CreateCsFinProduct($input: CSFinProductInput!) {
  finproduct {
    createCsFinproduct(input: $input) {
      id
    }
  }
}
    `

export const useCreateCsFinProductMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateCsFinProductMutation,
    TError,
    CreateCsFinProductMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateCsFinProductMutation,
    TError,
    CreateCsFinProductMutationVariables,
    TContext
  >({
    mutationKey: ["CreateCsFinProduct"],
    mutationFn: (variables?: CreateCsFinProductMutationVariables) =>
      adminFetcher<CreateCsFinProductMutation, CreateCsFinProductMutationVariables>(
        CreateCsFinProductDocument,
        variables,
      )(),
    ...options,
  })
}

useCreateCsFinProductMutation.fetcher = (
  variables: CreateCsFinProductMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<CreateCsFinProductMutation, CreateCsFinProductMutationVariables>(
    CreateCsFinProductDocument,
    variables,
    options,
  )

export const EditCsFinProductPricesDocument = `
    mutation EditCSFinProductPrices($id: Int!, $input: [CSPriceInput!]!) {
  finproduct {
    editCsFinproductPrices(id: $id, input: $input) {
      id
    }
  }
}
    `

export const useEditCsFinProductPricesMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    EditCsFinProductPricesMutation,
    TError,
    EditCsFinProductPricesMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    EditCsFinProductPricesMutation,
    TError,
    EditCsFinProductPricesMutationVariables,
    TContext
  >({
    mutationKey: ["EditCSFinProductPrices"],
    mutationFn: (variables?: EditCsFinProductPricesMutationVariables) =>
      adminFetcher<
        EditCsFinProductPricesMutation,
        EditCsFinProductPricesMutationVariables
      >(EditCsFinProductPricesDocument, variables)(),
    ...options,
  })
}

useEditCsFinProductPricesMutation.fetcher = (
  variables: EditCsFinProductPricesMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<EditCsFinProductPricesMutation, EditCsFinProductPricesMutationVariables>(
    EditCsFinProductPricesDocument,
    variables,
    options,
  )

export const CreatePpaFinProductDocument = `
    mutation CreatePpaFinProduct($input: PPAFinProductInput!) {
  finproduct {
    createPpaFinproduct(input: $input) {
      id
    }
  }
}
    `

export const useCreatePpaFinProductMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreatePpaFinProductMutation,
    TError,
    CreatePpaFinProductMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreatePpaFinProductMutation,
    TError,
    CreatePpaFinProductMutationVariables,
    TContext
  >({
    mutationKey: ["CreatePpaFinProduct"],
    mutationFn: (variables?: CreatePpaFinProductMutationVariables) =>
      adminFetcher<CreatePpaFinProductMutation, CreatePpaFinProductMutationVariables>(
        CreatePpaFinProductDocument,
        variables,
      )(),
    ...options,
  })
}

useCreatePpaFinProductMutation.fetcher = (
  variables: CreatePpaFinProductMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<CreatePpaFinProductMutation, CreatePpaFinProductMutationVariables>(
    CreatePpaFinProductDocument,
    variables,
    options,
  )

export const CreateLoanFinProductDocument = `
    mutation CreateLoanFinProduct($input: LoanFinProductInput!) {
  finproduct {
    createLoanFinproduct(input: $input) {
      id
    }
  }
}
    `

export const useCreateLoanFinProductMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateLoanFinProductMutation,
    TError,
    CreateLoanFinProductMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateLoanFinProductMutation,
    TError,
    CreateLoanFinProductMutationVariables,
    TContext
  >({
    mutationKey: ["CreateLoanFinProduct"],
    mutationFn: (variables?: CreateLoanFinProductMutationVariables) =>
      adminFetcher<CreateLoanFinProductMutation, CreateLoanFinProductMutationVariables>(
        CreateLoanFinProductDocument,
        variables,
      )(),
    ...options,
  })
}

useCreateLoanFinProductMutation.fetcher = (
  variables: CreateLoanFinProductMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<CreateLoanFinProductMutation, CreateLoanFinProductMutationVariables>(
    CreateLoanFinProductDocument,
    variables,
    options,
  )

export const FinProductSetNameDocument = `
    mutation FinProductSetName($id: Int!, $value: String!) {
  finproduct {
    setName(id: $id, name: $value) {
      id
    }
  }
}
    `

export const useFinProductSetNameMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    FinProductSetNameMutation,
    TError,
    FinProductSetNameMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    FinProductSetNameMutation,
    TError,
    FinProductSetNameMutationVariables,
    TContext
  >({
    mutationKey: ["FinProductSetName"],
    mutationFn: (variables?: FinProductSetNameMutationVariables) =>
      adminFetcher<FinProductSetNameMutation, FinProductSetNameMutationVariables>(
        FinProductSetNameDocument,
        variables,
      )(),
    ...options,
  })
}

useFinProductSetNameMutation.fetcher = (
  variables: FinProductSetNameMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<FinProductSetNameMutation, FinProductSetNameMutationVariables>(
    FinProductSetNameDocument,
    variables,
    options,
  )

export const FinProductSetStatusDocument = `
    mutation FinProductSetStatus($id: Int!, $value: FinProductStatus) {
  finproduct {
    setStatus(id: $id, status: $value) {
      id
    }
  }
}
    `

export const useFinProductSetStatusMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    FinProductSetStatusMutation,
    TError,
    FinProductSetStatusMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    FinProductSetStatusMutation,
    TError,
    FinProductSetStatusMutationVariables,
    TContext
  >({
    mutationKey: ["FinProductSetStatus"],
    mutationFn: (variables?: FinProductSetStatusMutationVariables) =>
      adminFetcher<FinProductSetStatusMutation, FinProductSetStatusMutationVariables>(
        FinProductSetStatusDocument,
        variables,
      )(),
    ...options,
  })
}

useFinProductSetStatusMutation.fetcher = (
  variables: FinProductSetStatusMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<FinProductSetStatusMutation, FinProductSetStatusMutationVariables>(
    FinProductSetStatusDocument,
    variables,
    options,
  )

export const FinProductSetDisabledDocument = `
    mutation FinProductSetDisabled($id: Int!, $value: Boolean!) {
  finproduct {
    setDisabled(id: $id, disabled: $value) {
      id
    }
  }
}
    `

export const useFinProductSetDisabledMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    FinProductSetDisabledMutation,
    TError,
    FinProductSetDisabledMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    FinProductSetDisabledMutation,
    TError,
    FinProductSetDisabledMutationVariables,
    TContext
  >({
    mutationKey: ["FinProductSetDisabled"],
    mutationFn: (variables?: FinProductSetDisabledMutationVariables) =>
      adminFetcher<
        FinProductSetDisabledMutation,
        FinProductSetDisabledMutationVariables
      >(FinProductSetDisabledDocument, variables)(),
    ...options,
  })
}

useFinProductSetDisabledMutation.fetcher = (
  variables: FinProductSetDisabledMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<FinProductSetDisabledMutation, FinProductSetDisabledMutationVariables>(
    FinProductSetDisabledDocument,
    variables,
    options,
  )

export const FinProductSetIncludeStorageDocument = `
    mutation FinProductSetIncludeStorage($finproductId: Int!, $enable: Boolean!) {
  finproduct {
    setIncludeStorage(id: $finproductId, includeStorage: $enable) {
      id
    }
  }
}
    `

export const useFinProductSetIncludeStorageMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    FinProductSetIncludeStorageMutation,
    TError,
    FinProductSetIncludeStorageMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    FinProductSetIncludeStorageMutation,
    TError,
    FinProductSetIncludeStorageMutationVariables,
    TContext
  >({
    mutationKey: ["FinProductSetIncludeStorage"],
    mutationFn: (variables?: FinProductSetIncludeStorageMutationVariables) =>
      adminFetcher<
        FinProductSetIncludeStorageMutation,
        FinProductSetIncludeStorageMutationVariables
      >(FinProductSetIncludeStorageDocument, variables)(),
    ...options,
  })
}

useFinProductSetIncludeStorageMutation.fetcher = (
  variables: FinProductSetIncludeStorageMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    FinProductSetIncludeStorageMutation,
    FinProductSetIncludeStorageMutationVariables
  >(FinProductSetIncludeStorageDocument, variables, options)

export const SiteToggleFinProductDocument = `
    mutation SiteToggleFinProduct($sitePid: String!, $finproductId: Int!, $enabled: Boolean!) {
  site {
    toggleFinproduct(
      sitePid: $sitePid
      finproductId: $finproductId
      enabled: $enabled
    )
  }
}
    `

export const useSiteToggleFinProductMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SiteToggleFinProductMutation,
    TError,
    SiteToggleFinProductMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SiteToggleFinProductMutation,
    TError,
    SiteToggleFinProductMutationVariables,
    TContext
  >({
    mutationKey: ["SiteToggleFinProduct"],
    mutationFn: (variables?: SiteToggleFinProductMutationVariables) =>
      adminFetcher<SiteToggleFinProductMutation, SiteToggleFinProductMutationVariables>(
        SiteToggleFinProductDocument,
        variables,
      )(),
    ...options,
  })
}

useSiteToggleFinProductMutation.fetcher = (
  variables: SiteToggleFinProductMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SiteToggleFinProductMutation, SiteToggleFinProductMutationVariables>(
    SiteToggleFinProductDocument,
    variables,
    options,
  )

export const ToggleHideFakePanelsDocument = `
    mutation ToggleHideFakePanels($sitePid: String!, $hide: Boolean!) {
  site {
    toggleHideFakePanels(sitePid: $sitePid, hide: $hide)
  }
}
    `

export const useToggleHideFakePanelsMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ToggleHideFakePanelsMutation,
    TError,
    ToggleHideFakePanelsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ToggleHideFakePanelsMutation,
    TError,
    ToggleHideFakePanelsMutationVariables,
    TContext
  >({
    mutationKey: ["ToggleHideFakePanels"],
    mutationFn: (variables?: ToggleHideFakePanelsMutationVariables) =>
      adminFetcher<ToggleHideFakePanelsMutation, ToggleHideFakePanelsMutationVariables>(
        ToggleHideFakePanelsDocument,
        variables,
      )(),
    ...options,
  })
}

useToggleHideFakePanelsMutation.fetcher = (
  variables: ToggleHideFakePanelsMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ToggleHideFakePanelsMutation, ToggleHideFakePanelsMutationVariables>(
    ToggleHideFakePanelsDocument,
    variables,
    options,
  )

export const TodoItemAddDocument = `
    mutation TodoItemAdd($sitePid: String!, $content: String!, $sectionName: String!) {
  todos {
    add(sitePid: $sitePid, content: $content, sectionName: $sectionName)
  }
}
    `

export const useTodoItemAddMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    TodoItemAddMutation,
    TError,
    TodoItemAddMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    TodoItemAddMutation,
    TError,
    TodoItemAddMutationVariables,
    TContext
  >({
    mutationKey: ["TodoItemAdd"],
    mutationFn: (variables?: TodoItemAddMutationVariables) =>
      adminFetcher<TodoItemAddMutation, TodoItemAddMutationVariables>(
        TodoItemAddDocument,
        variables,
      )(),
    ...options,
  })
}

useTodoItemAddMutation.fetcher = (
  variables: TodoItemAddMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<TodoItemAddMutation, TodoItemAddMutationVariables>(
    TodoItemAddDocument,
    variables,
    options,
  )

export const TodoItemDeleteDocument = `
    mutation TodoItemDelete($sitePid: String!, $todoItemId: Int!) {
  todos {
    delete(sitePid: $sitePid, todoItemId: $todoItemId)
  }
}
    `

export const useTodoItemDeleteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    TodoItemDeleteMutation,
    TError,
    TodoItemDeleteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    TodoItemDeleteMutation,
    TError,
    TodoItemDeleteMutationVariables,
    TContext
  >({
    mutationKey: ["TodoItemDelete"],
    mutationFn: (variables?: TodoItemDeleteMutationVariables) =>
      adminFetcher<TodoItemDeleteMutation, TodoItemDeleteMutationVariables>(
        TodoItemDeleteDocument,
        variables,
      )(),
    ...options,
  })
}

useTodoItemDeleteMutation.fetcher = (
  variables: TodoItemDeleteMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<TodoItemDeleteMutation, TodoItemDeleteMutationVariables>(
    TodoItemDeleteDocument,
    variables,
    options,
  )

export const TodoItemSetContentDocument = `
    mutation TodoItemSetContent($sitePid: String!, $todoItemId: Int!, $content: String!) {
  todos {
    setContent(sitePid: $sitePid, todoItemId: $todoItemId, content: $content)
  }
}
    `

export const useTodoItemSetContentMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    TodoItemSetContentMutation,
    TError,
    TodoItemSetContentMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    TodoItemSetContentMutation,
    TError,
    TodoItemSetContentMutationVariables,
    TContext
  >({
    mutationKey: ["TodoItemSetContent"],
    mutationFn: (variables?: TodoItemSetContentMutationVariables) =>
      adminFetcher<TodoItemSetContentMutation, TodoItemSetContentMutationVariables>(
        TodoItemSetContentDocument,
        variables,
      )(),
    ...options,
  })
}

useTodoItemSetContentMutation.fetcher = (
  variables: TodoItemSetContentMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<TodoItemSetContentMutation, TodoItemSetContentMutationVariables>(
    TodoItemSetContentDocument,
    variables,
    options,
  )

export const TodoItemSetCompleteDocument = `
    mutation TodoItemSetComplete($sitePid: String!, $todoItemId: Int!, $complete: Boolean!) {
  todos {
    setComplete(sitePid: $sitePid, todoItemId: $todoItemId, complete: $complete)
  }
}
    `

export const useTodoItemSetCompleteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    TodoItemSetCompleteMutation,
    TError,
    TodoItemSetCompleteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    TodoItemSetCompleteMutation,
    TError,
    TodoItemSetCompleteMutationVariables,
    TContext
  >({
    mutationKey: ["TodoItemSetComplete"],
    mutationFn: (variables?: TodoItemSetCompleteMutationVariables) =>
      adminFetcher<TodoItemSetCompleteMutation, TodoItemSetCompleteMutationVariables>(
        TodoItemSetCompleteDocument,
        variables,
      )(),
    ...options,
  })
}

useTodoItemSetCompleteMutation.fetcher = (
  variables: TodoItemSetCompleteMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<TodoItemSetCompleteMutation, TodoItemSetCompleteMutationVariables>(
    TodoItemSetCompleteDocument,
    variables,
    options,
  )

export const TodoItemSetLocationDocument = `
    mutation TodoItemSetLocation($sitePid: String!, $todoItemId: Int!, $sectionName: String!, $index: Int!) {
  todos {
    setSection(
      sitePid: $sitePid
      todoItemId: $todoItemId
      sectionName: $sectionName
      index: $index
    )
  }
}
    `

export const useTodoItemSetLocationMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    TodoItemSetLocationMutation,
    TError,
    TodoItemSetLocationMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    TodoItemSetLocationMutation,
    TError,
    TodoItemSetLocationMutationVariables,
    TContext
  >({
    mutationKey: ["TodoItemSetLocation"],
    mutationFn: (variables?: TodoItemSetLocationMutationVariables) =>
      adminFetcher<TodoItemSetLocationMutation, TodoItemSetLocationMutationVariables>(
        TodoItemSetLocationDocument,
        variables,
      )(),
    ...options,
  })
}

useTodoItemSetLocationMutation.fetcher = (
  variables: TodoItemSetLocationMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<TodoItemSetLocationMutation, TodoItemSetLocationMutationVariables>(
    TodoItemSetLocationDocument,
    variables,
    options,
  )

export const TodoSectionSetIndexDocument = `
    mutation TodoSectionSetIndex($sitePid: String!, $sectionName: String!, $index: Int!) {
  todos {
    setSectionIndex(sitePid: $sitePid, sectionName: $sectionName, index: $index)
  }
}
    `

export const useTodoSectionSetIndexMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    TodoSectionSetIndexMutation,
    TError,
    TodoSectionSetIndexMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    TodoSectionSetIndexMutation,
    TError,
    TodoSectionSetIndexMutationVariables,
    TContext
  >({
    mutationKey: ["TodoSectionSetIndex"],
    mutationFn: (variables?: TodoSectionSetIndexMutationVariables) =>
      adminFetcher<TodoSectionSetIndexMutation, TodoSectionSetIndexMutationVariables>(
        TodoSectionSetIndexDocument,
        variables,
      )(),
    ...options,
  })
}

useTodoSectionSetIndexMutation.fetcher = (
  variables: TodoSectionSetIndexMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<TodoSectionSetIndexMutation, TodoSectionSetIndexMutationVariables>(
    TodoSectionSetIndexDocument,
    variables,
    options,
  )

export const TodoSectionSetNameDocument = `
    mutation TodoSectionSetName($sitePid: String!, $sectionName: String!, $newName: String!) {
  todos {
    setSectionName(sitePid: $sitePid, sectionName: $sectionName, newName: $newName)
  }
}
    `

export const useTodoSectionSetNameMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    TodoSectionSetNameMutation,
    TError,
    TodoSectionSetNameMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    TodoSectionSetNameMutation,
    TError,
    TodoSectionSetNameMutationVariables,
    TContext
  >({
    mutationKey: ["TodoSectionSetName"],
    mutationFn: (variables?: TodoSectionSetNameMutationVariables) =>
      adminFetcher<TodoSectionSetNameMutation, TodoSectionSetNameMutationVariables>(
        TodoSectionSetNameDocument,
        variables,
      )(),
    ...options,
  })
}

useTodoSectionSetNameMutation.fetcher = (
  variables: TodoSectionSetNameMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<TodoSectionSetNameMutation, TodoSectionSetNameMutationVariables>(
    TodoSectionSetNameDocument,
    variables,
    options,
  )

export const SetHelioscopeAllocationDocument = `
    mutation SetHelioscopeAllocation($helioscopeId: Int!, $allocations: [Allocation!]!) {
  site {
    setHelioscopeAllocation(helioscopeId: $helioscopeId, allocations: $allocations)
  }
}
    `

export const useSetHelioscopeAllocationMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetHelioscopeAllocationMutation,
    TError,
    SetHelioscopeAllocationMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetHelioscopeAllocationMutation,
    TError,
    SetHelioscopeAllocationMutationVariables,
    TContext
  >({
    mutationKey: ["SetHelioscopeAllocation"],
    mutationFn: (variables?: SetHelioscopeAllocationMutationVariables) =>
      adminFetcher<
        SetHelioscopeAllocationMutation,
        SetHelioscopeAllocationMutationVariables
      >(SetHelioscopeAllocationDocument, variables)(),
    ...options,
  })
}

useSetHelioscopeAllocationMutation.fetcher = (
  variables: SetHelioscopeAllocationMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    SetHelioscopeAllocationMutation,
    SetHelioscopeAllocationMutationVariables
  >(SetHelioscopeAllocationDocument, variables, options)

export const NewEvCalcDocument = `
    mutation NewEvCalc($sitePid: String!, $markupUsdPerKwh: Float!, $numChargers: Int!) {
  site {
    newEvCalc(
      sitePid: $sitePid
      markupUsdPerKwh: $markupUsdPerKwh
      numChargers: $numChargers
    ) {
      ...BasicEVCalc
    }
  }
}
    ${BasicEvCalcFragmentDoc}`

export const useNewEvCalcMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    NewEvCalcMutation,
    TError,
    NewEvCalcMutationVariables,
    TContext
  >,
) => {
  return useMutation<NewEvCalcMutation, TError, NewEvCalcMutationVariables, TContext>({
    mutationKey: ["NewEvCalc"],
    mutationFn: (variables?: NewEvCalcMutationVariables) =>
      adminFetcher<NewEvCalcMutation, NewEvCalcMutationVariables>(
        NewEvCalcDocument,
        variables,
      )(),
    ...options,
  })
}

useNewEvCalcMutation.fetcher = (
  variables: NewEvCalcMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<NewEvCalcMutation, NewEvCalcMutationVariables>(
    NewEvCalcDocument,
    variables,
    options,
  )

export const FetchTariffVersionDocument = `
    mutation FetchTariffVersion($masterTariffId: Int!, $effectiveOn: DateTime!) {
  tariff {
    fetchTariffVersion(masterTariffId: $masterTariffId, effectiveOn: $effectiveOn)
  }
}
    `

export const useFetchTariffVersionMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    FetchTariffVersionMutation,
    TError,
    FetchTariffVersionMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    FetchTariffVersionMutation,
    TError,
    FetchTariffVersionMutationVariables,
    TContext
  >({
    mutationKey: ["FetchTariffVersion"],
    mutationFn: (variables?: FetchTariffVersionMutationVariables) =>
      adminFetcher<FetchTariffVersionMutation, FetchTariffVersionMutationVariables>(
        FetchTariffVersionDocument,
        variables,
      )(),
    ...options,
  })
}

useFetchTariffVersionMutation.fetcher = (
  variables: FetchTariffVersionMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<FetchTariffVersionMutation, FetchTariffVersionMutationVariables>(
    FetchTariffVersionDocument,
    variables,
    options,
  )

export const UpdateHelioscopeAssumptionsDocument = `
    mutation UpdateHelioscopeAssumptions($helioscopePid: String!, $assumptions: HelioscopeAssumptionsInput!) {
  helioscopes {
    updateHelioscopeAssumptions(
      helioscopePid: $helioscopePid
      assumptions: $assumptions
    ) {
      __typename
    }
  }
}
    `

export const useUpdateHelioscopeAssumptionsMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateHelioscopeAssumptionsMutation,
    TError,
    UpdateHelioscopeAssumptionsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateHelioscopeAssumptionsMutation,
    TError,
    UpdateHelioscopeAssumptionsMutationVariables,
    TContext
  >({
    mutationKey: ["UpdateHelioscopeAssumptions"],
    mutationFn: (variables?: UpdateHelioscopeAssumptionsMutationVariables) =>
      adminFetcher<
        UpdateHelioscopeAssumptionsMutation,
        UpdateHelioscopeAssumptionsMutationVariables
      >(UpdateHelioscopeAssumptionsDocument, variables)(),
    ...options,
  })
}

useUpdateHelioscopeAssumptionsMutation.fetcher = (
  variables: UpdateHelioscopeAssumptionsMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    UpdateHelioscopeAssumptionsMutation,
    UpdateHelioscopeAssumptionsMutationVariables
  >(UpdateHelioscopeAssumptionsDocument, variables, options)

export const UpdateMultifamilyUnitsDocument = `
    mutation UpdateMultifamilyUnits($sitePid: String!, $input: MFUnitBreakdownInput!) {
  updateMfUnits(sitePid: $sitePid, input: $input)
}
    `

export const useUpdateMultifamilyUnitsMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateMultifamilyUnitsMutation,
    TError,
    UpdateMultifamilyUnitsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateMultifamilyUnitsMutation,
    TError,
    UpdateMultifamilyUnitsMutationVariables,
    TContext
  >({
    mutationKey: ["UpdateMultifamilyUnits"],
    mutationFn: (variables?: UpdateMultifamilyUnitsMutationVariables) =>
      adminFetcher<
        UpdateMultifamilyUnitsMutation,
        UpdateMultifamilyUnitsMutationVariables
      >(UpdateMultifamilyUnitsDocument, variables)(),
    ...options,
  })
}

useUpdateMultifamilyUnitsMutation.fetcher = (
  variables: UpdateMultifamilyUnitsMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<UpdateMultifamilyUnitsMutation, UpdateMultifamilyUnitsMutationVariables>(
    UpdateMultifamilyUnitsDocument,
    variables,
    options,
  )

export const SetUserEnabledDocument = `
    mutation SetUserEnabled($userId: Int!, $isEnabled: Boolean!) {
  user {
    setIsEnabled(userId: $userId, isEnabled: $isEnabled) {
      __typename
      isEnabled
      lastSeenAt
    }
  }
}
    `

export const useSetUserEnabledMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetUserEnabledMutation,
    TError,
    SetUserEnabledMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetUserEnabledMutation,
    TError,
    SetUserEnabledMutationVariables,
    TContext
  >({
    mutationKey: ["SetUserEnabled"],
    mutationFn: (variables?: SetUserEnabledMutationVariables) =>
      adminFetcher<SetUserEnabledMutation, SetUserEnabledMutationVariables>(
        SetUserEnabledDocument,
        variables,
      )(),
    ...options,
  })
}

useSetUserEnabledMutation.fetcher = (
  variables: SetUserEnabledMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SetUserEnabledMutation, SetUserEnabledMutationVariables>(
    SetUserEnabledDocument,
    variables,
    options,
  )

export const ClearSiteDrawingsDocument = `
    mutation ClearSiteDrawings($input: ClearDrawingsInput!) {
  site {
    clearDrawings(input: $input)
  }
}
    `

export const useClearSiteDrawingsMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ClearSiteDrawingsMutation,
    TError,
    ClearSiteDrawingsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ClearSiteDrawingsMutation,
    TError,
    ClearSiteDrawingsMutationVariables,
    TContext
  >({
    mutationKey: ["ClearSiteDrawings"],
    mutationFn: (variables?: ClearSiteDrawingsMutationVariables) =>
      adminFetcher<ClearSiteDrawingsMutation, ClearSiteDrawingsMutationVariables>(
        ClearSiteDrawingsDocument,
        variables,
      )(),
    ...options,
  })
}

useClearSiteDrawingsMutation.fetcher = (
  variables: ClearSiteDrawingsMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ClearSiteDrawingsMutation, ClearSiteDrawingsMutationVariables>(
    ClearSiteDrawingsDocument,
    variables,
    options,
  )

export const RevertSiteToEstimatesDocument = `
    mutation RevertSiteToEstimates($input: RevertToEstimatesInput!) {
  site {
    revertToEstimates(input: $input)
  }
}
    `

export const useRevertSiteToEstimatesMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    RevertSiteToEstimatesMutation,
    TError,
    RevertSiteToEstimatesMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RevertSiteToEstimatesMutation,
    TError,
    RevertSiteToEstimatesMutationVariables,
    TContext
  >({
    mutationKey: ["RevertSiteToEstimates"],
    mutationFn: (variables?: RevertSiteToEstimatesMutationVariables) =>
      adminFetcher<
        RevertSiteToEstimatesMutation,
        RevertSiteToEstimatesMutationVariables
      >(RevertSiteToEstimatesDocument, variables)(),
    ...options,
  })
}

useRevertSiteToEstimatesMutation.fetcher = (
  variables: RevertSiteToEstimatesMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<RevertSiteToEstimatesMutation, RevertSiteToEstimatesMutationVariables>(
    RevertSiteToEstimatesDocument,
    variables,
    options,
  )

export const PromoteTheFinmodelAnywayDocument = `
    mutation PromoteTheFinmodelAnyway($finmodelId: Int!) {
  promoteTheFinmodelAnyway(finmodelId: $finmodelId)
}
    `

export const usePromoteTheFinmodelAnywayMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    PromoteTheFinmodelAnywayMutation,
    TError,
    PromoteTheFinmodelAnywayMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    PromoteTheFinmodelAnywayMutation,
    TError,
    PromoteTheFinmodelAnywayMutationVariables,
    TContext
  >({
    mutationKey: ["PromoteTheFinmodelAnyway"],
    mutationFn: (variables?: PromoteTheFinmodelAnywayMutationVariables) =>
      adminFetcher<
        PromoteTheFinmodelAnywayMutation,
        PromoteTheFinmodelAnywayMutationVariables
      >(PromoteTheFinmodelAnywayDocument, variables)(),
    ...options,
  })
}

usePromoteTheFinmodelAnywayMutation.fetcher = (
  variables: PromoteTheFinmodelAnywayMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    PromoteTheFinmodelAnywayMutation,
    PromoteTheFinmodelAnywayMutationVariables
  >(PromoteTheFinmodelAnywayDocument, variables, options)

export const TurnOffBillingMetersDocument = `
    mutation TurnOffBillingMeters($sitePid: String!) {
  site {
    turnOffBillingMeters(sitePid: $sitePid)
  }
}
    `

export const useTurnOffBillingMetersMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    TurnOffBillingMetersMutation,
    TError,
    TurnOffBillingMetersMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    TurnOffBillingMetersMutation,
    TError,
    TurnOffBillingMetersMutationVariables,
    TContext
  >({
    mutationKey: ["TurnOffBillingMeters"],
    mutationFn: (variables?: TurnOffBillingMetersMutationVariables) =>
      adminFetcher<TurnOffBillingMetersMutation, TurnOffBillingMetersMutationVariables>(
        TurnOffBillingMetersDocument,
        variables,
      )(),
    ...options,
  })
}

useTurnOffBillingMetersMutation.fetcher = (
  variables: TurnOffBillingMetersMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<TurnOffBillingMetersMutation, TurnOffBillingMetersMutationVariables>(
    TurnOffBillingMetersDocument,
    variables,
    options,
  )

export const UpdateBundleRowMilestonesDocument = `
    mutation UpdateBundleRowMilestones($id: Int!, $preBidMeetingDate: Date, $bidReviewMeetingDate: Date, $contractSignedDate: Date, $ntpDate: Date, $codDate: Date, $reason: CloseReason, $customReason: String) {
  bundleRows {
    setPreBidMeetingDate(id: $id, preBidMeetingDate: $preBidMeetingDate) {
      __typename
    }
    setBidReviewMeetingDate(id: $id, bidReviewMeetingDate: $bidReviewMeetingDate) {
      __typename
    }
    setContractSignedDate(id: $id, contractSignedDate: $contractSignedDate) {
      __typename
    }
    setNtpDate(id: $id, ntpDate: $ntpDate) {
      __typename
    }
    setCodDate(id: $id, codDate: $codDate) {
      __typename
    }
    setCloseReason(bundleRowId: $id, reason: $reason, customReason: $customReason)
  }
}
    `

export const useUpdateBundleRowMilestonesMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateBundleRowMilestonesMutation,
    TError,
    UpdateBundleRowMilestonesMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateBundleRowMilestonesMutation,
    TError,
    UpdateBundleRowMilestonesMutationVariables,
    TContext
  >({
    mutationKey: ["UpdateBundleRowMilestones"],
    mutationFn: (variables?: UpdateBundleRowMilestonesMutationVariables) =>
      adminFetcher<
        UpdateBundleRowMilestonesMutation,
        UpdateBundleRowMilestonesMutationVariables
      >(UpdateBundleRowMilestonesDocument, variables)(),
    ...options,
  })
}

useUpdateBundleRowMilestonesMutation.fetcher = (
  variables: UpdateBundleRowMilestonesMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    UpdateBundleRowMilestonesMutation,
    UpdateBundleRowMilestonesMutationVariables
  >(UpdateBundleRowMilestonesDocument, variables, options)

export const FindBuildingFootprintsDocument = `
    mutation FindBuildingFootprints($sitePid: String!, $strategy: FootprintStrategy!) {
  site {
    findBuildingFootprints(sitePid: $sitePid, strategy: $strategy)
  }
}
    `

export const useFindBuildingFootprintsMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    FindBuildingFootprintsMutation,
    TError,
    FindBuildingFootprintsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    FindBuildingFootprintsMutation,
    TError,
    FindBuildingFootprintsMutationVariables,
    TContext
  >({
    mutationKey: ["FindBuildingFootprints"],
    mutationFn: (variables?: FindBuildingFootprintsMutationVariables) =>
      adminFetcher<
        FindBuildingFootprintsMutation,
        FindBuildingFootprintsMutationVariables
      >(FindBuildingFootprintsDocument, variables)(),
    ...options,
  })
}

useFindBuildingFootprintsMutation.fetcher = (
  variables: FindBuildingFootprintsMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<FindBuildingFootprintsMutation, FindBuildingFootprintsMutationVariables>(
    FindBuildingFootprintsDocument,
    variables,
    options,
  )

export const CreateHostingCapacityMapDocument = `
    mutation CreateHostingCapacityMap($utilityPid: String!, $hostingCapacityMap: HostingCapacityMapInputs!) {
  hostingCapacityMaps {
    create(utilityPid: $utilityPid, inputs: $hostingCapacityMap)
  }
}
    `

export const useCreateHostingCapacityMapMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateHostingCapacityMapMutation,
    TError,
    CreateHostingCapacityMapMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateHostingCapacityMapMutation,
    TError,
    CreateHostingCapacityMapMutationVariables,
    TContext
  >({
    mutationKey: ["CreateHostingCapacityMap"],
    mutationFn: (variables?: CreateHostingCapacityMapMutationVariables) =>
      adminFetcher<
        CreateHostingCapacityMapMutation,
        CreateHostingCapacityMapMutationVariables
      >(CreateHostingCapacityMapDocument, variables)(),
    ...options,
  })
}

useCreateHostingCapacityMapMutation.fetcher = (
  variables: CreateHostingCapacityMapMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    CreateHostingCapacityMapMutation,
    CreateHostingCapacityMapMutationVariables
  >(CreateHostingCapacityMapDocument, variables, options)

export const UpdateHostingCapacityMapDocument = `
    mutation UpdateHostingCapacityMap($mapId: Int!, $hostingCapacityMap: HostingCapacityMapInputs!) {
  hostingCapacityMaps {
    update(mapId: $mapId, inputs: $hostingCapacityMap)
  }
}
    `

export const useUpdateHostingCapacityMapMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateHostingCapacityMapMutation,
    TError,
    UpdateHostingCapacityMapMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateHostingCapacityMapMutation,
    TError,
    UpdateHostingCapacityMapMutationVariables,
    TContext
  >({
    mutationKey: ["UpdateHostingCapacityMap"],
    mutationFn: (variables?: UpdateHostingCapacityMapMutationVariables) =>
      adminFetcher<
        UpdateHostingCapacityMapMutation,
        UpdateHostingCapacityMapMutationVariables
      >(UpdateHostingCapacityMapDocument, variables)(),
    ...options,
  })
}

useUpdateHostingCapacityMapMutation.fetcher = (
  variables: UpdateHostingCapacityMapMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    UpdateHostingCapacityMapMutation,
    UpdateHostingCapacityMapMutationVariables
  >(UpdateHostingCapacityMapDocument, variables, options)

export const DeleteHostingCapacityMapDocument = `
    mutation DeleteHostingCapacityMap($mapId: Int!) {
  hostingCapacityMaps {
    delete(mapId: $mapId)
  }
}
    `

export const useDeleteHostingCapacityMapMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DeleteHostingCapacityMapMutation,
    TError,
    DeleteHostingCapacityMapMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeleteHostingCapacityMapMutation,
    TError,
    DeleteHostingCapacityMapMutationVariables,
    TContext
  >({
    mutationKey: ["DeleteHostingCapacityMap"],
    mutationFn: (variables?: DeleteHostingCapacityMapMutationVariables) =>
      adminFetcher<
        DeleteHostingCapacityMapMutation,
        DeleteHostingCapacityMapMutationVariables
      >(DeleteHostingCapacityMapDocument, variables)(),
    ...options,
  })
}

useDeleteHostingCapacityMapMutation.fetcher = (
  variables: DeleteHostingCapacityMapMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    DeleteHostingCapacityMapMutation,
    DeleteHostingCapacityMapMutationVariables
  >(DeleteHostingCapacityMapDocument, variables, options)

export const CreateEmailDraftDocument = `
    mutation CreateEmailDraft($draftParams: CreateDraftInput!) {
  googleApi {
    createDraft(draftParams: $draftParams)
  }
}
    `

export const useCreateEmailDraftMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateEmailDraftMutation,
    TError,
    CreateEmailDraftMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateEmailDraftMutation,
    TError,
    CreateEmailDraftMutationVariables,
    TContext
  >({
    mutationKey: ["CreateEmailDraft"],
    mutationFn: (variables?: CreateEmailDraftMutationVariables) =>
      adminFetcher<CreateEmailDraftMutation, CreateEmailDraftMutationVariables>(
        CreateEmailDraftDocument,
        variables,
      )(),
    ...options,
  })
}

useCreateEmailDraftMutation.fetcher = (
  variables: CreateEmailDraftMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<CreateEmailDraftMutation, CreateEmailDraftMutationVariables>(
    CreateEmailDraftDocument,
    variables,
    options,
  )

export const UpdateBundleParentRowDocument = `
    mutation UpdateBundleParentRow($bundleParentRowId: Int!, $inputs: MarketplaceRowInputs!) {
  marketplace {
    updateBundleParentRow(bundleParentRowId: $bundleParentRowId, inputs: $inputs) {
      __typename
      ... on BundleParentRow {
        id
      }
      ... on Error {
        message
      }
    }
  }
}
    `

export const useUpdateBundleParentRowMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateBundleParentRowMutation,
    TError,
    UpdateBundleParentRowMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateBundleParentRowMutation,
    TError,
    UpdateBundleParentRowMutationVariables,
    TContext
  >({
    mutationKey: ["UpdateBundleParentRow"],
    mutationFn: (variables?: UpdateBundleParentRowMutationVariables) =>
      adminFetcher<
        UpdateBundleParentRowMutation,
        UpdateBundleParentRowMutationVariables
      >(UpdateBundleParentRowDocument, variables)(),
    ...options,
  })
}

useUpdateBundleParentRowMutation.fetcher = (
  variables: UpdateBundleParentRowMutationVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<UpdateBundleParentRowMutation, UpdateBundleParentRowMutationVariables>(
    UpdateBundleParentRowDocument,
    variables,
    options,
  )

export const GetVersionDocument = `
    query GetVersion {
  schemaVersion {
    version
  }
}
    `

export const useGetVersionQuery = <TData = GetVersionQuery, TError = unknown>(
  variables?: GetVersionQueryVariables,
  options?: Omit<UseQueryOptions<GetVersionQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<GetVersionQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<GetVersionQuery, TError, TData>({
    queryKey: variables === undefined ? ["GetVersion"] : ["GetVersion", variables],
    queryFn: adminFetcher<GetVersionQuery, GetVersionQueryVariables>(
      GetVersionDocument,
      variables,
    ),
    ...options,
  })
}

useGetVersionQuery.getKey = (variables?: GetVersionQueryVariables) =>
  variables === undefined ? ["GetVersion"] : ["GetVersion", variables]

useGetVersionQuery.rootKey = "GetVersion"

export const useSuspenseGetVersionQuery = <TData = GetVersionQuery, TError = unknown>(
  variables?: GetVersionQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<GetVersionQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<GetVersionQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<GetVersionQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["GetVersionSuspense"]
        : ["GetVersionSuspense", variables],
    queryFn: adminFetcher<GetVersionQuery, GetVersionQueryVariables>(
      GetVersionDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseGetVersionQuery.getKey = (variables?: GetVersionQueryVariables) =>
  variables === undefined ? ["GetVersionSuspense"] : ["GetVersionSuspense", variables]

useSuspenseGetVersionQuery.rootKey = "GetVersion"

export const useInfiniteGetVersionQuery = <
  TData = InfiniteData<GetVersionQuery>,
  TError = unknown,
>(
  variables: GetVersionQueryVariables,
  options: Omit<UseInfiniteQueryOptions<GetVersionQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<GetVersionQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<GetVersionQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["GetVersion.infinite"]
            : ["GetVersion.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<GetVersionQuery, GetVersionQueryVariables>(GetVersionDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteGetVersionQuery.getKey = (variables?: GetVersionQueryVariables) =>
  variables === undefined ? ["GetVersion.infinite"] : ["GetVersion.infinite", variables]

useInfiniteGetVersionQuery.rootKey = "GetVersion.infinite"

export const useSuspenseInfiniteGetVersionQuery = <
  TData = InfiniteData<GetVersionQuery>,
  TError = unknown,
>(
  variables: GetVersionQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<GetVersionQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      GetVersionQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<GetVersionQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["GetVersion.infiniteSuspense"]
            : ["GetVersion.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<GetVersionQuery, GetVersionQueryVariables>(GetVersionDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteGetVersionQuery.getKey = (variables?: GetVersionQueryVariables) =>
  variables === undefined
    ? ["GetVersion.infiniteSuspense"]
    : ["GetVersion.infiniteSuspense", variables]

useSuspenseInfiniteGetVersionQuery.rootKey = "GetVersion.infinite"

useGetVersionQuery.fetcher = (
  variables?: GetVersionQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<GetVersionQuery, GetVersionQueryVariables>(
    GetVersionDocument,
    variables,
    options,
  )

export const CurrentAdminUserDocument = `
    query CurrentAdminUser {
  currentUser {
    pid
    isAuthenticated
    isAdmin
  }
}
    `

export const useCurrentAdminUserQuery = <
  TData = CurrentAdminUserQuery,
  TError = unknown,
>(
  variables?: CurrentAdminUserQueryVariables,
  options?: Omit<UseQueryOptions<CurrentAdminUserQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<CurrentAdminUserQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<CurrentAdminUserQuery, TError, TData>({
    queryKey:
      variables === undefined ? ["CurrentAdminUser"] : ["CurrentAdminUser", variables],
    queryFn: adminFetcher<CurrentAdminUserQuery, CurrentAdminUserQueryVariables>(
      CurrentAdminUserDocument,
      variables,
    ),
    ...options,
  })
}

useCurrentAdminUserQuery.getKey = (variables?: CurrentAdminUserQueryVariables) =>
  variables === undefined ? ["CurrentAdminUser"] : ["CurrentAdminUser", variables]

useCurrentAdminUserQuery.rootKey = "CurrentAdminUser"

export const useSuspenseCurrentAdminUserQuery = <
  TData = CurrentAdminUserQuery,
  TError = unknown,
>(
  variables?: CurrentAdminUserQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<CurrentAdminUserQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<CurrentAdminUserQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<CurrentAdminUserQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["CurrentAdminUserSuspense"]
        : ["CurrentAdminUserSuspense", variables],
    queryFn: adminFetcher<CurrentAdminUserQuery, CurrentAdminUserQueryVariables>(
      CurrentAdminUserDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseCurrentAdminUserQuery.getKey = (
  variables?: CurrentAdminUserQueryVariables,
) =>
  variables === undefined
    ? ["CurrentAdminUserSuspense"]
    : ["CurrentAdminUserSuspense", variables]

useSuspenseCurrentAdminUserQuery.rootKey = "CurrentAdminUser"

export const useInfiniteCurrentAdminUserQuery = <
  TData = InfiniteData<CurrentAdminUserQuery>,
  TError = unknown,
>(
  variables: CurrentAdminUserQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<CurrentAdminUserQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<CurrentAdminUserQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<CurrentAdminUserQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["CurrentAdminUser.infinite"]
            : ["CurrentAdminUser.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<CurrentAdminUserQuery, CurrentAdminUserQueryVariables>(
            CurrentAdminUserDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteCurrentAdminUserQuery.getKey = (
  variables?: CurrentAdminUserQueryVariables,
) =>
  variables === undefined
    ? ["CurrentAdminUser.infinite"]
    : ["CurrentAdminUser.infinite", variables]

useInfiniteCurrentAdminUserQuery.rootKey = "CurrentAdminUser.infinite"

export const useSuspenseInfiniteCurrentAdminUserQuery = <
  TData = InfiniteData<CurrentAdminUserQuery>,
  TError = unknown,
>(
  variables: CurrentAdminUserQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<CurrentAdminUserQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      CurrentAdminUserQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<CurrentAdminUserQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["CurrentAdminUser.infiniteSuspense"]
            : ["CurrentAdminUser.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<CurrentAdminUserQuery, CurrentAdminUserQueryVariables>(
            CurrentAdminUserDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteCurrentAdminUserQuery.getKey = (
  variables?: CurrentAdminUserQueryVariables,
) =>
  variables === undefined
    ? ["CurrentAdminUser.infiniteSuspense"]
    : ["CurrentAdminUser.infiniteSuspense", variables]

useSuspenseInfiniteCurrentAdminUserQuery.rootKey = "CurrentAdminUser.infinite"

useCurrentAdminUserQuery.fetcher = (
  variables?: CurrentAdminUserQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<CurrentAdminUserQuery, CurrentAdminUserQueryVariables>(
    CurrentAdminUserDocument,
    variables,
    options,
  )

export const AdminPortfolioListDocument = `
    query AdminPortfolioList {
  portfolios {
    pid
    title
    numSites
    org {
      pid
      name
    }
  }
}
    `

export const useAdminPortfolioListQuery = <
  TData = AdminPortfolioListQuery,
  TError = unknown,
>(
  variables?: AdminPortfolioListQueryVariables,
  options?: Omit<
    UseQueryOptions<AdminPortfolioListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<AdminPortfolioListQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<AdminPortfolioListQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["AdminPortfolioList"]
        : ["AdminPortfolioList", variables],
    queryFn: adminFetcher<AdminPortfolioListQuery, AdminPortfolioListQueryVariables>(
      AdminPortfolioListDocument,
      variables,
    ),
    ...options,
  })
}

useAdminPortfolioListQuery.getKey = (variables?: AdminPortfolioListQueryVariables) =>
  variables === undefined ? ["AdminPortfolioList"] : ["AdminPortfolioList", variables]

useAdminPortfolioListQuery.rootKey = "AdminPortfolioList"

export const useSuspenseAdminPortfolioListQuery = <
  TData = AdminPortfolioListQuery,
  TError = unknown,
>(
  variables?: AdminPortfolioListQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<AdminPortfolioListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      AdminPortfolioListQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<AdminPortfolioListQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["AdminPortfolioListSuspense"]
        : ["AdminPortfolioListSuspense", variables],
    queryFn: adminFetcher<AdminPortfolioListQuery, AdminPortfolioListQueryVariables>(
      AdminPortfolioListDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseAdminPortfolioListQuery.getKey = (
  variables?: AdminPortfolioListQueryVariables,
) =>
  variables === undefined
    ? ["AdminPortfolioListSuspense"]
    : ["AdminPortfolioListSuspense", variables]

useSuspenseAdminPortfolioListQuery.rootKey = "AdminPortfolioList"

export const useInfiniteAdminPortfolioListQuery = <
  TData = InfiniteData<AdminPortfolioListQuery>,
  TError = unknown,
>(
  variables: AdminPortfolioListQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<AdminPortfolioListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      AdminPortfolioListQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<AdminPortfolioListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["AdminPortfolioList.infinite"]
            : ["AdminPortfolioList.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminPortfolioListQuery, AdminPortfolioListQueryVariables>(
            AdminPortfolioListDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteAdminPortfolioListQuery.getKey = (
  variables?: AdminPortfolioListQueryVariables,
) =>
  variables === undefined
    ? ["AdminPortfolioList.infinite"]
    : ["AdminPortfolioList.infinite", variables]

useInfiniteAdminPortfolioListQuery.rootKey = "AdminPortfolioList.infinite"

export const useSuspenseInfiniteAdminPortfolioListQuery = <
  TData = InfiniteData<AdminPortfolioListQuery>,
  TError = unknown,
>(
  variables: AdminPortfolioListQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<AdminPortfolioListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      AdminPortfolioListQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<AdminPortfolioListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["AdminPortfolioList.infiniteSuspense"]
            : ["AdminPortfolioList.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminPortfolioListQuery, AdminPortfolioListQueryVariables>(
            AdminPortfolioListDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteAdminPortfolioListQuery.getKey = (
  variables?: AdminPortfolioListQueryVariables,
) =>
  variables === undefined
    ? ["AdminPortfolioList.infiniteSuspense"]
    : ["AdminPortfolioList.infiniteSuspense", variables]

useSuspenseInfiniteAdminPortfolioListQuery.rootKey = "AdminPortfolioList.infinite"

useAdminPortfolioListQuery.fetcher = (
  variables?: AdminPortfolioListQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AdminPortfolioListQuery, AdminPortfolioListQueryVariables>(
    AdminPortfolioListDocument,
    variables,
    options,
  )

export const AdminOrgBySlugDocument = `
    query AdminOrgBySlug($slug: String, $pid: String) {
  orgBySlug(slug: $slug, pid: $pid) {
    pid
    slug
  }
}
    `

export const useAdminOrgBySlugQuery = <TData = AdminOrgBySlugQuery, TError = unknown>(
  variables?: AdminOrgBySlugQueryVariables,
  options?: Omit<UseQueryOptions<AdminOrgBySlugQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<AdminOrgBySlugQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<AdminOrgBySlugQuery, TError, TData>({
    queryKey:
      variables === undefined ? ["AdminOrgBySlug"] : ["AdminOrgBySlug", variables],
    queryFn: adminFetcher<AdminOrgBySlugQuery, AdminOrgBySlugQueryVariables>(
      AdminOrgBySlugDocument,
      variables,
    ),
    ...options,
  })
}

useAdminOrgBySlugQuery.getKey = (variables?: AdminOrgBySlugQueryVariables) =>
  variables === undefined ? ["AdminOrgBySlug"] : ["AdminOrgBySlug", variables]

useAdminOrgBySlugQuery.rootKey = "AdminOrgBySlug"

export const useSuspenseAdminOrgBySlugQuery = <
  TData = AdminOrgBySlugQuery,
  TError = unknown,
>(
  variables?: AdminOrgBySlugQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<AdminOrgBySlugQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<AdminOrgBySlugQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<AdminOrgBySlugQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["AdminOrgBySlugSuspense"]
        : ["AdminOrgBySlugSuspense", variables],
    queryFn: adminFetcher<AdminOrgBySlugQuery, AdminOrgBySlugQueryVariables>(
      AdminOrgBySlugDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseAdminOrgBySlugQuery.getKey = (variables?: AdminOrgBySlugQueryVariables) =>
  variables === undefined
    ? ["AdminOrgBySlugSuspense"]
    : ["AdminOrgBySlugSuspense", variables]

useSuspenseAdminOrgBySlugQuery.rootKey = "AdminOrgBySlug"

export const useInfiniteAdminOrgBySlugQuery = <
  TData = InfiniteData<AdminOrgBySlugQuery>,
  TError = unknown,
>(
  variables: AdminOrgBySlugQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<AdminOrgBySlugQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<AdminOrgBySlugQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<AdminOrgBySlugQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["AdminOrgBySlug.infinite"]
            : ["AdminOrgBySlug.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminOrgBySlugQuery, AdminOrgBySlugQueryVariables>(
            AdminOrgBySlugDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteAdminOrgBySlugQuery.getKey = (variables?: AdminOrgBySlugQueryVariables) =>
  variables === undefined
    ? ["AdminOrgBySlug.infinite"]
    : ["AdminOrgBySlug.infinite", variables]

useInfiniteAdminOrgBySlugQuery.rootKey = "AdminOrgBySlug.infinite"

export const useSuspenseInfiniteAdminOrgBySlugQuery = <
  TData = InfiniteData<AdminOrgBySlugQuery>,
  TError = unknown,
>(
  variables: AdminOrgBySlugQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<AdminOrgBySlugQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      AdminOrgBySlugQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<AdminOrgBySlugQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["AdminOrgBySlug.infiniteSuspense"]
            : ["AdminOrgBySlug.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminOrgBySlugQuery, AdminOrgBySlugQueryVariables>(
            AdminOrgBySlugDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteAdminOrgBySlugQuery.getKey = (
  variables?: AdminOrgBySlugQueryVariables,
) =>
  variables === undefined
    ? ["AdminOrgBySlug.infiniteSuspense"]
    : ["AdminOrgBySlug.infiniteSuspense", variables]

useSuspenseInfiniteAdminOrgBySlugQuery.rootKey = "AdminOrgBySlug.infinite"

useAdminOrgBySlugQuery.fetcher = (
  variables?: AdminOrgBySlugQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AdminOrgBySlugQuery, AdminOrgBySlugQueryVariables>(
    AdminOrgBySlugDocument,
    variables,
    options,
  )

export const OrgsAndPortfoliosDocument = `
    query OrgsAndPortfolios {
  orgs {
    pid
    name
  }
  portfolios {
    pid
    title
    numSites
    org {
      pid
    }
  }
}
    `

export const useOrgsAndPortfoliosQuery = <
  TData = OrgsAndPortfoliosQuery,
  TError = unknown,
>(
  variables?: OrgsAndPortfoliosQueryVariables,
  options?: Omit<UseQueryOptions<OrgsAndPortfoliosQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<OrgsAndPortfoliosQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OrgsAndPortfoliosQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["OrgsAndPortfolios"]
        : ["OrgsAndPortfolios", variables],
    queryFn: adminFetcher<OrgsAndPortfoliosQuery, OrgsAndPortfoliosQueryVariables>(
      OrgsAndPortfoliosDocument,
      variables,
    ),
    ...options,
  })
}

useOrgsAndPortfoliosQuery.getKey = (variables?: OrgsAndPortfoliosQueryVariables) =>
  variables === undefined ? ["OrgsAndPortfolios"] : ["OrgsAndPortfolios", variables]

useOrgsAndPortfoliosQuery.rootKey = "OrgsAndPortfolios"

export const useSuspenseOrgsAndPortfoliosQuery = <
  TData = OrgsAndPortfoliosQuery,
  TError = unknown,
>(
  variables?: OrgsAndPortfoliosQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<OrgsAndPortfoliosQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      OrgsAndPortfoliosQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<OrgsAndPortfoliosQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["OrgsAndPortfoliosSuspense"]
        : ["OrgsAndPortfoliosSuspense", variables],
    queryFn: adminFetcher<OrgsAndPortfoliosQuery, OrgsAndPortfoliosQueryVariables>(
      OrgsAndPortfoliosDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseOrgsAndPortfoliosQuery.getKey = (
  variables?: OrgsAndPortfoliosQueryVariables,
) =>
  variables === undefined
    ? ["OrgsAndPortfoliosSuspense"]
    : ["OrgsAndPortfoliosSuspense", variables]

useSuspenseOrgsAndPortfoliosQuery.rootKey = "OrgsAndPortfolios"

export const useInfiniteOrgsAndPortfoliosQuery = <
  TData = InfiniteData<OrgsAndPortfoliosQuery>,
  TError = unknown,
>(
  variables: OrgsAndPortfoliosQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<OrgsAndPortfoliosQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      OrgsAndPortfoliosQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<OrgsAndPortfoliosQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["OrgsAndPortfolios.infinite"]
            : ["OrgsAndPortfolios.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<OrgsAndPortfoliosQuery, OrgsAndPortfoliosQueryVariables>(
            OrgsAndPortfoliosDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOrgsAndPortfoliosQuery.getKey = (
  variables?: OrgsAndPortfoliosQueryVariables,
) =>
  variables === undefined
    ? ["OrgsAndPortfolios.infinite"]
    : ["OrgsAndPortfolios.infinite", variables]

useInfiniteOrgsAndPortfoliosQuery.rootKey = "OrgsAndPortfolios.infinite"

export const useSuspenseInfiniteOrgsAndPortfoliosQuery = <
  TData = InfiniteData<OrgsAndPortfoliosQuery>,
  TError = unknown,
>(
  variables: OrgsAndPortfoliosQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OrgsAndPortfoliosQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      OrgsAndPortfoliosQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OrgsAndPortfoliosQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["OrgsAndPortfolios.infiniteSuspense"]
            : ["OrgsAndPortfolios.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<OrgsAndPortfoliosQuery, OrgsAndPortfoliosQueryVariables>(
            OrgsAndPortfoliosDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOrgsAndPortfoliosQuery.getKey = (
  variables?: OrgsAndPortfoliosQueryVariables,
) =>
  variables === undefined
    ? ["OrgsAndPortfolios.infiniteSuspense"]
    : ["OrgsAndPortfolios.infiniteSuspense", variables]

useSuspenseInfiniteOrgsAndPortfoliosQuery.rootKey = "OrgsAndPortfolios.infinite"

useOrgsAndPortfoliosQuery.fetcher = (
  variables?: OrgsAndPortfoliosQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<OrgsAndPortfoliosQuery, OrgsAndPortfoliosQueryVariables>(
    OrgsAndPortfoliosDocument,
    variables,
    options,
  )

export const GetEnergyProductionDocument = `
    query GetEnergyProduction {
  energy {
    sites {
      name
      daysActive
      kwhLifetime
    }
    kwhPerDay {
      day
      kwh
    }
    currentTime
    kwhAllTime
    kwhToday
    projectedNextInterval
  }
}
    `

export const useGetEnergyProductionQuery = <
  TData = GetEnergyProductionQuery,
  TError = unknown,
>(
  variables?: GetEnergyProductionQueryVariables,
  options?: Omit<
    UseQueryOptions<GetEnergyProductionQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<GetEnergyProductionQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<GetEnergyProductionQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["GetEnergyProduction"]
        : ["GetEnergyProduction", variables],
    queryFn: adminFetcher<GetEnergyProductionQuery, GetEnergyProductionQueryVariables>(
      GetEnergyProductionDocument,
      variables,
    ),
    ...options,
  })
}

useGetEnergyProductionQuery.getKey = (variables?: GetEnergyProductionQueryVariables) =>
  variables === undefined ? ["GetEnergyProduction"] : ["GetEnergyProduction", variables]

useGetEnergyProductionQuery.rootKey = "GetEnergyProduction"

export const useSuspenseGetEnergyProductionQuery = <
  TData = GetEnergyProductionQuery,
  TError = unknown,
>(
  variables?: GetEnergyProductionQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<GetEnergyProductionQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      GetEnergyProductionQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<GetEnergyProductionQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["GetEnergyProductionSuspense"]
        : ["GetEnergyProductionSuspense", variables],
    queryFn: adminFetcher<GetEnergyProductionQuery, GetEnergyProductionQueryVariables>(
      GetEnergyProductionDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseGetEnergyProductionQuery.getKey = (
  variables?: GetEnergyProductionQueryVariables,
) =>
  variables === undefined
    ? ["GetEnergyProductionSuspense"]
    : ["GetEnergyProductionSuspense", variables]

useSuspenseGetEnergyProductionQuery.rootKey = "GetEnergyProduction"

export const useInfiniteGetEnergyProductionQuery = <
  TData = InfiniteData<GetEnergyProductionQuery>,
  TError = unknown,
>(
  variables: GetEnergyProductionQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<GetEnergyProductionQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      GetEnergyProductionQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<GetEnergyProductionQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["GetEnergyProduction.infinite"]
            : ["GetEnergyProduction.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<GetEnergyProductionQuery, GetEnergyProductionQueryVariables>(
            GetEnergyProductionDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteGetEnergyProductionQuery.getKey = (
  variables?: GetEnergyProductionQueryVariables,
) =>
  variables === undefined
    ? ["GetEnergyProduction.infinite"]
    : ["GetEnergyProduction.infinite", variables]

useInfiniteGetEnergyProductionQuery.rootKey = "GetEnergyProduction.infinite"

export const useSuspenseInfiniteGetEnergyProductionQuery = <
  TData = InfiniteData<GetEnergyProductionQuery>,
  TError = unknown,
>(
  variables: GetEnergyProductionQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<GetEnergyProductionQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      GetEnergyProductionQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<GetEnergyProductionQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["GetEnergyProduction.infiniteSuspense"]
            : ["GetEnergyProduction.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<GetEnergyProductionQuery, GetEnergyProductionQueryVariables>(
            GetEnergyProductionDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteGetEnergyProductionQuery.getKey = (
  variables?: GetEnergyProductionQueryVariables,
) =>
  variables === undefined
    ? ["GetEnergyProduction.infiniteSuspense"]
    : ["GetEnergyProduction.infiniteSuspense", variables]

useSuspenseInfiniteGetEnergyProductionQuery.rootKey = "GetEnergyProduction.infinite"

useGetEnergyProductionQuery.fetcher = (
  variables?: GetEnergyProductionQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<GetEnergyProductionQuery, GetEnergyProductionQueryVariables>(
    GetEnergyProductionDocument,
    variables,
    options,
  )

export const MultiPortfolioSitesDocument = `
    query MultiPortfolioSites($portfolioPids: [String!]!, $statuses: [SiteStatus!]!) {
  sitesInPortfolios(portfolioPids: $portfolioPids, statuses: $statuses) {
    ...SitesTable
    portfolio {
      pid
      title
    }
  }
}
    ${SitesTableFragmentDoc}`

export const useMultiPortfolioSitesQuery = <
  TData = MultiPortfolioSitesQuery,
  TError = unknown,
>(
  variables: MultiPortfolioSitesQueryVariables,
  options?: Omit<
    UseQueryOptions<MultiPortfolioSitesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<MultiPortfolioSitesQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<MultiPortfolioSitesQuery, TError, TData>({
    queryKey: ["MultiPortfolioSites", variables],
    queryFn: adminFetcher<MultiPortfolioSitesQuery, MultiPortfolioSitesQueryVariables>(
      MultiPortfolioSitesDocument,
      variables,
    ),
    ...options,
  })
}

useMultiPortfolioSitesQuery.getKey = (variables: MultiPortfolioSitesQueryVariables) => [
  "MultiPortfolioSites",
  variables,
]

useMultiPortfolioSitesQuery.rootKey = "MultiPortfolioSites"

export const useSuspenseMultiPortfolioSitesQuery = <
  TData = MultiPortfolioSitesQuery,
  TError = unknown,
>(
  variables: MultiPortfolioSitesQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<MultiPortfolioSitesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      MultiPortfolioSitesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<MultiPortfolioSitesQuery, TError, TData>({
    queryKey: ["MultiPortfolioSitesSuspense", variables],
    queryFn: adminFetcher<MultiPortfolioSitesQuery, MultiPortfolioSitesQueryVariables>(
      MultiPortfolioSitesDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseMultiPortfolioSitesQuery.getKey = (
  variables: MultiPortfolioSitesQueryVariables,
) => ["MultiPortfolioSitesSuspense", variables]

useSuspenseMultiPortfolioSitesQuery.rootKey = "MultiPortfolioSites"

export const useInfiniteMultiPortfolioSitesQuery = <
  TData = InfiniteData<MultiPortfolioSitesQuery>,
  TError = unknown,
>(
  variables: MultiPortfolioSitesQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<MultiPortfolioSitesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      MultiPortfolioSitesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<MultiPortfolioSitesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MultiPortfolioSites.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<MultiPortfolioSitesQuery, MultiPortfolioSitesQueryVariables>(
            MultiPortfolioSitesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteMultiPortfolioSitesQuery.getKey = (
  variables: MultiPortfolioSitesQueryVariables,
) => ["MultiPortfolioSites.infinite", variables]

useInfiniteMultiPortfolioSitesQuery.rootKey = "MultiPortfolioSites.infinite"

export const useSuspenseInfiniteMultiPortfolioSitesQuery = <
  TData = InfiniteData<MultiPortfolioSitesQuery>,
  TError = unknown,
>(
  variables: MultiPortfolioSitesQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<MultiPortfolioSitesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      MultiPortfolioSitesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<MultiPortfolioSitesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "MultiPortfolioSites.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<MultiPortfolioSitesQuery, MultiPortfolioSitesQueryVariables>(
            MultiPortfolioSitesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteMultiPortfolioSitesQuery.getKey = (
  variables: MultiPortfolioSitesQueryVariables,
) => ["MultiPortfolioSites.infiniteSuspense", variables]

useSuspenseInfiniteMultiPortfolioSitesQuery.rootKey = "MultiPortfolioSites.infinite"

useMultiPortfolioSitesQuery.fetcher = (
  variables: MultiPortfolioSitesQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<MultiPortfolioSitesQuery, MultiPortfolioSitesQueryVariables>(
    MultiPortfolioSitesDocument,
    variables,
    options,
  )

export const PortfolioSitesDocument = `
    query PortfolioSites($pid: String!, $sitePids: [String!]!) {
  portfolio(pid: $pid) {
    pid
    sites(sitePids: $sitePids) {
      ...SitesTable
    }
  }
}
    ${SitesTableFragmentDoc}`

export const usePortfolioSitesQuery = <TData = PortfolioSitesQuery, TError = unknown>(
  variables: PortfolioSitesQueryVariables,
  options?: Omit<UseQueryOptions<PortfolioSitesQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<PortfolioSitesQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<PortfolioSitesQuery, TError, TData>({
    queryKey: ["PortfolioSites", variables],
    queryFn: adminFetcher<PortfolioSitesQuery, PortfolioSitesQueryVariables>(
      PortfolioSitesDocument,
      variables,
    ),
    ...options,
  })
}

usePortfolioSitesQuery.getKey = (variables: PortfolioSitesQueryVariables) => [
  "PortfolioSites",
  variables,
]

usePortfolioSitesQuery.rootKey = "PortfolioSites"

export const useSuspensePortfolioSitesQuery = <
  TData = PortfolioSitesQuery,
  TError = unknown,
>(
  variables: PortfolioSitesQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<PortfolioSitesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<PortfolioSitesQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<PortfolioSitesQuery, TError, TData>({
    queryKey: ["PortfolioSitesSuspense", variables],
    queryFn: adminFetcher<PortfolioSitesQuery, PortfolioSitesQueryVariables>(
      PortfolioSitesDocument,
      variables,
    ),
    ...options,
  })
}

useSuspensePortfolioSitesQuery.getKey = (variables: PortfolioSitesQueryVariables) => [
  "PortfolioSitesSuspense",
  variables,
]

useSuspensePortfolioSitesQuery.rootKey = "PortfolioSites"

export const useInfinitePortfolioSitesQuery = <
  TData = InfiniteData<PortfolioSitesQuery>,
  TError = unknown,
>(
  variables: PortfolioSitesQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<PortfolioSitesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<PortfolioSitesQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<PortfolioSitesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["PortfolioSites.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<PortfolioSitesQuery, PortfolioSitesQueryVariables>(
            PortfolioSitesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfinitePortfolioSitesQuery.getKey = (variables: PortfolioSitesQueryVariables) => [
  "PortfolioSites.infinite",
  variables,
]

useInfinitePortfolioSitesQuery.rootKey = "PortfolioSites.infinite"

export const useSuspenseInfinitePortfolioSitesQuery = <
  TData = InfiniteData<PortfolioSitesQuery>,
  TError = unknown,
>(
  variables: PortfolioSitesQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<PortfolioSitesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      PortfolioSitesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<PortfolioSitesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["PortfolioSites.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<PortfolioSitesQuery, PortfolioSitesQueryVariables>(
            PortfolioSitesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfinitePortfolioSitesQuery.getKey = (
  variables: PortfolioSitesQueryVariables,
) => ["PortfolioSites.infiniteSuspense", variables]

useSuspenseInfinitePortfolioSitesQuery.rootKey = "PortfolioSites.infinite"

usePortfolioSitesQuery.fetcher = (
  variables: PortfolioSitesQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<PortfolioSitesQuery, PortfolioSitesQueryVariables>(
    PortfolioSitesDocument,
    variables,
    options,
  )

export const SitesDocument = `
    query Sites($sitePids: [String!]!) {
  sites(sitePids: $sitePids) {
    ...SitesTable
  }
}
    ${SitesTableFragmentDoc}`

export const useSitesQuery = <TData = SitesQuery, TError = unknown>(
  variables: SitesQueryVariables,
  options?: Omit<UseQueryOptions<SitesQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SitesQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SitesQuery, TError, TData>({
    queryKey: ["Sites", variables],
    queryFn: adminFetcher<SitesQuery, SitesQueryVariables>(SitesDocument, variables),
    ...options,
  })
}

useSitesQuery.getKey = (variables: SitesQueryVariables) => ["Sites", variables]

useSitesQuery.rootKey = "Sites"

export const useSuspenseSitesQuery = <TData = SitesQuery, TError = unknown>(
  variables: SitesQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<SitesQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<SitesQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<SitesQuery, TError, TData>({
    queryKey: ["SitesSuspense", variables],
    queryFn: adminFetcher<SitesQuery, SitesQueryVariables>(SitesDocument, variables),
    ...options,
  })
}

useSuspenseSitesQuery.getKey = (variables: SitesQueryVariables) => [
  "SitesSuspense",
  variables,
]

useSuspenseSitesQuery.rootKey = "Sites"

export const useInfiniteSitesQuery = <
  TData = InfiniteData<SitesQuery>,
  TError = unknown,
>(
  variables: SitesQueryVariables,
  options: Omit<UseInfiniteQueryOptions<SitesQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<SitesQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<SitesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["Sites.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<SitesQuery, SitesQueryVariables>(SitesDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSitesQuery.getKey = (variables: SitesQueryVariables) => [
  "Sites.infinite",
  variables,
]

useInfiniteSitesQuery.rootKey = "Sites.infinite"

export const useSuspenseInfiniteSitesQuery = <
  TData = InfiniteData<SitesQuery>,
  TError = unknown,
>(
  variables: SitesQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SitesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<SitesQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SitesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["Sites.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<SitesQuery, SitesQueryVariables>(SitesDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSitesQuery.getKey = (variables: SitesQueryVariables) => [
  "Sites.infiniteSuspense",
  variables,
]

useSuspenseInfiniteSitesQuery.rootKey = "Sites.infinite"

useSitesQuery.fetcher = (
  variables: SitesQueryVariables,
  options?: RequestInit["headers"],
) => adminFetcher<SitesQuery, SitesQueryVariables>(SitesDocument, variables, options)

export const GetPortfolioSiteRefsDocument = `
    query GetPortfolioSiteRefs($pid: String!) {
  portfolio(pid: $pid) {
    pid
    siteRefs {
      pid
      name
      streetAddress
    }
  }
}
    `

export const useGetPortfolioSiteRefsQuery = <
  TData = GetPortfolioSiteRefsQuery,
  TError = unknown,
>(
  variables: GetPortfolioSiteRefsQueryVariables,
  options?: Omit<
    UseQueryOptions<GetPortfolioSiteRefsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<GetPortfolioSiteRefsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<GetPortfolioSiteRefsQuery, TError, TData>({
    queryKey: ["GetPortfolioSiteRefs", variables],
    queryFn: adminFetcher<
      GetPortfolioSiteRefsQuery,
      GetPortfolioSiteRefsQueryVariables
    >(GetPortfolioSiteRefsDocument, variables),
    ...options,
  })
}

useGetPortfolioSiteRefsQuery.getKey = (
  variables: GetPortfolioSiteRefsQueryVariables,
) => ["GetPortfolioSiteRefs", variables]

useGetPortfolioSiteRefsQuery.rootKey = "GetPortfolioSiteRefs"

export const useSuspenseGetPortfolioSiteRefsQuery = <
  TData = GetPortfolioSiteRefsQuery,
  TError = unknown,
>(
  variables: GetPortfolioSiteRefsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<GetPortfolioSiteRefsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      GetPortfolioSiteRefsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<GetPortfolioSiteRefsQuery, TError, TData>({
    queryKey: ["GetPortfolioSiteRefsSuspense", variables],
    queryFn: adminFetcher<
      GetPortfolioSiteRefsQuery,
      GetPortfolioSiteRefsQueryVariables
    >(GetPortfolioSiteRefsDocument, variables),
    ...options,
  })
}

useSuspenseGetPortfolioSiteRefsQuery.getKey = (
  variables: GetPortfolioSiteRefsQueryVariables,
) => ["GetPortfolioSiteRefsSuspense", variables]

useSuspenseGetPortfolioSiteRefsQuery.rootKey = "GetPortfolioSiteRefs"

export const useInfiniteGetPortfolioSiteRefsQuery = <
  TData = InfiniteData<GetPortfolioSiteRefsQuery>,
  TError = unknown,
>(
  variables: GetPortfolioSiteRefsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<GetPortfolioSiteRefsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      GetPortfolioSiteRefsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<GetPortfolioSiteRefsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["GetPortfolioSiteRefs.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<GetPortfolioSiteRefsQuery, GetPortfolioSiteRefsQueryVariables>(
            GetPortfolioSiteRefsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteGetPortfolioSiteRefsQuery.getKey = (
  variables: GetPortfolioSiteRefsQueryVariables,
) => ["GetPortfolioSiteRefs.infinite", variables]

useInfiniteGetPortfolioSiteRefsQuery.rootKey = "GetPortfolioSiteRefs.infinite"

export const useSuspenseInfiniteGetPortfolioSiteRefsQuery = <
  TData = InfiniteData<GetPortfolioSiteRefsQuery>,
  TError = unknown,
>(
  variables: GetPortfolioSiteRefsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<GetPortfolioSiteRefsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      GetPortfolioSiteRefsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<GetPortfolioSiteRefsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "GetPortfolioSiteRefs.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<GetPortfolioSiteRefsQuery, GetPortfolioSiteRefsQueryVariables>(
            GetPortfolioSiteRefsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteGetPortfolioSiteRefsQuery.getKey = (
  variables: GetPortfolioSiteRefsQueryVariables,
) => ["GetPortfolioSiteRefs.infiniteSuspense", variables]

useSuspenseInfiniteGetPortfolioSiteRefsQuery.rootKey = "GetPortfolioSiteRefs.infinite"

useGetPortfolioSiteRefsQuery.fetcher = (
  variables: GetPortfolioSiteRefsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<GetPortfolioSiteRefsQuery, GetPortfolioSiteRefsQueryVariables>(
    GetPortfolioSiteRefsDocument,
    variables,
    options,
  )

export const SiteBuildingDataDocument = `
    query SiteBuildingData($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    customerId
    propertyName
    capRate
    buildingClass
    streetAddress
    city
    state
    zipCode
    county
    latitude
    longitude
    sqft
    yearBuilt
    numStories
    numParkingSpaces
    numUnitsTotal
    numUnitsStudio
    numUnits1Bd
    numUnits2Bd
    numUnits3Bd
    numUnits4Bd
    occupancyType
    leaseType
    metering
    meteringSetBy {
      ...UserRef
    }
    meteringSetDate
    doeReferenceType
    costarPropertyType
    costarSecondaryType
    mappedDoeReferenceType
    buildingClass
    leaseType
    occupancyType
    mortgageLender
    roofReplacedYr
    roofCondition
    cbsaId
    cbsaName
    timeZone
    roofSqft
    roofMaxPvKw
    carportMaxPvKw
    groundMaxPvKw
    computedRoofMaxPvKw
    computedCarportMaxPvKw
    computedGroundMaxPvKw
    buildingData {
      id
      affordableType
      source
      sourceId
      streetAddress
      city
      state
      zipCode
      county
      latitude
      longitude
      sqft
      totalBuildings
      numStories
      numParkingSpaces
      costarPropertyType
      costarSecondaryType
      buildingType
      yearBuilt
      numUnitsTotal
      numUnitsStudio
      numUnits1Bd
      numUnits2Bd
      numUnits3Bd
      numUnits4Bd
      yearRenovated
      parentCompany
      buildingClass
      buildingOpex
      energyStar
      leedCertified
      lastSalePrice
      electricPowerRating
      zoning
      propertyName
      capRate
      numUnitsTotal
      numUnitsStudio
      numUnits1Bd
      numUnits2Bd
      numUnits3Bd
      numUnits4Bd
      numVacantUnitsStudio
      numVacantUnits1Bd
      numVacantUnits2Bd
      numVacantUnits3Bd
      numVacantUnits4Bd
      avgSqftStudio
      avgSqft1Bd
      avgSqft2Bd
      avgSqft3Bd
      avgSqft4Bd
      numElevators
      taxIdPrintFormat
      parcelNumberMin
      parcelNumberMax
      rentType
      reportedOwnerName
      reportedContactName
      reportedOwnerAddress
      reportedOwnerCity
      reportedOwnerState
      reportedOwnerZipCode
      reportedOwnerPhone
      ownerName
      ownerFirstName
      ownerLastName
      contactAddress
      contactCity
      contactState
      contactZipCode
      contactPhone
      buildingClass
    }
  }
}
    ${UserRefFragmentDoc}`

export const useSiteBuildingDataQuery = <
  TData = SiteBuildingDataQuery,
  TError = unknown,
>(
  variables: SiteBuildingDataQueryVariables,
  options?: Omit<UseQueryOptions<SiteBuildingDataQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SiteBuildingDataQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteBuildingDataQuery, TError, TData>({
    queryKey: ["SiteBuildingData", variables],
    queryFn: adminFetcher<SiteBuildingDataQuery, SiteBuildingDataQueryVariables>(
      SiteBuildingDataDocument,
      variables,
    ),
    ...options,
  })
}

useSiteBuildingDataQuery.getKey = (variables: SiteBuildingDataQueryVariables) => [
  "SiteBuildingData",
  variables,
]

useSiteBuildingDataQuery.rootKey = "SiteBuildingData"

export const useSuspenseSiteBuildingDataQuery = <
  TData = SiteBuildingDataQuery,
  TError = unknown,
>(
  variables: SiteBuildingDataQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteBuildingDataQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<SiteBuildingDataQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteBuildingDataQuery, TError, TData>({
    queryKey: ["SiteBuildingDataSuspense", variables],
    queryFn: adminFetcher<SiteBuildingDataQuery, SiteBuildingDataQueryVariables>(
      SiteBuildingDataDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteBuildingDataQuery.getKey = (
  variables: SiteBuildingDataQueryVariables,
) => ["SiteBuildingDataSuspense", variables]

useSuspenseSiteBuildingDataQuery.rootKey = "SiteBuildingData"

export const useInfiniteSiteBuildingDataQuery = <
  TData = InfiniteData<SiteBuildingDataQuery>,
  TError = unknown,
>(
  variables: SiteBuildingDataQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SiteBuildingDataQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<SiteBuildingDataQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteBuildingDataQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteBuildingData.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteBuildingDataQuery, SiteBuildingDataQueryVariables>(
            SiteBuildingDataDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteBuildingDataQuery.getKey = (
  variables: SiteBuildingDataQueryVariables,
) => ["SiteBuildingData.infinite", variables]

useInfiniteSiteBuildingDataQuery.rootKey = "SiteBuildingData.infinite"

export const useSuspenseInfiniteSiteBuildingDataQuery = <
  TData = InfiniteData<SiteBuildingDataQuery>,
  TError = unknown,
>(
  variables: SiteBuildingDataQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteBuildingDataQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteBuildingDataQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteBuildingDataQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteBuildingData.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteBuildingDataQuery, SiteBuildingDataQueryVariables>(
            SiteBuildingDataDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteBuildingDataQuery.getKey = (
  variables: SiteBuildingDataQueryVariables,
) => ["SiteBuildingData.infiniteSuspense", variables]

useSuspenseInfiniteSiteBuildingDataQuery.rootKey = "SiteBuildingData.infinite"

useSiteBuildingDataQuery.fetcher = (
  variables: SiteBuildingDataQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SiteBuildingDataQuery, SiteBuildingDataQueryVariables>(
    SiteBuildingDataDocument,
    variables,
    options,
  )

export const SitePossibleTariffsDocument = `
    query SitePossibleTariffs($pid: String!, $loadCategory: LoadCategory, $preferred: Boolean! = true, $includeUnpreferred: Boolean! = false, $includeCustom: Boolean! = false) {
  site(pid: $pid) {
    pid
    possibleTariffs(
      loadCategory: $loadCategory
      preferred: $preferred
      includeUnpreferred: $includeUnpreferred
      includeCustom: $includeCustom
    ) {
      id
      name
      code
      tariffType
      customerClass
      customerCount
      customerLikelihood
      masterTariffId
      isPreferred
      hasNetMetering
      requiresPv
      requiresStorage
      minMonthlyKw
      maxMonthlyKw
      minMonthlyKwh
      maxMonthlyKwh
    }
  }
}
    `

export const useSitePossibleTariffsQuery = <
  TData = SitePossibleTariffsQuery,
  TError = unknown,
>(
  variables: SitePossibleTariffsQueryVariables,
  options?: Omit<
    UseQueryOptions<SitePossibleTariffsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<SitePossibleTariffsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SitePossibleTariffsQuery, TError, TData>({
    queryKey: ["SitePossibleTariffs", variables],
    queryFn: adminFetcher<SitePossibleTariffsQuery, SitePossibleTariffsQueryVariables>(
      SitePossibleTariffsDocument,
      variables,
    ),
    ...options,
  })
}

useSitePossibleTariffsQuery.getKey = (variables: SitePossibleTariffsQueryVariables) => [
  "SitePossibleTariffs",
  variables,
]

useSitePossibleTariffsQuery.rootKey = "SitePossibleTariffs"

export const useSuspenseSitePossibleTariffsQuery = <
  TData = SitePossibleTariffsQuery,
  TError = unknown,
>(
  variables: SitePossibleTariffsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SitePossibleTariffsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      SitePossibleTariffsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<SitePossibleTariffsQuery, TError, TData>({
    queryKey: ["SitePossibleTariffsSuspense", variables],
    queryFn: adminFetcher<SitePossibleTariffsQuery, SitePossibleTariffsQueryVariables>(
      SitePossibleTariffsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSitePossibleTariffsQuery.getKey = (
  variables: SitePossibleTariffsQueryVariables,
) => ["SitePossibleTariffsSuspense", variables]

useSuspenseSitePossibleTariffsQuery.rootKey = "SitePossibleTariffs"

export const useInfiniteSitePossibleTariffsQuery = <
  TData = InfiniteData<SitePossibleTariffsQuery>,
  TError = unknown,
>(
  variables: SitePossibleTariffsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SitePossibleTariffsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      SitePossibleTariffsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<SitePossibleTariffsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SitePossibleTariffs.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<SitePossibleTariffsQuery, SitePossibleTariffsQueryVariables>(
            SitePossibleTariffsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSitePossibleTariffsQuery.getKey = (
  variables: SitePossibleTariffsQueryVariables,
) => ["SitePossibleTariffs.infinite", variables]

useInfiniteSitePossibleTariffsQuery.rootKey = "SitePossibleTariffs.infinite"

export const useSuspenseInfiniteSitePossibleTariffsQuery = <
  TData = InfiniteData<SitePossibleTariffsQuery>,
  TError = unknown,
>(
  variables: SitePossibleTariffsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SitePossibleTariffsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SitePossibleTariffsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SitePossibleTariffsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "SitePossibleTariffs.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<SitePossibleTariffsQuery, SitePossibleTariffsQueryVariables>(
            SitePossibleTariffsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSitePossibleTariffsQuery.getKey = (
  variables: SitePossibleTariffsQueryVariables,
) => ["SitePossibleTariffs.infiniteSuspense", variables]

useSuspenseInfiniteSitePossibleTariffsQuery.rootKey = "SitePossibleTariffs.infinite"

useSitePossibleTariffsQuery.fetcher = (
  variables: SitePossibleTariffsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SitePossibleTariffsQuery, SitePossibleTariffsQueryVariables>(
    SitePossibleTariffsDocument,
    variables,
    options,
  )

export const GetSiteAdminDocument = `
    query GetSiteAdmin($pid: String!) {
  site(pid: $pid) {
    id
    pid
    fullAddress
    hiddenFromCustomers
    hideFakePanels
    portfolio {
      pid
      title
      org {
        pid
        slug
      }
    }
    buildingData {
      id
    }
    primaryScenario {
      pid
      name
    }
    currentStatus {
      pid
      displayText
      dateCreated
      createdBy {
        ...UserRef
      }
    }
    footprint {
      ...Footprint
      parcelShape
      parcelShapeGeojson
      parcelShapeUpdatedAt
      parcelShapeUpdatedBy {
        ...UserRef
      }
    }
    buildingFootprintNeedsReview
    physicalCheck {
      existingSolar
      badRoof
    }
    currentPolicyChecks {
      productType
      isGood
      disqualReason
      violatedPolicy {
        pid
        name
      }
    }
    roofSqft
    roofMaxPvKw
    computedRoofMaxPvKw
    groundMaxPvKw
    carportMaxPvKw
    parcelFootprintSqft
    buildingFootprintSqft
    buildingFootprintCount
    roofObstructionsSqft
    roofUsableSqft
    roofImage {
      id
      name
    }
    attachments {
      ...AttachmentFragment
    }
  }
}
    ${UserRefFragmentDoc}
${FootprintFragmentDoc}
${AttachmentFragmentFragmentDoc}`

export const useGetSiteAdminQuery = <TData = GetSiteAdminQuery, TError = unknown>(
  variables: GetSiteAdminQueryVariables,
  options?: Omit<UseQueryOptions<GetSiteAdminQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<GetSiteAdminQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<GetSiteAdminQuery, TError, TData>({
    queryKey: ["GetSiteAdmin", variables],
    queryFn: adminFetcher<GetSiteAdminQuery, GetSiteAdminQueryVariables>(
      GetSiteAdminDocument,
      variables,
    ),
    ...options,
  })
}

useGetSiteAdminQuery.getKey = (variables: GetSiteAdminQueryVariables) => [
  "GetSiteAdmin",
  variables,
]

useGetSiteAdminQuery.rootKey = "GetSiteAdmin"

export const useSuspenseGetSiteAdminQuery = <
  TData = GetSiteAdminQuery,
  TError = unknown,
>(
  variables: GetSiteAdminQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<GetSiteAdminQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<GetSiteAdminQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<GetSiteAdminQuery, TError, TData>({
    queryKey: ["GetSiteAdminSuspense", variables],
    queryFn: adminFetcher<GetSiteAdminQuery, GetSiteAdminQueryVariables>(
      GetSiteAdminDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseGetSiteAdminQuery.getKey = (variables: GetSiteAdminQueryVariables) => [
  "GetSiteAdminSuspense",
  variables,
]

useSuspenseGetSiteAdminQuery.rootKey = "GetSiteAdmin"

export const useInfiniteGetSiteAdminQuery = <
  TData = InfiniteData<GetSiteAdminQuery>,
  TError = unknown,
>(
  variables: GetSiteAdminQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<GetSiteAdminQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<GetSiteAdminQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<GetSiteAdminQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["GetSiteAdmin.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<GetSiteAdminQuery, GetSiteAdminQueryVariables>(
            GetSiteAdminDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteGetSiteAdminQuery.getKey = (variables: GetSiteAdminQueryVariables) => [
  "GetSiteAdmin.infinite",
  variables,
]

useInfiniteGetSiteAdminQuery.rootKey = "GetSiteAdmin.infinite"

export const useSuspenseInfiniteGetSiteAdminQuery = <
  TData = InfiniteData<GetSiteAdminQuery>,
  TError = unknown,
>(
  variables: GetSiteAdminQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<GetSiteAdminQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      GetSiteAdminQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<GetSiteAdminQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["GetSiteAdmin.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<GetSiteAdminQuery, GetSiteAdminQueryVariables>(
            GetSiteAdminDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteGetSiteAdminQuery.getKey = (
  variables: GetSiteAdminQueryVariables,
) => ["GetSiteAdmin.infiniteSuspense", variables]

useSuspenseInfiniteGetSiteAdminQuery.rootKey = "GetSiteAdmin.infinite"

useGetSiteAdminQuery.fetcher = (
  variables: GetSiteAdminQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<GetSiteAdminQuery, GetSiteAdminQueryVariables>(
    GetSiteAdminDocument,
    variables,
    options,
  )

export const UserListDocument = `
    query UserList {
  users {
    ...UserListUser
  }
}
    ${UserListUserFragmentDoc}`

export const useUserListQuery = <TData = UserListQuery, TError = unknown>(
  variables?: UserListQueryVariables,
  options?: Omit<UseQueryOptions<UserListQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<UserListQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<UserListQuery, TError, TData>({
    queryKey: variables === undefined ? ["UserList"] : ["UserList", variables],
    queryFn: adminFetcher<UserListQuery, UserListQueryVariables>(
      UserListDocument,
      variables,
    ),
    ...options,
  })
}

useUserListQuery.getKey = (variables?: UserListQueryVariables) =>
  variables === undefined ? ["UserList"] : ["UserList", variables]

useUserListQuery.rootKey = "UserList"

export const useSuspenseUserListQuery = <TData = UserListQuery, TError = unknown>(
  variables?: UserListQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<UserListQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<UserListQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<UserListQuery, TError, TData>({
    queryKey:
      variables === undefined ? ["UserListSuspense"] : ["UserListSuspense", variables],
    queryFn: adminFetcher<UserListQuery, UserListQueryVariables>(
      UserListDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseUserListQuery.getKey = (variables?: UserListQueryVariables) =>
  variables === undefined ? ["UserListSuspense"] : ["UserListSuspense", variables]

useSuspenseUserListQuery.rootKey = "UserList"

export const useInfiniteUserListQuery = <
  TData = InfiniteData<UserListQuery>,
  TError = unknown,
>(
  variables: UserListQueryVariables,
  options: Omit<UseInfiniteQueryOptions<UserListQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<UserListQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<UserListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["UserList.infinite"]
            : ["UserList.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<UserListQuery, UserListQueryVariables>(UserListDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteUserListQuery.getKey = (variables?: UserListQueryVariables) =>
  variables === undefined ? ["UserList.infinite"] : ["UserList.infinite", variables]

useInfiniteUserListQuery.rootKey = "UserList.infinite"

export const useSuspenseInfiniteUserListQuery = <
  TData = InfiniteData<UserListQuery>,
  TError = unknown,
>(
  variables: UserListQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<UserListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<UserListQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<UserListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["UserList.infiniteSuspense"]
            : ["UserList.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<UserListQuery, UserListQueryVariables>(UserListDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteUserListQuery.getKey = (variables?: UserListQueryVariables) =>
  variables === undefined
    ? ["UserList.infiniteSuspense"]
    : ["UserList.infiniteSuspense", variables]

useSuspenseInfiniteUserListQuery.rootKey = "UserList.infinite"

useUserListQuery.fetcher = (
  variables?: UserListQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<UserListQuery, UserListQueryVariables>(
    UserListDocument,
    variables,
    options,
  )

export const DraftSitePageDocument = `
    query DraftSitePage {
  costarPropertyTypes
  portfolios {
    pid
    title
    numSites
  }
  myDraftSites {
    ...DraftSiteFragment
  }
}
    ${DraftSiteFragmentFragmentDoc}`

export const useDraftSitePageQuery = <TData = DraftSitePageQuery, TError = unknown>(
  variables?: DraftSitePageQueryVariables,
  options?: Omit<UseQueryOptions<DraftSitePageQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<DraftSitePageQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<DraftSitePageQuery, TError, TData>({
    queryKey:
      variables === undefined ? ["DraftSitePage"] : ["DraftSitePage", variables],
    queryFn: adminFetcher<DraftSitePageQuery, DraftSitePageQueryVariables>(
      DraftSitePageDocument,
      variables,
    ),
    ...options,
  })
}

useDraftSitePageQuery.getKey = (variables?: DraftSitePageQueryVariables) =>
  variables === undefined ? ["DraftSitePage"] : ["DraftSitePage", variables]

useDraftSitePageQuery.rootKey = "DraftSitePage"

export const useSuspenseDraftSitePageQuery = <
  TData = DraftSitePageQuery,
  TError = unknown,
>(
  variables?: DraftSitePageQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<DraftSitePageQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<DraftSitePageQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<DraftSitePageQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["DraftSitePageSuspense"]
        : ["DraftSitePageSuspense", variables],
    queryFn: adminFetcher<DraftSitePageQuery, DraftSitePageQueryVariables>(
      DraftSitePageDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseDraftSitePageQuery.getKey = (variables?: DraftSitePageQueryVariables) =>
  variables === undefined
    ? ["DraftSitePageSuspense"]
    : ["DraftSitePageSuspense", variables]

useSuspenseDraftSitePageQuery.rootKey = "DraftSitePage"

export const useInfiniteDraftSitePageQuery = <
  TData = InfiniteData<DraftSitePageQuery>,
  TError = unknown,
>(
  variables: DraftSitePageQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<DraftSitePageQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<DraftSitePageQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<DraftSitePageQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["DraftSitePage.infinite"]
            : ["DraftSitePage.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<DraftSitePageQuery, DraftSitePageQueryVariables>(
            DraftSitePageDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteDraftSitePageQuery.getKey = (variables?: DraftSitePageQueryVariables) =>
  variables === undefined
    ? ["DraftSitePage.infinite"]
    : ["DraftSitePage.infinite", variables]

useInfiniteDraftSitePageQuery.rootKey = "DraftSitePage.infinite"

export const useSuspenseInfiniteDraftSitePageQuery = <
  TData = InfiniteData<DraftSitePageQuery>,
  TError = unknown,
>(
  variables: DraftSitePageQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<DraftSitePageQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      DraftSitePageQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<DraftSitePageQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["DraftSitePage.infiniteSuspense"]
            : ["DraftSitePage.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<DraftSitePageQuery, DraftSitePageQueryVariables>(
            DraftSitePageDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteDraftSitePageQuery.getKey = (
  variables?: DraftSitePageQueryVariables,
) =>
  variables === undefined
    ? ["DraftSitePage.infiniteSuspense"]
    : ["DraftSitePage.infiniteSuspense", variables]

useSuspenseInfiniteDraftSitePageQuery.rootKey = "DraftSitePage.infinite"

useDraftSitePageQuery.fetcher = (
  variables?: DraftSitePageQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<DraftSitePageQuery, DraftSitePageQueryVariables>(
    DraftSitePageDocument,
    variables,
    options,
  )

export const PortfolioDetailDocument = `
    query PortfolioDetail($pid: String!) {
  portfolio(pid: $pid) {
    pid
    title
    logoUrl
    minKw
    minKwSetBy
    minKwSetDate
    view {
      sitePids
    }
    org {
      pid
      name
      slug
    }
  }
}
    `

export const usePortfolioDetailQuery = <TData = PortfolioDetailQuery, TError = unknown>(
  variables: PortfolioDetailQueryVariables,
  options?: Omit<UseQueryOptions<PortfolioDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<PortfolioDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<PortfolioDetailQuery, TError, TData>({
    queryKey: ["PortfolioDetail", variables],
    queryFn: adminFetcher<PortfolioDetailQuery, PortfolioDetailQueryVariables>(
      PortfolioDetailDocument,
      variables,
    ),
    ...options,
  })
}

usePortfolioDetailQuery.getKey = (variables: PortfolioDetailQueryVariables) => [
  "PortfolioDetail",
  variables,
]

usePortfolioDetailQuery.rootKey = "PortfolioDetail"

export const useSuspensePortfolioDetailQuery = <
  TData = PortfolioDetailQuery,
  TError = unknown,
>(
  variables: PortfolioDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<PortfolioDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<PortfolioDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<PortfolioDetailQuery, TError, TData>({
    queryKey: ["PortfolioDetailSuspense", variables],
    queryFn: adminFetcher<PortfolioDetailQuery, PortfolioDetailQueryVariables>(
      PortfolioDetailDocument,
      variables,
    ),
    ...options,
  })
}

useSuspensePortfolioDetailQuery.getKey = (variables: PortfolioDetailQueryVariables) => [
  "PortfolioDetailSuspense",
  variables,
]

useSuspensePortfolioDetailQuery.rootKey = "PortfolioDetail"

export const useInfinitePortfolioDetailQuery = <
  TData = InfiniteData<PortfolioDetailQuery>,
  TError = unknown,
>(
  variables: PortfolioDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<PortfolioDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<PortfolioDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<PortfolioDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["PortfolioDetail.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<PortfolioDetailQuery, PortfolioDetailQueryVariables>(
            PortfolioDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfinitePortfolioDetailQuery.getKey = (variables: PortfolioDetailQueryVariables) => [
  "PortfolioDetail.infinite",
  variables,
]

useInfinitePortfolioDetailQuery.rootKey = "PortfolioDetail.infinite"

export const useSuspenseInfinitePortfolioDetailQuery = <
  TData = InfiniteData<PortfolioDetailQuery>,
  TError = unknown,
>(
  variables: PortfolioDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<PortfolioDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      PortfolioDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<PortfolioDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["PortfolioDetail.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<PortfolioDetailQuery, PortfolioDetailQueryVariables>(
            PortfolioDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfinitePortfolioDetailQuery.getKey = (
  variables: PortfolioDetailQueryVariables,
) => ["PortfolioDetail.infiniteSuspense", variables]

useSuspenseInfinitePortfolioDetailQuery.rootKey = "PortfolioDetail.infinite"

usePortfolioDetailQuery.fetcher = (
  variables: PortfolioDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<PortfolioDetailQuery, PortfolioDetailQueryVariables>(
    PortfolioDetailDocument,
    variables,
    options,
  )

export const UtilityListDocument = `
    query UtilityList($zipCode: String) {
  tariffs {
    utilities(zipCode: $zipCode) {
      ...UtilityFragment
    }
  }
}
    ${UtilityFragmentFragmentDoc}`

export const useUtilityListQuery = <TData = UtilityListQuery, TError = unknown>(
  variables?: UtilityListQueryVariables,
  options?: Omit<UseQueryOptions<UtilityListQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<UtilityListQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<UtilityListQuery, TError, TData>({
    queryKey: variables === undefined ? ["UtilityList"] : ["UtilityList", variables],
    queryFn: adminFetcher<UtilityListQuery, UtilityListQueryVariables>(
      UtilityListDocument,
      variables,
    ),
    ...options,
  })
}

useUtilityListQuery.getKey = (variables?: UtilityListQueryVariables) =>
  variables === undefined ? ["UtilityList"] : ["UtilityList", variables]

useUtilityListQuery.rootKey = "UtilityList"

export const useSuspenseUtilityListQuery = <TData = UtilityListQuery, TError = unknown>(
  variables?: UtilityListQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<UtilityListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<UtilityListQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<UtilityListQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["UtilityListSuspense"]
        : ["UtilityListSuspense", variables],
    queryFn: adminFetcher<UtilityListQuery, UtilityListQueryVariables>(
      UtilityListDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseUtilityListQuery.getKey = (variables?: UtilityListQueryVariables) =>
  variables === undefined ? ["UtilityListSuspense"] : ["UtilityListSuspense", variables]

useSuspenseUtilityListQuery.rootKey = "UtilityList"

export const useInfiniteUtilityListQuery = <
  TData = InfiniteData<UtilityListQuery>,
  TError = unknown,
>(
  variables: UtilityListQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<UtilityListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<UtilityListQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<UtilityListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["UtilityList.infinite"]
            : ["UtilityList.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<UtilityListQuery, UtilityListQueryVariables>(
            UtilityListDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteUtilityListQuery.getKey = (variables?: UtilityListQueryVariables) =>
  variables === undefined
    ? ["UtilityList.infinite"]
    : ["UtilityList.infinite", variables]

useInfiniteUtilityListQuery.rootKey = "UtilityList.infinite"

export const useSuspenseInfiniteUtilityListQuery = <
  TData = InfiniteData<UtilityListQuery>,
  TError = unknown,
>(
  variables: UtilityListQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<UtilityListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      UtilityListQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<UtilityListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["UtilityList.infiniteSuspense"]
            : ["UtilityList.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<UtilityListQuery, UtilityListQueryVariables>(
            UtilityListDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteUtilityListQuery.getKey = (variables?: UtilityListQueryVariables) =>
  variables === undefined
    ? ["UtilityList.infiniteSuspense"]
    : ["UtilityList.infiniteSuspense", variables]

useSuspenseInfiniteUtilityListQuery.rootKey = "UtilityList.infinite"

useUtilityListQuery.fetcher = (
  variables?: UtilityListQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<UtilityListQuery, UtilityListQueryVariables>(
    UtilityListDocument,
    variables,
    options,
  )

export const UtilityDetailDocument = `
    query UtilityDetail($id: Int!) {
  tariffs {
    utility(id: $id) {
      ...UtilityFragment
    }
  }
}
    ${UtilityFragmentFragmentDoc}`

export const useUtilityDetailQuery = <TData = UtilityDetailQuery, TError = unknown>(
  variables: UtilityDetailQueryVariables,
  options?: Omit<UseQueryOptions<UtilityDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<UtilityDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<UtilityDetailQuery, TError, TData>({
    queryKey: ["UtilityDetail", variables],
    queryFn: adminFetcher<UtilityDetailQuery, UtilityDetailQueryVariables>(
      UtilityDetailDocument,
      variables,
    ),
    ...options,
  })
}

useUtilityDetailQuery.getKey = (variables: UtilityDetailQueryVariables) => [
  "UtilityDetail",
  variables,
]

useUtilityDetailQuery.rootKey = "UtilityDetail"

export const useSuspenseUtilityDetailQuery = <
  TData = UtilityDetailQuery,
  TError = unknown,
>(
  variables: UtilityDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<UtilityDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<UtilityDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<UtilityDetailQuery, TError, TData>({
    queryKey: ["UtilityDetailSuspense", variables],
    queryFn: adminFetcher<UtilityDetailQuery, UtilityDetailQueryVariables>(
      UtilityDetailDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseUtilityDetailQuery.getKey = (variables: UtilityDetailQueryVariables) => [
  "UtilityDetailSuspense",
  variables,
]

useSuspenseUtilityDetailQuery.rootKey = "UtilityDetail"

export const useInfiniteUtilityDetailQuery = <
  TData = InfiniteData<UtilityDetailQuery>,
  TError = unknown,
>(
  variables: UtilityDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<UtilityDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<UtilityDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<UtilityDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["UtilityDetail.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<UtilityDetailQuery, UtilityDetailQueryVariables>(
            UtilityDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteUtilityDetailQuery.getKey = (variables: UtilityDetailQueryVariables) => [
  "UtilityDetail.infinite",
  variables,
]

useInfiniteUtilityDetailQuery.rootKey = "UtilityDetail.infinite"

export const useSuspenseInfiniteUtilityDetailQuery = <
  TData = InfiniteData<UtilityDetailQuery>,
  TError = unknown,
>(
  variables: UtilityDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<UtilityDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      UtilityDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<UtilityDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["UtilityDetail.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<UtilityDetailQuery, UtilityDetailQueryVariables>(
            UtilityDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteUtilityDetailQuery.getKey = (
  variables: UtilityDetailQueryVariables,
) => ["UtilityDetail.infiniteSuspense", variables]

useSuspenseInfiniteUtilityDetailQuery.rootKey = "UtilityDetail.infinite"

useUtilityDetailQuery.fetcher = (
  variables: UtilityDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<UtilityDetailQuery, UtilityDetailQueryVariables>(
    UtilityDetailDocument,
    variables,
    options,
  )

export const TariffListDocument = `
    query TariffList($id: Int!) {
  tariffs {
    utility(id: $id) {
      id
      shortName
      name
      tariffs {
        id
        masterTariffId
        code
        name
        tariffType
        customerClass
        isPreferred
        requiresPv
        requiresStorage
        customerLikelihood
        hasNetMetering
        hasTouRates
        minMonthlyKwh
        maxMonthlyKwh
        minMonthlyKw
        maxMonthlyKw
      }
    }
  }
}
    `

export const useTariffListQuery = <TData = TariffListQuery, TError = unknown>(
  variables: TariffListQueryVariables,
  options?: Omit<UseQueryOptions<TariffListQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<TariffListQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<TariffListQuery, TError, TData>({
    queryKey: ["TariffList", variables],
    queryFn: adminFetcher<TariffListQuery, TariffListQueryVariables>(
      TariffListDocument,
      variables,
    ),
    ...options,
  })
}

useTariffListQuery.getKey = (variables: TariffListQueryVariables) => [
  "TariffList",
  variables,
]

useTariffListQuery.rootKey = "TariffList"

export const useSuspenseTariffListQuery = <TData = TariffListQuery, TError = unknown>(
  variables: TariffListQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<TariffListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<TariffListQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<TariffListQuery, TError, TData>({
    queryKey: ["TariffListSuspense", variables],
    queryFn: adminFetcher<TariffListQuery, TariffListQueryVariables>(
      TariffListDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseTariffListQuery.getKey = (variables: TariffListQueryVariables) => [
  "TariffListSuspense",
  variables,
]

useSuspenseTariffListQuery.rootKey = "TariffList"

export const useInfiniteTariffListQuery = <
  TData = InfiniteData<TariffListQuery>,
  TError = unknown,
>(
  variables: TariffListQueryVariables,
  options: Omit<UseInfiniteQueryOptions<TariffListQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<TariffListQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<TariffListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["TariffList.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<TariffListQuery, TariffListQueryVariables>(TariffListDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteTariffListQuery.getKey = (variables: TariffListQueryVariables) => [
  "TariffList.infinite",
  variables,
]

useInfiniteTariffListQuery.rootKey = "TariffList.infinite"

export const useSuspenseInfiniteTariffListQuery = <
  TData = InfiniteData<TariffListQuery>,
  TError = unknown,
>(
  variables: TariffListQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<TariffListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      TariffListQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<TariffListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["TariffList.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<TariffListQuery, TariffListQueryVariables>(TariffListDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteTariffListQuery.getKey = (variables: TariffListQueryVariables) => [
  "TariffList.infiniteSuspense",
  variables,
]

useSuspenseInfiniteTariffListQuery.rootKey = "TariffList.infinite"

useTariffListQuery.fetcher = (
  variables: TariffListQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<TariffListQuery, TariffListQueryVariables>(
    TariffListDocument,
    variables,
    options,
  )

export const CustomTariffListDocument = `
    query CustomTariffList($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    displayName
    targetUtility {
      id
      name
    }
    customTariffs {
      id
      dateCreated
      name
      code
      customerClass
      parent {
        id
      }
      utility {
        id
        name
      }
      createdBy {
        pid
        email
      }
      archivedAt
    }
  }
}
    `

export const useCustomTariffListQuery = <
  TData = CustomTariffListQuery,
  TError = unknown,
>(
  variables: CustomTariffListQueryVariables,
  options?: Omit<UseQueryOptions<CustomTariffListQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<CustomTariffListQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<CustomTariffListQuery, TError, TData>({
    queryKey: ["CustomTariffList", variables],
    queryFn: adminFetcher<CustomTariffListQuery, CustomTariffListQueryVariables>(
      CustomTariffListDocument,
      variables,
    ),
    ...options,
  })
}

useCustomTariffListQuery.getKey = (variables: CustomTariffListQueryVariables) => [
  "CustomTariffList",
  variables,
]

useCustomTariffListQuery.rootKey = "CustomTariffList"

export const useSuspenseCustomTariffListQuery = <
  TData = CustomTariffListQuery,
  TError = unknown,
>(
  variables: CustomTariffListQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<CustomTariffListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<CustomTariffListQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<CustomTariffListQuery, TError, TData>({
    queryKey: ["CustomTariffListSuspense", variables],
    queryFn: adminFetcher<CustomTariffListQuery, CustomTariffListQueryVariables>(
      CustomTariffListDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseCustomTariffListQuery.getKey = (
  variables: CustomTariffListQueryVariables,
) => ["CustomTariffListSuspense", variables]

useSuspenseCustomTariffListQuery.rootKey = "CustomTariffList"

export const useInfiniteCustomTariffListQuery = <
  TData = InfiniteData<CustomTariffListQuery>,
  TError = unknown,
>(
  variables: CustomTariffListQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<CustomTariffListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<CustomTariffListQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<CustomTariffListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["CustomTariffList.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<CustomTariffListQuery, CustomTariffListQueryVariables>(
            CustomTariffListDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteCustomTariffListQuery.getKey = (
  variables: CustomTariffListQueryVariables,
) => ["CustomTariffList.infinite", variables]

useInfiniteCustomTariffListQuery.rootKey = "CustomTariffList.infinite"

export const useSuspenseInfiniteCustomTariffListQuery = <
  TData = InfiniteData<CustomTariffListQuery>,
  TError = unknown,
>(
  variables: CustomTariffListQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<CustomTariffListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      CustomTariffListQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<CustomTariffListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["CustomTariffList.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<CustomTariffListQuery, CustomTariffListQueryVariables>(
            CustomTariffListDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteCustomTariffListQuery.getKey = (
  variables: CustomTariffListQueryVariables,
) => ["CustomTariffList.infiniteSuspense", variables]

useSuspenseInfiniteCustomTariffListQuery.rootKey = "CustomTariffList.infinite"

useCustomTariffListQuery.fetcher = (
  variables: CustomTariffListQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<CustomTariffListQuery, CustomTariffListQueryVariables>(
    CustomTariffListDocument,
    variables,
    options,
  )

export const TariffDetailDocument = `
    query TariffDetail($tariffId: Int!) {
  tariffs {
    tariff(id: $tariffId) {
      id
      masterTariffId
      code
      name
      tariffType
      customerClass
      customerCount
      customerLikelihood
      minMonthlyKwh
      maxMonthlyKwh
      minMonthlyKw
      maxMonthlyKw
      hasTouRates
      hasNetMetering
      isPreferred
      notes
      requiresPv
      requiresStorage
      utility {
        id
        name
      }
      rateDetails {
        ...TariffDetailFragment
      }
      history {
        dateLastUpdated
        versions {
          isDownloaded
          tariffId
          effectiveDate
          endDate
        }
      }
    }
  }
}
    ${TariffDetailFragmentFragmentDoc}`

export const useTariffDetailQuery = <TData = TariffDetailQuery, TError = unknown>(
  variables: TariffDetailQueryVariables,
  options?: Omit<UseQueryOptions<TariffDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<TariffDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<TariffDetailQuery, TError, TData>({
    queryKey: ["TariffDetail", variables],
    queryFn: adminFetcher<TariffDetailQuery, TariffDetailQueryVariables>(
      TariffDetailDocument,
      variables,
    ),
    ...options,
  })
}

useTariffDetailQuery.getKey = (variables: TariffDetailQueryVariables) => [
  "TariffDetail",
  variables,
]

useTariffDetailQuery.rootKey = "TariffDetail"

export const useSuspenseTariffDetailQuery = <
  TData = TariffDetailQuery,
  TError = unknown,
>(
  variables: TariffDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<TariffDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<TariffDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<TariffDetailQuery, TError, TData>({
    queryKey: ["TariffDetailSuspense", variables],
    queryFn: adminFetcher<TariffDetailQuery, TariffDetailQueryVariables>(
      TariffDetailDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseTariffDetailQuery.getKey = (variables: TariffDetailQueryVariables) => [
  "TariffDetailSuspense",
  variables,
]

useSuspenseTariffDetailQuery.rootKey = "TariffDetail"

export const useInfiniteTariffDetailQuery = <
  TData = InfiniteData<TariffDetailQuery>,
  TError = unknown,
>(
  variables: TariffDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<TariffDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<TariffDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<TariffDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["TariffDetail.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<TariffDetailQuery, TariffDetailQueryVariables>(
            TariffDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteTariffDetailQuery.getKey = (variables: TariffDetailQueryVariables) => [
  "TariffDetail.infinite",
  variables,
]

useInfiniteTariffDetailQuery.rootKey = "TariffDetail.infinite"

export const useSuspenseInfiniteTariffDetailQuery = <
  TData = InfiniteData<TariffDetailQuery>,
  TError = unknown,
>(
  variables: TariffDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<TariffDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      TariffDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<TariffDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["TariffDetail.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<TariffDetailQuery, TariffDetailQueryVariables>(
            TariffDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteTariffDetailQuery.getKey = (
  variables: TariffDetailQueryVariables,
) => ["TariffDetail.infiniteSuspense", variables]

useSuspenseInfiniteTariffDetailQuery.rootKey = "TariffDetail.infinite"

useTariffDetailQuery.fetcher = (
  variables: TariffDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<TariffDetailQuery, TariffDetailQueryVariables>(
    TariffDetailDocument,
    variables,
    options,
  )

export const SiteHeaderDocument = `
    query SiteHeader($sitePid: String!) {
  site(pid: $sitePid) {
    id
    pid
    customerId
    propertyName
    streetAddress
    city
    state
    zipCode
    portfolio {
      pid
      title
      org {
        pid
        name
        slug
      }
    }
    status
    hiddenFromCustomers
    statusCheckPassed
    policyViolations {
      policy {
        pid
      }
    }
  }
}
    `

export const useSiteHeaderQuery = <TData = SiteHeaderQuery, TError = unknown>(
  variables: SiteHeaderQueryVariables,
  options?: Omit<UseQueryOptions<SiteHeaderQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SiteHeaderQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteHeaderQuery, TError, TData>({
    queryKey: ["SiteHeader", variables],
    queryFn: adminFetcher<SiteHeaderQuery, SiteHeaderQueryVariables>(
      SiteHeaderDocument,
      variables,
    ),
    ...options,
  })
}

useSiteHeaderQuery.getKey = (variables: SiteHeaderQueryVariables) => [
  "SiteHeader",
  variables,
]

useSiteHeaderQuery.rootKey = "SiteHeader"

export const useSuspenseSiteHeaderQuery = <TData = SiteHeaderQuery, TError = unknown>(
  variables: SiteHeaderQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteHeaderQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<SiteHeaderQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteHeaderQuery, TError, TData>({
    queryKey: ["SiteHeaderSuspense", variables],
    queryFn: adminFetcher<SiteHeaderQuery, SiteHeaderQueryVariables>(
      SiteHeaderDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteHeaderQuery.getKey = (variables: SiteHeaderQueryVariables) => [
  "SiteHeaderSuspense",
  variables,
]

useSuspenseSiteHeaderQuery.rootKey = "SiteHeader"

export const useInfiniteSiteHeaderQuery = <
  TData = InfiniteData<SiteHeaderQuery>,
  TError = unknown,
>(
  variables: SiteHeaderQueryVariables,
  options: Omit<UseInfiniteQueryOptions<SiteHeaderQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<SiteHeaderQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteHeaderQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteHeader.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteHeaderQuery, SiteHeaderQueryVariables>(SiteHeaderDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteHeaderQuery.getKey = (variables: SiteHeaderQueryVariables) => [
  "SiteHeader.infinite",
  variables,
]

useInfiniteSiteHeaderQuery.rootKey = "SiteHeader.infinite"

export const useSuspenseInfiniteSiteHeaderQuery = <
  TData = InfiniteData<SiteHeaderQuery>,
  TError = unknown,
>(
  variables: SiteHeaderQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteHeaderQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteHeaderQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteHeaderQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteHeader.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteHeaderQuery, SiteHeaderQueryVariables>(SiteHeaderDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteHeaderQuery.getKey = (variables: SiteHeaderQueryVariables) => [
  "SiteHeader.infiniteSuspense",
  variables,
]

useSuspenseInfiniteSiteHeaderQuery.rootKey = "SiteHeader.infinite"

useSiteHeaderQuery.fetcher = (
  variables: SiteHeaderQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SiteHeaderQuery, SiteHeaderQueryVariables>(
    SiteHeaderDocument,
    variables,
    options,
  )

export const GetEtbDetailDocument = `
    query GetEtbDetail($sitePid: String!, $etbId: Int!) {
  site(pid: $sitePid) {
    pid
    activeMeters {
      id
      meters {
        ...BauMeter
      }
    }
    etbReport(id: $etbId) {
      id
      dateCreated
      projectName
      proposalDate
      taxType
      ownerSector
      federalIncomeTaxRate
      stateIncomeTaxRate
      discountRate
      electricityEscalationRate
      scenario {
        ...ETBScenarioRef
      }
      combinedCosts {
        ...CostsFragment
      }
      meters {
        id
        name
        streetAddress
        city
        state
        zipCode
        utilityName
        genabilityUtility: utility {
          id
          name
          shortName
        }
        tariffFullDescriptionBefore
        genabilityTariffBefore: tariffBefore {
          id
          name
          code
        }
        tariffFullDescriptionAfter
        genabilityTariffAfter: tariffAfter {
          id
          name
          code
        }
        costs {
          ...CostsFragment
        }
        pv {
          cost
          powerRatingKwDc
          powerRatingKwAc
          degradationRate
          tilt
          azimuth
        }
        pvType
        bauMeter {
          id
          archivedAt
        }
      }
      transactions {
        name
        termYears
        irr10Year
        irr20Year
        irrTerm
        lcoeBefore
        lcoeAfter
        lcoePv
        npvTerm
        paybackYears
        roiTerm
        demandSavingsTerm
        energySavingsTerm
        totalSavingsTerm
        pvGenerationKwhTerm
        storageDischargeKwhTerm
        storageConsumptionKwh
        totalCost
        totalIncentives
        netCost
        upfrontCost
        ppaTerm
        ppaStartingRate
        ppaEscalationRate
        series {
          name
          series
        }
      }
      roofPvKw
      carportPvKw
    }
  }
}
    ${BauMeterFragmentDoc}
${BauTariffFragmentDoc}
${EtbScenarioRefFragmentDoc}
${CostsFragmentFragmentDoc}`

export const useGetEtbDetailQuery = <TData = GetEtbDetailQuery, TError = unknown>(
  variables: GetEtbDetailQueryVariables,
  options?: Omit<UseQueryOptions<GetEtbDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<GetEtbDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<GetEtbDetailQuery, TError, TData>({
    queryKey: ["GetEtbDetail", variables],
    queryFn: adminFetcher<GetEtbDetailQuery, GetEtbDetailQueryVariables>(
      GetEtbDetailDocument,
      variables,
    ),
    ...options,
  })
}

useGetEtbDetailQuery.getKey = (variables: GetEtbDetailQueryVariables) => [
  "GetEtbDetail",
  variables,
]

useGetEtbDetailQuery.rootKey = "GetEtbDetail"

export const useSuspenseGetEtbDetailQuery = <
  TData = GetEtbDetailQuery,
  TError = unknown,
>(
  variables: GetEtbDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<GetEtbDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<GetEtbDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<GetEtbDetailQuery, TError, TData>({
    queryKey: ["GetEtbDetailSuspense", variables],
    queryFn: adminFetcher<GetEtbDetailQuery, GetEtbDetailQueryVariables>(
      GetEtbDetailDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseGetEtbDetailQuery.getKey = (variables: GetEtbDetailQueryVariables) => [
  "GetEtbDetailSuspense",
  variables,
]

useSuspenseGetEtbDetailQuery.rootKey = "GetEtbDetail"

export const useInfiniteGetEtbDetailQuery = <
  TData = InfiniteData<GetEtbDetailQuery>,
  TError = unknown,
>(
  variables: GetEtbDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<GetEtbDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<GetEtbDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<GetEtbDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["GetEtbDetail.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<GetEtbDetailQuery, GetEtbDetailQueryVariables>(
            GetEtbDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteGetEtbDetailQuery.getKey = (variables: GetEtbDetailQueryVariables) => [
  "GetEtbDetail.infinite",
  variables,
]

useInfiniteGetEtbDetailQuery.rootKey = "GetEtbDetail.infinite"

export const useSuspenseInfiniteGetEtbDetailQuery = <
  TData = InfiniteData<GetEtbDetailQuery>,
  TError = unknown,
>(
  variables: GetEtbDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<GetEtbDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      GetEtbDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<GetEtbDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["GetEtbDetail.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<GetEtbDetailQuery, GetEtbDetailQueryVariables>(
            GetEtbDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteGetEtbDetailQuery.getKey = (
  variables: GetEtbDetailQueryVariables,
) => ["GetEtbDetail.infiniteSuspense", variables]

useSuspenseInfiniteGetEtbDetailQuery.rootKey = "GetEtbDetail.infinite"

useGetEtbDetailQuery.fetcher = (
  variables: GetEtbDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<GetEtbDetailQuery, GetEtbDetailQueryVariables>(
    GetEtbDetailDocument,
    variables,
    options,
  )

export const EtbIndexDocument = `
    query EtbIndex($pid: String!) {
  site(pid: $pid) {
    pid
    etbReports {
      id
      projectName
      dateCreated
      proposalDate
      scenario {
        ...ETBScenarioRef
      }
    }
    etbScenarioOptions {
      ...ETBScenarioRef
    }
  }
}
    ${EtbScenarioRefFragmentDoc}`

export const useEtbIndexQuery = <TData = EtbIndexQuery, TError = unknown>(
  variables: EtbIndexQueryVariables,
  options?: Omit<UseQueryOptions<EtbIndexQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<EtbIndexQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<EtbIndexQuery, TError, TData>({
    queryKey: ["EtbIndex", variables],
    queryFn: adminFetcher<EtbIndexQuery, EtbIndexQueryVariables>(
      EtbIndexDocument,
      variables,
    ),
    ...options,
  })
}

useEtbIndexQuery.getKey = (variables: EtbIndexQueryVariables) => ["EtbIndex", variables]

useEtbIndexQuery.rootKey = "EtbIndex"

export const useSuspenseEtbIndexQuery = <TData = EtbIndexQuery, TError = unknown>(
  variables: EtbIndexQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<EtbIndexQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<EtbIndexQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<EtbIndexQuery, TError, TData>({
    queryKey: ["EtbIndexSuspense", variables],
    queryFn: adminFetcher<EtbIndexQuery, EtbIndexQueryVariables>(
      EtbIndexDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseEtbIndexQuery.getKey = (variables: EtbIndexQueryVariables) => [
  "EtbIndexSuspense",
  variables,
]

useSuspenseEtbIndexQuery.rootKey = "EtbIndex"

export const useInfiniteEtbIndexQuery = <
  TData = InfiniteData<EtbIndexQuery>,
  TError = unknown,
>(
  variables: EtbIndexQueryVariables,
  options: Omit<UseInfiniteQueryOptions<EtbIndexQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<EtbIndexQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<EtbIndexQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["EtbIndex.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<EtbIndexQuery, EtbIndexQueryVariables>(EtbIndexDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteEtbIndexQuery.getKey = (variables: EtbIndexQueryVariables) => [
  "EtbIndex.infinite",
  variables,
]

useInfiniteEtbIndexQuery.rootKey = "EtbIndex.infinite"

export const useSuspenseInfiniteEtbIndexQuery = <
  TData = InfiniteData<EtbIndexQuery>,
  TError = unknown,
>(
  variables: EtbIndexQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<EtbIndexQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<EtbIndexQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<EtbIndexQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["EtbIndex.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<EtbIndexQuery, EtbIndexQueryVariables>(EtbIndexDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteEtbIndexQuery.getKey = (variables: EtbIndexQueryVariables) => [
  "EtbIndex.infiniteSuspense",
  variables,
]

useSuspenseInfiniteEtbIndexQuery.rootKey = "EtbIndex.infinite"

useEtbIndexQuery.fetcher = (
  variables: EtbIndexQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<EtbIndexQuery, EtbIndexQueryVariables>(
    EtbIndexDocument,
    variables,
    options,
  )

export const HelioscopeIndexDocument = `
    query HelioscopeIndex($pid: String!) {
  site(pid: $pid) {
    pid
    activeMeters {
      meters {
        label
      }
    }
    helioscopes {
      id
      pid
      createdAt
      createdBy {
        ...UserRef
      }
      isTrashed
      roofPvKw
      carportPvKw
      carportPvThreeHighKw
      carportPvSixHighKw
      groundPvKw
      roofIsMax
      carportIsMax
      annualProductionAcKwh
      monthlyProductionAcKwh
      systemProductivityKwhPerKw
      allocations
      pvSpecs {
        pvType
        sizeKw
      }
      pdf {
        ...AttachmentFragment
      }
      roofImage {
        ...AttachmentFragment
      }
      roofImageHref
      productionCsv {
        ...AttachmentFragment
      }
      dcNameplateKw
      acNameplateKw
      loadRatio
      moduleType
      inverterType
      rackingTiltDegrees
      rackingManufacturer
      rackingConnectionType
      notes
    }
  }
}
    ${UserRefFragmentDoc}
${AttachmentFragmentFragmentDoc}`

export const useHelioscopeIndexQuery = <TData = HelioscopeIndexQuery, TError = unknown>(
  variables: HelioscopeIndexQueryVariables,
  options?: Omit<UseQueryOptions<HelioscopeIndexQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<HelioscopeIndexQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<HelioscopeIndexQuery, TError, TData>({
    queryKey: ["HelioscopeIndex", variables],
    queryFn: adminFetcher<HelioscopeIndexQuery, HelioscopeIndexQueryVariables>(
      HelioscopeIndexDocument,
      variables,
    ),
    ...options,
  })
}

useHelioscopeIndexQuery.getKey = (variables: HelioscopeIndexQueryVariables) => [
  "HelioscopeIndex",
  variables,
]

useHelioscopeIndexQuery.rootKey = "HelioscopeIndex"

export const useSuspenseHelioscopeIndexQuery = <
  TData = HelioscopeIndexQuery,
  TError = unknown,
>(
  variables: HelioscopeIndexQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<HelioscopeIndexQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<HelioscopeIndexQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<HelioscopeIndexQuery, TError, TData>({
    queryKey: ["HelioscopeIndexSuspense", variables],
    queryFn: adminFetcher<HelioscopeIndexQuery, HelioscopeIndexQueryVariables>(
      HelioscopeIndexDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseHelioscopeIndexQuery.getKey = (variables: HelioscopeIndexQueryVariables) => [
  "HelioscopeIndexSuspense",
  variables,
]

useSuspenseHelioscopeIndexQuery.rootKey = "HelioscopeIndex"

export const useInfiniteHelioscopeIndexQuery = <
  TData = InfiniteData<HelioscopeIndexQuery>,
  TError = unknown,
>(
  variables: HelioscopeIndexQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<HelioscopeIndexQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<HelioscopeIndexQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<HelioscopeIndexQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["HelioscopeIndex.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<HelioscopeIndexQuery, HelioscopeIndexQueryVariables>(
            HelioscopeIndexDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteHelioscopeIndexQuery.getKey = (variables: HelioscopeIndexQueryVariables) => [
  "HelioscopeIndex.infinite",
  variables,
]

useInfiniteHelioscopeIndexQuery.rootKey = "HelioscopeIndex.infinite"

export const useSuspenseInfiniteHelioscopeIndexQuery = <
  TData = InfiniteData<HelioscopeIndexQuery>,
  TError = unknown,
>(
  variables: HelioscopeIndexQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<HelioscopeIndexQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      HelioscopeIndexQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<HelioscopeIndexQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["HelioscopeIndex.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<HelioscopeIndexQuery, HelioscopeIndexQueryVariables>(
            HelioscopeIndexDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteHelioscopeIndexQuery.getKey = (
  variables: HelioscopeIndexQueryVariables,
) => ["HelioscopeIndex.infiniteSuspense", variables]

useSuspenseInfiniteHelioscopeIndexQuery.rootKey = "HelioscopeIndex.infinite"

useHelioscopeIndexQuery.fetcher = (
  variables: HelioscopeIndexQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<HelioscopeIndexQuery, HelioscopeIndexQueryVariables>(
    HelioscopeIndexDocument,
    variables,
    options,
  )

export const HelioscopeUploadDocument = `
    query HelioscopeUpload($pid: String!) {
  site(pid: $pid) {
    pid
    scenarios {
      ...SmallScenarioFragment
    }
  }
}
    ${SmallScenarioFragmentFragmentDoc}
${UserRefFragmentDoc}`

export const useHelioscopeUploadQuery = <
  TData = HelioscopeUploadQuery,
  TError = unknown,
>(
  variables: HelioscopeUploadQueryVariables,
  options?: Omit<UseQueryOptions<HelioscopeUploadQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<HelioscopeUploadQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<HelioscopeUploadQuery, TError, TData>({
    queryKey: ["HelioscopeUpload", variables],
    queryFn: adminFetcher<HelioscopeUploadQuery, HelioscopeUploadQueryVariables>(
      HelioscopeUploadDocument,
      variables,
    ),
    ...options,
  })
}

useHelioscopeUploadQuery.getKey = (variables: HelioscopeUploadQueryVariables) => [
  "HelioscopeUpload",
  variables,
]

useHelioscopeUploadQuery.rootKey = "HelioscopeUpload"

export const useSuspenseHelioscopeUploadQuery = <
  TData = HelioscopeUploadQuery,
  TError = unknown,
>(
  variables: HelioscopeUploadQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<HelioscopeUploadQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<HelioscopeUploadQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<HelioscopeUploadQuery, TError, TData>({
    queryKey: ["HelioscopeUploadSuspense", variables],
    queryFn: adminFetcher<HelioscopeUploadQuery, HelioscopeUploadQueryVariables>(
      HelioscopeUploadDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseHelioscopeUploadQuery.getKey = (
  variables: HelioscopeUploadQueryVariables,
) => ["HelioscopeUploadSuspense", variables]

useSuspenseHelioscopeUploadQuery.rootKey = "HelioscopeUpload"

export const useInfiniteHelioscopeUploadQuery = <
  TData = InfiniteData<HelioscopeUploadQuery>,
  TError = unknown,
>(
  variables: HelioscopeUploadQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<HelioscopeUploadQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<HelioscopeUploadQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<HelioscopeUploadQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["HelioscopeUpload.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<HelioscopeUploadQuery, HelioscopeUploadQueryVariables>(
            HelioscopeUploadDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteHelioscopeUploadQuery.getKey = (
  variables: HelioscopeUploadQueryVariables,
) => ["HelioscopeUpload.infinite", variables]

useInfiniteHelioscopeUploadQuery.rootKey = "HelioscopeUpload.infinite"

export const useSuspenseInfiniteHelioscopeUploadQuery = <
  TData = InfiniteData<HelioscopeUploadQuery>,
  TError = unknown,
>(
  variables: HelioscopeUploadQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<HelioscopeUploadQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      HelioscopeUploadQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<HelioscopeUploadQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["HelioscopeUpload.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<HelioscopeUploadQuery, HelioscopeUploadQueryVariables>(
            HelioscopeUploadDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteHelioscopeUploadQuery.getKey = (
  variables: HelioscopeUploadQueryVariables,
) => ["HelioscopeUpload.infiniteSuspense", variables]

useSuspenseInfiniteHelioscopeUploadQuery.rootKey = "HelioscopeUpload.infinite"

useHelioscopeUploadQuery.fetcher = (
  variables: HelioscopeUploadQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<HelioscopeUploadQuery, HelioscopeUploadQueryVariables>(
    HelioscopeUploadDocument,
    variables,
    options,
  )

export const LuxDetailDocument = `
    query LuxDetail($sitePid: String!, $id: Int!) {
  site(pid: $sitePid) {
    pid
    lux(id: $id) {
      ...Lux
    }
  }
}
    ${LuxFragmentDoc}
${SlimLuxFragmentDoc}
${PvConfigFragmentDoc}
${BatteryConfigFragmentDoc}
${LuxMeterFragmentDoc}
${CostSummaryFragmentDoc}`

export const useLuxDetailQuery = <TData = LuxDetailQuery, TError = unknown>(
  variables: LuxDetailQueryVariables,
  options?: Omit<UseQueryOptions<LuxDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<LuxDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<LuxDetailQuery, TError, TData>({
    queryKey: ["LuxDetail", variables],
    queryFn: adminFetcher<LuxDetailQuery, LuxDetailQueryVariables>(
      LuxDetailDocument,
      variables,
    ),
    ...options,
  })
}

useLuxDetailQuery.getKey = (variables: LuxDetailQueryVariables) => [
  "LuxDetail",
  variables,
]

useLuxDetailQuery.rootKey = "LuxDetail"

export const useSuspenseLuxDetailQuery = <TData = LuxDetailQuery, TError = unknown>(
  variables: LuxDetailQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<LuxDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<LuxDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<LuxDetailQuery, TError, TData>({
    queryKey: ["LuxDetailSuspense", variables],
    queryFn: adminFetcher<LuxDetailQuery, LuxDetailQueryVariables>(
      LuxDetailDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseLuxDetailQuery.getKey = (variables: LuxDetailQueryVariables) => [
  "LuxDetailSuspense",
  variables,
]

useSuspenseLuxDetailQuery.rootKey = "LuxDetail"

export const useInfiniteLuxDetailQuery = <
  TData = InfiniteData<LuxDetailQuery>,
  TError = unknown,
>(
  variables: LuxDetailQueryVariables,
  options: Omit<UseInfiniteQueryOptions<LuxDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<LuxDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<LuxDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["LuxDetail.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<LuxDetailQuery, LuxDetailQueryVariables>(LuxDetailDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteLuxDetailQuery.getKey = (variables: LuxDetailQueryVariables) => [
  "LuxDetail.infinite",
  variables,
]

useInfiniteLuxDetailQuery.rootKey = "LuxDetail.infinite"

export const useSuspenseInfiniteLuxDetailQuery = <
  TData = InfiniteData<LuxDetailQuery>,
  TError = unknown,
>(
  variables: LuxDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<LuxDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      LuxDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<LuxDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["LuxDetail.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<LuxDetailQuery, LuxDetailQueryVariables>(LuxDetailDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteLuxDetailQuery.getKey = (variables: LuxDetailQueryVariables) => [
  "LuxDetail.infiniteSuspense",
  variables,
]

useSuspenseInfiniteLuxDetailQuery.rootKey = "LuxDetail.infinite"

useLuxDetailQuery.fetcher = (
  variables: LuxDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<LuxDetailQuery, LuxDetailQueryVariables>(
    LuxDetailDocument,
    variables,
    options,
  )

export const GetPortfolioOverridesDocument = `
    query GetPortfolioOverrides($portfolioPid: String!) {
  portfolio(pid: $portfolioPid) {
    pid
    overrides {
      ...Override
    }
  }
  finmodelSettings {
    possibleOverrides {
      name
      type
    }
  }
}
    ${OverrideFragmentDoc}`

export const useGetPortfolioOverridesQuery = <
  TData = GetPortfolioOverridesQuery,
  TError = unknown,
>(
  variables: GetPortfolioOverridesQueryVariables,
  options?: Omit<
    UseQueryOptions<GetPortfolioOverridesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<GetPortfolioOverridesQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<GetPortfolioOverridesQuery, TError, TData>({
    queryKey: ["GetPortfolioOverrides", variables],
    queryFn: adminFetcher<
      GetPortfolioOverridesQuery,
      GetPortfolioOverridesQueryVariables
    >(GetPortfolioOverridesDocument, variables),
    ...options,
  })
}

useGetPortfolioOverridesQuery.getKey = (
  variables: GetPortfolioOverridesQueryVariables,
) => ["GetPortfolioOverrides", variables]

useGetPortfolioOverridesQuery.rootKey = "GetPortfolioOverrides"

export const useSuspenseGetPortfolioOverridesQuery = <
  TData = GetPortfolioOverridesQuery,
  TError = unknown,
>(
  variables: GetPortfolioOverridesQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<GetPortfolioOverridesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      GetPortfolioOverridesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<GetPortfolioOverridesQuery, TError, TData>({
    queryKey: ["GetPortfolioOverridesSuspense", variables],
    queryFn: adminFetcher<
      GetPortfolioOverridesQuery,
      GetPortfolioOverridesQueryVariables
    >(GetPortfolioOverridesDocument, variables),
    ...options,
  })
}

useSuspenseGetPortfolioOverridesQuery.getKey = (
  variables: GetPortfolioOverridesQueryVariables,
) => ["GetPortfolioOverridesSuspense", variables]

useSuspenseGetPortfolioOverridesQuery.rootKey = "GetPortfolioOverrides"

export const useInfiniteGetPortfolioOverridesQuery = <
  TData = InfiniteData<GetPortfolioOverridesQuery>,
  TError = unknown,
>(
  variables: GetPortfolioOverridesQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<GetPortfolioOverridesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      GetPortfolioOverridesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<GetPortfolioOverridesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["GetPortfolioOverrides.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<GetPortfolioOverridesQuery, GetPortfolioOverridesQueryVariables>(
            GetPortfolioOverridesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteGetPortfolioOverridesQuery.getKey = (
  variables: GetPortfolioOverridesQueryVariables,
) => ["GetPortfolioOverrides.infinite", variables]

useInfiniteGetPortfolioOverridesQuery.rootKey = "GetPortfolioOverrides.infinite"

export const useSuspenseInfiniteGetPortfolioOverridesQuery = <
  TData = InfiniteData<GetPortfolioOverridesQuery>,
  TError = unknown,
>(
  variables: GetPortfolioOverridesQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<GetPortfolioOverridesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      GetPortfolioOverridesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<GetPortfolioOverridesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "GetPortfolioOverrides.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<GetPortfolioOverridesQuery, GetPortfolioOverridesQueryVariables>(
            GetPortfolioOverridesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteGetPortfolioOverridesQuery.getKey = (
  variables: GetPortfolioOverridesQueryVariables,
) => ["GetPortfolioOverrides.infiniteSuspense", variables]

useSuspenseInfiniteGetPortfolioOverridesQuery.rootKey = "GetPortfolioOverrides.infinite"

useGetPortfolioOverridesQuery.fetcher = (
  variables: GetPortfolioOverridesQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<GetPortfolioOverridesQuery, GetPortfolioOverridesQueryVariables>(
    GetPortfolioOverridesDocument,
    variables,
    options,
  )

export const GetSiteOverridesDocument = `
    query GetSiteOverrides($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    overrides {
      ...Override
    }
    portfolio {
      pid
      overrides {
        ...Override
      }
    }
  }
  finmodelSettings {
    possibleOverrides {
      name
      type
    }
  }
}
    ${OverrideFragmentDoc}`

export const useGetSiteOverridesQuery = <
  TData = GetSiteOverridesQuery,
  TError = unknown,
>(
  variables: GetSiteOverridesQueryVariables,
  options?: Omit<UseQueryOptions<GetSiteOverridesQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<GetSiteOverridesQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<GetSiteOverridesQuery, TError, TData>({
    queryKey: ["GetSiteOverrides", variables],
    queryFn: adminFetcher<GetSiteOverridesQuery, GetSiteOverridesQueryVariables>(
      GetSiteOverridesDocument,
      variables,
    ),
    ...options,
  })
}

useGetSiteOverridesQuery.getKey = (variables: GetSiteOverridesQueryVariables) => [
  "GetSiteOverrides",
  variables,
]

useGetSiteOverridesQuery.rootKey = "GetSiteOverrides"

export const useSuspenseGetSiteOverridesQuery = <
  TData = GetSiteOverridesQuery,
  TError = unknown,
>(
  variables: GetSiteOverridesQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<GetSiteOverridesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<GetSiteOverridesQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<GetSiteOverridesQuery, TError, TData>({
    queryKey: ["GetSiteOverridesSuspense", variables],
    queryFn: adminFetcher<GetSiteOverridesQuery, GetSiteOverridesQueryVariables>(
      GetSiteOverridesDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseGetSiteOverridesQuery.getKey = (
  variables: GetSiteOverridesQueryVariables,
) => ["GetSiteOverridesSuspense", variables]

useSuspenseGetSiteOverridesQuery.rootKey = "GetSiteOverrides"

export const useInfiniteGetSiteOverridesQuery = <
  TData = InfiniteData<GetSiteOverridesQuery>,
  TError = unknown,
>(
  variables: GetSiteOverridesQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<GetSiteOverridesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<GetSiteOverridesQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<GetSiteOverridesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["GetSiteOverrides.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<GetSiteOverridesQuery, GetSiteOverridesQueryVariables>(
            GetSiteOverridesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteGetSiteOverridesQuery.getKey = (
  variables: GetSiteOverridesQueryVariables,
) => ["GetSiteOverrides.infinite", variables]

useInfiniteGetSiteOverridesQuery.rootKey = "GetSiteOverrides.infinite"

export const useSuspenseInfiniteGetSiteOverridesQuery = <
  TData = InfiniteData<GetSiteOverridesQuery>,
  TError = unknown,
>(
  variables: GetSiteOverridesQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<GetSiteOverridesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      GetSiteOverridesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<GetSiteOverridesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["GetSiteOverrides.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<GetSiteOverridesQuery, GetSiteOverridesQueryVariables>(
            GetSiteOverridesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteGetSiteOverridesQuery.getKey = (
  variables: GetSiteOverridesQueryVariables,
) => ["GetSiteOverrides.infiniteSuspense", variables]

useSuspenseInfiniteGetSiteOverridesQuery.rootKey = "GetSiteOverrides.infinite"

useGetSiteOverridesQuery.fetcher = (
  variables: GetSiteOverridesQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<GetSiteOverridesQuery, GetSiteOverridesQueryVariables>(
    GetSiteOverridesDocument,
    variables,
    options,
  )

export const GetFinancingGiverOrgOverridesDocument = `
    query GetFinancingGiverOrgOverrides($orgPid: String!) {
  org(orgPid: $orgPid) {
    pid
    overrides {
      ...Override
    }
  }
  finmodelSettings {
    possibleOverrides {
      name
      type
    }
  }
}
    ${OverrideFragmentDoc}`

export const useGetFinancingGiverOrgOverridesQuery = <
  TData = GetFinancingGiverOrgOverridesQuery,
  TError = unknown,
>(
  variables: GetFinancingGiverOrgOverridesQueryVariables,
  options?: Omit<
    UseQueryOptions<GetFinancingGiverOrgOverridesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      GetFinancingGiverOrgOverridesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useQuery<GetFinancingGiverOrgOverridesQuery, TError, TData>({
    queryKey: ["GetFinancingGiverOrgOverrides", variables],
    queryFn: adminFetcher<
      GetFinancingGiverOrgOverridesQuery,
      GetFinancingGiverOrgOverridesQueryVariables
    >(GetFinancingGiverOrgOverridesDocument, variables),
    ...options,
  })
}

useGetFinancingGiverOrgOverridesQuery.getKey = (
  variables: GetFinancingGiverOrgOverridesQueryVariables,
) => ["GetFinancingGiverOrgOverrides", variables]

useGetFinancingGiverOrgOverridesQuery.rootKey = "GetFinancingGiverOrgOverrides"

export const useSuspenseGetFinancingGiverOrgOverridesQuery = <
  TData = GetFinancingGiverOrgOverridesQuery,
  TError = unknown,
>(
  variables: GetFinancingGiverOrgOverridesQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<GetFinancingGiverOrgOverridesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      GetFinancingGiverOrgOverridesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<GetFinancingGiverOrgOverridesQuery, TError, TData>({
    queryKey: ["GetFinancingGiverOrgOverridesSuspense", variables],
    queryFn: adminFetcher<
      GetFinancingGiverOrgOverridesQuery,
      GetFinancingGiverOrgOverridesQueryVariables
    >(GetFinancingGiverOrgOverridesDocument, variables),
    ...options,
  })
}

useSuspenseGetFinancingGiverOrgOverridesQuery.getKey = (
  variables: GetFinancingGiverOrgOverridesQueryVariables,
) => ["GetFinancingGiverOrgOverridesSuspense", variables]

useSuspenseGetFinancingGiverOrgOverridesQuery.rootKey = "GetFinancingGiverOrgOverrides"

export const useInfiniteGetFinancingGiverOrgOverridesQuery = <
  TData = InfiniteData<GetFinancingGiverOrgOverridesQuery>,
  TError = unknown,
>(
  variables: GetFinancingGiverOrgOverridesQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<GetFinancingGiverOrgOverridesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      GetFinancingGiverOrgOverridesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<GetFinancingGiverOrgOverridesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "GetFinancingGiverOrgOverrides.infinite",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<
            GetFinancingGiverOrgOverridesQuery,
            GetFinancingGiverOrgOverridesQueryVariables
          >(GetFinancingGiverOrgOverridesDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteGetFinancingGiverOrgOverridesQuery.getKey = (
  variables: GetFinancingGiverOrgOverridesQueryVariables,
) => ["GetFinancingGiverOrgOverrides.infinite", variables]

useInfiniteGetFinancingGiverOrgOverridesQuery.rootKey =
  "GetFinancingGiverOrgOverrides.infinite"

export const useSuspenseInfiniteGetFinancingGiverOrgOverridesQuery = <
  TData = InfiniteData<GetFinancingGiverOrgOverridesQuery>,
  TError = unknown,
>(
  variables: GetFinancingGiverOrgOverridesQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<GetFinancingGiverOrgOverridesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      GetFinancingGiverOrgOverridesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<GetFinancingGiverOrgOverridesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "GetFinancingGiverOrgOverrides.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<
            GetFinancingGiverOrgOverridesQuery,
            GetFinancingGiverOrgOverridesQueryVariables
          >(GetFinancingGiverOrgOverridesDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteGetFinancingGiverOrgOverridesQuery.getKey = (
  variables: GetFinancingGiverOrgOverridesQueryVariables,
) => ["GetFinancingGiverOrgOverrides.infiniteSuspense", variables]

useSuspenseInfiniteGetFinancingGiverOrgOverridesQuery.rootKey =
  "GetFinancingGiverOrgOverrides.infinite"

useGetFinancingGiverOrgOverridesQuery.fetcher = (
  variables: GetFinancingGiverOrgOverridesQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    GetFinancingGiverOrgOverridesQuery,
    GetFinancingGiverOrgOverridesQueryVariables
  >(GetFinancingGiverOrgOverridesDocument, variables, options)

export const FinproductOverridesDocument = `
    query FinproductOverrides($finProductId: Int!) {
  finproduct(finproductId: $finProductId) {
    id
    finmodelInputOverrides {
      ...Override
    }
  }
  finmodelSettings {
    possibleOverrides {
      name
      type
    }
  }
}
    ${OverrideFragmentDoc}`

export const useFinproductOverridesQuery = <
  TData = FinproductOverridesQuery,
  TError = unknown,
>(
  variables: FinproductOverridesQueryVariables,
  options?: Omit<
    UseQueryOptions<FinproductOverridesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<FinproductOverridesQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<FinproductOverridesQuery, TError, TData>({
    queryKey: ["FinproductOverrides", variables],
    queryFn: adminFetcher<FinproductOverridesQuery, FinproductOverridesQueryVariables>(
      FinproductOverridesDocument,
      variables,
    ),
    ...options,
  })
}

useFinproductOverridesQuery.getKey = (variables: FinproductOverridesQueryVariables) => [
  "FinproductOverrides",
  variables,
]

useFinproductOverridesQuery.rootKey = "FinproductOverrides"

export const useSuspenseFinproductOverridesQuery = <
  TData = FinproductOverridesQuery,
  TError = unknown,
>(
  variables: FinproductOverridesQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<FinproductOverridesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      FinproductOverridesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<FinproductOverridesQuery, TError, TData>({
    queryKey: ["FinproductOverridesSuspense", variables],
    queryFn: adminFetcher<FinproductOverridesQuery, FinproductOverridesQueryVariables>(
      FinproductOverridesDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseFinproductOverridesQuery.getKey = (
  variables: FinproductOverridesQueryVariables,
) => ["FinproductOverridesSuspense", variables]

useSuspenseFinproductOverridesQuery.rootKey = "FinproductOverrides"

export const useInfiniteFinproductOverridesQuery = <
  TData = InfiniteData<FinproductOverridesQuery>,
  TError = unknown,
>(
  variables: FinproductOverridesQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<FinproductOverridesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      FinproductOverridesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<FinproductOverridesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["FinproductOverrides.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<FinproductOverridesQuery, FinproductOverridesQueryVariables>(
            FinproductOverridesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteFinproductOverridesQuery.getKey = (
  variables: FinproductOverridesQueryVariables,
) => ["FinproductOverrides.infinite", variables]

useInfiniteFinproductOverridesQuery.rootKey = "FinproductOverrides.infinite"

export const useSuspenseInfiniteFinproductOverridesQuery = <
  TData = InfiniteData<FinproductOverridesQuery>,
  TError = unknown,
>(
  variables: FinproductOverridesQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<FinproductOverridesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      FinproductOverridesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<FinproductOverridesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "FinproductOverrides.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<FinproductOverridesQuery, FinproductOverridesQueryVariables>(
            FinproductOverridesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteFinproductOverridesQuery.getKey = (
  variables: FinproductOverridesQueryVariables,
) => ["FinproductOverrides.infiniteSuspense", variables]

useSuspenseInfiniteFinproductOverridesQuery.rootKey = "FinproductOverrides.infinite"

useFinproductOverridesQuery.fetcher = (
  variables: FinproductOverridesQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<FinproductOverridesQuery, FinproductOverridesQueryVariables>(
    FinproductOverridesDocument,
    variables,
    options,
  )

export const SiteUtilityDocument = `
    query SiteUtility($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    zipCode
    thirdPartySupplier {
      id
      name
    }
    targetUtility {
      id
      name
      shortName
    }
    targetUtilitySetBy {
      ...UserRef
    }
    dateTargetUtilitySet
    utilityName
    probableUtilities {
      id
      name
    }
    isMultifamily
    ...Metering
    customTariffs {
      id
      name
      code
      parent {
        id
      }
    }
  }
}
    ${UserRefFragmentDoc}
${MeteringFragmentDoc}`

export const useSiteUtilityQuery = <TData = SiteUtilityQuery, TError = unknown>(
  variables: SiteUtilityQueryVariables,
  options?: Omit<UseQueryOptions<SiteUtilityQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SiteUtilityQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteUtilityQuery, TError, TData>({
    queryKey: ["SiteUtility", variables],
    queryFn: adminFetcher<SiteUtilityQuery, SiteUtilityQueryVariables>(
      SiteUtilityDocument,
      variables,
    ),
    ...options,
  })
}

useSiteUtilityQuery.getKey = (variables: SiteUtilityQueryVariables) => [
  "SiteUtility",
  variables,
]

useSiteUtilityQuery.rootKey = "SiteUtility"

export const useSuspenseSiteUtilityQuery = <TData = SiteUtilityQuery, TError = unknown>(
  variables: SiteUtilityQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteUtilityQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<SiteUtilityQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteUtilityQuery, TError, TData>({
    queryKey: ["SiteUtilitySuspense", variables],
    queryFn: adminFetcher<SiteUtilityQuery, SiteUtilityQueryVariables>(
      SiteUtilityDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteUtilityQuery.getKey = (variables: SiteUtilityQueryVariables) => [
  "SiteUtilitySuspense",
  variables,
]

useSuspenseSiteUtilityQuery.rootKey = "SiteUtility"

export const useInfiniteSiteUtilityQuery = <
  TData = InfiniteData<SiteUtilityQuery>,
  TError = unknown,
>(
  variables: SiteUtilityQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SiteUtilityQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<SiteUtilityQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteUtilityQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteUtility.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteUtilityQuery, SiteUtilityQueryVariables>(
            SiteUtilityDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteUtilityQuery.getKey = (variables: SiteUtilityQueryVariables) => [
  "SiteUtility.infinite",
  variables,
]

useInfiniteSiteUtilityQuery.rootKey = "SiteUtility.infinite"

export const useSuspenseInfiniteSiteUtilityQuery = <
  TData = InfiniteData<SiteUtilityQuery>,
  TError = unknown,
>(
  variables: SiteUtilityQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteUtilityQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteUtilityQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteUtilityQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteUtility.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteUtilityQuery, SiteUtilityQueryVariables>(
            SiteUtilityDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteUtilityQuery.getKey = (variables: SiteUtilityQueryVariables) => [
  "SiteUtility.infiniteSuspense",
  variables,
]

useSuspenseInfiniteSiteUtilityQuery.rootKey = "SiteUtility.infinite"

useSiteUtilityQuery.fetcher = (
  variables: SiteUtilityQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SiteUtilityQuery, SiteUtilityQueryVariables>(
    SiteUtilityDocument,
    variables,
    options,
  )

export const UtilitySearchDocument = `
    query UtilitySearch($name: String!) {
  tariffs {
    searchGenabilityByUtilityName(name: $name) {
      id
      name
    }
  }
}
    `

export const useUtilitySearchQuery = <TData = UtilitySearchQuery, TError = unknown>(
  variables: UtilitySearchQueryVariables,
  options?: Omit<UseQueryOptions<UtilitySearchQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<UtilitySearchQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<UtilitySearchQuery, TError, TData>({
    queryKey: ["UtilitySearch", variables],
    queryFn: adminFetcher<UtilitySearchQuery, UtilitySearchQueryVariables>(
      UtilitySearchDocument,
      variables,
    ),
    ...options,
  })
}

useUtilitySearchQuery.getKey = (variables: UtilitySearchQueryVariables) => [
  "UtilitySearch",
  variables,
]

useUtilitySearchQuery.rootKey = "UtilitySearch"

export const useSuspenseUtilitySearchQuery = <
  TData = UtilitySearchQuery,
  TError = unknown,
>(
  variables: UtilitySearchQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<UtilitySearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<UtilitySearchQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<UtilitySearchQuery, TError, TData>({
    queryKey: ["UtilitySearchSuspense", variables],
    queryFn: adminFetcher<UtilitySearchQuery, UtilitySearchQueryVariables>(
      UtilitySearchDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseUtilitySearchQuery.getKey = (variables: UtilitySearchQueryVariables) => [
  "UtilitySearchSuspense",
  variables,
]

useSuspenseUtilitySearchQuery.rootKey = "UtilitySearch"

export const useInfiniteUtilitySearchQuery = <
  TData = InfiniteData<UtilitySearchQuery>,
  TError = unknown,
>(
  variables: UtilitySearchQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<UtilitySearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<UtilitySearchQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<UtilitySearchQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["UtilitySearch.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<UtilitySearchQuery, UtilitySearchQueryVariables>(
            UtilitySearchDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteUtilitySearchQuery.getKey = (variables: UtilitySearchQueryVariables) => [
  "UtilitySearch.infinite",
  variables,
]

useInfiniteUtilitySearchQuery.rootKey = "UtilitySearch.infinite"

export const useSuspenseInfiniteUtilitySearchQuery = <
  TData = InfiniteData<UtilitySearchQuery>,
  TError = unknown,
>(
  variables: UtilitySearchQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<UtilitySearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      UtilitySearchQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<UtilitySearchQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["UtilitySearch.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<UtilitySearchQuery, UtilitySearchQueryVariables>(
            UtilitySearchDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteUtilitySearchQuery.getKey = (
  variables: UtilitySearchQueryVariables,
) => ["UtilitySearch.infiniteSuspense", variables]

useSuspenseInfiniteUtilitySearchQuery.rootKey = "UtilitySearch.infinite"

useUtilitySearchQuery.fetcher = (
  variables: UtilitySearchQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<UtilitySearchQuery, UtilitySearchQueryVariables>(
    UtilitySearchDocument,
    variables,
    options,
  )

export const SiteUtilityByLabelDocument = `
    query SiteUtilityByLabel($sitePid: String!, $label: String!) {
  site(pid: $sitePid) {
    pid
    utilityByLabel(label: $label) {
      id
      name
    }
    probableUtilities {
      id
      name
    }
  }
}
    `

export const useSiteUtilityByLabelQuery = <
  TData = SiteUtilityByLabelQuery,
  TError = unknown,
>(
  variables: SiteUtilityByLabelQueryVariables,
  options?: Omit<
    UseQueryOptions<SiteUtilityByLabelQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<SiteUtilityByLabelQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteUtilityByLabelQuery, TError, TData>({
    queryKey: ["SiteUtilityByLabel", variables],
    queryFn: adminFetcher<SiteUtilityByLabelQuery, SiteUtilityByLabelQueryVariables>(
      SiteUtilityByLabelDocument,
      variables,
    ),
    ...options,
  })
}

useSiteUtilityByLabelQuery.getKey = (variables: SiteUtilityByLabelQueryVariables) => [
  "SiteUtilityByLabel",
  variables,
]

useSiteUtilityByLabelQuery.rootKey = "SiteUtilityByLabel"

export const useSuspenseSiteUtilityByLabelQuery = <
  TData = SiteUtilityByLabelQuery,
  TError = unknown,
>(
  variables: SiteUtilityByLabelQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteUtilityByLabelQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      SiteUtilityByLabelQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteUtilityByLabelQuery, TError, TData>({
    queryKey: ["SiteUtilityByLabelSuspense", variables],
    queryFn: adminFetcher<SiteUtilityByLabelQuery, SiteUtilityByLabelQueryVariables>(
      SiteUtilityByLabelDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteUtilityByLabelQuery.getKey = (
  variables: SiteUtilityByLabelQueryVariables,
) => ["SiteUtilityByLabelSuspense", variables]

useSuspenseSiteUtilityByLabelQuery.rootKey = "SiteUtilityByLabel"

export const useInfiniteSiteUtilityByLabelQuery = <
  TData = InfiniteData<SiteUtilityByLabelQuery>,
  TError = unknown,
>(
  variables: SiteUtilityByLabelQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SiteUtilityByLabelQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      SiteUtilityByLabelQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteUtilityByLabelQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteUtilityByLabel.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteUtilityByLabelQuery, SiteUtilityByLabelQueryVariables>(
            SiteUtilityByLabelDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteUtilityByLabelQuery.getKey = (
  variables: SiteUtilityByLabelQueryVariables,
) => ["SiteUtilityByLabel.infinite", variables]

useInfiniteSiteUtilityByLabelQuery.rootKey = "SiteUtilityByLabel.infinite"

export const useSuspenseInfiniteSiteUtilityByLabelQuery = <
  TData = InfiniteData<SiteUtilityByLabelQuery>,
  TError = unknown,
>(
  variables: SiteUtilityByLabelQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteUtilityByLabelQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteUtilityByLabelQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteUtilityByLabelQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteUtilityByLabel.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteUtilityByLabelQuery, SiteUtilityByLabelQueryVariables>(
            SiteUtilityByLabelDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteUtilityByLabelQuery.getKey = (
  variables: SiteUtilityByLabelQueryVariables,
) => ["SiteUtilityByLabel.infiniteSuspense", variables]

useSuspenseInfiniteSiteUtilityByLabelQuery.rootKey = "SiteUtilityByLabel.infinite"

useSiteUtilityByLabelQuery.fetcher = (
  variables: SiteUtilityByLabelQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SiteUtilityByLabelQuery, SiteUtilityByLabelQueryVariables>(
    SiteUtilityByLabelDocument,
    variables,
    options,
  )

export const ThirdPartySuppliersDocument = `
    query ThirdPartySuppliers {
  thirdPartySuppliers {
    id
    pid
    name
  }
}
    `

export const useThirdPartySuppliersQuery = <
  TData = ThirdPartySuppliersQuery,
  TError = unknown,
>(
  variables?: ThirdPartySuppliersQueryVariables,
  options?: Omit<
    UseQueryOptions<ThirdPartySuppliersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<ThirdPartySuppliersQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ThirdPartySuppliersQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["ThirdPartySuppliers"]
        : ["ThirdPartySuppliers", variables],
    queryFn: adminFetcher<ThirdPartySuppliersQuery, ThirdPartySuppliersQueryVariables>(
      ThirdPartySuppliersDocument,
      variables,
    ),
    ...options,
  })
}

useThirdPartySuppliersQuery.getKey = (variables?: ThirdPartySuppliersQueryVariables) =>
  variables === undefined ? ["ThirdPartySuppliers"] : ["ThirdPartySuppliers", variables]

useThirdPartySuppliersQuery.rootKey = "ThirdPartySuppliers"

export const useSuspenseThirdPartySuppliersQuery = <
  TData = ThirdPartySuppliersQuery,
  TError = unknown,
>(
  variables?: ThirdPartySuppliersQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ThirdPartySuppliersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      ThirdPartySuppliersQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<ThirdPartySuppliersQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["ThirdPartySuppliersSuspense"]
        : ["ThirdPartySuppliersSuspense", variables],
    queryFn: adminFetcher<ThirdPartySuppliersQuery, ThirdPartySuppliersQueryVariables>(
      ThirdPartySuppliersDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseThirdPartySuppliersQuery.getKey = (
  variables?: ThirdPartySuppliersQueryVariables,
) =>
  variables === undefined
    ? ["ThirdPartySuppliersSuspense"]
    : ["ThirdPartySuppliersSuspense", variables]

useSuspenseThirdPartySuppliersQuery.rootKey = "ThirdPartySuppliers"

export const useInfiniteThirdPartySuppliersQuery = <
  TData = InfiniteData<ThirdPartySuppliersQuery>,
  TError = unknown,
>(
  variables: ThirdPartySuppliersQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ThirdPartySuppliersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      ThirdPartySuppliersQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<ThirdPartySuppliersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["ThirdPartySuppliers.infinite"]
            : ["ThirdPartySuppliers.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<ThirdPartySuppliersQuery, ThirdPartySuppliersQueryVariables>(
            ThirdPartySuppliersDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteThirdPartySuppliersQuery.getKey = (
  variables?: ThirdPartySuppliersQueryVariables,
) =>
  variables === undefined
    ? ["ThirdPartySuppliers.infinite"]
    : ["ThirdPartySuppliers.infinite", variables]

useInfiniteThirdPartySuppliersQuery.rootKey = "ThirdPartySuppliers.infinite"

export const useSuspenseInfiniteThirdPartySuppliersQuery = <
  TData = InfiniteData<ThirdPartySuppliersQuery>,
  TError = unknown,
>(
  variables: ThirdPartySuppliersQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ThirdPartySuppliersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ThirdPartySuppliersQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ThirdPartySuppliersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["ThirdPartySuppliers.infiniteSuspense"]
            : ["ThirdPartySuppliers.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<ThirdPartySuppliersQuery, ThirdPartySuppliersQueryVariables>(
            ThirdPartySuppliersDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteThirdPartySuppliersQuery.getKey = (
  variables?: ThirdPartySuppliersQueryVariables,
) =>
  variables === undefined
    ? ["ThirdPartySuppliers.infiniteSuspense"]
    : ["ThirdPartySuppliers.infiniteSuspense", variables]

useSuspenseInfiniteThirdPartySuppliersQuery.rootKey = "ThirdPartySuppliers.infinite"

useThirdPartySuppliersQuery.fetcher = (
  variables?: ThirdPartySuppliersQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ThirdPartySuppliersQuery, ThirdPartySuppliersQueryVariables>(
    ThirdPartySuppliersDocument,
    variables,
    options,
  )

export const TariffRateDetailDocument = `
    query TariffRateDetail($sitePid: String!, $tariffParentId: Int!) {
  site(pid: $sitePid) {
    pid
    tariffDetail(tariffParentId: $tariffParentId) {
      ...TariffDetailFragment
    }
  }
}
    ${TariffDetailFragmentFragmentDoc}`

export const useTariffRateDetailQuery = <
  TData = TariffRateDetailQuery,
  TError = unknown,
>(
  variables: TariffRateDetailQueryVariables,
  options?: Omit<UseQueryOptions<TariffRateDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<TariffRateDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<TariffRateDetailQuery, TError, TData>({
    queryKey: ["TariffRateDetail", variables],
    queryFn: adminFetcher<TariffRateDetailQuery, TariffRateDetailQueryVariables>(
      TariffRateDetailDocument,
      variables,
    ),
    ...options,
  })
}

useTariffRateDetailQuery.getKey = (variables: TariffRateDetailQueryVariables) => [
  "TariffRateDetail",
  variables,
]

useTariffRateDetailQuery.rootKey = "TariffRateDetail"

export const useSuspenseTariffRateDetailQuery = <
  TData = TariffRateDetailQuery,
  TError = unknown,
>(
  variables: TariffRateDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<TariffRateDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<TariffRateDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<TariffRateDetailQuery, TError, TData>({
    queryKey: ["TariffRateDetailSuspense", variables],
    queryFn: adminFetcher<TariffRateDetailQuery, TariffRateDetailQueryVariables>(
      TariffRateDetailDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseTariffRateDetailQuery.getKey = (
  variables: TariffRateDetailQueryVariables,
) => ["TariffRateDetailSuspense", variables]

useSuspenseTariffRateDetailQuery.rootKey = "TariffRateDetail"

export const useInfiniteTariffRateDetailQuery = <
  TData = InfiniteData<TariffRateDetailQuery>,
  TError = unknown,
>(
  variables: TariffRateDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<TariffRateDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<TariffRateDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<TariffRateDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["TariffRateDetail.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<TariffRateDetailQuery, TariffRateDetailQueryVariables>(
            TariffRateDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteTariffRateDetailQuery.getKey = (
  variables: TariffRateDetailQueryVariables,
) => ["TariffRateDetail.infinite", variables]

useInfiniteTariffRateDetailQuery.rootKey = "TariffRateDetail.infinite"

export const useSuspenseInfiniteTariffRateDetailQuery = <
  TData = InfiniteData<TariffRateDetailQuery>,
  TError = unknown,
>(
  variables: TariffRateDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<TariffRateDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      TariffRateDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<TariffRateDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["TariffRateDetail.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<TariffRateDetailQuery, TariffRateDetailQueryVariables>(
            TariffRateDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteTariffRateDetailQuery.getKey = (
  variables: TariffRateDetailQueryVariables,
) => ["TariffRateDetail.infiniteSuspense", variables]

useSuspenseInfiniteTariffRateDetailQuery.rootKey = "TariffRateDetail.infinite"

useTariffRateDetailQuery.fetcher = (
  variables: TariffRateDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<TariffRateDetailQuery, TariffRateDetailQueryVariables>(
    TariffRateDetailDocument,
    variables,
    options,
  )

export const AdminSearchDocument = `
    query AdminSearch($q: String!) {
  search(q: $q) {
    id
    pid
    name
    fullAddress
    portfolio {
      pid
      title
    }
  }
}
    `

export const useAdminSearchQuery = <TData = AdminSearchQuery, TError = unknown>(
  variables: AdminSearchQueryVariables,
  options?: Omit<UseQueryOptions<AdminSearchQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<AdminSearchQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<AdminSearchQuery, TError, TData>({
    queryKey: ["AdminSearch", variables],
    queryFn: adminFetcher<AdminSearchQuery, AdminSearchQueryVariables>(
      AdminSearchDocument,
      variables,
    ),
    ...options,
  })
}

useAdminSearchQuery.getKey = (variables: AdminSearchQueryVariables) => [
  "AdminSearch",
  variables,
]

useAdminSearchQuery.rootKey = "AdminSearch"

export const useSuspenseAdminSearchQuery = <TData = AdminSearchQuery, TError = unknown>(
  variables: AdminSearchQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<AdminSearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<AdminSearchQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<AdminSearchQuery, TError, TData>({
    queryKey: ["AdminSearchSuspense", variables],
    queryFn: adminFetcher<AdminSearchQuery, AdminSearchQueryVariables>(
      AdminSearchDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseAdminSearchQuery.getKey = (variables: AdminSearchQueryVariables) => [
  "AdminSearchSuspense",
  variables,
]

useSuspenseAdminSearchQuery.rootKey = "AdminSearch"

export const useInfiniteAdminSearchQuery = <
  TData = InfiniteData<AdminSearchQuery>,
  TError = unknown,
>(
  variables: AdminSearchQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<AdminSearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<AdminSearchQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<AdminSearchQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["AdminSearch.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminSearchQuery, AdminSearchQueryVariables>(
            AdminSearchDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteAdminSearchQuery.getKey = (variables: AdminSearchQueryVariables) => [
  "AdminSearch.infinite",
  variables,
]

useInfiniteAdminSearchQuery.rootKey = "AdminSearch.infinite"

export const useSuspenseInfiniteAdminSearchQuery = <
  TData = InfiniteData<AdminSearchQuery>,
  TError = unknown,
>(
  variables: AdminSearchQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<AdminSearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      AdminSearchQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<AdminSearchQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["AdminSearch.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminSearchQuery, AdminSearchQueryVariables>(
            AdminSearchDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteAdminSearchQuery.getKey = (variables: AdminSearchQueryVariables) => [
  "AdminSearch.infiniteSuspense",
  variables,
]

useSuspenseInfiniteAdminSearchQuery.rootKey = "AdminSearch.infinite"

useAdminSearchQuery.fetcher = (
  variables: AdminSearchQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AdminSearchQuery, AdminSearchQueryVariables>(
    AdminSearchDocument,
    variables,
    options,
  )

export const CostarOwnerNameSearchDocument = `
    query CostarOwnerNameSearch($q: String!) {
  searchForOwnerName(q: $q) {
    ownerName
    countSitesInPortfolio
    countSitesNotInPortfolio
    primaryState
  }
}
    `

export const useCostarOwnerNameSearchQuery = <
  TData = CostarOwnerNameSearchQuery,
  TError = unknown,
>(
  variables: CostarOwnerNameSearchQueryVariables,
  options?: Omit<
    UseQueryOptions<CostarOwnerNameSearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<CostarOwnerNameSearchQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<CostarOwnerNameSearchQuery, TError, TData>({
    queryKey: ["CostarOwnerNameSearch", variables],
    queryFn: adminFetcher<
      CostarOwnerNameSearchQuery,
      CostarOwnerNameSearchQueryVariables
    >(CostarOwnerNameSearchDocument, variables),
    ...options,
  })
}

useCostarOwnerNameSearchQuery.getKey = (
  variables: CostarOwnerNameSearchQueryVariables,
) => ["CostarOwnerNameSearch", variables]

useCostarOwnerNameSearchQuery.rootKey = "CostarOwnerNameSearch"

export const useSuspenseCostarOwnerNameSearchQuery = <
  TData = CostarOwnerNameSearchQuery,
  TError = unknown,
>(
  variables: CostarOwnerNameSearchQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<CostarOwnerNameSearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      CostarOwnerNameSearchQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<CostarOwnerNameSearchQuery, TError, TData>({
    queryKey: ["CostarOwnerNameSearchSuspense", variables],
    queryFn: adminFetcher<
      CostarOwnerNameSearchQuery,
      CostarOwnerNameSearchQueryVariables
    >(CostarOwnerNameSearchDocument, variables),
    ...options,
  })
}

useSuspenseCostarOwnerNameSearchQuery.getKey = (
  variables: CostarOwnerNameSearchQueryVariables,
) => ["CostarOwnerNameSearchSuspense", variables]

useSuspenseCostarOwnerNameSearchQuery.rootKey = "CostarOwnerNameSearch"

export const useInfiniteCostarOwnerNameSearchQuery = <
  TData = InfiniteData<CostarOwnerNameSearchQuery>,
  TError = unknown,
>(
  variables: CostarOwnerNameSearchQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<CostarOwnerNameSearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      CostarOwnerNameSearchQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<CostarOwnerNameSearchQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["CostarOwnerNameSearch.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<CostarOwnerNameSearchQuery, CostarOwnerNameSearchQueryVariables>(
            CostarOwnerNameSearchDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteCostarOwnerNameSearchQuery.getKey = (
  variables: CostarOwnerNameSearchQueryVariables,
) => ["CostarOwnerNameSearch.infinite", variables]

useInfiniteCostarOwnerNameSearchQuery.rootKey = "CostarOwnerNameSearch.infinite"

export const useSuspenseInfiniteCostarOwnerNameSearchQuery = <
  TData = InfiniteData<CostarOwnerNameSearchQuery>,
  TError = unknown,
>(
  variables: CostarOwnerNameSearchQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<CostarOwnerNameSearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      CostarOwnerNameSearchQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<CostarOwnerNameSearchQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "CostarOwnerNameSearch.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<CostarOwnerNameSearchQuery, CostarOwnerNameSearchQueryVariables>(
            CostarOwnerNameSearchDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteCostarOwnerNameSearchQuery.getKey = (
  variables: CostarOwnerNameSearchQueryVariables,
) => ["CostarOwnerNameSearch.infiniteSuspense", variables]

useSuspenseInfiniteCostarOwnerNameSearchQuery.rootKey = "CostarOwnerNameSearch.infinite"

useCostarOwnerNameSearchQuery.fetcher = (
  variables: CostarOwnerNameSearchQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<CostarOwnerNameSearchQuery, CostarOwnerNameSearchQueryVariables>(
    CostarOwnerNameSearchDocument,
    variables,
    options,
  )

export const CostarSitesByOwnerNameDocument = `
    query CostarSitesByOwnerName($name: String!) {
  sitesByOwnerName(name: $name) {
    pid
    displayName
    costarPropertyType
    city
    state
  }
}
    `

export const useCostarSitesByOwnerNameQuery = <
  TData = CostarSitesByOwnerNameQuery,
  TError = unknown,
>(
  variables: CostarSitesByOwnerNameQueryVariables,
  options?: Omit<
    UseQueryOptions<CostarSitesByOwnerNameQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<CostarSitesByOwnerNameQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<CostarSitesByOwnerNameQuery, TError, TData>({
    queryKey: ["CostarSitesByOwnerName", variables],
    queryFn: adminFetcher<
      CostarSitesByOwnerNameQuery,
      CostarSitesByOwnerNameQueryVariables
    >(CostarSitesByOwnerNameDocument, variables),
    ...options,
  })
}

useCostarSitesByOwnerNameQuery.getKey = (
  variables: CostarSitesByOwnerNameQueryVariables,
) => ["CostarSitesByOwnerName", variables]

useCostarSitesByOwnerNameQuery.rootKey = "CostarSitesByOwnerName"

export const useSuspenseCostarSitesByOwnerNameQuery = <
  TData = CostarSitesByOwnerNameQuery,
  TError = unknown,
>(
  variables: CostarSitesByOwnerNameQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<CostarSitesByOwnerNameQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      CostarSitesByOwnerNameQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<CostarSitesByOwnerNameQuery, TError, TData>({
    queryKey: ["CostarSitesByOwnerNameSuspense", variables],
    queryFn: adminFetcher<
      CostarSitesByOwnerNameQuery,
      CostarSitesByOwnerNameQueryVariables
    >(CostarSitesByOwnerNameDocument, variables),
    ...options,
  })
}

useSuspenseCostarSitesByOwnerNameQuery.getKey = (
  variables: CostarSitesByOwnerNameQueryVariables,
) => ["CostarSitesByOwnerNameSuspense", variables]

useSuspenseCostarSitesByOwnerNameQuery.rootKey = "CostarSitesByOwnerName"

export const useInfiniteCostarSitesByOwnerNameQuery = <
  TData = InfiniteData<CostarSitesByOwnerNameQuery>,
  TError = unknown,
>(
  variables: CostarSitesByOwnerNameQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<CostarSitesByOwnerNameQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      CostarSitesByOwnerNameQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<CostarSitesByOwnerNameQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["CostarSitesByOwnerName.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<
            CostarSitesByOwnerNameQuery,
            CostarSitesByOwnerNameQueryVariables
          >(CostarSitesByOwnerNameDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteCostarSitesByOwnerNameQuery.getKey = (
  variables: CostarSitesByOwnerNameQueryVariables,
) => ["CostarSitesByOwnerName.infinite", variables]

useInfiniteCostarSitesByOwnerNameQuery.rootKey = "CostarSitesByOwnerName.infinite"

export const useSuspenseInfiniteCostarSitesByOwnerNameQuery = <
  TData = InfiniteData<CostarSitesByOwnerNameQuery>,
  TError = unknown,
>(
  variables: CostarSitesByOwnerNameQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<CostarSitesByOwnerNameQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      CostarSitesByOwnerNameQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<CostarSitesByOwnerNameQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "CostarSitesByOwnerName.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<
            CostarSitesByOwnerNameQuery,
            CostarSitesByOwnerNameQueryVariables
          >(CostarSitesByOwnerNameDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteCostarSitesByOwnerNameQuery.getKey = (
  variables: CostarSitesByOwnerNameQueryVariables,
) => ["CostarSitesByOwnerName.infiniteSuspense", variables]

useSuspenseInfiniteCostarSitesByOwnerNameQuery.rootKey =
  "CostarSitesByOwnerName.infinite"

useCostarSitesByOwnerNameQuery.fetcher = (
  variables: CostarSitesByOwnerNameQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<CostarSitesByOwnerNameQuery, CostarSitesByOwnerNameQueryVariables>(
    CostarSitesByOwnerNameDocument,
    variables,
    options,
  )

export const ScenarioListDocument = `
    query ScenarioList($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    scenarios {
      ...ScenarioFragment
    }
  }
}
    ${ScenarioFragmentFragmentDoc}
${SmallScenarioFragmentFragmentDoc}
${UserRefFragmentDoc}`

export const useScenarioListQuery = <TData = ScenarioListQuery, TError = unknown>(
  variables: ScenarioListQueryVariables,
  options?: Omit<UseQueryOptions<ScenarioListQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<ScenarioListQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ScenarioListQuery, TError, TData>({
    queryKey: ["ScenarioList", variables],
    queryFn: adminFetcher<ScenarioListQuery, ScenarioListQueryVariables>(
      ScenarioListDocument,
      variables,
    ),
    ...options,
  })
}

useScenarioListQuery.getKey = (variables: ScenarioListQueryVariables) => [
  "ScenarioList",
  variables,
]

useScenarioListQuery.rootKey = "ScenarioList"

export const useSuspenseScenarioListQuery = <
  TData = ScenarioListQuery,
  TError = unknown,
>(
  variables: ScenarioListQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ScenarioListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<ScenarioListQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<ScenarioListQuery, TError, TData>({
    queryKey: ["ScenarioListSuspense", variables],
    queryFn: adminFetcher<ScenarioListQuery, ScenarioListQueryVariables>(
      ScenarioListDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseScenarioListQuery.getKey = (variables: ScenarioListQueryVariables) => [
  "ScenarioListSuspense",
  variables,
]

useSuspenseScenarioListQuery.rootKey = "ScenarioList"

export const useInfiniteScenarioListQuery = <
  TData = InfiniteData<ScenarioListQuery>,
  TError = unknown,
>(
  variables: ScenarioListQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ScenarioListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<ScenarioListQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<ScenarioListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ScenarioList.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<ScenarioListQuery, ScenarioListQueryVariables>(
            ScenarioListDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteScenarioListQuery.getKey = (variables: ScenarioListQueryVariables) => [
  "ScenarioList.infinite",
  variables,
]

useInfiniteScenarioListQuery.rootKey = "ScenarioList.infinite"

export const useSuspenseInfiniteScenarioListQuery = <
  TData = InfiniteData<ScenarioListQuery>,
  TError = unknown,
>(
  variables: ScenarioListQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ScenarioListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ScenarioListQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ScenarioListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ScenarioList.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<ScenarioListQuery, ScenarioListQueryVariables>(
            ScenarioListDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteScenarioListQuery.getKey = (
  variables: ScenarioListQueryVariables,
) => ["ScenarioList.infiniteSuspense", variables]

useSuspenseInfiniteScenarioListQuery.rootKey = "ScenarioList.infinite"

useScenarioListQuery.fetcher = (
  variables: ScenarioListQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ScenarioListQuery, ScenarioListQueryVariables>(
    ScenarioListDocument,
    variables,
    options,
  )

export const ScenarioDetailDocument = `
    query ScenarioDetail($sitePid: String!, $scenarioPid: String!) {
  site(pid: $sitePid) {
    pid
    attachments {
      ...AttachmentFragment
    }
    helioscopes {
      ...ScenarioHelioscopeFragment
    }
    etbReports {
      ...ScenarioEtbFragment
    }
    scenario(pid: $scenarioPid) {
      ...ScenarioFragment
      etbs {
        id
        projectName
        dateCreated
      }
      configs {
        id
        createdAt
        finproduct {
          __typename
          financier {
            pid
            name
          }
          id
          createdAt
          name
          type
        }
        finproductType
        goal
        roofKw
        carportKw
        groundKw
        helioscope {
          ...ScenarioHelioscopeFragment
        }
        etb {
          ...ScenarioEtbFragment
        }
      }
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${UserRefFragmentDoc}
${ScenarioHelioscopeFragmentFragmentDoc}
${ScenarioEtbFragmentFragmentDoc}
${ScenarioFragmentFragmentDoc}
${SmallScenarioFragmentFragmentDoc}`

export const useScenarioDetailQuery = <TData = ScenarioDetailQuery, TError = unknown>(
  variables: ScenarioDetailQueryVariables,
  options?: Omit<UseQueryOptions<ScenarioDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<ScenarioDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ScenarioDetailQuery, TError, TData>({
    queryKey: ["ScenarioDetail", variables],
    queryFn: adminFetcher<ScenarioDetailQuery, ScenarioDetailQueryVariables>(
      ScenarioDetailDocument,
      variables,
    ),
    ...options,
  })
}

useScenarioDetailQuery.getKey = (variables: ScenarioDetailQueryVariables) => [
  "ScenarioDetail",
  variables,
]

useScenarioDetailQuery.rootKey = "ScenarioDetail"

export const useSuspenseScenarioDetailQuery = <
  TData = ScenarioDetailQuery,
  TError = unknown,
>(
  variables: ScenarioDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ScenarioDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<ScenarioDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<ScenarioDetailQuery, TError, TData>({
    queryKey: ["ScenarioDetailSuspense", variables],
    queryFn: adminFetcher<ScenarioDetailQuery, ScenarioDetailQueryVariables>(
      ScenarioDetailDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseScenarioDetailQuery.getKey = (variables: ScenarioDetailQueryVariables) => [
  "ScenarioDetailSuspense",
  variables,
]

useSuspenseScenarioDetailQuery.rootKey = "ScenarioDetail"

export const useInfiniteScenarioDetailQuery = <
  TData = InfiniteData<ScenarioDetailQuery>,
  TError = unknown,
>(
  variables: ScenarioDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ScenarioDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<ScenarioDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<ScenarioDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ScenarioDetail.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<ScenarioDetailQuery, ScenarioDetailQueryVariables>(
            ScenarioDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteScenarioDetailQuery.getKey = (variables: ScenarioDetailQueryVariables) => [
  "ScenarioDetail.infinite",
  variables,
]

useInfiniteScenarioDetailQuery.rootKey = "ScenarioDetail.infinite"

export const useSuspenseInfiniteScenarioDetailQuery = <
  TData = InfiniteData<ScenarioDetailQuery>,
  TError = unknown,
>(
  variables: ScenarioDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ScenarioDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ScenarioDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ScenarioDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ScenarioDetail.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<ScenarioDetailQuery, ScenarioDetailQueryVariables>(
            ScenarioDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteScenarioDetailQuery.getKey = (
  variables: ScenarioDetailQueryVariables,
) => ["ScenarioDetail.infiniteSuspense", variables]

useSuspenseInfiniteScenarioDetailQuery.rootKey = "ScenarioDetail.infinite"

useScenarioDetailQuery.fetcher = (
  variables: ScenarioDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ScenarioDetailQuery, ScenarioDetailQueryVariables>(
    ScenarioDetailDocument,
    variables,
    options,
  )

export const PortfolioUsersDocument = `
    query PortfolioUsers($portfolioPid: String!) {
  portfolio(pid: $portfolioPid) {
    pid
    title
    users {
      id
      email
    }
  }
}
    `

export const usePortfolioUsersQuery = <TData = PortfolioUsersQuery, TError = unknown>(
  variables: PortfolioUsersQueryVariables,
  options?: Omit<UseQueryOptions<PortfolioUsersQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<PortfolioUsersQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<PortfolioUsersQuery, TError, TData>({
    queryKey: ["PortfolioUsers", variables],
    queryFn: adminFetcher<PortfolioUsersQuery, PortfolioUsersQueryVariables>(
      PortfolioUsersDocument,
      variables,
    ),
    ...options,
  })
}

usePortfolioUsersQuery.getKey = (variables: PortfolioUsersQueryVariables) => [
  "PortfolioUsers",
  variables,
]

usePortfolioUsersQuery.rootKey = "PortfolioUsers"

export const useSuspensePortfolioUsersQuery = <
  TData = PortfolioUsersQuery,
  TError = unknown,
>(
  variables: PortfolioUsersQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<PortfolioUsersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<PortfolioUsersQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<PortfolioUsersQuery, TError, TData>({
    queryKey: ["PortfolioUsersSuspense", variables],
    queryFn: adminFetcher<PortfolioUsersQuery, PortfolioUsersQueryVariables>(
      PortfolioUsersDocument,
      variables,
    ),
    ...options,
  })
}

useSuspensePortfolioUsersQuery.getKey = (variables: PortfolioUsersQueryVariables) => [
  "PortfolioUsersSuspense",
  variables,
]

useSuspensePortfolioUsersQuery.rootKey = "PortfolioUsers"

export const useInfinitePortfolioUsersQuery = <
  TData = InfiniteData<PortfolioUsersQuery>,
  TError = unknown,
>(
  variables: PortfolioUsersQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<PortfolioUsersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<PortfolioUsersQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<PortfolioUsersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["PortfolioUsers.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<PortfolioUsersQuery, PortfolioUsersQueryVariables>(
            PortfolioUsersDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfinitePortfolioUsersQuery.getKey = (variables: PortfolioUsersQueryVariables) => [
  "PortfolioUsers.infinite",
  variables,
]

useInfinitePortfolioUsersQuery.rootKey = "PortfolioUsers.infinite"

export const useSuspenseInfinitePortfolioUsersQuery = <
  TData = InfiniteData<PortfolioUsersQuery>,
  TError = unknown,
>(
  variables: PortfolioUsersQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<PortfolioUsersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      PortfolioUsersQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<PortfolioUsersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["PortfolioUsers.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<PortfolioUsersQuery, PortfolioUsersQueryVariables>(
            PortfolioUsersDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfinitePortfolioUsersQuery.getKey = (
  variables: PortfolioUsersQueryVariables,
) => ["PortfolioUsers.infiniteSuspense", variables]

useSuspenseInfinitePortfolioUsersQuery.rootKey = "PortfolioUsers.infinite"

usePortfolioUsersQuery.fetcher = (
  variables: PortfolioUsersQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<PortfolioUsersQuery, PortfolioUsersQueryVariables>(
    PortfolioUsersDocument,
    variables,
    options,
  )

export const SiteChangelogDocument = `
    query SiteChangelog($sitePid: String!) {
  changelogs {
    site(sitePid: $sitePid) {
      id
      transactionId
      dateCreated
      columnName
      oldVal
      newVal
      changedBy {
        ...UserRef
      }
    }
  }
}
    ${UserRefFragmentDoc}`

export const useSiteChangelogQuery = <TData = SiteChangelogQuery, TError = unknown>(
  variables: SiteChangelogQueryVariables,
  options?: Omit<UseQueryOptions<SiteChangelogQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SiteChangelogQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteChangelogQuery, TError, TData>({
    queryKey: ["SiteChangelog", variables],
    queryFn: adminFetcher<SiteChangelogQuery, SiteChangelogQueryVariables>(
      SiteChangelogDocument,
      variables,
    ),
    ...options,
  })
}

useSiteChangelogQuery.getKey = (variables: SiteChangelogQueryVariables) => [
  "SiteChangelog",
  variables,
]

useSiteChangelogQuery.rootKey = "SiteChangelog"

export const useSuspenseSiteChangelogQuery = <
  TData = SiteChangelogQuery,
  TError = unknown,
>(
  variables: SiteChangelogQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteChangelogQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<SiteChangelogQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteChangelogQuery, TError, TData>({
    queryKey: ["SiteChangelogSuspense", variables],
    queryFn: adminFetcher<SiteChangelogQuery, SiteChangelogQueryVariables>(
      SiteChangelogDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteChangelogQuery.getKey = (variables: SiteChangelogQueryVariables) => [
  "SiteChangelogSuspense",
  variables,
]

useSuspenseSiteChangelogQuery.rootKey = "SiteChangelog"

export const useInfiniteSiteChangelogQuery = <
  TData = InfiniteData<SiteChangelogQuery>,
  TError = unknown,
>(
  variables: SiteChangelogQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SiteChangelogQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<SiteChangelogQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteChangelogQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteChangelog.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteChangelogQuery, SiteChangelogQueryVariables>(
            SiteChangelogDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteChangelogQuery.getKey = (variables: SiteChangelogQueryVariables) => [
  "SiteChangelog.infinite",
  variables,
]

useInfiniteSiteChangelogQuery.rootKey = "SiteChangelog.infinite"

export const useSuspenseInfiniteSiteChangelogQuery = <
  TData = InfiniteData<SiteChangelogQuery>,
  TError = unknown,
>(
  variables: SiteChangelogQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteChangelogQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteChangelogQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteChangelogQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteChangelog.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteChangelogQuery, SiteChangelogQueryVariables>(
            SiteChangelogDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteChangelogQuery.getKey = (
  variables: SiteChangelogQueryVariables,
) => ["SiteChangelog.infiniteSuspense", variables]

useSuspenseInfiniteSiteChangelogQuery.rootKey = "SiteChangelog.infinite"

useSiteChangelogQuery.fetcher = (
  variables: SiteChangelogQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SiteChangelogQuery, SiteChangelogQueryVariables>(
    SiteChangelogDocument,
    variables,
    options,
  )

export const SiteAttachmentsDocument = `
    query SiteAttachments($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    attachments {
      ...AttachmentFragment
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${UserRefFragmentDoc}`

export const useSiteAttachmentsQuery = <TData = SiteAttachmentsQuery, TError = unknown>(
  variables: SiteAttachmentsQueryVariables,
  options?: Omit<UseQueryOptions<SiteAttachmentsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SiteAttachmentsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteAttachmentsQuery, TError, TData>({
    queryKey: ["SiteAttachments", variables],
    queryFn: adminFetcher<SiteAttachmentsQuery, SiteAttachmentsQueryVariables>(
      SiteAttachmentsDocument,
      variables,
    ),
    ...options,
  })
}

useSiteAttachmentsQuery.getKey = (variables: SiteAttachmentsQueryVariables) => [
  "SiteAttachments",
  variables,
]

useSiteAttachmentsQuery.rootKey = "SiteAttachments"

export const useSuspenseSiteAttachmentsQuery = <
  TData = SiteAttachmentsQuery,
  TError = unknown,
>(
  variables: SiteAttachmentsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteAttachmentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<SiteAttachmentsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteAttachmentsQuery, TError, TData>({
    queryKey: ["SiteAttachmentsSuspense", variables],
    queryFn: adminFetcher<SiteAttachmentsQuery, SiteAttachmentsQueryVariables>(
      SiteAttachmentsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteAttachmentsQuery.getKey = (variables: SiteAttachmentsQueryVariables) => [
  "SiteAttachmentsSuspense",
  variables,
]

useSuspenseSiteAttachmentsQuery.rootKey = "SiteAttachments"

export const useInfiniteSiteAttachmentsQuery = <
  TData = InfiniteData<SiteAttachmentsQuery>,
  TError = unknown,
>(
  variables: SiteAttachmentsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SiteAttachmentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<SiteAttachmentsQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteAttachmentsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteAttachments.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteAttachmentsQuery, SiteAttachmentsQueryVariables>(
            SiteAttachmentsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteAttachmentsQuery.getKey = (variables: SiteAttachmentsQueryVariables) => [
  "SiteAttachments.infinite",
  variables,
]

useInfiniteSiteAttachmentsQuery.rootKey = "SiteAttachments.infinite"

export const useSuspenseInfiniteSiteAttachmentsQuery = <
  TData = InfiniteData<SiteAttachmentsQuery>,
  TError = unknown,
>(
  variables: SiteAttachmentsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteAttachmentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteAttachmentsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteAttachmentsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteAttachments.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteAttachmentsQuery, SiteAttachmentsQueryVariables>(
            SiteAttachmentsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteAttachmentsQuery.getKey = (
  variables: SiteAttachmentsQueryVariables,
) => ["SiteAttachments.infiniteSuspense", variables]

useSuspenseInfiniteSiteAttachmentsQuery.rootKey = "SiteAttachments.infinite"

useSiteAttachmentsQuery.fetcher = (
  variables: SiteAttachmentsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SiteAttachmentsQuery, SiteAttachmentsQueryVariables>(
    SiteAttachmentsDocument,
    variables,
    options,
  )

export const AttachmentAsCsvDocument = `
    query AttachmentAsCsv($sitePid: String!, $attachmentId: Int!) {
  site(pid: $sitePid) {
    pid
    isMultifamily
    attachment(id: $attachmentId) {
      ...AttachmentFragment
      csvPeek
    }
  }
}
    ${AttachmentFragmentFragmentDoc}
${UserRefFragmentDoc}`

export const useAttachmentAsCsvQuery = <TData = AttachmentAsCsvQuery, TError = unknown>(
  variables: AttachmentAsCsvQueryVariables,
  options?: Omit<UseQueryOptions<AttachmentAsCsvQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<AttachmentAsCsvQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<AttachmentAsCsvQuery, TError, TData>({
    queryKey: ["AttachmentAsCsv", variables],
    queryFn: adminFetcher<AttachmentAsCsvQuery, AttachmentAsCsvQueryVariables>(
      AttachmentAsCsvDocument,
      variables,
    ),
    ...options,
  })
}

useAttachmentAsCsvQuery.getKey = (variables: AttachmentAsCsvQueryVariables) => [
  "AttachmentAsCsv",
  variables,
]

useAttachmentAsCsvQuery.rootKey = "AttachmentAsCsv"

export const useSuspenseAttachmentAsCsvQuery = <
  TData = AttachmentAsCsvQuery,
  TError = unknown,
>(
  variables: AttachmentAsCsvQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<AttachmentAsCsvQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<AttachmentAsCsvQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<AttachmentAsCsvQuery, TError, TData>({
    queryKey: ["AttachmentAsCsvSuspense", variables],
    queryFn: adminFetcher<AttachmentAsCsvQuery, AttachmentAsCsvQueryVariables>(
      AttachmentAsCsvDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseAttachmentAsCsvQuery.getKey = (variables: AttachmentAsCsvQueryVariables) => [
  "AttachmentAsCsvSuspense",
  variables,
]

useSuspenseAttachmentAsCsvQuery.rootKey = "AttachmentAsCsv"

export const useInfiniteAttachmentAsCsvQuery = <
  TData = InfiniteData<AttachmentAsCsvQuery>,
  TError = unknown,
>(
  variables: AttachmentAsCsvQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<AttachmentAsCsvQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<AttachmentAsCsvQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<AttachmentAsCsvQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["AttachmentAsCsv.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<AttachmentAsCsvQuery, AttachmentAsCsvQueryVariables>(
            AttachmentAsCsvDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteAttachmentAsCsvQuery.getKey = (variables: AttachmentAsCsvQueryVariables) => [
  "AttachmentAsCsv.infinite",
  variables,
]

useInfiniteAttachmentAsCsvQuery.rootKey = "AttachmentAsCsv.infinite"

export const useSuspenseInfiniteAttachmentAsCsvQuery = <
  TData = InfiniteData<AttachmentAsCsvQuery>,
  TError = unknown,
>(
  variables: AttachmentAsCsvQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<AttachmentAsCsvQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      AttachmentAsCsvQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<AttachmentAsCsvQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["AttachmentAsCsv.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<AttachmentAsCsvQuery, AttachmentAsCsvQueryVariables>(
            AttachmentAsCsvDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteAttachmentAsCsvQuery.getKey = (
  variables: AttachmentAsCsvQueryVariables,
) => ["AttachmentAsCsv.infiniteSuspense", variables]

useSuspenseInfiniteAttachmentAsCsvQuery.rootKey = "AttachmentAsCsv.infinite"

useAttachmentAsCsvQuery.fetcher = (
  variables: AttachmentAsCsvQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AttachmentAsCsvQuery, AttachmentAsCsvQueryVariables>(
    AttachmentAsCsvDocument,
    variables,
    options,
  )

export const CleanMetersDocument = `
    query CleanMeters($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    isMultifamily
    cleanMeters {
      all {
        id
        dateCreated
        source
        label
        address
        dirtyIntervals {
          units
          totalKwh
          rollup {
            season
            days
            numbers
          }
        }
      }
    }
  }
}
    `

export const useCleanMetersQuery = <TData = CleanMetersQuery, TError = unknown>(
  variables: CleanMetersQueryVariables,
  options?: Omit<UseQueryOptions<CleanMetersQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<CleanMetersQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<CleanMetersQuery, TError, TData>({
    queryKey: ["CleanMeters", variables],
    queryFn: adminFetcher<CleanMetersQuery, CleanMetersQueryVariables>(
      CleanMetersDocument,
      variables,
    ),
    ...options,
  })
}

useCleanMetersQuery.getKey = (variables: CleanMetersQueryVariables) => [
  "CleanMeters",
  variables,
]

useCleanMetersQuery.rootKey = "CleanMeters"

export const useSuspenseCleanMetersQuery = <TData = CleanMetersQuery, TError = unknown>(
  variables: CleanMetersQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<CleanMetersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<CleanMetersQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<CleanMetersQuery, TError, TData>({
    queryKey: ["CleanMetersSuspense", variables],
    queryFn: adminFetcher<CleanMetersQuery, CleanMetersQueryVariables>(
      CleanMetersDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseCleanMetersQuery.getKey = (variables: CleanMetersQueryVariables) => [
  "CleanMetersSuspense",
  variables,
]

useSuspenseCleanMetersQuery.rootKey = "CleanMeters"

export const useInfiniteCleanMetersQuery = <
  TData = InfiniteData<CleanMetersQuery>,
  TError = unknown,
>(
  variables: CleanMetersQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<CleanMetersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<CleanMetersQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<CleanMetersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["CleanMeters.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<CleanMetersQuery, CleanMetersQueryVariables>(
            CleanMetersDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteCleanMetersQuery.getKey = (variables: CleanMetersQueryVariables) => [
  "CleanMeters.infinite",
  variables,
]

useInfiniteCleanMetersQuery.rootKey = "CleanMeters.infinite"

export const useSuspenseInfiniteCleanMetersQuery = <
  TData = InfiniteData<CleanMetersQuery>,
  TError = unknown,
>(
  variables: CleanMetersQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<CleanMetersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      CleanMetersQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<CleanMetersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["CleanMeters.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<CleanMetersQuery, CleanMetersQueryVariables>(
            CleanMetersDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteCleanMetersQuery.getKey = (variables: CleanMetersQueryVariables) => [
  "CleanMeters.infiniteSuspense",
  variables,
]

useSuspenseInfiniteCleanMetersQuery.rootKey = "CleanMeters.infinite"

useCleanMetersQuery.fetcher = (
  variables: CleanMetersQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<CleanMetersQuery, CleanMetersQueryVariables>(
    CleanMetersDocument,
    variables,
    options,
  )

export const SiteStatusCheckDocument = `
    query SiteStatusCheck($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    statusCheck {
      desc
      hint
      status
    }
  }
}
    `

export const useSiteStatusCheckQuery = <TData = SiteStatusCheckQuery, TError = unknown>(
  variables: SiteStatusCheckQueryVariables,
  options?: Omit<UseQueryOptions<SiteStatusCheckQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SiteStatusCheckQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteStatusCheckQuery, TError, TData>({
    queryKey: ["SiteStatusCheck", variables],
    queryFn: adminFetcher<SiteStatusCheckQuery, SiteStatusCheckQueryVariables>(
      SiteStatusCheckDocument,
      variables,
    ),
    ...options,
  })
}

useSiteStatusCheckQuery.getKey = (variables: SiteStatusCheckQueryVariables) => [
  "SiteStatusCheck",
  variables,
]

useSiteStatusCheckQuery.rootKey = "SiteStatusCheck"

export const useSuspenseSiteStatusCheckQuery = <
  TData = SiteStatusCheckQuery,
  TError = unknown,
>(
  variables: SiteStatusCheckQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteStatusCheckQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<SiteStatusCheckQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteStatusCheckQuery, TError, TData>({
    queryKey: ["SiteStatusCheckSuspense", variables],
    queryFn: adminFetcher<SiteStatusCheckQuery, SiteStatusCheckQueryVariables>(
      SiteStatusCheckDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteStatusCheckQuery.getKey = (variables: SiteStatusCheckQueryVariables) => [
  "SiteStatusCheckSuspense",
  variables,
]

useSuspenseSiteStatusCheckQuery.rootKey = "SiteStatusCheck"

export const useInfiniteSiteStatusCheckQuery = <
  TData = InfiniteData<SiteStatusCheckQuery>,
  TError = unknown,
>(
  variables: SiteStatusCheckQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SiteStatusCheckQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<SiteStatusCheckQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteStatusCheckQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteStatusCheck.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteStatusCheckQuery, SiteStatusCheckQueryVariables>(
            SiteStatusCheckDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteStatusCheckQuery.getKey = (variables: SiteStatusCheckQueryVariables) => [
  "SiteStatusCheck.infinite",
  variables,
]

useInfiniteSiteStatusCheckQuery.rootKey = "SiteStatusCheck.infinite"

export const useSuspenseInfiniteSiteStatusCheckQuery = <
  TData = InfiniteData<SiteStatusCheckQuery>,
  TError = unknown,
>(
  variables: SiteStatusCheckQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteStatusCheckQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteStatusCheckQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteStatusCheckQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteStatusCheck.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteStatusCheckQuery, SiteStatusCheckQueryVariables>(
            SiteStatusCheckDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteStatusCheckQuery.getKey = (
  variables: SiteStatusCheckQueryVariables,
) => ["SiteStatusCheck.infiniteSuspense", variables]

useSuspenseInfiniteSiteStatusCheckQuery.rootKey = "SiteStatusCheck.infinite"

useSiteStatusCheckQuery.fetcher = (
  variables: SiteStatusCheckQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SiteStatusCheckQuery, SiteStatusCheckQueryVariables>(
    SiteStatusCheckDocument,
    variables,
    options,
  )

export const FailuresDocument = `
    query Failures($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    failures {
      __typename
      ... on FinmodelFailure {
        id
        createdAt
        name
        message
        scenario {
          ...ScenarioRef
        }
      }
      ... on GuessTariffFailure {
        createdAt
        name
        message
      }
      ... on BuildingFootprintFailure {
        createdAt
        name
        message
      }
      ... on LoadEstimateFailure {
        createdAt: dateCreated
        errorClass
        errorMessage
      }
      ... on ParcelDataFailure {
        createdAt
        name
        message
      }
    }
  }
}
    ${ScenarioRefFragmentDoc}`

export const useFailuresQuery = <TData = FailuresQuery, TError = unknown>(
  variables: FailuresQueryVariables,
  options?: Omit<UseQueryOptions<FailuresQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<FailuresQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<FailuresQuery, TError, TData>({
    queryKey: ["Failures", variables],
    queryFn: adminFetcher<FailuresQuery, FailuresQueryVariables>(
      FailuresDocument,
      variables,
    ),
    ...options,
  })
}

useFailuresQuery.getKey = (variables: FailuresQueryVariables) => ["Failures", variables]

useFailuresQuery.rootKey = "Failures"

export const useSuspenseFailuresQuery = <TData = FailuresQuery, TError = unknown>(
  variables: FailuresQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<FailuresQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<FailuresQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<FailuresQuery, TError, TData>({
    queryKey: ["FailuresSuspense", variables],
    queryFn: adminFetcher<FailuresQuery, FailuresQueryVariables>(
      FailuresDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseFailuresQuery.getKey = (variables: FailuresQueryVariables) => [
  "FailuresSuspense",
  variables,
]

useSuspenseFailuresQuery.rootKey = "Failures"

export const useInfiniteFailuresQuery = <
  TData = InfiniteData<FailuresQuery>,
  TError = unknown,
>(
  variables: FailuresQueryVariables,
  options: Omit<UseInfiniteQueryOptions<FailuresQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<FailuresQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<FailuresQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["Failures.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<FailuresQuery, FailuresQueryVariables>(FailuresDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteFailuresQuery.getKey = (variables: FailuresQueryVariables) => [
  "Failures.infinite",
  variables,
]

useInfiniteFailuresQuery.rootKey = "Failures.infinite"

export const useSuspenseInfiniteFailuresQuery = <
  TData = InfiniteData<FailuresQuery>,
  TError = unknown,
>(
  variables: FailuresQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<FailuresQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<FailuresQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<FailuresQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["Failures.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<FailuresQuery, FailuresQueryVariables>(FailuresDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteFailuresQuery.getKey = (variables: FailuresQueryVariables) => [
  "Failures.infiniteSuspense",
  variables,
]

useSuspenseInfiniteFailuresQuery.rootKey = "Failures.infinite"

useFailuresQuery.fetcher = (
  variables: FailuresQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<FailuresQuery, FailuresQueryVariables>(
    FailuresDocument,
    variables,
    options,
  )

export const BillDocumentsDocument = `
    query BillDocuments($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    isMultifamily
    targetUtility {
      id
      name
      shortName
    }
    documentsV0 {
      id
      pid
      fileName
      dateCreated
      ownerEmail
      contentType
      tag
      downloadHref
      viewHref
    }
    billSuggestions {
      id
      document {
        pid
      }
    }
  }
}
    `

export const useBillDocumentsQuery = <TData = BillDocumentsQuery, TError = unknown>(
  variables: BillDocumentsQueryVariables,
  options?: Omit<UseQueryOptions<BillDocumentsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<BillDocumentsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<BillDocumentsQuery, TError, TData>({
    queryKey: ["BillDocuments", variables],
    queryFn: adminFetcher<BillDocumentsQuery, BillDocumentsQueryVariables>(
      BillDocumentsDocument,
      variables,
    ),
    ...options,
  })
}

useBillDocumentsQuery.getKey = (variables: BillDocumentsQueryVariables) => [
  "BillDocuments",
  variables,
]

useBillDocumentsQuery.rootKey = "BillDocuments"

export const useSuspenseBillDocumentsQuery = <
  TData = BillDocumentsQuery,
  TError = unknown,
>(
  variables: BillDocumentsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<BillDocumentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<BillDocumentsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<BillDocumentsQuery, TError, TData>({
    queryKey: ["BillDocumentsSuspense", variables],
    queryFn: adminFetcher<BillDocumentsQuery, BillDocumentsQueryVariables>(
      BillDocumentsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseBillDocumentsQuery.getKey = (variables: BillDocumentsQueryVariables) => [
  "BillDocumentsSuspense",
  variables,
]

useSuspenseBillDocumentsQuery.rootKey = "BillDocuments"

export const useInfiniteBillDocumentsQuery = <
  TData = InfiniteData<BillDocumentsQuery>,
  TError = unknown,
>(
  variables: BillDocumentsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<BillDocumentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<BillDocumentsQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<BillDocumentsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["BillDocuments.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<BillDocumentsQuery, BillDocumentsQueryVariables>(
            BillDocumentsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteBillDocumentsQuery.getKey = (variables: BillDocumentsQueryVariables) => [
  "BillDocuments.infinite",
  variables,
]

useInfiniteBillDocumentsQuery.rootKey = "BillDocuments.infinite"

export const useSuspenseInfiniteBillDocumentsQuery = <
  TData = InfiniteData<BillDocumentsQuery>,
  TError = unknown,
>(
  variables: BillDocumentsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<BillDocumentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      BillDocumentsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<BillDocumentsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["BillDocuments.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<BillDocumentsQuery, BillDocumentsQueryVariables>(
            BillDocumentsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteBillDocumentsQuery.getKey = (
  variables: BillDocumentsQueryVariables,
) => ["BillDocuments.infiniteSuspense", variables]

useSuspenseInfiniteBillDocumentsQuery.rootKey = "BillDocuments.infinite"

useBillDocumentsQuery.fetcher = (
  variables: BillDocumentsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<BillDocumentsQuery, BillDocumentsQueryVariables>(
    BillDocumentsDocument,
    variables,
    options,
  )

export const OrgsDocument = `
    query Orgs {
  orgs {
    pid
    name
  }
}
    `

export const useOrgsQuery = <TData = OrgsQuery, TError = unknown>(
  variables?: OrgsQueryVariables,
  options?: Omit<UseQueryOptions<OrgsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<OrgsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OrgsQuery, TError, TData>({
    queryKey: variables === undefined ? ["Orgs"] : ["Orgs", variables],
    queryFn: adminFetcher<OrgsQuery, OrgsQueryVariables>(OrgsDocument, variables),
    ...options,
  })
}

useOrgsQuery.getKey = (variables?: OrgsQueryVariables) =>
  variables === undefined ? ["Orgs"] : ["Orgs", variables]

useOrgsQuery.rootKey = "Orgs"

export const useSuspenseOrgsQuery = <TData = OrgsQuery, TError = unknown>(
  variables?: OrgsQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<OrgsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<OrgsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<OrgsQuery, TError, TData>({
    queryKey: variables === undefined ? ["OrgsSuspense"] : ["OrgsSuspense", variables],
    queryFn: adminFetcher<OrgsQuery, OrgsQueryVariables>(OrgsDocument, variables),
    ...options,
  })
}

useSuspenseOrgsQuery.getKey = (variables?: OrgsQueryVariables) =>
  variables === undefined ? ["OrgsSuspense"] : ["OrgsSuspense", variables]

useSuspenseOrgsQuery.rootKey = "Orgs"

export const useInfiniteOrgsQuery = <TData = InfiniteData<OrgsQuery>, TError = unknown>(
  variables: OrgsQueryVariables,
  options: Omit<UseInfiniteQueryOptions<OrgsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<OrgsQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<OrgsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["Orgs.infinite"]
            : ["Orgs.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<OrgsQuery, OrgsQueryVariables>(OrgsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOrgsQuery.getKey = (variables?: OrgsQueryVariables) =>
  variables === undefined ? ["Orgs.infinite"] : ["Orgs.infinite", variables]

useInfiniteOrgsQuery.rootKey = "Orgs.infinite"

export const useSuspenseInfiniteOrgsQuery = <
  TData = InfiniteData<OrgsQuery>,
  TError = unknown,
>(
  variables: OrgsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OrgsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<OrgsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OrgsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["Orgs.infiniteSuspense"]
            : ["Orgs.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<OrgsQuery, OrgsQueryVariables>(OrgsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOrgsQuery.getKey = (variables?: OrgsQueryVariables) =>
  variables === undefined
    ? ["Orgs.infiniteSuspense"]
    : ["Orgs.infiniteSuspense", variables]

useSuspenseInfiniteOrgsQuery.rootKey = "Orgs.infinite"

useOrgsQuery.fetcher = (
  variables?: OrgsQueryVariables,
  options?: RequestInit["headers"],
) => adminFetcher<OrgsQuery, OrgsQueryVariables>(OrgsDocument, variables, options)

export const OrgsDetailListDocument = `
    query OrgsDetailList {
  orgs {
    ...BasicOrgDetails
  }
  financierOrgs {
    ...BasicOrgDetails
  }
}
    ${BasicOrgDetailsFragmentDoc}`

export const useOrgsDetailListQuery = <TData = OrgsDetailListQuery, TError = unknown>(
  variables?: OrgsDetailListQueryVariables,
  options?: Omit<UseQueryOptions<OrgsDetailListQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<OrgsDetailListQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OrgsDetailListQuery, TError, TData>({
    queryKey:
      variables === undefined ? ["OrgsDetailList"] : ["OrgsDetailList", variables],
    queryFn: adminFetcher<OrgsDetailListQuery, OrgsDetailListQueryVariables>(
      OrgsDetailListDocument,
      variables,
    ),
    ...options,
  })
}

useOrgsDetailListQuery.getKey = (variables?: OrgsDetailListQueryVariables) =>
  variables === undefined ? ["OrgsDetailList"] : ["OrgsDetailList", variables]

useOrgsDetailListQuery.rootKey = "OrgsDetailList"

export const useSuspenseOrgsDetailListQuery = <
  TData = OrgsDetailListQuery,
  TError = unknown,
>(
  variables?: OrgsDetailListQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<OrgsDetailListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<OrgsDetailListQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<OrgsDetailListQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["OrgsDetailListSuspense"]
        : ["OrgsDetailListSuspense", variables],
    queryFn: adminFetcher<OrgsDetailListQuery, OrgsDetailListQueryVariables>(
      OrgsDetailListDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseOrgsDetailListQuery.getKey = (variables?: OrgsDetailListQueryVariables) =>
  variables === undefined
    ? ["OrgsDetailListSuspense"]
    : ["OrgsDetailListSuspense", variables]

useSuspenseOrgsDetailListQuery.rootKey = "OrgsDetailList"

export const useInfiniteOrgsDetailListQuery = <
  TData = InfiniteData<OrgsDetailListQuery>,
  TError = unknown,
>(
  variables: OrgsDetailListQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<OrgsDetailListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<OrgsDetailListQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<OrgsDetailListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["OrgsDetailList.infinite"]
            : ["OrgsDetailList.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<OrgsDetailListQuery, OrgsDetailListQueryVariables>(
            OrgsDetailListDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOrgsDetailListQuery.getKey = (variables?: OrgsDetailListQueryVariables) =>
  variables === undefined
    ? ["OrgsDetailList.infinite"]
    : ["OrgsDetailList.infinite", variables]

useInfiniteOrgsDetailListQuery.rootKey = "OrgsDetailList.infinite"

export const useSuspenseInfiniteOrgsDetailListQuery = <
  TData = InfiniteData<OrgsDetailListQuery>,
  TError = unknown,
>(
  variables: OrgsDetailListQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OrgsDetailListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      OrgsDetailListQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OrgsDetailListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["OrgsDetailList.infiniteSuspense"]
            : ["OrgsDetailList.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<OrgsDetailListQuery, OrgsDetailListQueryVariables>(
            OrgsDetailListDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOrgsDetailListQuery.getKey = (
  variables?: OrgsDetailListQueryVariables,
) =>
  variables === undefined
    ? ["OrgsDetailList.infiniteSuspense"]
    : ["OrgsDetailList.infiniteSuspense", variables]

useSuspenseInfiniteOrgsDetailListQuery.rootKey = "OrgsDetailList.infinite"

useOrgsDetailListQuery.fetcher = (
  variables?: OrgsDetailListQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<OrgsDetailListQuery, OrgsDetailListQueryVariables>(
    OrgsDetailListDocument,
    variables,
    options,
  )

export const SiteIraIncentiveDataDocument = `
    query SiteIraIncentiveData($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    isLowIncomeCommunity
    isEnergyCommunity
  }
}
    `

export const useSiteIraIncentiveDataQuery = <
  TData = SiteIraIncentiveDataQuery,
  TError = unknown,
>(
  variables: SiteIraIncentiveDataQueryVariables,
  options?: Omit<
    UseQueryOptions<SiteIraIncentiveDataQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<SiteIraIncentiveDataQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteIraIncentiveDataQuery, TError, TData>({
    queryKey: ["SiteIraIncentiveData", variables],
    queryFn: adminFetcher<
      SiteIraIncentiveDataQuery,
      SiteIraIncentiveDataQueryVariables
    >(SiteIraIncentiveDataDocument, variables),
    ...options,
  })
}

useSiteIraIncentiveDataQuery.getKey = (
  variables: SiteIraIncentiveDataQueryVariables,
) => ["SiteIraIncentiveData", variables]

useSiteIraIncentiveDataQuery.rootKey = "SiteIraIncentiveData"

export const useSuspenseSiteIraIncentiveDataQuery = <
  TData = SiteIraIncentiveDataQuery,
  TError = unknown,
>(
  variables: SiteIraIncentiveDataQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteIraIncentiveDataQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      SiteIraIncentiveDataQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteIraIncentiveDataQuery, TError, TData>({
    queryKey: ["SiteIraIncentiveDataSuspense", variables],
    queryFn: adminFetcher<
      SiteIraIncentiveDataQuery,
      SiteIraIncentiveDataQueryVariables
    >(SiteIraIncentiveDataDocument, variables),
    ...options,
  })
}

useSuspenseSiteIraIncentiveDataQuery.getKey = (
  variables: SiteIraIncentiveDataQueryVariables,
) => ["SiteIraIncentiveDataSuspense", variables]

useSuspenseSiteIraIncentiveDataQuery.rootKey = "SiteIraIncentiveData"

export const useInfiniteSiteIraIncentiveDataQuery = <
  TData = InfiniteData<SiteIraIncentiveDataQuery>,
  TError = unknown,
>(
  variables: SiteIraIncentiveDataQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SiteIraIncentiveDataQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      SiteIraIncentiveDataQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteIraIncentiveDataQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteIraIncentiveData.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteIraIncentiveDataQuery, SiteIraIncentiveDataQueryVariables>(
            SiteIraIncentiveDataDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteIraIncentiveDataQuery.getKey = (
  variables: SiteIraIncentiveDataQueryVariables,
) => ["SiteIraIncentiveData.infinite", variables]

useInfiniteSiteIraIncentiveDataQuery.rootKey = "SiteIraIncentiveData.infinite"

export const useSuspenseInfiniteSiteIraIncentiveDataQuery = <
  TData = InfiniteData<SiteIraIncentiveDataQuery>,
  TError = unknown,
>(
  variables: SiteIraIncentiveDataQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteIraIncentiveDataQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteIraIncentiveDataQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteIraIncentiveDataQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "SiteIraIncentiveData.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<SiteIraIncentiveDataQuery, SiteIraIncentiveDataQueryVariables>(
            SiteIraIncentiveDataDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteIraIncentiveDataQuery.getKey = (
  variables: SiteIraIncentiveDataQueryVariables,
) => ["SiteIraIncentiveData.infiniteSuspense", variables]

useSuspenseInfiniteSiteIraIncentiveDataQuery.rootKey = "SiteIraIncentiveData.infinite"

useSiteIraIncentiveDataQuery.fetcher = (
  variables: SiteIraIncentiveDataQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SiteIraIncentiveDataQuery, SiteIraIncentiveDataQueryVariables>(
    SiteIraIncentiveDataDocument,
    variables,
    options,
  )

export const SiteLeaseTypeDocument = `
    query SiteLeaseType($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    leaseType
  }
}
    `

export const useSiteLeaseTypeQuery = <TData = SiteLeaseTypeQuery, TError = unknown>(
  variables: SiteLeaseTypeQueryVariables,
  options?: Omit<UseQueryOptions<SiteLeaseTypeQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SiteLeaseTypeQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteLeaseTypeQuery, TError, TData>({
    queryKey: ["SiteLeaseType", variables],
    queryFn: adminFetcher<SiteLeaseTypeQuery, SiteLeaseTypeQueryVariables>(
      SiteLeaseTypeDocument,
      variables,
    ),
    ...options,
  })
}

useSiteLeaseTypeQuery.getKey = (variables: SiteLeaseTypeQueryVariables) => [
  "SiteLeaseType",
  variables,
]

useSiteLeaseTypeQuery.rootKey = "SiteLeaseType"

export const useSuspenseSiteLeaseTypeQuery = <
  TData = SiteLeaseTypeQuery,
  TError = unknown,
>(
  variables: SiteLeaseTypeQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteLeaseTypeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<SiteLeaseTypeQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteLeaseTypeQuery, TError, TData>({
    queryKey: ["SiteLeaseTypeSuspense", variables],
    queryFn: adminFetcher<SiteLeaseTypeQuery, SiteLeaseTypeQueryVariables>(
      SiteLeaseTypeDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteLeaseTypeQuery.getKey = (variables: SiteLeaseTypeQueryVariables) => [
  "SiteLeaseTypeSuspense",
  variables,
]

useSuspenseSiteLeaseTypeQuery.rootKey = "SiteLeaseType"

export const useInfiniteSiteLeaseTypeQuery = <
  TData = InfiniteData<SiteLeaseTypeQuery>,
  TError = unknown,
>(
  variables: SiteLeaseTypeQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SiteLeaseTypeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<SiteLeaseTypeQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteLeaseTypeQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteLeaseType.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteLeaseTypeQuery, SiteLeaseTypeQueryVariables>(
            SiteLeaseTypeDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteLeaseTypeQuery.getKey = (variables: SiteLeaseTypeQueryVariables) => [
  "SiteLeaseType.infinite",
  variables,
]

useInfiniteSiteLeaseTypeQuery.rootKey = "SiteLeaseType.infinite"

export const useSuspenseInfiniteSiteLeaseTypeQuery = <
  TData = InfiniteData<SiteLeaseTypeQuery>,
  TError = unknown,
>(
  variables: SiteLeaseTypeQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteLeaseTypeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteLeaseTypeQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteLeaseTypeQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteLeaseType.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteLeaseTypeQuery, SiteLeaseTypeQueryVariables>(
            SiteLeaseTypeDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteLeaseTypeQuery.getKey = (
  variables: SiteLeaseTypeQueryVariables,
) => ["SiteLeaseType.infiniteSuspense", variables]

useSuspenseInfiniteSiteLeaseTypeQuery.rootKey = "SiteLeaseType.infinite"

useSiteLeaseTypeQuery.fetcher = (
  variables: SiteLeaseTypeQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SiteLeaseTypeQuery, SiteLeaseTypeQueryVariables>(
    SiteLeaseTypeDocument,
    variables,
    options,
  )

export const SiteOccupancyTypeDocument = `
    query SiteOccupancyType($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    occupancyType
  }
}
    `

export const useSiteOccupancyTypeQuery = <
  TData = SiteOccupancyTypeQuery,
  TError = unknown,
>(
  variables: SiteOccupancyTypeQueryVariables,
  options?: Omit<UseQueryOptions<SiteOccupancyTypeQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SiteOccupancyTypeQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteOccupancyTypeQuery, TError, TData>({
    queryKey: ["SiteOccupancyType", variables],
    queryFn: adminFetcher<SiteOccupancyTypeQuery, SiteOccupancyTypeQueryVariables>(
      SiteOccupancyTypeDocument,
      variables,
    ),
    ...options,
  })
}

useSiteOccupancyTypeQuery.getKey = (variables: SiteOccupancyTypeQueryVariables) => [
  "SiteOccupancyType",
  variables,
]

useSiteOccupancyTypeQuery.rootKey = "SiteOccupancyType"

export const useSuspenseSiteOccupancyTypeQuery = <
  TData = SiteOccupancyTypeQuery,
  TError = unknown,
>(
  variables: SiteOccupancyTypeQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteOccupancyTypeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      SiteOccupancyTypeQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteOccupancyTypeQuery, TError, TData>({
    queryKey: ["SiteOccupancyTypeSuspense", variables],
    queryFn: adminFetcher<SiteOccupancyTypeQuery, SiteOccupancyTypeQueryVariables>(
      SiteOccupancyTypeDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteOccupancyTypeQuery.getKey = (
  variables: SiteOccupancyTypeQueryVariables,
) => ["SiteOccupancyTypeSuspense", variables]

useSuspenseSiteOccupancyTypeQuery.rootKey = "SiteOccupancyType"

export const useInfiniteSiteOccupancyTypeQuery = <
  TData = InfiniteData<SiteOccupancyTypeQuery>,
  TError = unknown,
>(
  variables: SiteOccupancyTypeQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SiteOccupancyTypeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      SiteOccupancyTypeQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteOccupancyTypeQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteOccupancyType.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteOccupancyTypeQuery, SiteOccupancyTypeQueryVariables>(
            SiteOccupancyTypeDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteOccupancyTypeQuery.getKey = (
  variables: SiteOccupancyTypeQueryVariables,
) => ["SiteOccupancyType.infinite", variables]

useInfiniteSiteOccupancyTypeQuery.rootKey = "SiteOccupancyType.infinite"

export const useSuspenseInfiniteSiteOccupancyTypeQuery = <
  TData = InfiniteData<SiteOccupancyTypeQuery>,
  TError = unknown,
>(
  variables: SiteOccupancyTypeQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteOccupancyTypeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteOccupancyTypeQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteOccupancyTypeQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteOccupancyType.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteOccupancyTypeQuery, SiteOccupancyTypeQueryVariables>(
            SiteOccupancyTypeDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteOccupancyTypeQuery.getKey = (
  variables: SiteOccupancyTypeQueryVariables,
) => ["SiteOccupancyType.infiniteSuspense", variables]

useSuspenseInfiniteSiteOccupancyTypeQuery.rootKey = "SiteOccupancyType.infinite"

useSiteOccupancyTypeQuery.fetcher = (
  variables: SiteOccupancyTypeQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SiteOccupancyTypeQuery, SiteOccupancyTypeQueryVariables>(
    SiteOccupancyTypeDocument,
    variables,
    options,
  )

export const OrgDetailDocument = `
    query OrgDetail($orgPid: String!) {
  org(orgPid: $orgPid) {
    ...BasicOrgDetails
    portfolios {
      pid
      title
    }
    allowedEmailDomains
    labels {
      pid
      name
      themeColor
    }
    financing {
      ...FinRel
    }
    finproducts {
      __typename
      financier {
        pid
        name
      }
      id
      createdAt
      name
      type
      activeOverrides {
        ...Override
      }
      targetOrg {
        pid
        name
      }
      targetSite {
        pid
        name
        streetAddress
      }
      disabledAt
      includeStorage
      status
      csPrices {
        utility {
          name
          id
          shortName
        }
        state
        usdPerKwPerYear
        escalator
        termYears
        minPvKw
        maxPvKw
        pvType
      }
    }
  }
}
    ${BasicOrgDetailsFragmentDoc}
${FinRelFragmentDoc}
${OverrideFragmentDoc}`

export const useOrgDetailQuery = <TData = OrgDetailQuery, TError = unknown>(
  variables: OrgDetailQueryVariables,
  options?: Omit<UseQueryOptions<OrgDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<OrgDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OrgDetailQuery, TError, TData>({
    queryKey: ["OrgDetail", variables],
    queryFn: adminFetcher<OrgDetailQuery, OrgDetailQueryVariables>(
      OrgDetailDocument,
      variables,
    ),
    ...options,
  })
}

useOrgDetailQuery.getKey = (variables: OrgDetailQueryVariables) => [
  "OrgDetail",
  variables,
]

useOrgDetailQuery.rootKey = "OrgDetail"

export const useSuspenseOrgDetailQuery = <TData = OrgDetailQuery, TError = unknown>(
  variables: OrgDetailQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<OrgDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<OrgDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<OrgDetailQuery, TError, TData>({
    queryKey: ["OrgDetailSuspense", variables],
    queryFn: adminFetcher<OrgDetailQuery, OrgDetailQueryVariables>(
      OrgDetailDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseOrgDetailQuery.getKey = (variables: OrgDetailQueryVariables) => [
  "OrgDetailSuspense",
  variables,
]

useSuspenseOrgDetailQuery.rootKey = "OrgDetail"

export const useInfiniteOrgDetailQuery = <
  TData = InfiniteData<OrgDetailQuery>,
  TError = unknown,
>(
  variables: OrgDetailQueryVariables,
  options: Omit<UseInfiniteQueryOptions<OrgDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<OrgDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<OrgDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgDetail.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<OrgDetailQuery, OrgDetailQueryVariables>(OrgDetailDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOrgDetailQuery.getKey = (variables: OrgDetailQueryVariables) => [
  "OrgDetail.infinite",
  variables,
]

useInfiniteOrgDetailQuery.rootKey = "OrgDetail.infinite"

export const useSuspenseInfiniteOrgDetailQuery = <
  TData = InfiniteData<OrgDetailQuery>,
  TError = unknown,
>(
  variables: OrgDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OrgDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      OrgDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OrgDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgDetail.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<OrgDetailQuery, OrgDetailQueryVariables>(OrgDetailDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOrgDetailQuery.getKey = (variables: OrgDetailQueryVariables) => [
  "OrgDetail.infiniteSuspense",
  variables,
]

useSuspenseInfiniteOrgDetailQuery.rootKey = "OrgDetail.infinite"

useOrgDetailQuery.fetcher = (
  variables: OrgDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<OrgDetailQuery, OrgDetailQueryVariables>(
    OrgDetailDocument,
    variables,
    options,
  )

export const OrgUsersDocument = `
    query OrgUsers($orgPid: String!) {
  org(orgPid: $orgPid) {
    pid
    name
    logoUrl
    logomarkUrl
    users {
      ...UserListUser
    }
  }
}
    ${UserListUserFragmentDoc}`

export const useOrgUsersQuery = <TData = OrgUsersQuery, TError = unknown>(
  variables: OrgUsersQueryVariables,
  options?: Omit<UseQueryOptions<OrgUsersQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<OrgUsersQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OrgUsersQuery, TError, TData>({
    queryKey: ["OrgUsers", variables],
    queryFn: adminFetcher<OrgUsersQuery, OrgUsersQueryVariables>(
      OrgUsersDocument,
      variables,
    ),
    ...options,
  })
}

useOrgUsersQuery.getKey = (variables: OrgUsersQueryVariables) => ["OrgUsers", variables]

useOrgUsersQuery.rootKey = "OrgUsers"

export const useSuspenseOrgUsersQuery = <TData = OrgUsersQuery, TError = unknown>(
  variables: OrgUsersQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<OrgUsersQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<OrgUsersQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<OrgUsersQuery, TError, TData>({
    queryKey: ["OrgUsersSuspense", variables],
    queryFn: adminFetcher<OrgUsersQuery, OrgUsersQueryVariables>(
      OrgUsersDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseOrgUsersQuery.getKey = (variables: OrgUsersQueryVariables) => [
  "OrgUsersSuspense",
  variables,
]

useSuspenseOrgUsersQuery.rootKey = "OrgUsers"

export const useInfiniteOrgUsersQuery = <
  TData = InfiniteData<OrgUsersQuery>,
  TError = unknown,
>(
  variables: OrgUsersQueryVariables,
  options: Omit<UseInfiniteQueryOptions<OrgUsersQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<OrgUsersQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<OrgUsersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgUsers.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<OrgUsersQuery, OrgUsersQueryVariables>(OrgUsersDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOrgUsersQuery.getKey = (variables: OrgUsersQueryVariables) => [
  "OrgUsers.infinite",
  variables,
]

useInfiniteOrgUsersQuery.rootKey = "OrgUsers.infinite"

export const useSuspenseInfiniteOrgUsersQuery = <
  TData = InfiniteData<OrgUsersQuery>,
  TError = unknown,
>(
  variables: OrgUsersQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OrgUsersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<OrgUsersQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OrgUsersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgUsers.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<OrgUsersQuery, OrgUsersQueryVariables>(OrgUsersDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOrgUsersQuery.getKey = (variables: OrgUsersQueryVariables) => [
  "OrgUsers.infiniteSuspense",
  variables,
]

useSuspenseInfiniteOrgUsersQuery.rootKey = "OrgUsers.infinite"

useOrgUsersQuery.fetcher = (
  variables: OrgUsersQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<OrgUsersQuery, OrgUsersQueryVariables>(
    OrgUsersDocument,
    variables,
    options,
  )

export const FinmodelFailureIndexDocument = `
    query FinmodelFailureIndex {
  finmodelFailureIndex {
    fmv
    name
    failureCount
  }
}
    `

export const useFinmodelFailureIndexQuery = <
  TData = FinmodelFailureIndexQuery,
  TError = unknown,
>(
  variables?: FinmodelFailureIndexQueryVariables,
  options?: Omit<
    UseQueryOptions<FinmodelFailureIndexQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<FinmodelFailureIndexQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<FinmodelFailureIndexQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["FinmodelFailureIndex"]
        : ["FinmodelFailureIndex", variables],
    queryFn: adminFetcher<
      FinmodelFailureIndexQuery,
      FinmodelFailureIndexQueryVariables
    >(FinmodelFailureIndexDocument, variables),
    ...options,
  })
}

useFinmodelFailureIndexQuery.getKey = (
  variables?: FinmodelFailureIndexQueryVariables,
) =>
  variables === undefined
    ? ["FinmodelFailureIndex"]
    : ["FinmodelFailureIndex", variables]

useFinmodelFailureIndexQuery.rootKey = "FinmodelFailureIndex"

export const useSuspenseFinmodelFailureIndexQuery = <
  TData = FinmodelFailureIndexQuery,
  TError = unknown,
>(
  variables?: FinmodelFailureIndexQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<FinmodelFailureIndexQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      FinmodelFailureIndexQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<FinmodelFailureIndexQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["FinmodelFailureIndexSuspense"]
        : ["FinmodelFailureIndexSuspense", variables],
    queryFn: adminFetcher<
      FinmodelFailureIndexQuery,
      FinmodelFailureIndexQueryVariables
    >(FinmodelFailureIndexDocument, variables),
    ...options,
  })
}

useSuspenseFinmodelFailureIndexQuery.getKey = (
  variables?: FinmodelFailureIndexQueryVariables,
) =>
  variables === undefined
    ? ["FinmodelFailureIndexSuspense"]
    : ["FinmodelFailureIndexSuspense", variables]

useSuspenseFinmodelFailureIndexQuery.rootKey = "FinmodelFailureIndex"

export const useInfiniteFinmodelFailureIndexQuery = <
  TData = InfiniteData<FinmodelFailureIndexQuery>,
  TError = unknown,
>(
  variables: FinmodelFailureIndexQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<FinmodelFailureIndexQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      FinmodelFailureIndexQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<FinmodelFailureIndexQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["FinmodelFailureIndex.infinite"]
            : ["FinmodelFailureIndex.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<FinmodelFailureIndexQuery, FinmodelFailureIndexQueryVariables>(
            FinmodelFailureIndexDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteFinmodelFailureIndexQuery.getKey = (
  variables?: FinmodelFailureIndexQueryVariables,
) =>
  variables === undefined
    ? ["FinmodelFailureIndex.infinite"]
    : ["FinmodelFailureIndex.infinite", variables]

useInfiniteFinmodelFailureIndexQuery.rootKey = "FinmodelFailureIndex.infinite"

export const useSuspenseInfiniteFinmodelFailureIndexQuery = <
  TData = InfiniteData<FinmodelFailureIndexQuery>,
  TError = unknown,
>(
  variables: FinmodelFailureIndexQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<FinmodelFailureIndexQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      FinmodelFailureIndexQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<FinmodelFailureIndexQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["FinmodelFailureIndex.infiniteSuspense"]
            : ["FinmodelFailureIndex.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<FinmodelFailureIndexQuery, FinmodelFailureIndexQueryVariables>(
            FinmodelFailureIndexDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteFinmodelFailureIndexQuery.getKey = (
  variables?: FinmodelFailureIndexQueryVariables,
) =>
  variables === undefined
    ? ["FinmodelFailureIndex.infiniteSuspense"]
    : ["FinmodelFailureIndex.infiniteSuspense", variables]

useSuspenseInfiniteFinmodelFailureIndexQuery.rootKey = "FinmodelFailureIndex.infinite"

useFinmodelFailureIndexQuery.fetcher = (
  variables?: FinmodelFailureIndexQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<FinmodelFailureIndexQuery, FinmodelFailureIndexQueryVariables>(
    FinmodelFailureIndexDocument,
    variables,
    options,
  )

export const FinmodelFailureViewDocument = `
    query FinmodelFailureView($filterBy: FinmodelFailureTableFilter!, $sortBy: [FinmodelFailureTableSort!]) {
  finmodelFailures {
    view(filterBy: $filterBy, sortBy: $sortBy) {
      count
      keys
    }
  }
}
    `

export const useFinmodelFailureViewQuery = <
  TData = FinmodelFailureViewQuery,
  TError = unknown,
>(
  variables: FinmodelFailureViewQueryVariables,
  options?: Omit<
    UseQueryOptions<FinmodelFailureViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<FinmodelFailureViewQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<FinmodelFailureViewQuery, TError, TData>({
    queryKey: ["FinmodelFailureView", variables],
    queryFn: adminFetcher<FinmodelFailureViewQuery, FinmodelFailureViewQueryVariables>(
      FinmodelFailureViewDocument,
      variables,
    ),
    ...options,
  })
}

useFinmodelFailureViewQuery.getKey = (variables: FinmodelFailureViewQueryVariables) => [
  "FinmodelFailureView",
  variables,
]

useFinmodelFailureViewQuery.rootKey = "FinmodelFailureView"

export const useSuspenseFinmodelFailureViewQuery = <
  TData = FinmodelFailureViewQuery,
  TError = unknown,
>(
  variables: FinmodelFailureViewQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<FinmodelFailureViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      FinmodelFailureViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<FinmodelFailureViewQuery, TError, TData>({
    queryKey: ["FinmodelFailureViewSuspense", variables],
    queryFn: adminFetcher<FinmodelFailureViewQuery, FinmodelFailureViewQueryVariables>(
      FinmodelFailureViewDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseFinmodelFailureViewQuery.getKey = (
  variables: FinmodelFailureViewQueryVariables,
) => ["FinmodelFailureViewSuspense", variables]

useSuspenseFinmodelFailureViewQuery.rootKey = "FinmodelFailureView"

export const useInfiniteFinmodelFailureViewQuery = <
  TData = InfiniteData<FinmodelFailureViewQuery>,
  TError = unknown,
>(
  variables: FinmodelFailureViewQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<FinmodelFailureViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      FinmodelFailureViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<FinmodelFailureViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["FinmodelFailureView.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<FinmodelFailureViewQuery, FinmodelFailureViewQueryVariables>(
            FinmodelFailureViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteFinmodelFailureViewQuery.getKey = (
  variables: FinmodelFailureViewQueryVariables,
) => ["FinmodelFailureView.infinite", variables]

useInfiniteFinmodelFailureViewQuery.rootKey = "FinmodelFailureView.infinite"

export const useSuspenseInfiniteFinmodelFailureViewQuery = <
  TData = InfiniteData<FinmodelFailureViewQuery>,
  TError = unknown,
>(
  variables: FinmodelFailureViewQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<FinmodelFailureViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      FinmodelFailureViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<FinmodelFailureViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "FinmodelFailureView.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<FinmodelFailureViewQuery, FinmodelFailureViewQueryVariables>(
            FinmodelFailureViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteFinmodelFailureViewQuery.getKey = (
  variables: FinmodelFailureViewQueryVariables,
) => ["FinmodelFailureView.infiniteSuspense", variables]

useSuspenseInfiniteFinmodelFailureViewQuery.rootKey = "FinmodelFailureView.infinite"

useFinmodelFailureViewQuery.fetcher = (
  variables: FinmodelFailureViewQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<FinmodelFailureViewQuery, FinmodelFailureViewQueryVariables>(
    FinmodelFailureViewDocument,
    variables,
    options,
  )

export const FinmodelFailureRowDocument = `
    query FinmodelFailureRow($keys: [Int!]!) {
  finmodelFailures {
    rows(keys: $keys) {
      id
      createdAt
      fmv
      name
      message
    }
  }
}
    `

export const useFinmodelFailureRowQuery = <
  TData = FinmodelFailureRowQuery,
  TError = unknown,
>(
  variables: FinmodelFailureRowQueryVariables,
  options?: Omit<
    UseQueryOptions<FinmodelFailureRowQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<FinmodelFailureRowQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<FinmodelFailureRowQuery, TError, TData>({
    queryKey: ["FinmodelFailureRow", variables],
    queryFn: adminFetcher<FinmodelFailureRowQuery, FinmodelFailureRowQueryVariables>(
      FinmodelFailureRowDocument,
      variables,
    ),
    ...options,
  })
}

useFinmodelFailureRowQuery.getKey = (variables: FinmodelFailureRowQueryVariables) => [
  "FinmodelFailureRow",
  variables,
]

useFinmodelFailureRowQuery.rootKey = "FinmodelFailureRow"

export const useSuspenseFinmodelFailureRowQuery = <
  TData = FinmodelFailureRowQuery,
  TError = unknown,
>(
  variables: FinmodelFailureRowQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<FinmodelFailureRowQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      FinmodelFailureRowQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<FinmodelFailureRowQuery, TError, TData>({
    queryKey: ["FinmodelFailureRowSuspense", variables],
    queryFn: adminFetcher<FinmodelFailureRowQuery, FinmodelFailureRowQueryVariables>(
      FinmodelFailureRowDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseFinmodelFailureRowQuery.getKey = (
  variables: FinmodelFailureRowQueryVariables,
) => ["FinmodelFailureRowSuspense", variables]

useSuspenseFinmodelFailureRowQuery.rootKey = "FinmodelFailureRow"

export const useInfiniteFinmodelFailureRowQuery = <
  TData = InfiniteData<FinmodelFailureRowQuery>,
  TError = unknown,
>(
  variables: FinmodelFailureRowQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<FinmodelFailureRowQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      FinmodelFailureRowQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<FinmodelFailureRowQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["FinmodelFailureRow.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<FinmodelFailureRowQuery, FinmodelFailureRowQueryVariables>(
            FinmodelFailureRowDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteFinmodelFailureRowQuery.getKey = (
  variables: FinmodelFailureRowQueryVariables,
) => ["FinmodelFailureRow.infinite", variables]

useInfiniteFinmodelFailureRowQuery.rootKey = "FinmodelFailureRow.infinite"

export const useSuspenseInfiniteFinmodelFailureRowQuery = <
  TData = InfiniteData<FinmodelFailureRowQuery>,
  TError = unknown,
>(
  variables: FinmodelFailureRowQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<FinmodelFailureRowQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      FinmodelFailureRowQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<FinmodelFailureRowQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["FinmodelFailureRow.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<FinmodelFailureRowQuery, FinmodelFailureRowQueryVariables>(
            FinmodelFailureRowDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteFinmodelFailureRowQuery.getKey = (
  variables: FinmodelFailureRowQueryVariables,
) => ["FinmodelFailureRow.infiniteSuspense", variables]

useSuspenseInfiniteFinmodelFailureRowQuery.rootKey = "FinmodelFailureRow.infinite"

useFinmodelFailureRowQuery.fetcher = (
  variables: FinmodelFailureRowQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<FinmodelFailureRowQuery, FinmodelFailureRowQueryVariables>(
    FinmodelFailureRowDocument,
    variables,
    options,
  )

export const FinmodelFailureDetailDocument = `
    query FinmodelFailureDetail($id: Int!) {
  finmodelFailure(id: $id) {
    ...FinmodelFailureDetail
    finmodel {
      id
      fmvStr
    }
  }
}
    ${FinmodelFailureDetailFragmentDoc}
${SiteRefFragmentDoc}
${ScenarioRefFragmentDoc}
${FinmodelSourceFragmentFragmentDoc}`

export const useFinmodelFailureDetailQuery = <
  TData = FinmodelFailureDetailQuery,
  TError = unknown,
>(
  variables: FinmodelFailureDetailQueryVariables,
  options?: Omit<
    UseQueryOptions<FinmodelFailureDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<FinmodelFailureDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<FinmodelFailureDetailQuery, TError, TData>({
    queryKey: ["FinmodelFailureDetail", variables],
    queryFn: adminFetcher<
      FinmodelFailureDetailQuery,
      FinmodelFailureDetailQueryVariables
    >(FinmodelFailureDetailDocument, variables),
    ...options,
  })
}

useFinmodelFailureDetailQuery.getKey = (
  variables: FinmodelFailureDetailQueryVariables,
) => ["FinmodelFailureDetail", variables]

useFinmodelFailureDetailQuery.rootKey = "FinmodelFailureDetail"

export const useSuspenseFinmodelFailureDetailQuery = <
  TData = FinmodelFailureDetailQuery,
  TError = unknown,
>(
  variables: FinmodelFailureDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<FinmodelFailureDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      FinmodelFailureDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<FinmodelFailureDetailQuery, TError, TData>({
    queryKey: ["FinmodelFailureDetailSuspense", variables],
    queryFn: adminFetcher<
      FinmodelFailureDetailQuery,
      FinmodelFailureDetailQueryVariables
    >(FinmodelFailureDetailDocument, variables),
    ...options,
  })
}

useSuspenseFinmodelFailureDetailQuery.getKey = (
  variables: FinmodelFailureDetailQueryVariables,
) => ["FinmodelFailureDetailSuspense", variables]

useSuspenseFinmodelFailureDetailQuery.rootKey = "FinmodelFailureDetail"

export const useInfiniteFinmodelFailureDetailQuery = <
  TData = InfiniteData<FinmodelFailureDetailQuery>,
  TError = unknown,
>(
  variables: FinmodelFailureDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<FinmodelFailureDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      FinmodelFailureDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<FinmodelFailureDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["FinmodelFailureDetail.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<FinmodelFailureDetailQuery, FinmodelFailureDetailQueryVariables>(
            FinmodelFailureDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteFinmodelFailureDetailQuery.getKey = (
  variables: FinmodelFailureDetailQueryVariables,
) => ["FinmodelFailureDetail.infinite", variables]

useInfiniteFinmodelFailureDetailQuery.rootKey = "FinmodelFailureDetail.infinite"

export const useSuspenseInfiniteFinmodelFailureDetailQuery = <
  TData = InfiniteData<FinmodelFailureDetailQuery>,
  TError = unknown,
>(
  variables: FinmodelFailureDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<FinmodelFailureDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      FinmodelFailureDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<FinmodelFailureDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "FinmodelFailureDetail.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<FinmodelFailureDetailQuery, FinmodelFailureDetailQueryVariables>(
            FinmodelFailureDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteFinmodelFailureDetailQuery.getKey = (
  variables: FinmodelFailureDetailQueryVariables,
) => ["FinmodelFailureDetail.infiniteSuspense", variables]

useSuspenseInfiniteFinmodelFailureDetailQuery.rootKey = "FinmodelFailureDetail.infinite"

useFinmodelFailureDetailQuery.fetcher = (
  variables: FinmodelFailureDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<FinmodelFailureDetailQuery, FinmodelFailureDetailQueryVariables>(
    FinmodelFailureDetailDocument,
    variables,
    options,
  )

export const OpenInvitesDocument = `
    query OpenInvites($portfolioPid: String) {
  openInvites(portfolioPid: $portfolioPid) {
    id
    pid
    url
    expiresAt
    isExpired
    createdAt
    createdBy {
      pid
      name
      email
    }
    portfolio {
      pid
      title
    }
  }
  portfolios {
    pid
    title
  }
}
    `

export const useOpenInvitesQuery = <TData = OpenInvitesQuery, TError = unknown>(
  variables?: OpenInvitesQueryVariables,
  options?: Omit<UseQueryOptions<OpenInvitesQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<OpenInvitesQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OpenInvitesQuery, TError, TData>({
    queryKey: variables === undefined ? ["OpenInvites"] : ["OpenInvites", variables],
    queryFn: adminFetcher<OpenInvitesQuery, OpenInvitesQueryVariables>(
      OpenInvitesDocument,
      variables,
    ),
    ...options,
  })
}

useOpenInvitesQuery.getKey = (variables?: OpenInvitesQueryVariables) =>
  variables === undefined ? ["OpenInvites"] : ["OpenInvites", variables]

useOpenInvitesQuery.rootKey = "OpenInvites"

export const useSuspenseOpenInvitesQuery = <TData = OpenInvitesQuery, TError = unknown>(
  variables?: OpenInvitesQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<OpenInvitesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<OpenInvitesQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<OpenInvitesQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["OpenInvitesSuspense"]
        : ["OpenInvitesSuspense", variables],
    queryFn: adminFetcher<OpenInvitesQuery, OpenInvitesQueryVariables>(
      OpenInvitesDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseOpenInvitesQuery.getKey = (variables?: OpenInvitesQueryVariables) =>
  variables === undefined ? ["OpenInvitesSuspense"] : ["OpenInvitesSuspense", variables]

useSuspenseOpenInvitesQuery.rootKey = "OpenInvites"

export const useInfiniteOpenInvitesQuery = <
  TData = InfiniteData<OpenInvitesQuery>,
  TError = unknown,
>(
  variables: OpenInvitesQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<OpenInvitesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<OpenInvitesQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<OpenInvitesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["OpenInvites.infinite"]
            : ["OpenInvites.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<OpenInvitesQuery, OpenInvitesQueryVariables>(
            OpenInvitesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOpenInvitesQuery.getKey = (variables?: OpenInvitesQueryVariables) =>
  variables === undefined
    ? ["OpenInvites.infinite"]
    : ["OpenInvites.infinite", variables]

useInfiniteOpenInvitesQuery.rootKey = "OpenInvites.infinite"

export const useSuspenseInfiniteOpenInvitesQuery = <
  TData = InfiniteData<OpenInvitesQuery>,
  TError = unknown,
>(
  variables: OpenInvitesQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OpenInvitesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      OpenInvitesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OpenInvitesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["OpenInvites.infiniteSuspense"]
            : ["OpenInvites.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<OpenInvitesQuery, OpenInvitesQueryVariables>(
            OpenInvitesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOpenInvitesQuery.getKey = (variables?: OpenInvitesQueryVariables) =>
  variables === undefined
    ? ["OpenInvites.infiniteSuspense"]
    : ["OpenInvites.infiniteSuspense", variables]

useSuspenseInfiniteOpenInvitesQuery.rootKey = "OpenInvites.infinite"

useOpenInvitesQuery.fetcher = (
  variables?: OpenInvitesQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<OpenInvitesQuery, OpenInvitesQueryVariables>(
    OpenInvitesDocument,
    variables,
    options,
  )

export const SitePoliciesDocument = `
    query SitePolicies($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    state
    targetUtility {
      id
      name
      shortName
    }
    policies {
      ...PolicyListItem
    }
  }
}
    ${PolicyListItemFragmentDoc}
${RuleFragmentDoc}
${RuleValueFragmentDoc}
${PolicyConditionFragmentDoc}`

export const useSitePoliciesQuery = <TData = SitePoliciesQuery, TError = unknown>(
  variables: SitePoliciesQueryVariables,
  options?: Omit<UseQueryOptions<SitePoliciesQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SitePoliciesQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SitePoliciesQuery, TError, TData>({
    queryKey: ["SitePolicies", variables],
    queryFn: adminFetcher<SitePoliciesQuery, SitePoliciesQueryVariables>(
      SitePoliciesDocument,
      variables,
    ),
    ...options,
  })
}

useSitePoliciesQuery.getKey = (variables: SitePoliciesQueryVariables) => [
  "SitePolicies",
  variables,
]

useSitePoliciesQuery.rootKey = "SitePolicies"

export const useSuspenseSitePoliciesQuery = <
  TData = SitePoliciesQuery,
  TError = unknown,
>(
  variables: SitePoliciesQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SitePoliciesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<SitePoliciesQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<SitePoliciesQuery, TError, TData>({
    queryKey: ["SitePoliciesSuspense", variables],
    queryFn: adminFetcher<SitePoliciesQuery, SitePoliciesQueryVariables>(
      SitePoliciesDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSitePoliciesQuery.getKey = (variables: SitePoliciesQueryVariables) => [
  "SitePoliciesSuspense",
  variables,
]

useSuspenseSitePoliciesQuery.rootKey = "SitePolicies"

export const useInfiniteSitePoliciesQuery = <
  TData = InfiniteData<SitePoliciesQuery>,
  TError = unknown,
>(
  variables: SitePoliciesQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SitePoliciesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<SitePoliciesQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<SitePoliciesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SitePolicies.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<SitePoliciesQuery, SitePoliciesQueryVariables>(
            SitePoliciesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSitePoliciesQuery.getKey = (variables: SitePoliciesQueryVariables) => [
  "SitePolicies.infinite",
  variables,
]

useInfiniteSitePoliciesQuery.rootKey = "SitePolicies.infinite"

export const useSuspenseInfiniteSitePoliciesQuery = <
  TData = InfiniteData<SitePoliciesQuery>,
  TError = unknown,
>(
  variables: SitePoliciesQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SitePoliciesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SitePoliciesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SitePoliciesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SitePolicies.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<SitePoliciesQuery, SitePoliciesQueryVariables>(
            SitePoliciesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSitePoliciesQuery.getKey = (
  variables: SitePoliciesQueryVariables,
) => ["SitePolicies.infiniteSuspense", variables]

useSuspenseInfiniteSitePoliciesQuery.rootKey = "SitePolicies.infinite"

useSitePoliciesQuery.fetcher = (
  variables: SitePoliciesQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SitePoliciesQuery, SitePoliciesQueryVariables>(
    SitePoliciesDocument,
    variables,
    options,
  )

export const AllPoliciesDocument = `
    query AllPolicies {
  policies {
    all {
      ...PolicyListItem
    }
  }
}
    ${PolicyListItemFragmentDoc}
${RuleFragmentDoc}
${RuleValueFragmentDoc}
${PolicyConditionFragmentDoc}`

export const useAllPoliciesQuery = <TData = AllPoliciesQuery, TError = unknown>(
  variables?: AllPoliciesQueryVariables,
  options?: Omit<UseQueryOptions<AllPoliciesQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<AllPoliciesQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<AllPoliciesQuery, TError, TData>({
    queryKey: variables === undefined ? ["AllPolicies"] : ["AllPolicies", variables],
    queryFn: adminFetcher<AllPoliciesQuery, AllPoliciesQueryVariables>(
      AllPoliciesDocument,
      variables,
    ),
    ...options,
  })
}

useAllPoliciesQuery.getKey = (variables?: AllPoliciesQueryVariables) =>
  variables === undefined ? ["AllPolicies"] : ["AllPolicies", variables]

useAllPoliciesQuery.rootKey = "AllPolicies"

export const useSuspenseAllPoliciesQuery = <TData = AllPoliciesQuery, TError = unknown>(
  variables?: AllPoliciesQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<AllPoliciesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<AllPoliciesQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<AllPoliciesQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["AllPoliciesSuspense"]
        : ["AllPoliciesSuspense", variables],
    queryFn: adminFetcher<AllPoliciesQuery, AllPoliciesQueryVariables>(
      AllPoliciesDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseAllPoliciesQuery.getKey = (variables?: AllPoliciesQueryVariables) =>
  variables === undefined ? ["AllPoliciesSuspense"] : ["AllPoliciesSuspense", variables]

useSuspenseAllPoliciesQuery.rootKey = "AllPolicies"

export const useInfiniteAllPoliciesQuery = <
  TData = InfiniteData<AllPoliciesQuery>,
  TError = unknown,
>(
  variables: AllPoliciesQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<AllPoliciesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<AllPoliciesQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<AllPoliciesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["AllPolicies.infinite"]
            : ["AllPolicies.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<AllPoliciesQuery, AllPoliciesQueryVariables>(
            AllPoliciesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteAllPoliciesQuery.getKey = (variables?: AllPoliciesQueryVariables) =>
  variables === undefined
    ? ["AllPolicies.infinite"]
    : ["AllPolicies.infinite", variables]

useInfiniteAllPoliciesQuery.rootKey = "AllPolicies.infinite"

export const useSuspenseInfiniteAllPoliciesQuery = <
  TData = InfiniteData<AllPoliciesQuery>,
  TError = unknown,
>(
  variables: AllPoliciesQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<AllPoliciesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      AllPoliciesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<AllPoliciesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["AllPolicies.infiniteSuspense"]
            : ["AllPolicies.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<AllPoliciesQuery, AllPoliciesQueryVariables>(
            AllPoliciesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteAllPoliciesQuery.getKey = (variables?: AllPoliciesQueryVariables) =>
  variables === undefined
    ? ["AllPolicies.infiniteSuspense"]
    : ["AllPolicies.infiniteSuspense", variables]

useSuspenseInfiniteAllPoliciesQuery.rootKey = "AllPolicies.infinite"

useAllPoliciesQuery.fetcher = (
  variables?: AllPoliciesQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AllPoliciesQuery, AllPoliciesQueryVariables>(
    AllPoliciesDocument,
    variables,
    options,
  )

export const PolicyDetailDocument = `
    query PolicyDetail($policyPid: String!) {
  policies {
    policy(policyPid: $policyPid) {
      pid
      name
      userVisible
      description
      publicDescription
      status
      startDate
      endDate
      application {
        status
      }
      jurisdiction {
        scope
        name
      }
      rules {
        ...Rule
      }
      conditions {
        ...PolicyCondition
      }
      sources {
        text
        url
      }
    }
  }
}
    ${RuleFragmentDoc}
${RuleValueFragmentDoc}
${PolicyConditionFragmentDoc}`

export const usePolicyDetailQuery = <TData = PolicyDetailQuery, TError = unknown>(
  variables: PolicyDetailQueryVariables,
  options?: Omit<UseQueryOptions<PolicyDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<PolicyDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<PolicyDetailQuery, TError, TData>({
    queryKey: ["PolicyDetail", variables],
    queryFn: adminFetcher<PolicyDetailQuery, PolicyDetailQueryVariables>(
      PolicyDetailDocument,
      variables,
    ),
    ...options,
  })
}

usePolicyDetailQuery.getKey = (variables: PolicyDetailQueryVariables) => [
  "PolicyDetail",
  variables,
]

usePolicyDetailQuery.rootKey = "PolicyDetail"

export const useSuspensePolicyDetailQuery = <
  TData = PolicyDetailQuery,
  TError = unknown,
>(
  variables: PolicyDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<PolicyDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<PolicyDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<PolicyDetailQuery, TError, TData>({
    queryKey: ["PolicyDetailSuspense", variables],
    queryFn: adminFetcher<PolicyDetailQuery, PolicyDetailQueryVariables>(
      PolicyDetailDocument,
      variables,
    ),
    ...options,
  })
}

useSuspensePolicyDetailQuery.getKey = (variables: PolicyDetailQueryVariables) => [
  "PolicyDetailSuspense",
  variables,
]

useSuspensePolicyDetailQuery.rootKey = "PolicyDetail"

export const useInfinitePolicyDetailQuery = <
  TData = InfiniteData<PolicyDetailQuery>,
  TError = unknown,
>(
  variables: PolicyDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<PolicyDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<PolicyDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<PolicyDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["PolicyDetail.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<PolicyDetailQuery, PolicyDetailQueryVariables>(
            PolicyDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfinitePolicyDetailQuery.getKey = (variables: PolicyDetailQueryVariables) => [
  "PolicyDetail.infinite",
  variables,
]

useInfinitePolicyDetailQuery.rootKey = "PolicyDetail.infinite"

export const useSuspenseInfinitePolicyDetailQuery = <
  TData = InfiniteData<PolicyDetailQuery>,
  TError = unknown,
>(
  variables: PolicyDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<PolicyDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      PolicyDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<PolicyDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["PolicyDetail.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<PolicyDetailQuery, PolicyDetailQueryVariables>(
            PolicyDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfinitePolicyDetailQuery.getKey = (
  variables: PolicyDetailQueryVariables,
) => ["PolicyDetail.infiniteSuspense", variables]

useSuspenseInfinitePolicyDetailQuery.rootKey = "PolicyDetail.infinite"

usePolicyDetailQuery.fetcher = (
  variables: PolicyDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<PolicyDetailQuery, PolicyDetailQueryVariables>(
    PolicyDetailDocument,
    variables,
    options,
  )

export const SitePolicyViolationsDocument = `
    query SitePolicyViolations($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    policyViolations {
      policy {
        pid
        name
      }
      violatedRule {
        id
        description
        units
        value {
          ...RuleValue
        }
      }
      value {
        ...RuleValue
      }
    }
  }
}
    ${RuleValueFragmentDoc}`

export const useSitePolicyViolationsQuery = <
  TData = SitePolicyViolationsQuery,
  TError = unknown,
>(
  variables: SitePolicyViolationsQueryVariables,
  options?: Omit<
    UseQueryOptions<SitePolicyViolationsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<SitePolicyViolationsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SitePolicyViolationsQuery, TError, TData>({
    queryKey: ["SitePolicyViolations", variables],
    queryFn: adminFetcher<
      SitePolicyViolationsQuery,
      SitePolicyViolationsQueryVariables
    >(SitePolicyViolationsDocument, variables),
    ...options,
  })
}

useSitePolicyViolationsQuery.getKey = (
  variables: SitePolicyViolationsQueryVariables,
) => ["SitePolicyViolations", variables]

useSitePolicyViolationsQuery.rootKey = "SitePolicyViolations"

export const useSuspenseSitePolicyViolationsQuery = <
  TData = SitePolicyViolationsQuery,
  TError = unknown,
>(
  variables: SitePolicyViolationsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SitePolicyViolationsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      SitePolicyViolationsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<SitePolicyViolationsQuery, TError, TData>({
    queryKey: ["SitePolicyViolationsSuspense", variables],
    queryFn: adminFetcher<
      SitePolicyViolationsQuery,
      SitePolicyViolationsQueryVariables
    >(SitePolicyViolationsDocument, variables),
    ...options,
  })
}

useSuspenseSitePolicyViolationsQuery.getKey = (
  variables: SitePolicyViolationsQueryVariables,
) => ["SitePolicyViolationsSuspense", variables]

useSuspenseSitePolicyViolationsQuery.rootKey = "SitePolicyViolations"

export const useInfiniteSitePolicyViolationsQuery = <
  TData = InfiniteData<SitePolicyViolationsQuery>,
  TError = unknown,
>(
  variables: SitePolicyViolationsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SitePolicyViolationsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      SitePolicyViolationsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<SitePolicyViolationsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SitePolicyViolations.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<SitePolicyViolationsQuery, SitePolicyViolationsQueryVariables>(
            SitePolicyViolationsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSitePolicyViolationsQuery.getKey = (
  variables: SitePolicyViolationsQueryVariables,
) => ["SitePolicyViolations.infinite", variables]

useInfiniteSitePolicyViolationsQuery.rootKey = "SitePolicyViolations.infinite"

export const useSuspenseInfiniteSitePolicyViolationsQuery = <
  TData = InfiniteData<SitePolicyViolationsQuery>,
  TError = unknown,
>(
  variables: SitePolicyViolationsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SitePolicyViolationsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SitePolicyViolationsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SitePolicyViolationsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "SitePolicyViolations.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<SitePolicyViolationsQuery, SitePolicyViolationsQueryVariables>(
            SitePolicyViolationsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSitePolicyViolationsQuery.getKey = (
  variables: SitePolicyViolationsQueryVariables,
) => ["SitePolicyViolations.infiniteSuspense", variables]

useSuspenseInfiniteSitePolicyViolationsQuery.rootKey = "SitePolicyViolations.infinite"

useSitePolicyViolationsQuery.fetcher = (
  variables: SitePolicyViolationsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SitePolicyViolationsQuery, SitePolicyViolationsQueryVariables>(
    SitePolicyViolationsDocument,
    variables,
    options,
  )

export const MultiMeterDocument = `
    query MultiMeter($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    isMultifamily
    usingBillingMeters
    orgSlug
    bauMeters {
      ...BauMeter
      hasTruth
    }
    activeMeters {
      id
      createdAt
      createdBy {
        pid
        email
      }
      meters {
        ...BauMeter
      }
    }
    thirdPartySupplier {
      id
      name
    }
    targetUtility {
      id
      name
      shortName
    }
    targetUtilitySetBy {
      ...UserRef
    }
    dateTargetUtilitySet
    utilityName
    probableUtilities {
      id
      name
    }
    customTariffs {
      id
      name
      code
      parent {
        id
      }
    }
  }
}
    ${BauMeterFragmentDoc}
${BauTariffFragmentDoc}
${UserRefFragmentDoc}`

export const useMultiMeterQuery = <TData = MultiMeterQuery, TError = unknown>(
  variables: MultiMeterQueryVariables,
  options?: Omit<UseQueryOptions<MultiMeterQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<MultiMeterQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<MultiMeterQuery, TError, TData>({
    queryKey: ["MultiMeter", variables],
    queryFn: adminFetcher<MultiMeterQuery, MultiMeterQueryVariables>(
      MultiMeterDocument,
      variables,
    ),
    ...options,
  })
}

useMultiMeterQuery.getKey = (variables: MultiMeterQueryVariables) => [
  "MultiMeter",
  variables,
]

useMultiMeterQuery.rootKey = "MultiMeter"

export const useSuspenseMultiMeterQuery = <TData = MultiMeterQuery, TError = unknown>(
  variables: MultiMeterQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<MultiMeterQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<MultiMeterQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<MultiMeterQuery, TError, TData>({
    queryKey: ["MultiMeterSuspense", variables],
    queryFn: adminFetcher<MultiMeterQuery, MultiMeterQueryVariables>(
      MultiMeterDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseMultiMeterQuery.getKey = (variables: MultiMeterQueryVariables) => [
  "MultiMeterSuspense",
  variables,
]

useSuspenseMultiMeterQuery.rootKey = "MultiMeter"

export const useInfiniteMultiMeterQuery = <
  TData = InfiniteData<MultiMeterQuery>,
  TError = unknown,
>(
  variables: MultiMeterQueryVariables,
  options: Omit<UseInfiniteQueryOptions<MultiMeterQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<MultiMeterQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<MultiMeterQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MultiMeter.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<MultiMeterQuery, MultiMeterQueryVariables>(MultiMeterDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteMultiMeterQuery.getKey = (variables: MultiMeterQueryVariables) => [
  "MultiMeter.infinite",
  variables,
]

useInfiniteMultiMeterQuery.rootKey = "MultiMeter.infinite"

export const useSuspenseInfiniteMultiMeterQuery = <
  TData = InfiniteData<MultiMeterQuery>,
  TError = unknown,
>(
  variables: MultiMeterQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<MultiMeterQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      MultiMeterQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<MultiMeterQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MultiMeter.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<MultiMeterQuery, MultiMeterQueryVariables>(MultiMeterDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteMultiMeterQuery.getKey = (variables: MultiMeterQueryVariables) => [
  "MultiMeter.infiniteSuspense",
  variables,
]

useSuspenseInfiniteMultiMeterQuery.rootKey = "MultiMeter.infinite"

useMultiMeterQuery.fetcher = (
  variables: MultiMeterQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<MultiMeterQuery, MultiMeterQueryVariables>(
    MultiMeterDocument,
    variables,
    options,
  )

export const MultiMeterDetailDocument = `
    query MultiMeterDetail($id: Int!) {
  bauMeter(id: $id) {
    id
    formattedBill {
      ...FormattedBill
    }
    formattedPostBill {
      ...FormattedBill
    }
    tariff {
      name
      code
    }
    tariffUsdPerKwh
    postTariff {
      name
      code
    }
  }
}
    ${FormattedBillFragmentDoc}
${BillSectionFragmentDoc}
${DecodedRateFragmentDoc}
${CostOrTaxItemFragmentDoc}`

export const useMultiMeterDetailQuery = <
  TData = MultiMeterDetailQuery,
  TError = unknown,
>(
  variables: MultiMeterDetailQueryVariables,
  options?: Omit<UseQueryOptions<MultiMeterDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<MultiMeterDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<MultiMeterDetailQuery, TError, TData>({
    queryKey: ["MultiMeterDetail", variables],
    queryFn: adminFetcher<MultiMeterDetailQuery, MultiMeterDetailQueryVariables>(
      MultiMeterDetailDocument,
      variables,
    ),
    ...options,
  })
}

useMultiMeterDetailQuery.getKey = (variables: MultiMeterDetailQueryVariables) => [
  "MultiMeterDetail",
  variables,
]

useMultiMeterDetailQuery.rootKey = "MultiMeterDetail"

export const useSuspenseMultiMeterDetailQuery = <
  TData = MultiMeterDetailQuery,
  TError = unknown,
>(
  variables: MultiMeterDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<MultiMeterDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<MultiMeterDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<MultiMeterDetailQuery, TError, TData>({
    queryKey: ["MultiMeterDetailSuspense", variables],
    queryFn: adminFetcher<MultiMeterDetailQuery, MultiMeterDetailQueryVariables>(
      MultiMeterDetailDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseMultiMeterDetailQuery.getKey = (
  variables: MultiMeterDetailQueryVariables,
) => ["MultiMeterDetailSuspense", variables]

useSuspenseMultiMeterDetailQuery.rootKey = "MultiMeterDetail"

export const useInfiniteMultiMeterDetailQuery = <
  TData = InfiniteData<MultiMeterDetailQuery>,
  TError = unknown,
>(
  variables: MultiMeterDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<MultiMeterDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<MultiMeterDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<MultiMeterDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MultiMeterDetail.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<MultiMeterDetailQuery, MultiMeterDetailQueryVariables>(
            MultiMeterDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteMultiMeterDetailQuery.getKey = (
  variables: MultiMeterDetailQueryVariables,
) => ["MultiMeterDetail.infinite", variables]

useInfiniteMultiMeterDetailQuery.rootKey = "MultiMeterDetail.infinite"

export const useSuspenseInfiniteMultiMeterDetailQuery = <
  TData = InfiniteData<MultiMeterDetailQuery>,
  TError = unknown,
>(
  variables: MultiMeterDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<MultiMeterDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      MultiMeterDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<MultiMeterDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MultiMeterDetail.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<MultiMeterDetailQuery, MultiMeterDetailQueryVariables>(
            MultiMeterDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteMultiMeterDetailQuery.getKey = (
  variables: MultiMeterDetailQueryVariables,
) => ["MultiMeterDetail.infiniteSuspense", variables]

useSuspenseInfiniteMultiMeterDetailQuery.rootKey = "MultiMeterDetail.infinite"

useMultiMeterDetailQuery.fetcher = (
  variables: MultiMeterDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<MultiMeterDetailQuery, MultiMeterDetailQueryVariables>(
    MultiMeterDetailDocument,
    variables,
    options,
  )

export const BauMeterNameThatTariffDetailDocument = `
    query BauMeterNameThatTariffDetail($id: Int!, $tariffId: Int!, $documentBillingMonthId: Int!) {
  bauMeter(id: $id) {
    nameThatTariffDetail(
      tariffId: $tariffId
      documentBillingMonthId: $documentBillingMonthId
    ) {
      tariff {
        id
        masterTariffId
        code
        name
      }
      result {
        ...NameThatTariffResult
      }
      groups {
        group
        items {
          cost
          usage
          name
          rate
        }
      }
    }
  }
}
    ${NameThatTariffResultFragmentDoc}
${DeltaFragmentDoc}`

export const useBauMeterNameThatTariffDetailQuery = <
  TData = BauMeterNameThatTariffDetailQuery,
  TError = unknown,
>(
  variables: BauMeterNameThatTariffDetailQueryVariables,
  options?: Omit<
    UseQueryOptions<BauMeterNameThatTariffDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      BauMeterNameThatTariffDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useQuery<BauMeterNameThatTariffDetailQuery, TError, TData>({
    queryKey: ["BauMeterNameThatTariffDetail", variables],
    queryFn: adminFetcher<
      BauMeterNameThatTariffDetailQuery,
      BauMeterNameThatTariffDetailQueryVariables
    >(BauMeterNameThatTariffDetailDocument, variables),
    ...options,
  })
}

useBauMeterNameThatTariffDetailQuery.getKey = (
  variables: BauMeterNameThatTariffDetailQueryVariables,
) => ["BauMeterNameThatTariffDetail", variables]

useBauMeterNameThatTariffDetailQuery.rootKey = "BauMeterNameThatTariffDetail"

export const useSuspenseBauMeterNameThatTariffDetailQuery = <
  TData = BauMeterNameThatTariffDetailQuery,
  TError = unknown,
>(
  variables: BauMeterNameThatTariffDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<BauMeterNameThatTariffDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      BauMeterNameThatTariffDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<BauMeterNameThatTariffDetailQuery, TError, TData>({
    queryKey: ["BauMeterNameThatTariffDetailSuspense", variables],
    queryFn: adminFetcher<
      BauMeterNameThatTariffDetailQuery,
      BauMeterNameThatTariffDetailQueryVariables
    >(BauMeterNameThatTariffDetailDocument, variables),
    ...options,
  })
}

useSuspenseBauMeterNameThatTariffDetailQuery.getKey = (
  variables: BauMeterNameThatTariffDetailQueryVariables,
) => ["BauMeterNameThatTariffDetailSuspense", variables]

useSuspenseBauMeterNameThatTariffDetailQuery.rootKey = "BauMeterNameThatTariffDetail"

export const useInfiniteBauMeterNameThatTariffDetailQuery = <
  TData = InfiniteData<BauMeterNameThatTariffDetailQuery>,
  TError = unknown,
>(
  variables: BauMeterNameThatTariffDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<BauMeterNameThatTariffDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      BauMeterNameThatTariffDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<BauMeterNameThatTariffDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "BauMeterNameThatTariffDetail.infinite",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<
            BauMeterNameThatTariffDetailQuery,
            BauMeterNameThatTariffDetailQueryVariables
          >(BauMeterNameThatTariffDetailDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteBauMeterNameThatTariffDetailQuery.getKey = (
  variables: BauMeterNameThatTariffDetailQueryVariables,
) => ["BauMeterNameThatTariffDetail.infinite", variables]

useInfiniteBauMeterNameThatTariffDetailQuery.rootKey =
  "BauMeterNameThatTariffDetail.infinite"

export const useSuspenseInfiniteBauMeterNameThatTariffDetailQuery = <
  TData = InfiniteData<BauMeterNameThatTariffDetailQuery>,
  TError = unknown,
>(
  variables: BauMeterNameThatTariffDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<BauMeterNameThatTariffDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      BauMeterNameThatTariffDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<BauMeterNameThatTariffDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "BauMeterNameThatTariffDetail.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<
            BauMeterNameThatTariffDetailQuery,
            BauMeterNameThatTariffDetailQueryVariables
          >(BauMeterNameThatTariffDetailDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteBauMeterNameThatTariffDetailQuery.getKey = (
  variables: BauMeterNameThatTariffDetailQueryVariables,
) => ["BauMeterNameThatTariffDetail.infiniteSuspense", variables]

useSuspenseInfiniteBauMeterNameThatTariffDetailQuery.rootKey =
  "BauMeterNameThatTariffDetail.infinite"

useBauMeterNameThatTariffDetailQuery.fetcher = (
  variables: BauMeterNameThatTariffDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    BauMeterNameThatTariffDetailQuery,
    BauMeterNameThatTariffDetailQueryVariables
  >(BauMeterNameThatTariffDetailDocument, variables, options)

export const TestCustomTariffDocument = `
    query TestCustomTariff($id: Int!, $cfg: String!, $utilityId: Int!) {
  bauMeter(id: $id) {
    id
    testCustomTariff(cfg: $cfg, utilityId: $utilityId) {
      ...FormattedBill
    }
  }
}
    ${FormattedBillFragmentDoc}
${BillSectionFragmentDoc}
${DecodedRateFragmentDoc}
${CostOrTaxItemFragmentDoc}`

export const useTestCustomTariffQuery = <
  TData = TestCustomTariffQuery,
  TError = unknown,
>(
  variables: TestCustomTariffQueryVariables,
  options?: Omit<UseQueryOptions<TestCustomTariffQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<TestCustomTariffQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<TestCustomTariffQuery, TError, TData>({
    queryKey: ["TestCustomTariff", variables],
    queryFn: adminFetcher<TestCustomTariffQuery, TestCustomTariffQueryVariables>(
      TestCustomTariffDocument,
      variables,
    ),
    ...options,
  })
}

useTestCustomTariffQuery.getKey = (variables: TestCustomTariffQueryVariables) => [
  "TestCustomTariff",
  variables,
]

useTestCustomTariffQuery.rootKey = "TestCustomTariff"

export const useSuspenseTestCustomTariffQuery = <
  TData = TestCustomTariffQuery,
  TError = unknown,
>(
  variables: TestCustomTariffQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<TestCustomTariffQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<TestCustomTariffQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<TestCustomTariffQuery, TError, TData>({
    queryKey: ["TestCustomTariffSuspense", variables],
    queryFn: adminFetcher<TestCustomTariffQuery, TestCustomTariffQueryVariables>(
      TestCustomTariffDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseTestCustomTariffQuery.getKey = (
  variables: TestCustomTariffQueryVariables,
) => ["TestCustomTariffSuspense", variables]

useSuspenseTestCustomTariffQuery.rootKey = "TestCustomTariff"

export const useInfiniteTestCustomTariffQuery = <
  TData = InfiniteData<TestCustomTariffQuery>,
  TError = unknown,
>(
  variables: TestCustomTariffQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<TestCustomTariffQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<TestCustomTariffQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<TestCustomTariffQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["TestCustomTariff.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<TestCustomTariffQuery, TestCustomTariffQueryVariables>(
            TestCustomTariffDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteTestCustomTariffQuery.getKey = (
  variables: TestCustomTariffQueryVariables,
) => ["TestCustomTariff.infinite", variables]

useInfiniteTestCustomTariffQuery.rootKey = "TestCustomTariff.infinite"

export const useSuspenseInfiniteTestCustomTariffQuery = <
  TData = InfiniteData<TestCustomTariffQuery>,
  TError = unknown,
>(
  variables: TestCustomTariffQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<TestCustomTariffQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      TestCustomTariffQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<TestCustomTariffQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["TestCustomTariff.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<TestCustomTariffQuery, TestCustomTariffQueryVariables>(
            TestCustomTariffDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteTestCustomTariffQuery.getKey = (
  variables: TestCustomTariffQueryVariables,
) => ["TestCustomTariff.infiniteSuspense", variables]

useSuspenseInfiniteTestCustomTariffQuery.rootKey = "TestCustomTariff.infinite"

useTestCustomTariffQuery.fetcher = (
  variables: TestCustomTariffQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<TestCustomTariffQuery, TestCustomTariffQueryVariables>(
    TestCustomTariffDocument,
    variables,
    options,
  )

export const BauMeterIntervalsDocument = `
    query BauMeterIntervals($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    bauMeters {
      ...BauMeterIntervals
    }
  }
}
    ${BauMeterIntervalsFragmentDoc}`

export const useBauMeterIntervalsQuery = <
  TData = BauMeterIntervalsQuery,
  TError = unknown,
>(
  variables: BauMeterIntervalsQueryVariables,
  options?: Omit<UseQueryOptions<BauMeterIntervalsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<BauMeterIntervalsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<BauMeterIntervalsQuery, TError, TData>({
    queryKey: ["BauMeterIntervals", variables],
    queryFn: adminFetcher<BauMeterIntervalsQuery, BauMeterIntervalsQueryVariables>(
      BauMeterIntervalsDocument,
      variables,
    ),
    ...options,
  })
}

useBauMeterIntervalsQuery.getKey = (variables: BauMeterIntervalsQueryVariables) => [
  "BauMeterIntervals",
  variables,
]

useBauMeterIntervalsQuery.rootKey = "BauMeterIntervals"

export const useSuspenseBauMeterIntervalsQuery = <
  TData = BauMeterIntervalsQuery,
  TError = unknown,
>(
  variables: BauMeterIntervalsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<BauMeterIntervalsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      BauMeterIntervalsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<BauMeterIntervalsQuery, TError, TData>({
    queryKey: ["BauMeterIntervalsSuspense", variables],
    queryFn: adminFetcher<BauMeterIntervalsQuery, BauMeterIntervalsQueryVariables>(
      BauMeterIntervalsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseBauMeterIntervalsQuery.getKey = (
  variables: BauMeterIntervalsQueryVariables,
) => ["BauMeterIntervalsSuspense", variables]

useSuspenseBauMeterIntervalsQuery.rootKey = "BauMeterIntervals"

export const useInfiniteBauMeterIntervalsQuery = <
  TData = InfiniteData<BauMeterIntervalsQuery>,
  TError = unknown,
>(
  variables: BauMeterIntervalsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<BauMeterIntervalsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      BauMeterIntervalsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<BauMeterIntervalsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["BauMeterIntervals.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<BauMeterIntervalsQuery, BauMeterIntervalsQueryVariables>(
            BauMeterIntervalsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteBauMeterIntervalsQuery.getKey = (
  variables: BauMeterIntervalsQueryVariables,
) => ["BauMeterIntervals.infinite", variables]

useInfiniteBauMeterIntervalsQuery.rootKey = "BauMeterIntervals.infinite"

export const useSuspenseInfiniteBauMeterIntervalsQuery = <
  TData = InfiniteData<BauMeterIntervalsQuery>,
  TError = unknown,
>(
  variables: BauMeterIntervalsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<BauMeterIntervalsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      BauMeterIntervalsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<BauMeterIntervalsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["BauMeterIntervals.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<BauMeterIntervalsQuery, BauMeterIntervalsQueryVariables>(
            BauMeterIntervalsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteBauMeterIntervalsQuery.getKey = (
  variables: BauMeterIntervalsQueryVariables,
) => ["BauMeterIntervals.infiniteSuspense", variables]

useSuspenseInfiniteBauMeterIntervalsQuery.rootKey = "BauMeterIntervals.infinite"

useBauMeterIntervalsQuery.fetcher = (
  variables: BauMeterIntervalsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<BauMeterIntervalsQuery, BauMeterIntervalsQueryVariables>(
    BauMeterIntervalsDocument,
    variables,
    options,
  )

export const MeterSetDocument = `
    query MeterSet($sitePid: String!, $id: Int!) {
  site(pid: $sitePid) {
    pid
    isMultifamily
    meterSet(id: $id) {
      id
      meters {
        hasTruth
        ...BauMeter
        ...BauMeterIntervals
      }
    }
    customTariffs {
      id
      name
      code
      parent {
        id
      }
    }
  }
}
    ${BauMeterFragmentDoc}
${BauTariffFragmentDoc}
${BauMeterIntervalsFragmentDoc}`

export const useMeterSetQuery = <TData = MeterSetQuery, TError = unknown>(
  variables: MeterSetQueryVariables,
  options?: Omit<UseQueryOptions<MeterSetQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<MeterSetQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<MeterSetQuery, TError, TData>({
    queryKey: ["MeterSet", variables],
    queryFn: adminFetcher<MeterSetQuery, MeterSetQueryVariables>(
      MeterSetDocument,
      variables,
    ),
    ...options,
  })
}

useMeterSetQuery.getKey = (variables: MeterSetQueryVariables) => ["MeterSet", variables]

useMeterSetQuery.rootKey = "MeterSet"

export const useSuspenseMeterSetQuery = <TData = MeterSetQuery, TError = unknown>(
  variables: MeterSetQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<MeterSetQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<MeterSetQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<MeterSetQuery, TError, TData>({
    queryKey: ["MeterSetSuspense", variables],
    queryFn: adminFetcher<MeterSetQuery, MeterSetQueryVariables>(
      MeterSetDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseMeterSetQuery.getKey = (variables: MeterSetQueryVariables) => [
  "MeterSetSuspense",
  variables,
]

useSuspenseMeterSetQuery.rootKey = "MeterSet"

export const useInfiniteMeterSetQuery = <
  TData = InfiniteData<MeterSetQuery>,
  TError = unknown,
>(
  variables: MeterSetQueryVariables,
  options: Omit<UseInfiniteQueryOptions<MeterSetQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<MeterSetQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<MeterSetQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MeterSet.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<MeterSetQuery, MeterSetQueryVariables>(MeterSetDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteMeterSetQuery.getKey = (variables: MeterSetQueryVariables) => [
  "MeterSet.infinite",
  variables,
]

useInfiniteMeterSetQuery.rootKey = "MeterSet.infinite"

export const useSuspenseInfiniteMeterSetQuery = <
  TData = InfiniteData<MeterSetQuery>,
  TError = unknown,
>(
  variables: MeterSetQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<MeterSetQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<MeterSetQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<MeterSetQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MeterSet.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<MeterSetQuery, MeterSetQueryVariables>(MeterSetDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteMeterSetQuery.getKey = (variables: MeterSetQueryVariables) => [
  "MeterSet.infiniteSuspense",
  variables,
]

useSuspenseInfiniteMeterSetQuery.rootKey = "MeterSet.infinite"

useMeterSetQuery.fetcher = (
  variables: MeterSetQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<MeterSetQuery, MeterSetQueryVariables>(
    MeterSetDocument,
    variables,
    options,
  )

export const AdminNotesDocument = `
    query AdminNotes($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    notes {
      pid
      text
      createdAt
      createdBy {
        ...UserRef
      }
      updatedAt
      updatedBy {
        ...UserRef
      }
      trashedAt
      trashedBy {
        ...UserRef
      }
      hiddenFromCustomers
    }
  }
}
    ${UserRefFragmentDoc}`

export const useAdminNotesQuery = <TData = AdminNotesQuery, TError = unknown>(
  variables: AdminNotesQueryVariables,
  options?: Omit<UseQueryOptions<AdminNotesQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<AdminNotesQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<AdminNotesQuery, TError, TData>({
    queryKey: ["AdminNotes", variables],
    queryFn: adminFetcher<AdminNotesQuery, AdminNotesQueryVariables>(
      AdminNotesDocument,
      variables,
    ),
    ...options,
  })
}

useAdminNotesQuery.getKey = (variables: AdminNotesQueryVariables) => [
  "AdminNotes",
  variables,
]

useAdminNotesQuery.rootKey = "AdminNotes"

export const useSuspenseAdminNotesQuery = <TData = AdminNotesQuery, TError = unknown>(
  variables: AdminNotesQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<AdminNotesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<AdminNotesQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<AdminNotesQuery, TError, TData>({
    queryKey: ["AdminNotesSuspense", variables],
    queryFn: adminFetcher<AdminNotesQuery, AdminNotesQueryVariables>(
      AdminNotesDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseAdminNotesQuery.getKey = (variables: AdminNotesQueryVariables) => [
  "AdminNotesSuspense",
  variables,
]

useSuspenseAdminNotesQuery.rootKey = "AdminNotes"

export const useInfiniteAdminNotesQuery = <
  TData = InfiniteData<AdminNotesQuery>,
  TError = unknown,
>(
  variables: AdminNotesQueryVariables,
  options: Omit<UseInfiniteQueryOptions<AdminNotesQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<AdminNotesQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<AdminNotesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["AdminNotes.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminNotesQuery, AdminNotesQueryVariables>(AdminNotesDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteAdminNotesQuery.getKey = (variables: AdminNotesQueryVariables) => [
  "AdminNotes.infinite",
  variables,
]

useInfiniteAdminNotesQuery.rootKey = "AdminNotes.infinite"

export const useSuspenseInfiniteAdminNotesQuery = <
  TData = InfiniteData<AdminNotesQuery>,
  TError = unknown,
>(
  variables: AdminNotesQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<AdminNotesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      AdminNotesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<AdminNotesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["AdminNotes.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminNotesQuery, AdminNotesQueryVariables>(AdminNotesDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteAdminNotesQuery.getKey = (variables: AdminNotesQueryVariables) => [
  "AdminNotes.infiniteSuspense",
  variables,
]

useSuspenseInfiniteAdminNotesQuery.rootKey = "AdminNotes.infinite"

useAdminNotesQuery.fetcher = (
  variables: AdminNotesQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AdminNotesQuery, AdminNotesQueryVariables>(
    AdminNotesDocument,
    variables,
    options,
  )

export const BatchPhysicalCheckDocument = `
    query BatchPhysicalCheck($orgPid: String!, $propertyPids: [String!]!, $siteFields: [SiteChangelogColumn!]!, $buildingDataFields: [BuildingDataChangelogColumn!]!) {
  org(orgPid: $orgPid) {
    pid
    name
  }
  sites(sitePids: $propertyPids) {
    pid
    portfolio {
      name
    }
    changelog(fields: $siteFields) {
      all {
        column
        obj {
          ...Changelog
        }
      }
    }
    buildingData {
      changelog(fields: $buildingDataFields) {
        all {
          column
          obj {
            ...Changelog
          }
        }
      }
    }
    notes {
      pid
      text
      createdAt
      createdBy {
        ...UserRef
      }
      updatedAt
      updatedBy {
        ...UserRef
      }
    }
    currentStatus {
      pid
      status
    }
    slopedRoof
    propertyName
    numberOfBuildings
    sqft
    numStories
    fullAddress
    roofMaxPvKw
    computedRoofMaxPvKw
    explainRoofHeuristic
    explainSlopedHeuristic
    computedCarportMaxPvKw
    explainCarportHeuristic
    explainCarportParkingSpaceHeuristic
    computedGroundMaxPvKw
    explainGroundHeuristic
    impliedCarportLinearFt
    impliedUsableRoofSqft
    impliedUsableRoofSqftExplanation
    roofSqft
    usableRoofPct
    usableRoofSqft
    setbackRoofSqft
    roofKeepoutsSqft
    groundAvailableSqft
    groundMaxPvKw
    usableCarportFt
    numParkingSpaces
    carportMaxPvKw
    existingSolarDetectionScore
    physicalCheck {
      existingSolar
    }
    footprint {
      latitude
      longitude
      roofShape
      roofShapeGeojson
      roofSetbackShape
      roofSetbackShapeGeojson
      keepoutsShape
      keepoutsShapeGeojson
      parcelShape
      parcelShapeGeojson
      carportShape
      carportShapeGeojson
      groundmountShape
      groundmountShapeGeojson
      bounds
    }
  }
}
    ${ChangelogFragmentDoc}
${UserRefFragmentDoc}`

export const useBatchPhysicalCheckQuery = <
  TData = BatchPhysicalCheckQuery,
  TError = unknown,
>(
  variables: BatchPhysicalCheckQueryVariables,
  options?: Omit<
    UseQueryOptions<BatchPhysicalCheckQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<BatchPhysicalCheckQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<BatchPhysicalCheckQuery, TError, TData>({
    queryKey: ["BatchPhysicalCheck", variables],
    queryFn: adminFetcher<BatchPhysicalCheckQuery, BatchPhysicalCheckQueryVariables>(
      BatchPhysicalCheckDocument,
      variables,
    ),
    ...options,
  })
}

useBatchPhysicalCheckQuery.getKey = (variables: BatchPhysicalCheckQueryVariables) => [
  "BatchPhysicalCheck",
  variables,
]

useBatchPhysicalCheckQuery.rootKey = "BatchPhysicalCheck"

export const useSuspenseBatchPhysicalCheckQuery = <
  TData = BatchPhysicalCheckQuery,
  TError = unknown,
>(
  variables: BatchPhysicalCheckQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<BatchPhysicalCheckQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      BatchPhysicalCheckQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<BatchPhysicalCheckQuery, TError, TData>({
    queryKey: ["BatchPhysicalCheckSuspense", variables],
    queryFn: adminFetcher<BatchPhysicalCheckQuery, BatchPhysicalCheckQueryVariables>(
      BatchPhysicalCheckDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseBatchPhysicalCheckQuery.getKey = (
  variables: BatchPhysicalCheckQueryVariables,
) => ["BatchPhysicalCheckSuspense", variables]

useSuspenseBatchPhysicalCheckQuery.rootKey = "BatchPhysicalCheck"

export const useInfiniteBatchPhysicalCheckQuery = <
  TData = InfiniteData<BatchPhysicalCheckQuery>,
  TError = unknown,
>(
  variables: BatchPhysicalCheckQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<BatchPhysicalCheckQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      BatchPhysicalCheckQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<BatchPhysicalCheckQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["BatchPhysicalCheck.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<BatchPhysicalCheckQuery, BatchPhysicalCheckQueryVariables>(
            BatchPhysicalCheckDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteBatchPhysicalCheckQuery.getKey = (
  variables: BatchPhysicalCheckQueryVariables,
) => ["BatchPhysicalCheck.infinite", variables]

useInfiniteBatchPhysicalCheckQuery.rootKey = "BatchPhysicalCheck.infinite"

export const useSuspenseInfiniteBatchPhysicalCheckQuery = <
  TData = InfiniteData<BatchPhysicalCheckQuery>,
  TError = unknown,
>(
  variables: BatchPhysicalCheckQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<BatchPhysicalCheckQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      BatchPhysicalCheckQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<BatchPhysicalCheckQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["BatchPhysicalCheck.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<BatchPhysicalCheckQuery, BatchPhysicalCheckQueryVariables>(
            BatchPhysicalCheckDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteBatchPhysicalCheckQuery.getKey = (
  variables: BatchPhysicalCheckQueryVariables,
) => ["BatchPhysicalCheck.infiniteSuspense", variables]

useSuspenseInfiniteBatchPhysicalCheckQuery.rootKey = "BatchPhysicalCheck.infinite"

useBatchPhysicalCheckQuery.fetcher = (
  variables: BatchPhysicalCheckQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<BatchPhysicalCheckQuery, BatchPhysicalCheckQueryVariables>(
    BatchPhysicalCheckDocument,
    variables,
    options,
  )

export const ClosestParcelsDocument = `
    query ClosestParcels($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    closestSites {
      pid
      name
      fullAddress
      footprint {
        latitude
        longitude
        parcelShape
      }
    }
  }
}
    `

export const useClosestParcelsQuery = <TData = ClosestParcelsQuery, TError = unknown>(
  variables: ClosestParcelsQueryVariables,
  options?: Omit<UseQueryOptions<ClosestParcelsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<ClosestParcelsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ClosestParcelsQuery, TError, TData>({
    queryKey: ["ClosestParcels", variables],
    queryFn: adminFetcher<ClosestParcelsQuery, ClosestParcelsQueryVariables>(
      ClosestParcelsDocument,
      variables,
    ),
    ...options,
  })
}

useClosestParcelsQuery.getKey = (variables: ClosestParcelsQueryVariables) => [
  "ClosestParcels",
  variables,
]

useClosestParcelsQuery.rootKey = "ClosestParcels"

export const useSuspenseClosestParcelsQuery = <
  TData = ClosestParcelsQuery,
  TError = unknown,
>(
  variables: ClosestParcelsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ClosestParcelsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<ClosestParcelsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<ClosestParcelsQuery, TError, TData>({
    queryKey: ["ClosestParcelsSuspense", variables],
    queryFn: adminFetcher<ClosestParcelsQuery, ClosestParcelsQueryVariables>(
      ClosestParcelsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseClosestParcelsQuery.getKey = (variables: ClosestParcelsQueryVariables) => [
  "ClosestParcelsSuspense",
  variables,
]

useSuspenseClosestParcelsQuery.rootKey = "ClosestParcels"

export const useInfiniteClosestParcelsQuery = <
  TData = InfiniteData<ClosestParcelsQuery>,
  TError = unknown,
>(
  variables: ClosestParcelsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ClosestParcelsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<ClosestParcelsQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<ClosestParcelsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ClosestParcels.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<ClosestParcelsQuery, ClosestParcelsQueryVariables>(
            ClosestParcelsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteClosestParcelsQuery.getKey = (variables: ClosestParcelsQueryVariables) => [
  "ClosestParcels.infinite",
  variables,
]

useInfiniteClosestParcelsQuery.rootKey = "ClosestParcels.infinite"

export const useSuspenseInfiniteClosestParcelsQuery = <
  TData = InfiniteData<ClosestParcelsQuery>,
  TError = unknown,
>(
  variables: ClosestParcelsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ClosestParcelsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ClosestParcelsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ClosestParcelsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ClosestParcels.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<ClosestParcelsQuery, ClosestParcelsQueryVariables>(
            ClosestParcelsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteClosestParcelsQuery.getKey = (
  variables: ClosestParcelsQueryVariables,
) => ["ClosestParcels.infiniteSuspense", variables]

useSuspenseInfiniteClosestParcelsQuery.rootKey = "ClosestParcels.infinite"

useClosestParcelsQuery.fetcher = (
  variables: ClosestParcelsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ClosestParcelsQuery, ClosestParcelsQueryVariables>(
    ClosestParcelsDocument,
    variables,
    options,
  )

export const GeocodedLocationDocument = `
    query GeocodedLocation($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    fullAddress
    footprint {
      geocodedLocation {
        latitude
        longitude
      }
    }
  }
}
    `

export const useGeocodedLocationQuery = <
  TData = GeocodedLocationQuery,
  TError = unknown,
>(
  variables: GeocodedLocationQueryVariables,
  options?: Omit<UseQueryOptions<GeocodedLocationQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<GeocodedLocationQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<GeocodedLocationQuery, TError, TData>({
    queryKey: ["GeocodedLocation", variables],
    queryFn: adminFetcher<GeocodedLocationQuery, GeocodedLocationQueryVariables>(
      GeocodedLocationDocument,
      variables,
    ),
    ...options,
  })
}

useGeocodedLocationQuery.getKey = (variables: GeocodedLocationQueryVariables) => [
  "GeocodedLocation",
  variables,
]

useGeocodedLocationQuery.rootKey = "GeocodedLocation"

export const useSuspenseGeocodedLocationQuery = <
  TData = GeocodedLocationQuery,
  TError = unknown,
>(
  variables: GeocodedLocationQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<GeocodedLocationQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<GeocodedLocationQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<GeocodedLocationQuery, TError, TData>({
    queryKey: ["GeocodedLocationSuspense", variables],
    queryFn: adminFetcher<GeocodedLocationQuery, GeocodedLocationQueryVariables>(
      GeocodedLocationDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseGeocodedLocationQuery.getKey = (
  variables: GeocodedLocationQueryVariables,
) => ["GeocodedLocationSuspense", variables]

useSuspenseGeocodedLocationQuery.rootKey = "GeocodedLocation"

export const useInfiniteGeocodedLocationQuery = <
  TData = InfiniteData<GeocodedLocationQuery>,
  TError = unknown,
>(
  variables: GeocodedLocationQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<GeocodedLocationQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<GeocodedLocationQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<GeocodedLocationQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["GeocodedLocation.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<GeocodedLocationQuery, GeocodedLocationQueryVariables>(
            GeocodedLocationDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteGeocodedLocationQuery.getKey = (
  variables: GeocodedLocationQueryVariables,
) => ["GeocodedLocation.infinite", variables]

useInfiniteGeocodedLocationQuery.rootKey = "GeocodedLocation.infinite"

export const useSuspenseInfiniteGeocodedLocationQuery = <
  TData = InfiniteData<GeocodedLocationQuery>,
  TError = unknown,
>(
  variables: GeocodedLocationQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<GeocodedLocationQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      GeocodedLocationQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<GeocodedLocationQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["GeocodedLocation.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<GeocodedLocationQuery, GeocodedLocationQueryVariables>(
            GeocodedLocationDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteGeocodedLocationQuery.getKey = (
  variables: GeocodedLocationQueryVariables,
) => ["GeocodedLocation.infiniteSuspense", variables]

useSuspenseInfiniteGeocodedLocationQuery.rootKey = "GeocodedLocation.infinite"

useGeocodedLocationQuery.fetcher = (
  variables: GeocodedLocationQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<GeocodedLocationQuery, GeocodedLocationQueryVariables>(
    GeocodedLocationDocument,
    variables,
    options,
  )

export const ActiveResultListDocument = `
    query ActiveResultList($sitePid: String!) {
  site(pid: $sitePid) {
    activeResults {
      id
      pid
      createdAt
      scenario {
        pid
        name
        solarLocation
        loadCategory
        includeStorage
      }
      financing {
        id
        name
        type
        financierName
        financierPid
        financierLogo
        financierLogomark
        isThirdParty
        status
      }
      result {
        __typename
        ... on PhysicalCheck {
          createdAt
          roofIsGood
          carportIsGood
          existingSolar
          badRoof
          groundmountIsGood
        }
        ... on PolicyCheck {
          createdAt
          productType
          isGood
          disqualReason
        }
        ... on RevampFinmodelFailure {
          id
          createdAt
          fmvStr
          details {
            label
            description
          }
        }
        ... on RevampFinmodel {
          ...RevampFinmodel
          moreDetails {
            pvCostPerWatt
            storageCostPerKwh
            totalInstallCost
          }
        }
        ... on RevampCS {
          ...RevampCS
        }
        ... on Viability {
          isAllowed
          viabilityType: type
          reason
          level
        }
      }
      helioscope {
        ...Helioscope
      }
    }
  }
}
    ${RevampFinmodelFragmentDoc}
${KwhFlowFragmentDoc}
${RevampSystemFragmentDoc}
${FinmodelCostFragmentDoc}
${RevampCsFragmentDoc}
${HelioscopeFragmentDoc}`

export const useActiveResultListQuery = <
  TData = ActiveResultListQuery,
  TError = unknown,
>(
  variables: ActiveResultListQueryVariables,
  options?: Omit<UseQueryOptions<ActiveResultListQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<ActiveResultListQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ActiveResultListQuery, TError, TData>({
    queryKey: ["ActiveResultList", variables],
    queryFn: adminFetcher<ActiveResultListQuery, ActiveResultListQueryVariables>(
      ActiveResultListDocument,
      variables,
    ),
    ...options,
  })
}

useActiveResultListQuery.getKey = (variables: ActiveResultListQueryVariables) => [
  "ActiveResultList",
  variables,
]

useActiveResultListQuery.rootKey = "ActiveResultList"

export const useSuspenseActiveResultListQuery = <
  TData = ActiveResultListQuery,
  TError = unknown,
>(
  variables: ActiveResultListQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ActiveResultListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<ActiveResultListQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<ActiveResultListQuery, TError, TData>({
    queryKey: ["ActiveResultListSuspense", variables],
    queryFn: adminFetcher<ActiveResultListQuery, ActiveResultListQueryVariables>(
      ActiveResultListDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseActiveResultListQuery.getKey = (
  variables: ActiveResultListQueryVariables,
) => ["ActiveResultListSuspense", variables]

useSuspenseActiveResultListQuery.rootKey = "ActiveResultList"

export const useInfiniteActiveResultListQuery = <
  TData = InfiniteData<ActiveResultListQuery>,
  TError = unknown,
>(
  variables: ActiveResultListQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ActiveResultListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<ActiveResultListQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<ActiveResultListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ActiveResultList.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<ActiveResultListQuery, ActiveResultListQueryVariables>(
            ActiveResultListDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteActiveResultListQuery.getKey = (
  variables: ActiveResultListQueryVariables,
) => ["ActiveResultList.infinite", variables]

useInfiniteActiveResultListQuery.rootKey = "ActiveResultList.infinite"

export const useSuspenseInfiniteActiveResultListQuery = <
  TData = InfiniteData<ActiveResultListQuery>,
  TError = unknown,
>(
  variables: ActiveResultListQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ActiveResultListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ActiveResultListQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ActiveResultListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ActiveResultList.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<ActiveResultListQuery, ActiveResultListQueryVariables>(
            ActiveResultListDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteActiveResultListQuery.getKey = (
  variables: ActiveResultListQueryVariables,
) => ["ActiveResultList.infiniteSuspense", variables]

useSuspenseInfiniteActiveResultListQuery.rootKey = "ActiveResultList.infinite"

useActiveResultListQuery.fetcher = (
  variables: ActiveResultListQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ActiveResultListQuery, ActiveResultListQueryVariables>(
    ActiveResultListDocument,
    variables,
    options,
  )

export const ResultDetailDocument = `
    query ResultDetail($sitePid: String!, $id: Int!) {
  site(pid: $sitePid) {
    result(id: $id) {
      ...Result
      ...ResultWithEnergyData
    }
  }
}
    ${ResultFragmentDoc}
${RevampFinmodelFragmentDoc}
${KwhFlowFragmentDoc}
${RevampSystemFragmentDoc}
${FinmodelCostFragmentDoc}
${RevampCsFragmentDoc}
${HelioscopeFragmentDoc}
${ResultWithEnergyDataFragmentDoc}`

export const useResultDetailQuery = <TData = ResultDetailQuery, TError = unknown>(
  variables: ResultDetailQueryVariables,
  options?: Omit<UseQueryOptions<ResultDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<ResultDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ResultDetailQuery, TError, TData>({
    queryKey: ["ResultDetail", variables],
    queryFn: adminFetcher<ResultDetailQuery, ResultDetailQueryVariables>(
      ResultDetailDocument,
      variables,
    ),
    ...options,
  })
}

useResultDetailQuery.getKey = (variables: ResultDetailQueryVariables) => [
  "ResultDetail",
  variables,
]

useResultDetailQuery.rootKey = "ResultDetail"

export const useSuspenseResultDetailQuery = <
  TData = ResultDetailQuery,
  TError = unknown,
>(
  variables: ResultDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ResultDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<ResultDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<ResultDetailQuery, TError, TData>({
    queryKey: ["ResultDetailSuspense", variables],
    queryFn: adminFetcher<ResultDetailQuery, ResultDetailQueryVariables>(
      ResultDetailDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseResultDetailQuery.getKey = (variables: ResultDetailQueryVariables) => [
  "ResultDetailSuspense",
  variables,
]

useSuspenseResultDetailQuery.rootKey = "ResultDetail"

export const useInfiniteResultDetailQuery = <
  TData = InfiniteData<ResultDetailQuery>,
  TError = unknown,
>(
  variables: ResultDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ResultDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<ResultDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<ResultDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ResultDetail.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<ResultDetailQuery, ResultDetailQueryVariables>(
            ResultDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteResultDetailQuery.getKey = (variables: ResultDetailQueryVariables) => [
  "ResultDetail.infinite",
  variables,
]

useInfiniteResultDetailQuery.rootKey = "ResultDetail.infinite"

export const useSuspenseInfiniteResultDetailQuery = <
  TData = InfiniteData<ResultDetailQuery>,
  TError = unknown,
>(
  variables: ResultDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ResultDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ResultDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ResultDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ResultDetail.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<ResultDetailQuery, ResultDetailQueryVariables>(
            ResultDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteResultDetailQuery.getKey = (
  variables: ResultDetailQueryVariables,
) => ["ResultDetail.infiniteSuspense", variables]

useSuspenseInfiniteResultDetailQuery.rootKey = "ResultDetail.infinite"

useResultDetailQuery.fetcher = (
  variables: ResultDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ResultDetailQuery, ResultDetailQueryVariables>(
    ResultDetailDocument,
    variables,
    options,
  )

export const ResultTableDocument = `
    query ResultTable($slug: String!, $filterBy: ResultTableFilter, $sortBy: [ResultTableSort!]) {
  orgBySlug(slug: $slug) {
    resultTable {
      view(filterBy: $filterBy, sortBy: $sortBy) {
        keys
      }
    }
  }
}
    `

export const useResultTableQuery = <TData = ResultTableQuery, TError = unknown>(
  variables: ResultTableQueryVariables,
  options?: Omit<UseQueryOptions<ResultTableQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<ResultTableQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ResultTableQuery, TError, TData>({
    queryKey: ["ResultTable", variables],
    queryFn: adminFetcher<ResultTableQuery, ResultTableQueryVariables>(
      ResultTableDocument,
      variables,
    ),
    ...options,
  })
}

useResultTableQuery.getKey = (variables: ResultTableQueryVariables) => [
  "ResultTable",
  variables,
]

useResultTableQuery.rootKey = "ResultTable"

export const useSuspenseResultTableQuery = <TData = ResultTableQuery, TError = unknown>(
  variables: ResultTableQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ResultTableQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<ResultTableQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<ResultTableQuery, TError, TData>({
    queryKey: ["ResultTableSuspense", variables],
    queryFn: adminFetcher<ResultTableQuery, ResultTableQueryVariables>(
      ResultTableDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseResultTableQuery.getKey = (variables: ResultTableQueryVariables) => [
  "ResultTableSuspense",
  variables,
]

useSuspenseResultTableQuery.rootKey = "ResultTable"

export const useInfiniteResultTableQuery = <
  TData = InfiniteData<ResultTableQuery>,
  TError = unknown,
>(
  variables: ResultTableQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ResultTableQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<ResultTableQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<ResultTableQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ResultTable.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<ResultTableQuery, ResultTableQueryVariables>(
            ResultTableDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteResultTableQuery.getKey = (variables: ResultTableQueryVariables) => [
  "ResultTable.infinite",
  variables,
]

useInfiniteResultTableQuery.rootKey = "ResultTable.infinite"

export const useSuspenseInfiniteResultTableQuery = <
  TData = InfiniteData<ResultTableQuery>,
  TError = unknown,
>(
  variables: ResultTableQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ResultTableQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ResultTableQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ResultTableQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ResultTable.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<ResultTableQuery, ResultTableQueryVariables>(
            ResultTableDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteResultTableQuery.getKey = (variables: ResultTableQueryVariables) => [
  "ResultTable.infiniteSuspense",
  variables,
]

useSuspenseInfiniteResultTableQuery.rootKey = "ResultTable.infinite"

useResultTableQuery.fetcher = (
  variables: ResultTableQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ResultTableQuery, ResultTableQueryVariables>(
    ResultTableDocument,
    variables,
    options,
  )

export const ResultTableRowsDocument = `
    query ResultTableRows($slug: String!, $ids: [Int!]!) {
  orgBySlug(slug: $slug) {
    resultTable {
      rows(keys: $ids) {
        id
        createdAt
        sitePid
        siteName
        siteStreetAddress
        siteCity
        siteState
        siteStatus
        siteHiddenFromCustomers
        scenarioPid
        scenarioName
        scenarioSolarLocation
        scenarioIncludeStorage
        finproductType
        financierName
        financierPid
        finmodelId
        finmodelFmv
        finmodelNoi
        failureId
        failureFmv
        failureName
        failureMessage
        policyCheckIsGood
        physicalCheckRoofIsGood
        physicalCheckCarportIsGood
        physicalCheckGroundmountIsGood
      }
    }
  }
}
    `

export const useResultTableRowsQuery = <TData = ResultTableRowsQuery, TError = unknown>(
  variables: ResultTableRowsQueryVariables,
  options?: Omit<UseQueryOptions<ResultTableRowsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<ResultTableRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ResultTableRowsQuery, TError, TData>({
    queryKey: ["ResultTableRows", variables],
    queryFn: adminFetcher<ResultTableRowsQuery, ResultTableRowsQueryVariables>(
      ResultTableRowsDocument,
      variables,
    ),
    ...options,
  })
}

useResultTableRowsQuery.getKey = (variables: ResultTableRowsQueryVariables) => [
  "ResultTableRows",
  variables,
]

useResultTableRowsQuery.rootKey = "ResultTableRows"

export const useSuspenseResultTableRowsQuery = <
  TData = ResultTableRowsQuery,
  TError = unknown,
>(
  variables: ResultTableRowsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ResultTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<ResultTableRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<ResultTableRowsQuery, TError, TData>({
    queryKey: ["ResultTableRowsSuspense", variables],
    queryFn: adminFetcher<ResultTableRowsQuery, ResultTableRowsQueryVariables>(
      ResultTableRowsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseResultTableRowsQuery.getKey = (variables: ResultTableRowsQueryVariables) => [
  "ResultTableRowsSuspense",
  variables,
]

useSuspenseResultTableRowsQuery.rootKey = "ResultTableRows"

export const useInfiniteResultTableRowsQuery = <
  TData = InfiniteData<ResultTableRowsQuery>,
  TError = unknown,
>(
  variables: ResultTableRowsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ResultTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<ResultTableRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<ResultTableRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ResultTableRows.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<ResultTableRowsQuery, ResultTableRowsQueryVariables>(
            ResultTableRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteResultTableRowsQuery.getKey = (variables: ResultTableRowsQueryVariables) => [
  "ResultTableRows.infinite",
  variables,
]

useInfiniteResultTableRowsQuery.rootKey = "ResultTableRows.infinite"

export const useSuspenseInfiniteResultTableRowsQuery = <
  TData = InfiniteData<ResultTableRowsQuery>,
  TError = unknown,
>(
  variables: ResultTableRowsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ResultTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ResultTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ResultTableRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ResultTableRows.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<ResultTableRowsQuery, ResultTableRowsQueryVariables>(
            ResultTableRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteResultTableRowsQuery.getKey = (
  variables: ResultTableRowsQueryVariables,
) => ["ResultTableRows.infiniteSuspense", variables]

useSuspenseInfiniteResultTableRowsQuery.rootKey = "ResultTableRows.infinite"

useResultTableRowsQuery.fetcher = (
  variables: ResultTableRowsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ResultTableRowsQuery, ResultTableRowsQueryVariables>(
    ResultTableRowsDocument,
    variables,
    options,
  )

export const FinmodelTableDocument = `
    query FinmodelTable($sitePid: String!, $filterBy: FinmodelTableFilter, $sortBy: [FinmodelTableSort!]) {
  site(pid: $sitePid) {
    finmodelTable {
      view(filterBy: $filterBy, sortBy: $sortBy) {
        keys
      }
    }
  }
}
    `

export const useFinmodelTableQuery = <TData = FinmodelTableQuery, TError = unknown>(
  variables: FinmodelTableQueryVariables,
  options?: Omit<UseQueryOptions<FinmodelTableQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<FinmodelTableQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<FinmodelTableQuery, TError, TData>({
    queryKey: ["FinmodelTable", variables],
    queryFn: adminFetcher<FinmodelTableQuery, FinmodelTableQueryVariables>(
      FinmodelTableDocument,
      variables,
    ),
    ...options,
  })
}

useFinmodelTableQuery.getKey = (variables: FinmodelTableQueryVariables) => [
  "FinmodelTable",
  variables,
]

useFinmodelTableQuery.rootKey = "FinmodelTable"

export const useSuspenseFinmodelTableQuery = <
  TData = FinmodelTableQuery,
  TError = unknown,
>(
  variables: FinmodelTableQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<FinmodelTableQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<FinmodelTableQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<FinmodelTableQuery, TError, TData>({
    queryKey: ["FinmodelTableSuspense", variables],
    queryFn: adminFetcher<FinmodelTableQuery, FinmodelTableQueryVariables>(
      FinmodelTableDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseFinmodelTableQuery.getKey = (variables: FinmodelTableQueryVariables) => [
  "FinmodelTableSuspense",
  variables,
]

useSuspenseFinmodelTableQuery.rootKey = "FinmodelTable"

export const useInfiniteFinmodelTableQuery = <
  TData = InfiniteData<FinmodelTableQuery>,
  TError = unknown,
>(
  variables: FinmodelTableQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<FinmodelTableQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<FinmodelTableQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<FinmodelTableQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["FinmodelTable.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<FinmodelTableQuery, FinmodelTableQueryVariables>(
            FinmodelTableDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteFinmodelTableQuery.getKey = (variables: FinmodelTableQueryVariables) => [
  "FinmodelTable.infinite",
  variables,
]

useInfiniteFinmodelTableQuery.rootKey = "FinmodelTable.infinite"

export const useSuspenseInfiniteFinmodelTableQuery = <
  TData = InfiniteData<FinmodelTableQuery>,
  TError = unknown,
>(
  variables: FinmodelTableQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<FinmodelTableQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      FinmodelTableQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<FinmodelTableQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["FinmodelTable.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<FinmodelTableQuery, FinmodelTableQueryVariables>(
            FinmodelTableDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteFinmodelTableQuery.getKey = (
  variables: FinmodelTableQueryVariables,
) => ["FinmodelTable.infiniteSuspense", variables]

useSuspenseInfiniteFinmodelTableQuery.rootKey = "FinmodelTable.infinite"

useFinmodelTableQuery.fetcher = (
  variables: FinmodelTableQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<FinmodelTableQuery, FinmodelTableQueryVariables>(
    FinmodelTableDocument,
    variables,
    options,
  )

export const FinmodelTableRowsDocument = `
    query FinmodelTableRows($sitePid: String!, $ids: [Int!]!) {
  site(pid: $sitePid) {
    finmodelTable {
      rows(keys: $ids) {
        id
        createdAt
        name
        fmvStr
        type
        buildingOwnerNoiLifetimeUsd
        scenarioPid
        scenarioName
        scenarioSolarLocation
        scenarioIncludeStorage
      }
    }
  }
}
    `

export const useFinmodelTableRowsQuery = <
  TData = FinmodelTableRowsQuery,
  TError = unknown,
>(
  variables: FinmodelTableRowsQueryVariables,
  options?: Omit<UseQueryOptions<FinmodelTableRowsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<FinmodelTableRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<FinmodelTableRowsQuery, TError, TData>({
    queryKey: ["FinmodelTableRows", variables],
    queryFn: adminFetcher<FinmodelTableRowsQuery, FinmodelTableRowsQueryVariables>(
      FinmodelTableRowsDocument,
      variables,
    ),
    ...options,
  })
}

useFinmodelTableRowsQuery.getKey = (variables: FinmodelTableRowsQueryVariables) => [
  "FinmodelTableRows",
  variables,
]

useFinmodelTableRowsQuery.rootKey = "FinmodelTableRows"

export const useSuspenseFinmodelTableRowsQuery = <
  TData = FinmodelTableRowsQuery,
  TError = unknown,
>(
  variables: FinmodelTableRowsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<FinmodelTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      FinmodelTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<FinmodelTableRowsQuery, TError, TData>({
    queryKey: ["FinmodelTableRowsSuspense", variables],
    queryFn: adminFetcher<FinmodelTableRowsQuery, FinmodelTableRowsQueryVariables>(
      FinmodelTableRowsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseFinmodelTableRowsQuery.getKey = (
  variables: FinmodelTableRowsQueryVariables,
) => ["FinmodelTableRowsSuspense", variables]

useSuspenseFinmodelTableRowsQuery.rootKey = "FinmodelTableRows"

export const useInfiniteFinmodelTableRowsQuery = <
  TData = InfiniteData<FinmodelTableRowsQuery>,
  TError = unknown,
>(
  variables: FinmodelTableRowsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<FinmodelTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      FinmodelTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<FinmodelTableRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["FinmodelTableRows.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<FinmodelTableRowsQuery, FinmodelTableRowsQueryVariables>(
            FinmodelTableRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteFinmodelTableRowsQuery.getKey = (
  variables: FinmodelTableRowsQueryVariables,
) => ["FinmodelTableRows.infinite", variables]

useInfiniteFinmodelTableRowsQuery.rootKey = "FinmodelTableRows.infinite"

export const useSuspenseInfiniteFinmodelTableRowsQuery = <
  TData = InfiniteData<FinmodelTableRowsQuery>,
  TError = unknown,
>(
  variables: FinmodelTableRowsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<FinmodelTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      FinmodelTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<FinmodelTableRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["FinmodelTableRows.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<FinmodelTableRowsQuery, FinmodelTableRowsQueryVariables>(
            FinmodelTableRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteFinmodelTableRowsQuery.getKey = (
  variables: FinmodelTableRowsQueryVariables,
) => ["FinmodelTableRows.infiniteSuspense", variables]

useSuspenseInfiniteFinmodelTableRowsQuery.rootKey = "FinmodelTableRows.infinite"

useFinmodelTableRowsQuery.fetcher = (
  variables: FinmodelTableRowsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<FinmodelTableRowsQuery, FinmodelTableRowsQueryVariables>(
    FinmodelTableRowsDocument,
    variables,
    options,
  )

export const FinmodelDetail2Document = `
    query FinmodelDetail2($sitePid: String!, $id: Int!) {
  site(pid: $sitePid) {
    finmodel(id: $id) {
      ...AdminFinmodelDetail
    }
  }
}
    ${AdminFinmodelDetailFragmentDoc}
${RevampFinmodelFragmentDoc}
${KwhFlowFragmentDoc}
${RevampSystemFragmentDoc}
${FinmodelCostFragmentDoc}`

export const useFinmodelDetail2Query = <TData = FinmodelDetail2Query, TError = unknown>(
  variables: FinmodelDetail2QueryVariables,
  options?: Omit<UseQueryOptions<FinmodelDetail2Query, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<FinmodelDetail2Query, TError, TData>["queryKey"]
  },
) => {
  return useQuery<FinmodelDetail2Query, TError, TData>({
    queryKey: ["FinmodelDetail2", variables],
    queryFn: adminFetcher<FinmodelDetail2Query, FinmodelDetail2QueryVariables>(
      FinmodelDetail2Document,
      variables,
    ),
    ...options,
  })
}

useFinmodelDetail2Query.getKey = (variables: FinmodelDetail2QueryVariables) => [
  "FinmodelDetail2",
  variables,
]

useFinmodelDetail2Query.rootKey = "FinmodelDetail2"

export const useSuspenseFinmodelDetail2Query = <
  TData = FinmodelDetail2Query,
  TError = unknown,
>(
  variables: FinmodelDetail2QueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<FinmodelDetail2Query, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<FinmodelDetail2Query, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<FinmodelDetail2Query, TError, TData>({
    queryKey: ["FinmodelDetail2Suspense", variables],
    queryFn: adminFetcher<FinmodelDetail2Query, FinmodelDetail2QueryVariables>(
      FinmodelDetail2Document,
      variables,
    ),
    ...options,
  })
}

useSuspenseFinmodelDetail2Query.getKey = (variables: FinmodelDetail2QueryVariables) => [
  "FinmodelDetail2Suspense",
  variables,
]

useSuspenseFinmodelDetail2Query.rootKey = "FinmodelDetail2"

export const useInfiniteFinmodelDetail2Query = <
  TData = InfiniteData<FinmodelDetail2Query>,
  TError = unknown,
>(
  variables: FinmodelDetail2QueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<FinmodelDetail2Query, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<FinmodelDetail2Query, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<FinmodelDetail2Query, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["FinmodelDetail2.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<FinmodelDetail2Query, FinmodelDetail2QueryVariables>(
            FinmodelDetail2Document,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteFinmodelDetail2Query.getKey = (variables: FinmodelDetail2QueryVariables) => [
  "FinmodelDetail2.infinite",
  variables,
]

useInfiniteFinmodelDetail2Query.rootKey = "FinmodelDetail2.infinite"

export const useSuspenseInfiniteFinmodelDetail2Query = <
  TData = InfiniteData<FinmodelDetail2Query>,
  TError = unknown,
>(
  variables: FinmodelDetail2QueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<FinmodelDetail2Query, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      FinmodelDetail2Query,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<FinmodelDetail2Query, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["FinmodelDetail2.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<FinmodelDetail2Query, FinmodelDetail2QueryVariables>(
            FinmodelDetail2Document,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteFinmodelDetail2Query.getKey = (
  variables: FinmodelDetail2QueryVariables,
) => ["FinmodelDetail2.infiniteSuspense", variables]

useSuspenseInfiniteFinmodelDetail2Query.rootKey = "FinmodelDetail2.infinite"

useFinmodelDetail2Query.fetcher = (
  variables: FinmodelDetail2QueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<FinmodelDetail2Query, FinmodelDetail2QueryVariables>(
    FinmodelDetail2Document,
    variables,
    options,
  )

export const FinmodelLineageDocument = `
    query FinmodelLineage($sitePid: String!, $id: Int!) {
  site(pid: $sitePid) {
    finmodel(id: $id) {
      id
      moreDetails {
        lineage {
          ...AdminFinmodelDetail
        }
      }
    }
  }
}
    ${AdminFinmodelDetailFragmentDoc}
${RevampFinmodelFragmentDoc}
${KwhFlowFragmentDoc}
${RevampSystemFragmentDoc}
${FinmodelCostFragmentDoc}`

export const useFinmodelLineageQuery = <TData = FinmodelLineageQuery, TError = unknown>(
  variables: FinmodelLineageQueryVariables,
  options?: Omit<UseQueryOptions<FinmodelLineageQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<FinmodelLineageQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<FinmodelLineageQuery, TError, TData>({
    queryKey: ["FinmodelLineage", variables],
    queryFn: adminFetcher<FinmodelLineageQuery, FinmodelLineageQueryVariables>(
      FinmodelLineageDocument,
      variables,
    ),
    ...options,
  })
}

useFinmodelLineageQuery.getKey = (variables: FinmodelLineageQueryVariables) => [
  "FinmodelLineage",
  variables,
]

useFinmodelLineageQuery.rootKey = "FinmodelLineage"

export const useSuspenseFinmodelLineageQuery = <
  TData = FinmodelLineageQuery,
  TError = unknown,
>(
  variables: FinmodelLineageQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<FinmodelLineageQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<FinmodelLineageQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<FinmodelLineageQuery, TError, TData>({
    queryKey: ["FinmodelLineageSuspense", variables],
    queryFn: adminFetcher<FinmodelLineageQuery, FinmodelLineageQueryVariables>(
      FinmodelLineageDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseFinmodelLineageQuery.getKey = (variables: FinmodelLineageQueryVariables) => [
  "FinmodelLineageSuspense",
  variables,
]

useSuspenseFinmodelLineageQuery.rootKey = "FinmodelLineage"

export const useInfiniteFinmodelLineageQuery = <
  TData = InfiniteData<FinmodelLineageQuery>,
  TError = unknown,
>(
  variables: FinmodelLineageQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<FinmodelLineageQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<FinmodelLineageQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<FinmodelLineageQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["FinmodelLineage.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<FinmodelLineageQuery, FinmodelLineageQueryVariables>(
            FinmodelLineageDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteFinmodelLineageQuery.getKey = (variables: FinmodelLineageQueryVariables) => [
  "FinmodelLineage.infinite",
  variables,
]

useInfiniteFinmodelLineageQuery.rootKey = "FinmodelLineage.infinite"

export const useSuspenseInfiniteFinmodelLineageQuery = <
  TData = InfiniteData<FinmodelLineageQuery>,
  TError = unknown,
>(
  variables: FinmodelLineageQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<FinmodelLineageQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      FinmodelLineageQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<FinmodelLineageQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["FinmodelLineage.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<FinmodelLineageQuery, FinmodelLineageQueryVariables>(
            FinmodelLineageDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteFinmodelLineageQuery.getKey = (
  variables: FinmodelLineageQueryVariables,
) => ["FinmodelLineage.infiniteSuspense", variables]

useSuspenseInfiniteFinmodelLineageQuery.rootKey = "FinmodelLineage.infinite"

useFinmodelLineageQuery.fetcher = (
  variables: FinmodelLineageQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<FinmodelLineageQuery, FinmodelLineageQueryVariables>(
    FinmodelLineageDocument,
    variables,
    options,
  )

export const SiteLabelsDocument = `
    query SiteLabels($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    labels {
      pid
      name
      themeColor
    }
    portfolio {
      pid
      org {
        labels {
          pid
          name
          themeColor
        }
      }
    }
  }
}
    `

export const useSiteLabelsQuery = <TData = SiteLabelsQuery, TError = unknown>(
  variables: SiteLabelsQueryVariables,
  options?: Omit<UseQueryOptions<SiteLabelsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SiteLabelsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteLabelsQuery, TError, TData>({
    queryKey: ["SiteLabels", variables],
    queryFn: adminFetcher<SiteLabelsQuery, SiteLabelsQueryVariables>(
      SiteLabelsDocument,
      variables,
    ),
    ...options,
  })
}

useSiteLabelsQuery.getKey = (variables: SiteLabelsQueryVariables) => [
  "SiteLabels",
  variables,
]

useSiteLabelsQuery.rootKey = "SiteLabels"

export const useSuspenseSiteLabelsQuery = <TData = SiteLabelsQuery, TError = unknown>(
  variables: SiteLabelsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteLabelsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<SiteLabelsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteLabelsQuery, TError, TData>({
    queryKey: ["SiteLabelsSuspense", variables],
    queryFn: adminFetcher<SiteLabelsQuery, SiteLabelsQueryVariables>(
      SiteLabelsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteLabelsQuery.getKey = (variables: SiteLabelsQueryVariables) => [
  "SiteLabelsSuspense",
  variables,
]

useSuspenseSiteLabelsQuery.rootKey = "SiteLabels"

export const useInfiniteSiteLabelsQuery = <
  TData = InfiniteData<SiteLabelsQuery>,
  TError = unknown,
>(
  variables: SiteLabelsQueryVariables,
  options: Omit<UseInfiniteQueryOptions<SiteLabelsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<SiteLabelsQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteLabelsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteLabels.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteLabelsQuery, SiteLabelsQueryVariables>(SiteLabelsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteLabelsQuery.getKey = (variables: SiteLabelsQueryVariables) => [
  "SiteLabels.infinite",
  variables,
]

useInfiniteSiteLabelsQuery.rootKey = "SiteLabels.infinite"

export const useSuspenseInfiniteSiteLabelsQuery = <
  TData = InfiniteData<SiteLabelsQuery>,
  TError = unknown,
>(
  variables: SiteLabelsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteLabelsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteLabelsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteLabelsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteLabels.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteLabelsQuery, SiteLabelsQueryVariables>(SiteLabelsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteLabelsQuery.getKey = (variables: SiteLabelsQueryVariables) => [
  "SiteLabels.infiniteSuspense",
  variables,
]

useSuspenseInfiniteSiteLabelsQuery.rootKey = "SiteLabels.infinite"

useSiteLabelsQuery.fetcher = (
  variables: SiteLabelsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SiteLabelsQuery, SiteLabelsQueryVariables>(
    SiteLabelsDocument,
    variables,
    options,
  )

export const Xl2RenderDocument = `
    query Xl2Render {
  xl2
}
    `

export const useXl2RenderQuery = <TData = Xl2RenderQuery, TError = unknown>(
  variables?: Xl2RenderQueryVariables,
  options?: Omit<UseQueryOptions<Xl2RenderQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<Xl2RenderQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<Xl2RenderQuery, TError, TData>({
    queryKey: variables === undefined ? ["Xl2Render"] : ["Xl2Render", variables],
    queryFn: adminFetcher<Xl2RenderQuery, Xl2RenderQueryVariables>(
      Xl2RenderDocument,
      variables,
    ),
    ...options,
  })
}

useXl2RenderQuery.getKey = (variables?: Xl2RenderQueryVariables) =>
  variables === undefined ? ["Xl2Render"] : ["Xl2Render", variables]

useXl2RenderQuery.rootKey = "Xl2Render"

export const useSuspenseXl2RenderQuery = <TData = Xl2RenderQuery, TError = unknown>(
  variables?: Xl2RenderQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<Xl2RenderQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<Xl2RenderQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<Xl2RenderQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["Xl2RenderSuspense"]
        : ["Xl2RenderSuspense", variables],
    queryFn: adminFetcher<Xl2RenderQuery, Xl2RenderQueryVariables>(
      Xl2RenderDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseXl2RenderQuery.getKey = (variables?: Xl2RenderQueryVariables) =>
  variables === undefined ? ["Xl2RenderSuspense"] : ["Xl2RenderSuspense", variables]

useSuspenseXl2RenderQuery.rootKey = "Xl2Render"

export const useInfiniteXl2RenderQuery = <
  TData = InfiniteData<Xl2RenderQuery>,
  TError = unknown,
>(
  variables: Xl2RenderQueryVariables,
  options: Omit<UseInfiniteQueryOptions<Xl2RenderQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<Xl2RenderQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<Xl2RenderQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["Xl2Render.infinite"]
            : ["Xl2Render.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<Xl2RenderQuery, Xl2RenderQueryVariables>(Xl2RenderDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteXl2RenderQuery.getKey = (variables?: Xl2RenderQueryVariables) =>
  variables === undefined ? ["Xl2Render.infinite"] : ["Xl2Render.infinite", variables]

useInfiniteXl2RenderQuery.rootKey = "Xl2Render.infinite"

export const useSuspenseInfiniteXl2RenderQuery = <
  TData = InfiniteData<Xl2RenderQuery>,
  TError = unknown,
>(
  variables: Xl2RenderQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<Xl2RenderQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      Xl2RenderQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<Xl2RenderQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["Xl2Render.infiniteSuspense"]
            : ["Xl2Render.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<Xl2RenderQuery, Xl2RenderQueryVariables>(Xl2RenderDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteXl2RenderQuery.getKey = (variables?: Xl2RenderQueryVariables) =>
  variables === undefined
    ? ["Xl2Render.infiniteSuspense"]
    : ["Xl2Render.infiniteSuspense", variables]

useSuspenseInfiniteXl2RenderQuery.rootKey = "Xl2Render.infinite"

useXl2RenderQuery.fetcher = (
  variables?: Xl2RenderQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<Xl2RenderQuery, Xl2RenderQueryVariables>(
    Xl2RenderDocument,
    variables,
    options,
  )

export const TaskCountsDocument = `
    query TaskCounts($orgPid: String, $sitePid: String) {
  taskCounts(orgPid: $orgPid, sitePid: $sitePid) {
    name
    runningCount
    pendingCount
    successCount
    failureCount
  }
}
    `

export const useTaskCountsQuery = <TData = TaskCountsQuery, TError = unknown>(
  variables?: TaskCountsQueryVariables,
  options?: Omit<UseQueryOptions<TaskCountsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<TaskCountsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<TaskCountsQuery, TError, TData>({
    queryKey: variables === undefined ? ["TaskCounts"] : ["TaskCounts", variables],
    queryFn: adminFetcher<TaskCountsQuery, TaskCountsQueryVariables>(
      TaskCountsDocument,
      variables,
    ),
    ...options,
  })
}

useTaskCountsQuery.getKey = (variables?: TaskCountsQueryVariables) =>
  variables === undefined ? ["TaskCounts"] : ["TaskCounts", variables]

useTaskCountsQuery.rootKey = "TaskCounts"

export const useSuspenseTaskCountsQuery = <TData = TaskCountsQuery, TError = unknown>(
  variables?: TaskCountsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<TaskCountsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<TaskCountsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<TaskCountsQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["TaskCountsSuspense"]
        : ["TaskCountsSuspense", variables],
    queryFn: adminFetcher<TaskCountsQuery, TaskCountsQueryVariables>(
      TaskCountsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseTaskCountsQuery.getKey = (variables?: TaskCountsQueryVariables) =>
  variables === undefined ? ["TaskCountsSuspense"] : ["TaskCountsSuspense", variables]

useSuspenseTaskCountsQuery.rootKey = "TaskCounts"

export const useInfiniteTaskCountsQuery = <
  TData = InfiniteData<TaskCountsQuery>,
  TError = unknown,
>(
  variables: TaskCountsQueryVariables,
  options: Omit<UseInfiniteQueryOptions<TaskCountsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<TaskCountsQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<TaskCountsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["TaskCounts.infinite"]
            : ["TaskCounts.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<TaskCountsQuery, TaskCountsQueryVariables>(TaskCountsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteTaskCountsQuery.getKey = (variables?: TaskCountsQueryVariables) =>
  variables === undefined ? ["TaskCounts.infinite"] : ["TaskCounts.infinite", variables]

useInfiniteTaskCountsQuery.rootKey = "TaskCounts.infinite"

export const useSuspenseInfiniteTaskCountsQuery = <
  TData = InfiniteData<TaskCountsQuery>,
  TError = unknown,
>(
  variables: TaskCountsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<TaskCountsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      TaskCountsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<TaskCountsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["TaskCounts.infiniteSuspense"]
            : ["TaskCounts.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<TaskCountsQuery, TaskCountsQueryVariables>(TaskCountsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteTaskCountsQuery.getKey = (variables?: TaskCountsQueryVariables) =>
  variables === undefined
    ? ["TaskCounts.infiniteSuspense"]
    : ["TaskCounts.infiniteSuspense", variables]

useSuspenseInfiniteTaskCountsQuery.rootKey = "TaskCounts.infinite"

useTaskCountsQuery.fetcher = (
  variables?: TaskCountsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<TaskCountsQuery, TaskCountsQueryVariables>(
    TaskCountsDocument,
    variables,
    options,
  )

export const OplogCountsDocument = `
    query OplogCounts {
  oplogCounts {
    name
    runningCount
    pendingCount
    successCount
    failureCount
  }
}
    `

export const useOplogCountsQuery = <TData = OplogCountsQuery, TError = unknown>(
  variables?: OplogCountsQueryVariables,
  options?: Omit<UseQueryOptions<OplogCountsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<OplogCountsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OplogCountsQuery, TError, TData>({
    queryKey: variables === undefined ? ["OplogCounts"] : ["OplogCounts", variables],
    queryFn: adminFetcher<OplogCountsQuery, OplogCountsQueryVariables>(
      OplogCountsDocument,
      variables,
    ),
    ...options,
  })
}

useOplogCountsQuery.getKey = (variables?: OplogCountsQueryVariables) =>
  variables === undefined ? ["OplogCounts"] : ["OplogCounts", variables]

useOplogCountsQuery.rootKey = "OplogCounts"

export const useSuspenseOplogCountsQuery = <TData = OplogCountsQuery, TError = unknown>(
  variables?: OplogCountsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<OplogCountsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<OplogCountsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<OplogCountsQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["OplogCountsSuspense"]
        : ["OplogCountsSuspense", variables],
    queryFn: adminFetcher<OplogCountsQuery, OplogCountsQueryVariables>(
      OplogCountsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseOplogCountsQuery.getKey = (variables?: OplogCountsQueryVariables) =>
  variables === undefined ? ["OplogCountsSuspense"] : ["OplogCountsSuspense", variables]

useSuspenseOplogCountsQuery.rootKey = "OplogCounts"

export const useInfiniteOplogCountsQuery = <
  TData = InfiniteData<OplogCountsQuery>,
  TError = unknown,
>(
  variables: OplogCountsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<OplogCountsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<OplogCountsQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<OplogCountsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["OplogCounts.infinite"]
            : ["OplogCounts.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<OplogCountsQuery, OplogCountsQueryVariables>(
            OplogCountsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOplogCountsQuery.getKey = (variables?: OplogCountsQueryVariables) =>
  variables === undefined
    ? ["OplogCounts.infinite"]
    : ["OplogCounts.infinite", variables]

useInfiniteOplogCountsQuery.rootKey = "OplogCounts.infinite"

export const useSuspenseInfiniteOplogCountsQuery = <
  TData = InfiniteData<OplogCountsQuery>,
  TError = unknown,
>(
  variables: OplogCountsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OplogCountsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      OplogCountsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OplogCountsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["OplogCounts.infiniteSuspense"]
            : ["OplogCounts.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<OplogCountsQuery, OplogCountsQueryVariables>(
            OplogCountsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOplogCountsQuery.getKey = (variables?: OplogCountsQueryVariables) =>
  variables === undefined
    ? ["OplogCounts.infiniteSuspense"]
    : ["OplogCounts.infiniteSuspense", variables]

useSuspenseInfiniteOplogCountsQuery.rootKey = "OplogCounts.infinite"

useOplogCountsQuery.fetcher = (
  variables?: OplogCountsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<OplogCountsQuery, OplogCountsQueryVariables>(
    OplogCountsDocument,
    variables,
    options,
  )

export const ActiveBoostsDocument = `
    query ActiveBoosts($orgPid: String!) {
  activeBoosts(orgPid: $orgPid)
}
    `

export const useActiveBoostsQuery = <TData = ActiveBoostsQuery, TError = unknown>(
  variables: ActiveBoostsQueryVariables,
  options?: Omit<UseQueryOptions<ActiveBoostsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<ActiveBoostsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ActiveBoostsQuery, TError, TData>({
    queryKey: ["ActiveBoosts", variables],
    queryFn: adminFetcher<ActiveBoostsQuery, ActiveBoostsQueryVariables>(
      ActiveBoostsDocument,
      variables,
    ),
    ...options,
  })
}

useActiveBoostsQuery.getKey = (variables: ActiveBoostsQueryVariables) => [
  "ActiveBoosts",
  variables,
]

useActiveBoostsQuery.rootKey = "ActiveBoosts"

export const useSuspenseActiveBoostsQuery = <
  TData = ActiveBoostsQuery,
  TError = unknown,
>(
  variables: ActiveBoostsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ActiveBoostsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<ActiveBoostsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<ActiveBoostsQuery, TError, TData>({
    queryKey: ["ActiveBoostsSuspense", variables],
    queryFn: adminFetcher<ActiveBoostsQuery, ActiveBoostsQueryVariables>(
      ActiveBoostsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseActiveBoostsQuery.getKey = (variables: ActiveBoostsQueryVariables) => [
  "ActiveBoostsSuspense",
  variables,
]

useSuspenseActiveBoostsQuery.rootKey = "ActiveBoosts"

export const useInfiniteActiveBoostsQuery = <
  TData = InfiniteData<ActiveBoostsQuery>,
  TError = unknown,
>(
  variables: ActiveBoostsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ActiveBoostsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<ActiveBoostsQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<ActiveBoostsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ActiveBoosts.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<ActiveBoostsQuery, ActiveBoostsQueryVariables>(
            ActiveBoostsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteActiveBoostsQuery.getKey = (variables: ActiveBoostsQueryVariables) => [
  "ActiveBoosts.infinite",
  variables,
]

useInfiniteActiveBoostsQuery.rootKey = "ActiveBoosts.infinite"

export const useSuspenseInfiniteActiveBoostsQuery = <
  TData = InfiniteData<ActiveBoostsQuery>,
  TError = unknown,
>(
  variables: ActiveBoostsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ActiveBoostsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ActiveBoostsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ActiveBoostsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ActiveBoosts.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<ActiveBoostsQuery, ActiveBoostsQueryVariables>(
            ActiveBoostsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteActiveBoostsQuery.getKey = (
  variables: ActiveBoostsQueryVariables,
) => ["ActiveBoosts.infiniteSuspense", variables]

useSuspenseInfiniteActiveBoostsQuery.rootKey = "ActiveBoosts.infinite"

useActiveBoostsQuery.fetcher = (
  variables: ActiveBoostsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ActiveBoostsQuery, ActiveBoostsQueryVariables>(
    ActiveBoostsDocument,
    variables,
    options,
  )

export const OrgPriorityDocument = `
    query OrgPriority($orgPid: String!) {
  orgPriority(orgPid: $orgPid)
}
    `

export const useOrgPriorityQuery = <TData = OrgPriorityQuery, TError = unknown>(
  variables: OrgPriorityQueryVariables,
  options?: Omit<UseQueryOptions<OrgPriorityQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<OrgPriorityQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OrgPriorityQuery, TError, TData>({
    queryKey: ["OrgPriority", variables],
    queryFn: adminFetcher<OrgPriorityQuery, OrgPriorityQueryVariables>(
      OrgPriorityDocument,
      variables,
    ),
    ...options,
  })
}

useOrgPriorityQuery.getKey = (variables: OrgPriorityQueryVariables) => [
  "OrgPriority",
  variables,
]

useOrgPriorityQuery.rootKey = "OrgPriority"

export const useSuspenseOrgPriorityQuery = <TData = OrgPriorityQuery, TError = unknown>(
  variables: OrgPriorityQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<OrgPriorityQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<OrgPriorityQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<OrgPriorityQuery, TError, TData>({
    queryKey: ["OrgPrioritySuspense", variables],
    queryFn: adminFetcher<OrgPriorityQuery, OrgPriorityQueryVariables>(
      OrgPriorityDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseOrgPriorityQuery.getKey = (variables: OrgPriorityQueryVariables) => [
  "OrgPrioritySuspense",
  variables,
]

useSuspenseOrgPriorityQuery.rootKey = "OrgPriority"

export const useInfiniteOrgPriorityQuery = <
  TData = InfiniteData<OrgPriorityQuery>,
  TError = unknown,
>(
  variables: OrgPriorityQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<OrgPriorityQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<OrgPriorityQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<OrgPriorityQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgPriority.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<OrgPriorityQuery, OrgPriorityQueryVariables>(
            OrgPriorityDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOrgPriorityQuery.getKey = (variables: OrgPriorityQueryVariables) => [
  "OrgPriority.infinite",
  variables,
]

useInfiniteOrgPriorityQuery.rootKey = "OrgPriority.infinite"

export const useSuspenseInfiniteOrgPriorityQuery = <
  TData = InfiniteData<OrgPriorityQuery>,
  TError = unknown,
>(
  variables: OrgPriorityQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OrgPriorityQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      OrgPriorityQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OrgPriorityQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgPriority.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<OrgPriorityQuery, OrgPriorityQueryVariables>(
            OrgPriorityDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOrgPriorityQuery.getKey = (variables: OrgPriorityQueryVariables) => [
  "OrgPriority.infiniteSuspense",
  variables,
]

useSuspenseInfiniteOrgPriorityQuery.rootKey = "OrgPriority.infinite"

useOrgPriorityQuery.fetcher = (
  variables: OrgPriorityQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<OrgPriorityQuery, OrgPriorityQueryVariables>(
    OrgPriorityDocument,
    variables,
    options,
  )

export const ConserviceSearchDocument = `
    query ConserviceSearch($sitePid: String!, $onlyHouse: Boolean!) {
  site(pid: $sitePid) {
    portfolio {
      pid
      org {
        pid
      }
    }
    conserviceSearch(onlyHouse: $onlyHouse) {
      name
      count
      matched
    }
  }
}
    `

export const useConserviceSearchQuery = <
  TData = ConserviceSearchQuery,
  TError = unknown,
>(
  variables: ConserviceSearchQueryVariables,
  options?: Omit<UseQueryOptions<ConserviceSearchQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<ConserviceSearchQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ConserviceSearchQuery, TError, TData>({
    queryKey: ["ConserviceSearch", variables],
    queryFn: adminFetcher<ConserviceSearchQuery, ConserviceSearchQueryVariables>(
      ConserviceSearchDocument,
      variables,
    ),
    ...options,
  })
}

useConserviceSearchQuery.getKey = (variables: ConserviceSearchQueryVariables) => [
  "ConserviceSearch",
  variables,
]

useConserviceSearchQuery.rootKey = "ConserviceSearch"

export const useSuspenseConserviceSearchQuery = <
  TData = ConserviceSearchQuery,
  TError = unknown,
>(
  variables: ConserviceSearchQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ConserviceSearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<ConserviceSearchQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<ConserviceSearchQuery, TError, TData>({
    queryKey: ["ConserviceSearchSuspense", variables],
    queryFn: adminFetcher<ConserviceSearchQuery, ConserviceSearchQueryVariables>(
      ConserviceSearchDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseConserviceSearchQuery.getKey = (
  variables: ConserviceSearchQueryVariables,
) => ["ConserviceSearchSuspense", variables]

useSuspenseConserviceSearchQuery.rootKey = "ConserviceSearch"

export const useInfiniteConserviceSearchQuery = <
  TData = InfiniteData<ConserviceSearchQuery>,
  TError = unknown,
>(
  variables: ConserviceSearchQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ConserviceSearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<ConserviceSearchQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<ConserviceSearchQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ConserviceSearch.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<ConserviceSearchQuery, ConserviceSearchQueryVariables>(
            ConserviceSearchDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteConserviceSearchQuery.getKey = (
  variables: ConserviceSearchQueryVariables,
) => ["ConserviceSearch.infinite", variables]

useInfiniteConserviceSearchQuery.rootKey = "ConserviceSearch.infinite"

export const useSuspenseInfiniteConserviceSearchQuery = <
  TData = InfiniteData<ConserviceSearchQuery>,
  TError = unknown,
>(
  variables: ConserviceSearchQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ConserviceSearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ConserviceSearchQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ConserviceSearchQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ConserviceSearch.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<ConserviceSearchQuery, ConserviceSearchQueryVariables>(
            ConserviceSearchDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteConserviceSearchQuery.getKey = (
  variables: ConserviceSearchQueryVariables,
) => ["ConserviceSearch.infiniteSuspense", variables]

useSuspenseInfiniteConserviceSearchQuery.rootKey = "ConserviceSearch.infinite"

useConserviceSearchQuery.fetcher = (
  variables: ConserviceSearchQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ConserviceSearchQuery, ConserviceSearchQueryVariables>(
    ConserviceSearchDocument,
    variables,
    options,
  )

export const SiteResultConfigDocument = `
    query SiteResultConfig($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    resultConfig {
      finproduct {
        id
        type
        name
        financier {
          name
          pid
        }
      }
      disabledAt
      finrelDisabledAt
    }
  }
}
    `

export const useSiteResultConfigQuery = <
  TData = SiteResultConfigQuery,
  TError = unknown,
>(
  variables: SiteResultConfigQueryVariables,
  options?: Omit<UseQueryOptions<SiteResultConfigQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SiteResultConfigQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteResultConfigQuery, TError, TData>({
    queryKey: ["SiteResultConfig", variables],
    queryFn: adminFetcher<SiteResultConfigQuery, SiteResultConfigQueryVariables>(
      SiteResultConfigDocument,
      variables,
    ),
    ...options,
  })
}

useSiteResultConfigQuery.getKey = (variables: SiteResultConfigQueryVariables) => [
  "SiteResultConfig",
  variables,
]

useSiteResultConfigQuery.rootKey = "SiteResultConfig"

export const useSuspenseSiteResultConfigQuery = <
  TData = SiteResultConfigQuery,
  TError = unknown,
>(
  variables: SiteResultConfigQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteResultConfigQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<SiteResultConfigQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteResultConfigQuery, TError, TData>({
    queryKey: ["SiteResultConfigSuspense", variables],
    queryFn: adminFetcher<SiteResultConfigQuery, SiteResultConfigQueryVariables>(
      SiteResultConfigDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteResultConfigQuery.getKey = (
  variables: SiteResultConfigQueryVariables,
) => ["SiteResultConfigSuspense", variables]

useSuspenseSiteResultConfigQuery.rootKey = "SiteResultConfig"

export const useInfiniteSiteResultConfigQuery = <
  TData = InfiniteData<SiteResultConfigQuery>,
  TError = unknown,
>(
  variables: SiteResultConfigQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SiteResultConfigQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<SiteResultConfigQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteResultConfigQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteResultConfig.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteResultConfigQuery, SiteResultConfigQueryVariables>(
            SiteResultConfigDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteResultConfigQuery.getKey = (
  variables: SiteResultConfigQueryVariables,
) => ["SiteResultConfig.infinite", variables]

useInfiniteSiteResultConfigQuery.rootKey = "SiteResultConfig.infinite"

export const useSuspenseInfiniteSiteResultConfigQuery = <
  TData = InfiniteData<SiteResultConfigQuery>,
  TError = unknown,
>(
  variables: SiteResultConfigQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteResultConfigQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteResultConfigQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteResultConfigQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteResultConfig.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteResultConfigQuery, SiteResultConfigQueryVariables>(
            SiteResultConfigDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteResultConfigQuery.getKey = (
  variables: SiteResultConfigQueryVariables,
) => ["SiteResultConfig.infiniteSuspense", variables]

useSuspenseInfiniteSiteResultConfigQuery.rootKey = "SiteResultConfig.infinite"

useSiteResultConfigQuery.fetcher = (
  variables: SiteResultConfigQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SiteResultConfigQuery, SiteResultConfigQueryVariables>(
    SiteResultConfigDocument,
    variables,
    options,
  )

export const SiteTodosDocument = `
    query SiteTodos($sitePid: String!) {
  site(pid: $sitePid) {
    id
    pid
    todos {
      id
      content
      index
      createdAt
      createdBy {
        pid
        email
      }
      updatedAt
      updatedBy {
        pid
        email
      }
      completedAt
      completedBy {
        pid
        email
      }
      section {
        id
        name
        index
      }
    }
  }
}
    `

export const useSiteTodosQuery = <TData = SiteTodosQuery, TError = unknown>(
  variables: SiteTodosQueryVariables,
  options?: Omit<UseQueryOptions<SiteTodosQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SiteTodosQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteTodosQuery, TError, TData>({
    queryKey: ["SiteTodos", variables],
    queryFn: adminFetcher<SiteTodosQuery, SiteTodosQueryVariables>(
      SiteTodosDocument,
      variables,
    ),
    ...options,
  })
}

useSiteTodosQuery.getKey = (variables: SiteTodosQueryVariables) => [
  "SiteTodos",
  variables,
]

useSiteTodosQuery.rootKey = "SiteTodos"

export const useSuspenseSiteTodosQuery = <TData = SiteTodosQuery, TError = unknown>(
  variables: SiteTodosQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<SiteTodosQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<SiteTodosQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteTodosQuery, TError, TData>({
    queryKey: ["SiteTodosSuspense", variables],
    queryFn: adminFetcher<SiteTodosQuery, SiteTodosQueryVariables>(
      SiteTodosDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteTodosQuery.getKey = (variables: SiteTodosQueryVariables) => [
  "SiteTodosSuspense",
  variables,
]

useSuspenseSiteTodosQuery.rootKey = "SiteTodos"

export const useInfiniteSiteTodosQuery = <
  TData = InfiniteData<SiteTodosQuery>,
  TError = unknown,
>(
  variables: SiteTodosQueryVariables,
  options: Omit<UseInfiniteQueryOptions<SiteTodosQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<SiteTodosQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteTodosQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteTodos.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteTodosQuery, SiteTodosQueryVariables>(SiteTodosDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteTodosQuery.getKey = (variables: SiteTodosQueryVariables) => [
  "SiteTodos.infinite",
  variables,
]

useInfiniteSiteTodosQuery.rootKey = "SiteTodos.infinite"

export const useSuspenseInfiniteSiteTodosQuery = <
  TData = InfiniteData<SiteTodosQuery>,
  TError = unknown,
>(
  variables: SiteTodosQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteTodosQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteTodosQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteTodosQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteTodos.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteTodosQuery, SiteTodosQueryVariables>(SiteTodosDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteTodosQuery.getKey = (variables: SiteTodosQueryVariables) => [
  "SiteTodos.infiniteSuspense",
  variables,
]

useSuspenseInfiniteSiteTodosQuery.rootKey = "SiteTodos.infinite"

useSiteTodosQuery.fetcher = (
  variables: SiteTodosQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SiteTodosQuery, SiteTodosQueryVariables>(
    SiteTodosDocument,
    variables,
    options,
  )

export const SiteEspmDocument = `
    query SiteEspm($sitePid: String!) {
  site(pid: $sitePid) {
    pid
    espm {
      id
      createdAt
      lastUpdatedAt
      externalPropertyId
      xml
      accounts {
        id
        createdAt
        lastUpdatedAt
        externalAccountId
        xml
      }
      espmMeters {
        id
        createdAt
        lastUpdatedAt
        externalMeterId
        xml
        unitOfMeasure
        meterType
        espmConsumptions {
          id
          createdAt
          lastUpdatedAt
          externalConsumptionId
          xml
          start
          end
          usageKwh
          costUsd
        }
      }
    }
  }
}
    `

export const useSiteEspmQuery = <TData = SiteEspmQuery, TError = unknown>(
  variables: SiteEspmQueryVariables,
  options?: Omit<UseQueryOptions<SiteEspmQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SiteEspmQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteEspmQuery, TError, TData>({
    queryKey: ["SiteEspm", variables],
    queryFn: adminFetcher<SiteEspmQuery, SiteEspmQueryVariables>(
      SiteEspmDocument,
      variables,
    ),
    ...options,
  })
}

useSiteEspmQuery.getKey = (variables: SiteEspmQueryVariables) => ["SiteEspm", variables]

useSiteEspmQuery.rootKey = "SiteEspm"

export const useSuspenseSiteEspmQuery = <TData = SiteEspmQuery, TError = unknown>(
  variables: SiteEspmQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<SiteEspmQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<SiteEspmQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteEspmQuery, TError, TData>({
    queryKey: ["SiteEspmSuspense", variables],
    queryFn: adminFetcher<SiteEspmQuery, SiteEspmQueryVariables>(
      SiteEspmDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteEspmQuery.getKey = (variables: SiteEspmQueryVariables) => [
  "SiteEspmSuspense",
  variables,
]

useSuspenseSiteEspmQuery.rootKey = "SiteEspm"

export const useInfiniteSiteEspmQuery = <
  TData = InfiniteData<SiteEspmQuery>,
  TError = unknown,
>(
  variables: SiteEspmQueryVariables,
  options: Omit<UseInfiniteQueryOptions<SiteEspmQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<SiteEspmQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteEspmQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteEspm.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteEspmQuery, SiteEspmQueryVariables>(SiteEspmDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteEspmQuery.getKey = (variables: SiteEspmQueryVariables) => [
  "SiteEspm.infinite",
  variables,
]

useInfiniteSiteEspmQuery.rootKey = "SiteEspm.infinite"

export const useSuspenseInfiniteSiteEspmQuery = <
  TData = InfiniteData<SiteEspmQuery>,
  TError = unknown,
>(
  variables: SiteEspmQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteEspmQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<SiteEspmQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteEspmQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteEspm.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<SiteEspmQuery, SiteEspmQueryVariables>(SiteEspmDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteEspmQuery.getKey = (variables: SiteEspmQueryVariables) => [
  "SiteEspm.infiniteSuspense",
  variables,
]

useSuspenseInfiniteSiteEspmQuery.rootKey = "SiteEspm.infinite"

useSiteEspmQuery.fetcher = (
  variables: SiteEspmQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SiteEspmQuery, SiteEspmQueryVariables>(
    SiteEspmDocument,
    variables,
    options,
  )

export const TaskHistoryDocument = `
    query TaskHistory {
  taskHistory {
    timestamps
    taskNames
    series {
      taskName
      counts
    }
  }
}
    `

export const useTaskHistoryQuery = <TData = TaskHistoryQuery, TError = unknown>(
  variables?: TaskHistoryQueryVariables,
  options?: Omit<UseQueryOptions<TaskHistoryQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<TaskHistoryQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<TaskHistoryQuery, TError, TData>({
    queryKey: variables === undefined ? ["TaskHistory"] : ["TaskHistory", variables],
    queryFn: adminFetcher<TaskHistoryQuery, TaskHistoryQueryVariables>(
      TaskHistoryDocument,
      variables,
    ),
    ...options,
  })
}

useTaskHistoryQuery.getKey = (variables?: TaskHistoryQueryVariables) =>
  variables === undefined ? ["TaskHistory"] : ["TaskHistory", variables]

useTaskHistoryQuery.rootKey = "TaskHistory"

export const useSuspenseTaskHistoryQuery = <TData = TaskHistoryQuery, TError = unknown>(
  variables?: TaskHistoryQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<TaskHistoryQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<TaskHistoryQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<TaskHistoryQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["TaskHistorySuspense"]
        : ["TaskHistorySuspense", variables],
    queryFn: adminFetcher<TaskHistoryQuery, TaskHistoryQueryVariables>(
      TaskHistoryDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseTaskHistoryQuery.getKey = (variables?: TaskHistoryQueryVariables) =>
  variables === undefined ? ["TaskHistorySuspense"] : ["TaskHistorySuspense", variables]

useSuspenseTaskHistoryQuery.rootKey = "TaskHistory"

export const useInfiniteTaskHistoryQuery = <
  TData = InfiniteData<TaskHistoryQuery>,
  TError = unknown,
>(
  variables: TaskHistoryQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<TaskHistoryQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<TaskHistoryQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<TaskHistoryQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["TaskHistory.infinite"]
            : ["TaskHistory.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<TaskHistoryQuery, TaskHistoryQueryVariables>(
            TaskHistoryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteTaskHistoryQuery.getKey = (variables?: TaskHistoryQueryVariables) =>
  variables === undefined
    ? ["TaskHistory.infinite"]
    : ["TaskHistory.infinite", variables]

useInfiniteTaskHistoryQuery.rootKey = "TaskHistory.infinite"

export const useSuspenseInfiniteTaskHistoryQuery = <
  TData = InfiniteData<TaskHistoryQuery>,
  TError = unknown,
>(
  variables: TaskHistoryQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<TaskHistoryQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      TaskHistoryQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<TaskHistoryQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["TaskHistory.infiniteSuspense"]
            : ["TaskHistory.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<TaskHistoryQuery, TaskHistoryQueryVariables>(
            TaskHistoryDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteTaskHistoryQuery.getKey = (variables?: TaskHistoryQueryVariables) =>
  variables === undefined
    ? ["TaskHistory.infiniteSuspense"]
    : ["TaskHistory.infiniteSuspense", variables]

useSuspenseInfiniteTaskHistoryQuery.rootKey = "TaskHistory.infinite"

useTaskHistoryQuery.fetcher = (
  variables?: TaskHistoryQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<TaskHistoryQuery, TaskHistoryQueryVariables>(
    TaskHistoryDocument,
    variables,
    options,
  )

export const AdminBundleRowViewDocument = `
    query AdminBundleRowView {
  bundleRows {
    view {
      count
      keys
    }
  }
}
    `

export const useAdminBundleRowViewQuery = <
  TData = AdminBundleRowViewQuery,
  TError = unknown,
>(
  variables?: AdminBundleRowViewQueryVariables,
  options?: Omit<
    UseQueryOptions<AdminBundleRowViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<AdminBundleRowViewQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<AdminBundleRowViewQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["AdminBundleRowView"]
        : ["AdminBundleRowView", variables],
    queryFn: adminFetcher<AdminBundleRowViewQuery, AdminBundleRowViewQueryVariables>(
      AdminBundleRowViewDocument,
      variables,
    ),
    ...options,
  })
}

useAdminBundleRowViewQuery.getKey = (variables?: AdminBundleRowViewQueryVariables) =>
  variables === undefined ? ["AdminBundleRowView"] : ["AdminBundleRowView", variables]

useAdminBundleRowViewQuery.rootKey = "AdminBundleRowView"

export const useSuspenseAdminBundleRowViewQuery = <
  TData = AdminBundleRowViewQuery,
  TError = unknown,
>(
  variables?: AdminBundleRowViewQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<AdminBundleRowViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      AdminBundleRowViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<AdminBundleRowViewQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["AdminBundleRowViewSuspense"]
        : ["AdminBundleRowViewSuspense", variables],
    queryFn: adminFetcher<AdminBundleRowViewQuery, AdminBundleRowViewQueryVariables>(
      AdminBundleRowViewDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseAdminBundleRowViewQuery.getKey = (
  variables?: AdminBundleRowViewQueryVariables,
) =>
  variables === undefined
    ? ["AdminBundleRowViewSuspense"]
    : ["AdminBundleRowViewSuspense", variables]

useSuspenseAdminBundleRowViewQuery.rootKey = "AdminBundleRowView"

export const useInfiniteAdminBundleRowViewQuery = <
  TData = InfiniteData<AdminBundleRowViewQuery>,
  TError = unknown,
>(
  variables: AdminBundleRowViewQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<AdminBundleRowViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      AdminBundleRowViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<AdminBundleRowViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["AdminBundleRowView.infinite"]
            : ["AdminBundleRowView.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminBundleRowViewQuery, AdminBundleRowViewQueryVariables>(
            AdminBundleRowViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteAdminBundleRowViewQuery.getKey = (
  variables?: AdminBundleRowViewQueryVariables,
) =>
  variables === undefined
    ? ["AdminBundleRowView.infinite"]
    : ["AdminBundleRowView.infinite", variables]

useInfiniteAdminBundleRowViewQuery.rootKey = "AdminBundleRowView.infinite"

export const useSuspenseInfiniteAdminBundleRowViewQuery = <
  TData = InfiniteData<AdminBundleRowViewQuery>,
  TError = unknown,
>(
  variables: AdminBundleRowViewQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<AdminBundleRowViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      AdminBundleRowViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<AdminBundleRowViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["AdminBundleRowView.infiniteSuspense"]
            : ["AdminBundleRowView.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminBundleRowViewQuery, AdminBundleRowViewQueryVariables>(
            AdminBundleRowViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteAdminBundleRowViewQuery.getKey = (
  variables?: AdminBundleRowViewQueryVariables,
) =>
  variables === undefined
    ? ["AdminBundleRowView.infiniteSuspense"]
    : ["AdminBundleRowView.infiniteSuspense", variables]

useSuspenseInfiniteAdminBundleRowViewQuery.rootKey = "AdminBundleRowView.infinite"

useAdminBundleRowViewQuery.fetcher = (
  variables?: AdminBundleRowViewQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AdminBundleRowViewQuery, AdminBundleRowViewQueryVariables>(
    AdminBundleRowViewDocument,
    variables,
    options,
  )

export const AdminBundleRowsDocument = `
    query AdminBundleRows($keys: [Int!]!) {
  bundleRows {
    rows(keys: $keys) {
      id
      createdAt
      bundleName
      finproductType
      sitePid
      siteName
      receiverPid
      receiverName
      financierPid
      financierName
      portfolioPid
      portfolioName
      biddingOpenAt
      biddingClosedAt
      preBidMeetingDate
      bidReviewMeetingDate
      contractSignedDate
      ntpDate
      codDate
      state
      reason
      customReason
      leDevFee
      pvKw
    }
  }
}
    `

export const useAdminBundleRowsQuery = <TData = AdminBundleRowsQuery, TError = unknown>(
  variables: AdminBundleRowsQueryVariables,
  options?: Omit<UseQueryOptions<AdminBundleRowsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<AdminBundleRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<AdminBundleRowsQuery, TError, TData>({
    queryKey: ["AdminBundleRows", variables],
    queryFn: adminFetcher<AdminBundleRowsQuery, AdminBundleRowsQueryVariables>(
      AdminBundleRowsDocument,
      variables,
    ),
    ...options,
  })
}

useAdminBundleRowsQuery.getKey = (variables: AdminBundleRowsQueryVariables) => [
  "AdminBundleRows",
  variables,
]

useAdminBundleRowsQuery.rootKey = "AdminBundleRows"

export const useSuspenseAdminBundleRowsQuery = <
  TData = AdminBundleRowsQuery,
  TError = unknown,
>(
  variables: AdminBundleRowsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<AdminBundleRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<AdminBundleRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<AdminBundleRowsQuery, TError, TData>({
    queryKey: ["AdminBundleRowsSuspense", variables],
    queryFn: adminFetcher<AdminBundleRowsQuery, AdminBundleRowsQueryVariables>(
      AdminBundleRowsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseAdminBundleRowsQuery.getKey = (variables: AdminBundleRowsQueryVariables) => [
  "AdminBundleRowsSuspense",
  variables,
]

useSuspenseAdminBundleRowsQuery.rootKey = "AdminBundleRows"

export const useInfiniteAdminBundleRowsQuery = <
  TData = InfiniteData<AdminBundleRowsQuery>,
  TError = unknown,
>(
  variables: AdminBundleRowsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<AdminBundleRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<AdminBundleRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<AdminBundleRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["AdminBundleRows.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminBundleRowsQuery, AdminBundleRowsQueryVariables>(
            AdminBundleRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteAdminBundleRowsQuery.getKey = (variables: AdminBundleRowsQueryVariables) => [
  "AdminBundleRows.infinite",
  variables,
]

useInfiniteAdminBundleRowsQuery.rootKey = "AdminBundleRows.infinite"

export const useSuspenseInfiniteAdminBundleRowsQuery = <
  TData = InfiniteData<AdminBundleRowsQuery>,
  TError = unknown,
>(
  variables: AdminBundleRowsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<AdminBundleRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      AdminBundleRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<AdminBundleRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["AdminBundleRows.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminBundleRowsQuery, AdminBundleRowsQueryVariables>(
            AdminBundleRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteAdminBundleRowsQuery.getKey = (
  variables: AdminBundleRowsQueryVariables,
) => ["AdminBundleRows.infiniteSuspense", variables]

useSuspenseInfiniteAdminBundleRowsQuery.rootKey = "AdminBundleRows.infinite"

useAdminBundleRowsQuery.fetcher = (
  variables: AdminBundleRowsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AdminBundleRowsQuery, AdminBundleRowsQueryVariables>(
    AdminBundleRowsDocument,
    variables,
    options,
  )

export const SolarCaptchaSitesDocument = `
    query SolarCaptchaSites($sitePids: [String!]!) {
  sites(sitePids: $sitePids) {
    pid
    fullAddress
    staticMapUrl
    existingSolarDetectionScore
    latitude
    longitude
    orgSlug
  }
}
    `

export const useSolarCaptchaSitesQuery = <
  TData = SolarCaptchaSitesQuery,
  TError = unknown,
>(
  variables: SolarCaptchaSitesQueryVariables,
  options?: Omit<UseQueryOptions<SolarCaptchaSitesQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SolarCaptchaSitesQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SolarCaptchaSitesQuery, TError, TData>({
    queryKey: ["SolarCaptchaSites", variables],
    queryFn: adminFetcher<SolarCaptchaSitesQuery, SolarCaptchaSitesQueryVariables>(
      SolarCaptchaSitesDocument,
      variables,
    ),
    ...options,
  })
}

useSolarCaptchaSitesQuery.getKey = (variables: SolarCaptchaSitesQueryVariables) => [
  "SolarCaptchaSites",
  variables,
]

useSolarCaptchaSitesQuery.rootKey = "SolarCaptchaSites"

export const useSuspenseSolarCaptchaSitesQuery = <
  TData = SolarCaptchaSitesQuery,
  TError = unknown,
>(
  variables: SolarCaptchaSitesQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SolarCaptchaSitesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      SolarCaptchaSitesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<SolarCaptchaSitesQuery, TError, TData>({
    queryKey: ["SolarCaptchaSitesSuspense", variables],
    queryFn: adminFetcher<SolarCaptchaSitesQuery, SolarCaptchaSitesQueryVariables>(
      SolarCaptchaSitesDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSolarCaptchaSitesQuery.getKey = (
  variables: SolarCaptchaSitesQueryVariables,
) => ["SolarCaptchaSitesSuspense", variables]

useSuspenseSolarCaptchaSitesQuery.rootKey = "SolarCaptchaSites"

export const useInfiniteSolarCaptchaSitesQuery = <
  TData = InfiniteData<SolarCaptchaSitesQuery>,
  TError = unknown,
>(
  variables: SolarCaptchaSitesQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SolarCaptchaSitesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      SolarCaptchaSitesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<SolarCaptchaSitesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SolarCaptchaSites.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<SolarCaptchaSitesQuery, SolarCaptchaSitesQueryVariables>(
            SolarCaptchaSitesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSolarCaptchaSitesQuery.getKey = (
  variables: SolarCaptchaSitesQueryVariables,
) => ["SolarCaptchaSites.infinite", variables]

useInfiniteSolarCaptchaSitesQuery.rootKey = "SolarCaptchaSites.infinite"

export const useSuspenseInfiniteSolarCaptchaSitesQuery = <
  TData = InfiniteData<SolarCaptchaSitesQuery>,
  TError = unknown,
>(
  variables: SolarCaptchaSitesQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SolarCaptchaSitesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SolarCaptchaSitesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SolarCaptchaSitesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SolarCaptchaSites.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<SolarCaptchaSitesQuery, SolarCaptchaSitesQueryVariables>(
            SolarCaptchaSitesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSolarCaptchaSitesQuery.getKey = (
  variables: SolarCaptchaSitesQueryVariables,
) => ["SolarCaptchaSites.infiniteSuspense", variables]

useSuspenseInfiniteSolarCaptchaSitesQuery.rootKey = "SolarCaptchaSites.infinite"

useSolarCaptchaSitesQuery.fetcher = (
  variables: SolarCaptchaSitesQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<SolarCaptchaSitesQuery, SolarCaptchaSitesQueryVariables>(
    SolarCaptchaSitesDocument,
    variables,
    options,
  )

export const PreviewBuildingFootprintsDocument = `
    query PreviewBuildingFootprints($sitePid: String!, $strategy: FootprintStrategy!) {
  site(pid: $sitePid) {
    previewBuildingFootprints(strategy: $strategy) {
      __typename
      ... on Footprint {
        latitude
        longitude
        bounds
        roofShape
        roofShapeGeojson
        parcelShape
        parcelShapeGeojson
      }
      ... on Error {
        message
      }
    }
  }
}
    `

export const usePreviewBuildingFootprintsQuery = <
  TData = PreviewBuildingFootprintsQuery,
  TError = unknown,
>(
  variables: PreviewBuildingFootprintsQueryVariables,
  options?: Omit<
    UseQueryOptions<PreviewBuildingFootprintsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      PreviewBuildingFootprintsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useQuery<PreviewBuildingFootprintsQuery, TError, TData>({
    queryKey: ["PreviewBuildingFootprints", variables],
    queryFn: adminFetcher<
      PreviewBuildingFootprintsQuery,
      PreviewBuildingFootprintsQueryVariables
    >(PreviewBuildingFootprintsDocument, variables),
    ...options,
  })
}

usePreviewBuildingFootprintsQuery.getKey = (
  variables: PreviewBuildingFootprintsQueryVariables,
) => ["PreviewBuildingFootprints", variables]

usePreviewBuildingFootprintsQuery.rootKey = "PreviewBuildingFootprints"

export const useSuspensePreviewBuildingFootprintsQuery = <
  TData = PreviewBuildingFootprintsQuery,
  TError = unknown,
>(
  variables: PreviewBuildingFootprintsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<PreviewBuildingFootprintsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      PreviewBuildingFootprintsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<PreviewBuildingFootprintsQuery, TError, TData>({
    queryKey: ["PreviewBuildingFootprintsSuspense", variables],
    queryFn: adminFetcher<
      PreviewBuildingFootprintsQuery,
      PreviewBuildingFootprintsQueryVariables
    >(PreviewBuildingFootprintsDocument, variables),
    ...options,
  })
}

useSuspensePreviewBuildingFootprintsQuery.getKey = (
  variables: PreviewBuildingFootprintsQueryVariables,
) => ["PreviewBuildingFootprintsSuspense", variables]

useSuspensePreviewBuildingFootprintsQuery.rootKey = "PreviewBuildingFootprints"

export const useInfinitePreviewBuildingFootprintsQuery = <
  TData = InfiniteData<PreviewBuildingFootprintsQuery>,
  TError = unknown,
>(
  variables: PreviewBuildingFootprintsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<PreviewBuildingFootprintsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      PreviewBuildingFootprintsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<PreviewBuildingFootprintsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["PreviewBuildingFootprints.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<
            PreviewBuildingFootprintsQuery,
            PreviewBuildingFootprintsQueryVariables
          >(PreviewBuildingFootprintsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfinitePreviewBuildingFootprintsQuery.getKey = (
  variables: PreviewBuildingFootprintsQueryVariables,
) => ["PreviewBuildingFootprints.infinite", variables]

useInfinitePreviewBuildingFootprintsQuery.rootKey = "PreviewBuildingFootprints.infinite"

export const useSuspenseInfinitePreviewBuildingFootprintsQuery = <
  TData = InfiniteData<PreviewBuildingFootprintsQuery>,
  TError = unknown,
>(
  variables: PreviewBuildingFootprintsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<PreviewBuildingFootprintsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      PreviewBuildingFootprintsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<PreviewBuildingFootprintsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "PreviewBuildingFootprints.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<
            PreviewBuildingFootprintsQuery,
            PreviewBuildingFootprintsQueryVariables
          >(PreviewBuildingFootprintsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfinitePreviewBuildingFootprintsQuery.getKey = (
  variables: PreviewBuildingFootprintsQueryVariables,
) => ["PreviewBuildingFootprints.infiniteSuspense", variables]

useSuspenseInfinitePreviewBuildingFootprintsQuery.rootKey =
  "PreviewBuildingFootprints.infinite"

usePreviewBuildingFootprintsQuery.fetcher = (
  variables: PreviewBuildingFootprintsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<PreviewBuildingFootprintsQuery, PreviewBuildingFootprintsQueryVariables>(
    PreviewBuildingFootprintsDocument,
    variables,
    options,
  )

export const ListHostingCapacityMapsDocument = `
    query ListHostingCapacityMaps {
  hostingCapacityMaps {
    all {
      id
      utility {
        id
        pid
        name
        shortName
      }
      url
      requiresLogin
      types
    }
  }
}
    `

export const useListHostingCapacityMapsQuery = <
  TData = ListHostingCapacityMapsQuery,
  TError = unknown,
>(
  variables?: ListHostingCapacityMapsQueryVariables,
  options?: Omit<
    UseQueryOptions<ListHostingCapacityMapsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<ListHostingCapacityMapsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ListHostingCapacityMapsQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["ListHostingCapacityMaps"]
        : ["ListHostingCapacityMaps", variables],
    queryFn: adminFetcher<
      ListHostingCapacityMapsQuery,
      ListHostingCapacityMapsQueryVariables
    >(ListHostingCapacityMapsDocument, variables),
    ...options,
  })
}

useListHostingCapacityMapsQuery.getKey = (
  variables?: ListHostingCapacityMapsQueryVariables,
) =>
  variables === undefined
    ? ["ListHostingCapacityMaps"]
    : ["ListHostingCapacityMaps", variables]

useListHostingCapacityMapsQuery.rootKey = "ListHostingCapacityMaps"

export const useSuspenseListHostingCapacityMapsQuery = <
  TData = ListHostingCapacityMapsQuery,
  TError = unknown,
>(
  variables?: ListHostingCapacityMapsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ListHostingCapacityMapsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      ListHostingCapacityMapsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<ListHostingCapacityMapsQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["ListHostingCapacityMapsSuspense"]
        : ["ListHostingCapacityMapsSuspense", variables],
    queryFn: adminFetcher<
      ListHostingCapacityMapsQuery,
      ListHostingCapacityMapsQueryVariables
    >(ListHostingCapacityMapsDocument, variables),
    ...options,
  })
}

useSuspenseListHostingCapacityMapsQuery.getKey = (
  variables?: ListHostingCapacityMapsQueryVariables,
) =>
  variables === undefined
    ? ["ListHostingCapacityMapsSuspense"]
    : ["ListHostingCapacityMapsSuspense", variables]

useSuspenseListHostingCapacityMapsQuery.rootKey = "ListHostingCapacityMaps"

export const useInfiniteListHostingCapacityMapsQuery = <
  TData = InfiniteData<ListHostingCapacityMapsQuery>,
  TError = unknown,
>(
  variables: ListHostingCapacityMapsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ListHostingCapacityMapsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      ListHostingCapacityMapsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<ListHostingCapacityMapsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["ListHostingCapacityMaps.infinite"]
            : ["ListHostingCapacityMaps.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<
            ListHostingCapacityMapsQuery,
            ListHostingCapacityMapsQueryVariables
          >(ListHostingCapacityMapsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteListHostingCapacityMapsQuery.getKey = (
  variables?: ListHostingCapacityMapsQueryVariables,
) =>
  variables === undefined
    ? ["ListHostingCapacityMaps.infinite"]
    : ["ListHostingCapacityMaps.infinite", variables]

useInfiniteListHostingCapacityMapsQuery.rootKey = "ListHostingCapacityMaps.infinite"

export const useSuspenseInfiniteListHostingCapacityMapsQuery = <
  TData = InfiniteData<ListHostingCapacityMapsQuery>,
  TError = unknown,
>(
  variables: ListHostingCapacityMapsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ListHostingCapacityMapsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ListHostingCapacityMapsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ListHostingCapacityMapsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["ListHostingCapacityMaps.infiniteSuspense"]
            : ["ListHostingCapacityMaps.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<
            ListHostingCapacityMapsQuery,
            ListHostingCapacityMapsQueryVariables
          >(ListHostingCapacityMapsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteListHostingCapacityMapsQuery.getKey = (
  variables?: ListHostingCapacityMapsQueryVariables,
) =>
  variables === undefined
    ? ["ListHostingCapacityMaps.infiniteSuspense"]
    : ["ListHostingCapacityMaps.infiniteSuspense", variables]

useSuspenseInfiniteListHostingCapacityMapsQuery.rootKey =
  "ListHostingCapacityMaps.infinite"

useListHostingCapacityMapsQuery.fetcher = (
  variables?: ListHostingCapacityMapsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ListHostingCapacityMapsQuery, ListHostingCapacityMapsQueryVariables>(
    ListHostingCapacityMapsDocument,
    variables,
    options,
  )

export const BauMeterBillComparisonDocument = `
    query BauMeterBillComparison($sitePid: String!, $meterId: Int!) {
  site(pid: $sitePid) {
    pid
    isMultifamily
    customTariffs {
      id
      name
      code
      parent {
        id
      }
    }
  }
  bauMeter(id: $meterId) {
    loadCategory
    tariff {
      id
      code
      name
    }
    documentBillingMonths {
      id
      start
      end
    }
  }
}
    `

export const useBauMeterBillComparisonQuery = <
  TData = BauMeterBillComparisonQuery,
  TError = unknown,
>(
  variables: BauMeterBillComparisonQueryVariables,
  options?: Omit<
    UseQueryOptions<BauMeterBillComparisonQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<BauMeterBillComparisonQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<BauMeterBillComparisonQuery, TError, TData>({
    queryKey: ["BauMeterBillComparison", variables],
    queryFn: adminFetcher<
      BauMeterBillComparisonQuery,
      BauMeterBillComparisonQueryVariables
    >(BauMeterBillComparisonDocument, variables),
    ...options,
  })
}

useBauMeterBillComparisonQuery.getKey = (
  variables: BauMeterBillComparisonQueryVariables,
) => ["BauMeterBillComparison", variables]

useBauMeterBillComparisonQuery.rootKey = "BauMeterBillComparison"

export const useSuspenseBauMeterBillComparisonQuery = <
  TData = BauMeterBillComparisonQuery,
  TError = unknown,
>(
  variables: BauMeterBillComparisonQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<BauMeterBillComparisonQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      BauMeterBillComparisonQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<BauMeterBillComparisonQuery, TError, TData>({
    queryKey: ["BauMeterBillComparisonSuspense", variables],
    queryFn: adminFetcher<
      BauMeterBillComparisonQuery,
      BauMeterBillComparisonQueryVariables
    >(BauMeterBillComparisonDocument, variables),
    ...options,
  })
}

useSuspenseBauMeterBillComparisonQuery.getKey = (
  variables: BauMeterBillComparisonQueryVariables,
) => ["BauMeterBillComparisonSuspense", variables]

useSuspenseBauMeterBillComparisonQuery.rootKey = "BauMeterBillComparison"

export const useInfiniteBauMeterBillComparisonQuery = <
  TData = InfiniteData<BauMeterBillComparisonQuery>,
  TError = unknown,
>(
  variables: BauMeterBillComparisonQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<BauMeterBillComparisonQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      BauMeterBillComparisonQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<BauMeterBillComparisonQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["BauMeterBillComparison.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<
            BauMeterBillComparisonQuery,
            BauMeterBillComparisonQueryVariables
          >(BauMeterBillComparisonDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteBauMeterBillComparisonQuery.getKey = (
  variables: BauMeterBillComparisonQueryVariables,
) => ["BauMeterBillComparison.infinite", variables]

useInfiniteBauMeterBillComparisonQuery.rootKey = "BauMeterBillComparison.infinite"

export const useSuspenseInfiniteBauMeterBillComparisonQuery = <
  TData = InfiniteData<BauMeterBillComparisonQuery>,
  TError = unknown,
>(
  variables: BauMeterBillComparisonQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<BauMeterBillComparisonQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      BauMeterBillComparisonQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<BauMeterBillComparisonQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "BauMeterBillComparison.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<
            BauMeterBillComparisonQuery,
            BauMeterBillComparisonQueryVariables
          >(BauMeterBillComparisonDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteBauMeterBillComparisonQuery.getKey = (
  variables: BauMeterBillComparisonQueryVariables,
) => ["BauMeterBillComparison.infiniteSuspense", variables]

useSuspenseInfiniteBauMeterBillComparisonQuery.rootKey =
  "BauMeterBillComparison.infinite"

useBauMeterBillComparisonQuery.fetcher = (
  variables: BauMeterBillComparisonQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<BauMeterBillComparisonQuery, BauMeterBillComparisonQueryVariables>(
    BauMeterBillComparisonDocument,
    variables,
    options,
  )

export const AdminMarketplaceViewDocument = `
    query AdminMarketplaceView($filterBy: AdminMarketplaceTableFilter, $sortBy: [AdminMarketplaceTableSort!]) {
  marketplace {
    view(filterBy: $filterBy, sortBy: $sortBy) {
      keys
      count
      stats {
        buildingOwners
        assetManagers
        bidPackageNames
        siteStates
        financiers
        portfolios
        salesOwners
        opsOwners
      }
    }
  }
}
    `

export const useAdminMarketplaceViewQuery = <
  TData = AdminMarketplaceViewQuery,
  TError = unknown,
>(
  variables?: AdminMarketplaceViewQueryVariables,
  options?: Omit<
    UseQueryOptions<AdminMarketplaceViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<AdminMarketplaceViewQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<AdminMarketplaceViewQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["AdminMarketplaceView"]
        : ["AdminMarketplaceView", variables],
    queryFn: adminFetcher<
      AdminMarketplaceViewQuery,
      AdminMarketplaceViewQueryVariables
    >(AdminMarketplaceViewDocument, variables),
    ...options,
  })
}

useAdminMarketplaceViewQuery.getKey = (
  variables?: AdminMarketplaceViewQueryVariables,
) =>
  variables === undefined
    ? ["AdminMarketplaceView"]
    : ["AdminMarketplaceView", variables]

useAdminMarketplaceViewQuery.rootKey = "AdminMarketplaceView"

export const useSuspenseAdminMarketplaceViewQuery = <
  TData = AdminMarketplaceViewQuery,
  TError = unknown,
>(
  variables?: AdminMarketplaceViewQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<AdminMarketplaceViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      AdminMarketplaceViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<AdminMarketplaceViewQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["AdminMarketplaceViewSuspense"]
        : ["AdminMarketplaceViewSuspense", variables],
    queryFn: adminFetcher<
      AdminMarketplaceViewQuery,
      AdminMarketplaceViewQueryVariables
    >(AdminMarketplaceViewDocument, variables),
    ...options,
  })
}

useSuspenseAdminMarketplaceViewQuery.getKey = (
  variables?: AdminMarketplaceViewQueryVariables,
) =>
  variables === undefined
    ? ["AdminMarketplaceViewSuspense"]
    : ["AdminMarketplaceViewSuspense", variables]

useSuspenseAdminMarketplaceViewQuery.rootKey = "AdminMarketplaceView"

export const useInfiniteAdminMarketplaceViewQuery = <
  TData = InfiniteData<AdminMarketplaceViewQuery>,
  TError = unknown,
>(
  variables: AdminMarketplaceViewQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<AdminMarketplaceViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      AdminMarketplaceViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<AdminMarketplaceViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["AdminMarketplaceView.infinite"]
            : ["AdminMarketplaceView.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminMarketplaceViewQuery, AdminMarketplaceViewQueryVariables>(
            AdminMarketplaceViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteAdminMarketplaceViewQuery.getKey = (
  variables?: AdminMarketplaceViewQueryVariables,
) =>
  variables === undefined
    ? ["AdminMarketplaceView.infinite"]
    : ["AdminMarketplaceView.infinite", variables]

useInfiniteAdminMarketplaceViewQuery.rootKey = "AdminMarketplaceView.infinite"

export const useSuspenseInfiniteAdminMarketplaceViewQuery = <
  TData = InfiniteData<AdminMarketplaceViewQuery>,
  TError = unknown,
>(
  variables: AdminMarketplaceViewQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<AdminMarketplaceViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      AdminMarketplaceViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<AdminMarketplaceViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["AdminMarketplaceView.infiniteSuspense"]
            : ["AdminMarketplaceView.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminMarketplaceViewQuery, AdminMarketplaceViewQueryVariables>(
            AdminMarketplaceViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteAdminMarketplaceViewQuery.getKey = (
  variables?: AdminMarketplaceViewQueryVariables,
) =>
  variables === undefined
    ? ["AdminMarketplaceView.infiniteSuspense"]
    : ["AdminMarketplaceView.infiniteSuspense", variables]

useSuspenseInfiniteAdminMarketplaceViewQuery.rootKey = "AdminMarketplaceView.infinite"

useAdminMarketplaceViewQuery.fetcher = (
  variables?: AdminMarketplaceViewQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AdminMarketplaceViewQuery, AdminMarketplaceViewQueryVariables>(
    AdminMarketplaceViewDocument,
    variables,
    options,
  )

export const AdminMarketplaceRowsDocument = `
    query AdminMarketplaceRows($keys: [Int!]!) {
  marketplace {
    rows(keys: $keys) {
      id
      orgSlug
      orgName
      portfolioName
      sitePid
      bidPackagePid
      bidPackageName
      name
      city
      state
      zipCode
      streetAddress
      county
      cbsaName
      assetManager
      packageRowStatus
      packageRowIsClosed
      packageRowClosedAt
      packageRowCloseReason
      packageRowCloseCustomReason
      isAwarded
      buildingType
      yearBuilt
      sqft
      buildingFootprintSqft
      roofSqft
      usableRoofSqft
      numStories
      numUnitsTotal
      buildingClass
      roofReplacedYr
      roofCondition
      salePlannedYear
      salePlans
      buildingLegalName
      propertyFundName
      leaseSignatory
      counselApproval
      leaseApprovers
      externalLeaseApprovers
      needsTenantApproval
      roofRightsHolder
      propertyLenders
      propertyInsurer
      constructionEmail
      propertySiteVisitContacts
      leasePropertyLegalDescription
      leaseLegalOwnerName
      signatureBlocks
      isFannieMaeLender
      isFmGlobalInsurer
      utilityShortName
      finproductType
      biddingOpenAt
      biddingClosedAt
      bidReviewMeetingDate
      estimatedNtp
      estimatedCod
      bidCount
      awardedTo
      roofRentY1Usd
      noiLifetimeUsd
      roofRentEscalator
      pvSizeKwDc
      lumenRevenue
      lumenFeeUsdPerWatt
      hubspotRecordId
      salesOwnerEmail
      salesOwnerPid
      opsOwnerEmail
      opsOwnerPid
      rofoSignedDate
      rofoSignedEstimated
      rofoSignedActual
      preBidMeetingEstimated
      preBidMeetingActual
      preBidMeetingDate
      biddingOpenedEstimated
      biddingOpenedActual
      biddingOpenedDate
      biddingClosedEstimated
      biddingClosedActual
      biddingClosedDate
      bidsPresentedEstimated
      bidsPresentedActual
      bidsPresentedDate
      ixSubmittedEstimated
      ixSubmittedActual
      ixSubmittedDate
      ixApprovedEstimated
      ixApprovedActual
      ixApprovedDate
      csProgramSubmittedEstimated
      csProgramSubmittedActual
      csProgramSubmittedDate
      csProgramApprovedEstimated
      csProgramApprovedActual
      csProgramApprovedDate
      awardedToDeveloperEstimated
      awardedToDeveloperActual
      awardedToDeveloperDate
      leaseSignedEstimated
      leaseSignedActual
      leaseSignedDate
      ntpEstimated
      ntpActual
      ntpDate
      codEstimated
      codActual
      codDate
    }
  }
}
    `

export const useAdminMarketplaceRowsQuery = <
  TData = AdminMarketplaceRowsQuery,
  TError = unknown,
>(
  variables: AdminMarketplaceRowsQueryVariables,
  options?: Omit<
    UseQueryOptions<AdminMarketplaceRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<AdminMarketplaceRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<AdminMarketplaceRowsQuery, TError, TData>({
    queryKey: ["AdminMarketplaceRows", variables],
    queryFn: adminFetcher<
      AdminMarketplaceRowsQuery,
      AdminMarketplaceRowsQueryVariables
    >(AdminMarketplaceRowsDocument, variables),
    ...options,
  })
}

useAdminMarketplaceRowsQuery.getKey = (
  variables: AdminMarketplaceRowsQueryVariables,
) => ["AdminMarketplaceRows", variables]

useAdminMarketplaceRowsQuery.rootKey = "AdminMarketplaceRows"

export const useSuspenseAdminMarketplaceRowsQuery = <
  TData = AdminMarketplaceRowsQuery,
  TError = unknown,
>(
  variables: AdminMarketplaceRowsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<AdminMarketplaceRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      AdminMarketplaceRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<AdminMarketplaceRowsQuery, TError, TData>({
    queryKey: ["AdminMarketplaceRowsSuspense", variables],
    queryFn: adminFetcher<
      AdminMarketplaceRowsQuery,
      AdminMarketplaceRowsQueryVariables
    >(AdminMarketplaceRowsDocument, variables),
    ...options,
  })
}

useSuspenseAdminMarketplaceRowsQuery.getKey = (
  variables: AdminMarketplaceRowsQueryVariables,
) => ["AdminMarketplaceRowsSuspense", variables]

useSuspenseAdminMarketplaceRowsQuery.rootKey = "AdminMarketplaceRows"

export const useInfiniteAdminMarketplaceRowsQuery = <
  TData = InfiniteData<AdminMarketplaceRowsQuery>,
  TError = unknown,
>(
  variables: AdminMarketplaceRowsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<AdminMarketplaceRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      AdminMarketplaceRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<AdminMarketplaceRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["AdminMarketplaceRows.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminMarketplaceRowsQuery, AdminMarketplaceRowsQueryVariables>(
            AdminMarketplaceRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteAdminMarketplaceRowsQuery.getKey = (
  variables: AdminMarketplaceRowsQueryVariables,
) => ["AdminMarketplaceRows.infinite", variables]

useInfiniteAdminMarketplaceRowsQuery.rootKey = "AdminMarketplaceRows.infinite"

export const useSuspenseInfiniteAdminMarketplaceRowsQuery = <
  TData = InfiniteData<AdminMarketplaceRowsQuery>,
  TError = unknown,
>(
  variables: AdminMarketplaceRowsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<AdminMarketplaceRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      AdminMarketplaceRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<AdminMarketplaceRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "AdminMarketplaceRows.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<AdminMarketplaceRowsQuery, AdminMarketplaceRowsQueryVariables>(
            AdminMarketplaceRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteAdminMarketplaceRowsQuery.getKey = (
  variables: AdminMarketplaceRowsQueryVariables,
) => ["AdminMarketplaceRows.infiniteSuspense", variables]

useSuspenseInfiniteAdminMarketplaceRowsQuery.rootKey = "AdminMarketplaceRows.infinite"

useAdminMarketplaceRowsQuery.fetcher = (
  variables: AdminMarketplaceRowsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AdminMarketplaceRowsQuery, AdminMarketplaceRowsQueryVariables>(
    AdminMarketplaceRowsDocument,
    variables,
    options,
  )

export const AdminMarketplaceSiteDocumentsDocument = `
    query AdminMarketplaceSiteDocuments($keys: [Int!]!) {
  bundleRowParentDocuments(
    bundleParentRowIds: $keys
    includeTags: [SITE__ROOF, SITE__ROOF_WARRANTY, SITE__STRUCTURAL_DRAWINGS, SITE__ELECTRICAL_DIAGRAMS, SITE__WIRING_INSTRUCTIONS]
  ) {
    sitePid
    documents {
      pid
      fileName
      downloadHref
      tag
    }
  }
}
    `

export const useAdminMarketplaceSiteDocumentsQuery = <
  TData = AdminMarketplaceSiteDocumentsQuery,
  TError = unknown,
>(
  variables: AdminMarketplaceSiteDocumentsQueryVariables,
  options?: Omit<
    UseQueryOptions<AdminMarketplaceSiteDocumentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      AdminMarketplaceSiteDocumentsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useQuery<AdminMarketplaceSiteDocumentsQuery, TError, TData>({
    queryKey: ["AdminMarketplaceSiteDocuments", variables],
    queryFn: adminFetcher<
      AdminMarketplaceSiteDocumentsQuery,
      AdminMarketplaceSiteDocumentsQueryVariables
    >(AdminMarketplaceSiteDocumentsDocument, variables),
    ...options,
  })
}

useAdminMarketplaceSiteDocumentsQuery.getKey = (
  variables: AdminMarketplaceSiteDocumentsQueryVariables,
) => ["AdminMarketplaceSiteDocuments", variables]

useAdminMarketplaceSiteDocumentsQuery.rootKey = "AdminMarketplaceSiteDocuments"

export const useSuspenseAdminMarketplaceSiteDocumentsQuery = <
  TData = AdminMarketplaceSiteDocumentsQuery,
  TError = unknown,
>(
  variables: AdminMarketplaceSiteDocumentsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<AdminMarketplaceSiteDocumentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      AdminMarketplaceSiteDocumentsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<AdminMarketplaceSiteDocumentsQuery, TError, TData>({
    queryKey: ["AdminMarketplaceSiteDocumentsSuspense", variables],
    queryFn: adminFetcher<
      AdminMarketplaceSiteDocumentsQuery,
      AdminMarketplaceSiteDocumentsQueryVariables
    >(AdminMarketplaceSiteDocumentsDocument, variables),
    ...options,
  })
}

useSuspenseAdminMarketplaceSiteDocumentsQuery.getKey = (
  variables: AdminMarketplaceSiteDocumentsQueryVariables,
) => ["AdminMarketplaceSiteDocumentsSuspense", variables]

useSuspenseAdminMarketplaceSiteDocumentsQuery.rootKey = "AdminMarketplaceSiteDocuments"

export const useInfiniteAdminMarketplaceSiteDocumentsQuery = <
  TData = InfiniteData<AdminMarketplaceSiteDocumentsQuery>,
  TError = unknown,
>(
  variables: AdminMarketplaceSiteDocumentsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<AdminMarketplaceSiteDocumentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      AdminMarketplaceSiteDocumentsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<AdminMarketplaceSiteDocumentsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "AdminMarketplaceSiteDocuments.infinite",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<
            AdminMarketplaceSiteDocumentsQuery,
            AdminMarketplaceSiteDocumentsQueryVariables
          >(AdminMarketplaceSiteDocumentsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteAdminMarketplaceSiteDocumentsQuery.getKey = (
  variables: AdminMarketplaceSiteDocumentsQueryVariables,
) => ["AdminMarketplaceSiteDocuments.infinite", variables]

useInfiniteAdminMarketplaceSiteDocumentsQuery.rootKey =
  "AdminMarketplaceSiteDocuments.infinite"

export const useSuspenseInfiniteAdminMarketplaceSiteDocumentsQuery = <
  TData = InfiniteData<AdminMarketplaceSiteDocumentsQuery>,
  TError = unknown,
>(
  variables: AdminMarketplaceSiteDocumentsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<AdminMarketplaceSiteDocumentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      AdminMarketplaceSiteDocumentsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<AdminMarketplaceSiteDocumentsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "AdminMarketplaceSiteDocuments.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<
            AdminMarketplaceSiteDocumentsQuery,
            AdminMarketplaceSiteDocumentsQueryVariables
          >(AdminMarketplaceSiteDocumentsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteAdminMarketplaceSiteDocumentsQuery.getKey = (
  variables: AdminMarketplaceSiteDocumentsQueryVariables,
) => ["AdminMarketplaceSiteDocuments.infiniteSuspense", variables]

useSuspenseInfiniteAdminMarketplaceSiteDocumentsQuery.rootKey =
  "AdminMarketplaceSiteDocuments.infinite"

useAdminMarketplaceSiteDocumentsQuery.fetcher = (
  variables: AdminMarketplaceSiteDocumentsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<
    AdminMarketplaceSiteDocumentsQuery,
    AdminMarketplaceSiteDocumentsQueryVariables
  >(AdminMarketplaceSiteDocumentsDocument, variables, options)

export const ActiveAdminsDocument = `
    query ActiveAdmins {
  activeAdmins {
    pid
    isAdmin
    name
    email
  }
}
    `

export const useActiveAdminsQuery = <TData = ActiveAdminsQuery, TError = unknown>(
  variables?: ActiveAdminsQueryVariables,
  options?: Omit<UseQueryOptions<ActiveAdminsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<ActiveAdminsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ActiveAdminsQuery, TError, TData>({
    queryKey: variables === undefined ? ["ActiveAdmins"] : ["ActiveAdmins", variables],
    queryFn: adminFetcher<ActiveAdminsQuery, ActiveAdminsQueryVariables>(
      ActiveAdminsDocument,
      variables,
    ),
    ...options,
  })
}

useActiveAdminsQuery.getKey = (variables?: ActiveAdminsQueryVariables) =>
  variables === undefined ? ["ActiveAdmins"] : ["ActiveAdmins", variables]

useActiveAdminsQuery.rootKey = "ActiveAdmins"

export const useSuspenseActiveAdminsQuery = <
  TData = ActiveAdminsQuery,
  TError = unknown,
>(
  variables?: ActiveAdminsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ActiveAdminsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<ActiveAdminsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<ActiveAdminsQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["ActiveAdminsSuspense"]
        : ["ActiveAdminsSuspense", variables],
    queryFn: adminFetcher<ActiveAdminsQuery, ActiveAdminsQueryVariables>(
      ActiveAdminsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseActiveAdminsQuery.getKey = (variables?: ActiveAdminsQueryVariables) =>
  variables === undefined
    ? ["ActiveAdminsSuspense"]
    : ["ActiveAdminsSuspense", variables]

useSuspenseActiveAdminsQuery.rootKey = "ActiveAdmins"

export const useInfiniteActiveAdminsQuery = <
  TData = InfiniteData<ActiveAdminsQuery>,
  TError = unknown,
>(
  variables: ActiveAdminsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ActiveAdminsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<ActiveAdminsQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<ActiveAdminsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["ActiveAdmins.infinite"]
            : ["ActiveAdmins.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<ActiveAdminsQuery, ActiveAdminsQueryVariables>(
            ActiveAdminsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteActiveAdminsQuery.getKey = (variables?: ActiveAdminsQueryVariables) =>
  variables === undefined
    ? ["ActiveAdmins.infinite"]
    : ["ActiveAdmins.infinite", variables]

useInfiniteActiveAdminsQuery.rootKey = "ActiveAdmins.infinite"

export const useSuspenseInfiniteActiveAdminsQuery = <
  TData = InfiniteData<ActiveAdminsQuery>,
  TError = unknown,
>(
  variables: ActiveAdminsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ActiveAdminsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ActiveAdminsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ActiveAdminsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["ActiveAdmins.infiniteSuspense"]
            : ["ActiveAdmins.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<ActiveAdminsQuery, ActiveAdminsQueryVariables>(
            ActiveAdminsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteActiveAdminsQuery.getKey = (
  variables?: ActiveAdminsQueryVariables,
) =>
  variables === undefined
    ? ["ActiveAdmins.infiniteSuspense"]
    : ["ActiveAdmins.infiniteSuspense", variables]

useSuspenseInfiniteActiveAdminsQuery.rootKey = "ActiveAdmins.infinite"

useActiveAdminsQuery.fetcher = (
  variables?: ActiveAdminsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<ActiveAdminsQuery, ActiveAdminsQueryVariables>(
    ActiveAdminsDocument,
    variables,
    options,
  )

export const AdminUserDetailDocument = `
    query AdminUserDetail($userId: Int!) {
  user(userId: $userId) {
    ...UserListUser
    pageViews {
      pathname
      createdAt
    }
  }
}
    ${UserListUserFragmentDoc}`

export const useAdminUserDetailQuery = <TData = AdminUserDetailQuery, TError = unknown>(
  variables: AdminUserDetailQueryVariables,
  options?: Omit<UseQueryOptions<AdminUserDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<AdminUserDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<AdminUserDetailQuery, TError, TData>({
    queryKey: ["AdminUserDetail", variables],
    queryFn: adminFetcher<AdminUserDetailQuery, AdminUserDetailQueryVariables>(
      AdminUserDetailDocument,
      variables,
    ),
    ...options,
  })
}

useAdminUserDetailQuery.getKey = (variables: AdminUserDetailQueryVariables) => [
  "AdminUserDetail",
  variables,
]

useAdminUserDetailQuery.rootKey = "AdminUserDetail"

export const useSuspenseAdminUserDetailQuery = <
  TData = AdminUserDetailQuery,
  TError = unknown,
>(
  variables: AdminUserDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<AdminUserDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<AdminUserDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<AdminUserDetailQuery, TError, TData>({
    queryKey: ["AdminUserDetailSuspense", variables],
    queryFn: adminFetcher<AdminUserDetailQuery, AdminUserDetailQueryVariables>(
      AdminUserDetailDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseAdminUserDetailQuery.getKey = (variables: AdminUserDetailQueryVariables) => [
  "AdminUserDetailSuspense",
  variables,
]

useSuspenseAdminUserDetailQuery.rootKey = "AdminUserDetail"

export const useInfiniteAdminUserDetailQuery = <
  TData = InfiniteData<AdminUserDetailQuery>,
  TError = unknown,
>(
  variables: AdminUserDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<AdminUserDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<AdminUserDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<AdminUserDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["AdminUserDetail.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminUserDetailQuery, AdminUserDetailQueryVariables>(
            AdminUserDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteAdminUserDetailQuery.getKey = (variables: AdminUserDetailQueryVariables) => [
  "AdminUserDetail.infinite",
  variables,
]

useInfiniteAdminUserDetailQuery.rootKey = "AdminUserDetail.infinite"

export const useSuspenseInfiniteAdminUserDetailQuery = <
  TData = InfiniteData<AdminUserDetailQuery>,
  TError = unknown,
>(
  variables: AdminUserDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<AdminUserDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      AdminUserDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<AdminUserDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["AdminUserDetail.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminUserDetailQuery, AdminUserDetailQueryVariables>(
            AdminUserDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteAdminUserDetailQuery.getKey = (
  variables: AdminUserDetailQueryVariables,
) => ["AdminUserDetail.infiniteSuspense", variables]

useSuspenseInfiniteAdminUserDetailQuery.rootKey = "AdminUserDetail.infinite"

useAdminUserDetailQuery.fetcher = (
  variables: AdminUserDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AdminUserDetailQuery, AdminUserDetailQueryVariables>(
    AdminUserDetailDocument,
    variables,
    options,
  )

export const AdminSitesTableViewDocument = `
    query AdminSitesTableView($filterBy: AdminSitesTableFilter, $sortBy: [AdminSitesTableSort!]) {
  allSites {
    view(filterBy: $filterBy, sortBy: $sortBy) {
      keys
      count
      stats {
        orgNames
        portfolios
        utilityNames
        cities
      }
    }
  }
}
    `

export const useAdminSitesTableViewQuery = <
  TData = AdminSitesTableViewQuery,
  TError = unknown,
>(
  variables?: AdminSitesTableViewQueryVariables,
  options?: Omit<
    UseQueryOptions<AdminSitesTableViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<AdminSitesTableViewQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<AdminSitesTableViewQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["AdminSitesTableView"]
        : ["AdminSitesTableView", variables],
    queryFn: adminFetcher<AdminSitesTableViewQuery, AdminSitesTableViewQueryVariables>(
      AdminSitesTableViewDocument,
      variables,
    ),
    ...options,
  })
}

useAdminSitesTableViewQuery.getKey = (variables?: AdminSitesTableViewQueryVariables) =>
  variables === undefined ? ["AdminSitesTableView"] : ["AdminSitesTableView", variables]

useAdminSitesTableViewQuery.rootKey = "AdminSitesTableView"

export const useSuspenseAdminSitesTableViewQuery = <
  TData = AdminSitesTableViewQuery,
  TError = unknown,
>(
  variables?: AdminSitesTableViewQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<AdminSitesTableViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      AdminSitesTableViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<AdminSitesTableViewQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["AdminSitesTableViewSuspense"]
        : ["AdminSitesTableViewSuspense", variables],
    queryFn: adminFetcher<AdminSitesTableViewQuery, AdminSitesTableViewQueryVariables>(
      AdminSitesTableViewDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseAdminSitesTableViewQuery.getKey = (
  variables?: AdminSitesTableViewQueryVariables,
) =>
  variables === undefined
    ? ["AdminSitesTableViewSuspense"]
    : ["AdminSitesTableViewSuspense", variables]

useSuspenseAdminSitesTableViewQuery.rootKey = "AdminSitesTableView"

export const useInfiniteAdminSitesTableViewQuery = <
  TData = InfiniteData<AdminSitesTableViewQuery>,
  TError = unknown,
>(
  variables: AdminSitesTableViewQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<AdminSitesTableViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      AdminSitesTableViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<AdminSitesTableViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["AdminSitesTableView.infinite"]
            : ["AdminSitesTableView.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminSitesTableViewQuery, AdminSitesTableViewQueryVariables>(
            AdminSitesTableViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteAdminSitesTableViewQuery.getKey = (
  variables?: AdminSitesTableViewQueryVariables,
) =>
  variables === undefined
    ? ["AdminSitesTableView.infinite"]
    : ["AdminSitesTableView.infinite", variables]

useInfiniteAdminSitesTableViewQuery.rootKey = "AdminSitesTableView.infinite"

export const useSuspenseInfiniteAdminSitesTableViewQuery = <
  TData = InfiniteData<AdminSitesTableViewQuery>,
  TError = unknown,
>(
  variables: AdminSitesTableViewQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<AdminSitesTableViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      AdminSitesTableViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<AdminSitesTableViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["AdminSitesTableView.infiniteSuspense"]
            : ["AdminSitesTableView.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminSitesTableViewQuery, AdminSitesTableViewQueryVariables>(
            AdminSitesTableViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteAdminSitesTableViewQuery.getKey = (
  variables?: AdminSitesTableViewQueryVariables,
) =>
  variables === undefined
    ? ["AdminSitesTableView.infiniteSuspense"]
    : ["AdminSitesTableView.infiniteSuspense", variables]

useSuspenseInfiniteAdminSitesTableViewQuery.rootKey = "AdminSitesTableView.infinite"

useAdminSitesTableViewQuery.fetcher = (
  variables?: AdminSitesTableViewQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AdminSitesTableViewQuery, AdminSitesTableViewQueryVariables>(
    AdminSitesTableViewDocument,
    variables,
    options,
  )

export const AdminSitesTableRowsDocument = `
    query AdminSitesTableRows($keys: [Int!]!) {
  allSites {
    rows(keys: $keys) {
      id
      orgName
      orgPid
      orgSlug
      portfolioPid
      portfolioName
      sitePid
      createdAt
      status
      statusReason
      statusCustomReason
      name
      customerId
      streetAddress
      city
      state
      zipCode
      roofMaxPvKw
      utilityId
      utilityShortName
      utilityName
    }
  }
}
    `

export const useAdminSitesTableRowsQuery = <
  TData = AdminSitesTableRowsQuery,
  TError = unknown,
>(
  variables: AdminSitesTableRowsQueryVariables,
  options?: Omit<
    UseQueryOptions<AdminSitesTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<AdminSitesTableRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<AdminSitesTableRowsQuery, TError, TData>({
    queryKey: ["AdminSitesTableRows", variables],
    queryFn: adminFetcher<AdminSitesTableRowsQuery, AdminSitesTableRowsQueryVariables>(
      AdminSitesTableRowsDocument,
      variables,
    ),
    ...options,
  })
}

useAdminSitesTableRowsQuery.getKey = (variables: AdminSitesTableRowsQueryVariables) => [
  "AdminSitesTableRows",
  variables,
]

useAdminSitesTableRowsQuery.rootKey = "AdminSitesTableRows"

export const useSuspenseAdminSitesTableRowsQuery = <
  TData = AdminSitesTableRowsQuery,
  TError = unknown,
>(
  variables: AdminSitesTableRowsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<AdminSitesTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      AdminSitesTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<AdminSitesTableRowsQuery, TError, TData>({
    queryKey: ["AdminSitesTableRowsSuspense", variables],
    queryFn: adminFetcher<AdminSitesTableRowsQuery, AdminSitesTableRowsQueryVariables>(
      AdminSitesTableRowsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseAdminSitesTableRowsQuery.getKey = (
  variables: AdminSitesTableRowsQueryVariables,
) => ["AdminSitesTableRowsSuspense", variables]

useSuspenseAdminSitesTableRowsQuery.rootKey = "AdminSitesTableRows"

export const useInfiniteAdminSitesTableRowsQuery = <
  TData = InfiniteData<AdminSitesTableRowsQuery>,
  TError = unknown,
>(
  variables: AdminSitesTableRowsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<AdminSitesTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      AdminSitesTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<AdminSitesTableRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["AdminSitesTableRows.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminSitesTableRowsQuery, AdminSitesTableRowsQueryVariables>(
            AdminSitesTableRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteAdminSitesTableRowsQuery.getKey = (
  variables: AdminSitesTableRowsQueryVariables,
) => ["AdminSitesTableRows.infinite", variables]

useInfiniteAdminSitesTableRowsQuery.rootKey = "AdminSitesTableRows.infinite"

export const useSuspenseInfiniteAdminSitesTableRowsQuery = <
  TData = InfiniteData<AdminSitesTableRowsQuery>,
  TError = unknown,
>(
  variables: AdminSitesTableRowsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<AdminSitesTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      AdminSitesTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<AdminSitesTableRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "AdminSitesTableRows.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          adminFetcher<AdminSitesTableRowsQuery, AdminSitesTableRowsQueryVariables>(
            AdminSitesTableRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteAdminSitesTableRowsQuery.getKey = (
  variables: AdminSitesTableRowsQueryVariables,
) => ["AdminSitesTableRows.infiniteSuspense", variables]

useSuspenseInfiniteAdminSitesTableRowsQuery.rootKey = "AdminSitesTableRows.infinite"

useAdminSitesTableRowsQuery.fetcher = (
  variables: AdminSitesTableRowsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AdminSitesTableRowsQuery, AdminSitesTableRowsQueryVariables>(
    AdminSitesTableRowsDocument,
    variables,
    options,
  )

export const AdminBidsTableViewDocument = `
    query AdminBidsTableView($filterBy: AdminBidsTableFilter, $sortBy: [AdminBidsTableSort!]) {
  allBids {
    view(filterBy: $filterBy, sortBy: $sortBy) {
      count
      keys
      stats {
        buildingOwnerNames
        financierNames
      }
    }
  }
}
    `

export const useAdminBidsTableViewQuery = <
  TData = AdminBidsTableViewQuery,
  TError = unknown,
>(
  variables?: AdminBidsTableViewQueryVariables,
  options?: Omit<
    UseQueryOptions<AdminBidsTableViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<AdminBidsTableViewQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<AdminBidsTableViewQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["AdminBidsTableView"]
        : ["AdminBidsTableView", variables],
    queryFn: adminFetcher<AdminBidsTableViewQuery, AdminBidsTableViewQueryVariables>(
      AdminBidsTableViewDocument,
      variables,
    ),
    ...options,
  })
}

useAdminBidsTableViewQuery.getKey = (variables?: AdminBidsTableViewQueryVariables) =>
  variables === undefined ? ["AdminBidsTableView"] : ["AdminBidsTableView", variables]

useAdminBidsTableViewQuery.rootKey = "AdminBidsTableView"

export const useSuspenseAdminBidsTableViewQuery = <
  TData = AdminBidsTableViewQuery,
  TError = unknown,
>(
  variables?: AdminBidsTableViewQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<AdminBidsTableViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      AdminBidsTableViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<AdminBidsTableViewQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["AdminBidsTableViewSuspense"]
        : ["AdminBidsTableViewSuspense", variables],
    queryFn: adminFetcher<AdminBidsTableViewQuery, AdminBidsTableViewQueryVariables>(
      AdminBidsTableViewDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseAdminBidsTableViewQuery.getKey = (
  variables?: AdminBidsTableViewQueryVariables,
) =>
  variables === undefined
    ? ["AdminBidsTableViewSuspense"]
    : ["AdminBidsTableViewSuspense", variables]

useSuspenseAdminBidsTableViewQuery.rootKey = "AdminBidsTableView"

export const useInfiniteAdminBidsTableViewQuery = <
  TData = InfiniteData<AdminBidsTableViewQuery>,
  TError = unknown,
>(
  variables: AdminBidsTableViewQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<AdminBidsTableViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      AdminBidsTableViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<AdminBidsTableViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["AdminBidsTableView.infinite"]
            : ["AdminBidsTableView.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminBidsTableViewQuery, AdminBidsTableViewQueryVariables>(
            AdminBidsTableViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteAdminBidsTableViewQuery.getKey = (
  variables?: AdminBidsTableViewQueryVariables,
) =>
  variables === undefined
    ? ["AdminBidsTableView.infinite"]
    : ["AdminBidsTableView.infinite", variables]

useInfiniteAdminBidsTableViewQuery.rootKey = "AdminBidsTableView.infinite"

export const useSuspenseInfiniteAdminBidsTableViewQuery = <
  TData = InfiniteData<AdminBidsTableViewQuery>,
  TError = unknown,
>(
  variables: AdminBidsTableViewQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<AdminBidsTableViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      AdminBidsTableViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<AdminBidsTableViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["AdminBidsTableView.infiniteSuspense"]
            : ["AdminBidsTableView.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminBidsTableViewQuery, AdminBidsTableViewQueryVariables>(
            AdminBidsTableViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteAdminBidsTableViewQuery.getKey = (
  variables?: AdminBidsTableViewQueryVariables,
) =>
  variables === undefined
    ? ["AdminBidsTableView.infiniteSuspense"]
    : ["AdminBidsTableView.infiniteSuspense", variables]

useSuspenseInfiniteAdminBidsTableViewQuery.rootKey = "AdminBidsTableView.infinite"

useAdminBidsTableViewQuery.fetcher = (
  variables?: AdminBidsTableViewQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AdminBidsTableViewQuery, AdminBidsTableViewQueryVariables>(
    AdminBidsTableViewDocument,
    variables,
    options,
  )

export const AdminBidsTableRowsDocument = `
    query AdminBidsTableRows($keys: [Int!]!) {
  allBids {
    rows(keys: $keys) {
      id
      bidPackagePid
      bundlePid
      bidPackageName
      name
      createdAt
      isAwarded
      isCustom
      packageRowStatus
      packageRowIsClosed
      packageRowClosedAt
      packageRowCloseReason
      packageRowCloseCustomReason
      estimatedCod
      estimatedNtp
      csEstimatedAwardDate
      pvSizeKwDc
      pvSizeKwAc
      pvTypes
      buildingOwnerPid
      buildingOwnerName
      financierPid
      financierName
      sitePid
      siteName
      streetAddress
      city
      state
      zipCode
      utilityId
      utilityName
      utilityShortName
      termYears
      roofRentY1Usd
      roofRentEscalator
      buildingOwnerExtraPaymentsUsd
      extraPaymentsNotes
      buildingOwnerNoiLifetimeUsd
      interconnectionCostUtilityMaxUsd
      interconnectionCostUtilityMinUsd
      interconnectionCostNonUtilityUsd
      interconnectionCostUsdPerWatt
      interconnectionNotes
      itcPercentageAssumption
      recOwner
      incentivesNotes
      otherNotes
    }
  }
}
    `

export const useAdminBidsTableRowsQuery = <
  TData = AdminBidsTableRowsQuery,
  TError = unknown,
>(
  variables: AdminBidsTableRowsQueryVariables,
  options?: Omit<
    UseQueryOptions<AdminBidsTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<AdminBidsTableRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<AdminBidsTableRowsQuery, TError, TData>({
    queryKey: ["AdminBidsTableRows", variables],
    queryFn: adminFetcher<AdminBidsTableRowsQuery, AdminBidsTableRowsQueryVariables>(
      AdminBidsTableRowsDocument,
      variables,
    ),
    ...options,
  })
}

useAdminBidsTableRowsQuery.getKey = (variables: AdminBidsTableRowsQueryVariables) => [
  "AdminBidsTableRows",
  variables,
]

useAdminBidsTableRowsQuery.rootKey = "AdminBidsTableRows"

export const useSuspenseAdminBidsTableRowsQuery = <
  TData = AdminBidsTableRowsQuery,
  TError = unknown,
>(
  variables: AdminBidsTableRowsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<AdminBidsTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      AdminBidsTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<AdminBidsTableRowsQuery, TError, TData>({
    queryKey: ["AdminBidsTableRowsSuspense", variables],
    queryFn: adminFetcher<AdminBidsTableRowsQuery, AdminBidsTableRowsQueryVariables>(
      AdminBidsTableRowsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseAdminBidsTableRowsQuery.getKey = (
  variables: AdminBidsTableRowsQueryVariables,
) => ["AdminBidsTableRowsSuspense", variables]

useSuspenseAdminBidsTableRowsQuery.rootKey = "AdminBidsTableRows"

export const useInfiniteAdminBidsTableRowsQuery = <
  TData = InfiniteData<AdminBidsTableRowsQuery>,
  TError = unknown,
>(
  variables: AdminBidsTableRowsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<AdminBidsTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      AdminBidsTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<AdminBidsTableRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["AdminBidsTableRows.infinite", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminBidsTableRowsQuery, AdminBidsTableRowsQueryVariables>(
            AdminBidsTableRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteAdminBidsTableRowsQuery.getKey = (
  variables: AdminBidsTableRowsQueryVariables,
) => ["AdminBidsTableRows.infinite", variables]

useInfiniteAdminBidsTableRowsQuery.rootKey = "AdminBidsTableRows.infinite"

export const useSuspenseInfiniteAdminBidsTableRowsQuery = <
  TData = InfiniteData<AdminBidsTableRowsQuery>,
  TError = unknown,
>(
  variables: AdminBidsTableRowsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<AdminBidsTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      AdminBidsTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<AdminBidsTableRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["AdminBidsTableRows.infiniteSuspense", variables],
        queryFn: (metaData) =>
          adminFetcher<AdminBidsTableRowsQuery, AdminBidsTableRowsQueryVariables>(
            AdminBidsTableRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteAdminBidsTableRowsQuery.getKey = (
  variables: AdminBidsTableRowsQueryVariables,
) => ["AdminBidsTableRows.infiniteSuspense", variables]

useSuspenseInfiniteAdminBidsTableRowsQuery.rootKey = "AdminBidsTableRows.infinite"

useAdminBidsTableRowsQuery.fetcher = (
  variables: AdminBidsTableRowsQueryVariables,
  options?: RequestInit["headers"],
) =>
  adminFetcher<AdminBidsTableRowsQuery, AdminBidsTableRowsQueryVariables>(
    AdminBidsTableRowsDocument,
    variables,
    options,
  )
